!function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("Phaser", [], e) : "object" == typeof exports ? exports.Phaser = e() : t.Phaser = e();
}(window, function() {
    var i, n;
    return n = {}, s.m = i = [
        function(t, e) {
            function r(t, e, i, n) {
                for(var s in e)if (e.hasOwnProperty(s)) {
                    var r = (l = e, u = s, f = d = void 0, f = (c = i) ? l[u] : Object.getOwnPropertyDescriptor(l, u), !c && f.value && "object" == typeof f.value && (f = f.value), !(!f || !((d = f).get && "function" == typeof d.get || d.set && "function" == typeof d.set)) && (void 0 === f.enumerable && (f.enumerable = !0), void 0 === f.configurable && (f.configurable = !0), f));
                    if (!1 !== r) {
                        if (o = (n || t).prototype, a = s, h = void 0, (h = Object.getOwnPropertyDescriptor(o, a)) && (h.value && "object" == typeof h.value && (h = h.value), !1 === h.configurable)) {
                            if (p.ignoreFinals) continue;
                            throw new Error("cannot override final property '" + s + "', set Class.ignoreFinals = true to skip");
                        }
                        Object.defineProperty(t.prototype, s, r);
                    } else t.prototype[s] = e[s];
                }
                var o, a, h, l, u, c, d, f;
            }
            function o(t, e) {
                if (e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for(var i = 0; i < e.length; i++)r(t, e[i].prototype || e[i]);
                }
            }
            function p(t) {
                var e, i, n;
                if ((t = t || {}).initialize) {
                    if ("function" != typeof t.initialize) throw new Error("initialize must be a function");
                    n = t.initialize, delete t.initialize;
                } else n = t.Extends ? (i = t.Extends, function() {
                    i.apply(this, arguments);
                }) : function() {};
                t.Extends ? (n.prototype = Object.create(t.Extends.prototype), n.prototype.constructor = n, e = t.Extends, delete t.Extends) : n.prototype.constructor = n;
                var s = null;
                return t.Mixins && (s = t.Mixins, delete t.Mixins), o(n, s), r(n, t, !0, e), n;
            }
            p.extend = r, p.mixin = o, p.ignoreFinals = !1, t.exports = p;
        },
        function(t, e) {
            t.exports = function() {};
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = typeof t;
                return t && "number" != n && "string" != n && t.hasOwnProperty(e) && void 0 !== t[e] ? t[e] : i;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(123), r = new n({
                initialize: function(t, e) {
                    this.x = 0, this.y = 0, "object" == typeof t ? (this.x = t.x || 0, this.y = t.y || 0) : (void 0 === e && (e = t), this.x = t || 0, this.y = e || 0);
                },
                clone: function() {
                    return new r(this.x, this.y);
                },
                copy: function(t) {
                    return this.x = t.x || 0, this.y = t.y || 0, this;
                },
                setFromObject: function(t) {
                    return this.x = t.x || 0, this.y = t.y || 0, this;
                },
                set: function(t, e) {
                    return void 0 === e && (e = t), this.x = t, this.y = e, this;
                },
                setTo: function(t, e) {
                    return this.set(t, e);
                },
                setToPolar: function(t, e) {
                    return null == e && (e = 1), this.x = Math.cos(t) * e, this.y = Math.sin(t) * e, this;
                },
                equals: function(t) {
                    return this.x === t.x && this.y === t.y;
                },
                fuzzyEquals: function(t, e) {
                    return s(this.x, t.x, e) && s(this.y, t.y, e);
                },
                angle: function() {
                    var t = Math.atan2(this.y, this.x);
                    return t < 0 && (t += 2 * Math.PI), t;
                },
                setAngle: function(t) {
                    return this.setToPolar(t, this.length());
                },
                add: function(t) {
                    return this.x += t.x, this.y += t.y, this;
                },
                subtract: function(t) {
                    return this.x -= t.x, this.y -= t.y, this;
                },
                multiply: function(t) {
                    return this.x *= t.x, this.y *= t.y, this;
                },
                scale: function(t) {
                    return isFinite(t) ? (this.x *= t, this.y *= t) : (this.x = 0, this.y = 0), this;
                },
                divide: function(t) {
                    return this.x /= t.x, this.y /= t.y, this;
                },
                negate: function() {
                    return this.x = -this.x, this.y = -this.y, this;
                },
                distance: function(t) {
                    var e = t.x - this.x, i = t.y - this.y;
                    return Math.sqrt(e * e + i * i);
                },
                distanceSq: function(t) {
                    var e = t.x - this.x, i = t.y - this.y;
                    return e * e + i * i;
                },
                length: function() {
                    var t = this.x, e = this.y;
                    return Math.sqrt(t * t + e * e);
                },
                setLength: function(t) {
                    return this.normalize().scale(t);
                },
                lengthSq: function() {
                    var t = this.x, e = this.y;
                    return t * t + e * e;
                },
                normalize: function() {
                    var t = this.x, e = this.y, i = t * t + e * e;
                    return 0 < i && (i = 1 / Math.sqrt(i), this.x = t * i, this.y = e * i), this;
                },
                normalizeRightHand: function() {
                    var t = this.x;
                    return this.x = -1 * this.y, this.y = t, this;
                },
                normalizeLeftHand: function() {
                    var t = this.x;
                    return this.x = this.y, this.y = -1 * t, this;
                },
                dot: function(t) {
                    return this.x * t.x + this.y * t.y;
                },
                cross: function(t) {
                    return this.x * t.y - this.y * t.x;
                },
                lerp: function(t, e) {
                    void 0 === e && (e = 0);
                    var i = this.x, n = this.y;
                    return this.x = i + e * (t.x - i), this.y = n + e * (t.y - n), this;
                },
                transformMat3: function(t) {
                    var e = this.x, i = this.y, n = t.val;
                    return this.x = n[0] * e + n[3] * i + n[6], this.y = n[1] * e + n[4] * i + n[7], this;
                },
                transformMat4: function(t) {
                    var e = this.x, i = this.y, n = t.val;
                    return this.x = n[0] * e + n[4] * i + n[12], this.y = n[1] * e + n[5] * i + n[13], this;
                },
                reset: function() {
                    return this.x = 0, this.y = 0, this;
                },
                limit: function(t) {
                    var e = this.length();
                    return e && t < e && this.scale(t / e), this;
                },
                reflect: function(t) {
                    return t = t.clone().normalize(), this.subtract(t.scale(2 * this.dot(t)));
                },
                mirror: function(t) {
                    return this.reflect(t).negate();
                },
                rotate: function(t) {
                    var e = Math.cos(t), i = Math.sin(t);
                    return this.set(e * this.x - i * this.y, i * this.x + e * this.y);
                }
            });
            r.ZERO = new r, r.RIGHT = new r(1, 0), r.LEFT = new r(-1, 0), r.UP = new r(0, -1), r.DOWN = new r(0, 1), r.ONE = new r(1, 1), t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(55), r = new n({
                initialize: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = t), this.type = s.POINT, this.x = t, this.y = e;
                },
                setTo: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this.x = t, this.y = e, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(24), r = i(21), o = new n({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.events = t.sys.events, this.displayList, this.updateList, this.events.once(r.BOOT, this.boot, this), this.events.on(r.START, this.start, this);
                },
                boot: function() {
                    this.displayList = this.systems.displayList, this.updateList = this.systems.updateList, this.events.once(r.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.events.once(r.SHUTDOWN, this.shutdown, this);
                },
                existing: function(t) {
                    return (t.renderCanvas || t.renderWebGL) && this.displayList.add(t), t.preUpdate && this.updateList.add(t), t;
                },
                shutdown: function() {
                    this.events.off(r.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.events.off(r.START, this.start, this), this.scene = null, this.systems = null, this.events = null, this.displayList = null, this.updateList = null;
                }
            });
            o.register = function(t, e) {
                o.prototype.hasOwnProperty(t) || (o.prototype[t] = e);
            }, o.remove = function(t) {
                o.prototype.hasOwnProperty(t) && delete o.prototype[t];
            }, s.register("GameObjectFactory", o, "add"), t.exports = o;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (t && "number" != typeof t) {
                    if (t.hasOwnProperty(e)) return t[e];
                    if (-1 === e.indexOf(".")) return i;
                    for(var n = e.split("."), s = t, r = i, o = 0; o < n.length; o++){
                        if (!s.hasOwnProperty(n[o])) {
                            r = i;
                            break;
                        }
                        r = s[n[o]], s = s[n[o]];
                    }
                    return r;
                }
                return i;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if ("object" != typeof t || t.nodeType || t === t.window) return !1;
                try {
                    if (t.constructor && !({}).hasOwnProperty.call(t.constructor.prototype, "isPrototypeOf")) return !1;
                } catch (t) {
                    return !1;
                }
                return !0;
            };
        },
        function(t, e) {
            var i = {}, n = {
                install: function(t) {
                    for(var e in i)t[e] = i[e];
                },
                register: function(t, e) {
                    i[t] = e;
                },
                destroy: function() {
                    i = {};
                }
            };
            t.exports = n;
        },
        function(t, e, i) {
            "use strict";
            var n = Object.prototype.hasOwnProperty, f = "~";
            function s() {}
            function a(t, e, i) {
                this.fn = t, this.context = e, this.once = i || !1;
            }
            function r(t, e, i, n, s) {
                if ("function" != typeof i) throw new TypeError("The listener must be a function");
                var r = new a(i, n || t, s), o = f ? f + e : e;
                return t._events[o] ? t._events[o].fn ? t._events[o] = [
                    t._events[o],
                    r
                ] : t._events[o].push(r) : (t._events[o] = r, t._eventsCount++), t;
            }
            function l(t, e) {
                0 == --t._eventsCount ? t._events = new s : delete t._events[e];
            }
            function o() {
                this._events = new s, this._eventsCount = 0;
            }
            Object.create && (s.prototype = Object.create(null), (new s).__proto__ || (f = !1)), o.prototype.eventNames = function() {
                var t, e, i = [];
                if (0 === this._eventsCount) return i;
                for(e in t = this._events)n.call(t, e) && i.push(f ? e.slice(1) : e);
                return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(t)) : i;
            }, o.prototype.listeners = function(t) {
                var e = f ? f + t : t, i = this._events[e];
                if (!i) return [];
                if (i.fn) return [
                    i.fn
                ];
                for(var n = 0, s = i.length, r = new Array(s); n < s; n++)r[n] = i[n].fn;
                return r;
            }, o.prototype.listenerCount = function(t) {
                var e = f ? f + t : t, i = this._events[e];
                return i ? i.fn ? 1 : i.length : 0;
            }, o.prototype.emit = function(t, e, i, n, s, r) {
                var o = f ? f + t : t;
                if (!this._events[o]) return !1;
                var a, h = this._events[o], l = arguments.length;
                if (h.fn) {
                    switch(h.once && this.removeListener(t, h.fn, void 0, !0), l){
                        case 1:
                            return h.fn.call(h.context), !0;
                        case 2:
                            return h.fn.call(h.context, e), !0;
                        case 3:
                            return h.fn.call(h.context, e, i), !0;
                        case 4:
                            return h.fn.call(h.context, e, i, n), !0;
                        case 5:
                            return h.fn.call(h.context, e, i, n, s), !0;
                        case 6:
                            return h.fn.call(h.context, e, i, n, s, r), !0;
                    }
                    for(d = 1, a = new Array(l - 1); d < l; d++)a[d - 1] = arguments[d];
                    h.fn.apply(h.context, a);
                } else for(var u, c = h.length, d = 0; d < c; d++)switch(h[d].once && this.removeListener(t, h[d].fn, void 0, !0), l){
                    case 1:
                        h[d].fn.call(h[d].context);
                        break;
                    case 2:
                        h[d].fn.call(h[d].context, e);
                        break;
                    case 3:
                        h[d].fn.call(h[d].context, e, i);
                        break;
                    case 4:
                        h[d].fn.call(h[d].context, e, i, n);
                        break;
                    default:
                        if (!a) for(u = 1, a = new Array(l - 1); u < l; u++)a[u - 1] = arguments[u];
                        h[d].fn.apply(h[d].context, a);
                }
                return !0;
            }, o.prototype.on = function(t, e, i) {
                return r(this, t, e, i, !1);
            }, o.prototype.once = function(t, e, i) {
                return r(this, t, e, i, !0);
            }, o.prototype.removeListener = function(t, e, i, n) {
                var s = f ? f + t : t;
                if (!this._events[s]) return this;
                if (!e) return l(this, s), this;
                var r = this._events[s];
                if (r.fn) r.fn !== e || n && !r.once || i && r.context !== i || l(this, s);
                else {
                    for(var o = 0, a = [], h = r.length; o < h; o++)(r[o].fn !== e || n && !r[o].once || i && r[o].context !== i) && a.push(r[o]);
                    a.length ? this._events[s] = 1 === a.length ? a[0] : a : l(this, s);
                }
                return this;
            }, o.prototype.removeAllListeners = function(t) {
                var e;
                return t ? (e = f ? f + t : t, this._events[e] && l(this, e)) : (this._events = new s, this._eventsCount = 0), this;
            }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = f, o.EventEmitter = o, t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(56), r = i(167), o = i(300), a = i(55), h = i(45), l = i(170), u = new n({
                initialize: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), this.type = a.RECTANGLE, this.x = t, this.y = e, this.width = i, this.height = n;
                },
                contains: function(t, e) {
                    return s(this, t, e);
                },
                getPoint: function(t, e) {
                    return r(this, t, e);
                },
                getPoints: function(t, e, i) {
                    return o(this, t, e, i);
                },
                getRandomPoint: function(t) {
                    return l(this, t);
                },
                setTo: function(t, e, i, n) {
                    return this.x = t, this.y = e, this.width = i, this.height = n, this;
                },
                setEmpty: function() {
                    return this.setTo(0, 0, 0, 0);
                },
                setPosition: function(t, e) {
                    return void 0 === e && (e = t), this.x = t, this.y = e, this;
                },
                setSize: function(t, e) {
                    return void 0 === e && (e = t), this.width = t, this.height = e, this;
                },
                isEmpty: function() {
                    return this.width <= 0 || this.height <= 0;
                },
                getLineA: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.x, this.y, this.right, this.y), t;
                },
                getLineB: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.right, this.y, this.right, this.bottom), t;
                },
                getLineC: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.right, this.bottom, this.x, this.bottom), t;
                },
                getLineD: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.x, this.bottom, this.x, this.y), t;
                },
                left: {
                    get: function() {
                        return this.x;
                    },
                    set: function(t) {
                        t >= this.right ? this.width = 0 : this.width = this.right - t, this.x = t;
                    }
                },
                right: {
                    get: function() {
                        return this.x + this.width;
                    },
                    set: function(t) {
                        t <= this.x ? this.width = 0 : this.width = t - this.x;
                    }
                },
                top: {
                    get: function() {
                        return this.y;
                    },
                    set: function(t) {
                        t >= this.bottom ? this.height = 0 : this.height = this.bottom - t, this.y = t;
                    }
                },
                bottom: {
                    get: function() {
                        return this.y + this.height;
                    },
                    set: function(t) {
                        t <= this.y ? this.height = 0 : this.height = t - this.y;
                    }
                },
                centerX: {
                    get: function() {
                        return this.x + this.width / 2;
                    },
                    set: function(t) {
                        this.x = t - this.width / 2;
                    }
                },
                centerY: {
                    get: function() {
                        return this.y + this.height / 2;
                    },
                    set: function(t) {
                        this.y = t - this.height / 2;
                    }
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            t.exports = {
                Alpha: i(605),
                AlphaSingle: i(297),
                BlendMode: i(298),
                ComputedSize: i(606),
                Crop: i(607),
                Depth: i(299),
                Flip: i(608),
                GetBounds: i(609),
                Mask: i(303),
                Origin: i(630),
                PathFollower: i(631),
                Pipeline: i(171),
                ScrollFactor: i(306),
                Size: i(632),
                Texture: i(633),
                TextureCrop: i(634),
                Tint: i(635),
                ToJSON: i(173),
                Transform: i(307),
                TransformMatrix: i(25),
                Visible: i(308)
            };
        },
        function(t, e) {
            t.exports = {
                getTintFromFloats: function(t, e, i, n) {
                    return ((255 & (255 * n | 0)) << 24 | (255 & (255 * t | 0)) << 16 | (255 & (255 * e | 0)) << 8 | 255 & (255 * i | 0)) >>> 0;
                },
                getTintAppendFloatAlpha: function(t, e) {
                    return ((255 & (255 * e | 0)) << 24 | t) >>> 0;
                },
                getTintAppendFloatAlphaAndSwap: function(t, e) {
                    return ((255 & (255 * e | 0)) << 24 | (255 & (0 | t)) << 16 | (255 & (t >> 8 | 0)) << 8 | 255 & (t >> 16 | 0)) >>> 0;
                },
                getFloatsFromUintRGB: function(t) {
                    return [
                        (255 & (t >> 16 | 0)) / 255,
                        (255 & (t >> 8 | 0)) / 255,
                        (255 & (0 | t)) / 255
                    ];
                },
                checkShaderMax: function(t, e) {
                    e && -1 !== e || (e = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS));
                    for(var i = t.createShader(t.FRAGMENT_SHADER), n = [
                        "precision mediump float;",
                        "void main(void){",
                        "float test = 0.1;",
                        "%forloop%",
                        "gl_FragColor = vec4(0.0);",
                        "}"
                    ].join("\n");;){
                        var s = n.replace(/%forloop%/gi, function(t) {
                            for(var e = "", i = 0; i < t; ++i)0 < i && (e += "\nelse "), i < t - 1 && (e += "if(test == " + i + ".0){}");
                            return e;
                        }(e));
                        if (t.shaderSource(i, s), t.compileShader(i), t.getShaderParameter(i, t.COMPILE_STATUS)) break;
                        e = e / 2 | 0;
                    }
                    return e;
                },
                parseFragmentShaderMaxTextures: function(t, e) {
                    if (!t) return "";
                    for(var i = "", n = 0; n < e; n++)0 < n && (i += "\n	else "), n < e - 1 && (i += "if (outTexId < " + n + ".5)"), i += "\n	{", i += "\n		texture = texture2D(uMainSampler[" + n + "], outTexCoord);", i += "\n	}";
                    return (t = t.replace(/%count%/gi, e.toString())).replace(/%forloop%/gi, i);
                }
            };
        },
        function(t, e, i) {
            var s = i(190), r = i(6);
            t.exports = function(t, e, i) {
                var n = r(t, e, null);
                if (null === n) return i;
                if (Array.isArray(n)) return s.RND.pick(n);
                if ("object" == typeof n) {
                    if (n.hasOwnProperty("randInt")) return s.RND.integerInRange(n.randInt[0], n.randInt[1]);
                    if (n.hasOwnProperty("randFloat")) return s.RND.realInRange(n.randFloat[0], n.randFloat[1]);
                } else if ("function" == typeof n) return n(e);
                return n;
            };
        },
        function(t, e) {
            var i = {
                PI2: 2 * Math.PI,
                TAU: .5 * Math.PI,
                EPSILON: 1e-6,
                DEG_TO_RAD: Math.PI / 180,
                RAD_TO_DEG: 180 / Math.PI,
                RND: null,
                MIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER || -9007199254740991,
                MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991
            };
            t.exports = i;
        },
        function(t, e, i) {
            var n = i(0), s = i(173), r = i(98), o = i(9), a = i(75), h = new n({
                Extends: o,
                initialize: function(t, e) {
                    o.call(this), this.scene = t, this.displayList = null, this.type = e, this.state = 0, this.parentContainer = null, this.name = "", this.active = !0, this.tabIndex = -1, this.data = null, this.renderFlags = 15, this.cameraFilter = 0, this.input = null, this.body = null, this.ignoreDestroy = !1, this.on(a.ADDED_TO_SCENE, this.addedToScene, this), this.on(a.REMOVED_FROM_SCENE, this.removedFromScene, this), t.sys.queueDepthSort();
                },
                setActive: function(t) {
                    return this.active = t, this;
                },
                setName: function(t) {
                    return this.name = t, this;
                },
                setState: function(t) {
                    return this.state = t, this;
                },
                setDataEnabled: function() {
                    return this.data || (this.data = new r(this)), this;
                },
                setData: function(t, e) {
                    return this.data || (this.data = new r(this)), this.data.set(t, e), this;
                },
                incData: function(t, e) {
                    return this.data || (this.data = new r(this)), this.data.inc(t, e), this;
                },
                toggleData: function(t) {
                    return this.data || (this.data = new r(this)), this.data.toggle(t), this;
                },
                getData: function(t) {
                    return this.data || (this.data = new r(this)), this.data.get(t);
                },
                setInteractive: function(t, e, i) {
                    return this.scene.sys.input.enable(this, t, e, i), this;
                },
                disableInteractive: function() {
                    return this.input && (this.input.enabled = !1), this;
                },
                removeInteractive: function() {
                    return this.scene.sys.input.clear(this), this.input = void 0, this;
                },
                addedToScene: function() {},
                removedFromScene: function() {},
                update: function() {},
                toJSON: function() {
                    return s(this);
                },
                willRender: function(t) {
                    return !(h.RENDER_MASK !== this.renderFlags || 0 !== this.cameraFilter && this.cameraFilter & t.id);
                },
                getIndexList: function() {
                    for(var t = this, e = this.parentContainer, i = []; e && (i.unshift(e.getIndex(t)), (t = e).parentContainer);)e = e.parentContainer;
                    return this.displayList ? i.unshift(this.displayList.getIndex(t)) : i.unshift(this.scene.sys.displayList.getIndex(t)), i;
                },
                destroy: function() {
                    this.scene && !this.ignoreDestroy && (this.preDestroy && this.preDestroy.call(this), this.emit(a.DESTROY, this), this.removeAllListeners(), this.postPipelines && this.resetPostPipeline(!0), this.displayList && (this.displayList.queueDepthSort(), this.displayList.remove(this)), this.input && (this.scene.sys.input.clear(this), this.input = void 0), this.data && (this.data.destroy(), this.data = void 0), this.body && (this.body.destroy(), this.body = void 0), this.active = !1, this.visible = !1, this.scene = void 0, this.displayList = void 0, this.parentContainer = void 0);
                }
            });
            h.RENDER_MASK = 15, t.exports = h;
        },
        function(t, e, i) {
            var n = i(0), s = i(24), r = i(21), o = new n({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.events = t.sys.events, this.displayList, this.updateList, this.events.once(r.BOOT, this.boot, this), this.events.on(r.START, this.start, this);
                },
                boot: function() {
                    this.displayList = this.systems.displayList, this.updateList = this.systems.updateList, this.events.once(r.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.events.once(r.SHUTDOWN, this.shutdown, this);
                },
                shutdown: function() {
                    this.events.off(r.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.events.off(r.START, this.start, this), this.scene = null, this.systems = null, this.events = null, this.displayList = null, this.updateList = null;
                }
            });
            o.register = function(t, e) {
                o.prototype.hasOwnProperty(t) || (o.prototype[t] = e);
            }, o.remove = function(t) {
                o.prototype.hasOwnProperty(t) && delete o.prototype[t];
            }, s.register("GameObjectCreator", o, "make"), t.exports = o;
        },
        function(t, e, i) {
            var u = i(7), c = function() {
                var t, e, i, n, s, r, o = arguments[0] || {}, a = 1, h = arguments.length, l = !1;
                for("boolean" == typeof o && (l = o, o = arguments[1] || {}, a = 2), h === a && (o = this, --a); a < h; a++)if (null != (t = arguments[a])) for(e in t)i = o[e], o !== (n = t[e]) && (l && n && (u(n) || (s = Array.isArray(n))) ? (r = s ? (s = !1, i && Array.isArray(i) ? i : []) : i && u(i) ? i : {}, o[e] = c(l, r, n)) : void 0 !== n && (o[e] = n));
                return o;
            };
            t.exports = c;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return Math.max(e, Math.min(i, t));
            };
        },
        function(t, e, i) {
            var n = i(25), o = new n, a = new n, h = new n, l = {
                camera: o,
                sprite: a,
                calc: h
            };
            t.exports = function(t, e, i) {
                var n = o, s = a, r = h;
                return s.applyITRS(t.x, t.y, t.rotation, t.scaleX, t.scaleY), n.copyFrom(e.matrix), i ? (n.multiplyWithOffset(i, -e.scrollX * t.scrollFactorX, -e.scrollY * t.scrollFactorY), s.e = t.x, s.f = t.y) : (s.e -= e.scrollX * t.scrollFactorX, s.f -= e.scrollY * t.scrollFactorY), n.multiply(s, r), l;
            };
        },
        function(t, e) {
            t.exports = {
                LOADER_IDLE: 0,
                LOADER_LOADING: 1,
                LOADER_PROCESSING: 2,
                LOADER_COMPLETE: 3,
                LOADER_SHUTDOWN: 4,
                LOADER_DESTROYED: 5,
                FILE_PENDING: 10,
                FILE_LOADING: 11,
                FILE_LOADED: 12,
                FILE_FAILED: 13,
                FILE_PROCESSING: 14,
                FILE_ERRORED: 16,
                FILE_COMPLETE: 17,
                FILE_DESTROYED: 18,
                FILE_POPULATED: 19
            };
        },
        function(t, e, i) {
            t.exports = {
                ADDED_TO_SCENE: i(782),
                BOOT: i(783),
                CREATE: i(784),
                DESTROY: i(785),
                PAUSE: i(786),
                POST_UPDATE: i(787),
                PRE_UPDATE: i(788),
                READY: i(789),
                REMOVED_FROM_SCENE: i(790),
                RENDER: i(791),
                RESUME: i(792),
                SHUTDOWN: i(793),
                SLEEP: i(794),
                START: i(795),
                TRANSITION_COMPLETE: i(796),
                TRANSITION_INIT: i(797),
                TRANSITION_OUT: i(798),
                TRANSITION_START: i(799),
                TRANSITION_WAKE: i(800),
                UPDATE: i(801),
                WAKE: i(802)
            };
        },
        function(t, e, i) {
            t.exports = {
                BLUR: i(610),
                BOOT: i(611),
                CONTEXT_LOST: i(612),
                CONTEXT_RESTORED: i(613),
                DESTROY: i(614),
                FOCUS: i(615),
                HIDDEN: i(616),
                PAUSE: i(617),
                POST_RENDER: i(618),
                POST_STEP: i(619),
                PRE_RENDER: i(620),
                PRE_STEP: i(621),
                READY: i(622),
                RESUME: i(623),
                STEP: i(624),
                VISIBLE: i(625)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(20), r = i(91), o = i(2), a = i(153), h = i(237), l = i(511), u = i(154), c = new n({
                initialize: function(t, e) {
                    this.loader = t, this.cache = o(e, "cache", !1), this.type = o(e, "type", !1), this.key = o(e, "key", !1);
                    var i = this.key;
                    if (t.prefix && "" !== t.prefix && (this.key = t.prefix + i), !this.type || !this.key) throw new Error("Invalid Loader." + this.type + " key");
                    var n = o(e, "url");
                    void 0 === n ? n = t.path + i + "." + o(e, "extension", "") : "string" != typeof n || n.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/) || (n = t.path + n), this.url = n, this.src = "", this.xhrSettings = u(o(e, "responseType", void 0)), o(e, "xhrSettings", !1) && (this.xhrSettings = h(this.xhrSettings, o(e, "xhrSettings", {}))), this.xhrLoader = null, this.state = "function" == typeof this.url ? s.FILE_POPULATED : s.FILE_PENDING, this.bytesTotal = 0, this.bytesLoaded = -1, this.percentComplete = -1, this.crossOrigin = void 0, this.data = void 0, this.config = o(e, "config", {}), this.multiFile, this.linkFile;
                },
                setLink: function(t) {
                    (this.linkFile = t).linkFile = this;
                },
                resetXHR: function() {
                    this.xhrLoader && (this.xhrLoader.onload = void 0, this.xhrLoader.onerror = void 0, this.xhrLoader.onprogress = void 0);
                },
                load: function() {
                    this.state === s.FILE_POPULATED ? this.loader.nextFile(this, !0) : (this.state = s.FILE_LOADING, this.src = a(this, this.loader.baseURL), 0 === this.src.indexOf("data:") ? console.warn("Local data URIs are not supported: " + this.key) : this.xhrLoader = l(this, this.loader.xhr));
                },
                onLoad: function(t, e) {
                    var i = t.responseURL && 0 === t.responseURL.indexOf("file://") && 0 === e.target.status, n = !(e.target && 200 !== e.target.status) || i;
                    4 === t.readyState && 400 <= t.status && t.status <= 599 && (n = !1), this.state = s.FILE_LOADED, this.resetXHR(), this.loader.nextFile(this, n);
                },
                onError: function() {
                    this.resetXHR(), this.loader.nextFile(this, !1);
                },
                onProgress: function(t) {
                    t.lengthComputable && (this.bytesLoaded = t.loaded, this.bytesTotal = t.total, this.percentComplete = Math.min(this.bytesLoaded / this.bytesTotal, 1), this.loader.emit(r.FILE_PROGRESS, this, this.percentComplete));
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.onProcessComplete();
                },
                onProcessComplete: function() {
                    this.state = s.FILE_COMPLETE, this.multiFile && this.multiFile.onFileComplete(this), this.loader.fileProcessComplete(this);
                },
                onProcessError: function() {
                    this.state = s.FILE_ERRORED, this.multiFile && this.multiFile.onFileFailed(this), this.loader.fileProcessComplete(this);
                },
                hasCacheConflict: function() {
                    return this.cache && this.cache.exists(this.key);
                },
                addToCache: function() {
                    this.cache && this.cache.add(this.key, this.data), this.pendingDestroy();
                },
                pendingDestroy: function(t) {
                    void 0 === t && (t = this.data);
                    var e = this.key, i = this.type;
                    this.loader.emit(r.FILE_COMPLETE, e, i, t), this.loader.emit(r.FILE_KEY_COMPLETE + i + "-" + e, e, i, t), this.loader.flagForRemoval(this);
                },
                destroy: function() {
                    this.loader = null, this.cache = null, this.xhrSettings = null, this.multiFile = null, this.linkFile = null, this.data = null;
                }
            });
            c.createObjectURL = function(t, e, i) {
                var n;
                "function" == typeof URL ? t.src = URL.createObjectURL(e) : ((n = new FileReader).onload = function() {
                    t.removeAttribute("crossOrigin"), t.src = "data:" + (e.type || i) + ";base64," + n.result.split(",")[1];
                }, n.onerror = t.onerror, n.readAsDataURL(e));
            }, c.revokeObjectURL = function(t) {
                "function" == typeof URL && URL.revokeObjectURL(t.src);
            }, t.exports = c;
        },
        function(t, e) {
            var s = {}, r = {}, i = {
                register: function(t, e, i, n) {
                    void 0 === n && (n = !1), s[t] = {
                        plugin: e,
                        mapping: i,
                        custom: n
                    };
                },
                registerCustom: function(t, e, i, n) {
                    r[t] = {
                        plugin: e,
                        mapping: i,
                        data: n
                    };
                },
                hasCore: function(t) {
                    return s.hasOwnProperty(t);
                },
                hasCustom: function(t) {
                    return r.hasOwnProperty(t);
                },
                getCore: function(t) {
                    return s[t];
                },
                getCustom: function(t) {
                    return r[t];
                },
                getCustomClass: function(t) {
                    return r.hasOwnProperty(t) ? r[t].plugin : null;
                },
                remove: function(t) {
                    s.hasOwnProperty(t) && delete s[t];
                },
                removeCustom: function(t) {
                    r.hasOwnProperty(t) && delete r[t];
                },
                destroyCorePlugins: function() {
                    for(var t in s)s.hasOwnProperty(t) && delete s[t];
                },
                destroyCustomPlugins: function() {
                    for(var t in r)r.hasOwnProperty(t) && delete r[t];
                }
            };
            t.exports = i;
        },
        function(t, e, i) {
            var n = i(0), r = i(14), c = i(3), s = new n({
                initialize: function(t, e, i, n, s, r) {
                    void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 1), void 0 === s && (s = 0), void 0 === r && (r = 0), this.matrix = new Float32Array([
                        t,
                        e,
                        i,
                        n,
                        s,
                        r,
                        0,
                        0,
                        1
                    ]), this.decomposedMatrix = {
                        translateX: 0,
                        translateY: 0,
                        scaleX: 1,
                        scaleY: 1,
                        rotation: 0
                    };
                },
                a: {
                    get: function() {
                        return this.matrix[0];
                    },
                    set: function(t) {
                        this.matrix[0] = t;
                    }
                },
                b: {
                    get: function() {
                        return this.matrix[1];
                    },
                    set: function(t) {
                        this.matrix[1] = t;
                    }
                },
                c: {
                    get: function() {
                        return this.matrix[2];
                    },
                    set: function(t) {
                        this.matrix[2] = t;
                    }
                },
                d: {
                    get: function() {
                        return this.matrix[3];
                    },
                    set: function(t) {
                        this.matrix[3] = t;
                    }
                },
                e: {
                    get: function() {
                        return this.matrix[4];
                    },
                    set: function(t) {
                        this.matrix[4] = t;
                    }
                },
                f: {
                    get: function() {
                        return this.matrix[5];
                    },
                    set: function(t) {
                        this.matrix[5] = t;
                    }
                },
                tx: {
                    get: function() {
                        return this.matrix[4];
                    },
                    set: function(t) {
                        this.matrix[4] = t;
                    }
                },
                ty: {
                    get: function() {
                        return this.matrix[5];
                    },
                    set: function(t) {
                        this.matrix[5] = t;
                    }
                },
                rotation: {
                    get: function() {
                        return Math.acos(this.a / this.scaleX) * (Math.atan(-this.c / this.a) < 0 ? -1 : 1);
                    }
                },
                rotationNormalized: {
                    get: function() {
                        var t = this.matrix, e = t[0], i = t[1], n = t[2], s = t[3];
                        return e || i ? 0 < i ? Math.acos(e / this.scaleX) : -Math.acos(e / this.scaleX) : n || s ? r.TAU - (0 < s ? Math.acos(-n / this.scaleY) : -Math.acos(n / this.scaleY)) : 0;
                    }
                },
                scaleX: {
                    get: function() {
                        return Math.sqrt(this.a * this.a + this.b * this.b);
                    }
                },
                scaleY: {
                    get: function() {
                        return Math.sqrt(this.c * this.c + this.d * this.d);
                    }
                },
                loadIdentity: function() {
                    var t = this.matrix;
                    return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, this;
                },
                translate: function(t, e) {
                    var i = this.matrix;
                    return i[4] = i[0] * t + i[2] * e + i[4], i[5] = i[1] * t + i[3] * e + i[5], this;
                },
                scale: function(t, e) {
                    var i = this.matrix;
                    return i[0] *= t, i[1] *= t, i[2] *= e, i[3] *= e, this;
                },
                rotate: function(t) {
                    var e = Math.sin(t), i = Math.cos(t), n = this.matrix, s = n[0], r = n[1], o = n[2], a = n[3];
                    return n[0] = s * i + o * e, n[1] = r * i + a * e, n[2] = s * -e + o * i, n[3] = r * -e + a * i, this;
                },
                multiply: function(t, e) {
                    var i = this.matrix, n = t.matrix, s = i[0], r = i[1], o = i[2], a = i[3], h = i[4], l = i[5], u = n[0], c = n[1], d = n[2], f = n[3], p = n[4], g = n[5], v = void 0 === e ? this : e;
                    return v.a = u * s + c * o, v.b = u * r + c * a, v.c = d * s + f * o, v.d = d * r + f * a, v.e = p * s + g * o + h, v.f = p * r + g * a + l, v;
                },
                multiplyWithOffset: function(t, e, i) {
                    var n = this.matrix, s = t.matrix, r = n[0], o = n[1], a = n[2], h = n[3], l = e * r + i * a + n[4], u = e * o + i * h + n[5], c = s[0], d = s[1], f = s[2], p = s[3], g = s[4], v = s[5];
                    return n[0] = c * r + d * a, n[1] = c * o + d * h, n[2] = f * r + p * a, n[3] = f * o + p * h, n[4] = g * r + v * a + l, n[5] = g * o + v * h + u, this;
                },
                transform: function(t, e, i, n, s, r) {
                    var o = this.matrix, a = o[0], h = o[1], l = o[2], u = o[3], c = o[4], d = o[5];
                    return o[0] = t * a + e * l, o[1] = t * h + e * u, o[2] = i * a + n * l, o[3] = i * h + n * u, o[4] = s * a + r * l + c, o[5] = s * h + r * u + d, this;
                },
                transformPoint: function(t, e, i) {
                    void 0 === i && (i = {
                        x: 0,
                        y: 0
                    });
                    var n = this.matrix, s = n[0], r = n[1], o = n[2], a = n[3], h = n[4], l = n[5];
                    return i.x = t * s + e * o + h, i.y = t * r + e * a + l, i;
                },
                invert: function() {
                    var t = this.matrix, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = e * s - i * n;
                    return t[0] = s / a, t[1] = -i / a, t[2] = -n / a, t[3] = e / a, t[4] = (n * o - s * r) / a, t[5] = -(e * o - i * r) / a, this;
                },
                copyFrom: function(t) {
                    var e = this.matrix;
                    return e[0] = t.a, e[1] = t.b, e[2] = t.c, e[3] = t.d, e[4] = t.e, e[5] = t.f, this;
                },
                copyFromArray: function(t) {
                    var e = this.matrix;
                    return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], this;
                },
                copyToContext: function(t) {
                    var e = this.matrix;
                    return t.transform(e[0], e[1], e[2], e[3], e[4], e[5]), t;
                },
                setToContext: function(t) {
                    var e = this.matrix;
                    return t.setTransform(e[0], e[1], e[2], e[3], e[4], e[5]), t;
                },
                copyToArray: function(t) {
                    var e = this.matrix;
                    return void 0 === t ? t = [
                        e[0],
                        e[1],
                        e[2],
                        e[3],
                        e[4],
                        e[5]
                    ] : (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5]), t;
                },
                setTransform: function(t, e, i, n, s, r) {
                    var o = this.matrix;
                    return o[0] = t, o[1] = e, o[2] = i, o[3] = n, o[4] = s, o[5] = r, this;
                },
                decomposeMatrix: function() {
                    var t, e, i = this.decomposedMatrix, n = this.matrix, s = n[0], r = n[1], o = n[2], a = n[3], h = s * a - r * o;
                    return i.translateX = n[4], i.translateY = n[5], s || r ? (t = Math.sqrt(s * s + r * r), i.rotation = 0 < r ? Math.acos(s / t) : -Math.acos(s / t), i.scaleX = t, i.scaleY = h / t) : o || a ? (e = Math.sqrt(o * o + a * a), i.rotation = .5 * Math.PI - (0 < a ? Math.acos(-o / e) : -Math.acos(o / e)), i.scaleX = h / e, i.scaleY = e) : (i.rotation = 0, i.scaleX = 0, i.scaleY = 0), i;
                },
                applyITRS: function(t, e, i, n, s) {
                    var r = this.matrix, o = Math.sin(i), a = Math.cos(i);
                    return r[4] = t, r[5] = e, r[0] = a * n, r[1] = o * n, r[2] = -o * s, r[3] = a * s, this;
                },
                applyInverse: function(t, e, i) {
                    void 0 === i && (i = new c);
                    var n = this.matrix, s = n[0], r = n[1], o = n[2], a = n[3], h = n[4], l = n[5], u = 1 / (s * a + o * -r);
                    return i.x = a * u * t + -o * u * e + (l * o - h * a) * u, i.y = s * u * e + -r * u * t + (-l * s + h * r) * u, i;
                },
                getX: function(t, e) {
                    return t * this.a + e * this.c + this.e;
                },
                getY: function(t, e) {
                    return t * this.b + e * this.d + this.f;
                },
                getXRound: function(t, e, i) {
                    var n = this.getX(t, e);
                    return i && (n = Math.round(n)), n;
                },
                getYRound: function(t, e, i) {
                    var n = this.getY(t, e);
                    return i && (n = Math.round(n)), n;
                },
                getCSSMatrix: function() {
                    var t = this.matrix;
                    return "matrix(" + t[0] + "," + t[1] + "," + t[2] + "," + t[3] + "," + t[4] + "," + t[5] + ")";
                },
                destroy: function() {
                    this.matrix = null, this.decomposedMatrix = null;
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var f = i(2);
            t.exports = function(t, e, i, n, s, r) {
                void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = r.width), void 0 === n && (n = r.height);
                var o = f(s = s || {}, "isNotEmpty", !1), a = f(s, "isColliding", !1), h = f(s, "hasInterestingFace", !1);
                t < 0 && (i += t, t = 0), e < 0 && (n += e, e = 0), t + i > r.width && (i = Math.max(r.width - t, 0)), e + n > r.height && (n = Math.max(r.height - e, 0));
                for(var l = [], u = e; u < e + n; u++)for(var c = t; c < t + i; c++){
                    var d = r.data[u][c];
                    if (null !== d) {
                        if (o && -1 === d.index) continue;
                        if (a && !d.collides) continue;
                        if (h && !d.hasInterestingFace) continue;
                        l.push(d);
                    }
                }
                return l;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r) {
                var o;
                void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = 1);
                var a = 0, h = t.length;
                if (1 === r) for(o = s; o < h; o++)t[o][e] = i + a * n, a++;
                else for(o = s; 0 <= o; o--)t[o][e] = i + a * n, a++;
                return t;
            };
        },
        function(t, e, i) {
            var l = i(34), u = i(13);
            t.exports = function(t, e, i) {
                e.x = u(i, "x", 0), e.y = u(i, "y", 0), e.depth = u(i, "depth", 0), e.flipX = u(i, "flipX", !1), e.flipY = u(i, "flipY", !1);
                var n = u(i, "scale", null);
                "number" == typeof n ? e.setScale(n) : null !== n && (e.scaleX = u(n, "x", 1), e.scaleY = u(n, "y", 1));
                var s = u(i, "scrollFactor", null);
                "number" == typeof s ? e.setScrollFactor(s) : null !== s && (e.scrollFactorX = u(s, "x", 1), e.scrollFactorY = u(s, "y", 1)), e.rotation = u(i, "rotation", 0);
                var r = u(i, "angle", null);
                null !== r && (e.angle = r), e.alpha = u(i, "alpha", 1);
                var o, a, h = u(i, "origin", null);
                return "number" == typeof h ? e.setOrigin(h) : null !== h && (o = u(h, "x", .5), a = u(h, "y", .5), e.setOrigin(o, a)), e.blendMode = u(i, "blendMode", l.NORMAL), e.visible = u(i, "visible", !0), u(i, "add", !0) && t.sys.displayList.add(e), e.preUpdate && t.sys.updateList.add(e), e;
            };
        },
        function(t, e) {
            t.exports = {
                ORTHOGONAL: 0,
                ISOMETRIC: 1,
                STAGGERED: 2,
                HEXAGONAL: 3
            };
        },
        function(t, e, i) {
            var a = i(19);
            t.exports = function(t, e, i, n, s) {
                var r = n.alpha * i.alpha;
                if (r <= 0) return !1;
                var o = a(i, n, s).calc;
                return e.globalCompositeOperation = t.blendModes[i.blendMode], e.globalAlpha = r, e.save(), o.setToContext(e), e.imageSmoothingEnabled = !(!t.antialias || i.frame && i.frame.source.scaleMode), !0;
            };
        },
        function(t, e, i) {
            var a, h = i(32), l = i(189), u = [], c = !1;
            function n(t, e, i, n, s) {
                void 0 === e && (e = 1), void 0 === i && (i = 1), void 0 === n && (n = h.CANVAS), void 0 === s && (s = !1);
                var r = a(n), o = (null === r ? (r = {
                    parent: t,
                    canvas: document.createElement("canvas"),
                    type: n
                }, n === h.CANVAS && u.push(r)) : r.parent = t, r.canvas);
                return s && (r.parent = o), o.width = e, o.height = i, c && n === h.CANVAS && l.disable(o.getContext("2d")), o;
            }
            function s() {
                var e = 0;
                return u.forEach(function(t) {
                    t.parent && e++;
                }), e;
            }
            t.exports = {
                create2D: function(t, e, i) {
                    return n(t, e, i, h.CANVAS);
                },
                create: n,
                createWebGL: function(t, e, i) {
                    return n(t, e, i, h.WEBGL);
                },
                disableSmoothing: function() {
                    c = !0;
                },
                enableSmoothing: function() {
                    c = !1;
                },
                first: a = function(t) {
                    if (void 0 === t && (t = h.CANVAS), t === h.WEBGL) return null;
                    for(var e = 0; e < u.length; e++){
                        var i = u[e];
                        if (!i.parent && i.type === t) return i;
                    }
                    return null;
                },
                free: function() {
                    return u.length - s();
                },
                pool: u,
                remove: function(e) {
                    var i = e instanceof HTMLCanvasElement;
                    u.forEach(function(t) {
                        (i && t.canvas === e || !i && t.parent === e) && (t.parent = null, t.canvas.width = 1, t.canvas.height = 1);
                    });
                },
                total: s
            };
        },
        function(t, e, i) {
            var n = {
                VERSION: "3.52.0",
                BlendModes: i(34),
                ScaleModes: i(164),
                AUTO: 0,
                CANVAS: 1,
                WEBGL: 2,
                HEADLESS: 3,
                FOREVER: -1,
                NONE: 4,
                UP: 5,
                DOWN: 6,
                LEFT: 7,
                RIGHT: 8
            };
            t.exports = n;
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(15), o = i(45), a = i(65), h = new n({
                Extends: r,
                Mixins: [
                    s.AlphaSingle,
                    s.BlendMode,
                    s.Depth,
                    s.GetBounds,
                    s.Mask,
                    s.Origin,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Transform,
                    s.Visible
                ],
                initialize: function(t, e, i) {
                    void 0 === e && (e = "Shape"), r.call(this, t, e), this.geom = i, this.pathData = [], this.pathIndexes = [], this.fillColor = 16777215, this.fillAlpha = 1, this.strokeColor = 16777215, this.strokeAlpha = 1, this.lineWidth = 1, this.isFilled = !1, this.isStroked = !1, this.closePath = !0, this._tempLine = new o, this.width = 0, this.height = 0, this.initPipeline(a.GRAPHICS_PIPELINE);
                },
                setFillStyle: function(t, e) {
                    return void 0 === e && (e = 1), void 0 === t ? this.isFilled = !1 : (this.fillColor = t, this.fillAlpha = e, this.isFilled = !0), this;
                },
                setStrokeStyle: function(t, e, i) {
                    return void 0 === i && (i = 1), void 0 === t ? this.isStroked = !1 : (this.lineWidth = t, this.strokeColor = e, this.strokeAlpha = i, this.isStroked = !0), this;
                },
                setClosePath: function(t) {
                    return this.closePath = t, this;
                },
                setSize: function(t, e) {
                    return this.width = t, this.height = e, this;
                },
                preDestroy: function() {
                    this.geom = null, this._tempLine = null, this.pathData = [], this.pathIndexes = [];
                },
                displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(t) {
                        this.scaleX = t / this.width;
                    }
                },
                displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(t) {
                        this.scaleY = t / this.height;
                    }
                }
            });
            t.exports = h;
        },
        function(t, e) {
            t.exports = {
                SKIP_CHECK: -1,
                NORMAL: 0,
                ADD: 1,
                MULTIPLY: 2,
                SCREEN: 3,
                OVERLAY: 4,
                DARKEN: 5,
                LIGHTEN: 6,
                COLOR_DODGE: 7,
                COLOR_BURN: 8,
                HARD_LIGHT: 9,
                SOFT_LIGHT: 10,
                DIFFERENCE: 11,
                EXCLUSION: 12,
                HUE: 13,
                SATURATION: 14,
                COLOR: 15,
                LUMINOSITY: 16,
                ERASE: 17,
                SOURCE_IN: 18,
                SOURCE_OUT: 19,
                SOURCE_ATOP: 20,
                DESTINATION_OVER: 21,
                DESTINATION_IN: 22,
                DESTINATION_OUT: 23,
                DESTINATION_ATOP: 24,
                LIGHTER: 25,
                COPY: 26,
                XOR: 27
            };
        },
        function(t, e, i) {
            var n = i(14);
            t.exports = function(t) {
                return t * n.DEG_TO_RAD;
            };
        },
        function(t, e, i) {
            t.exports = {
                DESTROY: i(719),
                FADE_IN_COMPLETE: i(720),
                FADE_IN_START: i(721),
                FADE_OUT_COMPLETE: i(722),
                FADE_OUT_START: i(723),
                FLASH_COMPLETE: i(724),
                FLASH_START: i(725),
                FOLLOW_UPDATE: i(726),
                PAN_COMPLETE: i(727),
                PAN_START: i(728),
                POST_RENDER: i(729),
                PRE_RENDER: i(730),
                ROTATE_COMPLETE: i(731),
                ROTATE_START: i(732),
                SHAKE_COMPLETE: i(733),
                SHAKE_START: i(734),
                ZOOM_COMPLETE: i(735),
                ZOOM_START: i(736)
            };
        },
        function(t, e, i) {
            var n = i(0), r = i(100), o = i(322), s = i(185), a = i(323), h = new n({
                initialize: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 255), this.r = 0, this.g = 0, this.b = 0, this.a = 255, this._h = 0, this._s = 0, this._v = 0, this._locked = !1, this.gl = [
                        0,
                        0,
                        0,
                        1
                    ], this._color = 0, this._color32 = 0, this._rgba = "", this.setTo(t, e, i, n);
                },
                transparent: function() {
                    return this._locked = !0, this.red = 0, this.green = 0, this.blue = 0, this.alpha = 0, this._locked = !1, this.update(!0);
                },
                setTo: function(t, e, i, n, s) {
                    return void 0 === n && (n = 255), void 0 === s && (s = !0), this._locked = !0, this.red = t, this.green = e, this.blue = i, this.alpha = n, this._locked = !1, this.update(s);
                },
                setGLTo: function(t, e, i, n) {
                    return void 0 === n && (n = 1), this._locked = !0, this.redGL = t, this.greenGL = e, this.blueGL = i, this.alphaGL = n, this._locked = !1, this.update(!0);
                },
                setFromRGB: function(t) {
                    return this._locked = !0, this.red = t.r, this.green = t.g, this.blue = t.b, t.hasOwnProperty("a") && (this.alpha = t.a), this._locked = !1, this.update(!0);
                },
                setFromHSV: function(t, e, i) {
                    return s(t, e, i, this);
                },
                update: function(t) {
                    if (void 0 === t && (t = !1), this._locked) return this;
                    var e = this.r, i = this.g, n = this.b, s = this.a;
                    return this._color = r(e, i, n), this._color32 = o(e, i, n, s), this._rgba = "rgba(" + e + "," + i + "," + n + "," + s / 255 + ")", t && a(e, i, n, this), this;
                },
                updateHSV: function() {
                    var t = this.r, e = this.g, i = this.b;
                    return a(t, e, i, this), this;
                },
                clone: function() {
                    return new h(this.r, this.g, this.b, this.a);
                },
                gray: function(t) {
                    return this.setTo(t, t, t);
                },
                random: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = 255);
                    var i = Math.floor(t + Math.random() * (e - t)), n = Math.floor(t + Math.random() * (e - t)), s = Math.floor(t + Math.random() * (e - t));
                    return this.setTo(i, n, s);
                },
                randomGray: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = 255);
                    var i = Math.floor(t + Math.random() * (e - t));
                    return this.setTo(i, i, i);
                },
                saturate: function(t) {
                    return this.s += t / 100, this;
                },
                desaturate: function(t) {
                    return this.s -= t / 100, this;
                },
                lighten: function(t) {
                    return this.v += t / 100, this;
                },
                darken: function(t) {
                    return this.v -= t / 100, this;
                },
                brighten: function(t) {
                    var e = this.r, i = this.g, n = this.b, e = Math.max(0, Math.min(255, e - Math.round(-t / 100 * 255))), i = Math.max(0, Math.min(255, i - Math.round(-t / 100 * 255))), n = Math.max(0, Math.min(255, n - Math.round(-t / 100 * 255)));
                    return this.setTo(e, i, n);
                },
                color: {
                    get: function() {
                        return this._color;
                    }
                },
                color32: {
                    get: function() {
                        return this._color32;
                    }
                },
                rgba: {
                    get: function() {
                        return this._rgba;
                    }
                },
                redGL: {
                    get: function() {
                        return this.gl[0];
                    },
                    set: function(t) {
                        this.gl[0] = Math.min(Math.abs(t), 1), this.r = Math.floor(255 * this.gl[0]), this.update(!0);
                    }
                },
                greenGL: {
                    get: function() {
                        return this.gl[1];
                    },
                    set: function(t) {
                        this.gl[1] = Math.min(Math.abs(t), 1), this.g = Math.floor(255 * this.gl[1]), this.update(!0);
                    }
                },
                blueGL: {
                    get: function() {
                        return this.gl[2];
                    },
                    set: function(t) {
                        this.gl[2] = Math.min(Math.abs(t), 1), this.b = Math.floor(255 * this.gl[2]), this.update(!0);
                    }
                },
                alphaGL: {
                    get: function() {
                        return this.gl[3];
                    },
                    set: function(t) {
                        this.gl[3] = Math.min(Math.abs(t), 1), this.a = Math.floor(255 * this.gl[3]), this.update();
                    }
                },
                red: {
                    get: function() {
                        return this.r;
                    },
                    set: function(t) {
                        t = Math.floor(Math.abs(t)), this.r = Math.min(t, 255), this.gl[0] = t / 255, this.update(!0);
                    }
                },
                green: {
                    get: function() {
                        return this.g;
                    },
                    set: function(t) {
                        t = Math.floor(Math.abs(t)), this.g = Math.min(t, 255), this.gl[1] = t / 255, this.update(!0);
                    }
                },
                blue: {
                    get: function() {
                        return this.b;
                    },
                    set: function(t) {
                        t = Math.floor(Math.abs(t)), this.b = Math.min(t, 255), this.gl[2] = t / 255, this.update(!0);
                    }
                },
                alpha: {
                    get: function() {
                        return this.a;
                    },
                    set: function(t) {
                        t = Math.floor(Math.abs(t)), this.a = Math.min(t, 255), this.gl[3] = t / 255, this.update();
                    }
                },
                h: {
                    get: function() {
                        return this._h;
                    },
                    set: function(t) {
                        this._h = t, s(t, this._s, this._v, this);
                    }
                },
                s: {
                    get: function() {
                        return this._s;
                    },
                    set: function(t) {
                        this._s = t, s(this._h, t, this._v, this);
                    }
                },
                v: {
                    get: function() {
                        return this._v;
                    },
                    set: function(t) {
                        this._v = t, s(this._h, this._s, t, this);
                    }
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i) {
                    this.x = 0, this.y = 0, this.z = 0, "object" == typeof t ? (this.x = t.x || 0, this.y = t.y || 0, this.z = t.z || 0) : (this.x = t || 0, this.y = e || 0, this.z = i || 0);
                },
                up: function() {
                    return this.x = 0, this.y = 1, this.z = 0, this;
                },
                min: function(t) {
                    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
                },
                max: function(t) {
                    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
                },
                clone: function() {
                    return new n(this.x, this.y, this.z);
                },
                addVectors: function(t, e) {
                    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
                },
                crossVectors: function(t, e) {
                    var i = t.x, n = t.y, s = t.z, r = e.x, o = e.y, a = e.z;
                    return this.x = n * a - s * o, this.y = s * r - i * a, this.z = i * o - n * r, this;
                },
                equals: function(t) {
                    return this.x === t.x && this.y === t.y && this.z === t.z;
                },
                copy: function(t) {
                    return this.x = t.x, this.y = t.y, this.z = t.z || 0, this;
                },
                set: function(t, e, i) {
                    return "object" == typeof t ? (this.x = t.x || 0, this.y = t.y || 0, this.z = t.z || 0) : (this.x = t || 0, this.y = e || 0, this.z = i || 0), this;
                },
                setFromMatrixPosition: function(t) {
                    return this.fromArray(t.val, 12);
                },
                setFromMatrixColumn: function(t, e) {
                    return this.fromArray(t.val, 4 * e);
                },
                fromArray: function(t, e) {
                    return void 0 === e && (e = 0), this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
                },
                add: function(t) {
                    return this.x += t.x, this.y += t.y, this.z += t.z || 0, this;
                },
                addScalar: function(t) {
                    return this.x += t, this.y += t, this.z += t, this;
                },
                addScale: function(t, e) {
                    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e || 0, this;
                },
                subtract: function(t) {
                    return this.x -= t.x, this.y -= t.y, this.z -= t.z || 0, this;
                },
                multiply: function(t) {
                    return this.x *= t.x, this.y *= t.y, this.z *= t.z || 1, this;
                },
                scale: function(t) {
                    return isFinite(t) ? (this.x *= t, this.y *= t, this.z *= t) : (this.x = 0, this.y = 0, this.z = 0), this;
                },
                divide: function(t) {
                    return this.x /= t.x, this.y /= t.y, this.z /= t.z || 1, this;
                },
                negate: function() {
                    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
                },
                distance: function(t) {
                    var e = t.x - this.x, i = t.y - this.y, n = t.z - this.z || 0;
                    return Math.sqrt(e * e + i * i + n * n);
                },
                distanceSq: function(t) {
                    var e = t.x - this.x, i = t.y - this.y, n = t.z - this.z || 0;
                    return e * e + i * i + n * n;
                },
                length: function() {
                    var t = this.x, e = this.y, i = this.z;
                    return Math.sqrt(t * t + e * e + i * i);
                },
                lengthSq: function() {
                    var t = this.x, e = this.y, i = this.z;
                    return t * t + e * e + i * i;
                },
                normalize: function() {
                    var t = this.x, e = this.y, i = this.z, n = t * t + e * e + i * i;
                    return 0 < n && (n = 1 / Math.sqrt(n), this.x = t * n, this.y = e * n, this.z = i * n), this;
                },
                dot: function(t) {
                    return this.x * t.x + this.y * t.y + this.z * t.z;
                },
                cross: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.x, r = t.y, o = t.z;
                    return this.x = i * o - n * r, this.y = n * s - e * o, this.z = e * r - i * s, this;
                },
                lerp: function(t, e) {
                    void 0 === e && (e = 0);
                    var i = this.x, n = this.y, s = this.z;
                    return this.x = i + e * (t.x - i), this.y = n + e * (t.y - n), this.z = s + e * (t.z - s), this;
                },
                applyMatrix3: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.val;
                    return this.x = s[0] * e + s[3] * i + s[6] * n, this.y = s[1] * e + s[4] * i + s[7] * n, this.z = s[2] * e + s[5] * i + s[8] * n, this;
                },
                applyMatrix4: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.val, r = 1 / (s[3] * e + s[7] * i + s[11] * n + s[15]);
                    return this.x = (s[0] * e + s[4] * i + s[8] * n + s[12]) * r, this.y = (s[1] * e + s[5] * i + s[9] * n + s[13]) * r, this.z = (s[2] * e + s[6] * i + s[10] * n + s[14]) * r, this;
                },
                transformMat3: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.val;
                    return this.x = e * s[0] + i * s[3] + n * s[6], this.y = e * s[1] + i * s[4] + n * s[7], this.z = e * s[2] + i * s[5] + n * s[8], this;
                },
                transformMat4: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.val;
                    return this.x = s[0] * e + s[4] * i + s[8] * n + s[12], this.y = s[1] * e + s[5] * i + s[9] * n + s[13], this.z = s[2] * e + s[6] * i + s[10] * n + s[14], this;
                },
                transformCoordinates: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.val, r = e * s[0] + i * s[4] + n * s[8] + s[12], o = e * s[1] + i * s[5] + n * s[9] + s[13], a = e * s[2] + i * s[6] + n * s[10] + s[14], h = e * s[3] + i * s[7] + n * s[11] + s[15];
                    return this.x = r / h, this.y = o / h, this.z = a / h, this;
                },
                transformQuat: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.x, r = t.y, o = t.z, a = t.w, h = a * e + r * n - o * i, l = a * i + o * e - s * n, u = a * n + s * i - r * e, c = -s * e - r * i - o * n;
                    return this.x = h * a + c * -s + l * -o - u * -r, this.y = l * a + c * -r + u * -s - h * -o, this.z = u * a + c * -o + h * -r - l * -s, this;
                },
                project: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.val, r = s[0], o = s[1], a = s[2], h = s[3], l = s[4], u = s[5], c = s[6], d = s[7], f = s[8], p = s[9], g = s[10], v = s[11], m = s[12], y = s[13], x = s[14], T = 1 / (e * h + i * d + n * v + s[15]);
                    return this.x = (e * r + i * l + n * f + m) * T, this.y = (e * o + i * u + n * p + y) * T, this.z = (e * a + i * c + n * g + x) * T, this;
                },
                projectViewMatrix: function(t, e) {
                    return this.applyMatrix4(t).applyMatrix4(e);
                },
                unprojectViewMatrix: function(t, e) {
                    return this.applyMatrix4(t).applyMatrix4(e);
                },
                unproject: function(t, e) {
                    var i = t.x, n = t.y, s = t.z, r = t.w, o = this.x - i, a = r - this.y - 1 - n, h = this.z;
                    return this.x = 2 * o / s - 1, this.y = 2 * a / r - 1, this.z = 2 * h - 1, this.project(e);
                },
                reset: function() {
                    return this.x = 0, this.y = 0, this.z = 0, this;
                }
            });
            n.ZERO = new n, n.RIGHT = new n(1, 0, 0), n.LEFT = new n(-1, 0, 0), n.UP = new n(0, -1, 0), n.DOWN = new n(0, 1, 0), n.FORWARD = new n(0, 0, 1), n.BACK = new n(0, 0, -1), n.ONE = new n(1, 1, 1), t.exports = n;
        },
        function(t, e) {
            t.exports = {
                CSV: 0,
                TILED_JSON: 1,
                ARRAY_2D: 2,
                WELTMEISTER: 3
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.y + t.height - t.height * t.originY;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x - t.width * t.originX;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x + t.width - t.width * t.originX;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.y - t.height * t.originY;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r) {
                var o;
                void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = 1);
                var a = 0, h = t.length;
                if (1 === r) for(o = s; o < h; o++)t[o][e] += i + a * n, a++;
                else for(o = s; 0 <= o; o--)t[o][e] += i + a * n, a++;
                return t;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(301), r = i(168), o = i(55), a = i(169), h = i(3), l = new n({
                initialize: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), this.type = o.LINE, this.x1 = t, this.y1 = e, this.x2 = i, this.y2 = n;
                },
                getPoint: function(t, e) {
                    return s(this, t, e);
                },
                getPoints: function(t, e, i) {
                    return r(this, t, e, i);
                },
                getRandomPoint: function(t) {
                    return a(this, t);
                },
                setTo: function(t, e, i, n) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), this.x1 = t, this.y1 = e, this.x2 = i, this.y2 = n, this;
                },
                getPointA: function(t) {
                    return void 0 === t && (t = new h), t.set(this.x1, this.y1), t;
                },
                getPointB: function(t) {
                    return void 0 === t && (t = new h), t.set(this.x2, this.y2), t;
                },
                left: {
                    get: function() {
                        return Math.min(this.x1, this.x2);
                    },
                    set: function(t) {
                        this.x1 <= this.x2 ? this.x1 = t : this.x2 = t;
                    }
                },
                right: {
                    get: function() {
                        return Math.max(this.x1, this.x2);
                    },
                    set: function(t) {
                        this.x1 > this.x2 ? this.x1 = t : this.x2 = t;
                    }
                },
                top: {
                    get: function() {
                        return Math.min(this.y1, this.y2);
                    },
                    set: function(t) {
                        this.y1 <= this.y2 ? this.y1 = t : this.y2 = t;
                    }
                },
                bottom: {
                    get: function() {
                        return Math.max(this.y1, this.y2);
                    },
                    set: function(t) {
                        this.y1 > this.y2 ? this.y1 = t : this.y2 = t;
                    }
                }
            });
            t.exports = l;
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = i || e.fillColor, r = n || e.fillAlpha, o = (16711680 & s) >>> 16, a = (65280 & s) >>> 8, h = 255 & s;
                t.fillStyle = "rgba(" + o + "," + a + "," + h + "," + r + ")";
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n) {
                    var s = [];
                    n.forEach(function(t) {
                        t && s.push(t);
                    }), this.loader = t, this.type = e, this.key = i, this.multiKeyIndex = t.multiKeyIndex++, this.files = s, this.complete = !1, this.pending = s.length, this.failed = 0, this.config = {}, this.baseURL = t.baseURL, this.path = t.path, this.prefix = t.prefix;
                    for(var r = 0; r < s.length; r++)s[r].multiFile = this;
                },
                isReadyToProcess: function() {
                    return 0 === this.pending && 0 === this.failed && !this.complete;
                },
                addToMultiFile: function(t) {
                    return this.files.push(t), (t.multiFile = this).pending++, this.complete = !1, this;
                },
                onFileComplete: function(t) {
                    -1 !== this.files.indexOf(t) && this.pending--;
                },
                onFileFailed: function(t) {
                    -1 !== this.files.indexOf(t) && this.failed++;
                }
            });
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = t - i, r = e - n;
                return Math.sqrt(s * s + r * r);
            };
        },
        function(t, e, i) {
            t.exports = {
                BOOT: i(918),
                DESTROY: i(919),
                DRAG_END: i(920),
                DRAG_ENTER: i(921),
                DRAG: i(922),
                DRAG_LEAVE: i(923),
                DRAG_OVER: i(924),
                DRAG_START: i(925),
                DROP: i(926),
                GAME_OUT: i(927),
                GAME_OVER: i(928),
                GAMEOBJECT_DOWN: i(929),
                GAMEOBJECT_DRAG_END: i(930),
                GAMEOBJECT_DRAG_ENTER: i(931),
                GAMEOBJECT_DRAG: i(932),
                GAMEOBJECT_DRAG_LEAVE: i(933),
                GAMEOBJECT_DRAG_OVER: i(934),
                GAMEOBJECT_DRAG_START: i(935),
                GAMEOBJECT_DROP: i(936),
                GAMEOBJECT_MOVE: i(937),
                GAMEOBJECT_OUT: i(938),
                GAMEOBJECT_OVER: i(939),
                GAMEOBJECT_POINTER_DOWN: i(940),
                GAMEOBJECT_POINTER_MOVE: i(941),
                GAMEOBJECT_POINTER_OUT: i(942),
                GAMEOBJECT_POINTER_OVER: i(943),
                GAMEOBJECT_POINTER_UP: i(944),
                GAMEOBJECT_POINTER_WHEEL: i(945),
                GAMEOBJECT_UP: i(946),
                GAMEOBJECT_WHEEL: i(947),
                MANAGER_BOOT: i(948),
                MANAGER_PROCESS: i(949),
                MANAGER_UPDATE: i(950),
                POINTER_DOWN: i(951),
                POINTER_DOWN_OUTSIDE: i(952),
                POINTER_MOVE: i(953),
                POINTER_OUT: i(954),
                POINTER_OVER: i(955),
                POINTER_UP: i(956),
                POINTER_UP_OUTSIDE: i(957),
                POINTER_WHEEL: i(958),
                POINTERLOCK_CHANGE: i(959),
                PRE_UPDATE: i(960),
                SHUTDOWN: i(961),
                START: i(962),
                UPDATE: i(963)
            };
        },
        function(t, e) {
            var h = {};
            t.exports = h, function() {
                h._nextId = 0, h._seed = 0, h._nowStartTime = +new Date, h.extend = function(t, e) {
                    for(var i, n = "boolean" == typeof e ? (i = 2, e) : (i = 1, !0), s = i; s < arguments.length; s++){
                        var r = arguments[s];
                        if (r) for(var o in r)!n || !r[o] || r[o].constructor !== Object || t[o] && t[o].constructor !== Object ? t[o] = r[o] : (t[o] = t[o] || {}, h.extend(t[o], n, r[o]));
                    }
                    return t;
                }, h.clone = function(t, e) {
                    return h.extend({}, e, t);
                }, h.keys = function(t) {
                    if (Object.keys) return Object.keys(t);
                    var e = [];
                    for(var i in t)e.push(i);
                    return e;
                }, h.values = function(t) {
                    var e = [];
                    if (Object.keys) {
                        for(var i = Object.keys(t), n = 0; n < i.length; n++)e.push(t[i[n]]);
                        return e;
                    }
                    for(var s in t)e.push(t[s]);
                    return e;
                }, h.get = function(t, e, i, n) {
                    e = e.split(".").slice(i, n);
                    for(var s = 0; s < e.length; s += 1)t = t[e[s]];
                    return t;
                }, h.set = function(t, e, i, n, s) {
                    var r = e.split(".").slice(n, s);
                    return h.get(t, e, 0, -1)[r[r.length - 1]] = i;
                }, h.shuffle = function(t) {
                    for(var e = t.length - 1; 0 < e; e--){
                        var i = Math.floor(h.random() * (e + 1)), n = t[e];
                        t[e] = t[i], t[i] = n;
                    }
                    return t;
                }, h.choose = function(t) {
                    return t[Math.floor(h.random() * t.length)];
                }, h.isElement = function(t) {
                    return "undefined" != typeof HTMLElement ? t instanceof HTMLElement : !!(t && t.nodeType && t.nodeName);
                }, h.isArray = function(t) {
                    return "[object Array]" === Object.prototype.toString.call(t);
                }, h.isFunction = function(t) {
                    return "function" == typeof t;
                }, h.isPlainObject = function(t) {
                    return "object" == typeof t && t.constructor === Object;
                }, h.isString = function(t) {
                    return "[object String]" === Object.prototype.toString.call(t);
                }, h.clamp = function(t, e, i) {
                    return t < e ? e : i < t ? i : t;
                }, h.sign = function(t) {
                    return t < 0 ? -1 : 1;
                }, h.now = function() {
                    if ("undefined" != typeof window && window.performance) {
                        if (window.performance.now) return window.performance.now();
                        if (window.performance.webkitNow) return window.performance.webkitNow();
                    }
                    return new Date - h._nowStartTime;
                }, h.random = function(t, e) {
                    return e = void 0 !== e ? e : 1, (t = void 0 !== t ? t : 0) + i() * (e - t);
                };
                var i = function() {
                    return h._seed = (9301 * h._seed + 49297) % 233280, h._seed / 233280;
                };
                h.colorToNumber = function(t) {
                    return 3 == (t = t.replace("#", "")).length && (t = t.charAt(0) + t.charAt(0) + t.charAt(1) + t.charAt(1) + t.charAt(2) + t.charAt(2)), parseInt(t, 16);
                }, h.logLevel = 1, h.log = function() {
                    console && 0 < h.logLevel && h.logLevel <= 3 && console.log.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                }, h.info = function() {
                    console && 0 < h.logLevel && h.logLevel <= 2 && console.info.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                }, h.warn = function() {
                    console && 0 < h.logLevel && h.logLevel <= 3 && console.warn.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                }, h.nextId = function() {
                    return h._nextId++;
                }, h.indexOf = function(t, e) {
                    if (t.indexOf) return t.indexOf(e);
                    for(var i = 0; i < t.length; i++)if (t[i] === e) return i;
                    return -1;
                }, h.map = function(t, e) {
                    if (t.map) return t.map(e);
                    for(var i = [], n = 0; n < t.length; n += 1)i.push(e(t[n]));
                    return i;
                }, h.topologicalSort = function(t) {
                    var e = [], i = [], n = [];
                    for(var s in t)i[s] || n[s] || h._topologicalSort(s, i, n, t, e);
                    return e;
                }, h._topologicalSort = function(t, e, i, n, s) {
                    var r = n[t] || [];
                    i[t] = !0;
                    for(var o = 0; o < r.length; o += 1){
                        var a = r[o];
                        i[a] || e[a] || h._topologicalSort(a, e, i, n, s);
                    }
                    i[t] = !1, e[t] = !0, s.push(t);
                }, h.chain = function() {
                    for(var r = [], t = 0; t < arguments.length; t += 1){
                        var e = arguments[t];
                        e._chained ? r.push.apply(r, e._chained) : r.push(e);
                    }
                    function i() {
                        for(var t, e = new Array(arguments.length), i = 0, n = arguments.length; i < n; i++)e[i] = arguments[i];
                        for(i = 0; i < r.length; i += 1){
                            var s = r[i].apply(t, e);
                            void 0 !== s && (t = s);
                        }
                        return t;
                    }
                    return i._chained = r, i;
                }, h.chainPathBefore = function(t, e, i) {
                    return h.set(t, e, h.chain(i, h.get(t, e)));
                }, h.chainPathAfter = function(t, e, i) {
                    return h.set(t, e, h.chain(h.get(t, e), i));
                };
            }();
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.y = e + t.height * t.originY, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x = e + t.width * t.originX, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x = e - t.width + t.width * t.originX, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.y = e - t.height + t.height * t.originY, t;
            };
        },
        function(t, e) {
            t.exports = {
                CIRCLE: 0,
                ELLIPSE: 1,
                LINE: 2,
                POINT: 3,
                POLYGON: 4,
                RECTANGLE: 5,
                TRIANGLE: 6
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return !(t.width <= 0 || t.height <= 0) && t.x <= e && t.x + t.width >= e && t.y <= i && t.y + t.height >= i;
            };
        },
        function(t, e, i) {
            var n = i(0), y = i(172), s = i(9), v = i(368), x = i(2), m = i(67), T = i(88), w = i(139), b = i(12), E = i(369), r = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this);
                    var e = t.game, i = e.renderer, n = i.gl;
                    this.name = x(t, "name", "WebGLPipeline"), this.game = e, this.renderer = i, this.manager, this.gl = n, this.view = e.canvas, this.width = 0, this.height = 0, this.vertexCount = 0, this.vertexCapacity = 0, this.vertexData, this.vertexBuffer, this.topology = x(t, "topology", n.TRIANGLES), this.bytes, this.vertexViewF32, this.vertexViewU32, this.active = !0, this.currentUnit = 0, this.forceZero = x(t, "forceZero", !1), this.hasBooted = !1, this.isPostFX = !1, this.renderTargets = [], this.currentRenderTarget, this.shaders = [], this.currentShader, this.projectionMatrix, this.projectionWidth = 0, this.projectionHeight = 0, this.config = t;
                },
                boot: function() {
                    var t = this.gl, e = this.config, i = this.renderer;
                    this.isPostFX || (this.projectionMatrix = (new m).identity());
                    var n = this.renderTargets, s = x(e, "renderTarget", !1);
                    "boolean" == typeof s && s && (s = 1);
                    var r = i.width, o = i.height;
                    if ("number" == typeof s) for(d = 0; d < s; d++)n.push(new w(i, r, o, 1, 0, !0));
                    else if (Array.isArray(s)) for(d = 0; d < s.length; d++){
                        var a = x(s[d], "scale", 1), h = x(s[d], "minFilter", 0), l = x(s[d], "autoClear", 1);
                        n.push(new w(i, r, o, a, h, l));
                    }
                    n.length && (this.currentRenderTarget = n[0]), this.setShadersFromConfig(e);
                    for(var u = this.shaders, c = 0, d = 0; d < u.length; d++)u[d].vertexSize > c && (c = u[d].vertexSize);
                    var f = x(e, "batchSize", i.config.batchSize);
                    this.vertexCapacity = 6 * f;
                    var p = new ArrayBuffer(this.vertexCapacity * c);
                    this.vertexData = p, this.bytes = new Uint8Array(p), this.vertexViewF32 = new Float32Array(p), this.vertexViewU32 = new Uint32Array(p);
                    var g = x(e, "vertices", null);
                    for(g ? (this.vertexViewF32.set(g), this.vertexBuffer = i.createVertexBuffer(p, t.STATIC_DRAW)) : this.vertexBuffer = i.createVertexBuffer(p.byteLength, t.DYNAMIC_DRAW), this.setVertexBuffer(), d = u.length - 1; 0 <= d; d--)u[d].rebind();
                    this.hasBooted = !0, i.on(T.RESIZE, this.resize, this), i.on(T.PRE_RENDER, this.onPreRender, this), i.on(T.RENDER, this.onRender, this), i.on(T.POST_RENDER, this.onPostRender, this), this.emit(v.BOOT, this), this.onBoot();
                },
                onBoot: function() {},
                onResize: function() {},
                setShader: function(t, e) {
                    var i = this.renderer;
                    return t === this.currentShader && i.currentProgram === this.currentShader.program || (this.flush(), i.resetTextures(), this.setVertexBuffer() && !e && (e = !0), t.bind(e, !1), this.currentShader = t), this;
                },
                getShaderByName: function(t) {
                    for(var e = this.shaders, i = 0; i < e.length; i++)if (e[i].name === t) return e[i];
                },
                setShadersFromConfig: function(t) {
                    var e = this.shaders, i = this.renderer;
                    for(d = 0; d < e.length; d++)e[d].destroy();
                    var n = "vertShader", s = "fragShader", r = "attributes", o = x(t, n, null), a = b.parseFragmentShaderMaxTextures(x(t, s, null), i.maxTextures), h = x(t, r, null), l = x(t, "shaders", []), u = l.length;
                    if (0 === u) o && a && (this.shaders = [
                        new E(this, "default", o, a, y(h))
                    ]);
                    else {
                        for(var c = [], d = 0; d < u; d++){
                            var f = l[d], p = x(f, "name", "default"), g = x(f, n, o), v = b.parseFragmentShaderMaxTextures(x(f, s, a), i.maxTextures), m = x(f, r, h);
                            g && v && c.push(new E(this, p, g, v, y(m)));
                        }
                        this.shaders = c;
                    }
                    return 0 === this.shaders.length ? console.warn("Pipeline: " + this.name + " - Invalid shader config") : this.currentShader = this.shaders[0], this;
                },
                setGameObject: function(t, e) {
                    return void 0 === e && (e = t.frame), this.currentUnit = this.renderer.setTextureSource(e.source), this.currentUnit;
                },
                shouldFlush: function(t) {
                    return void 0 === t && (t = 0), this.vertexCount + t > this.vertexCapacity;
                },
                resize: function(t, e) {
                    t === this.width && e === this.height || this.flush(), this.width = t, this.height = e;
                    for(var i = this.renderTargets, n = 0; n < i.length; n++)i[n].resize(t, e);
                    return this.setProjectionMatrix(t, e), this.emit(v.RESIZE, t, e, this), this.onResize(t, e), this;
                },
                setProjectionMatrix: function(t, e) {
                    var i = this.projectionMatrix;
                    if (!i) return this;
                    this.projectionWidth = t, this.projectionHeight = e, i.ortho(0, t, e, 0, -1000, 1e3);
                    for(var n = this.shaders, s = "uProjectionMatrix", r = 0; r < n.length; r++){
                        var o = n[r];
                        o.hasUniform(s) && (o.resetUniform(s), o.setMatrix4fv(s, !1, i.val, o));
                    }
                    return this;
                },
                updateProjectionMatrix: function() {
                    var t, e;
                    this.projectionMatrix && (t = this.renderer.projectionWidth, e = this.renderer.projectionHeight, this.projectionWidth === t && this.projectionHeight === e || this.setProjectionMatrix(t, e));
                },
                bind: function(t) {
                    void 0 === t && (t = this.currentShader);
                    var e = this.setVertexBuffer();
                    return t.bind(e), this.currentShader = t, this.emit(v.BIND, this, t), this.onActive(t), this;
                },
                rebind: function() {
                    this.setVertexBuffer();
                    for(var t = this.shaders, e = t.length - 1; 0 <= e; e--)this.currentShader = t[e].rebind();
                    return this.emit(v.REBIND, this.currentShader), this.onActive(this.currentShader), this.onRebind(), this;
                },
                setVertexBuffer: function() {
                    var t = this.gl, e = this.vertexBuffer;
                    return t.getParameter(t.ARRAY_BUFFER_BINDING) !== e && (t.bindBuffer(t.ARRAY_BUFFER, e), !0);
                },
                preBatch: function(t) {
                    return this.currentRenderTarget && this.currentRenderTarget.bind(), this.onPreBatch(t), this;
                },
                postBatch: function(t) {
                    return this.onDraw(this.currentRenderTarget), this.onPostBatch(t), this;
                },
                onDraw: function() {},
                unbind: function() {
                    this.currentRenderTarget && this.currentRenderTarget.unbind();
                },
                flush: function(t) {
                    var e, i, n;
                    return void 0 === t && (t = !1), 0 < this.vertexCount && (this.emit(v.BEFORE_FLUSH, this, t), this.onBeforeFlush(t), e = this.gl, i = this.vertexCount, n = this.currentShader.vertexSize, this.active && (this.setVertexBuffer(), i === this.vertexCapacity ? e.bufferData(e.ARRAY_BUFFER, this.vertexData, e.DYNAMIC_DRAW) : e.bufferSubData(e.ARRAY_BUFFER, 0, this.bytes.subarray(0, i * n)), e.drawArrays(this.topology, 0, i)), this.vertexCount = 0, this.emit(v.AFTER_FLUSH, this, t), this.onAfterFlush(t)), this;
                },
                onActive: function() {},
                onBind: function() {},
                onRebind: function() {},
                onBatch: function() {},
                onPreBatch: function() {},
                onPostBatch: function() {},
                onPreRender: function() {},
                onRender: function() {},
                onPostRender: function() {},
                onBeforeFlush: function() {},
                onAfterFlush: function() {},
                batchVert: function(t, e, i, n, s, r, o) {
                    var a = this.vertexViewF32, h = this.vertexViewU32, l = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    a[++l] = t, a[++l] = e, a[++l] = i, a[++l] = n, a[++l] = s, a[++l] = r, h[++l] = o, this.vertexCount++;
                },
                batchQuad: function(t, e, i, n, s, r, o, a, h, l, u, c, d, f, p, g, v, m, y, x) {
                    void 0 === x && (x = this.currentUnit);
                    var T = !1;
                    return this.shouldFlush(6) && (this.flush(), T = !0, x = this.setTexture2D(y)), this.batchVert(e, i, l, u, x, m, f), this.batchVert(n, s, l, d, x, m, g), this.batchVert(r, o, c, d, x, m, v), this.batchVert(e, i, l, u, x, m, f), this.batchVert(r, o, c, d, x, m, v), this.batchVert(a, h, c, u, x, m, p), this.onBatch(t), T;
                },
                batchTri: function(t, e, i, n, s, r, o, a, h, l, u, c, d, f, p, g, v) {
                    void 0 === v && (v = this.currentUnit);
                    var m = !1;
                    return this.shouldFlush(3) && (this.flush(), m = !0, v = this.setTexture2D(g)), this.batchVert(e, i, a, h, v, p, c), this.batchVert(n, s, a, u, v, p, d), this.batchVert(r, o, l, u, v, p, f), this.onBatch(t), m;
                },
                drawFillRect: function(t, e, i, n, s, r, o, a) {
                    void 0 === o && (o = this.renderer.whiteTexture.glTexture), void 0 === a && (a = !0), t = Math.floor(t), e = Math.floor(e);
                    var h = Math.floor(t + i), l = Math.floor(e + n), u = this.setTexture2D(o), c = b.getTintAppendFloatAlphaAndSwap(s, r), d = 0, f = 1;
                    a && (d = 1, f = 0), this.batchQuad(null, t, e, t, l, h, l, h, e, 0, d, 1, f, c, c, c, c, 0, o, u);
                },
                setTexture2D: function(t) {
                    return void 0 === t && (t = this.renderer.whiteTexture.glTexture), this.currentUnit = this.renderer.setTexture2D(t), this.currentUnit;
                },
                bindTexture: function(t, e) {
                    void 0 === e && (e = 0);
                    var i = this.gl;
                    return i.activeTexture(i.TEXTURE0 + e), i.bindTexture(i.TEXTURE_2D, t), this;
                },
                bindRenderTarget: function(t, e) {
                    return this.bindTexture(t.texture, e);
                },
                setTime: function(t) {
                    return this.set1f(t, this.game.loop.getDuration()), this;
                },
                set1f: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set1f(t, e), this;
                },
                set2f: function(t, e, i, n) {
                    return void 0 === n && (n = this.currentShader), n.set2f(t, e, i), this;
                },
                set3f: function(t, e, i, n, s) {
                    return void 0 === s && (s = this.currentShader), s.set3f(t, e, i, n), this;
                },
                set4f: function(t, e, i, n, s, r) {
                    return void 0 === r && (r = this.currentShader), r.set4f(t, e, i, n, s), this;
                },
                set1fv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set1fv(t, e), this;
                },
                set2fv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set2fv(t, e), this;
                },
                set3fv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set3fv(t, e), this;
                },
                set4fv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set4fv(t, e), this;
                },
                set1iv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set1iv(t, e), this;
                },
                set2iv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set2iv(t, e), this;
                },
                set3iv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set3iv(t, e), this;
                },
                set4iv: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set4iv(t, e), this;
                },
                set1i: function(t, e, i) {
                    return void 0 === i && (i = this.currentShader), i.set1i(t, e), this;
                },
                set2i: function(t, e, i, n) {
                    return void 0 === n && (n = this.currentShader), n.set2i(t, e, i), this;
                },
                set3i: function(t, e, i, n, s) {
                    return void 0 === s && (s = this.currentShader), s.set3i(t, e, i, n), this;
                },
                set4i: function(t, e, i, n, s, r) {
                    return void 0 === r && (r = this.currentShader), r.set4i(t, e, i, n, s), this;
                },
                setMatrix2fv: function(t, e, i, n) {
                    return void 0 === n && (n = this.currentShader), n.setMatrix2fv(t, e, i), this;
                },
                setMatrix3fv: function(t, e, i, n) {
                    return void 0 === n && (n = this.currentShader), n.setMatrix3fv(t, e, i), this;
                },
                setMatrix4fv: function(t, e, i, n) {
                    return void 0 === n && (n = this.currentShader), n.setMatrix4fv(t, e, i), this;
                },
                destroy: function() {
                    this.emit(v.DESTROY, this);
                    for(var t = this.shaders, e = 0; e < t.length; e++)t[e].destroy();
                    var i = this.renderTargets;
                    for(e = 0; e < i.length; e++)i[e].destroy();
                    this.gl.deleteBuffer(this.vertexBuffer);
                    var n = this.renderer;
                    return n.off(T.RESIZE, this.resize, this), n.off(T.PRE_RENDER, this.onPreRender, this), n.off(T.RENDER, this.onRender, this), n.off(T.POST_RENDER, this.onPostRender, this), this.removeAllListeners(), this.game = null, this.renderer = null, this.manager = null, this.gl = null, this.view = null, this.shaders = null, this.renderTargets = null, this.bytes = null, this.vertexViewF32 = null, this.vertexViewU32 = null, this.vertexData = null, this.vertexBuffer = null, this.currentShader = null, this.currentRenderTarget = null, this;
                }
            });
            t.exports = r;
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = i || e.strokeColor, r = n || e.strokeAlpha, o = (16711680 & s) >>> 16, a = (65280 & s) >>> 8, h = 255 & s;
                t.strokeStyle = "rgba(" + o + "," + a + "," + h + "," + r + ")", t.lineWidth = e.lineWidth;
            };
        },
        function(t, e, i) {
            var n = i(0), h = i(20), l = i(23), s = i(8), u = i(2), c = i(6), d = i(7), r = new n({
                Extends: l,
                initialize: function(t, e, i, n, s) {
                    var r, o = "json";
                    d(e) && (e = u(r = e, "key"), i = u(r, "url"), n = u(r, "xhrSettings"), o = u(r, "extension", o), s = u(r, "dataKey", s));
                    var a = {
                        type: "json",
                        cache: t.cacheManager.json,
                        extension: o,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n,
                        config: s
                    };
                    l.call(this, t, a), d(i) && (this.data = s ? c(i, s) : i, this.state = h.FILE_POPULATED);
                },
                onProcess: function() {
                    var t, e;
                    this.state !== h.FILE_POPULATED && (this.state = h.FILE_PROCESSING, t = JSON.parse(this.xhrLoader.responseText), e = this.config, this.data = "string" == typeof e ? c(t, e, t) : t), this.onProcessComplete();
                }
            });
            s.register("json", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new r(this, t[s]));
                else this.addFile(new r(this, t, e, n, i));
                return this;
            }), t.exports = r;
        },
        function(t, e) {
            t.exports = {
                DYNAMIC_BODY: 0,
                STATIC_BODY: 1,
                GROUP: 2,
                TILEMAPLAYER: 3,
                FACING_NONE: 10,
                FACING_UP: 11,
                FACING_DOWN: 12,
                FACING_LEFT: 13,
                FACING_RIGHT: 14
            };
        },
        function(t, e, i) {
            var d = i(156), f = i(26);
            t.exports = function(t, e, i, n, s) {
                for(var r, o, a, h, l = f(t, e, i, n, null, s), u = 0; u < l.length; u++){
                    var c = l[u];
                    c && (c.collides ? (r = d(c.x, c.y - 1, !0, s), o = d(c.x, c.y + 1, !0, s), a = d(c.x - 1, c.y, !0, s), h = d(c.x + 1, c.y, !0, s), c.faceTop = !r || !r.collides, c.faceBottom = !o || !o.collides, c.faceLeft = !a || !a.collides, c.faceRight = !h || !h.collides) : c.resetFaces());
                }
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(63), r = i(294), o = i(295), a = i(55), h = i(166), l = new n({
                initialize: function(t, e, i) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), this.type = a.CIRCLE, this.x = t, this.y = e, this._radius = i, this._diameter = 2 * i;
                },
                contains: function(t, e) {
                    return s(this, t, e);
                },
                getPoint: function(t, e) {
                    return r(this, t, e);
                },
                getPoints: function(t, e, i) {
                    return o(this, t, e, i);
                },
                getRandomPoint: function(t) {
                    return h(this, t);
                },
                setTo: function(t, e, i) {
                    return this.x = t, this.y = e, this._radius = i, this._diameter = 2 * i, this;
                },
                setEmpty: function() {
                    return this._radius = 0, this._diameter = 0, this;
                },
                setPosition: function(t, e) {
                    return void 0 === e && (e = t), this.x = t, this.y = e, this;
                },
                isEmpty: function() {
                    return this._radius <= 0;
                },
                radius: {
                    get: function() {
                        return this._radius;
                    },
                    set: function(t) {
                        this._radius = t, this._diameter = 2 * t;
                    }
                },
                diameter: {
                    get: function() {
                        return this._diameter;
                    },
                    set: function(t) {
                        this._diameter = t, this._radius = .5 * t;
                    }
                },
                left: {
                    get: function() {
                        return this.x - this._radius;
                    },
                    set: function(t) {
                        this.x = t + this._radius;
                    }
                },
                right: {
                    get: function() {
                        return this.x + this._radius;
                    },
                    set: function(t) {
                        this.x = t - this._radius;
                    }
                },
                top: {
                    get: function() {
                        return this.y - this._radius;
                    },
                    set: function(t) {
                        this.y = t + this._radius;
                    }
                },
                bottom: {
                    get: function() {
                        return this.y + this._radius;
                    },
                    set: function(t) {
                        this.y = t - this._radius;
                    }
                }
            });
            t.exports = l;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return 0 < t.radius && e >= t.left && e <= t.right && i >= t.top && i <= t.bottom && (t.x - e) * (t.x - e) + (t.y - i) * (t.y - i) <= t.radius * t.radius;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.sqrt((t.x2 - t.x1) * (t.x2 - t.x1) + (t.y2 - t.y1) * (t.y2 - t.y1));
            };
        },
        function(t, e) {
            t.exports = {
                BITMAPMASK_PIPELINE: "BitmapMaskPipeline",
                LIGHT_PIPELINE: "Light2D",
                POINTLIGHT_PIPELINE: "PointLightPipeline",
                SINGLE_PIPELINE: "SinglePipeline",
                MULTI_PIPELINE: "MultiPipeline",
                ROPE_PIPELINE: "RopePipeline",
                GRAPHICS_PIPELINE: "GraphicsPipeline",
                POSTFX_PIPELINE: "PostFXPipeline",
                UTILITY_PIPELINE: "UtilityPipeline"
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = i - e;
                return e + ((t - e) % n + n) % n;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(38), r = new n({
                initialize: function(t) {
                    this.val = new Float32Array(16), t ? this.copy(t) : this.identity();
                },
                clone: function() {
                    return new r(this);
                },
                set: function(t) {
                    return this.copy(t);
                },
                setValues: function(t, e, i, n, s, r, o, a, h, l, u, c, d, f, p, g) {
                    var v = this.val;
                    return v[0] = t, v[1] = e, v[2] = i, v[3] = n, v[4] = s, v[5] = r, v[6] = o, v[7] = a, v[8] = h, v[9] = l, v[10] = u, v[11] = c, v[12] = d, v[13] = f, v[14] = p, v[15] = g, this;
                },
                copy: function(t) {
                    var e = t.val;
                    return this.setValues(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
                },
                fromArray: function(t) {
                    return this.setValues(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
                },
                zero: function() {
                    return this.setValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                },
                transform: function(t, e, i) {
                    var n = h.fromQuat(i).val, s = e.x, r = e.y, o = e.z;
                    return this.setValues(n[0] * s, n[1] * s, n[2] * s, 0, n[4] * r, n[5] * r, n[6] * r, 0, n[8] * o, n[9] * o, n[10] * o, 0, t.x, t.y, t.z, 1);
                },
                xyz: function(t, e, i) {
                    this.identity();
                    var n = this.val;
                    return n[12] = t, n[13] = e, n[14] = i, this;
                },
                scaling: function(t, e, i) {
                    this.zero();
                    var n = this.val;
                    return n[0] = t, n[5] = e, n[10] = i, n[15] = 1, this;
                },
                identity: function() {
                    return this.setValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                },
                transpose: function() {
                    var t = this.val, e = t[1], i = t[2], n = t[3], s = t[6], r = t[7], o = t[11];
                    return t[1] = t[4], t[2] = t[8], t[3] = t[12], t[4] = e, t[6] = t[9], t[7] = t[13], t[8] = i, t[9] = s, t[11] = t[14], t[12] = n, t[13] = r, t[14] = o, this;
                },
                getInverse: function(t) {
                    return this.copy(t), this.invert();
                },
                invert: function() {
                    var t = this.val, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = t[6], h = t[7], l = t[8], u = t[9], c = t[10], d = t[11], f = t[12], p = t[13], g = t[14], v = t[15], m = e * o - i * r, y = e * a - n * r, x = e * h - s * r, T = i * a - n * o, w = i * h - s * o, b = n * h - s * a, E = l * p - u * f, S = l * g - c * f, A = l * v - d * f, _ = u * g - c * p, C = u * v - d * p, M = c * v - d * g, R = m * M - y * C + x * _ + T * A - w * S + b * E;
                    return R ? (R = 1 / R, this.setValues((o * M - a * C + h * _) * R, (n * C - i * M - s * _) * R, (p * b - g * w + v * T) * R, (c * w - u * b - d * T) * R, (a * A - r * M - h * S) * R, (e * M - n * A + s * S) * R, (g * x - f * b - v * y) * R, (l * b - c * x + d * y) * R, (r * C - o * A + h * E) * R, (i * A - e * C - s * E) * R, (f * w - p * x + v * m) * R, (u * x - l * w - d * m) * R, (o * S - r * _ - a * E) * R, (e * _ - i * S + n * E) * R, (p * y - f * T - g * m) * R, (l * T - u * y + c * m) * R)) : this;
                },
                adjoint: function() {
                    var t = this.val, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = t[6], h = t[7], l = t[8], u = t[9], c = t[10], d = t[11], f = t[12], p = t[13], g = t[14], v = t[15];
                    return this.setValues(o * (c * v - d * g) - u * (a * v - h * g) + p * (a * d - h * c), -(i * (c * v - d * g) - u * (n * v - s * g) + p * (n * d - s * c)), i * (a * v - h * g) - o * (n * v - s * g) + p * (n * h - s * a), -(i * (a * d - h * c) - o * (n * d - s * c) + u * (n * h - s * a)), -(r * (c * v - d * g) - l * (a * v - h * g) + f * (a * d - h * c)), e * (c * v - d * g) - l * (n * v - s * g) + f * (n * d - s * c), -(e * (a * v - h * g) - r * (n * v - s * g) + f * (n * h - s * a)), e * (a * d - h * c) - r * (n * d - s * c) + l * (n * h - s * a), r * (u * v - d * p) - l * (o * v - h * p) + f * (o * d - h * u), -(e * (u * v - d * p) - l * (i * v - s * p) + f * (i * d - s * u)), e * (o * v - h * p) - r * (i * v - s * p) + f * (i * h - s * o), -(e * (o * d - h * u) - r * (i * d - s * u) + l * (i * h - s * o)), -(r * (u * g - c * p) - l * (o * g - a * p) + f * (o * c - a * u)), e * (u * g - c * p) - l * (i * g - n * p) + f * (i * c - n * u), -(e * (o * g - a * p) - r * (i * g - n * p) + f * (i * a - n * o)), e * (o * c - a * u) - r * (i * c - n * u) + l * (i * a - n * o));
                },
                determinant: function() {
                    var t = this.val, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = t[6], h = t[7], l = t[8], u = t[9], c = t[10], d = t[11], f = t[12], p = t[13], g = t[14], v = t[15];
                    return (e * o - i * r) * (c * v - d * g) - (e * a - n * r) * (u * v - d * p) + (e * h - s * r) * (u * g - c * p) + (i * a - n * o) * (l * v - d * f) - (i * h - s * o) * (l * g - c * f) + (n * h - s * a) * (l * p - u * f);
                },
                multiply: function(t) {
                    var e = this.val, i = e[0], n = e[1], s = e[2], r = e[3], o = e[4], a = e[5], h = e[6], l = e[7], u = e[8], c = e[9], d = e[10], f = e[11], p = e[12], g = e[13], v = e[14], m = e[15], y = t.val, x = y[0], T = y[1], w = y[2], b = y[3];
                    return e[0] = x * i + T * o + w * u + b * p, e[1] = x * n + T * a + w * c + b * g, e[2] = x * s + T * h + w * d + b * v, e[3] = x * r + T * l + w * f + b * m, x = y[4], T = y[5], w = y[6], b = y[7], e[4] = x * i + T * o + w * u + b * p, e[5] = x * n + T * a + w * c + b * g, e[6] = x * s + T * h + w * d + b * v, e[7] = x * r + T * l + w * f + b * m, x = y[8], T = y[9], w = y[10], b = y[11], e[8] = x * i + T * o + w * u + b * p, e[9] = x * n + T * a + w * c + b * g, e[10] = x * s + T * h + w * d + b * v, e[11] = x * r + T * l + w * f + b * m, x = y[12], T = y[13], w = y[14], b = y[15], e[12] = x * i + T * o + w * u + b * p, e[13] = x * n + T * a + w * c + b * g, e[14] = x * s + T * h + w * d + b * v, e[15] = x * r + T * l + w * f + b * m, this;
                },
                multiplyLocal: function(t) {
                    var e = this.val, i = t.val;
                    return this.setValues(e[0] * i[0] + e[1] * i[4] + e[2] * i[8] + e[3] * i[12], e[0] * i[1] + e[1] * i[5] + e[2] * i[9] + e[3] * i[13], e[0] * i[2] + e[1] * i[6] + e[2] * i[10] + e[3] * i[14], e[0] * i[3] + e[1] * i[7] + e[2] * i[11] + e[3] * i[15], e[4] * i[0] + e[5] * i[4] + e[6] * i[8] + e[7] * i[12], e[4] * i[1] + e[5] * i[5] + e[6] * i[9] + e[7] * i[13], e[4] * i[2] + e[5] * i[6] + e[6] * i[10] + e[7] * i[14], e[4] * i[3] + e[5] * i[7] + e[6] * i[11] + e[7] * i[15], e[8] * i[0] + e[9] * i[4] + e[10] * i[8] + e[11] * i[12], e[8] * i[1] + e[9] * i[5] + e[10] * i[9] + e[11] * i[13], e[8] * i[2] + e[9] * i[6] + e[10] * i[10] + e[11] * i[14], e[8] * i[3] + e[9] * i[7] + e[10] * i[11] + e[11] * i[15], e[12] * i[0] + e[13] * i[4] + e[14] * i[8] + e[15] * i[12], e[12] * i[1] + e[13] * i[5] + e[14] * i[9] + e[15] * i[13], e[12] * i[2] + e[13] * i[6] + e[14] * i[10] + e[15] * i[14], e[12] * i[3] + e[13] * i[7] + e[14] * i[11] + e[15] * i[15]);
                },
                premultiply: function(t) {
                    return this.multiplyMatrices(t, this);
                },
                multiplyMatrices: function(t, e) {
                    var i = t.val, n = e.val, s = i[0], r = i[4], o = i[8], a = i[12], h = i[1], l = i[5], u = i[9], c = i[13], d = i[2], f = i[6], p = i[10], g = i[14], v = i[3], m = i[7], y = i[11], x = i[15], T = n[0], w = n[4], b = n[8], E = n[12], S = n[1], A = n[5], _ = n[9], C = n[13], M = n[2], R = n[6], P = n[10], O = n[14], L = n[3], D = n[7], F = n[11], k = n[15];
                    return this.setValues(s * T + r * S + o * M + a * L, h * T + l * S + u * M + c * L, d * T + f * S + p * M + g * L, v * T + m * S + y * M + x * L, s * w + r * A + o * R + a * D, h * w + l * A + u * R + c * D, d * w + f * A + p * R + g * D, v * w + m * A + y * R + x * D, s * b + r * _ + o * P + a * F, h * b + l * _ + u * P + c * F, d * b + f * _ + p * P + g * F, v * b + m * _ + y * P + x * F, s * E + r * C + o * O + a * k, h * E + l * C + u * O + c * k, d * E + f * C + p * O + g * k, v * E + m * C + y * O + x * k);
                },
                translate: function(t) {
                    return this.translateXYZ(t.x, t.y, t.z);
                },
                translateXYZ: function(t, e, i) {
                    var n = this.val;
                    return n[12] = n[0] * t + n[4] * e + n[8] * i + n[12], n[13] = n[1] * t + n[5] * e + n[9] * i + n[13], n[14] = n[2] * t + n[6] * e + n[10] * i + n[14], n[15] = n[3] * t + n[7] * e + n[11] * i + n[15], this;
                },
                scale: function(t) {
                    return this.scaleXYZ(t.x, t.y, t.z);
                },
                scaleXYZ: function(t, e, i) {
                    var n = this.val;
                    return n[0] = n[0] * t, n[1] = n[1] * t, n[2] = n[2] * t, n[3] = n[3] * t, n[4] = n[4] * e, n[5] = n[5] * e, n[6] = n[6] * e, n[7] = n[7] * e, n[8] = n[8] * i, n[9] = n[9] * i, n[10] = n[10] * i, n[11] = n[11] * i, this;
                },
                makeRotationAxis: function(t, e) {
                    var i = Math.cos(e), n = Math.sin(e), s = 1 - i, r = t.x, o = t.y, a = t.z, h = s * r, l = s * o;
                    return this.setValues(h * r + i, h * o - n * a, h * a + n * o, 0, h * o + n * a, l * o + i, l * a - n * r, 0, h * a - n * o, l * a + n * r, s * a * a + i, 0, 0, 0, 0, 1);
                },
                rotate: function(t, e) {
                    var i = this.val, n = e.x, s = e.y, r = e.z, o = Math.sqrt(n * n + s * s + r * r);
                    if (Math.abs(o) < 1e-6) return this;
                    n *= o = 1 / o, s *= o, r *= o;
                    var a = Math.sin(t), h = Math.cos(t), l = 1 - h, u = i[0], c = i[1], d = i[2], f = i[3], p = i[4], g = i[5], v = i[6], m = i[7], y = i[8], x = i[9], T = i[10], w = i[11], b = i[12], E = i[13], S = i[14], A = i[15], _ = n * n * l + h, C = s * n * l + r * a, M = r * n * l - s * a, R = n * s * l - r * a, P = s * s * l + h, O = r * s * l + n * a, L = n * r * l + s * a, D = s * r * l - n * a, F = r * r * l + h;
                    return this.setValues(u * _ + p * C + y * M, c * _ + g * C + x * M, d * _ + v * C + T * M, f * _ + m * C + w * M, u * R + p * P + y * O, c * R + g * P + x * O, d * R + v * P + T * O, f * R + m * P + w * O, u * L + p * D + y * F, c * L + g * D + x * F, d * L + v * D + T * F, f * L + m * D + w * F, b, E, S, A);
                },
                rotateX: function(t) {
                    var e = this.val, i = Math.sin(t), n = Math.cos(t), s = e[4], r = e[5], o = e[6], a = e[7], h = e[8], l = e[9], u = e[10], c = e[11];
                    return e[4] = s * n + h * i, e[5] = r * n + l * i, e[6] = o * n + u * i, e[7] = a * n + c * i, e[8] = h * n - s * i, e[9] = l * n - r * i, e[10] = u * n - o * i, e[11] = c * n - a * i, this;
                },
                rotateY: function(t) {
                    var e = this.val, i = Math.sin(t), n = Math.cos(t), s = e[0], r = e[1], o = e[2], a = e[3], h = e[8], l = e[9], u = e[10], c = e[11];
                    return e[0] = s * n - h * i, e[1] = r * n - l * i, e[2] = o * n - u * i, e[3] = a * n - c * i, e[8] = s * i + h * n, e[9] = r * i + l * n, e[10] = o * i + u * n, e[11] = a * i + c * n, this;
                },
                rotateZ: function(t) {
                    var e = this.val, i = Math.sin(t), n = Math.cos(t), s = e[0], r = e[1], o = e[2], a = e[3], h = e[4], l = e[5], u = e[6], c = e[7];
                    return e[0] = s * n + h * i, e[1] = r * n + l * i, e[2] = o * n + u * i, e[3] = a * n + c * i, e[4] = h * n - s * i, e[5] = l * n - r * i, e[6] = u * n - o * i, e[7] = c * n - a * i, this;
                },
                fromRotationTranslation: function(t, e) {
                    var i = t.x, n = t.y, s = t.z, r = t.w, o = i + i, a = n + n, h = s + s, l = i * o, u = i * a, c = i * h, d = n * a, f = n * h, p = s * h, g = r * o, v = r * a, m = r * h;
                    return this.setValues(1 - (d + p), u + m, c - v, 0, u - m, 1 - (l + p), f + g, 0, c + v, f - g, 1 - (l + d), 0, e.x, e.y, e.z, 1);
                },
                fromQuat: function(t) {
                    var e = t.x, i = t.y, n = t.z, s = t.w, r = e + e, o = i + i, a = n + n, h = e * r, l = e * o, u = e * a, c = i * o, d = i * a, f = n * a, p = s * r, g = s * o, v = s * a;
                    return this.setValues(1 - (c + f), l + v, u - g, 0, l - v, 1 - (h + f), d + p, 0, u + g, d - p, 1 - (h + c), 0, 0, 0, 0, 1);
                },
                frustum: function(t, e, i, n, s, r) {
                    var o = 1 / (e - t), a = 1 / (n - i), h = 1 / (s - r);
                    return this.setValues(2 * s * o, 0, 0, 0, 0, 2 * s * a, 0, 0, (e + t) * o, (n + i) * a, (r + s) * h, -1, 0, 0, r * s * 2 * h, 0);
                },
                perspective: function(t, e, i, n) {
                    var s = 1 / Math.tan(t / 2), r = 1 / (i - n);
                    return this.setValues(s / e, 0, 0, 0, 0, s, 0, 0, 0, 0, (n + i) * r, -1, 0, 0, 2 * n * i * r, 0);
                },
                perspectiveLH: function(t, e, i, n) {
                    return this.setValues(2 * i / t, 0, 0, 0, 0, 2 * i / e, 0, 0, 0, 0, -n / (i - n), 1, 0, 0, i * n / (i - n), 0);
                },
                ortho: function(t, e, i, n, s, r) {
                    var o = 0 === (o = t - e) ? o : 1 / o, a = 0 === (a = i - n) ? a : 1 / a, h = 0 === (h = s - r) ? h : 1 / h;
                    return this.setValues(-2 * o, 0, 0, 0, 0, -2 * a, 0, 0, 0, 0, 2 * h, 0, (t + e) * o, (n + i) * a, (r + s) * h, 1);
                },
                lookAtRH: function(t, e, i) {
                    var n = this.val;
                    return u.subVectors(t, e), 0 === u.getLengthSquared() && (u.z = 1), u.normalize(), o.crossVectors(i, u), 0 === o.getLengthSquared() && (1 === Math.abs(i.z) ? u.x += 1e-4 : u.z += 1e-4, u.normalize(), o.crossVectors(i, u)), o.normalize(), a.crossVectors(u, o), n[0] = o.x, n[1] = o.y, n[2] = o.z, n[4] = a.x, n[5] = a.y, n[6] = a.z, n[8] = u.x, n[9] = u.y, n[10] = u.z, this;
                },
                lookAt: function(t, e, i) {
                    var n = t.x, s = t.y, r = t.z, o = i.x, a = i.y, h = i.z, l = e.x, u = e.y, c = e.z;
                    if (Math.abs(n - l) < 1e-6 && Math.abs(s - u) < 1e-6 && Math.abs(r - c) < 1e-6) return this.identity();
                    var d = n - l, f = s - u, p = r - c, g = 1 / Math.sqrt(d * d + f * f + p * p), v = a * (p *= g) - h * (f *= g), m = h * (d *= g) - o * p, y = o * f - a * d;
                    (g = Math.sqrt(v * v + m * m + y * y)) ? (v *= g = 1 / g, m *= g, y *= g) : y = m = v = 0;
                    var x = f * y - p * m, T = p * v - d * y, w = d * m - f * v;
                    return (g = Math.sqrt(x * x + T * T + w * w)) ? (x *= g = 1 / g, T *= g, w *= g) : w = T = x = 0, this.setValues(v, x, d, 0, m, T, f, 0, y, w, p, 0, -(v * n + m * s + y * r), -(x * n + T * s + w * r), -(d * n + f * s + p * r), 1);
                },
                yawPitchRoll: function(t, e, i) {
                    this.zero(), h.zero(), l.zero();
                    var n = this.val, s = h.val, r = l.val, o = Math.sin(i), a = Math.cos(i);
                    return n[10] = 1, n[15] = 1, n[0] = a, n[1] = o, n[4] = -o, n[5] = a, o = Math.sin(e), a = Math.cos(e), s[0] = 1, s[15] = 1, s[5] = a, s[10] = a, s[9] = -o, s[6] = o, o = Math.sin(t), a = Math.cos(t), r[5] = 1, r[15] = 1, r[0] = a, r[2] = -o, r[8] = o, r[10] = a, this.multiplyLocal(h), this.multiplyLocal(l), this;
                },
                setWorldMatrix: function(t, e, i, n, s) {
                    return this.yawPitchRoll(t.y, t.x, t.z), h.scaling(i.x, i.y, i.z), l.xyz(e.x, e.y, e.z), this.multiplyLocal(h), this.multiplyLocal(l), n && this.multiplyLocal(n), s && this.multiplyLocal(s), this;
                },
                multiplyToMat4: function(t, e) {
                    var i = this.val, n = t.val, s = i[0], r = i[1], o = i[2], a = i[3], h = i[4], l = i[5], u = i[6], c = i[7], d = i[8], f = i[9], p = i[10], g = i[11], v = i[12], m = i[13], y = i[14], x = i[15], T = n[0], w = n[1], b = n[2], E = n[3], S = n[4], A = n[5], _ = n[6], C = n[7], M = n[8], R = n[9], P = n[10], O = n[11], L = n[12], D = n[13], F = n[14], k = n[15];
                    return e.setValues(T * s + w * h + b * d + E * v, w * r + w * l + b * f + E * m, b * o + w * u + b * p + E * y, E * a + w * c + b * g + E * x, S * s + A * h + _ * d + C * v, S * r + A * l + _ * f + C * m, S * o + A * u + _ * p + C * y, S * a + A * c + _ * g + C * x, M * s + R * h + P * d + O * v, M * r + R * l + P * f + O * m, M * o + R * u + P * p + O * y, M * a + R * c + P * g + O * x, L * s + D * h + F * d + k * v, L * r + D * l + F * f + k * m, L * o + D * u + F * p + k * y, L * a + D * c + F * g + k * x);
                },
                fromRotationXYTranslation: function(t, e, i) {
                    var n = e.x, s = e.y, r = e.z, o = Math.sin(t.x), a = Math.cos(t.x), h = Math.sin(t.y), l = Math.cos(t.y), u = n, c = s, d = r, f = -o, p = 0 - f * h, g = 0 - a * h, v = f * l, m = a * l;
                    return i || (u = l * n + h * r, c = p * n + a * s + v * r, d = g * n + o * s + m * r), this.setValues(l, p, g, 0, 0, a, o, 0, h, v, m, 0, u, c, d, 1);
                },
                getMaxScaleOnAxis: function() {
                    var t = this.val, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], i = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], n = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
                    return Math.sqrt(Math.max(e, i, n));
                }
            }), h = new r, l = new r, o = new s, a = new s, u = new s;
            t.exports = r;
        },
        function(t, e, i) {
            "use strict";
            function n(t, e, i) {
                i = i || 2;
                var n, s, r, o, a, h, l, u = e && e.length, c = u ? e[0] * i : t.length, d = g(t, 0, c, i, !0), f = [];
                if (!d || d.next === d.prev) return f;
                if (u && (d = function(t, e, i, n) {
                    var s, r, o, a, h, l = [];
                    for(s = 0, r = e.length; s < r; s++)o = e[s] * n, a = s < r - 1 ? e[s + 1] * n : t.length, (h = g(t, o, a, n, !1)) === h.next && (h.steiner = !0), l.push(function(t) {
                        var e = t, i = t;
                        for(; (e.x < i.x || e.x === i.x && e.y < i.y) && (i = e), e = e.next, e !== t;);
                        return i;
                    }(h));
                    for(l.sort(y), s = 0; s < l.length; s++)!function(t, e) {
                        var i;
                        (e = function(t, e) {
                            var i, n = e, s = t.x, r = t.y, o = -1 / 0;
                            do {
                                if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                                    var a = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                                    if (a <= s && o < a) {
                                        if ((o = a) === s) {
                                            if (r === n.y) return n;
                                            if (r === n.next.y) return n.next;
                                        }
                                        i = n.x < n.next.x ? n : n.next;
                                    }
                                }
                                n = n.next;
                            }while (n !== e);
                            if (!i) return null;
                            if (s === o) return i;
                            var h, l = i, u = i.x, c = i.y, d = 1 / 0;
                            n = i;
                            for(; s >= n.x && n.x >= u && s !== n.x && T(r < c ? s : o, r, u, c, r < c ? o : s, r, n.x, n.y) && (h = Math.abs(r - n.y) / (s - n.x), b(n, t) && (h < d || h === d && (n.x > i.x || n.x === i.x && function(t, e) {
                                return w(t.prev, t, e.prev) < 0 && w(e.next, t, t.next) < 0;
                            }(i, n))) && (i = n, d = h)), n = n.next, n !== l;);
                            return i;
                        }(t, e)) && (i = E(e, t), v(e, e.next), v(i, i.next));
                    }(l[s], i), i = v(i, i.next);
                    return i;
                }(t, e, d, i)), t.length > 80 * i) {
                    n = r = t[0], s = o = t[1];
                    for(var p = i; p < c; p += i)(a = t[p]) < n && (n = a), (h = t[p + 1]) < s && (s = h), r < a && (r = a), o < h && (o = h);
                    l = 0 !== (l = Math.max(r - n, o - s)) ? 1 / l : 0;
                }
                return m(d, f, i, n, s, l), f;
            }
            function g(t, e, i, n, s) {
                var r, o;
                if (s === 0 < S(t, e, i, n)) for(r = e; r < i; r += n)o = a(r, t[r], t[r + 1], o);
                else for(r = i - n; e <= r; r -= n)o = a(r, t[r], t[r + 1], o);
                return o && u(o, o.next) && (d(o), o = o.next), o;
            }
            function v(t, e) {
                if (!t) return t;
                e = e || t;
                var i, n = t;
                do if (i = !1, n.steiner || !u(n, n.next) && 0 !== w(n.prev, n, n.next)) n = n.next;
                else {
                    if (d(n), (n = e = n.prev) === n.next) break;
                    i = !0;
                }
                while (i || n !== e);
                return e;
            }
            function m(t, e, i, n, s, r, o) {
                if (t) {
                    !o && r && function(t, e, i, n) {
                        var s = t;
                        for(; null === s.z && (s.z = x(s.x, s.y, e, i, n)), s.prevZ = s.prev, s.nextZ = s.next, s = s.next, s !== t;);
                        s.prevZ.nextZ = null, s.prevZ = null, function(t) {
                            var e, i, n, s, r, o, a, h, l = 1;
                            do {
                                for(i = t, r = t = null, o = 0; i;){
                                    for(o++, n = i, e = a = 0; e < l && (a++, n = n.nextZ); e++);
                                    for(h = l; 0 < a || 0 < h && n;)0 !== a && (0 === h || !n || i.z <= n.z) ? (i = (s = i).nextZ, a--) : (n = (s = n).nextZ, h--), r ? r.nextZ = s : t = s, s.prevZ = r, r = s;
                                    i = n;
                                }
                                r.nextZ = null, l *= 2;
                            }while (1 < o);
                        }(s);
                    }(t, n, s, r);
                    for(var a, h, l = t; t.prev !== t.next;)if (a = t.prev, h = t.next, r ? function(t, e, i, n) {
                        var s = t.prev, r = t, o = t.next;
                        if (0 <= w(s, r, o)) return !1;
                        var a = s.x < r.x ? s.x < o.x ? s.x : o.x : r.x < o.x ? r.x : o.x, h = s.y < r.y ? s.y < o.y ? s.y : o.y : r.y < o.y ? r.y : o.y, l = s.x > r.x ? s.x > o.x ? s.x : o.x : r.x > o.x ? r.x : o.x, u = s.y > r.y ? s.y > o.y ? s.y : o.y : r.y > o.y ? r.y : o.y, c = x(a, h, e, i, n), d = x(l, u, e, i, n), f = t.prevZ, p = t.nextZ;
                        for(; f && f.z >= c && p && p.z <= d;){
                            if (f !== t.prev && f !== t.next && T(s.x, s.y, r.x, r.y, o.x, o.y, f.x, f.y) && 0 <= w(f.prev, f, f.next)) return !1;
                            if (f = f.prevZ, p !== t.prev && p !== t.next && T(s.x, s.y, r.x, r.y, o.x, o.y, p.x, p.y) && 0 <= w(p.prev, p, p.next)) return !1;
                            p = p.nextZ;
                        }
                        for(; f && f.z >= c;){
                            if (f !== t.prev && f !== t.next && T(s.x, s.y, r.x, r.y, o.x, o.y, f.x, f.y) && 0 <= w(f.prev, f, f.next)) return !1;
                            f = f.prevZ;
                        }
                        for(; p && p.z <= d;){
                            if (p !== t.prev && p !== t.next && T(s.x, s.y, r.x, r.y, o.x, o.y, p.x, p.y) && 0 <= w(p.prev, p, p.next)) return !1;
                            p = p.nextZ;
                        }
                        return !0;
                    }(t, n, s, r) : function(t) {
                        var e = t.prev, i = t, n = t.next;
                        if (0 <= w(e, i, n)) return !1;
                        var s = t.next.next;
                        for(; s !== t.prev;){
                            if (T(e.x, e.y, i.x, i.y, n.x, n.y, s.x, s.y) && 0 <= w(s.prev, s, s.next)) return !1;
                            s = s.next;
                        }
                        return !0;
                    }(t)) e.push(a.i / i), e.push(t.i / i), e.push(h.i / i), d(t), t = h.next, l = h.next;
                    else if ((t = h) === l) {
                        o ? 1 === o ? m(t = function(t, e, i) {
                            var n = t;
                            do {
                                var s = n.prev, r = n.next.next;
                                !u(s, r) && c(s, n, n.next, r) && b(s, r) && b(r, s) && (e.push(s.i / i), e.push(n.i / i), e.push(r.i / i), d(n), d(n.next), n = t = r), n = n.next;
                            }while (n !== t);
                            return v(n);
                        }(v(t), e, i), e, i, n, s, r, 2) : 2 === o && function(t, e, i, n, s, r) {
                            var o = t;
                            do {
                                for(var a = o.next.next; a !== o.prev;){
                                    if (o.i !== a.i && function(t, e) {
                                        return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
                                            var i = t;
                                            do {
                                                if (i.i !== t.i && i.next.i !== t.i && i.i !== e.i && i.next.i !== e.i && c(i, i.next, t, e)) return !0;
                                                i = i.next;
                                            }while (i !== t);
                                            return !1;
                                        }(t, e) && (b(t, e) && b(e, t) && function(t, e) {
                                            var i = t, n = !1, s = (t.x + e.x) / 2, r = (t.y + e.y) / 2;
                                            for(; i.y > r != i.next.y > r && i.next.y !== i.y && s < (i.next.x - i.x) * (r - i.y) / (i.next.y - i.y) + i.x && (n = !n), i = i.next, i !== t;);
                                            return n;
                                        }(t, e) && (w(t.prev, t, e.prev) || w(t, e.prev, e)) || u(t, e) && 0 < w(t.prev, t, t.next) && 0 < w(e.prev, e, e.next));
                                    }(o, a)) {
                                        var h = E(o, a);
                                        return o = v(o, o.next), h = v(h, h.next), m(o, e, i, n, s, r), m(h, e, i, n, s, r);
                                    }
                                    a = a.next;
                                }
                                o = o.next;
                            }while (o !== t);
                        }(t, e, i, n, s, r) : m(v(t), e, i, n, s, r, 1);
                        break;
                    }
                }
            }
            function y(t, e) {
                return t.x - e.x;
            }
            function x(t, e, i, n, s) {
                return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - i) * s) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - n) * s) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
            }
            function T(t, e, i, n, s, r, o, a) {
                return 0 <= (s - o) * (e - a) - (t - o) * (r - a) && 0 <= (t - o) * (n - a) - (i - o) * (e - a) && 0 <= (i - o) * (r - a) - (s - o) * (n - a);
            }
            function w(t, e, i) {
                return (e.y - t.y) * (i.x - e.x) - (e.x - t.x) * (i.y - e.y);
            }
            function u(t, e) {
                return t.x === e.x && t.y === e.y;
            }
            function c(t, e, i, n) {
                var s = l(w(t, e, i)), r = l(w(t, e, n)), o = l(w(i, n, t)), a = l(w(i, n, e));
                return s !== r && o !== a || 0 === s && h(t, i, e) || 0 === r && h(t, n, e) || 0 === o && h(i, t, n) || !(0 !== a || !h(i, e, n));
            }
            function h(t, e, i) {
                return e.x <= Math.max(t.x, i.x) && e.x >= Math.min(t.x, i.x) && e.y <= Math.max(t.y, i.y) && e.y >= Math.min(t.y, i.y);
            }
            function l(t) {
                return 0 < t ? 1 : t < 0 ? -1 : 0;
            }
            function b(t, e) {
                return w(t.prev, t, t.next) < 0 ? 0 <= w(t, e, t.next) && 0 <= w(t, t.prev, e) : w(t, e, t.prev) < 0 || w(t, t.next, e) < 0;
            }
            function E(t, e) {
                var i = new o(t.i, t.x, t.y), n = new o(e.i, e.x, e.y), s = t.next, r = e.prev;
                return (t.next = e).prev = t, (i.next = s).prev = i, (n.next = i).prev = n, (r.next = n).prev = r, n;
            }
            function a(t, e, i, n) {
                var s = new o(t, e, i);
                return n ? (s.next = n.next, (s.prev = n).next.prev = s, n.next = s) : (s.prev = s).next = s, s;
            }
            function d(t) {
                t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
            }
            function o(t, e, i) {
                this.i = t, this.x = e, this.y = i, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
            }
            function S(t, e, i, n) {
                for(var s = 0, r = e, o = i - n; r < i; r += n)s += (t[o] - t[r]) * (t[r + 1] + t[o + 1]), o = r;
                return s;
            }
            n.deviation = function(t, e, i, n) {
                var s = e && e.length, r = s ? e[0] * i : t.length, o = Math.abs(S(t, 0, r, i));
                if (s) for(var a = 0, h = e.length; a < h; a++){
                    var l = e[a] * i, u = a < h - 1 ? e[a + 1] * i : t.length;
                    o -= Math.abs(S(t, l, u, i));
                }
                for(var c = 0, a = 0; a < n.length; a += 3){
                    var d = n[a] * i, f = n[a + 1] * i, p = n[a + 2] * i;
                    c += Math.abs((t[d] - t[p]) * (t[1 + f] - t[1 + d]) - (t[d] - t[f]) * (t[1 + p] - t[1 + d]));
                }
                return 0 === o && 0 === c ? 0 : Math.abs((c - o) / o);
            }, n.flatten = function(t) {
                for(var e = t[0][0].length, i = {
                    vertices: [],
                    holes: [],
                    dimensions: e
                }, n = 0, s = 0; s < t.length; s++){
                    for(var r = 0; r < t[s].length; r++)for(var o = 0; o < e; o++)i.vertices.push(t[s][r][o]);
                    0 < s && (n += t[s - 1].length, i.holes.push(n));
                }
                return i;
            }, t.exports = n;
        },
        function(t, e, i) {
            t.exports = {
                COMPLETE: i(983),
                DECODED: i(984),
                DECODED_ALL: i(985),
                DESTROY: i(986),
                DETUNE: i(987),
                GLOBAL_DETUNE: i(988),
                GLOBAL_MUTE: i(989),
                GLOBAL_RATE: i(990),
                GLOBAL_VOLUME: i(991),
                LOOP: i(992),
                LOOPED: i(993),
                MUTE: i(994),
                PAN: i(995),
                PAUSE_ALL: i(996),
                PAUSE: i(997),
                PLAY: i(998),
                RATE: i(999),
                RESUME_ALL: i(1e3),
                RESUME: i(1001),
                SEEK: i(1002),
                STOP_ALL: i(1003),
                STOP: i(1004),
                UNLOCKED: i(1005),
                VOLUME: i(1006)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(20), c = i(23), r = i(8), d = i(2), f = i(7), o = new n({
                Extends: c,
                initialize: function t(e, i, n, s, r) {
                    var o, a, h = "png";
                    f(i) && (i = d(a = i, "key"), n = d(a, "url"), o = d(a, "normalMap"), s = d(a, "xhrSettings"), h = d(a, "extension", h), r = d(a, "frameConfig")), Array.isArray(n) && (o = n[1], n = n[0]);
                    var l, u = {
                        type: "image",
                        cache: e.textureManager,
                        extension: h,
                        responseType: "blob",
                        key: i,
                        url: n,
                        xhrSettings: s,
                        config: r
                    };
                    c.call(this, e, u), o && ((l = new t(e, this.key, o, s, r)).type = "normalMap", this.setLink(l), e.addFile(l));
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = new Image, this.data.crossOrigin = this.crossOrigin;
                    var t = this;
                    this.data.onload = function() {
                        c.revokeObjectURL(t.data), t.onProcessComplete();
                    }, this.data.onerror = function() {
                        c.revokeObjectURL(t.data), t.onProcessError();
                    }, c.createObjectURL(this.data, this.xhrLoader.response, "image/png");
                },
                addToCache: function() {
                    var t, e = this.linkFile;
                    e && e.state === s.FILE_COMPLETE ? (t = "image" === this.type ? this.cache.addImage(this.key, this.data, e.data) : this.cache.addImage(e.key, e.data, this.data), this.pendingDestroy(t), e.pendingDestroy(t)) : e || (t = this.cache.addImage(this.key, this.data), this.pendingDestroy(t));
                }
            });
            r.register("image", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var p = {};
            t.exports = p;
            var g = i(94), u = i(116), s = i(267), r = i(50), v = i(117), c = i(585);
            !function() {
                p._inertiaScale = 4, p._nextCollidingGroupId = 1, p._nextNonCollidingGroupId = -1, p._nextCategory = 1, p.create = function(t) {
                    var e = {
                        id: r.nextId(),
                        type: "body",
                        label: "Body",
                        parts: [],
                        plugin: {},
                        angle: 0,
                        vertices: null,
                        position: {
                            x: 0,
                            y: 0
                        },
                        force: {
                            x: 0,
                            y: 0
                        },
                        torque: 0,
                        positionImpulse: {
                            x: 0,
                            y: 0
                        },
                        previousPositionImpulse: {
                            x: 0,
                            y: 0
                        },
                        constraintImpulse: {
                            x: 0,
                            y: 0,
                            angle: 0
                        },
                        totalContacts: 0,
                        speed: 0,
                        angularSpeed: 0,
                        velocity: {
                            x: 0,
                            y: 0
                        },
                        angularVelocity: 0,
                        isSensor: !1,
                        isStatic: !1,
                        isSleeping: !1,
                        motion: 0,
                        sleepThreshold: 60,
                        density: .001,
                        restitution: 0,
                        friction: .1,
                        frictionStatic: .5,
                        frictionAir: .01,
                        collisionFilter: {
                            category: 1,
                            mask: 4294967295,
                            group: 0
                        },
                        slop: .05,
                        timeScale: 1,
                        events: null,
                        bounds: null,
                        chamfer: null,
                        circleRadius: 0,
                        positionPrev: null,
                        anglePrev: 0,
                        parent: null,
                        axes: null,
                        area: 0,
                        mass: 0,
                        inverseMass: 0,
                        inertia: 0,
                        inverseInertia: 0,
                        _original: null,
                        render: {
                            visible: !0,
                            opacity: 1,
                            sprite: {
                                xOffset: 0,
                                yOffset: 0
                            },
                            fillColor: null,
                            fillOpacity: null,
                            lineColor: null,
                            lineOpacity: null,
                            lineThickness: null
                        },
                        gameObject: null,
                        scale: {
                            x: 1,
                            y: 1
                        },
                        centerOfMass: {
                            x: 0,
                            y: 0
                        },
                        centerOffset: {
                            x: 0,
                            y: 0
                        },
                        gravityScale: {
                            x: 1,
                            y: 1
                        },
                        ignoreGravity: !1,
                        ignorePointer: !1,
                        onCollideCallback: null,
                        onCollideEndCallback: null,
                        onCollideActiveCallback: null,
                        onCollideWith: {}
                    };
                    !t.hasOwnProperty("position") && t.hasOwnProperty("vertices") ? t.position = g.centre(t.vertices) : t.hasOwnProperty("vertices") || (e.vertices = g.fromPath("L 0 0 L 40 0 L 40 40 L 0 40"));
                    var i = r.extend(e, t);
                    return n(i, t), i.setOnCollideWith = function(t, e) {
                        return e ? this.onCollideWith[t.id] = e : delete this.onCollideWith[t.id], this;
                    }, i;
                }, p.nextGroup = function(t) {
                    return t ? p._nextNonCollidingGroupId-- : p._nextCollidingGroupId++;
                }, p.nextCategory = function() {
                    return p._nextCategory = p._nextCategory << 1, p._nextCategory;
                };
                var n = function(t, e) {
                    e = e || {}, p.set(t, {
                        bounds: t.bounds || v.create(t.vertices),
                        positionPrev: t.positionPrev || u.clone(t.position),
                        anglePrev: t.anglePrev || t.angle,
                        vertices: t.vertices,
                        parts: t.parts || [
                            t
                        ],
                        isStatic: t.isStatic,
                        isSleeping: t.isSleeping,
                        parent: t.parent || t
                    });
                    var i, n, s, r, o = t.bounds;
                    g.rotate(t.vertices, t.angle, t.position), c.rotate(t.axes, t.angle), v.update(o, t.vertices, t.velocity), p.set(t, {
                        axes: e.axes || t.axes,
                        area: e.area || t.area,
                        mass: e.mass || t.mass,
                        inertia: e.inertia || t.inertia
                    }), 1 === t.parts.length && (i = t.centerOfMass, n = t.centerOffset, s = o.max.x - o.min.x, r = o.max.y - o.min.y, i.x = -(o.min.x - t.position.x) / s, i.y = -(o.min.y - t.position.y) / r, n.x = s * i.x, n.y = r * i.y);
                };
                p.set = function(t, e, i) {
                    var n;
                    for(n in "string" == typeof e && (n = e, (e = {})[n] = i), e)if (Object.prototype.hasOwnProperty.call(e, n)) switch(i = e[n], n){
                        case "isStatic":
                            p.setStatic(t, i);
                            break;
                        case "isSleeping":
                            s.set(t, i);
                            break;
                        case "mass":
                            p.setMass(t, i);
                            break;
                        case "density":
                            p.setDensity(t, i);
                            break;
                        case "inertia":
                            p.setInertia(t, i);
                            break;
                        case "vertices":
                            p.setVertices(t, i);
                            break;
                        case "position":
                            p.setPosition(t, i);
                            break;
                        case "angle":
                            p.setAngle(t, i);
                            break;
                        case "velocity":
                            p.setVelocity(t, i);
                            break;
                        case "angularVelocity":
                            p.setAngularVelocity(t, i);
                            break;
                        case "parts":
                            p.setParts(t, i);
                            break;
                        case "centre":
                            p.setCentre(t, i);
                            break;
                        default:
                            t[n] = i;
                    }
                }, p.setStatic = function(t, e) {
                    for(var i = 0; i < t.parts.length; i++){
                        var n = t.parts[i];
                        (n.isStatic = e) ? (n._original = {
                            restitution: n.restitution,
                            friction: n.friction,
                            mass: n.mass,
                            inertia: n.inertia,
                            density: n.density,
                            inverseMass: n.inverseMass,
                            inverseInertia: n.inverseInertia
                        }, n.restitution = 0, n.friction = 1, n.mass = n.inertia = n.density = 1 / 0, n.inverseMass = n.inverseInertia = 0, n.positionPrev.x = n.position.x, n.positionPrev.y = n.position.y, n.anglePrev = n.angle, n.angularVelocity = 0, n.speed = 0, n.angularSpeed = 0, n.motion = 0) : n._original && (n.restitution = n._original.restitution, n.friction = n._original.friction, n.mass = n._original.mass, n.inertia = n._original.inertia, n.density = n._original.density, n.inverseMass = n._original.inverseMass, n.inverseInertia = n._original.inverseInertia, n._original = null);
                    }
                }, p.setMass = function(t, e) {
                    var i = t.inertia / (t.mass / 6);
                    t.inertia = e / 6 * i, t.inverseInertia = 1 / t.inertia, t.mass = e, t.inverseMass = 1 / t.mass, t.density = t.mass / t.area;
                }, p.setDensity = function(t, e) {
                    p.setMass(t, e * t.area), t.density = e;
                }, p.setInertia = function(t, e) {
                    t.inertia = e, t.inverseInertia = 1 / t.inertia;
                }, p.setVertices = function(t, e) {
                    e[0].body === t ? t.vertices = e : t.vertices = g.create(e, t), t.axes = c.fromVertices(t.vertices), t.area = g.area(t.vertices), p.setMass(t, t.density * t.area);
                    var i = g.centre(t.vertices);
                    g.translate(t.vertices, i, -1), p.setInertia(t, p._inertiaScale * g.inertia(t.vertices, t.mass)), g.translate(t.vertices, t.position), v.update(t.bounds, t.vertices, t.velocity);
                }, p.setParts = function(t, e, i) {
                    for(e = e.slice(0), t.parts.length = 0, t.parts.push(t), t.parent = t, r = 0; r < e.length; r++){
                        var n = e[r];
                        n !== t && (n.parent = t).parts.push(n);
                    }
                    if (1 !== t.parts.length) {
                        if (i = void 0 === i || i) {
                            for(var s = [], r = 0; r < e.length; r++)s = s.concat(e[r].vertices);
                            g.clockwiseSort(s);
                            var o = g.hull(s), a = g.centre(o);
                            p.setVertices(t, o), g.translate(t.vertices, a);
                        }
                        var h = p._totalProperties(t), l = h.centre.x, u = h.centre.y, c = t.bounds, d = t.centerOfMass, f = t.centerOffset;
                        v.update(c, t.vertices, t.velocity), d.x = -(c.min.x - l) / (c.max.x - c.min.x), d.y = -(c.min.y - u) / (c.max.y - c.min.y), f.x = l, f.y = u, t.area = h.area, (t.parent = t).position.x = l, t.position.y = u, t.positionPrev.x = l, t.positionPrev.y = u, p.setMass(t, h.mass), p.setInertia(t, h.inertia), p.setPosition(t, h.centre);
                    }
                }, p.setCentre = function(t, e, i) {
                    i ? (t.positionPrev.x += e.x, t.positionPrev.y += e.y, t.position.x += e.x, t.position.y += e.y) : (t.positionPrev.x = e.x - (t.position.x - t.positionPrev.x), t.positionPrev.y = e.y - (t.position.y - t.positionPrev.y), t.position.x = e.x, t.position.y = e.y);
                }, p.setPosition = function(t, e) {
                    var i = u.sub(e, t.position);
                    t.positionPrev.x += i.x, t.positionPrev.y += i.y;
                    for(var n = 0; n < t.parts.length; n++){
                        var s = t.parts[n];
                        s.position.x += i.x, s.position.y += i.y, g.translate(s.vertices, i), v.update(s.bounds, s.vertices, t.velocity);
                    }
                }, p.setAngle = function(t, e) {
                    var i = e - t.angle;
                    t.anglePrev += i;
                    for(var n = 0; n < t.parts.length; n++){
                        var s = t.parts[n];
                        s.angle += i, g.rotate(s.vertices, i, t.position), c.rotate(s.axes, i), v.update(s.bounds, s.vertices, t.velocity), 0 < n && u.rotateAbout(s.position, i, t.position, s.position);
                    }
                }, p.setVelocity = function(t, e) {
                    t.positionPrev.x = t.position.x - e.x, t.positionPrev.y = t.position.y - e.y, t.velocity.x = e.x, t.velocity.y = e.y, t.speed = u.magnitude(t.velocity);
                }, p.setAngularVelocity = function(t, e) {
                    t.anglePrev = t.angle - e, t.angularVelocity = e, t.angularSpeed = Math.abs(t.angularVelocity);
                }, p.translate = function(t, e) {
                    p.setPosition(t, u.add(t.position, e));
                }, p.rotate = function(t, e, i) {
                    var n, s, r, o;
                    i && (n = Math.cos(e), s = Math.sin(e), r = t.position.x - i.x, o = t.position.y - i.y, p.setPosition(t, {
                        x: i.x + (r * n - o * s),
                        y: i.y + (r * s + o * n)
                    })), p.setAngle(t, t.angle + e);
                }, p.scale = function(t, e, i, n) {
                    var s = 0, r = 0;
                    n = n || t.position;
                    for(var o = 0; o < t.parts.length; o++){
                        var a = t.parts[o];
                        a.scale.x = e, a.scale.y = i, g.scale(a.vertices, e, i, n), a.axes = c.fromVertices(a.vertices), a.area = g.area(a.vertices), p.setMass(a, t.density * a.area), g.translate(a.vertices, {
                            x: -a.position.x,
                            y: -a.position.y
                        }), p.setInertia(a, p._inertiaScale * g.inertia(a.vertices, a.mass)), g.translate(a.vertices, {
                            x: a.position.x,
                            y: a.position.y
                        }), 0 < o && (s += a.area, r += a.inertia), a.position.x = n.x + (a.position.x - n.x) * e, a.position.y = n.y + (a.position.y - n.y) * i, v.update(a.bounds, a.vertices, t.velocity);
                    }
                    1 < t.parts.length && (t.area = s, t.isStatic || (p.setMass(t, t.density * s), p.setInertia(t, r))), t.circleRadius && (e === i ? t.circleRadius *= e : t.circleRadius = null);
                }, p.update = function(t, e, i, n) {
                    var s = Math.pow(e * i * t.timeScale, 2), r = 1 - t.frictionAir * i * t.timeScale, o = t.position.x - t.positionPrev.x, a = t.position.y - t.positionPrev.y;
                    t.velocity.x = o * r * n + t.force.x / t.mass * s, t.velocity.y = a * r * n + t.force.y / t.mass * s, t.positionPrev.x = t.position.x, t.positionPrev.y = t.position.y, t.position.x += t.velocity.x, t.position.y += t.velocity.y, t.angularVelocity = (t.angle - t.anglePrev) * r * n + t.torque / t.inertia * s, t.anglePrev = t.angle, t.angle += t.angularVelocity, t.speed = u.magnitude(t.velocity), t.angularSpeed = Math.abs(t.angularVelocity);
                    for(var h = 0; h < t.parts.length; h++){
                        var l = t.parts[h];
                        g.translate(l.vertices, t.velocity), 0 < h && (l.position.x += t.velocity.x, l.position.y += t.velocity.y), 0 !== t.angularVelocity && (g.rotate(l.vertices, t.angularVelocity, t.position), c.rotate(l.axes, t.angularVelocity), 0 < h && u.rotateAbout(l.position, t.angularVelocity, t.position, l.position)), v.update(l.bounds, l.vertices, t.velocity);
                    }
                }, p.applyForce = function(t, e, i) {
                    t.force.x += i.x, t.force.y += i.y;
                    var n = e.x - t.position.x, s = e.y - t.position.y;
                    t.torque += n * i.y - s * i.x;
                }, p._totalProperties = function(t) {
                    for(var e = {
                        mass: 0,
                        area: 0,
                        inertia: 0,
                        centre: {
                            x: 0,
                            y: 0
                        }
                    }, i = 1 === t.parts.length ? 0 : 1; i < t.parts.length; i++){
                        var n = t.parts[i], s = n.mass !== 1 / 0 ? n.mass : 1;
                        e.mass += s, e.area += n.area, e.inertia += n.inertia, e.centre = u.add(e.centre, u.mult(n.position, s));
                    }
                    return e.centre = u.div(e.centre, e.mass), e;
                };
            }();
        },
        function(t, e) {
            t.exports = function(t, e) {
                e ? t.setCollision(!0, !0, !0, !0, !1) : t.resetCollision(!1);
            };
        },
        function(t, e, i) {
            var r = i(162), n = i(0), s = i(11), o = i(15), a = i(1059), h = new n({
                Extends: o,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.Depth,
                    s.Flip,
                    s.GetBounds,
                    s.Mask,
                    s.Origin,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Size,
                    s.TextureCrop,
                    s.Tint,
                    s.Transform,
                    s.Visible,
                    a
                ],
                initialize: function(t, e, i, n, s) {
                    o.call(this, t, "Sprite"), this._crop = this.resetCropObject(), this.anims = new r(this), this.setTexture(n, s), this.setPosition(e, i), this.setSizeToFrame(), this.setOriginFromFrame(), this.initPipeline();
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                preUpdate: function(t, e) {
                    this.anims.update(t, e);
                },
                play: function(t, e) {
                    return this.anims.play(t, e);
                },
                playReverse: function(t, e) {
                    return this.anims.playReverse(t, e);
                },
                playAfterDelay: function(t, e) {
                    return this.anims.playAfterDelay(t, e);
                },
                playAfterRepeat: function(t, e) {
                    return this.anims.playAfterRepeat(t, e);
                },
                chain: function(t) {
                    return this.anims.chain(t);
                },
                stop: function() {
                    return this.anims.stop();
                },
                stopAfterDelay: function(t) {
                    return this.anims.stopAfterDelay(t);
                },
                stopAfterRepeat: function(t) {
                    return this.anims.stopAfterRepeat(t);
                },
                stopOnFrame: function(t) {
                    return this.anims.stopOnFrame(t);
                },
                toJSON: function() {
                    return s.ToJSON(this);
                },
                preDestroy: function() {
                    this.anims.destroy(), this.anims = void 0;
                }
            });
            t.exports = h;
        },
        function(t, e) {
            t.exports = function(t, e) {
                if (!(e >= t.length)) {
                    for(var i = t.length - 1, n = t[e], s = e; s < i; s++)t[s] = t[s + 1];
                    return t.length = i, n;
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                ADDED_TO_SCENE: i(641),
                DESTROY: i(642),
                REMOVED_FROM_SCENE: i(643),
                VIDEO_COMPLETE: i(644),
                VIDEO_CREATED: i(645),
                VIDEO_ERROR: i(646),
                VIDEO_LOOP: i(647),
                VIDEO_PLAY: i(648),
                VIDEO_SEEKED: i(649),
                VIDEO_SEEKING: i(650),
                VIDEO_STOP: i(651),
                VIDEO_TIMEOUT: i(652),
                VIDEO_UNLOCKED: i(653)
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), 0 === e ? t : (t -= i, t = e * Math.floor(t / e), n ? (i + t) / e : i + t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = {};
                for(var i in t)Array.isArray(t[i]) ? e[i] = t[i].slice(0) : e[i] = t[i];
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = t.length;
                if (e < 0 || s < e || i <= e || s < i || s < e + i) {
                    if (n) throw new Error("Range Error: Values outside acceptable range");
                    return !1;
                }
                return !0;
            };
        },
        function(t, e) {
            function n(t, e) {
                return String(t).localeCompare(e);
            }
            function o(t, e, i, n) {
                for(var s, r, o, a, h = t.length, l = 0, u = 2 * i, c = 0; c < h; c += u)for(r = (s = c + i) + i, h < s && (s = h), h < r && (r = h), o = c, a = s;;)if (o < s && a < r) e(t[o], t[a]) <= 0 ? n[l++] = t[o++] : n[l++] = t[a++];
                else if (o < s) n[l++] = t[o++];
                else {
                    if (!(a < r)) break;
                    n[l++] = t[a++];
                }
            }
            t.exports = function(t, e) {
                void 0 === e && (e = n);
                var i = function(t, e) {
                    var i = t.length;
                    if (i <= 1) return t;
                    for(var n = new Array(i), s = 1; s < i; s *= 2){
                        o(t, e, s, n);
                        var r = t;
                        t = n, n = r;
                    }
                    return t;
                }(t, e);
                return i !== t && o(i, null, t.length, t), t;
            };
        },
        function(t, e, i) {
            var r = i(132), o = i(202);
            t.exports = function(t, e) {
                var i, n = r.Power0;
                if ("string" == typeof t ? r.hasOwnProperty(t) ? n = r[t] : (i = "", t.indexOf(".") && ("in" === (i = t.substr(t.indexOf(".") + 1)).toLowerCase() ? i = "easeIn" : "out" === i.toLowerCase() ? i = "easeOut" : "inout" === i.toLowerCase() && (i = "easeInOut")), t = o(t.substr(0, t.indexOf(".") + 1) + i), r.hasOwnProperty(t) && (n = r[t])) : "function" == typeof t ? n = t : Array.isArray(t) && t.length, !e) return n;
                var s = e.slice(0);
                return s.unshift(0), function(t) {
                    return s[0] = t, n.apply(this, s);
                };
            };
        },
        function(t, e, i) {
            var v = i(12);
            t.exports = function(t, e, i, n, s) {
                var r = t.strokeTint, o = v.getTintAppendFloatAlpha(e.strokeColor, e.strokeAlpha * i);
                r.TL = o, r.TR = o, r.BL = o, r.BR = o;
                var a = e.pathData, h = a.length - 1, l = e.lineWidth, u = l / 2, c = a[0] - n, d = a[1] - s;
                e.closePath || (h -= 2);
                for(var f = 2; f < h; f += 2){
                    var p = a[f] - n, g = a[f + 1] - s;
                    t.batchLine(c, d, p, g, u, u, l, f - 2, !!e.closePath && f === h - 1), c = p, d = g;
                }
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(112), r = i(470), o = i(471), a = i(55), h = i(45), l = i(178), u = new n({
                initialize: function(t, e, i, n, s, r) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = 0), this.type = a.TRIANGLE, this.x1 = t, this.y1 = e, this.x2 = i, this.y2 = n, this.x3 = s, this.y3 = r;
                },
                contains: function(t, e) {
                    return s(this, t, e);
                },
                getPoint: function(t, e) {
                    return r(this, t, e);
                },
                getPoints: function(t, e, i) {
                    return o(this, t, e, i);
                },
                getRandomPoint: function(t) {
                    return l(this, t);
                },
                setTo: function(t, e, i, n, s, r) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = 0), this.x1 = t, this.y1 = e, this.x2 = i, this.y2 = n, this.x3 = s, this.y3 = r, this;
                },
                getLineA: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.x1, this.y1, this.x2, this.y2), t;
                },
                getLineB: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.x2, this.y2, this.x3, this.y3), t;
                },
                getLineC: function(t) {
                    return void 0 === t && (t = new h), t.setTo(this.x3, this.y3, this.x1, this.y1), t;
                },
                left: {
                    get: function() {
                        return Math.min(this.x1, this.x2, this.x3);
                    },
                    set: function(t) {
                        var e = 0, e = this.x1 <= this.x2 && this.x1 <= this.x3 ? this.x1 - t : this.x2 <= this.x1 && this.x2 <= this.x3 ? this.x2 - t : this.x3 - t;
                        this.x1 -= e, this.x2 -= e, this.x3 -= e;
                    }
                },
                right: {
                    get: function() {
                        return Math.max(this.x1, this.x2, this.x3);
                    },
                    set: function(t) {
                        var e = 0, e = this.x1 >= this.x2 && this.x1 >= this.x3 ? this.x1 - t : this.x2 >= this.x1 && this.x2 >= this.x3 ? this.x2 - t : this.x3 - t;
                        this.x1 -= e, this.x2 -= e, this.x3 -= e;
                    }
                },
                top: {
                    get: function() {
                        return Math.min(this.y1, this.y2, this.y3);
                    },
                    set: function(t) {
                        var e = 0, e = this.y1 <= this.y2 && this.y1 <= this.y3 ? this.y1 - t : this.y2 <= this.y1 && this.y2 <= this.y3 ? this.y2 - t : this.y3 - t;
                        this.y1 -= e, this.y2 -= e, this.y3 -= e;
                    }
                },
                bottom: {
                    get: function() {
                        return Math.max(this.y1, this.y2, this.y3);
                    },
                    set: function(t) {
                        var e = 0, e = this.y1 >= this.y2 && this.y1 >= this.y3 ? this.y1 - t : this.y2 >= this.y1 && this.y2 >= this.y3 ? this.y2 - t : this.y3 - t;
                        this.y1 -= e, this.y2 -= e, this.y3 -= e;
                    }
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var n = i(29), s = i(0), r = i(11), o = i(496), a = new s({
                Mixins: [
                    r.Alpha,
                    r.Flip,
                    r.Visible
                ],
                initialize: function(t, e, i, n, s, r, o, a) {
                    this.layer = t, this.index = e, this.x = i, this.y = n, this.width = s, this.height = r, this.right, this.bottom, this.baseWidth = void 0 !== o ? o : s, this.baseHeight = void 0 !== a ? a : r, this.pixelX = 0, this.pixelY = 0, this.updatePixelXY(), this.properties = {}, this.rotation = 0, this.collideLeft = !1, this.collideRight = !1, this.collideUp = !1, this.collideDown = !1, this.faceLeft = !1, this.faceRight = !1, this.faceTop = !1, this.faceBottom = !1, this.collisionCallback = void 0, (this.collisionCallbackContext = this).tint = 16777215, this.physics = {};
                },
                containsPoint: function(t, e) {
                    return !(t < this.pixelX || e < this.pixelY || t > this.right || e > this.bottom);
                },
                copy: function(t) {
                    return this.index = t.index, this.alpha = t.alpha, this.properties = t.properties, this.visible = t.visible, this.setFlip(t.flipX, t.flipY), this.tint = t.tint, this.rotation = t.rotation, this.collideUp = t.collideUp, this.collideDown = t.collideDown, this.collideLeft = t.collideLeft, this.collideRight = t.collideRight, this.collisionCallback = t.collisionCallback, this.collisionCallbackContext = t.collisionCallbackContext, this;
                },
                getCollisionGroup: function() {
                    return this.tileset ? this.tileset.getTileCollisionGroup(this.index) : null;
                },
                getTileData: function() {
                    return this.tileset ? this.tileset.getTileData(this.index) : null;
                },
                getLeft: function(t) {
                    var e = this.tilemapLayer;
                    return e ? e.tileToWorldX(this.x, t) : this.x * this.baseWidth;
                },
                getRight: function(t) {
                    var e = this.tilemapLayer;
                    return e ? this.getLeft(t) + this.width * e.scaleX : this.getLeft(t) + this.width;
                },
                getTop: function(t) {
                    var e = this.tilemapLayer;
                    return e ? e.tileToWorldY(this.y, t) - (this.height - this.baseHeight) * e.scaleY : this.y * this.baseHeight - (this.height - this.baseHeight);
                },
                getBottom: function(t) {
                    var e = this.tilemapLayer;
                    return e ? this.getTop(t) + this.height * e.scaleY : this.getTop(t) + this.height;
                },
                getBounds: function(t, e) {
                    return void 0 === e && (e = new o), e.x = this.getLeft(), e.y = this.getTop(), e.width = this.getRight() - e.x, e.height = this.getBottom() - e.y, e;
                },
                getCenterX: function(t) {
                    return (this.getLeft(t) + this.getRight(t)) / 2;
                },
                getCenterY: function(t) {
                    return (this.getTop(t) + this.getBottom(t)) / 2;
                },
                intersects: function(t, e, i, n) {
                    return !(i <= this.pixelX || n <= this.pixelY || t >= this.right || e >= this.bottom);
                },
                isInteresting: function(t, e) {
                    return t && e ? this.canCollide || this.hasInterestingFace : t ? this.collides : !!e && this.hasInterestingFace;
                },
                resetCollision: function(t) {
                    return void 0 === t && (t = !0), this.collideLeft = !1, this.collideRight = !1, this.collideUp = !1, this.collideDown = !1, this.faceTop = !1, this.faceBottom = !1, this.faceLeft = !1, this.faceRight = !1, t && this.tilemapLayer && this.tilemapLayer.calculateFacesAt(this.x, this.y), this;
                },
                resetFaces: function() {
                    return this.faceTop = !1, this.faceBottom = !1, this.faceLeft = !1, this.faceRight = !1, this;
                },
                setCollision: function(t, e, i, n, s) {
                    return void 0 === e && (e = t), void 0 === i && (i = t), void 0 === n && (n = t), void 0 === s && (s = !0), this.collideLeft = t, this.collideRight = e, this.collideUp = i, this.collideDown = n, this.faceLeft = t, this.faceRight = e, this.faceTop = i, this.faceBottom = n, s && this.tilemapLayer && this.tilemapLayer.calculateFacesAt(this.x, this.y), this;
                },
                setCollisionCallback: function(t, e) {
                    return null === t ? (this.collisionCallback = void 0, this.collisionCallbackContext = void 0) : (this.collisionCallback = t, this.collisionCallbackContext = e), this;
                },
                setSize: function(t, e, i, n) {
                    return void 0 !== t && (this.width = t), void 0 !== e && (this.height = e), void 0 !== i && (this.baseWidth = i), void 0 !== n && (this.baseHeight = n), this.updatePixelXY(), this;
                },
                updatePixelXY: function() {
                    var t, e, i = this.layer.orientation;
                    return i === n.ORTHOGONAL ? (this.pixelX = this.x * this.baseWidth, this.pixelY = this.y * this.baseHeight) : i === n.ISOMETRIC ? (this.pixelX = (this.x - this.y) * this.baseWidth * .5, this.pixelY = (this.x + this.y) * this.baseHeight * .5) : i === n.STAGGERED ? (this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2), this.pixelY = this.y * (this.baseHeight / 2)) : i === n.HEXAGONAL && (t = this.layer.hexSideLength, e = (this.baseHeight - t) / 2 + t, this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2), this.pixelY = this.y * e), this.right = this.pixelX + this.baseWidth, this.bottom = this.pixelY + this.baseHeight, this;
                },
                destroy: function() {
                    this.collisionCallback = void 0, this.collisionCallbackContext = void 0, this.properties = void 0;
                },
                canCollide: {
                    get: function() {
                        return this.collideLeft || this.collideRight || this.collideUp || this.collideDown || void 0 !== this.collisionCallback;
                    }
                },
                collides: {
                    get: function() {
                        return this.collideLeft || this.collideRight || this.collideUp || this.collideDown;
                    }
                },
                hasInterestingFace: {
                    get: function() {
                        return this.faceTop || this.faceBottom || this.faceLeft || this.faceRight;
                    }
                },
                tileset: {
                    get: function() {
                        var t = this.layer.tilemapLayer;
                        if (t) {
                            var e = t.gidMap[this.index];
                            if (e) return e;
                        }
                        return null;
                    }
                },
                tilemapLayer: {
                    get: function() {
                        return this.layer.tilemapLayer;
                    }
                },
                tilemap: {
                    get: function() {
                        var t = this.tilemapLayer;
                        return t ? t.tilemap : null;
                    }
                }
            });
            t.exports = a;
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x - t.width * t.originX + .5 * t.width;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.width * t.originX;
                return t.x = e + i - .5 * t.width, t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.y - t.height * t.originY + .5 * t.height;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.height * t.originY;
                return t.y = e + i - .5 * t.height, t;
            };
        },
        function(t, e, i) {
            t.exports = {
                POST_RENDER: i(626),
                PRE_RENDER: i(627),
                RENDER: i(628),
                RESIZE: i(629)
            };
        },
        function(t, e, i) {
            var h = i(74);
            t.exports = function(t, e, i, n) {
                if (void 0 === n && (n = t), !Array.isArray(e)) return -1 !== (o = t.indexOf(e)) ? (h(t, o), i && i.call(n, e), e) : null;
                for(var s = e.length - 1, r = []; 0 <= s;){
                    var o, a = e[s];
                    -1 !== (o = t.indexOf(a)) && (h(t, o), r.push(a), i && i.call(n, a)), s--;
                }
                return r;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(196), r = i(10), o = i(3), a = new n({
                initialize: function(t) {
                    this.type = t, this.defaultDivisions = 5, this.arcLengthDivisions = 100, this.cacheArcLengths = [], this.needsUpdate = !0, this.active = !0, this._tmpVec2A = new o, this._tmpVec2B = new o;
                },
                draw: function(t, e) {
                    return void 0 === e && (e = 32), t.strokePoints(this.getPoints(e));
                },
                getBounds: function(t, e) {
                    t = t || new r, void 0 === e && (e = 16);
                    var i = this.getLength();
                    i < e && (e = i / 2);
                    var n = Math.max(1, Math.round(i / e));
                    return s(this.getSpacedPoints(n), t);
                },
                getDistancePoints: function(t) {
                    var e = this.getLength(), i = Math.max(1, e / t);
                    return this.getSpacedPoints(i);
                },
                getEndPoint: function(t) {
                    return void 0 === t && (t = new o), this.getPointAt(1, t);
                },
                getLength: function() {
                    var t = this.getLengths();
                    return t[t.length - 1];
                },
                getLengths: function(t) {
                    if (void 0 === t && (t = this.arcLengthDivisions), this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
                    this.needsUpdate = !1;
                    var e, i = [], n = this.getPoint(0, this._tmpVec2A), s = 0;
                    i.push(0);
                    for(var r = 1; r <= t; r++)s += (e = this.getPoint(r / t, this._tmpVec2B)).distance(n), i.push(s), n.copy(e);
                    return this.cacheArcLengths = i;
                },
                getPointAt: function(t, e) {
                    var i = this.getUtoTmapping(t);
                    return this.getPoint(i, e);
                },
                getPoints: function(t, e, i) {
                    void 0 === i && (i = []), t = t || (e ? this.getLength() / e : this.defaultDivisions);
                    for(var n = 0; n <= t; n++)i.push(this.getPoint(n / t));
                    return i;
                },
                getRandomPoint: function(t) {
                    return void 0 === t && (t = new o), this.getPoint(Math.random(), t);
                },
                getSpacedPoints: function(t, e, i) {
                    void 0 === i && (i = []), t = t || (e ? this.getLength() / e : this.defaultDivisions);
                    for(var n = 0; n <= t; n++){
                        var s = this.getUtoTmapping(n / t, null, t);
                        i.push(this.getPoint(s));
                    }
                    return i;
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new o), this.getPointAt(0, t);
                },
                getTangent: function(t, e) {
                    void 0 === e && (e = new o);
                    var i = t - 1e-4, n = t + 1e-4;
                    return i < 0 && (i = 0), 1 < n && (n = 1), this.getPoint(i, this._tmpVec2A), this.getPoint(n, e), e.subtract(this._tmpVec2A).normalize();
                },
                getTangentAt: function(t, e) {
                    var i = this.getUtoTmapping(t);
                    return this.getTangent(i, e);
                },
                getTFromDistance: function(t, e) {
                    return t <= 0 ? 0 : this.getUtoTmapping(0, t, e);
                },
                getUtoTmapping: function(t, e, i) {
                    for(var n, s = this.getLengths(i), r = 0, o = s.length, a = e ? Math.min(e, s[o - 1]) : t * s[o - 1], h = 0, l = o - 1; h <= l;)if ((n = s[r = Math.floor(h + (l - h) / 2)] - a) < 0) h = r + 1;
                    else {
                        if (!(0 < n)) {
                            l = r;
                            break;
                        }
                        l = r - 1;
                    }
                    if (s[r = l] === a) return r / (o - 1);
                    var u = s[r];
                    return (r + (a - u) / (s[r + 1] - u)) / (o - 1);
                },
                updateArcLengths: function() {
                    this.needsUpdate = !0, this.getLengths();
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            t.exports = {
                ADD: i(964),
                COMPLETE: i(965),
                FILE_COMPLETE: i(966),
                FILE_KEY_COMPLETE: i(967),
                FILE_LOAD_ERROR: i(968),
                FILE_LOAD: i(969),
                FILE_PROGRESS: i(970),
                POST_PROCESS: i(971),
                PROGRESS: i(972),
                START: i(973)
            };
        },
        function(t, e, i) {
            var p = i(4);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new p);
                var n = t.x1, s = t.y1, r = t.x2, o = t.y2, a = e.x1, h = e.y1, l = e.x2, u = e.y2, c = (u - h) * (r - n) - (l - a) * (o - s);
                if (0 == c) return !1;
                var d = ((l - a) * (s - h) - (u - h) * (n - a)) / c, f = ((r - n) * (s - h) - (o - s) * (n - a)) / c;
                return 0 <= d && d <= 1 && 0 <= f && f <= 1 && (i.x = n + d * (r - n), i.y = s + d * (o - s), !0);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.atan2(t.y2 - t.y1, t.x2 - t.x1);
            };
        },
        function(t, e, i) {
            var a = {};
            t.exports = a;
            var T = i(116), w = i(50);
            a.create = function(t, e) {
                for(var i = [], n = 0; n < t.length; n++){
                    var s = t[n], r = {
                        x: s.x,
                        y: s.y,
                        index: n,
                        body: e,
                        isInternal: !1,
                        contact: null,
                        offset: null
                    };
                    r.contact = {
                        vertex: r,
                        normalImpulse: 0,
                        tangentImpulse: 0
                    }, i.push(r);
                }
                return i;
            }, a.fromPath = function(t, e) {
                var n = [];
                return t.replace(/L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/gi, function(t, e, i) {
                    n.push({
                        x: parseFloat(e),
                        y: parseFloat(i)
                    });
                }), a.create(n, e);
            }, a.centre = function(t) {
                for(var e, i, n, s = a.area(t, !0), r = {
                    x: 0,
                    y: 0
                }, o = 0; o < t.length; o++)n = (o + 1) % t.length, e = T.cross(t[o], t[n]), i = T.mult(T.add(t[o], t[n]), e), r = T.add(r, i);
                return T.div(r, 6 * s);
            }, a.mean = function(t) {
                for(var e = {
                    x: 0,
                    y: 0
                }, i = 0; i < t.length; i++)e.x += t[i].x, e.y += t[i].y;
                return T.div(e, t.length);
            }, a.area = function(t, e) {
                for(var i = 0, n = t.length - 1, s = 0; s < t.length; s++)i += (t[n].x - t[s].x) * (t[n].y + t[s].y), n = s;
                return e ? i / 2 : Math.abs(i) / 2;
            }, a.inertia = function(t, e) {
                for(var i, n, s = 0, r = 0, o = t, a = 0; a < o.length; a++)n = (a + 1) % o.length, s += (i = Math.abs(T.cross(o[n], o[a]))) * (T.dot(o[n], o[n]) + T.dot(o[n], o[a]) + T.dot(o[a], o[a])), r += i;
                return e / 6 * (s / r);
            }, a.translate = function(t, e, i) {
                var n;
                if (i) for(n = 0; n < t.length; n++)t[n].x += e.x * i, t[n].y += e.y * i;
                else for(n = 0; n < t.length; n++)t[n].x += e.x, t[n].y += e.y;
                return t;
            }, a.rotate = function(t, e, i) {
                if (0 !== e) {
                    for(var n = Math.cos(e), s = Math.sin(e), r = 0; r < t.length; r++){
                        var o = t[r], a = o.x - i.x, h = o.y - i.y;
                        o.x = i.x + (a * n - h * s), o.y = i.y + (a * s + h * n);
                    }
                    return t;
                }
            }, a.contains = function(t, e) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i], s = t[(i + 1) % t.length];
                    if (0 < (e.x - n.x) * (s.y - n.y) + (e.y - n.y) * (n.x - s.x)) return !1;
                }
                return !0;
            }, a.scale = function(t, e, i, n) {
                if (1 === e && 1 === i) return t;
                var s, r;
                n = n || a.centre(t);
                for(var o = 0; o < t.length; o++)s = t[o], r = T.sub(s, n), t[o].x = n.x + r.x * e, t[o].y = n.y + r.y * i;
                return t;
            }, a.chamfer = function(t, e, i, n, s) {
                e = "number" == typeof e ? [
                    e
                ] : e || [
                    8
                ], i = void 0 !== i ? i : -1, n = n || 2, s = s || 14;
                for(var r = [], o = 0; o < t.length; o++){
                    var a = t[0 <= o - 1 ? o - 1 : t.length - 1], h = t[o], l = t[(o + 1) % t.length], u = e[o < e.length ? o : e.length - 1];
                    if (0 !== u) {
                        var c = T.normalise({
                            x: h.y - a.y,
                            y: a.x - h.x
                        }), d = T.normalise({
                            x: l.y - h.y,
                            y: h.x - l.x
                        }), f = Math.sqrt(2 * Math.pow(u, 2)), p = T.mult(w.clone(c), u), g = T.normalise(T.mult(T.add(c, d), .5)), v = T.sub(h, T.mult(g, f)), m = i;
                        -1 === i && (m = 1.75 * Math.pow(u, .32)), (m = w.clamp(m, n, s)) % 2 == 1 && (m += 1);
                        for(var y = Math.acos(T.dot(c, d)) / m, x = 0; x < m; x++)r.push(T.add(T.rotate(p, y * x), v));
                    } else r.push(h);
                }
                return r;
            }, a.clockwiseSort = function(t) {
                var i = a.mean(t);
                return t.sort(function(t, e) {
                    return T.angle(i, t) - T.angle(i, e);
                }), t;
            }, a.isConvex = function(t) {
                var e, i, n, s, r = 0, o = t.length;
                if (o < 3) return null;
                for(e = 0; e < o; e++)if (n = (e + 2) % o, s = (t[i = (e + 1) % o].x - t[e].x) * (t[n].y - t[i].y), (s -= (t[i].y - t[e].y) * (t[n].x - t[i].x)) < 0 ? r |= 1 : 0 < s && (r |= 2), 3 === r) return !1;
                return 0 !== r || null;
            }, a.hull = function(t) {
                var e, i, n = [], s = [];
                for((t = t.slice(0)).sort(function(t, e) {
                    var i = t.x - e.x;
                    return 0 != i ? i : t.y - e.y;
                }), i = 0; i < t.length; i += 1){
                    for(e = t[i]; 2 <= s.length && T.cross3(s[s.length - 2], s[s.length - 1], e) <= 0;)s.pop();
                    s.push(e);
                }
                for(i = t.length - 1; 0 <= i; --i){
                    for(e = t[i]; 2 <= n.length && T.cross3(n[n.length - 2], n[n.length - 1], e) <= 0;)n.pop();
                    n.push(e);
                }
                return n.pop(), s.pop(), n.concat(s);
            };
        },
        function(t, e, i) {
            var n = i(18);
            t.exports = function(t, e, i) {
                return (i - e) * (t = n(t, 0, 1));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t && t.hasOwnProperty(e) ? t[e] : i;
            };
        },
        function(t, e) {
            t.exports = {
                CREATED: 0,
                INIT: 1,
                DELAY: 2,
                OFFSET_DELAY: 3,
                PENDING_RENDER: 4,
                PLAYING_FORWARD: 5,
                PLAYING_BACKWARD: 6,
                HOLD_DELAY: 7,
                REPEAT_DELAY: 8,
                COMPLETE: 9,
                PENDING_ADD: 20,
                PAUSED: 21,
                LOOP_DELAY: 22,
                ACTIVE: 23,
                COMPLETE_DELAY: 24,
                PENDING_REMOVE: 25,
                REMOVED: 26
            };
        },
        function(t, e, i) {
            var n = i(0), a = i(309), s = new n({
                initialize: function(t, e) {
                    this.parent = t, (this.events = e) || (this.events = t.events ? t.events : t), this.list = {}, this.values = {}, this._frozen = !1, !t.hasOwnProperty("sys") && this.events && this.events.once(a.DESTROY, this.destroy, this);
                },
                get: function(t) {
                    var e = this.list;
                    if (Array.isArray(t)) {
                        for(var i = [], n = 0; n < t.length; n++)i.push(e[t[n]]);
                        return i;
                    }
                    return e[t];
                },
                getAll: function() {
                    var t = {};
                    for(var e in this.list)this.list.hasOwnProperty(e) && (t[e] = this.list[e]);
                    return t;
                },
                query: function(t) {
                    var e = {};
                    for(var i in this.list)this.list.hasOwnProperty(i) && i.match(t) && (e[i] = this.list[i]);
                    return e;
                },
                set: function(t, e) {
                    if (this._frozen) return this;
                    if ("string" == typeof t) return this.setValue(t, e);
                    for(var i in t)this.setValue(i, t[i]);
                    return this;
                },
                inc: function(t, e) {
                    if (this._frozen) return this;
                    void 0 === e && (e = 1);
                    var i = this.get(t);
                    return void 0 === i && (i = 0), this.set(t, i + e), this;
                },
                toggle: function(t) {
                    return this._frozen || this.set(t, !this.get(t)), this;
                },
                setValue: function(i, t) {
                    var n, s, r, o;
                    return this._frozen || (this.has(i) ? this.values[i] = t : (s = (n = this).list, r = this.events, o = this.parent, Object.defineProperty(this.values, i, {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return s[i];
                        },
                        set: function(t) {
                            var e;
                            n._frozen || (e = s[i], s[i] = t, r.emit(a.CHANGE_DATA, o, i, t, e), r.emit(a.CHANGE_DATA_KEY + i, o, t, e));
                        }
                    }), s[i] = t, r.emit(a.SET_DATA, o, i, t))), this;
                },
                each: function(t, e) {
                    for(var i = [
                        this.parent,
                        null,
                        void 0
                    ], n = 1; n < arguments.length; n++)i.push(arguments[n]);
                    for(var s in this.list)i[1] = s, i[2] = this.list[s], t.apply(e, i);
                    return this;
                },
                merge: function(t, e) {
                    for(var i in void 0 === e && (e = !0), t)t.hasOwnProperty(i) && (e || !e && !this.has(i)) && this.setValue(i, t[i]);
                    return this;
                },
                remove: function(t) {
                    if (this._frozen) return this;
                    if (!Array.isArray(t)) return this.removeValue(t);
                    for(var e = 0; e < t.length; e++)this.removeValue(t[e]);
                    return this;
                },
                removeValue: function(t) {
                    var e;
                    return this.has(t) && (e = this.list[t], delete this.list[t], delete this.values[t], this.events.emit(a.REMOVE_DATA, this.parent, t, e)), this;
                },
                pop: function(t) {
                    var e = void 0;
                    return !this._frozen && this.has(t) && (e = this.list[t], delete this.list[t], delete this.values[t], this.events.emit(a.REMOVE_DATA, this.parent, t, e)), e;
                },
                has: function(t) {
                    return this.list.hasOwnProperty(t);
                },
                setFreeze: function(t) {
                    return this._frozen = t, this;
                },
                reset: function() {
                    for(var t in this.list)delete this.list[t], delete this.values[t];
                    return this._frozen = !1, this;
                },
                destroy: function() {
                    this.reset(), this.events.off(a.CHANGE_DATA), this.events.off(a.SET_DATA), this.events.off(a.REMOVE_DATA), this.parent = null;
                },
                freeze: {
                    get: function() {
                        return this._frozen;
                    },
                    set: function(t) {
                        this._frozen = !!t;
                    }
                },
                count: {
                    get: function() {
                        var t = 0;
                        for(var e in this.list)void 0 !== this.list[e] && t++;
                        return t;
                    }
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t) {
                    if (this.entries = {}, this.size = 0, Array.isArray(t)) for(var e = 0; e < t.length; e++)this.set(t[e][0], t[e][1]);
                },
                set: function(t, e) {
                    return this.has(t) || this.size++, this.entries[t] = e, this;
                },
                get: function(t) {
                    if (this.has(t)) return this.entries[t];
                },
                getArray: function() {
                    var t = [], e = this.entries;
                    for(var i in e)t.push(e[i]);
                    return t;
                },
                has: function(t) {
                    return this.entries.hasOwnProperty(t);
                },
                delete: function(t) {
                    return this.has(t) && (delete this.entries[t], this.size--), this;
                },
                clear: function() {
                    return Object.keys(this.entries).forEach(function(t) {
                        delete this.entries[t];
                    }, this), this.size = 0, this;
                },
                keys: function() {
                    return Object.keys(this.entries);
                },
                values: function() {
                    var t = [], e = this.entries;
                    for(var i in e)t.push(e[i]);
                    return t;
                },
                dump: function() {
                    var t = this.entries;
                    for(var e in console.group("Map"), t)console.log(e, t[e]);
                    console.groupEnd();
                },
                each: function(t) {
                    var e = this.entries;
                    for(var i in e)if (!1 === t(i, e[i])) break;
                    return this;
                },
                contains: function(t) {
                    var e = this.entries;
                    for(var i in e)if (e[i] === t) return !0;
                    return !1;
                },
                merge: function(t, e) {
                    void 0 === e && (e = !1);
                    var i = this.entries, n = t.entries;
                    for(var s in n)i.hasOwnProperty(s) && e ? i[s] = n[s] : this.set(s, n[s]);
                    return this;
                }
            });
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t << 16 | e << 8 | i;
            };
        },
        function(t, e, i) {
            t.exports = {
                ENTER_FULLSCREEN: i(776),
                FULLSCREEN_FAILED: i(777),
                FULLSCREEN_UNSUPPORTED: i(778),
                LEAVE_FULLSCREEN: i(779),
                ORIENTATION_CHANGE: i(780),
                RESIZE: i(781)
            };
        },
        function(t, e, i) {
            (function(i) {
                var n = {
                    android: !1,
                    chromeOS: !1,
                    cordova: !1,
                    crosswalk: !1,
                    desktop: !1,
                    ejecta: !1,
                    electron: !1,
                    iOS: !1,
                    iOSVersion: 0,
                    iPad: !1,
                    iPhone: !1,
                    kindle: !1,
                    linux: !1,
                    macOS: !1,
                    node: !1,
                    nodeWebkit: !1,
                    pixelRatio: 1,
                    webApp: !1,
                    windows: !1,
                    windowsPhone: !1
                };
                t.exports = function() {
                    var t = navigator.userAgent;
                    /Windows/.test(t) ? n.windows = !0 : /Mac OS/.test(t) && !/like Mac OS/.test(t) ? navigator.maxTouchPoints && 2 < navigator.maxTouchPoints ? (n.iOS = !0, n.iPad = !0, navigator.appVersion.match(/Version\/(\d+)/), n.iOSVersion = parseInt(RegExp.$1, 10)) : n.macOS = !0 : /Android/.test(t) ? n.android = !0 : /Linux/.test(t) ? n.linux = !0 : /iP[ao]d|iPhone/i.test(t) ? (n.iOS = !0, navigator.appVersion.match(/OS (\d+)/), n.iOSVersion = parseInt(RegExp.$1, 10), n.iPhone = -1 !== t.toLowerCase().indexOf("iphone"), n.iPad = -1 !== t.toLowerCase().indexOf("ipad")) : /Kindle/.test(t) || /\bKF[A-Z][A-Z]+/.test(t) || /Silk.*Mobile Safari/.test(t) ? n.kindle = !0 : /CrOS/.test(t) && (n.chromeOS = !0), (/Windows Phone/i.test(t) || /IEMobile/i.test(t)) && (n.android = !1, n.iOS = !1, n.macOS = !1, n.windows = !0, n.windowsPhone = !0);
                    var e = /Silk/.test(t);
                    return (n.windows || n.macOS || n.linux && !e || n.chromeOS) && (n.desktop = !0), (n.windowsPhone || /Windows NT/i.test(t) && /Touch/i.test(t)) && (n.desktop = !1), navigator.standalone && (n.webApp = !0), void 0 !== window.cordova && (n.cordova = !0), void 0 !== i && i.versions && i.versions.node && (n.node = !0), n.node && "object" == typeof i.versions && (n.nodeWebkit = !!i.versions["node-webkit"], n.electron = !!i.versions.electron), void 0 !== window.ejecta && (n.ejecta = !0), /Crosswalk/.test(t) && (n.crosswalk = !0), n.pixelRatio = window.devicePixelRatio || 1, n;
                }();
            }).call(this, i(804));
        },
        function(t, e, i) {
            t.exports = {
                ADD: i(857),
                ERROR: i(858),
                LOAD: i(859),
                READY: i(860),
                REMOVE: i(861)
            };
        },
        function(t, e) {
            t.exports = {
                BYTE: {
                    enum: 5120,
                    size: 1
                },
                UNSIGNED_BYTE: {
                    enum: 5121,
                    size: 1
                },
                SHORT: {
                    enum: 5122,
                    size: 2
                },
                UNSIGNED_SHORT: {
                    enum: 5123,
                    size: 2
                },
                INT: {
                    enum: 5124,
                    size: 4
                },
                UNSIGNED_INT: {
                    enum: 5125,
                    size: 4
                },
                FLOAT: {
                    enum: 5126,
                    size: 4
                }
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = i(874), o = i(875), a = i(25), z = i(12), h = i(104), l = i(57), u = new n({
                Extends: l,
                initialize: function(t) {
                    var e = t.game.renderer, i = s(t, "fragShader", r);
                    t.fragShader = z.parseFragmentShaderMaxTextures(i, e.maxTextures), t.vertShader = s(t, "vertShader", o), t.attributes = s(t, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inTexCoord",
                            size: 2
                        },
                        {
                            name: "inTexId"
                        },
                        {
                            name: "inTintEffect"
                        },
                        {
                            name: "inTint",
                            size: 4,
                            type: h.UNSIGNED_BYTE,
                            normalized: !0
                        }
                    ]), l.call(this, t), this._tempMatrix1 = new a, this._tempMatrix2 = new a, this._tempMatrix3 = new a;
                },
                boot: function() {
                    l.prototype.boot.call(this), this.currentShader.set1iv("uMainSampler", this.renderer.textureIndexes);
                },
                batchSprite: function(t, e, i) {
                    this.manager.set(this, t);
                    var n, s = this._tempMatrix1, r = this._tempMatrix2, o = this._tempMatrix3, a = t.frame, h = a.glTexture, l = a.u0, u = a.v0, c = a.u1, d = a.v1, f = a.x, p = a.y, g = a.cutWidth, v = a.cutHeight, m = a.customPivot, y = t.displayOriginX, x = t.displayOriginY, T = -y + f, w = -x + p;
                    t.isCropped && ((n = t._crop).flipX === t.flipX && n.flipY === t.flipY || a.updateCropUVs(n, t.flipX, t.flipY), l = n.u0, u = n.v0, c = n.u1, d = n.v1, g = n.width, v = n.height, T = -y + n.x, w = -x + n.y);
                    var b = 1, E = 1;
                    t.flipX && (m || (T += -a.realWidth + 2 * y), b = -1), (t.flipY || a.source.isGLTexture && !h.flipY) && (m || (w += -a.realHeight + 2 * x), E = -1), r.applyITRS(t.x, t.y, t.rotation, t.scaleX * b, t.scaleY * E), s.copyFrom(e.matrix), i ? (s.multiplyWithOffset(i, -e.scrollX * t.scrollFactorX, -e.scrollY * t.scrollFactorY), r.e = t.x, r.f = t.y) : (r.e -= e.scrollX * t.scrollFactorX, r.f -= e.scrollY * t.scrollFactorY), s.multiply(r, o);
                    var S = T + g, A = w + v, _ = e.roundPixels, C = o.getXRound(T, w, _), M = o.getYRound(T, w, _), R = o.getXRound(T, A, _), P = o.getYRound(T, A, _), O = o.getXRound(S, A, _), L = o.getYRound(S, A, _), D = o.getXRound(S, w, _), F = o.getYRound(S, w, _), k = z.getTintAppendFloatAlpha, I = e.alpha, B = k(t.tintTopLeft, I * t._alphaTL), N = k(t.tintTopRight, I * t._alphaTR), Y = k(t.tintBottomLeft, I * t._alphaBL), U = k(t.tintBottomRight, I * t._alphaBR);
                    this.shouldFlush(6) && this.flush();
                    var X = this.setGameObject(t, a);
                    this.manager.preBatch(t), this.batchQuad(t, C, M, R, P, O, L, D, F, l, u, c, d, B, N, Y, U, t.tintFill, h, X), this.manager.postBatch(t);
                },
                batchTexture: function(t, e, i, n, s, r, o, a, h, l, u, c, d, f, p, g, v, m, y, x, T, w, b, E, S, A, _, C, M, R, P, O) {
                    this.manager.set(this, t);
                    var L, D, F, k, I, B = this._tempMatrix1, N = this._tempMatrix2, Y = this._tempMatrix3, U = m / i + _, X = y / n + C, z = (m + x) / i + _, G = (y + T) / n + C, W = o, V = a, H = -g, j = -v;
                    t.isCropped && (o = W = D = (L = t._crop).width, a = V = F = L.height, k = m = L.x, I = y = L.y, c && (k = x - L.x - D), d && (I = T - L.y - F), U = k / i + _, X = I / n + C, z = (k + D) / i + _, G = (I + F) / n + C, H = -g + m, j = -v + y), c && (W *= -1, H += o), (d ^= !P && e.isRenderTexture ? 1 : 0) && (V *= -1, j += a);
                    var q = H + W, K = j + V;
                    N.applyITRS(s, r, u, h, l), B.copyFrom(M.matrix), R ? (B.multiplyWithOffset(R, -M.scrollX * f, -M.scrollY * p), N.e = s, N.f = r) : (N.e -= M.scrollX * f, N.f -= M.scrollY * p), B.multiply(N, Y);
                    var Z = M.roundPixels, J = Y.getXRound(H, j, Z), Q = Y.getYRound(H, j, Z), $ = Y.getXRound(H, K, Z), tt = Y.getYRound(H, K, Z), et = Y.getXRound(q, K, Z), it = Y.getYRound(q, K, Z), nt = Y.getXRound(q, j, Z), st = Y.getYRound(q, j, Z);
                    void 0 === O && (O = this.renderer.setTexture2D(e)), t && this.manager.preBatch(t), this.batchQuad(t, J, Q, $, tt, et, it, nt, st, U, X, z, G, w, b, E, S, A, e, O), t && this.manager.postBatch(t);
                },
                batchTextureFrame: function(t, e, i, n, s, r, o) {
                    this.manager.set(this);
                    var a = this._tempMatrix1.copyFrom(r), h = this._tempMatrix2, l = e + t.width, u = i + t.height;
                    o ? a.multiply(o, h) : h = a;
                    var c = h.getX(e, i), d = h.getY(e, i), f = h.getX(e, u), p = h.getY(e, u), g = h.getX(l, u), v = h.getY(l, u), m = h.getX(l, i), y = h.getY(l, i), x = this.renderer.setTextureSource(t.source);
                    n = z.getTintAppendFloatAlpha(n, s), this.batchQuad(null, c, d, f, p, g, v, m, y, t.u0, t.v0, t.u1, t.v1, n, n, n, n, 0, t.glTexture, x);
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var n = i(0), C = i(18), s = i(17), r = new n({
                initialize: function(t, e, i, n, s, r, o) {
                    this.texture = t, this.name = e, this.source = t.source[i], this.sourceIndex = i, this.glTexture = this.source.glTexture, this.cutX, this.cutY, this.cutWidth, this.cutHeight, this.x = 0, this.y = 0, this.width, this.height, this.halfWidth, this.halfHeight, this.centerX, this.centerY, this.pivotX = 0, this.pivotY = 0, this.customPivot = !1, this.rotated = !1, this.autoRound = -1, this.customData = {}, this.u0 = 0, this.v0 = 0, this.u1 = 0, this.v1 = 0, this.data = {
                        cut: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                            r: 0,
                            b: 0
                        },
                        trim: !1,
                        sourceSize: {
                            w: 0,
                            h: 0
                        },
                        spriteSourceSize: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                            r: 0,
                            b: 0
                        },
                        radius: 0,
                        drawImage: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        }
                    }, this.setSize(r, o, n, s);
                },
                setSize: function(t, e, i, n) {
                    void 0 === i && (i = 0), void 0 === n && (n = 0), this.cutX = i, this.cutY = n, this.cutWidth = t, this.cutHeight = e, this.width = t, this.height = e, this.halfWidth = Math.floor(.5 * t), this.halfHeight = Math.floor(.5 * e), this.centerX = Math.floor(t / 2), this.centerY = Math.floor(e / 2);
                    var s = this.data, r = s.cut;
                    r.x = i, r.y = n, r.w = t, r.h = e, r.r = i + t, r.b = n + e, s.sourceSize.w = t, s.sourceSize.h = e, s.spriteSourceSize.w = t, s.spriteSourceSize.h = e, s.radius = .5 * Math.sqrt(t * t + e * e);
                    var o = s.drawImage;
                    return o.x = i, o.y = n, o.width = t, o.height = e, this.updateUVs();
                },
                setTrim: function(t, e, i, n, s, r) {
                    var o = this.data, a = o.spriteSourceSize;
                    return o.trim = !0, o.sourceSize.w = t, o.sourceSize.h = e, a.x = i, a.y = n, a.w = s, a.h = r, a.r = i + s, a.b = n + r, this.x = i, this.y = n, this.width = s, this.height = r, this.halfWidth = .5 * s, this.halfHeight = .5 * r, this.centerX = Math.floor(s / 2), this.centerY = Math.floor(r / 2), this.updateUVs();
                },
                setCropUVs: function(t, e, i, n, s, r, o) {
                    var a, h, l, u, c, d, f, p = this.cutX, g = this.cutY, v = this.cutWidth, m = this.cutHeight, y = this.realWidth, x = this.realHeight, T = p + (e = C(e, 0, y)), w = g + (i = C(i, 0, x)), b = n = C(n, 0, y - e), E = s = C(s, 0, x - i), S = this.data;
                    S.trim ? (a = S.spriteSourceSize, h = e + (n = C(n, 0, v - e)), l = i + (s = C(s, 0, m - i)), !(a.r < e || a.b < i || a.x > h || a.y > l) ? (u = Math.max(a.x, e), c = Math.max(a.y, i), b = d = Math.min(a.r, h) - u, E = f = Math.min(a.b, l) - c, T = r ? p + (v - (u - a.x) - d) : p + (u - a.x), w = o ? g + (m - (c - a.y) - f) : g + (c - a.y), e = u, i = c, n = d, s = f) : E = b = w = T = 0) : (r && (T = p + (v - e - n)), o && (w = g + (m - i - s)));
                    var A = this.source.width, _ = this.source.height;
                    return t.u0 = Math.max(0, T / A), t.v0 = Math.max(0, w / _), t.u1 = Math.min(1, (T + b) / A), t.v1 = Math.min(1, (w + E) / _), t.x = e, t.y = i, t.cx = T, t.cy = w, t.cw = b, t.ch = E, t.width = n, t.height = s, t.flipX = r, t.flipY = o, t;
                },
                updateCropUVs: function(t, e, i) {
                    return this.setCropUVs(t, t.x, t.y, t.width, t.height, e, i);
                },
                setUVs: function(t, e, i, n, s, r) {
                    var o = this.data.drawImage;
                    return o.width = t, o.height = e, this.u0 = i, this.v0 = n, this.u1 = s, this.v1 = r, this;
                },
                updateUVs: function() {
                    var t = this.cutX, e = this.cutY, i = this.cutWidth, n = this.cutHeight, s = this.data.drawImage;
                    s.width = i, s.height = n;
                    var r = this.source.width, o = this.source.height;
                    return this.u0 = t / r, this.v0 = e / o, this.u1 = (t + i) / r, this.v1 = (e + n) / o, this;
                },
                updateUVsInverted: function() {
                    var t = this.source.width, e = this.source.height;
                    return this.u0 = (this.cutX + this.cutHeight) / t, this.v0 = this.cutY / e, this.u1 = this.cutX / t, this.v1 = (this.cutY + this.cutWidth) / e, this;
                },
                clone: function() {
                    var t = new r(this.texture, this.name, this.sourceIndex);
                    return t.cutX = this.cutX, t.cutY = this.cutY, t.cutWidth = this.cutWidth, t.cutHeight = this.cutHeight, t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t.halfWidth = this.halfWidth, t.halfHeight = this.halfHeight, t.centerX = this.centerX, t.centerY = this.centerY, t.rotated = this.rotated, t.data = s(!0, t.data, this.data), t.updateUVs(), t;
                },
                destroy: function() {
                    this.source = null, this.texture = null, this.glTexture = null, this.customData = null, this.data = null;
                },
                realWidth: {
                    get: function() {
                        return this.data.sourceSize.w;
                    }
                },
                realHeight: {
                    get: function() {
                        return this.data.sourceSize.h;
                    }
                },
                radius: {
                    get: function() {
                        return this.data.radius;
                    }
                },
                trimmed: {
                    get: function() {
                        return this.data.trim;
                    }
                },
                canvasData: {
                    get: function() {
                        return this.data.drawImage;
                    }
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var s = i(205), n = i(0), r = i(1), o = i(79), a = new n({
                initialize: function(t) {
                    this.parent = t, this.list = [], this.position = 0, this.addCallback = r, this.removeCallback = r, this._sortKey = "";
                },
                add: function(t, e) {
                    return e ? s.Add(this.list, t) : s.Add(this.list, t, 0, this.addCallback, this);
                },
                addAt: function(t, e, i) {
                    return i ? s.AddAt(this.list, t, e) : s.AddAt(this.list, t, e, 0, this.addCallback, this);
                },
                getAt: function(t) {
                    return this.list[t];
                },
                getIndex: function(t) {
                    return this.list.indexOf(t);
                },
                sort: function(i, t) {
                    return i && (void 0 === t && (t = function(t, e) {
                        return t[i] - e[i];
                    }), o(this.list, t)), this;
                },
                getByName: function(t) {
                    return s.GetFirst(this.list, "name", t);
                },
                getRandom: function(t, e) {
                    return s.GetRandom(this.list, t, e);
                },
                getFirst: function(t, e, i, n) {
                    return s.GetFirst(this.list, t, e, i, n);
                },
                getAll: function(t, e, i, n) {
                    return s.GetAll(this.list, t, e, i, n);
                },
                count: function(t, e) {
                    return s.CountAllMatching(this.list, t, e);
                },
                swap: function(t, e) {
                    s.Swap(this.list, t, e);
                },
                moveTo: function(t, e) {
                    return s.MoveTo(this.list, t, e);
                },
                remove: function(t, e) {
                    return e ? s.Remove(this.list, t) : s.Remove(this.list, t, this.removeCallback, this);
                },
                removeAt: function(t, e) {
                    return e ? s.RemoveAt(this.list, t) : s.RemoveAt(this.list, t, this.removeCallback, this);
                },
                removeBetween: function(t, e, i) {
                    return i ? s.RemoveBetween(this.list, t, e) : s.RemoveBetween(this.list, t, e, this.removeCallback, this);
                },
                removeAll: function(t) {
                    for(var e = this.list.length; e--;)this.remove(this.list[e], t);
                    return this;
                },
                bringToTop: function(t) {
                    return s.BringToTop(this.list, t);
                },
                sendToBack: function(t) {
                    return s.SendToBack(this.list, t);
                },
                moveUp: function(t) {
                    return s.MoveUp(this.list, t), t;
                },
                moveDown: function(t) {
                    return s.MoveDown(this.list, t), t;
                },
                reverse: function() {
                    return this.list.reverse(), this;
                },
                shuffle: function() {
                    return s.Shuffle(this.list), this;
                },
                replace: function(t, e) {
                    return s.Replace(this.list, t, e);
                },
                exists: function(t) {
                    return -1 < this.list.indexOf(t);
                },
                setAll: function(t, e, i, n) {
                    return s.SetAll(this.list, t, e, i, n), this;
                },
                each: function(t, e) {
                    for(var i = [
                        null
                    ], n = 2; n < arguments.length; n++)i.push(arguments[n]);
                    for(n = 0; n < this.list.length; n++)i[0] = this.list[n], t.apply(e, i);
                },
                shutdown: function() {
                    this.removeAll(), this.list = [];
                },
                destroy: function() {
                    this.removeAll(), this.parent = null, this.addCallback = null, this.removeCallback = null;
                },
                length: {
                    get: function() {
                        return this.list.length;
                    }
                },
                first: {
                    get: function() {
                        return (this.position = 0) < this.list.length ? this.list[0] : null;
                    }
                },
                last: {
                    get: function() {
                        return 0 < this.list.length ? (this.position = this.list.length - 1, this.list[this.position]) : null;
                    }
                },
                next: {
                    get: function() {
                        return this.position < this.list.length ? (this.position++, this.list[this.position]) : null;
                    }
                },
                previous: {
                    get: function() {
                        return 0 < this.position ? (this.position--, this.list[this.position]) : null;
                    }
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(109), r = i(439), o = i(440), a = i(55), h = i(177), l = new n({
                initialize: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), this.type = a.ELLIPSE, this.x = t, this.y = e, this.width = i, this.height = n;
                },
                contains: function(t, e) {
                    return s(this, t, e);
                },
                getPoint: function(t, e) {
                    return r(this, t, e);
                },
                getPoints: function(t, e, i) {
                    return o(this, t, e, i);
                },
                getRandomPoint: function(t) {
                    return h(this, t);
                },
                setTo: function(t, e, i, n) {
                    return this.x = t, this.y = e, this.width = i, this.height = n, this;
                },
                setEmpty: function() {
                    return this.width = 0, this.height = 0, this;
                },
                setPosition: function(t, e) {
                    return void 0 === e && (e = t), this.x = t, this.y = e, this;
                },
                setSize: function(t, e) {
                    return void 0 === e && (e = t), this.width = t, this.height = e, this;
                },
                isEmpty: function() {
                    return this.width <= 0 || this.height <= 0;
                },
                getMinorRadius: function() {
                    return Math.min(this.width, this.height) / 2;
                },
                getMajorRadius: function() {
                    return Math.max(this.width, this.height) / 2;
                },
                left: {
                    get: function() {
                        return this.x - this.width / 2;
                    },
                    set: function(t) {
                        this.x = t + this.width / 2;
                    }
                },
                right: {
                    get: function() {
                        return this.x + this.width / 2;
                    },
                    set: function(t) {
                        this.x = t - this.width / 2;
                    }
                },
                top: {
                    get: function() {
                        return this.y - this.height / 2;
                    },
                    set: function(t) {
                        this.y = t + this.height / 2;
                    }
                },
                bottom: {
                    get: function() {
                        return this.y + this.height / 2;
                    },
                    set: function(t) {
                        this.y = t - this.height / 2;
                    }
                }
            });
            t.exports = l;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (t.width <= 0 || t.height <= 0) return !1;
                var n = (e - t.x) / t.width, s = (i - t.y) / t.height;
                return (n *= n) + (s *= s) < .25;
            };
        },
        function(t, e, i) {
            var X = i(269), n = i(0), r = i(75), s = i(9), o = i(204), z = i(2), G = i(6), a = i(7), W = i(431), h = i(148), l = i(73), u = new n({
                Extends: s,
                initialize: function(t, e, i) {
                    s.call(this), i ? e && !Array.isArray(e) && (e = [
                        e
                    ]) : Array.isArray(e) ? a(e[0]) && (i = e, e = null) : a(e) && (i = e, e = null), this.scene = t, this.children = new h, this.isParent = !0, this.type = "Group", this.classType = z(i, "classType", l), this.name = z(i, "name", ""), this.active = z(i, "active", !0), this.maxSize = z(i, "maxSize", -1), this.defaultKey = z(i, "defaultKey", null), this.defaultFrame = z(i, "defaultFrame", null), this.runChildUpdate = z(i, "runChildUpdate", !1), this.createCallback = z(i, "createCallback", null), this.removeCallback = z(i, "removeCallback", null), this.createMultipleCallback = z(i, "createMultipleCallback", null), this.internalCreateCallback = z(i, "internalCreateCallback", null), this.internalRemoveCallback = z(i, "internalRemoveCallback", null), e && this.addMultiple(e), i && this.createMultiple(i);
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                create: function(t, e, i, n, s, r) {
                    if (void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.defaultKey), void 0 === n && (n = this.defaultFrame), void 0 === s && (s = !0), void 0 === r && (r = !0), this.isFull()) return null;
                    var o = new this.classType(this.scene, t, e, i, n);
                    return this.scene.sys.displayList.add(o), o.preUpdate && this.scene.sys.updateList.add(o), o.visible = s, o.setActive(r), this.add(o), o;
                },
                createMultiple: function(t) {
                    if (this.isFull()) return [];
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    var e = [];
                    if (t[0].key) for(var i = 0; i < t.length; i++)var n = this.createFromConfig(t[i]), e = e.concat(n);
                    return e;
                },
                createFromConfig: function(t) {
                    if (this.isFull()) return [];
                    this.classType = z(t, "classType", this.classType);
                    var e = z(t, "key", void 0), i = z(t, "frame", null), n = z(t, "visible", !0), s = z(t, "active", !0), r = [];
                    if (void 0 === e) return r;
                    Array.isArray(e) || (e = [
                        e
                    ]), Array.isArray(i) || (i = [
                        i
                    ]);
                    var o = z(t, "repeat", 0), a = z(t, "randomKey", !1), h = z(t, "randomFrame", !1), l = z(t, "yoyo", !1), u = z(t, "quantity", !1), c = z(t, "frameQuantity", 1), d = z(t, "max", 0), f = W(e, i, {
                        max: d,
                        qty: u || c,
                        random: a,
                        randomB: h,
                        repeat: o,
                        yoyo: l
                    });
                    t.createCallback && (this.createCallback = t.createCallback), t.removeCallback && (this.removeCallback = t.removeCallback);
                    for(var p = 0; p < f.length; p++){
                        var g = this.create(0, 0, f[p].a, f[p].b, n, s);
                        if (!g) break;
                        r.push(g);
                    }
                    var v = G(t, "setXY.x", 0), m = G(t, "setXY.y", 0), y = G(t, "setXY.stepX", 0), x = G(t, "setXY.stepY", 0);
                    X.SetXY(r, v, m, y, x);
                    var T = G(t, "setRotation.value", 0), w = G(t, "setRotation.step", 0);
                    X.SetRotation(r, T, w);
                    var b = G(t, "setScale.x", 1), E = G(t, "setScale.y", b), S = G(t, "setScale.stepX", 0), A = G(t, "setScale.stepY", 0);
                    X.SetScale(r, b, E, S, A);
                    var _ = G(t, "setOrigin.x", .5), C = G(t, "setOrigin.y", _), M = G(t, "setOrigin.stepX", 0), R = G(t, "setOrigin.stepY", 0);
                    X.SetOrigin(r, _, C, M, R);
                    var P = G(t, "setAlpha.value", 1), O = G(t, "setAlpha.step", 0);
                    X.SetAlpha(r, P, O);
                    var L = G(t, "setDepth.value", 0), D = G(t, "setDepth.step", 0);
                    X.SetDepth(r, L, D);
                    var F = G(t, "setScrollFactor.x", 1), k = G(t, "setScrollFactor.y", F), I = G(t, "setScrollFactor.stepX", 0), B = G(t, "setScrollFactor.stepY", 0);
                    X.SetScrollFactor(r, F, k, I, B);
                    var N = z(t, "hitArea", null), Y = z(t, "hitAreaCallback", null);
                    N && X.SetHitArea(r, N, Y);
                    var U = z(t, "gridAlign", !1);
                    return U && X.GridAlign(r, U), this.createMultipleCallback && this.createMultipleCallback.call(this, r), r;
                },
                preUpdate: function(t, e) {
                    if (this.runChildUpdate && 0 !== this.children.size) for(var i = this.children.entries.slice(), n = 0; n < i.length; n++){
                        var s = i[n];
                        s.active && s.update(t, e);
                    }
                },
                add: function(t, e) {
                    return void 0 === e && (e = !1), this.isFull() || (this.children.set(t), this.internalCreateCallback && this.internalCreateCallback.call(this, t), this.createCallback && this.createCallback.call(this, t), e && (this.scene.sys.displayList.add(t), t.preUpdate && this.scene.sys.updateList.add(t)), t.on(r.DESTROY, this.remove, this)), this;
                },
                addMultiple: function(t, e) {
                    if (void 0 === e && (e = !1), Array.isArray(t)) for(var i = 0; i < t.length; i++)this.add(t[i], e);
                    return this;
                },
                remove: function(t, e, i) {
                    return void 0 === e && (e = !1), void 0 === i && (i = !1), this.children.contains(t) && (this.children.delete(t), this.internalRemoveCallback && this.internalRemoveCallback.call(this, t), this.removeCallback && this.removeCallback.call(this, t), t.off(r.DESTROY, this.remove, this), i ? t.destroy() : e && (t.scene.sys.displayList.remove(t), t.preUpdate && t.scene.sys.updateList.remove(t))), this;
                },
                clear: function(t, e) {
                    void 0 === t && (t = !1), void 0 === e && (e = !1);
                    for(var i = this.children, n = 0; n < i.size; n++){
                        var s = i.entries[n];
                        s.off(r.DESTROY, this.remove, this), e ? s.destroy() : t && (s.scene.sys.displayList.remove(s), s.preUpdate && s.scene.sys.updateList.remove(s));
                    }
                    return this.children.clear(), this;
                },
                contains: function(t) {
                    return this.children.contains(t);
                },
                getChildren: function() {
                    return this.children.entries;
                },
                getLength: function() {
                    return this.children.size;
                },
                getMatching: function(t, e, i, n) {
                    return o(this.children.entries, t, e, i, n);
                },
                getFirst: function(t, e, i, n, s, r, o) {
                    return this.getHandler(!0, 1, t, e, i, n, s, r, o);
                },
                getFirstNth: function(t, e, i, n, s, r, o, a) {
                    return this.getHandler(!0, t, e, i, n, s, r, o, a);
                },
                getLast: function(t, e, i, n, s, r, o) {
                    return this.getHandler(!1, 1, t, e, i, n, s, r, o);
                },
                getLastNth: function(t, e, i, n, s, r, o, a) {
                    return this.getHandler(!1, t, e, i, n, s, r, o, a);
                },
                getHandler: function(t, e, i, n, s, r, o, a, h) {
                    var l, u;
                    void 0 === i && (i = !1), void 0 === n && (n = !1);
                    var c = 0, d = this.children.entries;
                    if (t) for(u = 0; u < d.length; u++)if ((l = d[u]).active === i) {
                        if (++c === e) break;
                    } else l = null;
                    else for(u = d.length - 1; 0 <= u; u--)if ((l = d[u]).active === i) {
                        if (++c === e) break;
                    } else l = null;
                    return l ? ("number" == typeof s && (l.x = s), "number" == typeof r && (l.y = r), l) : n ? this.create(s, r, o, a, h) : null;
                },
                get: function(t, e, i, n, s) {
                    return this.getFirst(!1, !0, t, e, i, n, s);
                },
                getFirstAlive: function(t, e, i, n, s, r) {
                    return this.getFirst(!0, t, e, i, n, s, r);
                },
                getFirstDead: function(t, e, i, n, s, r) {
                    return this.getFirst(!1, t, e, i, n, s, r);
                },
                playAnimation: function(t, e) {
                    return X.PlayAnimation(this.children.entries, t, e), this;
                },
                isFull: function() {
                    return -1 !== this.maxSize && this.children.size >= this.maxSize;
                },
                countActive: function(t) {
                    void 0 === t && (t = !0);
                    for(var e = 0, i = 0; i < this.children.size; i++)this.children.entries[i].active === t && e++;
                    return e;
                },
                getTotalUsed: function() {
                    return this.countActive();
                },
                getTotalFree: function() {
                    var t = this.getTotalUsed();
                    return (-1 === this.maxSize ? 999999999999 : this.maxSize) - t;
                },
                setActive: function(t) {
                    return this.active = t, this;
                },
                setName: function(t) {
                    return this.name = t, this;
                },
                propertyValueSet: function(t, e, i, n, s) {
                    return X.PropertyValueSet(this.children.entries, t, e, i, n, s), this;
                },
                propertyValueInc: function(t, e, i, n, s) {
                    return X.PropertyValueInc(this.children.entries, t, e, i, n, s), this;
                },
                setX: function(t, e) {
                    return X.SetX(this.children.entries, t, e), this;
                },
                setY: function(t, e) {
                    return X.SetY(this.children.entries, t, e), this;
                },
                setXY: function(t, e, i, n) {
                    return X.SetXY(this.children.entries, t, e, i, n), this;
                },
                incX: function(t, e) {
                    return X.IncX(this.children.entries, t, e), this;
                },
                incY: function(t, e) {
                    return X.IncY(this.children.entries, t, e), this;
                },
                incXY: function(t, e, i, n) {
                    return X.IncXY(this.children.entries, t, e, i, n), this;
                },
                shiftPosition: function(t, e, i) {
                    return X.ShiftPosition(this.children.entries, t, e, i), this;
                },
                angle: function(t, e) {
                    return X.Angle(this.children.entries, t, e), this;
                },
                rotate: function(t, e) {
                    return X.Rotate(this.children.entries, t, e), this;
                },
                rotateAround: function(t, e) {
                    return X.RotateAround(this.children.entries, t, e), this;
                },
                rotateAroundDistance: function(t, e, i) {
                    return X.RotateAroundDistance(this.children.entries, t, e, i), this;
                },
                setAlpha: function(t, e) {
                    return X.SetAlpha(this.children.entries, t, e), this;
                },
                setTint: function(t, e, i, n) {
                    return X.SetTint(this.children.entries, t, e, i, n), this;
                },
                setOrigin: function(t, e, i, n) {
                    return X.SetOrigin(this.children.entries, t, e, i, n), this;
                },
                scaleX: function(t, e) {
                    return X.ScaleX(this.children.entries, t, e), this;
                },
                scaleY: function(t, e) {
                    return X.ScaleY(this.children.entries, t, e), this;
                },
                scaleXY: function(t, e, i, n) {
                    return X.ScaleXY(this.children.entries, t, e, i, n), this;
                },
                setDepth: function(t, e) {
                    return X.SetDepth(this.children.entries, t, e), this;
                },
                setBlendMode: function(t) {
                    return X.SetBlendMode(this.children.entries, t), this;
                },
                setHitArea: function(t, e) {
                    return X.SetHitArea(this.children.entries, t, e), this;
                },
                shuffle: function() {
                    return X.Shuffle(this.children.entries), this;
                },
                kill: function(t) {
                    this.children.contains(t) && t.setActive(!1);
                },
                killAndHide: function(t) {
                    this.children.contains(t) && (t.setActive(!1), t.setVisible(!1));
                },
                setVisible: function(t, e, i) {
                    return X.SetVisible(this.children.entries, t, e, i), this;
                },
                toggleVisible: function() {
                    return X.ToggleVisible(this.children.entries), this;
                },
                destroy: function(t) {
                    void 0 === t && (t = !1), this.scene && !this.ignoreDestroy && (this.clear(!1, t), this.scene = void 0, this.children = void 0);
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var A = i(12);
            t.exports = function(t, e, i, n, s, r) {
                for(var o = A.getTintAppendFloatAlpha(i.fillColor, i.fillAlpha * n), a = i.pathData, h = i.pathIndexes, l = 0; l < h.length; l += 3){
                    var u = 2 * h[l], c = 2 * h[l + 1], d = 2 * h[l + 2], f = a[0 + u] - s, p = a[1 + u] - r, g = a[0 + c] - s, v = a[1 + c] - r, m = a[0 + d] - s, y = a[1 + d] - r, x = e.getX(f, p), T = e.getY(f, p), w = e.getX(g, v), b = e.getY(g, v), E = e.getX(m, y), S = e.getY(m, y);
                    t.batchTri(x, T, w, b, E, S, o, o, o);
                }
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = t.x3 - t.x1, s = t.y3 - t.y1, r = t.x2 - t.x1, o = t.y2 - t.y1, a = e - t.x1, h = i - t.y1, l = n * n + s * s, u = n * r + s * o, c = n * a + s * h, d = r * r + o * o, f = r * a + o * h, p = l * d - u * u, g = 0 == p ? 0 : 1 / p, v = (d * c - u * f) * g, m = (l * f - u * c) * g;
                return 0 <= v && 0 <= m && v + m < 1;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(10), g = i(114), r = i(3);
            function p(t, e, i, n) {
                var s = t - i, r = e - n, o = s * s + r * r;
                return Math.sqrt(o);
            }
            var o = new n({
                initialize: function(t, e, i) {
                    this.vertex1 = t, this.vertex2 = e, this.vertex3 = i, this.bounds = new s, this._inCenter = new r;
                },
                getInCenter: function(t) {
                    void 0 === t && (t = !0);
                    var e, i, n, s, r, o = this.vertex1, a = this.vertex2, h = this.vertex3, l = t ? (e = o.x, i = o.y, n = a.x, s = a.y, r = h.x, h.y) : (e = o.vx, i = o.vy, n = a.vx, s = a.vy, r = h.vx, h.vy), u = p(r, l, n, s), c = p(e, i, r, l), d = p(n, s, e, i), f = u + c + d;
                    return this._inCenter.set((e * u + n * c + r * d) / f, (i * u + s * c + l * d) / f);
                },
                contains: function(t, e, i) {
                    var n, s, r, o, a, h, l = this.vertex1, u = this.vertex2, c = this.vertex3, d = l.vx, f = l.vy, p = u.vx, g = u.vy, v = c.vx, m = c.vy;
                    i && (n = i.a, s = i.b, r = i.c, o = i.d, a = i.e, h = i.f, d = l.vx * n + l.vy * r + a, f = l.vx * s + l.vy * o + h, p = u.vx * n + u.vy * r + a, g = u.vx * s + u.vy * o + h, v = c.vx * n + c.vy * r + a, m = c.vx * s + c.vy * o + h);
                    var y = v - d, x = m - f, T = p - d, w = g - f, b = t - d, E = e - f, S = y * y + x * x, A = y * T + x * w, _ = y * b + x * E, C = T * T + w * w, M = T * b + w * E, R = S * C - A * A, P = 0 == R ? 0 : 1 / R, O = (C * _ - A * M) * P, L = (S * M - A * _) * P;
                    return 0 <= O && 0 <= L && O + L < 1;
                },
                isCounterClockwise: function(t) {
                    var e = this.vertex1, i = this.vertex2, n = this.vertex3, s = (i.vx - e.vx) * (n.vy - e.vy) - (i.vy - e.vy) * (n.vx - e.vx);
                    return t <= 0 ? 0 <= s : s < 0;
                },
                load: function(t, e, i, n, s) {
                    return i = this.vertex1.load(t, e, i, n, s), i = this.vertex2.load(t, e, i, n, s), i = this.vertex3.load(t, e, i, n, s);
                },
                transformCoordinatesLocal: function(t, e, i, n) {
                    return this.vertex1.transformCoordinatesLocal(t, e, i, n), this.vertex2.transformCoordinatesLocal(t, e, i, n), this.vertex3.transformCoordinatesLocal(t, e, i, n), this;
                },
                updateBounds: function() {
                    var t = this.vertex1, e = this.vertex2, i = this.vertex3, n = this.bounds;
                    return n.x = Math.min(t.vx, e.vx, i.vx), n.y = Math.min(t.vy, e.vy, i.vy), n.width = Math.max(t.vx, e.vx, i.vx) - n.x, n.height = Math.max(t.vy, e.vy, i.vy) - n.y, this;
                },
                isInView: function(t, e, i, n, s, r, o, a, h, l, u) {
                    var c = this.vertex1.update(s, r, o, a, h, l, u, n), d = this.vertex2.update(s, r, o, a, h, l, u, n), f = this.vertex3.update(s, r, o, a, h, l, u, n);
                    if (c.ta <= 0 && d.ta <= 0 && f.ta <= 0) return !1;
                    if (e && !this.isCounterClockwise(i)) return !1;
                    var p = this.bounds;
                    return p.x = Math.min(c.tx, d.tx, f.tx), p.y = Math.min(c.ty, d.ty, f.ty), p.width = Math.max(c.tx, d.tx, f.tx) - p.x, p.height = Math.max(c.ty, d.ty, f.ty) - p.y, g(p, t.worldView);
                },
                translate: function(t, e) {
                    void 0 === e && (e = 0);
                    var i = this.vertex1, n = this.vertex2, s = this.vertex3;
                    return i.x += t, i.y += e, n.x += t, n.y += e, s.x += t, s.y += e, this;
                },
                x: {
                    get: function() {
                        return this.getInCenter().x;
                    },
                    set: function(t) {
                        var e = this.getInCenter();
                        this.translate(t - e.x, 0);
                    }
                },
                y: {
                    get: function() {
                        return this.getInCenter().y;
                    },
                    set: function(t) {
                        var e = this.getInCenter();
                        this.translate(0, t - e.y);
                    }
                },
                alpha: {
                    get: function() {
                        var t = this.vertex1, e = this.vertex2, i = this.vertex3;
                        return (t.alpha + e.alpha + i.alpha) / 3;
                    },
                    set: function(t) {
                        this.vertex1.alpha = t, this.vertex2.alpha = t, this.vertex3.alpha = t;
                    }
                },
                depth: {
                    get: function() {
                        var t = this.vertex1, e = this.vertex2, i = this.vertex3;
                        return (t.vz + e.vz + i.vz) / 3;
                    }
                },
                destroy: function() {
                    this.vertex1 = null, this.vertex2 = null, this.vertex3 = null;
                }
            });
            t.exports = o;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return !(t.width <= 0 || t.height <= 0 || e.width <= 0 || e.height <= 0) && !(t.right < e.x || t.bottom < e.y || t.x > e.right || t.y > e.bottom);
            };
        },
        function(t, e, i) {
            var n = i(0), r = i(12), u = i(38), s = new n({
                Extends: u,
                initialize: function(t, e, i, n, s, r, o, a, h, l) {
                    void 0 === r && (r = 16777215), void 0 === o && (o = 1), void 0 === a && (a = 0), void 0 === h && (h = 0), void 0 === l && (l = 0), u.call(this, t, e, i), this.vx = 0, this.vy = 0, this.vz = 0, this.nx = a, this.ny = h, this.nz = l, this.u = n, this.v = s, this.color = r, this.alpha = o, this.tx = 0, this.ty = 0, this.ta = 0;
                },
                setUVs: function(t, e) {
                    return this.u = t, this.v = e, this;
                },
                transformCoordinatesLocal: function(t, e, i, n) {
                    var s = this.x, r = this.y, o = this.z, a = t.val, h = s * a[0] + r * a[4] + o * a[8] + a[12], l = s * a[1] + r * a[5] + o * a[9] + a[13], u = s * a[2] + r * a[6] + o * a[10] + a[14], c = s * a[3] + r * a[7] + o * a[11] + a[15];
                    this.vx = h / c * e, this.vy = -l / c * i, this.vz = n <= 0 ? u / c : -u / c;
                },
                update: function(t, e, i, n, s, r, o, a) {
                    var h = this.vx * t + this.vy * i + s, l = this.vx * e + this.vy * n + r;
                    return o && (h = Math.round(h), l = Math.round(l)), this.tx = h, this.ty = l, this.ta = this.alpha * a, this;
                },
                load: function(t, e, i, n, s) {
                    return t[++i] = this.tx, t[++i] = this.ty, t[++i] = this.u, t[++i] = this.v, t[++i] = n, t[++i] = s, e[++i] = r.getTintAppendFloatAlpha(this.color, this.ta), i;
                }
            });
            t.exports = s;
        },
        function(t, e) {
            var i = {};
            (t.exports = i).create = function(t, e) {
                return {
                    x: t || 0,
                    y: e || 0
                };
            }, i.clone = function(t) {
                return {
                    x: t.x,
                    y: t.y
                };
            }, i.magnitude = function(t) {
                return Math.sqrt(t.x * t.x + t.y * t.y);
            }, i.magnitudeSquared = function(t) {
                return t.x * t.x + t.y * t.y;
            }, i.rotate = function(t, e, i) {
                var n = Math.cos(e), s = Math.sin(e);
                i = i || {};
                var r = t.x * n - t.y * s;
                return i.y = t.x * s + t.y * n, i.x = r, i;
            }, i.rotateAbout = function(t, e, i, n) {
                var s = Math.cos(e), r = Math.sin(e);
                n = n || {};
                var o = i.x + ((t.x - i.x) * s - (t.y - i.y) * r);
                return n.y = i.y + ((t.x - i.x) * r + (t.y - i.y) * s), n.x = o, n;
            }, i.normalise = function(t) {
                var e = i.magnitude(t);
                return 0 === e ? {
                    x: 0,
                    y: 0
                } : {
                    x: t.x / e,
                    y: t.y / e
                };
            }, i.dot = function(t, e) {
                return t.x * e.x + t.y * e.y;
            }, i.cross = function(t, e) {
                return t.x * e.y - t.y * e.x;
            }, i.cross3 = function(t, e, i) {
                return (e.x - t.x) * (i.y - t.y) - (e.y - t.y) * (i.x - t.x);
            }, i.add = function(t, e, i) {
                return (i = i || {}).x = t.x + e.x, i.y = t.y + e.y, i;
            }, i.sub = function(t, e, i) {
                return (i = i || {}).x = t.x - e.x, i.y = t.y - e.y, i;
            }, i.mult = function(t, e) {
                return {
                    x: t.x * e,
                    y: t.y * e
                };
            }, i.div = function(t, e) {
                return {
                    x: t.x / e,
                    y: t.y / e
                };
            }, i.perp = function(t, e) {
                return {
                    x: (e = !0 === e ? -1 : 1) * -t.y,
                    y: e * t.x
                };
            }, i.neg = function(t) {
                return {
                    x: -t.x,
                    y: -t.y
                };
            }, i.angle = function(t, e) {
                return Math.atan2(e.y - t.y, e.x - t.x);
            }, i._temp = [
                i.create(),
                i.create(),
                i.create(),
                i.create(),
                i.create(),
                i.create()
            ];
        },
        function(t, e) {
            var i = {};
            (t.exports = i).create = function(t) {
                var e = {
                    min: {
                        x: 0,
                        y: 0
                    },
                    max: {
                        x: 0,
                        y: 0
                    }
                };
                return t && i.update(e, t), e;
            }, i.update = function(t, e, i) {
                t.min.x = 1 / 0, t.max.x = -1 / 0, t.min.y = 1 / 0, t.max.y = -1 / 0;
                for(var n = 0; n < e.length; n++){
                    var s = e[n];
                    s.x > t.max.x && (t.max.x = s.x), s.x < t.min.x && (t.min.x = s.x), s.y > t.max.y && (t.max.y = s.y), s.y < t.min.y && (t.min.y = s.y);
                }
                i && (0 < i.x ? t.max.x += i.x : t.min.x += i.x, 0 < i.y ? t.max.y += i.y : t.min.y += i.y);
            }, i.contains = function(t, e) {
                return e.x >= t.min.x && e.x <= t.max.x && e.y >= t.min.y && e.y <= t.max.y;
            }, i.overlaps = function(t, e) {
                return t.min.x <= e.max.x && t.max.x >= e.min.x && t.max.y >= e.min.y && t.min.y <= e.max.y;
            }, i.translate = function(t, e) {
                t.min.x += e.x, t.max.x += e.x, t.min.y += e.y, t.max.y += e.y;
            }, i.shift = function(t, e) {
                var i = t.max.x - t.min.x, n = t.max.y - t.min.y;
                t.min.x = e.x, t.max.x = e.x + i, t.min.y = e.y, t.max.y = e.y + n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return 0 <= t && t < i.width && 0 <= e && e < i.height;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(29), r = i(2), o = new n({
                initialize: function(t) {
                    void 0 === t && (t = {}), this.name = r(t, "name", "layer"), this.x = r(t, "x", 0), this.y = r(t, "y", 0), this.width = r(t, "width", 0), this.height = r(t, "height", 0), this.tileWidth = r(t, "tileWidth", 0), this.tileHeight = r(t, "tileHeight", 0), this.baseTileWidth = r(t, "baseTileWidth", this.tileWidth), this.baseTileHeight = r(t, "baseTileHeight", this.tileHeight), this.orientation = r(t, "orientation", s.ORTHOGONAL), this.widthInPixels = r(t, "widthInPixels", this.width * this.baseTileWidth), this.heightInPixels = r(t, "heightInPixels", this.height * this.baseTileHeight), this.alpha = r(t, "alpha", 1), this.visible = r(t, "visible", !0), this.properties = r(t, "properties", []), this.indexes = r(t, "indexes", []), this.collideIndexes = r(t, "collideIndexes", []), this.callbacks = r(t, "callbacks", []), this.bodies = r(t, "bodies", []), this.data = r(t, "data", []), this.tilemapLayer = r(t, "tilemapLayer", null), this.hexSideLength = r(t, "hexSideLength", 0);
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(29), r = i(2), o = new n({
                initialize: function(t) {
                    void 0 === t && (t = {}), this.name = r(t, "name", "map"), this.width = r(t, "width", 0), this.height = r(t, "height", 0), this.infinite = r(t, "infinite", !1), this.tileWidth = r(t, "tileWidth", 0), this.tileHeight = r(t, "tileHeight", 0), this.widthInPixels = r(t, "widthInPixels", this.width * this.tileWidth), this.heightInPixels = r(t, "heightInPixels", this.height * this.tileHeight), this.format = r(t, "format", null), this.orientation = r(t, "orientation", s.ORTHOGONAL), this.renderOrder = r(t, "renderOrder", "right-down"), this.version = r(t, "version", "1"), this.properties = r(t, "properties", {}), this.layers = r(t, "layers", []), this.images = r(t, "images", []), this.objects = r(t, "objects", {}), this.collision = r(t, "collision", {}), this.tilesets = r(t, "tilesets", []), this.imageCollections = r(t, "imageCollections", []), this.tiles = r(t, "tiles", []), this.hexSideLength = r(t, "hexSideLength", 0);
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n, s, r, o, a) {
                    (void 0 === i || i <= 0) && (i = 32), (void 0 === n || n <= 0) && (n = 32), void 0 === s && (s = 0), void 0 === r && (r = 0), void 0 === o && (o = {}), void 0 === a && (a = {}), this.name = t, this.firstgid = e, this.tileWidth = i, this.tileHeight = n, this.tileMargin = s, this.tileSpacing = r, this.tileProperties = o, this.tileData = a, this.image = null, this.glTexture = null, this.rows = 0, this.columns = 0, this.total = 0, this.texCoordinates = [];
                },
                getTileProperties: function(t) {
                    return this.containsTileIndex(t) ? this.tileProperties[t - this.firstgid] : null;
                },
                getTileData: function(t) {
                    return this.containsTileIndex(t) ? this.tileData[t - this.firstgid] : null;
                },
                getTileCollisionGroup: function(t) {
                    var e = this.getTileData(t);
                    return e && e.objectgroup ? e.objectgroup : null;
                },
                containsTileIndex: function(t) {
                    return t >= this.firstgid && t < this.firstgid + this.total;
                },
                getTileTextureCoordinates: function(t) {
                    return this.containsTileIndex(t) ? this.texCoordinates[t - this.firstgid] : null;
                },
                setImage: function(t) {
                    return this.image = t, this.glTexture = t.get().source.glTexture, this.updateTileData(this.image.source[0].width, this.image.source[0].height), this;
                },
                setTileSize: function(t, e) {
                    return void 0 !== t && (this.tileWidth = t), void 0 !== e && (this.tileHeight = e), this.image && this.updateTileData(this.image.source[0].width, this.image.source[0].height), this;
                },
                setSpacing: function(t, e) {
                    return void 0 !== t && (this.tileMargin = t), void 0 !== e && (this.tileSpacing = e), this.image && this.updateTileData(this.image.source[0].width, this.image.source[0].height), this;
                },
                updateTileData: function(t, e) {
                    var i = (e - 2 * this.tileMargin + this.tileSpacing) / (this.tileHeight + this.tileSpacing), n = (t - 2 * this.tileMargin + this.tileSpacing) / (this.tileWidth + this.tileSpacing);
                    i % 1 == 0 && n % 1 == 0 || console.warn("Image tile area not tile size multiple in: " + this.name), i = Math.floor(i), n = Math.floor(n), this.rows = i, this.columns = n, this.total = i * n, this.texCoordinates.length = 0;
                    for(var s = this.tileMargin, r = this.tileMargin, o = 0; o < this.rows; o++){
                        for(var a = 0; a < this.columns; a++)this.texCoordinates.push({
                            x: s,
                            y: r
                        }), s += this.tileWidth + this.tileSpacing;
                        s = this.tileMargin, r += this.tileHeight + this.tileSpacing;
                    }
                    return this;
                }
            });
            t.exports = n;
        },
        function(t, e) {
            t.exports = {
                TOP_LEFT: 0,
                TOP_CENTER: 1,
                TOP_RIGHT: 2,
                LEFT_TOP: 3,
                LEFT_CENTER: 4,
                LEFT_BOTTOM: 5,
                CENTER: 6,
                RIGHT_TOP: 7,
                RIGHT_CENTER: 8,
                RIGHT_BOTTOM: 9,
                BOTTOM_LEFT: 10,
                BOTTOM_CENTER: 11,
                BOTTOM_RIGHT: 12
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return void 0 === i && (i = 1e-4), Math.abs(t - e) < i;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(15), o = i(1062), a = new n({
                Extends: r,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.Depth,
                    s.Flip,
                    s.GetBounds,
                    s.Mask,
                    s.Origin,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Size,
                    s.TextureCrop,
                    s.Tint,
                    s.Transform,
                    s.Visible,
                    o
                ],
                initialize: function(t, e, i, n, s) {
                    r.call(this, t, "Image"), this._crop = this.resetCropObject(), this.setTexture(n, s), this.setPosition(e, i), this.setSizeToFrame(), this.setOriginFromFrame(), this.initPipeline();
                }
            });
            t.exports = a;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.hasOwnProperty(e);
            };
        },
        function(t, e, i) {
            var v = {};
            t.exports = v;
            var m = i(94), y = i(50), x = i(71), d = i(117), f = i(116), T = i(1487);
            v.rectangle = function(t, e, i, n, s) {
                s = s || {};
                var r, o = {
                    label: "Rectangle Body",
                    position: {
                        x: t,
                        y: e
                    },
                    vertices: m.fromPath("L 0 0 L " + i + " 0 L " + i + " " + n + " L 0 " + n)
                };
                return s.chamfer && (r = s.chamfer, o.vertices = m.chamfer(o.vertices, r.radius, r.quality, r.qualityMin, r.qualityMax), delete s.chamfer), x.create(y.extend({}, o, s));
            }, v.trapezoid = function(t, e, i, n, s, r) {
                r = r || {};
                var o, a = i * (s *= .5), h = a + (1 - 2 * s) * i, l = h + a, u = s < .5 ? "L 0 0 L " + a + " " + -n + " L " + h + " " + -n + " L " + l + " 0" : "L 0 0 L " + h + " " + -n + " L " + l + " 0", c = {
                    label: "Trapezoid Body",
                    position: {
                        x: t,
                        y: e
                    },
                    vertices: m.fromPath(u)
                };
                return r.chamfer && (o = r.chamfer, c.vertices = m.chamfer(c.vertices, o.radius, o.quality, o.qualityMin, o.qualityMax), delete r.chamfer), x.create(y.extend({}, c, r));
            }, v.circle = function(t, e, i, n, s) {
                n = n || {};
                var r = {
                    label: "Circle Body",
                    circleRadius: i
                };
                s = s || 25;
                var o = Math.ceil(Math.max(10, Math.min(s, i)));
                return o % 2 == 1 && (o += 1), v.polygon(t, e, o, i, y.extend({}, r, n));
            }, v.polygon = function(t, e, i, n, s) {
                if (s = s || {}, i < 3) return v.circle(t, e, n, s);
                for(var r = 2 * Math.PI / i, o = "", a = .5 * r, h = 0; h < i; h += 1){
                    var l = a + h * r, u = Math.cos(l) * n, c = Math.sin(l) * n;
                    o += "L " + u.toFixed(3) + " " + c.toFixed(3) + " ";
                }
                var d, f = {
                    label: "Polygon Body",
                    position: {
                        x: t,
                        y: e
                    },
                    vertices: m.fromPath(o)
                };
                return s.chamfer && (d = s.chamfer, f.vertices = m.chamfer(f.vertices, d.radius, d.quality, d.qualityMin, d.qualityMax), delete s.chamfer), x.create(y.extend({}, f, s));
            }, v.fromVertices = function(t, e, i, n, s, r, o) {
                var a, h, l, u, c;
                for(n = n || {}, h = [], s = void 0 !== s && s, r = void 0 !== r ? r : .01, o = void 0 !== o ? o : 10, T || y.warn("Bodies.fromVertices: poly-decomp.js required. Could not decompose vertices. Fallback to convex hull."), y.isArray(i[0]) || (i = [
                    i
                ]), c = 0; c < i.length; c += 1)if (u = i[c], (l = m.isConvex(u)) || !T) u = l ? m.clockwiseSort(u) : m.hull(u), h.push({
                    position: {
                        x: t,
                        y: e
                    },
                    vertices: u
                });
                else {
                    var d = u.map(function(t) {
                        return [
                            t.x,
                            t.y
                        ];
                    });
                    T.makeCCW(d), !1 !== r && T.removeCollinearPoints(d, r);
                    for(var f = T.quickDecomp(d), p = 0; p < f.length; p++){
                        var g = f[p].map(function(t) {
                            return {
                                x: t[0],
                                y: t[1]
                            };
                        });
                        0 < o && m.area(g) < o || h.push({
                            position: m.centre(g),
                            vertices: g
                        });
                    }
                }
                for(p = 0; p < h.length; p++)h[p] = x.create(y.extend(h[p], n));
                return s && v.flagCoincidentParts(h, 5), 1 < h.length ? (a = x.create(y.extend({
                    parts: h.slice(0)
                }, n)), x.setPosition(a, {
                    x: t,
                    y: e
                }), a) : h[0];
            }, v.flagCoincidentParts = function(t, e) {
                void 0 === e && (e = 5);
                for(var i = 0; i < t.length; i++)for(var n = t[i], s = i + 1; s < t.length; s++){
                    var r = t[s];
                    if (d.overlaps(n.bounds, r.bounds)) for(var o = n.vertices, a = r.vertices, h = 0; h < n.vertices.length; h++)for(var l = 0; l < r.vertices.length; l++){
                        var u = f.magnitudeSquared(f.sub(o[(h + 1) % o.length], a[l])), c = f.magnitudeSquared(f.sub(o[h], a[(l + 1) % a.length]));
                        u < e && c < e && (o[h].isInternal = !0, a[l].isInternal = !0);
                    }
                }
                return t;
            };
        },
        function(t, e, i) {
            var r = i(34), n = i(62), s = i(63), o = i(0), a = i(11), h = i(15), l = i(10), u = i(56), c = new o({
                Extends: h,
                Mixins: [
                    a.Depth,
                    a.GetBounds,
                    a.Origin,
                    a.Transform,
                    a.ScrollFactor,
                    a.Visible
                ],
                initialize: function(t, e, i, n, s) {
                    void 0 === n && (n = 1), void 0 === s && (s = n), h.call(this, t, "Zone"), this.setPosition(e, i), this.width = n, this.height = s, this.blendMode = r.NORMAL, this.updateDisplayOrigin();
                },
                displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(t) {
                        this.scaleX = t / this.width;
                    }
                },
                displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(t) {
                        this.scaleY = t / this.height;
                    }
                },
                setSize: function(t, e, i) {
                    void 0 === i && (i = !0), this.width = t, this.height = e, this.updateDisplayOrigin();
                    var n = this.input;
                    return i && n && !n.customHitArea && (n.hitArea.width = t, n.hitArea.height = e), this;
                },
                setDisplaySize: function(t, e) {
                    return this.displayWidth = t, this.displayHeight = e, this;
                },
                setCircleDropZone: function(t) {
                    return this.setDropZone(new n(0, 0, t), s);
                },
                setRectangleDropZone: function(t, e) {
                    return this.setDropZone(new l(0, 0, t, e), u);
                },
                setDropZone: function(t, e) {
                    return void 0 === t ? this.setRectangleDropZone(this.width, this.height) : this.input || this.setInteractive(t, e, !0), this;
                },
                setAlpha: function() {},
                setBlendMode: function() {},
                renderCanvas: function() {},
                renderWebGL: function() {}
            });
            t.exports = c;
        },
        function(t, e) {
            t.exports = function(t) {
                return 2 * (t.width + t.height);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                for(var e = t.length - 1; 0 < e; e--){
                    var i = Math.floor(Math.random() * (e + 1)), n = t[e];
                    t[e] = t[i], t[i] = n;
                }
                return t;
            };
        },
        function(t, e, i) {
            t.exports = {
                ADD_ANIMATION: i(700),
                ANIMATION_COMPLETE: i(701),
                ANIMATION_COMPLETE_KEY: i(702),
                ANIMATION_REPEAT: i(703),
                ANIMATION_RESTART: i(704),
                ANIMATION_START: i(705),
                ANIMATION_STOP: i(706),
                ANIMATION_UPDATE: i(707),
                PAUSE_ALL: i(708),
                REMOVE_ANIMATION: i(709),
                RESUME_ALL: i(710)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(35), o = i(9), a = i(36), h = i(10), l = i(25), u = i(184), A = i(3), c = new n({
                Extends: o,
                Mixins: [
                    s.Alpha,
                    s.Visible
                ],
                initialize: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), o.call(this), this.scene, this.sceneManager, this.scaleManager, this.cameraManager, this.id = 0, this.name = "", this.roundPixels = !1, this.useBounds = !1, this.worldView = new h, this.dirty = !0, this._x = t, this._y = e, this._width = i, this._height = n, this._bounds = new h, this._scrollX = 0, this._scrollY = 0, this._zoomX = 1, this._zoomY = 1, this._rotation = 0, this.matrix = new l, this.transparent = !0, this.backgroundColor = u("rgba(0,0,0,0)"), this.disableCull = !1, this.culledObjects = [], this.midPoint = new A(i / 2, n / 2), this.originX = .5, this.originY = .5, this._customViewport = !1, this.mask = null, this._maskCamera = null, this.renderList = [];
                },
                addToRenderList: function(t) {
                    this.renderList.push(t);
                },
                setOrigin: function(t, e) {
                    return void 0 === t && (t = .5), void 0 === e && (e = t), this.originX = t, this.originY = e, this;
                },
                getScroll: function(t, e, i) {
                    void 0 === i && (i = new A);
                    var n = .5 * this.width, s = .5 * this.height;
                    return i.x = t - n, i.y = e - s, this.useBounds && (i.x = this.clampX(i.x), i.y = this.clampY(i.y)), i;
                },
                centerOnX: function(t) {
                    var e = .5 * this.width;
                    return this.midPoint.x = t, this.scrollX = t - e, this.useBounds && (this.scrollX = this.clampX(this.scrollX)), this;
                },
                centerOnY: function(t) {
                    var e = .5 * this.height;
                    return this.midPoint.y = t, this.scrollY = t - e, this.useBounds && (this.scrollY = this.clampY(this.scrollY)), this;
                },
                centerOn: function(t, e) {
                    return this.centerOnX(t), this.centerOnY(e), this;
                },
                centerToBounds: function() {
                    var t, e, i;
                    return this.useBounds && (t = this._bounds, e = .5 * this.width, i = .5 * this.height, this.midPoint.set(t.centerX, t.centerY), this.scrollX = t.centerX - e, this.scrollY = t.centerY - i), this;
                },
                centerToSize: function() {
                    return this.scrollX = .5 * this.width, this.scrollY = .5 * this.height, this;
                },
                cull: function(t) {
                    if (this.disableCull) return t;
                    var e = this.matrix.matrix, i = e[0], n = e[1], s = e[2], r = e[3];
                    if (!(i * r - n * s)) return t;
                    for(var o = e[4], a = e[5], h = this.scrollX, l = this.scrollY, u = this.width, c = this.height, d = this.y, f = d + c, p = this.x, g = p + u, v = this.culledObjects, m = t.length, y = v.length = 0; y < m; ++y){
                        var x, T, w, b, E = t[y];
                        E.hasOwnProperty("width") && !E.parentContainer ? (x = E.width, T = E.height, p < ((w = E.x - h * E.scrollFactorX - x * E.originX) + x) * i + ((b = E.y - l * E.scrollFactorY - T * E.originY) + T) * s + o && w * i + b * s + o < g && d < (w + x) * n + (b + T) * r + a && w * n + b * r + a < f && v.push(E)) : v.push(E);
                    }
                    return v;
                },
                getWorldPoint: function(t, e, i) {
                    void 0 === i && (i = new A);
                    var n = this.matrix.matrix, s = n[0], r = n[1], o = n[2], a = n[3], h = n[4], l = n[5], u = s * a - r * o;
                    if (!u) return i.x = t, i.y = e, i;
                    var c = a * (u = 1 / u), d = -r * u, f = -o * u, p = s * u, g = (o * l - a * h) * u, v = (r * h - s * l) * u, m = Math.cos(this.rotation), y = Math.sin(this.rotation), x = this.zoomX, T = this.zoomY, w = this.scrollX, b = this.scrollY, E = t + (w * m - b * y) * x, S = e + (w * y + b * m) * T;
                    return i.x = E * c + S * f + g, i.y = E * d + S * p + v, i;
                },
                ignore: function(t) {
                    var e = this.id;
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        Array.isArray(n) ? this.ignore(n) : n.isParent ? this.ignore(n.getChildren()) : n.cameraFilter |= e;
                    }
                    return this;
                },
                preRender: function() {
                    this.renderList.length = 0;
                    var t = this.width, e = this.height, i = .5 * t, n = .5 * e, s = this.zoomX, r = this.zoomY, o = this.matrix, a = t * this.originX, h = e * this.originY, l = this.scrollX, u = this.scrollY;
                    this.useBounds && (l = this.clampX(l), u = this.clampY(u)), this.roundPixels && (a = Math.round(a), h = Math.round(h));
                    var c = (this.scrollX = l) + i, d = (this.scrollY = u) + n;
                    this.midPoint.set(c, d);
                    var f = t / s, p = e / r;
                    this.worldView.setTo(c - f / 2, d - p / 2, f, p), o.applyITRS(this.x + a, this.y + h, this.rotation, s, r), o.translate(-a, -h);
                },
                clampX: function(t) {
                    var e = this._bounds, i = this.displayWidth, n = e.x + (i - this.width) / 2, s = Math.max(n, n + e.width - i);
                    return t < n ? t = n : s < t && (t = s), t;
                },
                clampY: function(t) {
                    var e = this._bounds, i = this.displayHeight, n = e.y + (i - this.height) / 2, s = Math.max(n, n + e.height - i);
                    return t < n ? t = n : s < t && (t = s), t;
                },
                removeBounds: function() {
                    return this.useBounds = !1, this.dirty = !0, this._bounds.setEmpty(), this;
                },
                setAngle: function(t) {
                    return void 0 === t && (t = 0), this.rotation = r(t), this;
                },
                setBackgroundColor: function(t) {
                    return void 0 === t && (t = "rgba(0,0,0,0)"), this.backgroundColor = u(t), this.transparent = 0 === this.backgroundColor.alpha, this;
                },
                setBounds: function(t, e, i, n, s) {
                    return void 0 === s && (s = !1), this._bounds.setTo(t, e, i, n), this.dirty = !0, this.useBounds = !0, s ? this.centerToBounds() : (this.scrollX = this.clampX(this.scrollX), this.scrollY = this.clampY(this.scrollY)), this;
                },
                getBounds: function(t) {
                    void 0 === t && (t = new h);
                    var e = this._bounds;
                    return t.setTo(e.x, e.y, e.width, e.height), t;
                },
                setName: function(t) {
                    return void 0 === t && (t = ""), this.name = t, this;
                },
                setPosition: function(t, e) {
                    return void 0 === e && (e = t), this.x = t, this.y = e, this;
                },
                setRotation: function(t) {
                    return void 0 === t && (t = 0), this.rotation = t, this;
                },
                setRoundPixels: function(t) {
                    return this.roundPixels = t, this;
                },
                setScene: function(t) {
                    this.scene && this._customViewport && this.sceneManager.customViewports--;
                    var e = (this.scene = t).sys;
                    return this.sceneManager = e.game.scene, this.scaleManager = e.scale, this.cameraManager = e.cameras, this.updateSystem(), this;
                },
                setScroll: function(t, e) {
                    return void 0 === e && (e = t), this.scrollX = t, this.scrollY = e, this;
                },
                setSize: function(t, e) {
                    return void 0 === e && (e = t), this.width = t, this.height = e, this;
                },
                setViewport: function(t, e, i, n) {
                    return this.x = t, this.y = e, this.width = i, this.height = n, this;
                },
                setZoom: function(t, e) {
                    return void 0 === t && (t = 1), void 0 === e && (e = t), 0 === t && (t = .001), 0 === e && (e = .001), this.zoomX = t, this.zoomY = e, this;
                },
                setMask: function(t, e) {
                    return void 0 === e && (e = !0), this.mask = t, this._maskCamera = e ? this.cameraManager.default : this, this;
                },
                clearMask: function(t) {
                    return void 0 === t && (t = !1), t && this.mask && this.mask.destroy(), this.mask = null, this;
                },
                toJSON: function() {
                    var t = {
                        name: this.name,
                        x: this.x,
                        y: this.y,
                        width: this.width,
                        height: this.height,
                        zoom: this.zoom,
                        rotation: this.rotation,
                        roundPixels: this.roundPixels,
                        scrollX: this.scrollX,
                        scrollY: this.scrollY,
                        backgroundColor: this.backgroundColor.rgba
                    };
                    return this.useBounds && (t.bounds = {
                        x: this._bounds.x,
                        y: this._bounds.y,
                        width: this._bounds.width,
                        height: this._bounds.height
                    }), t;
                },
                update: function() {},
                updateSystem: function() {
                    var t, e;
                    this.scaleManager && (t = 0 !== this._x || 0 !== this._y || this.scaleManager.width !== this._width || this.scaleManager.height !== this._height, e = this.sceneManager, t && !this._customViewport ? e.customViewports++ : !t && this._customViewport && e.customViewports--, this.dirty = !0, this._customViewport = t);
                },
                destroy: function() {
                    this.emit(a.DESTROY, this), this.removeAllListeners(), this.matrix.destroy(), this.culledObjects = [], this._customViewport && this.sceneManager.customViewports--, this.renderList = [], this._bounds = null, this.scene = null, this.scaleManager = null, this.sceneManager = null, this.cameraManager = null;
                },
                x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(t) {
                        this._x = t, this.updateSystem();
                    }
                },
                y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(t) {
                        this._y = t, this.updateSystem();
                    }
                },
                width: {
                    get: function() {
                        return this._width;
                    },
                    set: function(t) {
                        this._width = t, this.updateSystem();
                    }
                },
                height: {
                    get: function() {
                        return this._height;
                    },
                    set: function(t) {
                        this._height = t, this.updateSystem();
                    }
                },
                scrollX: {
                    get: function() {
                        return this._scrollX;
                    },
                    set: function(t) {
                        this._scrollX = t, this.dirty = !0;
                    }
                },
                scrollY: {
                    get: function() {
                        return this._scrollY;
                    },
                    set: function(t) {
                        this._scrollY = t, this.dirty = !0;
                    }
                },
                zoom: {
                    get: function() {
                        return (this._zoomX + this._zoomY) / 2;
                    },
                    set: function(t) {
                        this._zoomX = t, this._zoomY = t, this.dirty = !0;
                    }
                },
                zoomX: {
                    get: function() {
                        return this._zoomX;
                    },
                    set: function(t) {
                        this._zoomX = t, this.dirty = !0;
                    }
                },
                zoomY: {
                    get: function() {
                        return this._zoomY;
                    },
                    set: function(t) {
                        this._zoomY = t, this.dirty = !0;
                    }
                },
                rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(t) {
                        this._rotation = t, this.dirty = !0;
                    }
                },
                centerX: {
                    get: function() {
                        return this.x + .5 * this.width;
                    }
                },
                centerY: {
                    get: function() {
                        return this.y + .5 * this.height;
                    }
                },
                displayWidth: {
                    get: function() {
                        return this.width / this.zoomX;
                    }
                },
                displayHeight: {
                    get: function() {
                        return this.height / this.zoomY;
                    }
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var n = i(328), s = i(329), r = i(330), o = i(331), a = i(332), h = i(333), l = i(334), u = i(335), c = i(336), d = i(337), f = i(338), p = i(339);
            t.exports = {
                Power0: l,
                Power1: u.Out,
                Power2: o.Out,
                Power3: c.Out,
                Power4: d.Out,
                Linear: l,
                Quad: u.Out,
                Cubic: o.Out,
                Quart: c.Out,
                Quint: d.Out,
                Sine: f.Out,
                Expo: h.Out,
                Circ: r.Out,
                Elastic: a.Out,
                Back: n.Out,
                Bounce: s.Out,
                Stepped: p,
                "Quad.easeIn": u.In,
                "Cubic.easeIn": o.In,
                "Quart.easeIn": c.In,
                "Quint.easeIn": d.In,
                "Sine.easeIn": f.In,
                "Expo.easeIn": h.In,
                "Circ.easeIn": r.In,
                "Elastic.easeIn": a.In,
                "Back.easeIn": n.In,
                "Bounce.easeIn": s.In,
                "Quad.easeOut": u.Out,
                "Cubic.easeOut": o.Out,
                "Quart.easeOut": c.Out,
                "Quint.easeOut": d.Out,
                "Sine.easeOut": f.Out,
                "Expo.easeOut": h.Out,
                "Circ.easeOut": r.Out,
                "Elastic.easeOut": a.Out,
                "Back.easeOut": n.Out,
                "Bounce.easeOut": s.Out,
                "Quad.easeInOut": u.InOut,
                "Cubic.easeInOut": o.InOut,
                "Quart.easeInOut": c.InOut,
                "Quint.easeInOut": d.InOut,
                "Sine.easeInOut": f.InOut,
                "Expo.easeInOut": h.InOut,
                "Circ.easeInOut": r.InOut,
                "Elastic.easeInOut": a.InOut,
                "Back.easeInOut": n.InOut,
                "Bounce.easeInOut": s.InOut
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return (e - t) * i + t;
            };
        },
        function(t, e, i) {
            var n, s = i(102), r = {
                chrome: !1,
                chromeVersion: 0,
                edge: !1,
                firefox: !1,
                firefoxVersion: 0,
                ie: !1,
                ieVersion: 0,
                mobileSafari: !1,
                opera: !1,
                safari: !1,
                safariVersion: 0,
                silk: !1,
                trident: !1,
                tridentVersion: 0
            };
            t.exports = (n = navigator.userAgent, /Edge\/\d+/.test(n) ? r.edge = !0 : /Chrome\/(\d+)/.test(n) && !s.windowsPhone ? (r.chrome = !0, r.chromeVersion = parseInt(RegExp.$1, 10)) : /Firefox\D+(\d+)/.test(n) ? (r.firefox = !0, r.firefoxVersion = parseInt(RegExp.$1, 10)) : /AppleWebKit/.test(n) && s.iOS ? r.mobileSafari = !0 : /MSIE (\d+\.\d+);/.test(n) ? (r.ie = !0, r.ieVersion = parseInt(RegExp.$1, 10)) : /Opera/.test(n) ? r.opera = !0 : /Safari/.test(n) && !s.windowsPhone ? r.safari = !0 : /Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(n) && (r.ie = !0, r.trident = !0, r.tridentVersion = parseInt(RegExp.$1, 10), r.ieVersion = parseInt(RegExp.$3, 10)), /Silk/.test(n) && (r.silk = !0), r);
        },
        function(t, e) {
            t.exports = function(t, e) {
                return Math.random() * (e - t) + t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return 0 < t && 0 == (t & t - 1) && 0 < e && 0 == (e & e - 1);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), 0 === e ? t : (t -= i, t = e * Math.ceil(t / e), n ? (i + t) / e : i + t);
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n) {
                    this.x = 0, this.y = 0, this.z = 0, this.w = 0, "object" == typeof t ? (this.x = t.x || 0, this.y = t.y || 0, this.z = t.z || 0, this.w = t.w || 0) : (this.x = t || 0, this.y = e || 0, this.z = i || 0, this.w = n || 0);
                },
                clone: function() {
                    return new n(this.x, this.y, this.z, this.w);
                },
                copy: function(t) {
                    return this.x = t.x, this.y = t.y, this.z = t.z || 0, this.w = t.w || 0, this;
                },
                equals: function(t) {
                    return this.x === t.x && this.y === t.y && this.z === t.z && this.w === t.w;
                },
                set: function(t, e, i, n) {
                    return "object" == typeof t ? (this.x = t.x || 0, this.y = t.y || 0, this.z = t.z || 0, this.w = t.w || 0) : (this.x = t || 0, this.y = e || 0, this.z = i || 0, this.w = n || 0), this;
                },
                add: function(t) {
                    return this.x += t.x, this.y += t.y, this.z += t.z || 0, this.w += t.w || 0, this;
                },
                subtract: function(t) {
                    return this.x -= t.x, this.y -= t.y, this.z -= t.z || 0, this.w -= t.w || 0, this;
                },
                scale: function(t) {
                    return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
                },
                length: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w;
                    return Math.sqrt(t * t + e * e + i * i + n * n);
                },
                lengthSq: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w;
                    return t * t + e * e + i * i + n * n;
                },
                normalize: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w, s = t * t + e * e + i * i + n * n;
                    return 0 < s && (s = 1 / Math.sqrt(s), this.x = t * s, this.y = e * s, this.z = i * s, this.w = n * s), this;
                },
                dot: function(t) {
                    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
                },
                lerp: function(t, e) {
                    void 0 === e && (e = 0);
                    var i = this.x, n = this.y, s = this.z, r = this.w;
                    return this.x = i + e * (t.x - i), this.y = n + e * (t.y - n), this.z = s + e * (t.z - s), this.w = r + e * (t.w - r), this;
                },
                multiply: function(t) {
                    return this.x *= t.x, this.y *= t.y, this.z *= t.z || 1, this.w *= t.w || 1, this;
                },
                divide: function(t) {
                    return this.x /= t.x, this.y /= t.y, this.z /= t.z || 1, this.w /= t.w || 1, this;
                },
                distance: function(t) {
                    var e = t.x - this.x, i = t.y - this.y, n = t.z - this.z || 0, s = t.w - this.w || 0;
                    return Math.sqrt(e * e + i * i + n * n + s * s);
                },
                distanceSq: function(t) {
                    var e = t.x - this.x, i = t.y - this.y, n = t.z - this.z || 0, s = t.w - this.w || 0;
                    return e * e + i * i + n * n + s * s;
                },
                negate: function() {
                    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
                },
                transformMat4: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = this.w, r = t.val;
                    return this.x = r[0] * e + r[4] * i + r[8] * n + r[12] * s, this.y = r[1] * e + r[5] * i + r[9] * n + r[13] * s, this.z = r[2] * e + r[6] * i + r[10] * n + r[14] * s, this.w = r[3] * e + r[7] * i + r[11] * n + r[15] * s, this;
                },
                transformQuat: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = t.x, r = t.y, o = t.z, a = t.w, h = a * e + r * n - o * i, l = a * i + o * e - s * n, u = a * n + s * i - r * e, c = -s * e - r * i - o * n;
                    return this.x = h * a + c * -s + l * -o - u * -r, this.y = l * a + c * -r + u * -s - h * -o, this.z = u * a + c * -o + h * -r - l * -s, this;
                },
                reset: function() {
                    return this.x = 0, this.y = 0, this.z = 0, this.w = 0, this;
                }
            });
            n.prototype.sub = n.prototype.subtract, n.prototype.mul = n.prototype.multiply, n.prototype.div = n.prototype.divide, n.prototype.dist = n.prototype.distance, n.prototype.distSq = n.prototype.distanceSq, n.prototype.len = n.prototype.length, n.prototype.lenSq = n.prototype.lengthSq, t.exports = n;
        },
        function(t, e, i) {
            var n = i(0), s = i(88), r = new n({
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === n && (n = 1), void 0 === s && (s = 0), void 0 === r && (r = !0), void 0 === o && (o = !1), this.renderer = t, this.framebuffer = null, this.texture = null, this.width = 0, this.height = 0, this.scale = n, this.minFilter = s, this.autoClear = r, this.autoResize = !1, this.resize(e, i), o && this.setAutoResize(!0);
                },
                setAutoResize: function(t) {
                    return t && !this.autoResize ? (this.renderer.on(s.RESIZE, this.resize, this), this.autoResize = !0) : !t && this.autoResize && (this.renderer.off(s.RESIZE, this.resize, this), this.autoResize = !1), this;
                },
                resize: function(t, e) {
                    var i, n = t * this.scale, s = e * this.scale;
                    return n === this.width && s === this.height || ((i = this.renderer).deleteFramebuffer(this.framebuffer), i.deleteTexture(this.texture), t *= this.scale, e *= this.scale, this.texture = i.createTextureFromSource(null, t, e, this.minFilter), this.framebuffer = i.createFramebuffer(t, e, this.texture, !1), this.width = t, this.height = e), this;
                },
                bind: function(t, e, i) {
                    var n;
                    void 0 === t && (t = !1), t && this.renderer.flush(), e && i && this.resize(e, i), this.renderer.pushFramebuffer(this.framebuffer, !1, !1, !1), t && this.adjustViewport(), this.autoClear && ((n = this.renderer.gl).clearColor(0, 0, 0, 0), n.clear(n.COLOR_BUFFER_BIT));
                },
                adjustViewport: function() {
                    var t = this.renderer.gl;
                    t.viewport(0, 0, this.width, this.height), t.disable(t.SCISSOR_TEST);
                },
                clear: function() {
                    var t = this.renderer, e = t.gl;
                    t.pushFramebuffer(this.framebuffer), e.disable(e.SCISSOR_TEST), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), t.popFramebuffer(), t.resetScissor();
                },
                unbind: function(t) {
                    void 0 === t && (t = !1);
                    var e = this.renderer;
                    return t && e.flush(), e.popFramebuffer();
                },
                destroy: function() {
                    var t = this.renderer;
                    t.deleteFramebuffer(this.framebuffer), t.deleteTexture(this.texture), t.off(s.RESIZE, this.resize, this), this.renderer = null, this.framebuffer = null, this.texture = null;
                }
            });
            t.exports = r;
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i;
                if (e) "string" == typeof e ? i = document.getElementById(e) : "object" == typeof e && 1 === e.nodeType && (i = e);
                else if (t.parentElement || null === e) return t;
                return (i = i || document.body).appendChild(t), t;
            };
        },
        function(t, e) {
            t.exports = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                SHIFT: 16,
                CTRL: 17,
                ALT: 18,
                PAUSE: 19,
                CAPS_LOCK: 20,
                ESC: 27,
                SPACE: 32,
                PAGE_UP: 33,
                PAGE_DOWN: 34,
                END: 35,
                HOME: 36,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                PRINT_SCREEN: 42,
                INSERT: 45,
                DELETE: 46,
                ZERO: 48,
                ONE: 49,
                TWO: 50,
                THREE: 51,
                FOUR: 52,
                FIVE: 53,
                SIX: 54,
                SEVEN: 55,
                EIGHT: 56,
                NINE: 57,
                NUMPAD_ZERO: 96,
                NUMPAD_ONE: 97,
                NUMPAD_TWO: 98,
                NUMPAD_THREE: 99,
                NUMPAD_FOUR: 100,
                NUMPAD_FIVE: 101,
                NUMPAD_SIX: 102,
                NUMPAD_SEVEN: 103,
                NUMPAD_EIGHT: 104,
                NUMPAD_NINE: 105,
                NUMPAD_ADD: 107,
                NUMPAD_SUBTRACT: 109,
                A: 65,
                B: 66,
                C: 67,
                D: 68,
                E: 69,
                F: 70,
                G: 71,
                H: 72,
                I: 73,
                J: 74,
                K: 75,
                L: 76,
                M: 77,
                N: 78,
                O: 79,
                P: 80,
                Q: 81,
                R: 82,
                S: 83,
                T: 84,
                U: 85,
                V: 86,
                W: 87,
                X: 88,
                Y: 89,
                Z: 90,
                F1: 112,
                F2: 113,
                F3: 114,
                F4: 115,
                F5: 116,
                F6: 117,
                F7: 118,
                F8: 119,
                F9: 120,
                F10: 121,
                F11: 122,
                F12: 123,
                SEMICOLON: 186,
                PLUS: 187,
                COMMA: 188,
                MINUS: 189,
                PERIOD: 190,
                FORWARD_SLASH: 191,
                BACK_SLASH: 220,
                QUOTES: 222,
                BACKTICK: 192,
                OPEN_BRACKET: 219,
                CLOSED_BRACKET: 221,
                SEMICOLON_FIREFOX: 59,
                COLON: 58,
                COMMA_FIREFOX_WINDOWS: 60,
                COMMA_FIREFOX: 62,
                BRACKET_RIGHT_FIREFOX: 174,
                BRACKET_LEFT_FIREFOX: 175
            };
        },
        function(t, e) {
            t.exports = {
                PENDING: 0,
                INIT: 1,
                START: 2,
                LOADING: 3,
                CREATING: 4,
                RUNNING: 5,
                PAUSED: 6,
                SLEEPING: 7,
                SHUTDOWN: 8,
                DESTROYED: 9
            };
        },
        function(t, e, i) {
            var s = i(77);
            t.exports = function(t, e) {
                var i = s(t);
                for(var n in e)i.hasOwnProperty(n) || (i[n] = e[n]);
                return i;
            };
        },
        function(t, e, i) {
            var n = i(0), o = i(77), s = i(9), r = i(69), a = i(22), h = i(1), l = i(204), u = i(422), c = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.game = t, this.jsonCache = t.cache.json, this.sounds = [], this.mute = !1, this.volume = 1, this.pauseOnBlur = !0, this._rate = 1, this._detune = 0, this.locked = this.locked || !1, this.unlocked = !1, t.events.on(a.BLUR, this.onGameBlur, this), t.events.on(a.FOCUS, this.onGameFocus, this), t.events.on(a.PRE_STEP, this.update, this), t.events.once(a.DESTROY, this.destroy, this);
                },
                add: h,
                addAudioSprite: function(t, e) {
                    void 0 === e && (e = {});
                    var i, n, s = this.add(t, e);
                    for(var r in s.spritemap = this.jsonCache.get(t).spritemap, s.spritemap)s.spritemap.hasOwnProperty(r) && (i = o(e), n = s.spritemap[r], i.loop = !!n.hasOwnProperty("loop") && n.loop, s.addMarker({
                        name: r,
                        start: n.start,
                        duration: n.end - n.start,
                        config: i
                    }));
                    return s;
                },
                get: function(t) {
                    return u(this.sounds, "key", t);
                },
                getAll: function(t) {
                    return l(this.sounds, "key", t);
                },
                play: function(t, e) {
                    var i = this.add(t);
                    return i.once(r.COMPLETE, i.destroy, i), e ? e.name ? (i.addMarker(e), i.play(e.name)) : i.play(e) : i.play();
                },
                playAudioSprite: function(t, e, i) {
                    var n = this.addAudioSprite(t);
                    return n.once(r.COMPLETE, n.destroy, n), n.play(e, i);
                },
                remove: function(t) {
                    var e = this.sounds.indexOf(t);
                    return -1 !== e && (t.destroy(), this.sounds.splice(e, 1), !0);
                },
                removeAll: function() {
                    this.sounds.forEach(function(t) {
                        t.destroy();
                    }), this.sounds.length = 0;
                },
                removeByKey: function(t) {
                    for(var e = 0, i = this.sounds.length - 1; 0 <= i; i--){
                        var n = this.sounds[i];
                        n.key === t && (n.destroy(), this.sounds.splice(i, 1), e++);
                    }
                    return e;
                },
                pauseAll: function() {
                    this.forEachActiveSound(function(t) {
                        t.pause();
                    }), this.emit(r.PAUSE_ALL, this);
                },
                resumeAll: function() {
                    this.forEachActiveSound(function(t) {
                        t.resume();
                    }), this.emit(r.RESUME_ALL, this);
                },
                stopAll: function() {
                    this.forEachActiveSound(function(t) {
                        t.stop();
                    }), this.emit(r.STOP_ALL, this);
                },
                stopByKey: function(t) {
                    var e = 0;
                    return this.getAll(t).forEach(function(t) {
                        t.stop() && e++;
                    }), e;
                },
                unlock: h,
                onBlur: h,
                onFocus: h,
                onGameBlur: function() {
                    this.pauseOnBlur && this.onBlur();
                },
                onGameFocus: function() {
                    this.pauseOnBlur && this.onFocus();
                },
                update: function(e, i) {
                    this.unlocked && (this.unlocked = !1, this.locked = !1, this.emit(r.UNLOCKED, this));
                    for(var t = this.sounds.length - 1; 0 <= t; t--)this.sounds[t].pendingRemove && this.sounds.splice(t, 1);
                    this.sounds.forEach(function(t) {
                        t.update(e, i);
                    });
                },
                destroy: function() {
                    this.game.events.off(a.BLUR, this.onGameBlur, this), this.game.events.off(a.FOCUS, this.onGameFocus, this), this.game.events.off(a.PRE_STEP, this.update, this), this.removeAllListeners(), this.removeAll(), this.sounds.length = 0, this.sounds = null, this.game = null;
                },
                forEachActiveSound: function(i, n) {
                    var s = this;
                    this.sounds.forEach(function(t, e) {
                        t && !t.pendingRemove && i.call(n || s, t, e, s.sounds);
                    });
                },
                setRate: function(t) {
                    return this.rate = t, this;
                },
                rate: {
                    get: function() {
                        return this._rate;
                    },
                    set: function(t) {
                        this._rate = t, this.forEachActiveSound(function(t) {
                            t.calculateRate();
                        }), this.emit(r.GLOBAL_RATE, this, t);
                    }
                },
                setDetune: function(t) {
                    return this.detune = t, this;
                },
                detune: {
                    get: function() {
                        return this._detune;
                    },
                    set: function(t) {
                        this._detune = t, this.forEachActiveSound(function(t) {
                            t.calculateRate();
                        }), this.emit(r.GLOBAL_DETUNE, this, t);
                    }
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var n = i(0), s = i(9), r = i(69), o = i(17), a = i(1), h = new n({
                Extends: s,
                initialize: function(t, e, i) {
                    s.call(this), this.manager = t, this.key = e, this.isPlaying = !1, this.isPaused = !1, this.totalRate = 1, this.duration = this.duration || 0, this.totalDuration = this.totalDuration || 0, this.config = {
                        mute: !1,
                        volume: 1,
                        rate: 1,
                        detune: 0,
                        seek: 0,
                        loop: !1,
                        delay: 0,
                        pan: 0
                    }, this.currentConfig = this.config, this.config = o(this.config, i), this.markers = {}, this.currentMarker = null, this.pendingRemove = !1;
                },
                addMarker: function(t) {
                    return !(!t || !t.name || "string" != typeof t.name) && (this.markers[t.name] ? (console.error("addMarker " + t.name + " already exists in Sound"), !1) : (t = o(!0, {
                        name: "",
                        start: 0,
                        duration: this.totalDuration - (t.start || 0),
                        config: {
                            mute: !1,
                            volume: 1,
                            rate: 1,
                            detune: 0,
                            seek: 0,
                            loop: !1,
                            delay: 0,
                            pan: 0
                        }
                    }, t), this.markers[t.name] = t, !0));
                },
                updateMarker: function(t) {
                    return !(!t || !t.name || "string" != typeof t.name) && (this.markers[t.name] ? (this.markers[t.name] = o(!0, this.markers[t.name], t), !0) : (console.warn("Audio Marker: " + t.name + " missing in Sound: " + this.key), !1));
                },
                removeMarker: function(t) {
                    var e = this.markers[t];
                    return e ? (this.markers[t] = null, e) : null;
                },
                play: function(t, e) {
                    if (void 0 === t && (t = ""), "object" == typeof t && (e = t, t = ""), "string" != typeof t) return !1;
                    if (t) {
                        if (!this.markers[t]) return console.warn("Marker: " + t + " missing in Sound: " + this.key), !1;
                        this.currentMarker = this.markers[t], this.currentConfig = this.currentMarker.config, this.duration = this.currentMarker.duration;
                    } else this.currentMarker = null, this.currentConfig = this.config, this.duration = this.totalDuration;
                    return this.resetConfig(), this.currentConfig = o(this.currentConfig, e), this.isPlaying = !0, this.isPaused = !1, true;
                },
                pause: function() {
                    return !(this.isPaused || !this.isPlaying) && (this.isPlaying = !1, this.isPaused = !0);
                },
                resume: function() {
                    return !(!this.isPaused || this.isPlaying) && (this.isPlaying = !0, this.isPaused = !1, true);
                },
                stop: function() {
                    return !(!this.isPaused && !this.isPlaying) && (this.isPlaying = !1, this.isPaused = !1, this.resetConfig(), !0);
                },
                applyConfig: function() {
                    this.mute = this.currentConfig.mute, this.volume = this.currentConfig.volume, this.rate = this.currentConfig.rate, this.detune = this.currentConfig.detune, this.loop = this.currentConfig.loop, this.pan = this.currentConfig.pan;
                },
                resetConfig: function() {
                    this.currentConfig.seek = 0, this.currentConfig.delay = 0;
                },
                update: a,
                calculateRate: function() {
                    var t = this.currentConfig.detune + this.manager.detune, e = Math.pow(1.0005777895065548, t);
                    this.totalRate = this.currentConfig.rate * this.manager.rate * e;
                },
                destroy: function() {
                    this.pendingRemove || (this.emit(r.DESTROY, this), this.pendingRemove = !0, this.manager = null, this.key = "", this.removeAllListeners(), this.isPlaying = !1, this.isPaused = !1, this.config = null, this.currentConfig = null, this.markers = null, this.currentMarker = null);
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var n = i(206), s = i(429);
            t.exports = function(t, e) {
                if (void 0 === e && (e = 90), !n(t)) return null;
                if ("string" != typeof e && (e = (e % 360 + 360) % 360), 90 === e || -270 === e || "rotateLeft" === e) (t = s(t)).reverse();
                else if (-90 === e || 270 === e || "rotateRight" === e) t.reverse(), t = s(t);
                else if (180 === Math.abs(e) || "rotate180" === e) {
                    for(var i = 0; i < t.length; i++)t[i].reverse();
                    t.reverse();
                }
                return t;
            };
        },
        function(t, e, i) {
            var n = i(0), f = i(18), s = i(11), h = i(15), l = i(1037), r = i(1038), o = i(209), u = i(10), a = i(1039), c = new n({
                Extends: h,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.Depth,
                    s.Mask,
                    s.Origin,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Texture,
                    s.Tint,
                    s.Transform,
                    s.Visible,
                    a
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === s && (s = ""), void 0 === o && (o = 0), h.call(this, t, "BitmapText"), this.font = n;
                    var a = this.scene.sys.cache.bitmapFont.get(n);
                    a || console.warn("Invalid BitmapText key: " + n), this.fontData = a.data, this._text = "", this._fontSize = r || this.fontData.size, this._letterSpacing = 0, this._align = o, this._bounds = l(), this._dirty = !0, this._maxWidth = 0, this.wordWrapCharCode = 32, this.charColors = [], this.dropShadowX = 0, this.dropShadowY = 0, this.dropShadowColor = 0, this.dropShadowAlpha = .5, this.setTexture(a.texture, a.frame), this.setPosition(e, i), this.setOrigin(0, 0), this.initPipeline(), this.setText(s);
                },
                setLeftAlign: function() {
                    return this._align = c.ALIGN_LEFT, this._dirty = !0, this;
                },
                setCenterAlign: function() {
                    return this._align = c.ALIGN_CENTER, this._dirty = !0, this;
                },
                setRightAlign: function() {
                    return this._align = c.ALIGN_RIGHT, this._dirty = !0, this;
                },
                setFontSize: function(t) {
                    return this._fontSize = t, this._dirty = !0, this;
                },
                setLetterSpacing: function(t) {
                    return void 0 === t && (t = 0), this._letterSpacing = t, this._dirty = !0, this;
                },
                setText: function(t) {
                    return t || 0 === t || (t = ""), Array.isArray(t) && (t = t.join("\n")), t !== this.text && (this._text = t.toString(), this._dirty = !0, this.updateDisplayOrigin()), this;
                },
                setDropShadow: function(t, e, i, n) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = .5), this.dropShadowX = t, this.dropShadowY = e, this.dropShadowColor = i, this.dropShadowAlpha = n, this;
                },
                setCharacterTint: function(t, e, i, n, s, r, o) {
                    void 0 === t && (t = 0), void 0 === e && (e = 1), void 0 === i && (i = !1), void 0 === n && (n = -1), void 0 === s && (o = r = s = n);
                    var a = this.text.length;
                    -1 === e && (e = a), t < 0 && (t = a + t), t = f(t, 0, a - 1);
                    for(var h = f(t + e, t, a), l = this.charColors, u = t; u < h; u++){
                        var c, d = l[u];
                        -1 === n ? l[u] = null : (c = i ? 1 : 0, d ? (d.tintEffect = c, d.tintTL = n, d.tintTR = s, d.tintBL = r, d.tintBR = o) : l[u] = {
                            tintEffect: c,
                            tintTL: n,
                            tintTR: s,
                            tintBL: r,
                            tintBR: o
                        });
                    }
                    return this;
                },
                setWordTint: function(t, e, i, n, s, r, o) {
                    void 0 === e && (e = 1);
                    for(var a = this.getTextBounds().words, h = "number" == typeof t, l = 0, u = 0; u < a.length; u++){
                        var c = a[u];
                        if ((h && u === t || !h && c.word === t) && (this.setCharacterTint(c.i, c.word.length, i, n, s, r, o), ++l === e)) return this;
                    }
                    return this;
                },
                getTextBounds: function(t) {
                    var e = this._bounds;
                    return (this._dirty || t || this.scaleX !== e.scaleX || this.scaleY !== e.scaleY) && (l(this, t, !0, e), this._dirty = !1), e;
                },
                getCharacterAt: function(t, e, i) {
                    for(var n = this.getLocalPoint(t, e, null, i), s = this.getTextBounds().characters, r = new u, o = 0; o < s.length; o++){
                        var a = s[o];
                        if (r.setTo(a.x, a.t, a.r - a.x, a.b), r.contains(n.x, n.y)) return a;
                    }
                    return null;
                },
                updateDisplayOrigin: function() {
                    return this._dirty = !0, this.getTextBounds(!1), this;
                },
                setFont: function(t, e, i) {
                    var n;
                    return void 0 === e && (e = this._fontSize), void 0 === i && (i = this._align), t === this.font || (n = this.scene.sys.cache.bitmapFont.get(t)) && (this.font = t, this.fontData = n.data, this._fontSize = e, this._align = i, this.setTexture(n.texture, n.frame), l(this, !1, !0, this._bounds)), this;
                },
                setMaxWidth: function(t, e) {
                    return this._maxWidth = t, this._dirty = !0, void 0 !== e && (this.wordWrapCharCode = e), this;
                },
                align: {
                    set: function(t) {
                        this._align = t, this._dirty = !0;
                    },
                    get: function() {
                        return this._align;
                    }
                },
                text: {
                    set: function(t) {
                        this.setText(t);
                    },
                    get: function() {
                        return this._text;
                    }
                },
                fontSize: {
                    set: function(t) {
                        this._fontSize = t, this._dirty = !0;
                    },
                    get: function() {
                        return this._fontSize;
                    }
                },
                letterSpacing: {
                    set: function(t) {
                        this._letterSpacing = t, this._dirty = !0;
                    },
                    get: function() {
                        return this._letterSpacing;
                    }
                },
                maxWidth: {
                    set: function(t) {
                        this._maxWidth = t, this._dirty = !0;
                    },
                    get: function() {
                        return this._maxWidth;
                    }
                },
                width: {
                    get: function() {
                        return this.getTextBounds(!1), this._bounds.global.width;
                    }
                },
                height: {
                    get: function() {
                        return this.getTextBounds(!1), this._bounds.global.height;
                    }
                },
                toJSON: function() {
                    var t = s.ToJSON(this), e = {
                        font: this.font,
                        text: this.text,
                        fontSize: this.fontSize,
                        letterSpacing: this.letterSpacing,
                        align: this.align
                    };
                    return t.data = e, t;
                },
                preDestroy: function() {
                    this.charColors.length = 0, this._bounds = null, this.fontData = null;
                }
            });
            c.ALIGN_LEFT = 0, c.ALIGN_CENTER = 1, c.ALIGN_RIGHT = 2, c.ParseFromAtlas = r, c.ParseXMLBitmapFont = o, t.exports = c;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t) {
                    if (this.entries = [], Array.isArray(t)) for(var e = 0; e < t.length; e++)this.set(t[e]);
                },
                set: function(t) {
                    return -1 === this.entries.indexOf(t) && this.entries.push(t), this;
                },
                get: function(t, e) {
                    for(var i = 0; i < this.entries.length; i++){
                        var n = this.entries[i];
                        if (n[t] === e) return n;
                    }
                },
                getArray: function() {
                    return this.entries.slice(0);
                },
                delete: function(t) {
                    var e = this.entries.indexOf(t);
                    return -1 < e && this.entries.splice(e, 1), this;
                },
                dump: function() {
                    console.group("Set");
                    for(var t = 0; t < this.entries.length; t++){
                        var e = this.entries[t];
                        console.log(e);
                    }
                    console.groupEnd();
                },
                each: function(t, e) {
                    var i, n = this.entries.slice(), s = n.length;
                    if (e) for(i = 0; i < s && !1 !== t.call(e, n[i], i); i++);
                    else for(i = 0; i < s && !1 !== t(n[i], i); i++);
                    return this;
                },
                iterate: function(t, e) {
                    var i, n = this.entries.length;
                    if (e) for(i = 0; i < n && !1 !== t.call(e, this.entries[i], i); i++);
                    else for(i = 0; i < n && !1 !== t(this.entries[i], i); i++);
                    return this;
                },
                iterateLocal: function(t) {
                    for(var e = [], i = 1; i < arguments.length; i++)e.push(arguments[i]);
                    var n = this.entries.length;
                    for(i = 0; i < n; i++){
                        var s = this.entries[i];
                        s[t].apply(s, e);
                    }
                    return this;
                },
                clear: function() {
                    return this.entries.length = 0, this;
                },
                contains: function(t) {
                    return -1 < this.entries.indexOf(t);
                },
                union: function(t) {
                    var e = new n;
                    return t.entries.forEach(function(t) {
                        e.set(t);
                    }), this.entries.forEach(function(t) {
                        e.set(t);
                    }), e;
                },
                intersect: function(e) {
                    var i = new n;
                    return this.entries.forEach(function(t) {
                        e.contains(t) && i.set(t);
                    }), i;
                },
                difference: function(e) {
                    var i = new n;
                    return this.entries.forEach(function(t) {
                        e.contains(t) || i.set(t);
                    }), i;
                },
                size: {
                    get: function() {
                        return this.entries.length;
                    },
                    set: function(t) {
                        return t < this.entries.length ? this.entries.length = t : this.entries.length;
                    }
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var n = i(0), s = i(11), a = i(15), h = i(186), l = i(65), r = i(1176), o = new n({
                Extends: a,
                Mixins: [
                    s.AlphaSingle,
                    s.BlendMode,
                    s.Depth,
                    s.GetBounds,
                    s.Mask,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Transform,
                    s.Visible,
                    r
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === n && (n = 16777215), void 0 === s && (s = 128), void 0 === r && (r = 1), void 0 === o && (o = .1), a.call(this, t, "PointLight"), this.initPipeline(l.POINTLIGHT_PIPELINE), this.setPosition(e, i), this.color = h(n), this.intensity = r, this.attenuation = o, this.width = 2 * s, this.height = 2 * s, this._radius = s;
                },
                radius: {
                    get: function() {
                        return this._radius;
                    },
                    set: function(t) {
                        this._radius = t, this.width = 2 * t, this.height = 2 * t;
                    }
                },
                originX: {
                    get: function() {
                        return .5;
                    }
                },
                originY: {
                    get: function() {
                        return .5;
                    }
                },
                displayOriginX: {
                    get: function() {
                        return this._radius;
                    }
                },
                displayOriginY: {
                    get: function() {
                        return this._radius;
                    }
                }
            });
            t.exports = o;
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = e.width / 2, n = e.height / 2, s = Math.abs(t.x - e.x - i), r = Math.abs(t.y - e.y - n), o = i + t.radius, a = n + t.radius;
                if (o < s || a < r) return !1;
                if (s <= i || r <= n) return !0;
                var h = s - i, l = r - n;
                return h * h + l * l <= t.radius * t.radius;
            };
        },
        function(t, e, i) {
            var l = i(6), u = {}, n = {
                register: function(t, e, i, n, s) {
                    u[t] = {
                        plugin: e,
                        mapping: i,
                        settingsKey: n,
                        configKey: s
                    };
                },
                getPlugin: function(t) {
                    return u[t];
                },
                install: function(t) {
                    var e = t.scene.sys, i = e.settings.input, n = e.game.config;
                    for(var s in u){
                        var r = u[s].plugin, o = u[s].mapping, a = u[s].settingsKey, h = u[s].configKey;
                        l(i, a, n[h]) && (t[o] = new r(t));
                    }
                },
                remove: function(t) {
                    u.hasOwnProperty(t) && delete u[t];
                }
            };
            t.exports = n;
        },
        function(t, e, i) {
            t.exports = {
                ANY_KEY_DOWN: i(1317),
                ANY_KEY_UP: i(1318),
                COMBO_MATCH: i(1319),
                DOWN: i(1320),
                KEY_DOWN: i(1321),
                KEY_UP: i(1322),
                UP: i(1323)
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return !!t.url && (t.url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/) ? t.url : e + t.url);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r) {
                return void 0 === t && (t = ""), void 0 === e && (e = !0), void 0 === i && (i = ""), void 0 === n && (n = ""), void 0 === s && (s = 0), void 0 === r && (r = !1), {
                    responseType: t,
                    async: e,
                    user: i,
                    password: n,
                    timeout: s,
                    headers: void 0,
                    header: void 0,
                    headerValue: void 0,
                    requestedWith: !1,
                    overrideMimeType: void 0,
                    withCredentials: r
                };
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(240), r = i(73), o = new n({
                Extends: r,
                Mixins: [
                    s.Acceleration,
                    s.Angular,
                    s.Bounce,
                    s.Debug,
                    s.Drag,
                    s.Enable,
                    s.Friction,
                    s.Gravity,
                    s.Immovable,
                    s.Mass,
                    s.Pushable,
                    s.Size,
                    s.Velocity
                ],
                initialize: function(t, e, i, n, s) {
                    r.call(this, t, e, i, n, s), this.body = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var r = i(118);
            t.exports = function(t, e, i, n) {
                if (void 0 === i && (i = !1), r(t, e, n)) {
                    var s = n.data[e][t] || null;
                    return s && (-1 !== s.index || i) ? s : null;
                }
                return null;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s, r, o, a = t.data, h = t.width, l = t.height, u = t.tilemapLayer, c = Math.max(0, e.left), d = Math.min(h, e.right), f = Math.max(0, e.top), p = Math.min(l, e.bottom);
                if (0 === i) for(r = f; r < p; r++)for(s = c; a[r] && s < d; s++)(o = a[r][s]) && -1 !== o.index && o.visible && 0 !== o.alpha && n.push(o);
                else if (1 === i) for(r = f; r < p; r++)for(s = d; a[r] && c <= s; s--)(o = a[r][s]) && -1 !== o.index && o.visible && 0 !== o.alpha && n.push(o);
                else if (2 === i) for(r = p; f <= r; r--)for(s = c; a[r] && s < d; s++)(o = a[r][s]) && -1 !== o.index && o.visible && 0 !== o.alpha && n.push(o);
                else if (3 === i) for(r = p; f <= r; r--)for(s = d; a[r] && c <= s; s--)(o = a[r][s]) && -1 !== o.index && o.visible && 0 !== o.alpha && n.push(o);
                return u.tilesDrawn = n.length, u.tilesTotal = h * l, n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = i.collideIndexes.indexOf(t);
                e && -1 === n ? i.collideIndexes.push(t) : e || -1 === n || i.collideIndexes.splice(n, 1);
            };
        },
        function(t, e, i) {
            var r = i(2);
            t.exports = function(t, e, i) {
                if (!e) return {
                    i: 0,
                    layers: t.layers,
                    name: "",
                    opacity: 1,
                    visible: !0,
                    x: 0,
                    y: 0
                };
                var n = e.x + r(e, "startx", 0) * t.tilewidth + r(e, "offsetx", 0), s = e.y + r(e, "starty", 0) * t.tileheight + r(e, "offsety", 0);
                return {
                    i: 0,
                    layers: e.layers,
                    name: i.name + e.name + "/",
                    opacity: i.opacity * e.opacity,
                    visible: i.visible && e.visible,
                    x: i.x + n,
                    y: i.y + s
                };
            };
        },
        function(t, e) {
            t.exports = function(o, a, t) {
                return o.hasOwnProperty(a) ? "function" == typeof o[a] ? function(t, e, i, n, s, r) {
                    return o[a](t, e, i, n, s, r);
                } : function() {
                    return o[a];
                } : "function" == typeof t ? t : function() {
                    return t;
                };
            };
        },
        function(t, e, i) {
            var O = i(261), L = i(13), D = i(96), F = i(80), k = i(160), I = i(579), B = i(259), N = i(6), Y = i(260), U = i(262), X = i(264);
            t.exports = function(t, e, i) {
                void 0 === i && (i = O);
                for(var n = i.targets ? i.targets : B(e), s = I(e), r = k(e, "delay", i.delay), o = k(e, "duration", i.duration), a = N(e, "easeParams", i.easeParams), h = F(N(e, "ease", i.ease), a), l = k(e, "hold", i.hold), u = k(e, "repeat", i.repeat), c = k(e, "repeatDelay", i.repeatDelay), d = D(e, "yoyo", i.yoyo), f = D(e, "flipX", i.flipX), p = D(e, "flipY", i.flipY), g = [], v = 0; v < s.length; v++)for(var m = s[v].key, y = s[v].value, x = 0; x < n.length; x++){
                    var T = Y(m, y), w = X(n[x], x, m, T.getEnd, T.getStart, T.getActive, F(N(y, "ease", h), N(y, "easeParams", a)), k(y, "delay", r), k(y, "duration", o), D(y, "yoyo", d), k(y, "hold", l), k(y, "repeat", u), k(y, "repeatDelay", c), D(y, "flipX", f), D(y, "flipY", p));
                    g.push(w);
                }
                var b = new U(t, g, n);
                b.offset = L(e, "offset", null), b.completeDelay = L(e, "completeDelay", 0), b.loop = Math.round(L(e, "loop", 0)), b.loopDelay = Math.round(L(e, "loopDelay", 0)), b.paused = D(e, "paused", !1), b.useFrames = D(e, "useFrames", !1);
                for(var E = N(e, "callbackScope", b), S = [
                    b,
                    null
                ], A = U.TYPES, _ = 0; _ < A.length; _++){
                    var C, M, R = A[_], P = N(e, R, !1);
                    P && (C = N(e, R + "Scope", E), M = N(e, R + "Params", []), b.setCallback(R, P, S.concat(M), C));
                }
                return b;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(99), l = i(2), r = i(130), o = i(182), a = new n({
                initialize: function(t) {
                    this.parent = t, this.animationManager = t.scene.sys.anims, this.animationManager.on(r.REMOVE_ANIMATION, this.globalRemove, this), this.textureManager = this.animationManager.textureManager, this.anims = null, this.isPlaying = !1, this.hasStarted = !1, this.currentAnim = null, this.currentFrame = null, this.nextAnim = null, this.nextAnimsQueue = [], this.timeScale = 1, this.frameRate = 0, this.duration = 0, this.msPerFrame = 0, this.skipMissedFrames = !0, this.delay = 0, this.repeat = 0, this.repeatDelay = 0, this.yoyo = !1, this.showOnStart = !1, this.hideOnComplete = !1, this.forward = !0, this.inReverse = !1, this.accumulator = 0, this.nextTick = 0, this.delayCounter = 0, this.repeatCounter = 0, this.pendingRepeat = !1, this._paused = !1, this._wasPlaying = !1, this._pendingStop = 0, this._pendingStopValue;
                },
                chain: function(t) {
                    var e = this.parent;
                    if (void 0 === t) return this.nextAnimsQueue.length = 0, this.nextAnim = null, e;
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        null === this.nextAnim ? this.nextAnim = n : this.nextAnimsQueue.push(n);
                    }
                    return this.parent;
                },
                getName: function() {
                    return this.currentAnim ? this.currentAnim.key : "";
                },
                getFrameName: function() {
                    return this.currentFrame ? this.currentFrame.textureFrame : "";
                },
                load: function(t) {
                    this.isPlaying && this.stop();
                    var e, i, n, s, r, o = this.animationManager, a = "string" == typeof t ? t : l(t, "key", null), h = this.exists(a) ? this.get(a) : o.get(a);
                    return h ? (e = (this.currentAnim = h).getTotalFrames(), i = l(t, "frameRate", h.frameRate), n = l(t, "duration", h.duration), h.calculateDuration(this, e, n, i), this.delay = l(t, "delay", h.delay), this.repeat = l(t, "repeat", h.repeat), this.repeatDelay = l(t, "repeatDelay", h.repeatDelay), this.yoyo = l(t, "yoyo", h.yoyo), this.showOnStart = l(t, "showOnStart", h.showOnStart), this.hideOnComplete = l(t, "hideOnComplete", h.hideOnComplete), this.skipMissedFrames = l(t, "skipMissedFrames", h.skipMissedFrames), this.timeScale = l(t, "timeScale", this.timeScale), (s = l(t, "startFrame", 0)) > h.getTotalFrames() && (s = 0), r = h.frames[s], 0 !== s || this.forward || (r = h.getLastFrame()), this.currentFrame = r) : console.warn("Missing animation: " + a), this.parent;
                },
                pause: function(t) {
                    return this._paused || (this._paused = !0, this._wasPlaying = this.isPlaying, this.isPlaying = !1), void 0 !== t && this.setCurrentFrame(t), this.parent;
                },
                resume: function(t) {
                    return this._paused && (this._paused = !1, this.isPlaying = this._wasPlaying), void 0 !== t && this.setCurrentFrame(t), this.parent;
                },
                playAfterDelay: function(t, e) {
                    var i, n;
                    return this.isPlaying ? (i = this.nextAnim, n = this.nextAnimsQueue, i && n.unshift(i), this.nextAnim = t, this._pendingStop = 1, this._pendingStopValue = e) : (this.delayCounter = e, this.play(t, !0)), this.parent;
                },
                playAfterRepeat: function(t, e) {
                    var i, n;
                    return void 0 === e && (e = 1), this.isPlaying ? (i = this.nextAnim, n = this.nextAnimsQueue, i && n.unshift(i), -1 !== this.repeatCounter && e > this.repeatCounter && (e = this.repeatCounter), this.nextAnim = t, this._pendingStop = 2, this._pendingStopValue = e) : this.play(t), this.parent;
                },
                play: function(t, e) {
                    void 0 === e && (e = !1);
                    var i = this.currentAnim, n = this.parent, s = "string" == typeof t ? t : t.key;
                    if (e && this.isPlaying && i.key === s) return n;
                    if (i && this.isPlaying) {
                        var r = this.animationManager.getMix(i.key, t);
                        if (0 < r) return this.playAfterDelay(t, r);
                    }
                    return this.forward = !0, this.inReverse = !1, this._paused = !1, this._wasPlaying = !0, this.startAnimation(t);
                },
                playReverse: function(t, e) {
                    void 0 === e && (e = !1);
                    var i = "string" == typeof t ? t : t.key;
                    return e && this.isPlaying && this.currentAnim.key === i ? this.parent : (this.forward = !1, this.inReverse = !0, this._paused = !1, this._wasPlaying = !0, this.startAnimation(t));
                },
                startAnimation: function(t) {
                    this.load(t);
                    var e = this.currentAnim, i = this.parent;
                    return e && (this.repeatCounter = -1 === this.repeat ? Number.MAX_VALUE : this.repeat, e.getFirstTick(this), this.isPlaying = !0, this.pendingRepeat = !1, this.hasStarted = !1, this._pendingStop = 0, this._pendingStopValue = 0, this._paused = !1, this.delayCounter += this.delay, 0 === this.delayCounter && this.handleStart()), i;
                },
                handleStart: function() {
                    this.showOnStart && this.parent.setVisible(!0), this.setCurrentFrame(this.currentFrame), this.hasStarted = !0, this.emitEvents(r.ANIMATION_START);
                },
                handleRepeat: function() {
                    this.pendingRepeat = !1, this.emitEvents(r.ANIMATION_REPEAT);
                },
                handleStop: function() {
                    this._pendingStop = 0, this.isPlaying = !1, this.emitEvents(r.ANIMATION_STOP);
                },
                handleComplete: function() {
                    this._pendingStop = 0, this.isPlaying = !1, this.hideOnComplete && this.parent.setVisible(!1), this.emitEvents(r.ANIMATION_COMPLETE, r.ANIMATION_COMPLETE_KEY);
                },
                emitEvents: function(t, e) {
                    var i = this.currentAnim, n = this.currentFrame, s = this.parent, r = n.textureFrame;
                    s.emit(t, i, n, s, r), e && s.emit(e + i.key, i, n, s, r);
                },
                reverse: function() {
                    return this.isPlaying && (this.inReverse = !this.inReverse, this.forward = !this.forward), this.parent;
                },
                getProgress: function() {
                    var t = this.currentFrame;
                    if (!t) return 0;
                    var e = t.progress;
                    return this.inReverse && (e *= -1), e;
                },
                setProgress: function(t) {
                    return this.forward || (t = 1 - t), this.setCurrentFrame(this.currentAnim.getFrameByProgress(t)), this.parent;
                },
                setRepeat: function(t) {
                    return this.repeatCounter = -1 === t ? Number.MAX_VALUE : t, this.parent;
                },
                globalRemove: function(t, e) {
                    void 0 === e && (e = this.currentAnim), this.isPlaying && e.key === this.currentAnim.key && (this.stop(), this.setCurrentFrame(this.currentAnim.frames[0]));
                },
                restart: function(t, e) {
                    void 0 === t && (t = !1), void 0 === e && (e = !1);
                    var i = this.currentAnim, n = this.parent;
                    return i ? (e && (this.repeatCounter = -1 === this.repeat ? Number.MAX_VALUE : this.repeat), i.getFirstTick(this), this.emitEvents(r.ANIMATION_RESTART), this.isPlaying = !0, this.pendingRepeat = !1, this.hasStarted = !t, this._pendingStop = 0, this._pendingStopValue = 0, this._paused = !1, this.setCurrentFrame(i.frames[0]), this.parent) : n;
                },
                complete: function() {
                    var t;
                    return this._pendingStop = 0, this.isPlaying = !1, this.currentAnim && this.handleComplete(), this.nextAnim && (t = this.nextAnim, this.nextAnim = 0 < this.nextAnimsQueue.length ? this.nextAnimsQueue.shift() : null, this.play(t)), this.parent;
                },
                stop: function() {
                    var t;
                    return this._pendingStop = 0, this.isPlaying = !1, this.currentAnim && this.handleStop(), this.nextAnim && (t = this.nextAnim, this.nextAnim = this.nextAnimsQueue.shift(), this.play(t)), this.parent;
                },
                stopAfterDelay: function(t) {
                    return this._pendingStop = 1, this._pendingStopValue = t, this.parent;
                },
                stopAfterRepeat: function(t) {
                    return void 0 === t && (t = 1), -1 !== this.repeatCounter && t > this.repeatCounter && (t = this.repeatCounter), this._pendingStop = 2, this._pendingStopValue = t, this.parent;
                },
                stopOnFrame: function(t) {
                    return this._pendingStop = 3, this._pendingStopValue = t, this.parent;
                },
                getTotalFrames: function() {
                    return this.currentAnim ? this.currentAnim.getTotalFrames() : 0;
                },
                update: function(t, e) {
                    var i = this.currentAnim;
                    if (this.isPlaying && i && !i.paused) {
                        if (this.accumulator += e * this.timeScale, 1 === this._pendingStop && (this._pendingStopValue -= e, this._pendingStopValue <= 0)) return this.stop();
                        if (this.hasStarted) {
                            if (this.accumulator >= this.nextTick && (this.forward ? i.nextFrame(this) : i.previousFrame(this), this.isPlaying && 0 === this._pendingStop && this.skipMissedFrames && this.accumulator > this.nextTick)) for(var n = 0; this.forward ? i.nextFrame(this) : i.previousFrame(this), n++, this.accumulator > this.nextTick && n < 60;);
                        } else this.accumulator >= this.delayCounter && (this.accumulator -= this.delayCounter, this.handleStart());
                    }
                },
                setCurrentFrame: function(t) {
                    var e = this.parent;
                    return this.currentFrame = t, e.texture = t.frame.texture, e.frame = t.frame, e.isCropped && e.frame.updateCropUVs(e._crop, e.flipX, e.flipY), t.setAlpha && (e.alpha = t.alpha), e.setSizeToFrame(), e._originComponent && (t.frame.customPivot ? e.setOrigin(t.frame.pivotX, t.frame.pivotY) : e.updateDisplayOrigin()), this.isPlaying && this.hasStarted && (this.emitEvents(r.ANIMATION_UPDATE), 3 === this._pendingStop && this._pendingStopValue === t && this.stop()), e;
                },
                nextFrame: function() {
                    return this.currentAnim && this.currentAnim.nextFrame(this), this.parent;
                },
                previousFrame: function() {
                    return this.currentAnim && this.currentAnim.previousFrame(this), this.parent;
                },
                get: function(t) {
                    return this.anims ? this.anims.get(t) : null;
                },
                exists: function(t) {
                    return !!this.anims && this.anims.has(t);
                },
                create: function(t) {
                    var e = t.key, i = !1;
                    return e && ((i = this.get(e)) || (i = new o(this, e, t), this.anims || (this.anims = new s), this.anims.set(e, i))), i;
                },
                generateFrameNames: function(t, e) {
                    return this.animationManager.generateFrameNames(t, e);
                },
                generateFrameNumbers: function(t, e) {
                    return this.animationManager.generateFrameNumbers(t, e);
                },
                remove: function(t) {
                    var e = this.get(t);
                    return e && (this.currentAnim === e && this.stop(), this.anims.delete(t)), e;
                },
                destroy: function() {
                    this.animationManager.off(r.REMOVE_ANIMATION, this.globalRemove, this), this.anims && this.anims.clear(), this.animationManager = null, this.parent = null, this.nextAnim = null, this.nextAnimsQueue.length = 0, this.currentAnim = null, this.currentFrame = null;
                },
                isPaused: {
                    get: function() {
                        return this._paused;
                    }
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var c = {};
            t.exports = c;
            var o = i(268), r = i(50), a = i(117), d = i(71);
            c.create = function(t) {
                return r.extend({
                    id: r.nextId(),
                    type: "composite",
                    parent: null,
                    isModified: !1,
                    bodies: [],
                    constraints: [],
                    composites: [],
                    label: "Composite",
                    plugin: {}
                }, t);
            }, c.setModified = function(t, e, i, n) {
                if (o.trigger(t, "compositeModified", t), t.isModified = e, i && t.parent && c.setModified(t.parent, e, i, n), n) for(var s = 0; s < t.composites.length; s++){
                    var r = t.composites[s];
                    c.setModified(r, e, i, n);
                }
            }, c.add = function(t, e) {
                var i = [].concat(e);
                o.trigger(t, "beforeAdd", {
                    object: e
                });
                for(var n = 0; n < i.length; n++){
                    var s = i[n];
                    switch(s.type){
                        case "body":
                            if (s.parent !== s) {
                                r.warn("Composite.add: skipped adding a compound body part (you must add its parent instead)");
                                break;
                            }
                            c.addBody(t, s);
                            break;
                        case "constraint":
                            c.addConstraint(t, s);
                            break;
                        case "composite":
                            c.addComposite(t, s);
                            break;
                        case "mouseConstraint":
                            c.addConstraint(t, s.constraint);
                    }
                }
                return o.trigger(t, "afterAdd", {
                    object: e
                }), t;
            }, c.remove = function(t, e, i) {
                var n = [].concat(e);
                o.trigger(t, "beforeRemove", {
                    object: e
                });
                for(var s = 0; s < n.length; s++){
                    var r = n[s];
                    switch(r.type){
                        case "body":
                            c.removeBody(t, r, i);
                            break;
                        case "constraint":
                            c.removeConstraint(t, r, i);
                            break;
                        case "composite":
                            c.removeComposite(t, r, i);
                            break;
                        case "mouseConstraint":
                            c.removeConstraint(t, r.constraint);
                    }
                }
                return o.trigger(t, "afterRemove", {
                    object: e
                }), t;
            }, c.addComposite = function(t, e) {
                return t.composites.push(e), e.parent = t, c.setModified(t, !0, !0, !1), t;
            }, c.removeComposite = function(t, e, i) {
                var n = t.composites.indexOf(e);
                if (-1 !== n && (c.removeCompositeAt(t, n), c.setModified(t, !0, !0, !1)), i) for(var s = 0; s < t.composites.length; s++)c.removeComposite(t.composites[s], e, !0);
                return t;
            }, c.removeCompositeAt = function(t, e) {
                return t.composites.splice(e, 1), c.setModified(t, !0, !0, !1), t;
            }, c.addBody = function(t, e) {
                return t.bodies.push(e), c.setModified(t, !0, !0, !1), t;
            }, c.removeBody = function(t, e, i) {
                var n = t.bodies.indexOf(e);
                if (-1 !== n && (c.removeBodyAt(t, n), c.setModified(t, !0, !0, !1)), i) for(var s = 0; s < t.composites.length; s++)c.removeBody(t.composites[s], e, !0);
                return t;
            }, c.removeBodyAt = function(t, e) {
                return t.bodies.splice(e, 1), c.setModified(t, !0, !0, !1), t;
            }, c.addConstraint = function(t, e) {
                return t.constraints.push(e), c.setModified(t, !0, !0, !1), t;
            }, c.removeConstraint = function(t, e, i) {
                var n = t.constraints.indexOf(e);
                if (-1 !== n && c.removeConstraintAt(t, n), i) for(var s = 0; s < t.composites.length; s++)c.removeConstraint(t.composites[s], e, !0);
                return t;
            }, c.removeConstraintAt = function(t, e) {
                return t.constraints.splice(e, 1), c.setModified(t, !0, !0, !1), t;
            }, c.clear = function(t, e, i) {
                if (i) for(var n = 0; n < t.composites.length; n++)c.clear(t.composites[n], e, !0);
                return e ? t.bodies = t.bodies.filter(function(t) {
                    return t.isStatic;
                }) : t.bodies.length = 0, t.constraints.length = 0, t.composites.length = 0, c.setModified(t, !0, !0, !1), t;
            }, c.allBodies = function(t) {
                for(var e = [].concat(t.bodies), i = 0; i < t.composites.length; i++)e = e.concat(c.allBodies(t.composites[i]));
                return e;
            }, c.allConstraints = function(t) {
                for(var e = [].concat(t.constraints), i = 0; i < t.composites.length; i++)e = e.concat(c.allConstraints(t.composites[i]));
                return e;
            }, c.allComposites = function(t) {
                for(var e = [].concat(t.composites), i = 0; i < t.composites.length; i++)e = e.concat(c.allComposites(t.composites[i]));
                return e;
            }, c.get = function(t, e, i) {
                var n, s;
                switch(i){
                    case "body":
                        n = c.allBodies(t);
                        break;
                    case "constraint":
                        n = c.allConstraints(t);
                        break;
                    case "composite":
                        n = c.allComposites(t).concat(t);
                }
                return !n || 0 === (s = n.filter(function(t) {
                    return t.id.toString() === e.toString();
                })).length ? null : s[0];
            }, c.move = function(t, e, i) {
                return c.remove(t, e), c.add(i, e), t;
            }, c.rebase = function(t) {
                for(var e = c.allBodies(t).concat(c.allConstraints(t)).concat(c.allComposites(t)), i = 0; i < e.length; i++)e[i].id = r.nextId();
                return c.setModified(t, !0, !0, !1), t;
            }, c.translate = function(t, e, i) {
                for(var n = i ? c.allBodies(t) : t.bodies, s = 0; s < n.length; s++)d.translate(n[s], e);
                return c.setModified(t, !0, !0, !1), t;
            }, c.rotate = function(t, e, i, n) {
                for(var s = Math.cos(e), r = Math.sin(e), o = n ? c.allBodies(t) : t.bodies, a = 0; a < o.length; a++){
                    var h = o[a], l = h.position.x - i.x, u = h.position.y - i.y;
                    d.setPosition(h, {
                        x: i.x + (l * s - u * r),
                        y: i.y + (l * r + u * s)
                    }), d.rotate(h, e);
                }
                return c.setModified(t, !0, !0, !1), t;
            }, c.scale = function(t, e, i, n, s) {
                for(var r = s ? c.allBodies(t) : t.bodies, o = 0; o < r.length; o++){
                    var a = r[o], h = a.position.x - n.x, l = a.position.y - n.y;
                    d.setPosition(a, {
                        x: n.x + h * e,
                        y: n.y + l * i
                    }), d.scale(a, e, i);
                }
                return c.setModified(t, !0, !0, !1), t;
            }, c.bounds = function(t) {
                for(var e = c.allBodies(t), i = [], n = 0; n < e.length; n += 1){
                    var s = e[n];
                    i.push(s.bounds.min, s.bounds.max);
                }
                return a.create(i);
            };
        },
        function(t, e) {
            t.exports = {
                DEFAULT: 0,
                LINEAR: 0,
                NEAREST: 1
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e, i) {
                return void 0 === i && (i = new n), i.x = t.x + t.radius * Math.cos(e), i.y = t.y + t.radius * Math.sin(e), i;
            };
        },
        function(t, e, i) {
            var a = i(4);
            t.exports = function(t, e) {
                void 0 === e && (e = new a);
                var i = 2 * Math.PI * Math.random(), n = Math.random() + Math.random(), s = 1 < n ? 2 - n : n, r = s * Math.cos(i), o = s * Math.sin(i);
                return e.x = t.x + r * t.radius, e.y = t.y + o * t.radius, e;
            };
        },
        function(t, e, i) {
            var s = i(128), r = i(4);
            t.exports = function(t, e, i) {
                if (void 0 === i && (i = new r), e <= 0 || 1 <= e) return i.x = t.x, i.y = t.y, i;
                var n = s(t) * e;
                return .5 < e ? (n -= t.width + t.height) <= t.width ? (i.x = t.right - n, i.y = t.bottom) : (i.x = t.x, i.y = t.bottom - (n - t.width)) : n <= t.width ? (i.x = t.x + n, i.y = t.y) : (i.x = t.right, i.y = t.y + (n - t.width)), i;
            };
        },
        function(t, e, i) {
            var d = i(64), f = i(4);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = []), !e && 0 < i && (e = d(t) / i);
                for(var s = t.x1, r = t.y1, o = t.x2, a = t.y2, h = 0; h < e; h++){
                    var l = h / e, u = s + (o - s) * l, c = r + (a - r) * l;
                    n.push(new f(u, c));
                }
                return n;
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                void 0 === e && (e = new n);
                var i = Math.random();
                return e.x = t.x1 + i * (t.x2 - t.x1), e.y = t.y1 + i * (t.y2 - t.y1), e;
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = t.x + Math.random() * t.width, e.y = t.y + Math.random() * t.height, e;
            };
        },
        function(t, e, i) {
            var a = i(172), s = i(65), r = i(74), n = {
                defaultPipeline: null,
                pipeline: null,
                hasPostPipeline: !1,
                postPipelines: null,
                pipelineData: null,
                initPipeline: function(t) {
                    void 0 === t && (t = s.MULTI_PIPELINE);
                    var e = this.scene.sys.renderer;
                    if (!e) return !1;
                    var i = e.pipelines;
                    if (this.postPipelines = [], this.pipelineData = {}, i) {
                        var n = i.get(t);
                        if (n) return this.defaultPipeline = n, this.pipeline = n, !0;
                    }
                    return !1;
                },
                setPipeline: function(t, e, i) {
                    var n = this.scene.sys.renderer;
                    if (!n) return this;
                    var s, r = n.pipelines;
                    return r && ((s = r.get(t)) && (this.pipeline = s), e && (this.pipelineData = i ? a(e) : e)), this;
                },
                setPostPipeline: function(t, e, i) {
                    var n = this.scene.sys.renderer;
                    if (!n) return this;
                    var s = n.pipelines;
                    if (s) {
                        Array.isArray(t) || (t = [
                            t
                        ]);
                        for(var r = 0; r < t.length; r++){
                            var o = s.getPostPipeline(t[r], this);
                            o && this.postPipelines.push(o);
                        }
                        e && (this.pipelineData = i ? a(e) : e);
                    }
                    return this.hasPostPipeline = 0 < this.postPipelines.length, this;
                },
                setPipelineData: function(t, e) {
                    var i = this.pipelineData;
                    return void 0 === e ? delete i[t] : i[t] = e, this;
                },
                getPostPipeline: function(t) {
                    for(var e = this.postPipelines, i = [], n = 0; n < e.length; n++){
                        var s = e[n];
                        ("string" == typeof t && s.name === t || s instanceof t) && i.push(s);
                    }
                    return 1 === i.length ? i[0] : i;
                },
                resetPipeline: function(t, e) {
                    return void 0 === t && (t = !1), void 0 === e && (e = !1), this.pipeline = this.defaultPipeline, t && (this.postPipelines = [], this.hasPostPipeline = !1), e && (this.pipelineData = {}), null !== this.pipeline;
                },
                resetPostPipeline: function(t) {
                    void 0 === t && (t = !1);
                    for(var e = this.postPipelines, i = 0; i < e.length; i++)e[i].destroy();
                    this.postPipelines = [], this.hasPostPipeline = !1, t && (this.pipelineData = {});
                },
                removePostPipeline: function(t) {
                    for(var e = this.postPipelines, i = e.length - 1; 0 <= i; i--){
                        var n = e[i];
                        ("string" == typeof t && n.name === t || "string" != typeof t && n instanceof t) && (n.destroy(), r(e, i));
                    }
                    return this.hasPostPipeline = 0 < this.postPipelines.length, this;
                },
                getPipelineName: function() {
                    return this.pipeline.name;
                }
            };
            t.exports = n;
        },
        function(t, e) {
            var s = function(t) {
                var e, i, n;
                if ("object" != typeof t || null === t) return t;
                for(n in e = Array.isArray(t) ? [] : {}, t)i = t[n], e[n] = s(i);
                return e;
            };
            t.exports = s;
        },
        function(t, e) {
            t.exports = function(t) {
                var e = {
                    name: t.name,
                    type: t.type,
                    x: t.x,
                    y: t.y,
                    depth: t.depth,
                    scale: {
                        x: t.scaleX,
                        y: t.scaleY
                    },
                    origin: {
                        x: t.originX,
                        y: t.originY
                    },
                    flipX: t.flipX,
                    flipY: t.flipY,
                    rotation: t.rotation,
                    alpha: t.alpha,
                    visible: t.visible,
                    blendMode: t.blendMode,
                    textureKey: "",
                    frameKey: "",
                    data: {}
                };
                return t.texture && (e.textureKey = t.texture.key, e.frameKey = t.frame.name), e;
            };
        },
        function(t, e, i) {
            var g = i(3);
            t.exports = function(t, e, i, n, s, r, o, a) {
                void 0 === a && (a = new g);
                var h = Math.sin(s), l = Math.cos(s), u = l * r, c = h * r, d = -h * o, f = l * o, p = 1 / (u * f + d * -c);
                return a.x = f * p * t + -d * p * e + (n * d - i * f) * p, a.y = u * p * e + -c * p * t + (-n * u + i * c) * p, a;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 1);
                for(var i = null, n = 0; n < e; n++)i = t.shift(), t.push(i);
                return i;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 1);
                for(var i = null, n = 0; n < e; n++)i = t.pop(), t.unshift(i);
                return i;
            };
        },
        function(t, e, i) {
            var s = i(4);
            t.exports = function(t, e) {
                void 0 === e && (e = new s);
                var i = Math.random() * Math.PI * 2, n = Math.sqrt(Math.random());
                return e.x = t.x + n * Math.cos(i) * t.width / 2, e.y = t.y + n * Math.sin(i) * t.height / 2, e;
            };
        },
        function(t, e, i) {
            var h = i(4);
            t.exports = function(t, e) {
                void 0 === e && (e = new h);
                var i = t.x2 - t.x1, n = t.y2 - t.y1, s = t.x3 - t.x1, r = t.y3 - t.y1, o = Math.random(), a = Math.random();
                return 1 <= o + a && (o = 1 - o, a = 1 - a), e.x = t.x1 + (i * o + s * a), e.y = t.y1 + (n * o + r * a), e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                var r = n + Math.atan2(t.y - i, t.x - e);
                return t.x = e + s * Math.cos(r), t.y = i + s * Math.sin(r), t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return (t = Math.max(0, Math.min(1, (t - e) / (i - e)))) * t * t * (t * (6 * t - 15) + 10);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t <= e ? 0 : i <= t ? 1 : (t = (t - e) / (i - e)) * t * (3 - 2 * t);
            };
        },
        function(t, e, i) {
            var n = i(18), s = i(0), r = i(130), o = i(312), v = i(313), m = i(6), y = i(314), a = new s({
                initialize: function(t, e, i) {
                    this.manager = t, this.key = e, this.type = "frame", this.frames = this.getFrames(t.textureManager, m(i, "frames", []), m(i, "defaultTextureKey", null), m(i, "sortFrames", !0)), this.frameRate = m(i, "frameRate", null), this.duration = m(i, "duration", null), this.msPerFrame, this.skipMissedFrames = m(i, "skipMissedFrames", !0), this.delay = m(i, "delay", 0), this.repeat = m(i, "repeat", 0), this.repeatDelay = m(i, "repeatDelay", 0), this.yoyo = m(i, "yoyo", !1), this.showOnStart = m(i, "showOnStart", !1), this.hideOnComplete = m(i, "hideOnComplete", !1), this.paused = !1, this.calculateDuration(this, this.getTotalFrames(), this.duration, this.frameRate), this.manager.on && (this.manager.on(r.PAUSE_ALL, this.pause, this), this.manager.on(r.RESUME_ALL, this.resume, this));
                },
                getTotalFrames: function() {
                    return this.frames.length;
                },
                calculateDuration: function(t, e, i, n) {
                    null === i && null === n ? (t.frameRate = 24, t.duration = 24 / e * 1e3) : i && null === n ? (t.duration = i, t.frameRate = e / (i / 1e3)) : (t.frameRate = n, t.duration = e / n * 1e3), t.msPerFrame = 1e3 / t.frameRate;
                },
                addFrame: function(t) {
                    return this.addFrameAt(this.frames.length, t);
                },
                addFrameAt: function(t, e) {
                    var i, n, s = this.getFrames(this.manager.textureManager, e);
                    return 0 < s.length && (0 === t ? this.frames = s.concat(this.frames) : t === this.frames.length ? this.frames = this.frames.concat(s) : (i = this.frames.slice(0, t), n = this.frames.slice(t), this.frames = i.concat(s, n)), this.updateFrameSequence()), this;
                },
                checkFrame: function(t) {
                    return 0 <= t && t < this.frames.length;
                },
                getFirstTick: function(t) {
                    t.accumulator = 0, t.nextTick = t.msPerFrame + t.currentFrame.duration;
                },
                getFrameAt: function(t) {
                    return this.frames[t];
                },
                getFrames: function(t, e, i, n) {
                    void 0 === n && (n = !0);
                    var s, r, o, a = [], h = 1;
                    if ("string" == typeof e && (r = e, o = t.get(r).getFrameNames(), n && y(o), e = [], o.forEach(function(t) {
                        e.push({
                            key: r,
                            frame: t
                        });
                    })), !Array.isArray(e) || 0 === e.length) return a;
                    for(g = 0; g < e.length; g++){
                        var l, u, c, d = e[g], f = m(d, "key", i);
                        f && (l = m(d, "frame", 0), u = t.getFrame(f, l), (c = new v(f, l, h, u)).duration = m(d, "duration", 0), c.isFirst = !s, s && ((s.nextFrame = c).prevFrame = s), a.push(c), s = c, h++);
                    }
                    if (0 < a.length) {
                        c.isLast = !0, c.nextFrame = a[0], a[0].prevFrame = c;
                        for(var p = 1 / (a.length - 1), g = 0; g < a.length; g++)a[g].progress = g * p;
                    }
                    return a;
                },
                getNextTick: function(t) {
                    t.accumulator -= t.nextTick, t.nextTick = t.msPerFrame + t.currentFrame.duration;
                },
                getFrameByProgress: function(t) {
                    return t = n(t, 0, 1), o(t, this.frames, "progress");
                },
                nextFrame: function(t) {
                    var e = t.currentFrame;
                    e.isLast ? t.yoyo ? this.handleYoyoFrame(t, !1) : 0 < t.repeatCounter ? t.inReverse && t.forward ? t.forward = !1 : this.repeatAnimation(t) : t.complete() : this.updateAndGetNextTick(t, e.nextFrame);
                },
                handleYoyoFrame: function(t, e) {
                    if (e = e || !1, t.inReverse === !e && 0 < t.repeatCounter) return 0 !== t.repeatDelay && !t.pendingRepeat || (t.forward = e), void this.repeatAnimation(t);
                    var i;
                    t.inReverse === e || 0 !== t.repeatCounter ? (i = (t.forward = e) ? t.currentFrame.nextFrame : t.currentFrame.prevFrame, this.updateAndGetNextTick(t, i)) : t.complete();
                },
                getLastFrame: function() {
                    return this.frames[this.frames.length - 1];
                },
                previousFrame: function(t) {
                    var e = t.currentFrame;
                    e.isFirst ? t.yoyo ? this.handleYoyoFrame(t, !0) : 0 < t.repeatCounter ? (t.inReverse && !t.forward || (t.forward = !0), this.repeatAnimation(t)) : t.complete() : this.updateAndGetNextTick(t, e.prevFrame);
                },
                updateAndGetNextTick: function(t, e) {
                    t.setCurrentFrame(e), this.getNextTick(t);
                },
                removeFrame: function(t) {
                    var e = this.frames.indexOf(t);
                    return -1 !== e && this.removeFrameAt(e), this;
                },
                removeFrameAt: function(t) {
                    return this.frames.splice(t, 1), this.updateFrameSequence(), this;
                },
                repeatAnimation: function(t) {
                    if (2 === t._pendingStop) {
                        if (0 === t._pendingStopValue) return t.stop();
                        t._pendingStopValue--;
                    }
                    0 < t.repeatDelay && !t.pendingRepeat ? (t.pendingRepeat = !0, t.accumulator -= t.nextTick, t.nextTick += t.repeatDelay) : (t.repeatCounter--, t.forward ? t.setCurrentFrame(t.currentFrame.nextFrame) : t.setCurrentFrame(t.currentFrame.prevFrame), t.isPlaying && (this.getNextTick(t), t.handleRepeat()));
                },
                toJSON: function() {
                    var e = {
                        key: this.key,
                        type: this.type,
                        frames: [],
                        frameRate: this.frameRate,
                        duration: this.duration,
                        skipMissedFrames: this.skipMissedFrames,
                        delay: this.delay,
                        repeat: this.repeat,
                        repeatDelay: this.repeatDelay,
                        yoyo: this.yoyo,
                        showOnStart: this.showOnStart,
                        hideOnComplete: this.hideOnComplete
                    };
                    return this.frames.forEach(function(t) {
                        e.frames.push(t.toJSON());
                    }), e;
                },
                updateFrameSequence: function() {
                    for(var t, e = this.frames.length, i = 1 / (e - 1), n = 0; n < e; n++)(t = this.frames[n]).index = n + 1, t.isFirst = !1, t.isLast = !1, t.progress = n * i, 0 === n ? (t.isFirst = !0, 1 === e ? (t.isLast = !0, (t.nextFrame = t).prevFrame = t) : (t.isLast = !1, t.prevFrame = this.frames[e - 1], t.nextFrame = this.frames[n + 1])) : n === e - 1 && 1 < e ? (t.isLast = !0, t.prevFrame = this.frames[e - 2], t.nextFrame = this.frames[0]) : 1 < e && (t.prevFrame = this.frames[n - 1], t.nextFrame = this.frames[n + 1]);
                    return this;
                },
                pause: function() {
                    return this.paused = !0, this;
                },
                resume: function() {
                    return this.paused = !1, this;
                },
                destroy: function() {
                    this.manager.off && (this.manager.off(r.PAUSE_ALL, this.pause, this), this.manager.off(r.RESUME_ALL, this.resume, this)), this.manager.remove(this.key);
                    for(var t = 0; t < this.frames.length; t++)this.frames[t].destroy();
                    this.frames = [], this.manager = null;
                }
            });
            t.exports = a;
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = 0), void 0 === i && (i = " "), void 0 === n && (n = 3);
                var s;
                if (e + 1 >= (t = t.toString()).length) switch(n){
                    case 1:
                        t = new Array(e + 1 - t.length).join(i) + t;
                        break;
                    case 3:
                        var r = Math.ceil((s = e - t.length) / 2);
                        t = new Array(1 + (s - r)).join(i) + t + new Array(r + 1).join(i);
                        break;
                    default:
                        t += new Array(e + 1 - t.length).join(i);
                }
                return t;
            };
        },
        function(t, e, i) {
            var n = i(321), s = i(186), r = i(325), o = i(326);
            t.exports = function(t) {
                switch(typeof t){
                    case "string":
                        return ("rgb" === t.substr(0, 3).toLowerCase() ? o : n)(t);
                    case "number":
                        return s(t);
                    case "object":
                        return r(t);
                }
            };
        },
        function(t, e, i) {
            var a = i(100);
            function h(t, e, i, n) {
                var s = (t + 6 * e) % 6, r = Math.min(s, 4 - s, 1);
                return Math.round(255 * (n - n * i * Math.max(0, r)));
            }
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = 1), void 0 === i && (i = 1);
                var s = h(5, t, e, i), r = h(3, t, e, i), o = h(1, t, e, i);
                return n ? n.setTo ? n.setTo(s, r, o, n.alpha, !1) : (n.r = s, n.g = r, n.b = o, n.color = a(s, r, o), n) : {
                    r: s,
                    g: r,
                    b: o,
                    color: a(s, r, o)
                };
            };
        },
        function(t, e, i) {
            var n = i(37), s = i(324);
            t.exports = function(t) {
                var e = s(t);
                return new n(e.r, e.g, e.b, e.a);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t.x = e - t.width / 2, t.y = i - t.height / 2, t;
            };
        },
        function(t, e, i) {
            var n = i(102), r = i(134), o = i(31), a = {
                canvas: !1,
                canvasBitBltShift: null,
                file: !1,
                fileSystem: !1,
                getUserMedia: !0,
                littleEndian: !1,
                localStorage: !1,
                pointerLock: !1,
                support32bit: !1,
                vibration: !1,
                webGL: !1,
                worker: !1
            };
            t.exports = function() {
                a.canvas = !!window.CanvasRenderingContext2D;
                try {
                    a.localStorage = !!localStorage.getItem;
                } catch (t) {
                    a.localStorage = !1;
                }
                a.file = !!(window.File && window.FileReader && window.FileList && window.Blob), a.fileSystem = !!window.requestFileSystem;
                var t, e, i, s = !1;
                return a.webGL = function() {
                    if (window.WebGLRenderingContext) try {
                        var t = o.createWebGL(this), e = t.getContext("webgl") || t.getContext("experimental-webgl"), i = o.create2D(this), n = i.getContext("2d").createImageData(1, 1);
                        return s = n.data instanceof Uint8ClampedArray, o.remove(t), o.remove(i), !!e;
                    } catch (t) {
                        return !1;
                    }
                    return !1;
                }(), a.worker = !!window.Worker, a.pointerLock = "pointerLockElement" in document || "mozPointerLockElement" in document || "webkitPointerLockElement" in document, navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia, window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL, a.getUserMedia = a.getUserMedia && !!navigator.getUserMedia && !!window.URL, r.firefox && r.firefoxVersion < 21 && (a.getUserMedia = !1), !n.iOS && (r.ie || r.firefox || r.chrome) && (a.canvasBitBltShift = !0), (r.safari || r.mobileSafari) && (a.canvasBitBltShift = !1), navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate, navigator.vibrate && (a.vibration = !0), "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && "undefined" != typeof Uint32Array && (a.littleEndian = (t = new ArrayBuffer(4), e = new Uint8Array(t), i = new Uint32Array(t), e[0] = 161, e[1] = 178, e[2] = 195, e[3] = 212, 3569595041 === i[0] || 2712847316 !== i[0] && null)), a.support32bit = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8ClampedArray && "undefined" != typeof Int32Array && null !== a.littleEndian && s, a;
            }();
        },
        function(t, e) {
            var i = "";
            function n(t) {
                for(var e = [
                    "i",
                    "webkitI",
                    "msI",
                    "mozI",
                    "oI"
                ], i = 0; i < e.length; i++){
                    var n = e[i] + "mageSmoothingEnabled";
                    if (n in t) return n;
                }
                return null;
            }
            t.exports = {
                disable: function(t) {
                    return "" === i && (i = n(t)), i && (t[i] = !1), t;
                },
                enable: function(t) {
                    return "" === i && (i = n(t)), i && (t[i] = !0), t;
                },
                getPrefix: n,
                isEnabled: function(t) {
                    return null !== i ? t[i] : null;
                }
            };
        },
        function(t, e, i) {
            var n = i(14), s = i(17)(!1, s = {
                Angle: i(809),
                Distance: i(818),
                Easing: i(823),
                Fuzzy: i(824),
                Interpolation: i(827),
                Pow2: i(832),
                Snap: i(834),
                RandomDataGenerator: i(836),
                Average: i(837),
                Bernstein: i(350),
                Between: i(192),
                CatmullRom: i(191),
                CeilTo: i(838),
                Clamp: i(18),
                DegToRad: i(35),
                Difference: i(839),
                Euler: i(840),
                Factorial: i(351),
                FloatBetween: i(135),
                FloorTo: i(841),
                FromPercent: i(95),
                GetSpeed: i(842),
                IsEven: i(843),
                IsEvenStrict: i(844),
                Linear: i(133),
                MaxAdd: i(845),
                MinSub: i(846),
                Percent: i(847),
                RadToDeg: i(193),
                RandomXY: i(848),
                RandomXYZ: i(849),
                RandomXYZW: i(850),
                Rotate: i(356),
                RotateAround: i(302),
                RotateAroundDistance: i(179),
                RotateTo: i(851),
                RoundAwayFromZero: i(357),
                RoundTo: i(852),
                SinCosTableGenerator: i(853),
                SmootherStep: i(180),
                SmoothStep: i(181),
                ToXY: i(854),
                TransformXY: i(174),
                Within: i(855),
                Wrap: i(66),
                Vector2: i(3),
                Vector3: i(38),
                Vector4: i(138),
                Matrix3: i(358),
                Matrix4: i(67),
                Quaternion: i(359),
                RotateVec3: i(856)
            }, n);
            t.exports = s;
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                var r = .5 * (n - e), o = .5 * (s - i), a = t * t;
                return (2 * i - 2 * n + r + o) * (t * a) + (-3 * i + 3 * n - 2 * r - o) * a + r * t + i;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return Math.floor(Math.random() * (e - t + 1) + t);
            };
        },
        function(t, e, i) {
            var n = i(14);
            t.exports = function(t) {
                return t * n.RAD_TO_DEG;
            };
        },
        function(t, e, i) {
            t.exports = {
                Global: [
                    "game",
                    "anims",
                    "cache",
                    "plugins",
                    "registry",
                    "scale",
                    "sound",
                    "textures",
                    "renderer"
                ],
                CoreScene: [
                    "EventEmitter",
                    "CameraManager",
                    "GameObjectCreator",
                    "GameObjectFactory",
                    "ScenePlugin",
                    "DisplayList",
                    "UpdateList"
                ],
                DefaultScene: [
                    "Clock",
                    "DataManagerPlugin",
                    "InputPlugin",
                    "Loader",
                    "TweenManager",
                    "LightsPlugin"
                ]
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function() {
                    this._matrix = [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], this.alpha = 1, this._dirty = !0, this._data;
                },
                set: function(t) {
                    return this._matrix = t, this._dirty = !0, this;
                },
                reset: function() {
                    var t = this._matrix;
                    return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 0, t[6] = 1, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 0, t[11] = 0, t[12] = 1, t[13] = 0, t[14] = 0, t[15] = 0, t[16] = 0, t[17] = 0, t[18] = 1, t[19] = 0, this._dirty = !0, this;
                },
                getData: function() {
                    var t;
                    return this._dirty && ((t = new Float32Array(this._matrix))[4] /= 255, t[9] /= 255, t[14] /= 255, t[19] /= 255, this._data = t, this._dirty = !1), this._data;
                },
                brightness: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = !1), this.multiply([
                        t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], e);
                },
                saturate: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = !1);
                    var i = 2 * t / 3 + 1, n = -0.5 * (i - 1);
                    return this.multiply([
                        i,
                        n,
                        n,
                        0,
                        0,
                        n,
                        i,
                        n,
                        0,
                        0,
                        n,
                        n,
                        i,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], e);
                },
                desaturate: function(t) {
                    return void 0 === t && (t = !1), this.saturate(-1, t);
                },
                hue: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = !1), t = t / 180 * Math.PI;
                    var i = Math.cos(t), n = Math.sin(t);
                    return this.multiply([
                        .213 + .787 * i + -0.213 * n,
                        .715 + -0.715 * i + -0.715 * n,
                        .072 + -0.072 * i + .928 * n,
                        0,
                        0,
                        .213 + -0.213 * i + .143 * n,
                        .715 + i * (1 - .715) + .14 * n,
                        .072 + -0.072 * i + -0.283 * n,
                        0,
                        0,
                        .213 + -0.213 * i + -0.787 * n,
                        .715 + -0.715 * i + .715 * n,
                        .072 + .928 * i + .072 * n,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], e);
                },
                grayscale: function(t, e) {
                    return void 0 === t && (t = 1), void 0 === e && (e = !1), this.saturate(-t, e);
                },
                blackWhite: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        .3,
                        .6,
                        .1,
                        0,
                        0,
                        .3,
                        .6,
                        .1,
                        0,
                        0,
                        .3,
                        .6,
                        .1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                contrast: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = !1);
                    var i = t + 1, n = -0.5 * (i - 1);
                    return this.multiply([
                        i,
                        0,
                        0,
                        0,
                        n,
                        0,
                        i,
                        0,
                        0,
                        n,
                        0,
                        0,
                        i,
                        0,
                        n,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], e);
                },
                negative: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        -1,
                        0,
                        0,
                        1,
                        0,
                        0,
                        -1,
                        0,
                        1,
                        0,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                desaturateLuminance: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        .2764723,
                        .929708,
                        .0938197,
                        0,
                        -37.1,
                        .2764723,
                        .929708,
                        .0938197,
                        0,
                        -37.1,
                        .2764723,
                        .929708,
                        .0938197,
                        0,
                        -37.1,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                sepia: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        .393,
                        .7689999,
                        .18899999,
                        0,
                        0,
                        .349,
                        .6859999,
                        .16799999,
                        0,
                        0,
                        .272,
                        .5339999,
                        .13099999,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                night: function(t, e) {
                    return void 0 === t && (t = .1), void 0 === e && (e = !1), this.multiply([
                        -2 * t,
                        -t,
                        0,
                        0,
                        0,
                        -t,
                        0,
                        t,
                        0,
                        0,
                        0,
                        t,
                        2 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], e);
                },
                lsd: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        2,
                        -0.4,
                        .5,
                        0,
                        0,
                        -0.5,
                        2,
                        -0.4,
                        0,
                        0,
                        -0.4,
                        -0.5,
                        3,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                brown: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        .5997023498159715,
                        .34553243048391263,
                        -0.2708298674538042,
                        0,
                        47.43192855600873,
                        -0.037703249837783157,
                        .8609577587992641,
                        .15059552388459913,
                        0,
                        -36.96841498319127,
                        .24113635128153335,
                        -0.07441037908422492,
                        .44972182064877153,
                        0,
                        -7.562075277591283,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                vintagePinhole: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        .6279345635605994,
                        .3202183420819367,
                        -0.03965408211312453,
                        0,
                        9.651285835294123,
                        .02578397704808868,
                        .6441188644374771,
                        .03259127616149294,
                        0,
                        7.462829176470591,
                        .0466055556782719,
                        -0.0851232987247891,
                        .5241648018700465,
                        0,
                        5.159190588235296,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                kodachrome: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        1.1285582396593525,
                        -0.3967382283601348,
                        -0.03992559172921793,
                        0,
                        63.72958762196502,
                        -0.16404339962244616,
                        1.0835251566291304,
                        -0.05498805115633132,
                        0,
                        24.732407896706203,
                        -0.16786010706155763,
                        -0.5603416277695248,
                        1.6014850761964943,
                        0,
                        35.62982807460946,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                technicolor: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        1.9125277891456083,
                        -0.8545344976951645,
                        -0.09155508482755585,
                        0,
                        11.793603434377337,
                        -0.3087833385928097,
                        1.7658908555458428,
                        -0.10601743074722245,
                        0,
                        -70.35205161461398,
                        -0.231103377548616,
                        -0.7501899197440212,
                        1.847597816108189,
                        0,
                        30.950940869491138,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                polaroid: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        1.438,
                        -0.062,
                        -0.062,
                        0,
                        0,
                        -0.122,
                        1.378,
                        -0.122,
                        0,
                        0,
                        -0.016,
                        -0.016,
                        1.483,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                shiftToBGR: function(t) {
                    return void 0 === t && (t = !1), this.multiply([
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], t);
                },
                multiply: function(t, e) {
                    e || this.reset();
                    for(var i = this._matrix, n = [], s = 0; s < 20; s++)n[s] = i[s];
                    return i[0] = n[0] * t[0] + n[1] * t[5] + n[2] * t[10] + n[3] * t[15], i[1] = n[0] * t[1] + n[1] * t[6] + n[2] * t[11] + n[3] * t[16], i[2] = n[0] * t[2] + n[1] * t[7] + n[2] * t[12] + n[3] * t[17], i[3] = n[0] * t[3] + n[1] * t[8] + n[2] * t[13] + n[3] * t[18], i[4] = n[0] * t[4] + n[1] * t[9] + n[2] * t[14] + n[3] * t[19] + n[4], i[5] = n[5] * t[0] + n[6] * t[5] + n[7] * t[10] + n[8] * t[15], i[6] = n[5] * t[1] + n[6] * t[6] + n[7] * t[11] + n[8] * t[16], i[7] = n[5] * t[2] + n[6] * t[7] + n[7] * t[12] + n[8] * t[17], i[8] = n[5] * t[3] + n[6] * t[8] + n[7] * t[13] + n[8] * t[18], i[9] = n[5] * t[4] + n[6] * t[9] + n[7] * t[14] + n[8] * t[19] + n[9], i[10] = n[10] * t[0] + n[11] * t[5] + n[12] * t[10] + n[13] * t[15], i[11] = n[10] * t[1] + n[11] * t[6] + n[12] * t[11] + n[13] * t[16], i[12] = n[10] * t[2] + n[11] * t[7] + n[12] * t[12] + n[13] * t[17], i[13] = n[10] * t[3] + n[11] * t[8] + n[12] * t[13] + n[13] * t[18], i[14] = n[10] * t[4] + n[11] * t[9] + n[12] * t[14] + n[13] * t[19] + n[14], i[15] = n[15] * t[0] + n[16] * t[5] + n[17] * t[10] + n[18] * t[15], i[16] = n[15] * t[1] + n[16] * t[6] + n[17] * t[11] + n[18] * t[16], i[17] = n[15] * t[2] + n[16] * t[7] + n[17] * t[12] + n[18] * t[17], i[18] = n[15] * t[3] + n[16] * t[8] + n[17] * t[13] + n[18] * t[18], i[19] = n[15] * t[4] + n[16] * t[9] + n[17] * t[14] + n[18] * t[19] + n[19], this._dirty = !0, this;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var u = i(10), c = i(14);
            t.exports = function(t, e) {
                if (void 0 === e && (e = new u), 0 === t.length) return e;
                for(var i, n, s, r = Number.MAX_VALUE, o = Number.MAX_VALUE, a = c.MIN_SAFE_INTEGER, h = c.MIN_SAFE_INTEGER, l = 0; l < t.length; l++)i = t[l], s = Array.isArray(i) ? (n = i[0], i[1]) : (n = i.x, i.y), r = Math.min(r, n), o = Math.min(o, s), a = Math.max(a, n), h = Math.max(h, s);
                return e.x = r, e.y = o, e.width = a - r, e.height = h - o, e;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(1), r = new n({
                initialize: function(t, e, i) {
                    this._rgb = [
                        0,
                        0,
                        0
                    ], this.onChangeCallback = s, this.dirty = !1, this.set(t, e, i);
                },
                set: function(t, e, i) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), this._rgb = [
                        t,
                        e,
                        i
                    ], this.onChange(), this;
                },
                equals: function(t, e, i) {
                    var n = this._rgb;
                    return n.r === t && n.g === e && n.b === i;
                },
                onChange: function() {
                    this.dirty = !0;
                    var t = this._rgb;
                    this.onChangeCallback.call(this, t[0], t[1], t[2]);
                },
                r: {
                    get: function() {
                        return this._rgb[0];
                    },
                    set: function(t) {
                        this._rgb[0] = t, this.onChange();
                    }
                },
                g: {
                    get: function() {
                        return this._rgb[1];
                    },
                    set: function(t) {
                        this._rgb[1] = t, this.onChange();
                    }
                },
                b: {
                    get: function() {
                        return this._rgb[2];
                    },
                    set: function(t) {
                        this._rgb[2] = t, this.onChange();
                    }
                },
                destroy: function() {
                    this.onChangeCallback = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = {
                CENTER: i(397),
                ORIENTATION: i(398),
                SCALE_MODE: i(399),
                ZOOM: i(400)
            };
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                t.parentNode && t.parentNode.removeChild(t);
            };
        },
        function(t, e) {
            t.exports = {
                MOUSE_DOWN: 0,
                MOUSE_MOVE: 1,
                MOUSE_UP: 2,
                TOUCH_START: 3,
                TOUCH_MOVE: 4,
                TOUCH_END: 5,
                POINTER_LOCK_CHANGE: 6,
                TOUCH_CANCEL: 7,
                MOUSE_WHEEL: 8
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(142), r = i(194), o = i(21), a = i(413), h = i(414), l = i(32), u = i(1), c = i(415), d = new n({
                initialize: function(t, e) {
                    this.scene = t, this.game, this.renderer, this.config = e, this.settings = c.create(e), this.canvas, this.context, this.anims, this.cache, this.plugins, this.registry, this.scale, this.sound, this.textures, this.add, this.cameras, this.displayList, this.events, this.make, this.scenePlugin, this.updateList, this.sceneUpdate = u;
                },
                init: function(t) {
                    this.settings.status = s.INIT, this.sceneUpdate = u, this.game = t, this.renderer = t.renderer, this.canvas = t.canvas, this.context = t.context;
                    var e = t.plugins;
                    (this.plugins = e).addToScene(this, r.Global, [
                        r.CoreScene,
                        h(this),
                        a(this)
                    ]), this.events.emit(o.BOOT, this), this.settings.isBooted = !0;
                },
                install: function(t) {
                    Array.isArray(t) || (t = [
                        t
                    ]), this.plugins.installLocal(this, t);
                },
                step: function(t, e) {
                    var i = this.events;
                    i.emit(o.PRE_UPDATE, t, e), i.emit(o.UPDATE, t, e), this.sceneUpdate.call(this.scene, t, e), i.emit(o.POST_UPDATE, t, e);
                },
                render: function(t) {
                    var e = this.displayList;
                    e.depthSort(), this.cameras.render(t, e), this.events.emit(o.RENDER, t);
                },
                queueDepthSort: function() {
                    this.displayList.queueDepthSort();
                },
                depthSort: function() {
                    this.displayList.depthSort();
                },
                pause: function(t) {
                    var e = this.events, i = this.settings;
                    return this.settings.active && (i.status = s.PAUSED, i.active = !1, e.emit(o.PAUSE, this, t)), this;
                },
                resume: function(t) {
                    var e = this.events, i = this.settings;
                    return this.settings.active || (i.status = s.RUNNING, i.active = !0, e.emit(o.RESUME, this, t)), this;
                },
                sleep: function(t) {
                    var e = this.events, i = this.settings;
                    return i.status = s.SLEEPING, i.active = !1, i.visible = !1, e.emit(o.SLEEP, this, t), this;
                },
                wake: function(t) {
                    var e = this.events, i = this.settings;
                    return i.status = s.RUNNING, i.active = !0, i.visible = !0, e.emit(o.WAKE, this, t), i.isTransition && e.emit(o.TRANSITION_WAKE, i.transitionFrom, i.transitionDuration), this;
                },
                getData: function() {
                    return this.settings.data;
                },
                isSleeping: function() {
                    return this.settings.status === s.SLEEPING;
                },
                isActive: function() {
                    return this.settings.status === s.RUNNING;
                },
                isPaused: function() {
                    return this.settings.status === s.PAUSED;
                },
                isTransitioning: function() {
                    return this.settings.isTransition || null !== this.scenePlugin._target;
                },
                isTransitionOut: function() {
                    return null !== this.scenePlugin._target && 0 < this.scenePlugin._duration;
                },
                isTransitionIn: function() {
                    return this.settings.isTransition;
                },
                isVisible: function() {
                    return this.settings.visible;
                },
                setVisible: function(t) {
                    return this.settings.visible = t, this;
                },
                setActive: function(t, e) {
                    return t ? this.resume(e) : this.pause(e);
                },
                start: function(t) {
                    var e = this.events, i = this.settings;
                    t && (i.data = t), i.status = s.START, i.active = !0, i.visible = !0, e.emit(o.START, this), e.emit(o.READY, this, t);
                },
                shutdown: function(t) {
                    var e = this.events, i = this.settings;
                    e.off(o.TRANSITION_INIT), e.off(o.TRANSITION_START), e.off(o.TRANSITION_COMPLETE), e.off(o.TRANSITION_OUT), i.status = s.SHUTDOWN, i.active = !1, i.visible = !1, this.renderer === l.WEBGL && this.renderer.resetTextures(!0), e.emit(o.SHUTDOWN, this, t);
                },
                destroy: function() {
                    var t = this.events, e = this.settings;
                    e.status = s.DESTROYED, e.active = !1, e.visible = !1, t.emit(o.DESTROY, this), t.removeAllListeners();
                    for(var i = [
                        "scene",
                        "game",
                        "anims",
                        "cache",
                        "plugins",
                        "registry",
                        "sound",
                        "textures",
                        "add",
                        "camera",
                        "displayList",
                        "events",
                        "make",
                        "scenePlugin",
                        "updateList"
                    ], n = 0; n < i.length; n++)this[i[n]] = null;
                }
            });
            t.exports = d;
        },
        function(t, e) {
            t.exports = function(t) {
                return t && t[0].toUpperCase() + t.slice(1);
            };
        },
        function(t, e, i) {
            var n = i(32), s = i(0), a = i(106), o = i(418), r = "Texture.frame missing: ", h = new s({
                initialize: function(t, e, i, n, s) {
                    Array.isArray(i) || (i = [
                        i
                    ]), this.manager = t, this.key = e, this.source = [], this.dataSource = [], this.frames = {}, this.customData = {}, this.firstFrame = "__BASE";
                    for(var r = this.frameTotal = 0; r < i.length; r++)this.source.push(new o(this, i[r], n, s));
                },
                add: function(t, e, i, n, s, r) {
                    if (this.has(t)) return null;
                    var o = new a(this, t, e, i, n, s, r);
                    return this.frames[t] = o, "__BASE" === this.firstFrame && (this.firstFrame = t), this.frameTotal++, o;
                },
                remove: function(t) {
                    return !!this.has(t) && (this.get(t).destroy(), delete this.frames[t], !0);
                },
                has: function(t) {
                    return this.frames[t];
                },
                get: function(t) {
                    t = t || this.firstFrame;
                    var e = this.frames[t];
                    return e || (console.warn(r + t), e = this.frames[this.firstFrame]), e;
                },
                getTextureSourceIndex: function(t) {
                    for(var e = 0; e < this.source.length; e++)if (this.source[e] === t) return e;
                    return -1;
                },
                getFramesFromTextureSource: function(t, e) {
                    void 0 === e && (e = !1);
                    var i, n = [];
                    for(var s in this.frames)"__BASE" === s && !e || (i = this.frames[s]).sourceIndex === t && n.push(i);
                    return n;
                },
                getFrameNames: function(t) {
                    void 0 === t && (t = !1);
                    var e, i = Object.keys(this.frames);
                    return t || -1 !== (e = i.indexOf("__BASE")) && i.splice(e, 1), i;
                },
                getSourceImage: function(t) {
                    null != t && 1 !== this.frameTotal || (t = "__BASE");
                    var e = this.frames[t];
                    return e ? e.source.image : (console.warn(r + t), this.frames.__BASE.source.image);
                },
                getDataSourceImage: function(t) {
                    null != t && 1 !== this.frameTotal || (t = "__BASE");
                    var e = this.frames[t], i = e ? e.sourceIndex : (console.warn(r + t), this.frames.__BASE.sourceIndex);
                    return this.dataSource[i].image;
                },
                setDataSource: function(t) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = 0; e < t.length; e++){
                        var i = this.source[e];
                        this.dataSource.push(new o(this, t[e], i.width, i.height));
                    }
                },
                setFilter: function(t) {
                    for(var e = 0; e < this.source.length; e++)this.source[e].setFilter(t);
                    for(e = 0; e < this.dataSource.length; e++)this.dataSource[e].setFilter(t);
                },
                destroy: function() {
                    for(var t = 0; t < this.source.length; t++)this.source[t].destroy();
                    for(t = 0; t < this.dataSource.length; t++)this.dataSource[t].destroy();
                    for(var e in this.frames)this.frames[e].destroy();
                    this.source = [], this.dataSource = [], this.frames = {}, this.manager.removeKey(this.key);
                    var i = this.manager.game.renderer;
                    i.type === n.WEBGL && i.resetTextures(!0), this.manager = null;
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var h = i(78);
            t.exports = function(t, e, i, n, s) {
                void 0 === n && (n = 0), void 0 === s && (s = t.length);
                var r = [];
                if (h(t, n, s)) for(var o = n; o < s; o++){
                    var a = t[o];
                    (!e || e && void 0 === i && a.hasOwnProperty(e) || e && void 0 !== i && a[e] === i) && r.push(a);
                }
                return r;
            };
        },
        function(t, e, i) {
            t.exports = {
                Matrix: i(1009),
                Add: i(1017),
                AddAt: i(1018),
                BringToTop: i(1019),
                CountAllMatching: i(1020),
                Each: i(1021),
                EachInRange: i(1022),
                FindClosestInSorted: i(312),
                GetAll: i(204),
                GetFirst: i(422),
                GetRandom: i(207),
                MoveDown: i(1023),
                MoveTo: i(1024),
                MoveUp: i(1025),
                NumberArray: i(316),
                NumberArrayStep: i(1026),
                QuickSelect: i(430),
                Range: i(431),
                Remove: i(89),
                RemoveAt: i(1027),
                RemoveBetween: i(1028),
                RemoveRandomElement: i(1029),
                Replace: i(1030),
                RotateLeft: i(175),
                RotateRight: i(176),
                SafeRange: i(78),
                SendToBack: i(1031),
                SetAll: i(1032),
                Shuffle: i(129),
                SortByDigits: i(314),
                SpliceOne: i(74),
                StableSort: i(79),
                Swap: i(1033)
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if (!Array.isArray(t) || t.length < 2 || !Array.isArray(t[0])) return !1;
                for(var e = t[0].length, i = 1; i < t.length; i++)if (t[i].length !== e) return !1;
                return !0;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === e && (e = 0), void 0 === i && (i = t.length);
                var n = e + Math.floor(Math.random() * i);
                return void 0 === t[n] ? null : t[n];
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(9), r = i(432), o = new n({
                Extends: s,
                initialize: function() {
                    s.call(this), this._pending = [], this._active = [], this._destroy = [], this._toProcess = 0, this.checkQueue = !1;
                },
                add: function(t) {
                    return this._pending.push(t), this._toProcess++, t;
                },
                remove: function(t) {
                    return this._destroy.push(t), this._toProcess++, t;
                },
                removeAll: function() {
                    for(var t = this._active, e = this._destroy, i = t.length; i--;)e.push(t[i]), this._toProcess++;
                    return this;
                },
                update: function() {
                    if (0 === this._toProcess) return this._active;
                    for(var t, e = this._destroy, i = this._active, n = 0; n < e.length; n++){
                        t = e[n];
                        var s = i.indexOf(t);
                        -1 !== s && (i.splice(s, 1), this.emit(r.PROCESS_QUEUE_REMOVE, t));
                    }
                    for(e.length = 0, e = this._pending, n = 0; n < e.length; n++)t = e[n], (!this.checkQueue || this.checkQueue && -1 === i.indexOf(t)) && (i.push(t), this.emit(r.PROCESS_QUEUE_ADD, t));
                    return e.length = 0, this._toProcess = 0, i;
                },
                getActive: function() {
                    return this._active;
                },
                length: {
                    get: function() {
                        return this._active.length;
                    }
                },
                destroy: function() {
                    this._toProcess = 0, this._pending = [], this._active = [], this._destroy = [];
                }
            });
            t.exports = o;
        },
        function(t, e) {
            function k(t, e) {
                return parseInt(t.getAttribute(e), 10);
            }
            t.exports = function(t, e, i, n, s) {
                void 0 === i && (i = 0), void 0 === n && (n = 0);
                var r = e.cutX, o = e.cutY, a = e.source.width, h = e.source.height, l = e.sourceIndex, u = {}, c = t.getElementsByTagName("info")[0], d = t.getElementsByTagName("common")[0];
                u.font = c.getAttribute("face"), u.size = k(c, "size"), u.lineHeight = k(d, "lineHeight") + n, u.chars = {};
                var f, p, g = t.getElementsByTagName("char"), v = void 0 !== e && e.trimmed;
                v && (f = e.height, p = e.width);
                for(var m = 0; m < g.length; m++){
                    var y = g[m], x = k(y, "id"), T = String.fromCharCode(x), w = k(y, "x"), b = k(y, "y"), E = k(y, "width"), S = k(y, "height");
                    v && (w < p && (p = w), b < f && (f = b)), v && 0 !== f && 0 !== p && (w -= e.x, b -= e.y);
                    var A, _ = (r + w) / a, C = (o + b) / h, M = (r + w + E) / a, R = (o + b + S) / h;
                    u.chars[x] = {
                        x: w,
                        y: b,
                        width: E,
                        height: S,
                        centerX: Math.floor(E / 2),
                        centerY: Math.floor(S / 2),
                        xOffset: k(y, "xoffset"),
                        yOffset: k(y, "yoffset"),
                        xAdvance: k(y, "xadvance") + i,
                        data: {},
                        kerning: {},
                        u0: _,
                        v0: C,
                        u1: M,
                        v1: R
                    }, !s || 0 === E || 0 === S || (A = s.add(T, l, w, b, E, S)) && A.setUVs(E, S, _, C, M, R);
                }
                for(var P = t.getElementsByTagName("kerning"), m = 0; m < P.length; m++){
                    var O = P[m], L = k(O, "first"), D = k(O, "second"), F = k(O, "amount");
                    u.chars[D].kerning[L] = F;
                }
                return u;
            };
        },
        function(t, e, i) {
            var n = i(1043), o = i(434), s = i(0), r = i(11), a = i(106), h = i(15), l = i(107), u = new s({
                Extends: h,
                Mixins: [
                    r.Alpha,
                    r.BlendMode,
                    r.Depth,
                    r.Mask,
                    r.Pipeline,
                    r.ScrollFactor,
                    r.Size,
                    r.Texture,
                    r.Transform,
                    r.Visible,
                    n
                ],
                initialize: function(t, e, i, n, s) {
                    h.call(this, t, "Blitter"), this.setTexture(n, s), this.setPosition(e, i), this.initPipeline(), this.children = new l, this.renderList = [], this.dirty = !1;
                },
                create: function(t, e, i, n, s) {
                    void 0 === n && (n = !0), void 0 === s && (s = this.children.length), void 0 === i ? i = this.frame : i instanceof a || (i = this.texture.get(i));
                    var r = new o(this, t, e, i, n);
                    return this.children.addAt(r, s, !1), this.dirty = !0, r;
                },
                createFromCallback: function(t, e, i, n) {
                    for(var s = this.createMultiple(e, i, n), r = 0; r < s.length; r++){
                        var o = s[r];
                        t.call(this, o, r);
                    }
                    return s;
                },
                createMultiple: function(i, t, n) {
                    void 0 === t && (t = this.frame.name), void 0 === n && (n = !0), Array.isArray(t) || (t = [
                        t
                    ]);
                    var s = [], r = this;
                    return t.forEach(function(t) {
                        for(var e = 0; e < i; e++)s.push(r.create(0, 0, t, n));
                    }), s;
                },
                childCanRender: function(t) {
                    return t.visible && 0 < t.alpha;
                },
                getRenderList: function() {
                    return this.dirty && (this.renderList = this.children.list.filter(this.childCanRender, this), this.dirty = !1), this.renderList;
                },
                clear: function() {
                    this.children.removeAll(), this.dirty = !0;
                },
                preDestroy: function() {
                    this.children.destroy(), this.renderList = [];
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var r = i(205), s = i(34), n = i(0), o = i(11), a = i(75), h = i(15), l = i(10), u = i(1046), c = i(435), d = i(3), f = new n({
                Extends: h,
                Mixins: [
                    o.AlphaSingle,
                    o.BlendMode,
                    o.ComputedSize,
                    o.Depth,
                    o.Mask,
                    o.Pipeline,
                    o.Transform,
                    o.Visible,
                    u
                ],
                initialize: function(t, e, i, n) {
                    h.call(this, t, "Container"), this.list = [], this.exclusive = !0, this.maxSize = -1, this.position = 0, this.localTransform = new o.TransformMatrix, this.tempTransformMatrix = new o.TransformMatrix, this._sortKey = "", this._sysEvents = t.sys.events, this.scrollFactorX = 1, this.scrollFactorY = 1, this.initPipeline(), this.setPosition(e, i), this.clearAlpha(), this.setBlendMode(s.SKIP_CHECK), n && this.add(n);
                },
                originX: {
                    get: function() {
                        return .5;
                    }
                },
                originY: {
                    get: function() {
                        return .5;
                    }
                },
                displayOriginX: {
                    get: function() {
                        return .5 * this.width;
                    }
                },
                displayOriginY: {
                    get: function() {
                        return .5 * this.height;
                    }
                },
                setExclusive: function(t) {
                    return void 0 === t && (t = !0), this.exclusive = t, this;
                },
                getBounds: function(t) {
                    var e;
                    if (void 0 === t && (t = new l), t.setTo(this.x, this.y, 0, 0), this.parentContainer && (e = this.parentContainer.getBoundsTransformMatrix().transformPoint(this.x, this.y), t.setTo(e.x, e.y, 0, 0)), 0 < this.list.length) {
                        var i = this.list, n = new l, s = !1;
                        t.setEmpty();
                        for(var r = 0; r < i.length; r++){
                            var o = i[r];
                            o.getBounds && (o.getBounds(n), s ? c(n, t, t) : (t.setTo(n.x, n.y, n.width, n.height), s = !0));
                        }
                    }
                    return t;
                },
                addHandler: function(t) {
                    t.once(a.DESTROY, this.remove, this), this.exclusive && (t.displayList && t.displayList.remove(t), t.parentContainer && t.parentContainer.remove(t), this.displayList ? t.displayList = this.displayList : t.displayList = this.scene.sys.displayList, t.parentContainer = this), this.scene.sys.displayList.exists(t) || t.emit(a.ADDED_TO_SCENE, t, this.scene);
                },
                removeHandler: function(t) {
                    t.off(a.DESTROY, this.remove), this.exclusive && (t.parentContainer = null), this.scene.sys.displayList.exists(t) || t.emit(a.REMOVED_FROM_SCENE, t, this.scene);
                },
                pointToContainer: function(t, e) {
                    void 0 === e && (e = new d), this.parentContainer ? this.parentContainer.pointToContainer(t, e) : e = new d(t.x, t.y);
                    var i = this.tempTransformMatrix;
                    return i.applyITRS(this.x, this.y, this.rotation, this.scaleX, this.scaleY), i.invert(), i.transformPoint(t.x, t.y, e), e;
                },
                getBoundsTransformMatrix: function() {
                    return this.getWorldTransformMatrix(this.tempTransformMatrix, this.localTransform);
                },
                add: function(t) {
                    return r.Add(this.list, t, this.maxSize, this.addHandler, this), this;
                },
                addAt: function(t, e) {
                    return r.AddAt(this.list, t, e, this.maxSize, this.addHandler, this), this;
                },
                getAt: function(t) {
                    return this.list[t];
                },
                getIndex: function(t) {
                    return this.list.indexOf(t);
                },
                sort: function(i, t) {
                    return i && (void 0 === t && (t = function(t, e) {
                        return t[i] - e[i];
                    }), r.StableSort(this.list, t)), this;
                },
                getByName: function(t) {
                    return r.GetFirst(this.list, "name", t);
                },
                getRandom: function(t, e) {
                    return r.GetRandom(this.list, t, e);
                },
                getFirst: function(t, e, i, n) {
                    return r.GetFirst(this.list, t, e, i, n);
                },
                getAll: function(t, e, i, n) {
                    return r.GetAll(this.list, t, e, i, n);
                },
                count: function(t, e, i, n) {
                    return r.CountAllMatching(this.list, t, e, i, n);
                },
                swap: function(t, e) {
                    return r.Swap(this.list, t, e), this;
                },
                moveTo: function(t, e) {
                    return r.MoveTo(this.list, t, e), this;
                },
                remove: function(t, e) {
                    var i = r.Remove(this.list, t, this.removeHandler, this);
                    if (e && i) {
                        Array.isArray(i) || (i = [
                            i
                        ]);
                        for(var n = 0; n < i.length; n++)i[n].destroy();
                    }
                    return this;
                },
                removeAt: function(t, e) {
                    var i = r.RemoveAt(this.list, t, this.removeHandler, this);
                    return e && i && i.destroy(), this;
                },
                removeBetween: function(t, e, i) {
                    var n = r.RemoveBetween(this.list, t, e, this.removeHandler, this);
                    if (i) for(var s = 0; s < n.length; s++)n[s].destroy();
                    return this;
                },
                removeAll: function(t) {
                    var e = r.RemoveBetween(this.list, 0, this.list.length, this.removeHandler, this);
                    if (t) for(var i = 0; i < e.length; i++)e[i].destroy();
                    return this;
                },
                bringToTop: function(t) {
                    return r.BringToTop(this.list, t), this;
                },
                sendToBack: function(t) {
                    return r.SendToBack(this.list, t), this;
                },
                moveUp: function(t) {
                    return r.MoveUp(this.list, t), this;
                },
                moveDown: function(t) {
                    return r.MoveDown(this.list, t), this;
                },
                reverse: function() {
                    return this.list.reverse(), this;
                },
                shuffle: function() {
                    return r.Shuffle(this.list), this;
                },
                replace: function(t, e, i) {
                    return r.Replace(this.list, t, e) && (this.addHandler(e), this.removeHandler(t), i && t.destroy()), this;
                },
                exists: function(t) {
                    return -1 < this.list.indexOf(t);
                },
                setAll: function(t, e, i, n) {
                    return r.SetAll(this.list, t, e, i, n), this;
                },
                each: function(t, e) {
                    for(var i = [
                        null
                    ], n = this.list.slice(), s = n.length, r = 2; r < arguments.length; r++)i.push(arguments[r]);
                    for(r = 0; r < s; r++)i[0] = n[r], t.apply(e, i);
                    return this;
                },
                iterate: function(t, e) {
                    for(var i = [
                        null
                    ], n = 2; n < arguments.length; n++)i.push(arguments[n]);
                    for(n = 0; n < this.list.length; n++)i[0] = this.list[n], t.apply(e, i);
                    return this;
                },
                setScrollFactor: function(t, e, i) {
                    return void 0 === e && (e = t), void 0 === i && (i = !1), this.scrollFactorX = t, this.scrollFactorY = e, i && (r.SetAll(this.list, "scrollFactorX", t), r.SetAll(this.list, "scrollFactorY", e)), this;
                },
                length: {
                    get: function() {
                        return this.list.length;
                    }
                },
                first: {
                    get: function() {
                        return (this.position = 0) < this.list.length ? this.list[0] : null;
                    }
                },
                last: {
                    get: function() {
                        return 0 < this.list.length ? (this.position = this.list.length - 1, this.list[this.position]) : null;
                    }
                },
                next: {
                    get: function() {
                        return this.position < this.list.length ? (this.position++, this.list[this.position]) : null;
                    }
                },
                previous: {
                    get: function() {
                        return 0 < this.position ? (this.position--, this.list[this.position]) : null;
                    }
                },
                preDestroy: function() {
                    this.removeAll(!!this.exclusive), this.localTransform.destroy(), this.tempTransformMatrix.destroy(), this.list = [];
                }
            });
            t.exports = f;
        },
        function(t, e, i) {
            var a = i(147), n = i(0), s = i(1051), r = new n({
                Extends: a,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    a.call(this, t, e, i, n, s, r, o), this.type = "DynamicBitmapText", this.scrollX = 0, this.scrollY = 0, this.cropWidth = 0, this.cropHeight = 0, this.displayCallback, this.callbackData = {
                        parent: this,
                        color: 0,
                        tint: {
                            topLeft: 0,
                            topRight: 0,
                            bottomLeft: 0,
                            bottomRight: 0
                        },
                        index: 0,
                        charCode: 0,
                        x: 0,
                        y: 0,
                        scale: 0,
                        rotation: 0,
                        data: 0
                    };
                },
                setSize: function(t, e) {
                    return this.cropWidth = t, this.cropHeight = e, this;
                },
                setDisplayCallback: function(t) {
                    return this.displayCallback = t, this;
                },
                setScrollX: function(t) {
                    return this.scrollX = t, this;
                },
                setScrollY: function(t) {
                    return this.scrollY = t, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(131), s = i(0), h = i(214), r = i(297), o = i(298), a = i(299), l = i(303), u = i(171), c = i(306), d = i(307), f = i(308), p = i(108), g = i(15), v = i(2), m = i(6), y = i(14), x = i(65), T = i(1057), w = new s({
                Extends: g,
                Mixins: [
                    r,
                    o,
                    a,
                    l,
                    u,
                    d,
                    f,
                    c,
                    T
                ],
                initialize: function(t, e) {
                    var i = m(e, "x", 0), n = m(e, "y", 0);
                    g.call(this, t, "Graphics"), this.setPosition(i, n), this.initPipeline(x.GRAPHICS_PIPELINE), this.displayOriginX = 0, this.displayOriginY = 0, this.commandBuffer = [], this.defaultFillColor = -1, this.defaultFillAlpha = 1, this.defaultStrokeWidth = 1, this.defaultStrokeColor = -1, this.defaultStrokeAlpha = 1, this._lineWidth = 1, this.setDefaultStyles(e);
                },
                setDefaultStyles: function(t) {
                    return m(t, "lineStyle", null) && (this.defaultStrokeWidth = m(t, "lineStyle.width", 1), this.defaultStrokeColor = m(t, "lineStyle.color", 16777215), this.defaultStrokeAlpha = m(t, "lineStyle.alpha", 1), this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha)), m(t, "fillStyle", null) && (this.defaultFillColor = m(t, "fillStyle.color", 16777215), this.defaultFillAlpha = m(t, "fillStyle.alpha", 1), this.fillStyle(this.defaultFillColor, this.defaultFillAlpha)), this;
                },
                lineStyle: function(t, e, i) {
                    return void 0 === i && (i = 1), this.commandBuffer.push(h.LINE_STYLE, t, e, i), this._lineWidth = t, this;
                },
                fillStyle: function(t, e) {
                    return void 0 === e && (e = 1), this.commandBuffer.push(h.FILL_STYLE, t, e), this;
                },
                fillGradientStyle: function(t, e, i, n, s, r, o, a) {
                    return void 0 === s && (s = 1), void 0 === r && (r = s), void 0 === o && (o = s), void 0 === a && (a = s), this.commandBuffer.push(h.GRADIENT_FILL_STYLE, s, r, o, a, t, e, i, n), this;
                },
                lineGradientStyle: function(t, e, i, n, s, r) {
                    return void 0 === r && (r = 1), this.commandBuffer.push(h.GRADIENT_LINE_STYLE, t, r, e, i, n, s), this;
                },
                beginPath: function() {
                    return this.commandBuffer.push(h.BEGIN_PATH), this;
                },
                closePath: function() {
                    return this.commandBuffer.push(h.CLOSE_PATH), this;
                },
                fillPath: function() {
                    return this.commandBuffer.push(h.FILL_PATH), this;
                },
                fill: function() {
                    return this.commandBuffer.push(h.FILL_PATH), this;
                },
                strokePath: function() {
                    return this.commandBuffer.push(h.STROKE_PATH), this;
                },
                stroke: function() {
                    return this.commandBuffer.push(h.STROKE_PATH), this;
                },
                fillCircleShape: function(t) {
                    return this.fillCircle(t.x, t.y, t.radius);
                },
                strokeCircleShape: function(t) {
                    return this.strokeCircle(t.x, t.y, t.radius);
                },
                fillCircle: function(t, e, i) {
                    return this.beginPath(), this.arc(t, e, i, 0, y.PI2), this.fillPath(), this;
                },
                strokeCircle: function(t, e, i) {
                    return this.beginPath(), this.arc(t, e, i, 0, y.PI2), this.strokePath(), this;
                },
                fillRectShape: function(t) {
                    return this.fillRect(t.x, t.y, t.width, t.height);
                },
                strokeRectShape: function(t) {
                    return this.strokeRect(t.x, t.y, t.width, t.height);
                },
                fillRect: function(t, e, i, n) {
                    return this.commandBuffer.push(h.FILL_RECT, t, e, i, n), this;
                },
                strokeRect: function(t, e, i, n) {
                    var s = this._lineWidth / 2, r = t - s, o = t + s;
                    return this.beginPath(), this.moveTo(t, e), this.lineTo(t, e + n), this.strokePath(), this.beginPath(), this.moveTo(t + i, e), this.lineTo(t + i, e + n), this.strokePath(), this.beginPath(), this.moveTo(r, e), this.lineTo(o + i, e), this.strokePath(), this.beginPath(), this.moveTo(r, e + n), this.lineTo(o + i, e + n), this.strokePath(), this;
                },
                fillRoundedRect: function(t, e, i, n, s) {
                    void 0 === s && (s = 20);
                    var r = s, o = s, a = s, h = s;
                    return "number" != typeof s && (r = v(s, "tl", 20), o = v(s, "tr", 20), a = v(s, "bl", 20), h = v(s, "br", 20)), this.beginPath(), this.moveTo(t + r, e), this.lineTo(t + i - o, e), this.arc(t + i - o, e + o, o, -y.TAU, 0), this.lineTo(t + i, e + n - h), this.arc(t + i - h, e + n - h, h, 0, y.TAU), this.lineTo(t + a, e + n), this.arc(t + a, e + n - a, a, y.TAU, Math.PI), this.lineTo(t, e + r), this.arc(t + r, e + r, r, -Math.PI, -y.TAU), this.fillPath(), this;
                },
                strokeRoundedRect: function(t, e, i, n, s) {
                    void 0 === s && (s = 20);
                    var r = s, o = s, a = s, h = s;
                    return "number" != typeof s && (r = v(s, "tl", 20), o = v(s, "tr", 20), a = v(s, "bl", 20), h = v(s, "br", 20)), this.beginPath(), this.moveTo(t + r, e), this.lineTo(t + i - o, e), this.moveTo(t + i - o, e), this.arc(t + i - o, e + o, o, -y.TAU, 0), this.lineTo(t + i, e + n - h), this.moveTo(t + i, e + n - h), this.arc(t + i - h, e + n - h, h, 0, y.TAU), this.lineTo(t + a, e + n), this.moveTo(t + a, e + n), this.arc(t + a, e + n - a, a, y.TAU, Math.PI), this.lineTo(t, e + r), this.moveTo(t, e + r), this.arc(t + r, e + r, r, -Math.PI, -y.TAU), this.strokePath(), this;
                },
                fillPointShape: function(t, e) {
                    return this.fillPoint(t.x, t.y, e);
                },
                fillPoint: function(t, e, i) {
                    return !i || i < 1 ? i = 1 : (t -= i / 2, e -= i / 2), this.commandBuffer.push(h.FILL_RECT, t, e, i, i), this;
                },
                fillTriangleShape: function(t) {
                    return this.fillTriangle(t.x1, t.y1, t.x2, t.y2, t.x3, t.y3);
                },
                strokeTriangleShape: function(t) {
                    return this.strokeTriangle(t.x1, t.y1, t.x2, t.y2, t.x3, t.y3);
                },
                fillTriangle: function(t, e, i, n, s, r) {
                    return this.commandBuffer.push(h.FILL_TRIANGLE, t, e, i, n, s, r), this;
                },
                strokeTriangle: function(t, e, i, n, s, r) {
                    return this.commandBuffer.push(h.STROKE_TRIANGLE, t, e, i, n, s, r), this;
                },
                strokeLineShape: function(t) {
                    return this.lineBetween(t.x1, t.y1, t.x2, t.y2);
                },
                lineBetween: function(t, e, i, n) {
                    return this.beginPath(), this.moveTo(t, e), this.lineTo(i, n), this.strokePath(), this;
                },
                lineTo: function(t, e) {
                    return this.commandBuffer.push(h.LINE_TO, t, e), this;
                },
                moveTo: function(t, e) {
                    return this.commandBuffer.push(h.MOVE_TO, t, e), this;
                },
                strokePoints: function(t, e, i, n) {
                    void 0 === e && (e = !1), void 0 === i && (i = !1), void 0 === n && (n = t.length), this.beginPath(), this.moveTo(t[0].x, t[0].y);
                    for(var s = 1; s < n; s++)this.lineTo(t[s].x, t[s].y);
                    return e && this.lineTo(t[0].x, t[0].y), i && this.closePath(), this.strokePath(), this;
                },
                fillPoints: function(t, e, i, n) {
                    void 0 === e && (e = !1), void 0 === i && (i = !1), void 0 === n && (n = t.length), this.beginPath(), this.moveTo(t[0].x, t[0].y);
                    for(var s = 1; s < n; s++)this.lineTo(t[s].x, t[s].y);
                    return e && this.lineTo(t[0].x, t[0].y), i && this.closePath(), this.fillPath(), this;
                },
                strokeEllipseShape: function(t, e) {
                    void 0 === e && (e = 32);
                    var i = t.getPoints(e);
                    return this.strokePoints(i, !0);
                },
                strokeEllipse: function(t, e, i, n, s) {
                    void 0 === s && (s = 32);
                    var r = new p(t, e, i, n).getPoints(s);
                    return this.strokePoints(r, !0);
                },
                fillEllipseShape: function(t, e) {
                    void 0 === e && (e = 32);
                    var i = t.getPoints(e);
                    return this.fillPoints(i, !0);
                },
                fillEllipse: function(t, e, i, n, s) {
                    void 0 === s && (s = 32);
                    var r = new p(t, e, i, n).getPoints(s);
                    return this.fillPoints(r, !0);
                },
                arc: function(t, e, i, n, s, r, o) {
                    return void 0 === r && (r = !1), void 0 === o && (o = 0), this.commandBuffer.push(h.ARC, t, e, i, n, s, r, o), this;
                },
                slice: function(t, e, i, n, s, r, o) {
                    return void 0 === r && (r = !1), void 0 === o && (o = 0), this.commandBuffer.push(h.BEGIN_PATH), this.commandBuffer.push(h.MOVE_TO, t, e), this.commandBuffer.push(h.ARC, t, e, i, n, s, r, o), this.commandBuffer.push(h.CLOSE_PATH), this;
                },
                save: function() {
                    return this.commandBuffer.push(h.SAVE), this;
                },
                restore: function() {
                    return this.commandBuffer.push(h.RESTORE), this;
                },
                translateCanvas: function(t, e) {
                    return this.commandBuffer.push(h.TRANSLATE, t, e), this;
                },
                scaleCanvas: function(t, e) {
                    return this.commandBuffer.push(h.SCALE, t, e), this;
                },
                rotateCanvas: function(t) {
                    return this.commandBuffer.push(h.ROTATE, t), this;
                },
                clear: function() {
                    return this.commandBuffer.length = 0, -1 < this.defaultFillColor && this.fillStyle(this.defaultFillColor, this.defaultFillAlpha), -1 < this.defaultStrokeColor && this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha), this;
                },
                generateTexture: function(t, e, i) {
                    var n, s, r, o = this.scene.sys, a = o.game.renderer;
                    return void 0 === e && (e = o.scale.width), void 0 === i && (i = o.scale.height), w.TargetCamera.setScene(this.scene), w.TargetCamera.setViewport(0, 0, e, i), w.TargetCamera.scrollX = this.x, w.TargetCamera.scrollY = this.y, "string" == typeof t ? o.textures.exists(t) ? (r = (n = o.textures.get(t)).getSourceImage()) instanceof HTMLCanvasElement && (s = r.getContext("2d")) : s = (n = o.textures.createCanvas(t, e, i)).getSourceImage().getContext("2d") : t instanceof HTMLCanvasElement && (s = t.getContext("2d")), s && (this.renderCanvas(a, this, w.TargetCamera, null, s, !1), n && n.refresh()), this;
                },
                preDestroy: function() {
                    this.commandBuffer = [];
                }
            });
            w.TargetCamera = new n, t.exports = w;
        },
        function(t, e) {
            t.exports = {
                ARC: 0,
                BEGIN_PATH: 1,
                CLOSE_PATH: 2,
                FILL_RECT: 3,
                LINE_TO: 4,
                MOVE_TO: 5,
                LINE_STYLE: 6,
                FILL_STYLE: 7,
                FILL_PATH: 8,
                STROKE_PATH: 9,
                FILL_TRIANGLE: 10,
                STROKE_TRIANGLE: 11,
                SAVE: 14,
                RESTORE: 15,
                TRANSLATE: 16,
                SCALE: 17,
                ROTATE: 18,
                GRADIENT_FILL_STYLE: 21,
                GRADIENT_LINE_STYLE: 22
            };
        },
        function(t, e, i) {
            var r = i(4);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new r);
                var n = t.width / 2, s = t.height / 2;
                return i.x = t.x + n * Math.cos(e), i.y = t.y + s * Math.sin(e), i;
            };
        },
        function(t, e, i) {
            var n = i(34), s = i(0), r = i(11), o = i(173), a = i(98), h = i(9), l = i(75), u = i(107), c = i(1065), d = i(21), f = i(79), p = new s({
                Extends: u,
                Mixins: [
                    r.AlphaSingle,
                    r.BlendMode,
                    r.Depth,
                    r.Mask,
                    r.Pipeline,
                    r.Visible,
                    h,
                    c
                ],
                initialize: function(t, e) {
                    u.call(this, t), h.call(this), this.scene = t, this.displayList = null, this.type = "Layer", this.state = 0, this.parentContainer = null, this.name = "", this.active = !0, this.tabIndex = -1, this.data = null, this.renderFlags = 15, this.cameraFilter = 0, this.input = null, this.body = null, this.ignoreDestroy = !1, this.systems = t.sys, this.events = t.sys.events, this.sortChildrenFlag = !1, this.addCallback = this.addChildCallback, this.removeCallback = this.removeChildCallback, this.initPipeline(), this.clearAlpha(), this.setBlendMode(n.SKIP_CHECK), e && this.add(e), t.sys.queueDepthSort();
                },
                setActive: function(t) {
                    return this.active = t, this;
                },
                setName: function(t) {
                    return this.name = t, this;
                },
                setState: function(t) {
                    return this.state = t, this;
                },
                setDataEnabled: function() {
                    return this.data || (this.data = new a(this)), this;
                },
                setData: function(t, e) {
                    return this.data || (this.data = new a(this)), this.data.set(t, e), this;
                },
                incData: function(t, e) {
                    return this.data || (this.data = new a(this)), this.data.inc(t, e), this;
                },
                toggleData: function(t) {
                    return this.data || (this.data = new a(this)), this.data.toggle(t), this;
                },
                getData: function(t) {
                    return this.data || (this.data = new a(this)), this.data.get(t);
                },
                setInteractive: function() {
                    return this;
                },
                disableInteractive: function() {
                    return this;
                },
                removeInteractive: function() {
                    return this;
                },
                addedToScene: function() {},
                removedFromScene: function() {},
                update: function() {},
                toJSON: function() {
                    return o(this);
                },
                willRender: function(t) {
                    return !(15 !== this.renderFlags || 0 === this.list.length || 0 !== this.cameraFilter && this.cameraFilter & t.id);
                },
                getIndexList: function() {
                    for(var t = this, e = this.parentContainer, i = []; e && (i.unshift(e.getIndex(t)), (t = e).parentContainer);)e = e.parentContainer;
                    return i.unshift(this.displayList.getIndex(t)), i;
                },
                addChildCallback: function(t) {
                    t.emit(l.ADDED_TO_SCENE, t, this.scene), t.displayList && t.displayList.remove(t), (t.displayList = this).queueDepthSort(), this.events.emit(d.ADDED_TO_SCENE, t, this.scene);
                },
                removeChildCallback: function(t) {
                    t.emit(l.REMOVED_FROM_SCENE, t, this.scene), t.displayList = null, this.queueDepthSort(), this.events.emit(d.REMOVED_FROM_SCENE, t, this.scene);
                },
                queueDepthSort: function() {
                    this.sortChildrenFlag = !0;
                },
                depthSort: function() {
                    this.sortChildrenFlag && (f(this.list, this.sortByDepth), this.sortChildrenFlag = !1);
                },
                sortByDepth: function(t, e) {
                    return t._depth - e._depth;
                },
                getChildren: function() {
                    return this.list;
                },
                destroy: function() {
                    if (this.scene && !this.ignoreDestroy) {
                        this.emit(l.DESTROY, this);
                        for(var t = this.list.length; t--;)this.list[t].destroy();
                        this.removeAllListeners(), this.resetPostPipeline(!0), this.displayList && (this.displayList.queueDepthSort(), this.displayList.remove(this)), this.data && (this.data.destroy(), this.data = void 0), this.active = !1, this.visible = !1, this.list = void 0, this.scene = void 0, this.displayList = void 0, this.systems = void 0, this.events = void 0;
                    }
                }
            });
            t.exports = p;
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(15), o = i(444), a = i(107), h = i(446), l = i(1069), u = new n({
                Extends: r,
                Mixins: [
                    s.Depth,
                    s.Mask,
                    s.Pipeline,
                    s.Transform,
                    s.Visible,
                    l
                ],
                initialize: function(t, e, i, n) {
                    if (r.call(this, t, "ParticleEmitterManager"), this.blendMode = -1, this.timeScale = 1, this.texture = null, this.frame = null, this.frameNames = [], null === i || "object" != typeof i && !Array.isArray(i) || (n = i, i = null), this.setTexture(e, i), this.initPipeline(), this.emitters = new a(this), this.wells = new a(this), n) {
                        Array.isArray(n) || (n = [
                            n
                        ]);
                        for(var s = 0; s < n.length; s++)this.createEmitter(n[s]);
                    }
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                setTexture: function(t, e) {
                    return this.texture = this.scene.sys.textures.get(t), this.setFrame(e);
                },
                setFrame: function(t) {
                    this.frame = this.texture.get(t);
                    var e = this.texture.getFramesFromTextureSource(this.frame.sourceIndex), i = [];
                    return e.forEach(function(t) {
                        i.push(t.name);
                    }), this.frameNames = i, this.defaultFrame = this.frame, this;
                },
                setEmitterFrames: function(t, e) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = e.frames, n = i.length = 0; n < t.length; n++){
                        var s = t[n];
                        -1 !== this.frameNames.indexOf(s) && i.push(this.texture.get(s));
                    }
                    return 0 < i.length ? e.defaultFrame = i[0] : e.defaultFrame = this.defaultFrame, this;
                },
                addEmitter: function(t) {
                    return this.emitters.add(t);
                },
                createEmitter: function(t) {
                    return this.addEmitter(new h(this, t));
                },
                removeEmitter: function(t) {
                    return this.emitters.remove(t, !0);
                },
                addGravityWell: function(t) {
                    return this.wells.add(t);
                },
                createGravityWell: function(t) {
                    return this.addGravityWell(new o(t));
                },
                emitParticle: function(t, e, i) {
                    for(var n = this.emitters.list, s = 0; s < n.length; s++){
                        var r = n[s];
                        r.active && r.emitParticle(t, e, i);
                    }
                    return this;
                },
                emitParticleAt: function(t, e, i) {
                    return this.emitParticle(i, t, e);
                },
                pause: function() {
                    return this.active = !1, this;
                },
                resume: function() {
                    return this.active = !0, this;
                },
                getProcessors: function() {
                    return this.wells.getAll("active", !0);
                },
                preUpdate: function(t, e) {
                    e *= this.timeScale;
                    for(var i = this.emitters.list, n = 0; n < i.length; n++){
                        var s = i[n];
                        s.active && s.preUpdate(t, e);
                    }
                },
                setAlpha: function() {},
                setScrollFactor: function() {},
                setBlendMode: function() {}
            });
            t.exports = u;
        },
        function(t, e, i) {
            var o = i(34), h = i(131), l = i(31), n = i(0), s = i(11), u = i(32), a = i(106), c = i(15), d = i(1), f = i(65), r = i(1073), p = i(139), x = i(12), g = i(219), v = new n({
                Extends: c,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.ComputedSize,
                    s.Crop,
                    s.Depth,
                    s.Flip,
                    s.GetBounds,
                    s.Mask,
                    s.Origin,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Tint,
                    s.Transform,
                    s.Visible,
                    r
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 32), void 0 === s && (s = 32), c.call(this, t, "RenderTexture"), this.renderer = t.sys.renderer, this.textureManager = t.sys.textures, this.globalTint = 16777215, this.globalAlpha = 1, this.canvas = null, this.dirty = !1, this._crop = this.resetCropObject(), this.texture = null, this.frame = null, this._saved = !1, void 0 === r ? (this.canvas = l.create2D(this, n, s), this.texture = t.sys.textures.addCanvas(g(), this.canvas), this.frame = this.texture.get()) : (this.texture = t.sys.textures.get(r), this.frame = this.texture.get(o), this.canvas = this.frame.source.image, this._saved = !0, this.dirty = !0, this.width = this.frame.cutWidth, this.height = this.frame.cutHeight), this.context = this.canvas.getContext("2d"), this._eraseMode = !1, this.camera = new h(0, 0, n, s), this.renderTarget = null;
                    var a = this.renderer;
                    a ? a.type === u.WEBGL ? (this.drawGameObject = this.batchGameObjectWebGL, this.renderTarget = new p(a, n, s, 1, 0, !1)) : a.type === u.CANVAS && (this.drawGameObject = this.batchGameObjectCanvas) : this.drawGameObject = d, this.camera.setScene(t), this.setPosition(e, i), void 0 === r && this.setSize(n, s), this.setOrigin(0, 0), this.initPipeline(f.SINGLE_PIPELINE);
                },
                setSize: function(t, e) {
                    return this.resize(t, e);
                },
                resize: function(t, e) {
                    void 0 === e && (e = t);
                    var i, n, s = this.frame;
                    t !== this.width || e !== this.height ? "__BASE" === s.name && (this.canvas.width = t, this.canvas.height = e, this.texture.width = t, this.texture.height = e, (i = this.renderTarget) && (i.resize(t, e), s.glTexture = i.texture, s.source.isRenderTexture = !0, s.source.isGLTexture = !0, s.source.glTexture = i.texture), this.camera.setSize(t, e), s.source.width = t, s.source.height = e, s.setSize(t, e), this.width = t, this.height = e) : (n = this.texture.getSourceImage(), s.cutX + t > n.width && (t = n.width - s.cutX), s.cutY + e > n.height && (e = n.height - s.cutY), s.setSize(t, e, s.cutX, s.cutY)), this.updateDisplayOrigin();
                    var r = this.input;
                    return r && !r.customHitArea && (r.hitArea.width = t, r.hitArea.height = e), this;
                },
                setGlobalTint: function(t) {
                    return this.globalTint = t, this;
                },
                setGlobalAlpha: function(t) {
                    return this.globalAlpha = t, this;
                },
                saveTexture: function(t) {
                    return this.textureManager.renameTexture(this.texture.key, t), this._saved = !0, this.texture;
                },
                fill: function(t, e, i, n, s, r) {
                    var o = this.frame, a = this.camera, h = this.renderer;
                    void 0 === e && (e = 1), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = o.cutWidth), void 0 === r && (r = o.cutHeight);
                    var l, u, c, d, f, p, g = (t >> 16 & 255) / 255, v = (t >> 8 & 255) / 255, m = (255 & t) / 255, y = this.renderTarget;
                    return a.preRender(), y ? (y.bind(!0), (l = this.pipeline).manager.set(l), u = y.width, c = y.height, d = h.width / u, f = h.height / c, l.drawFillRect(i * d, n * f, s * d, r * f, x.getTintFromFloats(m, v, g, 1), e), y.unbind(!0)) : (p = this.context, h.setContext(p), p.fillStyle = "rgba(" + g + "," + v + "," + m + "," + e + ")", p.fillRect(i + o.cutX, n + o.cutY, s, r), h.setContext()), this.dirty = !0, this;
                },
                clear: function() {
                    var t, e;
                    return this.dirty && ((t = this.renderTarget) ? t.clear() : ((e = this.context).save(), e.setTransform(1, 0, 0, 1, 0, 0), e.clearRect(this.frame.cutX, this.frame.cutY, this.frame.cutWidth, this.frame.cutHeight), e.restore()), this.dirty = !1), this;
                },
                erase: function(t, e, i) {
                    return this._eraseMode = !0, this.draw(t, e, i, 1, 16777215), this._eraseMode = !1, this;
                },
                draw: function(t, e, i, n, s) {
                    return this.beginDraw(), this.batchDraw(t, e, i, n, s), this.endDraw(), this;
                },
                drawFrame: function(t, e, i, n, s, r) {
                    return this.beginDraw(), this.batchDrawFrame(t, e, i, n, s, r), this.endDraw(), this;
                },
                beginDraw: function() {
                    var t = this.camera, e = this.renderer, i = this.renderTarget;
                    return t.preRender(), i ? e.beginCapture(i.width, i.height) : e.setContext(this.context), this;
                },
                batchDraw: function(t, e, i, n, s) {
                    return void 0 === n && (n = this.globalAlpha), s = void 0 === s ? (this.globalTint >> 16) + (65280 & this.globalTint) + ((255 & this.globalTint) << 16) : (s >> 16) + (65280 & s) + ((255 & s) << 16), Array.isArray(t) || (t = [
                        t
                    ]), this.batchList(t, e, i, n, s), this;
                },
                batchDrawFrame: function(t, e, i, n, s, r) {
                    void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = this.globalAlpha), r = void 0 === r ? (this.globalTint >> 16) + (65280 & this.globalTint) + ((255 & this.globalTint) << 16) : (r >> 16) + (65280 & r) + ((255 & r) << 16);
                    var o = this.textureManager.getFrame(t, e);
                    return o && (this.renderTarget ? this.pipeline.batchTextureFrame(o, i, n, r, s, this.camera.matrix, null) : this.batchTextureFrame(o, i + this.frame.cutX, n + this.frame.cutY, s, r)), this;
                },
                endDraw: function() {
                    var t, e = this.renderer, i = this.renderTarget;
                    return i ? (t = e.endCapture(), e.pipelines.setUtility().blitFrame(t, i, 1, !1, !1, this._eraseMode), e.resetScissor(), e.resetViewport()) : e.setContext(), this.dirty = !0, this;
                },
                batchList: function(t, e, i, n, s) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o && o !== this && (o.renderWebGL || o.renderCanvas ? this.drawGameObject(o, e, i) : o.isParent || o.list ? this.batchGroup(o.getChildren(), e, i) : "string" == typeof o ? this.batchTextureFrameKey(o, null, e, i, n, s) : o instanceof a ? this.batchTextureFrame(o, e, i, n, s) : Array.isArray(o) && this.batchList(o, e, i, n, s));
                    }
                },
                batchGroup: function(t, e, i) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), e += this.frame.cutX, i += this.frame.cutY;
                    for(var n = 0; n < t.length; n++){
                        var s, r, o = t[n];
                        o.willRender(this.camera) && (s = o.x + e, r = o.y + i, this.drawGameObject(o, s, r));
                    }
                },
                batchGameObjectWebGL: function(t, e, i) {
                    void 0 === e && (e = t.x), void 0 === i && (i = t.y);
                    var n = t.x, s = t.y;
                    t.setPosition(e + this.frame.cutX, i + this.frame.cutY), t.renderDirect ? t.renderDirect(this.renderer, t, this.camera) : t.renderWebGL(this.renderer, t, this.camera), t.setPosition(n, s);
                },
                batchGameObjectCanvas: function(t, e, i) {
                    void 0 === e && (e = t.x), void 0 === i && (i = t.y);
                    var n, s = t.x, r = t.y;
                    this._eraseMode && (n = t.blendMode, t.blendMode = o.ERASE), t.setPosition(e + this.frame.cutX, i + this.frame.cutY), t.renderCanvas(this.renderer, t, this.camera, null), t.setPosition(s, r), this._eraseMode && (t.blendMode = n);
                },
                batchTextureFrameKey: function(t, e, i, n, s, r) {
                    var o = this.textureManager.getFrame(t, e);
                    o && this.batchTextureFrame(o, i, n, s, r);
                },
                batchTextureFrame: function(t, e, i, n, s) {
                    var r, o, a, h;
                    void 0 === e && (e = 0), void 0 === i && (i = 0), e += this.frame.cutX, i += this.frame.cutY, this.renderTarget ? this.pipeline.batchTextureFrame(t, e, i, s, n, this.camera.matrix, null) : (r = this.context, o = t.canvasData, a = t.source.image, h = this.camera.matrix, r.save(), r.globalCompositeOperation = this._eraseMode ? "destination-out" : "source-over", r.globalAlpha = n, h.setToContext(r), r.drawImage(a, o.x, o.y, o.width, o.height, e, i, o.width, o.height), r.restore());
                },
                snapshotArea: function(t, e, i, n, s, r, o) {
                    return this.renderTarget ? this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, s, !1, t, e, i, n, r, o) : this.renderer.snapshotCanvas(this.canvas, s, !1, t, e, i, n, r, o), this;
                },
                snapshot: function(t, e, i) {
                    return this.renderTarget ? this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, t, !1, 0, 0, this.width, this.height, e, i) : this.renderer.snapshotCanvas(this.canvas, t, !1, 0, 0, this.width, this.height, e, i), this;
                },
                snapshotPixel: function(t, e, i) {
                    return this.renderTarget ? this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, i, !0, t, e) : this.renderer.snapshotCanvas(this.canvas, i, !0, t, e), this;
                },
                preDestroy: function() {
                    this._saved || (l.remove(this.canvas), this.renderTarget && this.renderTarget.destroy(), this.texture.destroy(), this.camera.destroy(), this.canvas = null, this.context = null, this.texture = null);
                }
            });
            t.exports = v;
        },
        function(t, e) {
            t.exports = function() {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                    var e = 16 * Math.random() | 0;
                    return ("x" === t ? e : 3 & e | 8).toString(16);
                });
            };
        },
        function(t, e, i) {
            var l = i(162), n = i(0), s = i(11), u = i(15), c = i(65), r = i(1079), d = i(3), o = new n({
                Extends: u,
                Mixins: [
                    s.AlphaSingle,
                    s.BlendMode,
                    s.Depth,
                    s.Flip,
                    s.Mask,
                    s.Pipeline,
                    s.Size,
                    s.Texture,
                    s.Transform,
                    s.Visible,
                    s.ScrollFactor,
                    r
                ],
                initialize: function(t, e, i, n, s, r, o, a, h) {
                    void 0 === n && (n = "__DEFAULT"), void 0 === r && (r = 2), void 0 === o && (o = !0), u.call(this, t, "Rope"), this.anims = new l(this), this.points = r, this.vertices, this.uv, this.colors, this.alphas, this.tintFill = "__DEFAULT" === n, this.dirty = !1, this.horizontal = o, this._flipX = !1, this._flipY = !1, this._perp = new d, this.debugCallback = null, this.debugGraphic = null, this.setTexture(n, s), this.setPosition(e, i), this.setSizeToFrame(), this.initPipeline(c.ROPE_PIPELINE), Array.isArray(r) && this.resizeArrays(r.length), this.setPoints(r, a, h), this.updateVertices();
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                preUpdate: function(t, e) {
                    var i = this.anims.currentFrame;
                    this.anims.update(t, e), this.anims.currentFrame !== i && (this.updateUVs(), this.updateVertices());
                },
                play: function(t, e, i) {
                    return this.anims.play(t, e, i), this;
                },
                setDirty: function() {
                    return this.dirty = !0, this;
                },
                setHorizontal: function(t, e, i) {
                    return void 0 === t && (t = this.points.length), this.horizontal ? this : (this.horizontal = !0, this.setPoints(t, e, i));
                },
                setVertical: function(t, e, i) {
                    return void 0 === t && (t = this.points.length), this.horizontal ? (this.horizontal = !1, this.setPoints(t, e, i)) : this;
                },
                setTintFill: function(t) {
                    return void 0 === t && (t = !1), this.tintFill = t, this;
                },
                setAlphas: function(t, e) {
                    var i = this.points.length;
                    if (i < 1) return this;
                    var n = this.alphas;
                    void 0 === t ? t = [
                        1
                    ] : Array.isArray(t) || void 0 !== e || (t = [
                        t
                    ]);
                    var s = 0;
                    if (void 0 !== e) for(o = 0; o < i; o++)n[s = 2 * o] = t, n[s + 1] = e;
                    else if (t.length === i) for(o = 0; o < i; o++)n[s = 2 * o] = t[o], n[s + 1] = t[o];
                    else for(var r = t[0], o = 0; o < i; o++)s = 2 * o, t.length > s && (r = t[s]), n[s] = r, t.length > s + 1 && (r = t[s + 1]), n[s + 1] = r;
                    return this;
                },
                setColors: function(t) {
                    var e = this.points.length;
                    if (e < 1) return this;
                    var i = this.colors;
                    void 0 === t ? t = [
                        16777215
                    ] : Array.isArray(t) || (t = [
                        t
                    ]);
                    var n = 0;
                    if (t.length === e) for(r = 0; r < e; r++)i[n = 2 * r] = t[r], i[n + 1] = t[r];
                    else for(var s = t[0], r = 0; r < e; r++)n = 2 * r, t.length > n && (s = t[n]), i[n] = s, t.length > n + 1 && (s = t[n + 1]), i[n + 1] = s;
                    return this;
                },
                setPoints: function(t, e, i) {
                    if (void 0 === t && (t = 2), "number" == typeof t) {
                        var n, s, r, o = t;
                        if (o < 2 && (o = 2), t = [], this.horizontal) for(r = -this.frame.halfWidth, s = this.frame.width / (o - 1), n = 0; n < o; n++)t.push({
                            x: r + n * s,
                            y: 0
                        });
                        else for(r = -this.frame.halfHeight, s = this.frame.height / (o - 1), n = 0; n < o; n++)t.push({
                            x: 0,
                            y: r + n * s
                        });
                    }
                    var a = t.length, h = this.points.length;
                    return a < 1 ? console.warn("Rope: Not enough points given") : (1 === a && (t.unshift({
                        x: 0,
                        y: 0
                    }), a++), h !== a && this.resizeArrays(a), this.points = t, this.updateUVs(), null != e && this.setColors(e), null != i && this.setAlphas(i)), this;
                },
                updateUVs: function() {
                    for(var t = this.uv, e = this.points.length, i = this.frame.u0, n = this.frame.v0, s = this.frame.u1, r = this.frame.v1, o = (s - i) / (e - 1), a = (r - n) / (e - 1), h = 0; h < e; h++){
                        var l, u, c, d = 4 * h, f = this.horizontal ? (c = l = this._flipX ? s - h * o : i + h * o, this._flipY ? (u = r, n) : (u = n, r)) : (c = this._flipX ? (l = i, s) : (l = s, i), u = this._flipY ? r - h * a : n + h * a);
                        t[0 + d] = l, t[1 + d] = u, t[2 + d] = c, t[3 + d] = f;
                    }
                    return this;
                },
                resizeArrays: function(t) {
                    var e = this.colors, i = this.alphas;
                    this.vertices = new Float32Array(4 * t), this.uv = new Float32Array(4 * t), e = new Uint32Array(2 * t), i = new Float32Array(2 * t);
                    for(var n = 0; n < 2 * t; n++)e[n] = 16777215, i[n] = 1;
                    return this.colors = e, this.alphas = i, this.dirty = !0, this;
                },
                updateVertices: function() {
                    var t = this._perp, e = this.points, i = this.vertices, n = e.length;
                    if (this.dirty = !1, !(n < 1)) {
                        for(var s = e[0], r = this.horizontal ? this.frame.halfHeight : this.frame.halfWidth, o = 0; o < n; o++){
                            var a = e[o], h = 4 * o, l = o < n - 1 ? e[o + 1] : a;
                            t.x = l.y - s.y, t.y = -(l.x - s.x);
                            var u = t.length();
                            t.x /= u, t.y /= u, t.x *= r, t.y *= r, i[h] = a.x + t.x, i[1 + h] = a.y + t.y, i[2 + h] = a.x - t.x, i[3 + h] = a.y - t.y, s = a;
                        }
                        return this;
                    }
                },
                setDebug: function(t, e) {
                    return this.debugGraphic = t, this.debugCallback = t || e ? e || this.renderDebugVerts : null, this;
                },
                renderDebugVerts: function(t, e, i) {
                    var n = t.debugGraphic, s = i[0], r = i[1], o = i[2], a = i[3];
                    n.lineBetween(s, r, o, a);
                    for(var h = 4; h < e; h += 4){
                        var l = i[h + 0], u = i[h + 1], c = i[h + 2], d = i[h + 3];
                        n.lineBetween(s, r, l, u), n.lineBetween(o, a, c, d), n.lineBetween(o, a, l, u), n.lineBetween(l, u, c, d), s = l, r = u, o = c, a = d;
                    }
                },
                preDestroy: function() {
                    this.anims.destroy(), this.anims = void 0, this.points = null, this.vertices = null, this.uv = null, this.colors = null, this.alphas = null, this.debugCallback = null, this.debugGraphic = null;
                },
                flipX: {
                    get: function() {
                        return this._flipX;
                    },
                    set: function(t) {
                        return this._flipX = t, this.updateUVs();
                    }
                },
                flipY: {
                    get: function() {
                        return this._flipY;
                    },
                    set: function(t) {
                        return this._flipY = t, this.updateUVs();
                    }
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(140), r = i(31), s = i(0), o = i(11), a = i(22), h = i(15), b = i(452), l = i(6), u = i(199), c = i(1082), d = i(453), f = new s({
                Extends: h,
                Mixins: [
                    o.Alpha,
                    o.BlendMode,
                    o.ComputedSize,
                    o.Crop,
                    o.Depth,
                    o.Flip,
                    o.GetBounds,
                    o.Mask,
                    o.Origin,
                    o.Pipeline,
                    o.ScrollFactor,
                    o.Tint,
                    o.Transform,
                    o.Visible,
                    c
                ],
                initialize: function(t, e, i, n, s) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), h.call(this, t, "Text"), this.renderer = t.sys.renderer, this.setPosition(e, i), this.setOrigin(0, 0), this.initPipeline(), this.canvas = r.create(this), this.context = this.canvas.getContext("2d"), this.style = new d(this, s), this.autoRound = !0, this.splitRegExp = /(?:\r\n|\r|\n)/, this._text = void 0, this.padding = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }, this.width = 1, this.height = 1, this.lineSpacing = 0, this.dirty = !1, 0 === this.style.resolution && (this.style.resolution = 1), this._crop = this.resetCropObject(), this.texture = t.sys.textures.addCanvas(null, this.canvas, !0), this.frame = this.texture.get(), this.frame.source.resolution = this.style.resolution, this.renderer && this.renderer.gl && (this.renderer.deleteTexture(this.frame.source.glTexture), this.frame.source.glTexture = null), this.initRTL(), this.setText(n), s && s.padding && this.setPadding(s.padding), s && s.lineSpacing && this.setLineSpacing(s.lineSpacing), t.sys.game.events.on(a.CONTEXT_RESTORED, function() {
                        this.dirty = !0;
                    }, this);
                },
                initRTL: function() {
                    this.style.rtl && (this.canvas.dir = "rtl", this.context.direction = "rtl", this.canvas.style.display = "none", n(this.canvas, this.scene.sys.canvas), this.originX = 1);
                },
                runWordWrap: function(t) {
                    var e = this.style;
                    if (e.wordWrapCallback) {
                        var i = e.wordWrapCallback.call(e.wordWrapCallbackScope, t, this);
                        return Array.isArray(i) && (i = i.join("\n")), i;
                    }
                    return e.wordWrapWidth ? e.wordWrapUseAdvanced ? this.advancedWordWrap(t, this.context, this.style.wordWrapWidth) : this.basicWordWrap(t, this.context, this.style.wordWrapWidth) : t;
                },
                advancedWordWrap: function(t, e, i) {
                    for(var n = "", s = t.replace(/ +/gi, " ").split(this.splitRegExp), r = s.length, o = 0; o < r; o++){
                        var a = "", h = (h = s[o]).replace(/^ *|\s*$/gi, "");
                        if (e.measureText(h).width < i) n += h + "\n";
                        else {
                            for(var l = i, u = h.split(" "), c = 0; c < u.length; c++){
                                var d = u[c], f = d + " ", p = e.measureText(f).width;
                                if (l < p) {
                                    if (0 === c) {
                                        for(var g = f; g.length && (g = g.slice(0, -1), !((p = e.measureText(g).width) <= l)););
                                        if (!g.length) throw new Error("This text's wordWrapWidth setting is less than a single character!");
                                        var v = d.substr(g.length);
                                        u[c] = v, a += g;
                                    }
                                    var m = u[c].length ? c : c + 1, y = u.slice(m).join(" ").replace(/[ \n]*$/gi, "");
                                    s[o + 1] = y + " " + (s[o + 1] || ""), r = s.length;
                                    break;
                                }
                                a += f, l -= p;
                            }
                            n += a.replace(/[ \n]*$/gi, "") + "\n";
                        }
                    }
                    return n = n.replace(/[\s|\n]*$/gi, "");
                },
                basicWordWrap: function(t, e, i) {
                    for(var n = "", s = t.split(this.splitRegExp), r = s.length - 1, o = e.measureText(" ").width, a = 0; a <= r; a++){
                        for(var h = i, l = s[a].split(" "), u = l.length - 1, c = 0; c <= u; c++){
                            var d = l[c], f = e.measureText(d).width, p = f;
                            c < u && (p += o), h < p && 0 < c && (n += "\n", h = i), n += d, c < u ? (n += " ", h -= p) : h -= f;
                        }
                        a < r && (n += "\n");
                    }
                    return n;
                },
                getWrappedText: function(t) {
                    return void 0 === t && (t = this._text), this.style.syncFont(this.canvas, this.context), this.runWordWrap(t).split(this.splitRegExp);
                },
                setText: function(t) {
                    return t || 0 === t || (t = ""), Array.isArray(t) && (t = t.join("\n")), t !== this._text && (this._text = t.toString(), this.updateText()), this;
                },
                setStyle: function(t) {
                    return this.style.setStyle(t);
                },
                setFont: function(t) {
                    return this.style.setFont(t);
                },
                setFontFamily: function(t) {
                    return this.style.setFontFamily(t);
                },
                setFontSize: function(t) {
                    return this.style.setFontSize(t);
                },
                setFontStyle: function(t) {
                    return this.style.setFontStyle(t);
                },
                setFixedSize: function(t, e) {
                    return this.style.setFixedSize(t, e);
                },
                setBackgroundColor: function(t) {
                    return this.style.setBackgroundColor(t);
                },
                setFill: function(t) {
                    return this.style.setFill(t);
                },
                setColor: function(t) {
                    return this.style.setColor(t);
                },
                setStroke: function(t, e) {
                    return this.style.setStroke(t, e);
                },
                setShadow: function(t, e, i, n, s, r) {
                    return this.style.setShadow(t, e, i, n, s, r);
                },
                setShadowOffset: function(t, e) {
                    return this.style.setShadowOffset(t, e);
                },
                setShadowColor: function(t) {
                    return this.style.setShadowColor(t);
                },
                setShadowBlur: function(t) {
                    return this.style.setShadowBlur(t);
                },
                setShadowStroke: function(t) {
                    return this.style.setShadowStroke(t);
                },
                setShadowFill: function(t) {
                    return this.style.setShadowFill(t);
                },
                setWordWrapWidth: function(t, e) {
                    return this.style.setWordWrapWidth(t, e);
                },
                setWordWrapCallback: function(t, e) {
                    return this.style.setWordWrapCallback(t, e);
                },
                setAlign: function(t) {
                    return this.style.setAlign(t);
                },
                setResolution: function(t) {
                    return this.style.setResolution(t);
                },
                setLineSpacing: function(t) {
                    return this.lineSpacing = t, this.updateText();
                },
                setPadding: function(t, e, i, n) {
                    var s, r, o;
                    return "object" == typeof t ? (i = null !== (r = l(s = t, "x", null)) ? t = r : (t = l(s, "left", 0), l(s, "right", t)), n = null !== (o = l(s, "y", null)) ? e = o : (e = l(s, "top", 0), l(s, "bottom", e))) : (void 0 === t && (t = 0), void 0 === e && (e = t), void 0 === i && (i = t), void 0 === n && (n = e)), this.padding.left = t, this.padding.top = e, this.padding.right = i, this.padding.bottom = n, this.updateText();
                },
                setMaxLines: function(t) {
                    return this.style.setMaxLines(t);
                },
                updateText: function() {
                    var t = this.canvas, e = this.context, i = this.style, n = i.resolution, s = i.metrics;
                    i.syncFont(t, e);
                    var r = this._text;
                    (i.wordWrapWidth || i.wordWrapCallback) && (r = this.runWordWrap(this._text));
                    var o, a = r.split(this.splitRegExp), h = b(this, s, a), l = this.padding;
                    0 === i.fixedWidth ? (this.width = h.width + l.left + l.right, o = h.width) : (this.width = i.fixedWidth, (o = this.width - l.left - l.right) < h.width && (o = h.width)), 0 === i.fixedHeight ? this.height = h.height + l.top + l.bottom : this.height = i.fixedHeight;
                    var u, c, d = this.width, f = this.height;
                    this.updateDisplayOrigin(), d *= n, f *= n, d = Math.max(d, 1), f = Math.max(f, 1), t.width !== d || t.height !== f ? (t.width = d, t.height = f, this.frame.setSize(d, f), i.syncFont(t, e)) : e.clearRect(0, 0, d, f), e.save(), e.scale(n, n), i.backgroundColor && (e.fillStyle = i.backgroundColor, e.fillRect(0, 0, d, f)), i.syncStyle(t, e), e.textBaseline = "alphabetic", e.translate(l.left, l.top);
                    for(var p = 0; p < h.lines; p++){
                        if (u = i.strokeThickness / 2, c = i.strokeThickness / 2 + p * h.lineHeight + s.ascent, 0 < p && (c += h.lineSpacing * p), i.rtl) u = d - u;
                        else if ("right" === i.align) u += o - h.lineWidths[p];
                        else if ("center" === i.align) u += (o - h.lineWidths[p]) / 2;
                        else if ("justify" === i.align) {
                            if (.85 <= h.lineWidths[p] / h.width) {
                                var g = h.width - h.lineWidths[p], v = e.measureText(" ").width, m = a[p].trim(), y = m.split(" ");
                                g += (a[p].length - m.length) * v;
                                for(var x = Math.floor(g / v), T = 0; 0 < x;)y[T] += " ", T = (T + 1) % (y.length - 1 || 1), --x;
                                a[p] = y.join(" ");
                            }
                        }
                        this.autoRound && (u = Math.round(u), c = Math.round(c)), i.strokeThickness && (this.style.syncShadow(e, i.shadowStroke), e.strokeText(a[p], u, c)), i.color && (this.style.syncShadow(e, i.shadowFill), e.fillText(a[p], u, c));
                    }
                    e.restore(), this.renderer && this.renderer.gl && (this.frame.source.glTexture = this.renderer.canvasToTexture(t, this.frame.source.glTexture, !0), this.frame.glTexture = this.frame.source.glTexture), this.dirty = !0;
                    var w = this.input;
                    return w && !w.customHitArea && (w.hitArea.width = this.width, w.hitArea.height = this.height), this;
                },
                getTextMetrics: function() {
                    return this.style.getTextMetrics();
                },
                text: {
                    get: function() {
                        return this._text;
                    },
                    set: function(t) {
                        this.setText(t);
                    }
                },
                toJSON: function() {
                    var t = o.ToJSON(this), e = {
                        autoRound: this.autoRound,
                        text: this._text,
                        style: this.style.toJSON(),
                        padding: {
                            left: this.padding.left,
                            right: this.padding.right,
                            top: this.padding.top,
                            bottom: this.padding.bottom
                        }
                    };
                    return t.data = e, t;
                },
                preDestroy: function() {
                    this.style.rtl && u(this.canvas), r.remove(this.canvas), this.texture.destroy();
                }
            });
            t.exports = f;
        },
        function(t, e, i) {
            var u = i(31), n = i(0), s = i(11), c = i(22), d = i(15), f = i(355), o = i(189), r = i(1085), p = i(3), a = new n({
                Extends: d,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.ComputedSize,
                    s.Crop,
                    s.Depth,
                    s.Flip,
                    s.GetBounds,
                    s.Mask,
                    s.Origin,
                    s.Pipeline,
                    s.ScrollFactor,
                    s.Tint,
                    s.Transform,
                    s.Visible,
                    r
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    var a = t.sys.renderer;
                    d.call(this, t, "TileSprite");
                    var h = t.sys.textures.get(r), l = h.get(o);
                    s = n && s ? (n = Math.floor(n), Math.floor(s)) : (n = l.width, l.height), this._tilePosition = new p, this._tileScale = new p(1, 1), this.dirty = !1, this.renderer = a, this.canvas = u.create(this, n, s), this.context = this.canvas.getContext("2d"), this.displayTexture = h, this.displayFrame = l, this._crop = this.resetCropObject(), this.texture = t.sys.textures.addCanvas(null, this.canvas, !0), this.frame = this.texture.get(), this.potWidth = f(l.width), this.potHeight = f(l.height), this.fillCanvas = u.create2D(this, this.potWidth, this.potHeight), this.fillContext = this.fillCanvas.getContext("2d"), this.fillPattern = null, this.setPosition(e, i), this.setSize(n, s), this.setFrame(o), this.setOriginFromFrame(), this.initPipeline(), t.sys.game.events.on(c.CONTEXT_RESTORED, function(t) {
                        var e = t.gl;
                        this.dirty = !0, this.fillPattern = null, this.fillPattern = t.createTexture2D(0, e.LINEAR, e.LINEAR, e.REPEAT, e.REPEAT, e.RGBA, this.fillCanvas, this.potWidth, this.potHeight);
                    }, this);
                },
                setTexture: function(t, e) {
                    return this.displayTexture = this.scene.sys.textures.get(t), this.setFrame(e);
                },
                setFrame: function(t) {
                    var e = this.displayTexture.get(t);
                    return this.potWidth = f(e.width), this.potHeight = f(e.height), this.canvas.width = 0, e.cutWidth && e.cutHeight ? this.renderFlags |= 8 : this.renderFlags &= -9, this.displayFrame = e, this.dirty = !0, this.updateTileTexture(), this;
                },
                setTilePosition: function(t, e) {
                    return void 0 !== t && (this.tilePositionX = t), void 0 !== e && (this.tilePositionY = e), this;
                },
                setTileScale: function(t, e) {
                    return void 0 === t && (t = this.tileScaleX), void 0 === e && (e = t), this.tileScaleX = t, this.tileScaleY = e, this;
                },
                updateTileTexture: function() {
                    if (this.dirty && this.renderer) {
                        var t = this.displayFrame;
                        if (t.source.isRenderTexture || t.source.isGLTexture) return console.warn("TileSprites can only use Image or Canvas based textures"), void (this.dirty = !1);
                        var e = this.fillContext, i = this.fillCanvas, n = this.potWidth, s = this.potHeight;
                        this.renderer.gl || (n = t.cutWidth, s = t.cutHeight), e.clearRect(0, 0, n, s), i.width = n, i.height = s, e.drawImage(t.source.image, t.cutX, t.cutY, t.cutWidth, t.cutHeight, 0, 0, n, s), this.renderer.gl ? this.fillPattern = this.renderer.canvasToTexture(i, this.fillPattern) : this.fillPattern = e.createPattern(i, "repeat"), this.updateCanvas(), this.dirty = !1;
                    }
                },
                updateCanvas: function() {
                    var t, e, i, n, s, r = this.canvas;
                    r.width === this.width && r.height === this.height || (r.width = this.width, r.height = this.height, this.frame.setSize(this.width, this.height), this.updateDisplayOrigin(), this.dirty = !0), !this.dirty || this.renderer && this.renderer.gl || (t = this.context, this.scene.sys.game.config.antialias || o.disable(t), e = this._tileScale.x, i = this._tileScale.y, n = this._tilePosition.x, s = this._tilePosition.y, t.clearRect(0, 0, this.width, this.height), t.save(), t.scale(e, i), t.translate(-n, -s), t.fillStyle = this.fillPattern, t.fillRect(n, s, this.width / e, this.height / i), t.restore()), this.dirty = !1;
                },
                preDestroy: function() {
                    this.renderer && this.renderer.gl && this.renderer.deleteTexture(this.fillPattern), u.remove(this.canvas), u.remove(this.fillCanvas), this.fillPattern = null, this.fillContext = null, this.fillCanvas = null, this.displayTexture = null, this.displayFrame = null, this.texture.destroy(), this.renderer = null;
                },
                tilePositionX: {
                    get: function() {
                        return this._tilePosition.x;
                    },
                    set: function(t) {
                        this._tilePosition.x = t, this.dirty = !0;
                    }
                },
                tilePositionY: {
                    get: function() {
                        return this._tilePosition.y;
                    },
                    set: function(t) {
                        this._tilePosition.y = t, this.dirty = !0;
                    }
                },
                tileScaleX: {
                    get: function() {
                        return this._tileScale.x;
                    },
                    set: function(t) {
                        this._tileScale.x = t, this.dirty = !0;
                    }
                },
                tileScaleY: {
                    get: function() {
                        return this._tileScale.y;
                    },
                    set: function(t) {
                        this._tileScale.y = t, this.dirty = !0;
                    }
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(18), r = i(11), o = i(75), a = i(22), h = i(49), l = i(15), u = i(69), c = i(219), d = i(1088), f = i(14), p = new n({
                Extends: l,
                Mixins: [
                    r.Alpha,
                    r.BlendMode,
                    r.Depth,
                    r.Flip,
                    r.GetBounds,
                    r.Mask,
                    r.Origin,
                    r.Pipeline,
                    r.ScrollFactor,
                    r.Size,
                    r.TextureCrop,
                    r.Tint,
                    r.Transform,
                    r.Visible,
                    d
                ],
                initialize: function(t, e, i, n) {
                    l.call(this, t, "Video"), this.video = null, this.videoTexture = null, this.videoTextureSource = null, this.snapshotTexture = null, this.flipY = !1, this._key = c(), this.touchLocked = !0, this.playWhenUnlocked = !1, this.retryLimit = 20, this.retry = 0, this.retryInterval = 500, this._retryID = null, this._systemMuted = !1, this._codeMuted = !1, this._systemPaused = !1, this._codePaused = !1, this._callbacks = {
                        play: this.playHandler.bind(this),
                        error: this.loadErrorHandler.bind(this),
                        end: this.completeHandler.bind(this),
                        time: this.timeUpdateHandler.bind(this),
                        seeking: this.seekingHandler.bind(this),
                        seeked: this.seekedHandler.bind(this)
                    }, this._crop = this.resetCropObject(), this.markers = {}, this._markerIn = -1, this._markerOut = f.MAX_SAFE_INTEGER, this._lastUpdate = 0, this._cacheKey = "", this._isSeeking = !1, this.removeVideoElementOnDestroy = !1, this.setPosition(e, i), this.initPipeline(), n && this.changeSource(n, !1);
                    var s = t.sys.game.events;
                    s.on(a.PAUSE, this.globalPause, this), s.on(a.RESUME, this.globalResume, this);
                    var r = t.sys.sound;
                    r && r.on(u.GLOBAL_MUTE, this.globalMute, this);
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                play: function(t, e, i) {
                    if (this.touchLocked && this.playWhenUnlocked || this.isPlaying()) return this;
                    var n = this.video;
                    if (!n) return console.warn("Video not loaded"), this;
                    void 0 === t && (t = n.loop);
                    var s = this.scene.sys.sound;
                    s && s.mute && this.setMute(!0), isNaN(e) || (this._markerIn = e), !isNaN(i) && e < i && (this._markerOut = i), n.loop = t;
                    var r = this._callbacks, o = n.play();
                    return void 0 !== o ? o.then(this.playPromiseSuccessHandler.bind(this)).catch(this.playPromiseErrorHandler.bind(this)) : (n.addEventListener("playing", r.play, !0), n.readyState < 2 && (this.retry = this.retryLimit, this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval))), n.addEventListener("ended", r.end, !0), n.addEventListener("timeupdate", r.time, !0), n.addEventListener("seeking", r.seeking, !0), n.addEventListener("seeked", r.seeked, !0), this;
                },
                changeSource: function(t, e, i, n, s) {
                    void 0 === e && (e = !0), this.video && this.stop();
                    var r = this.scene.sys.cache.video.get(t);
                    return r ? (this.video = r, this._cacheKey = t, this._codePaused = r.paused, this._codeMuted = r.muted, this.videoTexture ? (this.scene.sys.textures.remove(this._key), this.videoTexture = this.scene.sys.textures.create(this._key, r, r.videoWidth, r.videoHeight), this.videoTextureSource = this.videoTexture.source[0], this.videoTexture.add("__BASE", 0, 0, 0, r.videoWidth, r.videoHeight), this.setTexture(this.videoTexture), this.setSizeToFrame(), this.updateDisplayOrigin(), this.emit(o.VIDEO_CREATED, this, r.videoWidth, r.videoHeight)) : this.updateTexture(), r.currentTime = 0, this._lastUpdate = 0, e && this.play(i, n, s)) : this.video = null, this;
                },
                addMarker: function(t, e, i) {
                    return !isNaN(e) && 0 <= e && !isNaN(i) && (this.markers[t] = [
                        e,
                        i
                    ]), this;
                },
                playMarker: function(t, e) {
                    var i = this.markers[t];
                    return i && this.play(e, i[0], i[1]), this;
                },
                removeMarker: function(t) {
                    return delete this.markers[t], this;
                },
                snapshot: function(t, e) {
                    return void 0 === t && (t = this.width), void 0 === e && (e = this.height), this.snapshotArea(0, 0, this.width, this.height, t, e);
                },
                snapshotArea: function(t, e, i, n, s, r) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.width), void 0 === n && (n = this.height), void 0 === s && (s = i), void 0 === r && (r = n);
                    var o = this.video, a = this.snapshotTexture;
                    return a ? a.setSize(s, r) : (a = this.scene.sys.textures.createCanvas(c(), s, r), this.snapshotTexture = a), o && a.context.drawImage(o, t, e, i, n, 0, 0, s, r), a.update();
                },
                saveSnapshotTexture: function(t) {
                    return this.snapshotTexture ? this.scene.sys.textures.renameTexture(this.snapshotTexture.key, t) : this.snapshotTexture = this.scene.sys.textures.createCanvas(t, this.width, this.height), this.snapshotTexture;
                },
                loadURL: function(t, e, i) {
                    void 0 === e && (e = "loadeddata"), void 0 === i && (i = !1), this.video && this.stop(), this.videoTexture && this.scene.sys.textures.remove(this._key);
                    var n = document.createElement("video");
                    return n.controls = !1, i && (n.muted = !0, n.defaultMuted = !0, n.setAttribute("autoplay", "autoplay")), n.setAttribute("playsinline", "playsinline"), n.setAttribute("preload", "auto"), n.addEventListener("error", this._callbacks.error, !0), n.src = t, n.load(), this.video = n, this;
                },
                loadMediaStream: function(e, t, i) {
                    void 0 === t && (t = "loadeddata"), void 0 === i && (i = !1), this.video && this.stop(), this.videoTexture && this.scene.sys.textures.remove(this._key);
                    var n = document.createElement("video");
                    n.controls = !1, i && (n.muted = !0, n.defaultMuted = !0, n.setAttribute("autoplay", "autoplay")), n.setAttribute("playsinline", "playsinline"), n.setAttribute("preload", "auto"), n.addEventListener("error", this._callbacks.error, !0);
                    try {
                        n.srcObject = e;
                    } catch (t) {
                        n.src = window.URL.createObjectURL(e);
                    }
                    return n.load(), this.video = n, this;
                },
                playPromiseSuccessHandler: function() {
                    this.touchLocked = !1, this.emit(o.VIDEO_PLAY, this), -1 < this._markerIn && (this.video.currentTime = this._markerIn);
                },
                playPromiseErrorHandler: function(t) {
                    this.scene.sys.input.once(h.POINTER_DOWN, this.unlockHandler, this), this.touchLocked = !0, this.playWhenUnlocked = !0, this.emit(o.VIDEO_ERROR, this, t);
                },
                playHandler: function() {
                    this.touchLocked = !1, this.emit(o.VIDEO_PLAY, this), this.video.removeEventListener("playing", this._callbacks.play, !0);
                },
                loadErrorHandler: function(t) {
                    this.stop(), this.emit(o.VIDEO_ERROR, this, t);
                },
                unlockHandler: function() {
                    this.touchLocked = !1, this.playWhenUnlocked = !1, this.emit(o.VIDEO_UNLOCKED, this), -1 < this._markerIn && (this.video.currentTime = this._markerIn), this.video.play(), this.emit(o.VIDEO_PLAY, this);
                },
                completeHandler: function() {
                    this.emit(o.VIDEO_COMPLETE, this);
                },
                timeUpdateHandler: function() {
                    this.video && this.video.currentTime < this._lastUpdate && (this.emit(o.VIDEO_LOOP, this), this._lastUpdate = 0);
                },
                preUpdate: function() {
                    var t, e = this.video;
                    !e || (t = e.currentTime) !== this._lastUpdate && (this._lastUpdate = t, this.updateTexture(), t >= this._markerOut && (e.loop ? (e.currentTime = this._markerIn, this.updateTexture(), this._lastUpdate = t, this.emit(o.VIDEO_LOOP, this)) : (this.emit(o.VIDEO_COMPLETE, this), this.stop())));
                },
                checkVideoProgress: function() {
                    2 <= this.video.readyState ? this.updateTexture() : (this.retry--, 0 < this.retry ? this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval) : this.emit(o.VIDEO_TIMEOUT, this));
                },
                updateTexture: function() {
                    var t, e = this.video, i = e.videoWidth, n = e.videoHeight;
                    this.videoTexture ? ((t = this.videoTextureSource).source !== e && (t.source = e, t.width = i, t.height = n), t.update()) : (this.videoTexture = this.scene.sys.textures.create(this._key, e, i, n), this.videoTextureSource = this.videoTexture.source[0], this.videoTexture.add("__BASE", 0, 0, 0, i, n), this.setTexture(this.videoTexture), this.setSizeToFrame(), this.updateDisplayOrigin(), this.emit(o.VIDEO_CREATED, this, i, n));
                },
                getVideoKey: function() {
                    return this._cacheKey;
                },
                seekTo: function(t) {
                    var e, i, n = this.video;
                    return n && ((e = n.duration) === 1 / 0 || isNaN(e) || (i = e * t, this.setCurrentTime(i))), this;
                },
                getCurrentTime: function() {
                    return this.video ? this.video.currentTime : 0;
                },
                setCurrentTime: function(t) {
                    var e, i, n = this.video;
                    return n && ("string" == typeof t && (e = t[0], i = parseFloat(t.substr(1)), "+" === e ? t = n.currentTime + i : "-" === e && (t = n.currentTime - i)), n.currentTime = t, this._lastUpdate = t), this;
                },
                isSeeking: function() {
                    return this._isSeeking;
                },
                seekingHandler: function() {
                    this._isSeeking = !0, this.emit(o.VIDEO_SEEKING, this);
                },
                seekedHandler: function() {
                    this._isSeeking = !1, this.emit(o.VIDEO_SEEKED, this), this.video && this.updateTexture();
                },
                getProgress: function() {
                    var t = this.video;
                    if (t) {
                        var e = t.currentTime, i = t.duration;
                        if (i !== 1 / 0 && !isNaN(i)) return e / i;
                    }
                    return 0;
                },
                getDuration: function() {
                    return this.video ? this.video.duration : 0;
                },
                setMute: function(t) {
                    void 0 === t && (t = !0), this._codeMuted = t;
                    var e = this.video;
                    return e && (e.muted = !!this._systemMuted || t), this;
                },
                isMuted: function() {
                    return this._codeMuted;
                },
                globalMute: function(t, e) {
                    this._systemMuted = e;
                    var i = this.video;
                    i && (i.muted = !!this._codeMuted || e);
                },
                globalPause: function() {
                    this._systemPaused = !0, this.video && this.video.pause();
                },
                globalResume: function() {
                    this._systemPaused = !1, this.video && !this._codePaused && this.video.play();
                },
                setPaused: function(t) {
                    void 0 === t && (t = !0);
                    var e = this.video;
                    return this._codePaused = t, e && (t ? e.paused || e.pause() : t || e.paused && !this._systemPaused && e.play()), this;
                },
                getVolume: function() {
                    return this.video ? this.video.volume : 1;
                },
                setVolume: function(t) {
                    return void 0 === t && (t = 1), this.video && (this.video.volume = s(t, 0, 1)), this;
                },
                getPlaybackRate: function() {
                    return this.video ? this.video.playbackRate : 1;
                },
                setPlaybackRate: function(t) {
                    return this.video && (this.video.playbackRate = t), this;
                },
                getLoop: function() {
                    return !!this.video && this.video.loop;
                },
                setLoop: function(t) {
                    return void 0 === t && (t = !0), this.video && (this.video.loop = t), this;
                },
                isPlaying: function() {
                    return !!this.video && !(this.video.paused || this.video.ended);
                },
                isPaused: function() {
                    return this.video && this.video.paused || this._codePaused || this._systemPaused;
                },
                saveTexture: function(t, e) {
                    return void 0 === e && (e = !1), this.videoTexture && this.scene.sys.textures.renameTexture(this._key, t), this._key = t, this.flipY = e, this.videoTextureSource && this.videoTextureSource.setFlipY(e), this.videoTexture;
                },
                stop: function() {
                    var t = this.video;
                    if (t) {
                        var e = this._callbacks;
                        for(var i in e)t.removeEventListener(i, e[i], !0);
                        t.pause();
                    }
                    return this._retryID && window.clearTimeout(this._retryID), this.emit(o.VIDEO_STOP, this), this;
                },
                removeVideoElement: function() {
                    var t = this.video;
                    if (t) {
                        for(t.parentNode && t.parentNode.removeChild(t); t.hasChildNodes();)t.removeChild(t.firstChild);
                        t.removeAttribute("autoplay"), t.removeAttribute("src"), this.video = null;
                    }
                },
                preDestroy: function() {
                    this.stop(), this.removeVideoElementOnDestroy && this.removeVideoElement();
                    var t = this.scene.sys.game.events;
                    t.off(a.PAUSE, this.globalPause, this), t.off(a.RESUME, this.globalResume, this);
                    var e = this.scene.sys.sound;
                    e && e.off(u.GLOBAL_MUTE, this.globalMute, this), this._retryID && window.clearTimeout(this._retryID);
                }
            });
            t.exports = p;
        },
        function(t, e, i) {
            var n = i(0), s = i(225), r = i(464), o = i(55), a = new n({
                initialize: function(t) {
                    this.type = o.POLYGON, this.area = 0, this.points = [], t && this.setTo(t);
                },
                contains: function(t, e) {
                    return s(this, t, e);
                },
                setTo: function(t) {
                    if (this.area = 0, this.points = [], "string" == typeof t && (t = t.split(" ")), !Array.isArray(t)) return this;
                    for(var e, i = Number.MAX_VALUE, n = 0; n < t.length; n++)e = {
                        x: 0,
                        y: 0
                    }, "number" == typeof t[n] || "string" == typeof t[n] ? (e.x = parseFloat(t[n]), e.y = parseFloat(t[n + 1]), n++) : Array.isArray(t[n]) ? (e.x = t[n][0], e.y = t[n][1]) : (e.x = t[n].x, e.y = t[n].y), this.points.push(e), e.y < i && (i = e.y);
                    return this.calculateArea(i), this;
                },
                calculateArea: function() {
                    if (this.points.length < 3) return this.area = 0, this.area;
                    for(var t, e, i = 0, n = 0; n < this.points.length - 1; n++)t = this.points[n], i += ((e = this.points[n + 1]).x - t.x) * (t.y + e.y);
                    return t = this.points[0], e = this.points[this.points.length - 1], i += (t.x - e.x) * (e.y + t.y), this.area = .5 * -i, this.area;
                },
                getPoints: function(t, e, i) {
                    return r(this, t, e, i);
                }
            });
            t.exports = a;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                for(var n = !1, s = -1, r = t.points.length - 1; ++s < t.points.length; r = s){
                    var o = t.points[s].x, a = t.points[s].y, h = t.points[r].x, l = t.points[r].y;
                    (a <= i && i < l || l <= i && i < a) && e < (h - o) * (i - a) / (l - a) + o && (n = !n);
                }
                return n;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(11), l = i(15), c = i(2), u = i(17), r = i(472), o = i(1170), d = i(25), a = new n({
                Extends: l,
                Mixins: [
                    s.ComputedSize,
                    s.Depth,
                    s.GetBounds,
                    s.Mask,
                    s.Origin,
                    s.ScrollFactor,
                    s.Transform,
                    s.Visible,
                    o
                ],
                initialize: function(t, e, i, n, s, r, o, a) {
                    void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = 128), void 0 === r && (r = 128), l.call(this, t, "Shader"), this.blendMode = -1, this.shader;
                    var h = t.sys.renderer;
                    this.renderer = h, this.gl = h.gl, this.vertexData = new ArrayBuffer(2 * Float32Array.BYTES_PER_ELEMENT * 6), this.vertexBuffer = h.createVertexBuffer(this.vertexData.byteLength, this.gl.STREAM_DRAW), this.program = null, this.bytes = new Uint8Array(this.vertexData), this.vertexViewF32 = new Float32Array(this.vertexData), this._tempMatrix1 = new d, this._tempMatrix2 = new d, this._tempMatrix3 = new d, this.viewMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]), this.projectionMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]), this.uniforms = {}, this.pointer = null, this._rendererWidth = h.width, this._rendererHeight = h.height, this._textureCount = 0, this.framebuffer = null, this.glTexture = null, this.renderToTexture = !1, this.texture = null, this.setPosition(i, n), this.setSize(s, r), this.setOrigin(.5, .5), this.setShader(e, o, a);
                },
                willRender: function(t) {
                    return !!this.renderToTexture || !(l.RENDER_MASK !== this.renderFlags || 0 !== this.cameraFilter && this.cameraFilter & t.id);
                },
                setRenderToTexture: function(t, e) {
                    var i, n, s;
                    return void 0 === e && (e = !1), this.renderToTexture || (i = this.width, n = this.height, s = this.renderer, this.glTexture = s.createTextureFromSource(null, i, n, 0), this.glTexture.flipY = e, this.framebuffer = s.createFramebuffer(i, n, this.glTexture, !1), this._rendererWidth = i, this._rendererHeight = n, this.renderToTexture = !0, this.projOrtho(0, this.width, this.height, 0), t && (this.texture = this.scene.sys.textures.addGLTexture(t, this.glTexture, i, n))), this.shader && (s.pipelines.clear(), this.load(), this.flush(), s.pipelines.rebind()), this;
                },
                setShader: function(t, e, i) {
                    if (void 0 === e && (e = []), "string" == typeof t) {
                        var n = this.scene.sys.cache.shader;
                        if (!n.has(t)) return console.warn("Shader missing: " + t), this;
                        this.shader = n.get(t);
                    } else this.shader = t;
                    var s = this.gl, r = this.renderer;
                    this.program && s.deleteProgram(this.program);
                    var o = r.createProgram(this.shader.vertexSrc, this.shader.fragmentSrc);
                    s.uniformMatrix4fv(s.getUniformLocation(o, "uViewMatrix"), !1, this.viewMatrix), s.uniformMatrix4fv(s.getUniformLocation(o, "uProjectionMatrix"), !1, this.projectionMatrix), s.uniform2f(s.getUniformLocation(o, "uResolution"), this.width, this.height), this.program = o;
                    var a = new Date, h = {
                        resolution: {
                            type: "2f",
                            value: {
                                x: this.width,
                                y: this.height
                            }
                        },
                        time: {
                            type: "1f",
                            value: 0
                        },
                        mouse: {
                            type: "2f",
                            value: {
                                x: this.width / 2,
                                y: this.height / 2
                            }
                        },
                        date: {
                            type: "4fv",
                            value: [
                                a.getFullYear(),
                                a.getMonth(),
                                a.getDate(),
                                60 * a.getHours() * 60 + 60 * a.getMinutes() + a.getSeconds()
                            ]
                        },
                        sampleRate: {
                            type: "1f",
                            value: 44100
                        },
                        iChannel0: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: !0
                            }
                        },
                        iChannel1: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: !0
                            }
                        },
                        iChannel2: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: !0
                            }
                        },
                        iChannel3: {
                            type: "sampler2D",
                            value: null,
                            textureData: {
                                repeat: !0
                            }
                        }
                    };
                    this.shader.uniforms ? this.uniforms = u(!0, {}, this.shader.uniforms, h) : this.uniforms = h;
                    for(var l = 0; l < 4; l++)e[l] && this.setSampler2D("iChannel" + l, e[l], l, i);
                    return this.initUniforms(), this.projOrtho(0, this._rendererWidth, this._rendererHeight, 0), this;
                },
                setPointer: function(t) {
                    return this.pointer = t, this;
                },
                projOrtho: function(t, e, i, n) {
                    var s = 1 / (t - e), r = 1 / (i - n), o = this.projectionMatrix;
                    o[0] = -2 * s, o[5] = -2 * r, o[10] = -0.001, o[12] = (t + e) * s, o[13] = (n + i) * r, o[14] = -0;
                    var a = this.program, h = this.gl;
                    this.renderer.setProgram(a), h.uniformMatrix4fv(h.getUniformLocation(a, "uProjectionMatrix"), !1, this.projectionMatrix), this._rendererWidth = e, this._rendererHeight = i;
                },
                initUniforms: function() {
                    var t = this.gl, e = this.renderer.glFuncMap, i = this.program;
                    for(var n in this._textureCount = 0, this.uniforms){
                        var s = this.uniforms[n], r = s.type, o = e[r];
                        s.uniformLocation = t.getUniformLocation(i, n), "sampler2D" !== r && (s.glMatrix = o.matrix, s.glValueLength = o.length, s.glFunc = o.func);
                    }
                },
                setSampler2DBuffer: function(t, e, i, n, s, r) {
                    void 0 === s && (s = 0), void 0 === r && (r = {});
                    var o = this.uniforms[t];
                    return o.value = e, r.width = i, r.height = n, o.textureData = r, this._textureCount = s, this.initSampler2D(o), this;
                },
                setSampler2D: function(t, e, i, n) {
                    void 0 === i && (i = 0);
                    var s = this.scene.sys.textures;
                    if (s.exists(e)) {
                        var r = s.getFrame(e);
                        if (r.glTexture && r.glTexture.isRenderTexture) return this.setSampler2DBuffer(t, r.glTexture, r.width, r.height, i, n);
                        var o = this.uniforms[t], a = r.source;
                        o.textureKey = e, o.source = a.image, o.value = r.glTexture, a.isGLTexture && ((n = n || {}).width = a.width, n.height = a.height), n && (o.textureData = n), this._textureCount = i, this.initSampler2D(o);
                    }
                    return this;
                },
                setUniform: function(t, e) {
                    return r(this.uniforms, t, e), this;
                },
                getUniform: function(t) {
                    return c(this.uniforms, t, null);
                },
                setChannel0: function(t, e) {
                    return this.setSampler2D("iChannel0", t, 0, e);
                },
                setChannel1: function(t, e) {
                    return this.setSampler2D("iChannel1", t, 1, e);
                },
                setChannel2: function(t, e) {
                    return this.setSampler2D("iChannel2", t, 2, e);
                },
                setChannel3: function(t, e) {
                    return this.setSampler2D("iChannel3", t, 3, e);
                },
                initSampler2D: function(t) {
                    var e, i, n, s, r, o, a, h, l, u;
                    t.value && ((e = this.gl).activeTexture(e.TEXTURE0 + this._textureCount), e.bindTexture(e.TEXTURE_2D, t.value), (i = t.textureData) && !t.value.isRenderTexture && (n = e[c(i, "magFilter", "linear").toUpperCase()], s = e[c(i, "minFilter", "linear").toUpperCase()], r = e[c(i, "wrapS", "repeat").toUpperCase()], o = e[c(i, "wrapT", "repeat").toUpperCase()], a = e[c(i, "format", "rgba").toUpperCase()], i.repeat && (r = e.REPEAT, o = e.REPEAT), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !!i.flipY), i.width ? (h = c(i, "width", 512), l = c(i, "height", 2), u = c(i, "border", 0), e.texImage2D(e.TEXTURE_2D, 0, a, h, l, u, a, e.UNSIGNED_BYTE, null)) : e.texImage2D(e.TEXTURE_2D, 0, a, e.RGBA, e.UNSIGNED_BYTE, t.source), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, n), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, s), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, r), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, o)), this.renderer.setProgram(this.program), e.uniform1i(t.uniformLocation, this._textureCount), this._textureCount++);
                },
                syncUniforms: function() {
                    var t, e, i, n, s, r = this.gl, o = this.uniforms, a = 0;
                    for(var h in o)i = (t = o[h]).glFunc, e = t.glValueLength, n = t.uniformLocation, null !== (s = t.value) && (1 === e ? t.glMatrix ? i.call(r, n, t.transpose, s) : i.call(r, n, s) : 2 === e ? i.call(r, n, s.x, s.y) : 3 === e ? i.call(r, n, s.x, s.y, s.z) : 4 === e ? i.call(r, n, s.x, s.y, s.z, s.w) : "sampler2D" === t.type && (r.activeTexture(r.TEXTURE0 + a), r.bindTexture(r.TEXTURE_2D, s), r.uniform1i(n, a), a++));
                },
                load: function(t) {
                    var e, i, n = this.gl, s = this.width, r = this.height, o = this.renderer, a = this.program, h = this.viewMatrix;
                    this.renderToTexture || (e = -this._displayOriginX, i = -this._displayOriginY, h[0] = t[0], h[1] = t[1], h[4] = t[2], h[5] = t[3], h[8] = t[4], h[9] = t[5], h[12] = h[0] * e + h[4] * i, h[13] = h[1] * e + h[5] * i), n.useProgram(a), n.uniformMatrix4fv(n.getUniformLocation(a, "uViewMatrix"), !1, h), n.uniform2f(n.getUniformLocation(a, "uResolution"), this.width, this.height);
                    var l = this.uniforms, u = l.resolution;
                    u.value.x = s, u.value.y = r, l.time.value = o.game.loop.getDuration();
                    var c, d, f, p = this.pointer;
                    p && (c = l.mouse, d = p.x / s, f = 1 - p.y / r, c.value.x = d.toFixed(2), c.value.y = f.toFixed(2)), this.syncUniforms();
                },
                flush: function() {
                    var t = this.width, e = this.height, i = this.program, n = this.gl, s = this.vertexBuffer, r = this.renderer, o = 2 * Float32Array.BYTES_PER_ELEMENT;
                    this.renderToTexture && (r.setFramebuffer(this.framebuffer), n.clearColor(0, 0, 0, 0), n.clear(n.COLOR_BUFFER_BIT)), n.bindBuffer(n.ARRAY_BUFFER, s);
                    var a = n.getAttribLocation(i, "inPosition");
                    -1 !== a && (n.enableVertexAttribArray(a), n.vertexAttribPointer(a, 2, n.FLOAT, !1, o, 0));
                    var h = this.vertexViewF32;
                    h[3] = e, h[4] = t, h[5] = e, h[8] = t, h[9] = e, h[10] = t;
                    n.bufferSubData(n.ARRAY_BUFFER, 0, this.bytes.subarray(0, 6 * o)), n.drawArrays(n.TRIANGLES, 0, 6), this.renderToTexture && r.setFramebuffer(null, !1);
                },
                setAlpha: function() {},
                setBlendMode: function() {},
                preDestroy: function() {
                    var t = this.gl;
                    t.deleteProgram(this.program), t.deleteBuffer(this.vertexBuffer), this.renderToTexture && (this.renderer.deleteFramebuffer(this.framebuffer), this.texture.destroy(), this.framebuffer = null, this.glTexture = null, this.texture = null);
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(35), o = i(113), f = i(15), h = i(473), u = i(474), l = i(19), p = i(67), a = i(1173), c = i(79), g = i(38), d = i(115), v = new n({
                Extends: f,
                Mixins: [
                    s.AlphaSingle,
                    s.BlendMode,
                    s.Depth,
                    s.Mask,
                    s.Pipeline,
                    s.Size,
                    s.Texture,
                    s.Transform,
                    s.Visible,
                    s.ScrollFactor,
                    a
                ],
                initialize: function(t, e, i, n, s, r, o, a, h, l, u, c) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = "__WHITE"), f.call(this, t, "Mesh"), this.faces = [], this.vertices = [], this.tintFill = !1, this.debugCallback = null, this.debugGraphic = null, this.hideCCW = !0, this.modelPosition = new g, this.modelScale = new g(1, 1, 1), this.modelRotation = new g, this.dirtyCache = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.transformMatrix = new p, this.viewPosition = new g, this.viewMatrix = new p, this.projectionMatrix = new p, this.totalRendered = 0, this.totalFrame = 0, this.ignoreDirtyCache = !1;
                    var d = t.sys.renderer;
                    this.setPosition(e, i), this.setTexture(n, s), this.setSize(d.width, d.height), this.initPipeline(), this.setPerspective(d.width, d.height), r && this.addVertices(r, o, a, h, l, u, c);
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                panX: function(t) {
                    return this.viewPosition.addScale(g.LEFT, t), this.dirtyCache[10] = 1, this;
                },
                panY: function(t) {
                    return this.viewPosition.y += g.DOWN.y * t, this.dirtyCache[10] = 1, this;
                },
                panZ: function(t) {
                    return this.viewPosition.z += t, this.dirtyCache[10] = 1, this;
                },
                setPerspective: function(t, e, i, n, s) {
                    return void 0 === i && (i = 45), void 0 === n && (n = .01), void 0 === s && (s = 1e3), this.projectionMatrix.perspective(r(i), t / e, n, s), this.dirtyCache[10] = 1, this.dirtyCache[11] = 0, this;
                },
                setOrtho: function(t, e, i, n) {
                    return void 0 === t && (t = this.scene.sys.renderer.getAspectRatio()), void 0 === e && (e = 1), void 0 === i && (i = -1000), void 0 === n && (n = 1e3), this.projectionMatrix.ortho(-t, t, -e, e, i, n), this.dirtyCache[10] = 1, this.dirtyCache[11] = 1, this;
                },
                clear: function() {
                    return this.faces.forEach(function(t) {
                        t.destroy();
                    }), this.faces = [], this.vertices = [], this;
                },
                addVerticesFromObj: function(t, e, i, n, s, r, o, a, h) {
                    var l = this.scene.sys.cache.obj.get(t);
                    return l && u(l, this, e, i, n, s, r, o, a, h), this;
                },
                sortByDepth: function(t, e) {
                    return t.depth - e.depth;
                },
                depthSort: function() {
                    return c(this.faces, this.sortByDepth), this;
                },
                addVertex: function(t, e, i, n, s, r, o) {
                    var a = new d(t, e, i, n, s, r, o);
                    return this.vertices.push(a), a;
                },
                addFace: function(t, e, i) {
                    var n = new o(t, e, i);
                    return this.faces.push(n), this.dirtyCache[9] = -1, n;
                },
                addVertices: function(t, e, i, n, s, r, o) {
                    var a = h(t, e, i, n, s, r, o);
                    return a && (this.faces = this.faces.concat(a.faces), this.vertices = this.vertices.concat(a.vertices)), this.dirtyCache[9] = -1, this;
                },
                getFaceCount: function() {
                    return this.faces.length;
                },
                getVertexCount: function() {
                    return this.vertices.length;
                },
                getFace: function(t) {
                    return this.faces[t];
                },
                getFaceAt: function(t, e, i) {
                    void 0 === i && (i = this.scene.sys.cameras.main);
                    for(var n = l(this, i).calc, s = this.faces, r = [], o = 0; o < s.length; o++){
                        var a = s[o];
                        a.contains(t, e, n) && r.push(a);
                    }
                    return c(r, this.sortByDepth);
                },
                setDebug: function(t, e) {
                    return this.debugGraphic = t, this.debugCallback = t || e ? e || this.renderDebug : null, this;
                },
                isDirty: function() {
                    var t = this.modelPosition, e = this.modelRotation, i = this.modelScale, n = this.dirtyCache, s = t.x, r = t.y, o = t.z, a = e.x, h = e.y, l = e.z, u = i.x, c = i.y, d = i.z, f = this.getFaceCount(), p = n[0], g = n[1], v = n[2], m = n[3], y = n[4], x = n[5], T = n[6], w = n[7], b = n[8], E = n[9];
                    return n[0] = s, n[1] = r, n[2] = o, n[3] = a, n[4] = h, n[5] = l, n[6] = u, n[7] = c, n[8] = d, n[9] = f, p !== s || g !== r || v !== o || m !== a || y !== h || x !== l || T !== u || w !== c || b !== d || E !== f;
                },
                preUpdate: function() {
                    this.totalRendered = this.totalFrame, this.totalFrame = 0;
                    var t = this.dirtyCache;
                    if (this.ignoreDirtyCache || t[10] || this.isDirty()) {
                        var e = this.width, i = this.height, n = this.viewMatrix, s = this.viewPosition;
                        t[10] && (n.identity(), n.translate(s), n.invert(), t[10] = 0);
                        var r = this.transformMatrix;
                        r.setWorldMatrix(this.modelRotation, this.modelPosition, this.modelScale, this.viewMatrix, this.projectionMatrix);
                        for(var o = s.z, a = this.faces, h = 0; h < a.length; h++)a[h].transformCoordinatesLocal(r, e, i, o);
                        this.depthSort();
                    }
                },
                renderDebug: function(t, e) {
                    for(var i = t.debugGraphic, n = 0; n < e.length; n++){
                        var s = e[n], r = s.vertex1.tx, o = s.vertex1.ty, a = s.vertex2.tx, h = s.vertex2.ty, l = s.vertex3.tx, u = s.vertex3.ty;
                        i.strokeTriangle(r, o, a, h, l, u);
                    }
                },
                preDestroy: function() {
                    this.clear(), this.debugCallback = null, this.debugGraphic = null;
                }
            });
            t.exports = v;
        },
        function(t, e, i) {
            var n = i(48);
            t.exports = function(t, e) {
                return n(t.x, t.y, e.x, e.y) <= t.radius + e.radius;
            };
        },
        function(t, e, i) {
            var T = i(4), w = i(230);
            t.exports = function(t, e, i) {
                var n, s, r, o, a, h, l, u, c, d, f, p, g, v, m, y, x;
                return void 0 === i && (i = []), w(t, e) && (n = t.x1, s = t.y1, r = t.x2, o = t.y2, 0 == (p = (f = 2 * ((h = r - n) * (u = n - e.x) + (l = o - s) * (c = s - e.y))) * f - 4 * (d = h * h + l * l) * (u * u + c * c - (a = e.radius) * a)) ? (v = n + (g = -f / (2 * d)) * h, m = s + g * l, 0 <= g && g <= 1 && i.push(new T(v, m))) : 0 < p && (v = n + (y = (-f - Math.sqrt(p)) / (2 * d)) * h, m = s + y * l, 0 <= y && y <= 1 && i.push(new T(v, m)), v = n + (x = (-f + Math.sqrt(p)) / (2 * d)) * h, m = s + x * l, 0 <= x && x <= 1 && i.push(new T(v, m)))), i;
            };
        },
        function(t, e, i) {
            var c = i(63), d = new (i(4));
            t.exports = function(t, e, i) {
                if (void 0 === i && (i = d), c(e, t.x1, t.y1)) return i.x = t.x1, i.y = t.y1, !0;
                if (c(e, t.x2, t.y2)) return i.x = t.x2, i.y = t.y2, !0;
                var n, s = t.x2 - t.x1, r = t.y2 - t.y1, o = e.x - t.x1, a = e.y - t.y1, h = s * s + r * r, l = s, u = r;
                return 0 < h && (l *= n = (o * s + a * r) / h, u *= n), i.x = t.x1 + l, i.y = t.y1 + u, l * l + u * u <= h && 0 <= l * s + u * r && c(e, i.x, i.y);
            };
        },
        function(t, e, i) {
            var u = i(4), c = i(92), d = i(482);
            t.exports = function(t, e, i) {
                if (void 0 === i && (i = []), d(t, e)) for(var n = e.getLineA(), s = e.getLineB(), r = e.getLineC(), o = e.getLineD(), a = [
                    new u,
                    new u,
                    new u,
                    new u
                ], h = [
                    c(n, t, a[0]),
                    c(s, t, a[1]),
                    c(r, t, a[2]),
                    c(o, t, a[3])
                ], l = 0; l < 4; l++)h[l] && i.push(a[l]);
                return i;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = !1), void 0 === n && (n = []);
                for(var s, r, o, a, h, l, u = t.x3 - t.x1, c = t.y3 - t.y1, d = t.x2 - t.x1, f = t.y2 - t.y1, p = u * u + c * c, g = u * d + c * f, v = d * d + f * f, m = p * v - g * g, y = 0 == m ? 0 : 1 / m, x = t.x1, T = t.y1, w = 0; w < e.length && (r = (p * (l = d * (o = e[w].x - x) + f * (a = e[w].y - T)) - g * (h = u * o + c * a)) * y, !(0 <= (s = (v * h - g * l) * y) && 0 <= r && s + r < 1 && (n.push({
                    x: e[w].x,
                    y: e[w].y
                }), i))); w++);
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = Math.cos(n), r = Math.sin(n), o = t.x1 - e, a = t.y1 - i;
                return t.x1 = o * s - a * r + e, t.y1 = o * r + a * s + i, o = t.x2 - e, a = t.y2 - i, t.x2 = o * s - a * r + e, t.y2 = o * r + a * s + i, t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 === t.height ? NaN : t.width / t.height;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = Math.cos(n), r = Math.sin(n), o = t.x1 - e, a = t.y1 - i;
                return t.x1 = o * s - a * r + e, t.y1 = o * r + a * s + i, o = t.x2 - e, a = t.y2 - i, t.x2 = o * s - a * r + e, t.y2 = o * r + a * s + i, o = t.x3 - e, a = t.y3 - i, t.x3 = o * s - a * r + e, t.y3 = o * r + a * s + i, t;
            };
        },
        function(t, e, i) {
            t.exports = {
                BUTTON_DOWN: i(1304),
                BUTTON_UP: i(1305),
                CONNECTED: i(1306),
                DISCONNECTED: i(1307),
                GAMEPAD_BUTTON_DOWN: i(1308),
                GAMEPAD_BUTTON_UP: i(1309)
            };
        },
        function(t, e, i) {
            var s = i(17), r = i(154);
            t.exports = function(t, e) {
                var i = void 0 === t ? r() : s({}, t);
                if (e) for(var n in e)void 0 !== e[n] && (i[n] = e[n]);
                return i;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), h = i(2), l = i(7), o = i(402), u = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    var s, r = "xml";
                    l(e) && (e = h(s = e, "key"), i = h(s, "url"), n = h(s, "xhrSettings"), r = h(s, "extension", r));
                    var o = {
                        type: "xml",
                        cache: t.cacheManager.xml,
                        extension: r,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    a.call(this, t, o);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = o(this.xhrLoader.responseText), this.data ? this.onProcessComplete() : (console.warn("Invalid XMLFile: " + this.key), this.onProcessError());
                }
            });
            r.register("xml", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new u(this, t[n]));
                else this.addFile(new u(this, t, e, i));
                return this;
            }), t.exports = u;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), l = i(23), r = i(8), u = i(2), c = i(7), o = new n({
                Extends: l,
                initialize: function(t, e, i, n) {
                    var s, r = "text", o = "txt", a = t.cacheManager.text;
                    c(e) && (e = u(s = e, "key"), i = u(s, "url"), n = u(s, "xhrSettings"), o = u(s, "extension", o), r = u(s, "type", r), a = u(s, "cache", a));
                    var h = {
                        type: r,
                        cache: a,
                        extension: o,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    l.call(this, t, h);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = this.xhrLoader.responseText, this.onProcessComplete();
                }
            });
            r.register("text", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            t.exports = {
                Acceleration: i(1362),
                Angular: i(1363),
                Bounce: i(1364),
                Debug: i(1365),
                Drag: i(1366),
                Enable: i(1367),
                Friction: i(1368),
                Gravity: i(1369),
                Immovable: i(1370),
                Mass: i(1371),
                OverlapCirc: i(517),
                OverlapRect: i(241),
                Pushable: i(1372),
                Size: i(1373),
                Velocity: i(1374)
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r, o) {
                void 0 === r && (r = !0), void 0 === o && (o = !1);
                var a, h, l, u = [], c = [], d = t.treeMinMax;
                return d.minX = e, d.minY = i, d.maxX = e + n, d.maxY = i + s, o && (c = t.staticTree.search(d)), r && t.useTree ? u = t.tree.search(d) : r && (a = t.bodies, h = {
                    position: {
                        x: e,
                        y: i
                    },
                    left: e,
                    top: i,
                    right: e + n,
                    bottom: i + s,
                    isCircle: !1
                }, l = t.intersects, a.iterate(function(t) {
                    l(t, h) && u.push(t);
                })), c.concat(u);
            };
        },
        function(t, e, i) {
            t.exports = {
                COLLIDE: i(1375),
                OVERLAP: i(1376),
                PAUSE: i(1377),
                RESUME: i(1378),
                TILE_COLLIDE: i(1379),
                TILE_OVERLAP: i(1380),
                WORLD_BOUNDS: i(1381),
                WORLD_STEP: i(1382)
            };
        },
        function(t, e, i) {
            var o = i(60);
            t.exports = function(t, e, i, n) {
                var s = 0, r = t.deltaAbsX() + e.deltaAbsX() + n;
                return 0 === t._dx && 0 === e._dx ? (t.embedded = !0, e.embedded = !0) : t._dx > e._dx ? r < (s = t.right - e.x) && !i || !1 === t.checkCollision.right || !1 === e.checkCollision.left ? s = 0 : (t.touching.none = !1, t.touching.right = !0, e.touching.none = !1, e.touching.left = !0, e.physicsType !== o.STATIC_BODY || i || (t.blocked.none = !1, t.blocked.right = !0), t.physicsType !== o.STATIC_BODY || i || (e.blocked.none = !1, e.blocked.left = !0)) : t._dx < e._dx && (r < -(s = t.x - e.width - e.x) && !i || !1 === t.checkCollision.left || !1 === e.checkCollision.right ? s = 0 : (t.touching.none = !1, t.touching.left = !0, e.touching.none = !1, e.touching.right = !0, e.physicsType !== o.STATIC_BODY || i || (t.blocked.none = !1, t.blocked.left = !0), t.physicsType !== o.STATIC_BODY || i || (e.blocked.none = !1, e.blocked.right = !0))), t.overlapX = s, e.overlapX = s;
            };
        },
        function(t, e, i) {
            var o = i(60);
            t.exports = function(t, e, i, n) {
                var s = 0, r = t.deltaAbsY() + e.deltaAbsY() + n;
                return 0 === t._dy && 0 === e._dy ? (t.embedded = !0, e.embedded = !0) : t._dy > e._dy ? r < (s = t.bottom - e.y) && !i || !1 === t.checkCollision.down || !1 === e.checkCollision.up ? s = 0 : (t.touching.none = !1, t.touching.down = !0, e.touching.none = !1, e.touching.up = !0, e.physicsType !== o.STATIC_BODY || i || (t.blocked.none = !1, t.blocked.down = !0), t.physicsType !== o.STATIC_BODY || i || (e.blocked.none = !1, e.blocked.up = !0)) : t._dy < e._dy && (r < -(s = t.y - e.bottom) && !i || !1 === t.checkCollision.up || !1 === e.checkCollision.down ? s = 0 : (t.touching.none = !1, t.touching.up = !0, e.touching.none = !1, e.touching.down = !0, e.physicsType !== o.STATIC_BODY || i || (t.blocked.none = !1, t.blocked.up = !0), t.physicsType !== o.STATIC_BODY || i || (e.blocked.none = !1, e.blocked.down = !0))), t.overlapY = s, e.overlapY = s;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return !(e.right <= t.left || e.bottom <= t.top || e.position.x >= t.right || e.position.y >= t.bottom);
            };
        },
        function(t, e, i) {
            var w = {};
            t.exports = w;
            var o = i(94), b = i(116), a = i(267), h = i(117), l = i(585), u = i(50);
            w._warming = .4, w._torqueDampen = 1, w._minLength = 1e-6, w.create = function(t) {
                var e = t;
                e.bodyA && !e.pointA && (e.pointA = {
                    x: 0,
                    y: 0
                }), e.bodyB && !e.pointB && (e.pointB = {
                    x: 0,
                    y: 0
                });
                var i = e.bodyA ? b.add(e.bodyA.position, e.pointA) : e.pointA, n = e.bodyB ? b.add(e.bodyB.position, e.pointB) : e.pointB, s = b.magnitude(b.sub(i, n));
                e.length = void 0 !== e.length ? e.length : s, e.id = e.id || u.nextId(), e.label = e.label || "Constraint", e.type = "constraint", e.stiffness = e.stiffness || (0 < e.length ? 1 : .7), e.damping = e.damping || 0, e.angularStiffness = e.angularStiffness || 0, e.angleA = e.bodyA ? e.bodyA.angle : e.angleA, e.angleB = e.bodyB ? e.bodyB.angle : e.angleB, e.plugin = {};
                var r = {
                    visible: !0,
                    type: "line",
                    anchors: !0,
                    lineColor: null,
                    lineOpacity: null,
                    lineThickness: null,
                    pinSize: null,
                    anchorColor: null,
                    anchorSize: null
                };
                return 0 === e.length && .1 < e.stiffness ? (r.type = "pin", r.anchors = !1) : e.stiffness < .9 && (r.type = "spring"), e.render = u.extend(r, e.render), e;
            }, w.preSolveAll = function(t) {
                for(var e = 0; e < t.length; e += 1){
                    var i = t[e], n = i.constraintImpulse;
                    i.isStatic || 0 === n.x && 0 === n.y && 0 === n.angle || (i.position.x += n.x, i.position.y += n.y, i.angle += n.angle);
                }
            }, w.solveAll = function(t, e) {
                for(var i = 0; i < t.length; i += 1){
                    var n = t[i], s = !n.bodyA || n.bodyA && n.bodyA.isStatic, r = !n.bodyB || n.bodyB && n.bodyB.isStatic;
                    (s || r) && w.solve(t[i], e);
                }
                for(i = 0; i < t.length; i += 1)s = !(n = t[i]).bodyA || n.bodyA && n.bodyA.isStatic, r = !n.bodyB || n.bodyB && n.bodyB.isStatic, s || r || w.solve(t[i], e);
            }, w.solve = function(t, e) {
                var i, n, s, r, o, a, h, l, u, c, d, f, p, g, v, m = t.bodyA, y = t.bodyB, x = t.pointA, T = t.pointB;
                (m || y) && (m && !m.isStatic && (b.rotate(x, m.angle - t.angleA, x), t.angleA = m.angle), y && !y.isStatic && (b.rotate(T, y.angle - t.angleB, T), t.angleB = y.angle), i = x, n = T, m && (i = b.add(m.position, x)), y && (n = b.add(y.position, T)), i && n && (s = b.sub(i, n), (r = b.magnitude(s)) < w._minLength && (r = w._minLength), o = (r - t.length) / r, a = t.stiffness < 1 ? t.stiffness * e : t.stiffness, h = b.mult(s, o * a), u = (l = (m ? m.inverseMass : 0) + (y ? y.inverseMass : 0)) + ((m ? m.inverseInertia : 0) + (y ? y.inverseInertia : 0)), t.damping && (f = b.create(), p = b.div(s, r), g = b.sub(y && b.sub(y.position, y.positionPrev) || f, m && b.sub(m.position, m.positionPrev) || f), v = b.dot(p, g)), m && !m.isStatic && (d = m.inverseMass / l, m.constraintImpulse.x -= h.x * d, m.constraintImpulse.y -= h.y * d, m.position.x -= h.x * d, m.position.y -= h.y * d, t.damping && (m.positionPrev.x -= t.damping * p.x * v * d, m.positionPrev.y -= t.damping * p.y * v * d), c = b.cross(x, h) / u * w._torqueDampen * m.inverseInertia * (1 - t.angularStiffness), m.constraintImpulse.angle -= c, m.angle -= c), y && !y.isStatic && (d = y.inverseMass / l, y.constraintImpulse.x += h.x * d, y.constraintImpulse.y += h.y * d, y.position.x += h.x * d, y.position.y += h.y * d, t.damping && (y.positionPrev.x += t.damping * p.x * v * d, y.positionPrev.y += t.damping * p.y * v * d), c = b.cross(T, h) / u * w._torqueDampen * y.inverseInertia * (1 - t.angularStiffness), y.constraintImpulse.angle += c, y.angle += c)));
            }, w.postSolveAll = function(t) {
                for(var e = 0; e < t.length; e++){
                    var i = t[e], n = i.constraintImpulse;
                    if (!(i.isStatic || 0 === n.x && 0 === n.y && 0 === n.angle)) {
                        a.set(i, !1);
                        for(var s = 0; s < i.parts.length; s++){
                            var r = i.parts[s];
                            o.translate(r.vertices, n), 0 < s && (r.position.x += n.x, r.position.y += n.y), 0 !== n.angle && (o.rotate(r.vertices, n.angle, i.position), l.rotate(r.axes, n.angle), 0 < s && b.rotateAbout(r.position, n.angle, i.position, r.position)), h.update(r.bounds, r.vertices, i.velocity);
                        }
                        n.angle *= w._warming, n.x *= w._warming, n.y *= w._warming;
                    }
                }
            }, w.pointAWorld = function(t) {
                return {
                    x: (t.bodyA ? t.bodyA.position.x : 0) + t.pointA.x,
                    y: (t.bodyA ? t.bodyA.position.y : 0) + t.pointA.y
                };
            }, w.pointBWorld = function(t) {
                return {
                    x: (t.bodyB ? t.bodyB.position.x : 0) + t.pointB.x,
                    y: (t.bodyB ? t.bodyB.position.y : 0) + t.pointB.y
                };
            };
        },
        function(t, e, i) {
            t.exports = {
                CalculateFacesAt: i(248),
                CalculateFacesWithin: i(61),
                CheckIsoBounds: i(537),
                Copy: i(1414),
                CreateFromTiles: i(1415),
                CullBounds: i(539),
                CullTiles: i(540),
                Fill: i(1416),
                FilterTiles: i(1417),
                FindByIndex: i(1418),
                FindTile: i(1419),
                ForEachTile: i(1420),
                GetCullTilesFunction: i(1421),
                GetTileAt: i(156),
                GetTileAtWorldXY: i(1422),
                GetTilesWithin: i(26),
                GetTilesWithinShape: i(1423),
                GetTilesWithinWorldXY: i(523),
                GetTileToWorldXFunction: i(1424),
                GetTileToWorldXYFunction: i(1425),
                GetTileToWorldYFunction: i(1426),
                GetWorldToTileXFunction: i(1427),
                GetWorldToTileXYFunction: i(1428),
                GetWorldToTileYFunction: i(1429),
                HasTileAt: i(558),
                HasTileAtWorldXY: i(1430),
                HexagonalCullBounds: i(542),
                HexagonalCullTiles: i(541),
                HexagonalTileToWorldXY: i(546),
                HexagonalTileToWorldY: i(550),
                HexagonalWorldToTileXY: i(552),
                HexagonalWorldToTileY: i(556),
                IsInLayerBounds: i(118),
                IsometricCullTiles: i(543),
                IsometricTileToWorldXY: i(547),
                IsometricWorldToTileXY: i(553),
                PutTileAt: i(253),
                PutTileAtWorldXY: i(1431),
                PutTilesAt: i(1432),
                Randomize: i(1433),
                RemoveTileAt: i(559),
                RemoveTileAtWorldXY: i(1434),
                RenderDebug: i(1435),
                ReplaceByIndex: i(538),
                RunCull: i(157),
                SetCollision: i(1436),
                SetCollisionBetween: i(1437),
                SetCollisionByExclusion: i(1438),
                SetCollisionByProperty: i(1439),
                SetCollisionFromCollisionGroup: i(1440),
                SetLayerCollisionIndex: i(158),
                SetTileCollision: i(72),
                SetTileIndexCallback: i(1441),
                SetTileLocationCallback: i(1442),
                Shuffle: i(1443),
                StaggeredCullBounds: i(545),
                StaggeredCullTiles: i(544),
                StaggeredTileToWorldXY: i(548),
                StaggeredTileToWorldY: i(551),
                StaggeredWorldToTileXY: i(554),
                StaggeredWorldToTileY: i(557),
                SwapByIndex: i(1444),
                TileToWorldX: i(249),
                TileToWorldXY: i(549),
                TileToWorldY: i(250),
                WeightedRandomize: i(1445),
                WorldToTileX: i(251),
                WorldToTileXY: i(555),
                WorldToTileY: i(252)
            };
        },
        function(t, e, i) {
            var l = i(156);
            t.exports = function(t, e, i) {
                var n = l(t, e, !0, i), s = l(t, e - 1, !0, i), r = l(t, e + 1, !0, i), o = l(t - 1, e, !0, i), a = l(t + 1, e, !0, i), h = n && n.collides;
                return h && (n.faceTop = !0, n.faceBottom = !0, n.faceLeft = !0, n.faceRight = !0), s && s.collides && (h && (n.faceTop = !1), s.faceBottom = !h), r && r.collides && (h && (n.faceBottom = !1), r.faceTop = !h), o && o.collides && (h && (n.faceLeft = !1), o.faceRight = !h), a && a.collides && (h && (n.faceRight = !1), a.faceLeft = !h), n && !n.collides && n.resetFaces(), n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = i.baseTileWidth, s = i.tilemapLayer, r = 0;
                return s && (e = e || s.scene.cameras.main, r = s.x + e.scrollX * (1 - s.scrollFactorX), n *= s.scaleX), r + t * n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = i.baseTileHeight, s = i.tilemapLayer, r = 0;
                return s && (e = e || s.scene.cameras.main, r = s.y + e.scrollY * (1 - s.scrollFactorY), n *= s.scaleY), r + t * n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = !0);
                var s = n.baseTileWidth, r = n.tilemapLayer;
                return r && (i = i || r.scene.cameras.main, t -= r.x + i.scrollX * (1 - r.scrollFactorX), s *= r.scaleX), e ? Math.floor(t / s) : t / s;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = !0);
                var s = n.baseTileHeight, r = n.tilemapLayer;
                return r && (i = i || r.scene.cameras.main, t -= r.y + i.scrollY * (1 - r.scrollFactorY), s *= r.scaleY), e ? Math.floor(t / s) : t / s;
            };
        },
        function(t, e, i) {
            var u = i(83), c = i(118), d = i(248), f = i(72);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === n && (n = !0), !c(e, i, s)) return null;
                var r, o = s.data[i][e], a = o && o.collides;
                t instanceof u ? (null === s.data[i][e] && (s.data[i][e] = new u(s, t.index, e, i, s.tileWidth, s.tileHeight)), s.data[i][e].copy(t)) : (r = t, null === s.data[i][e] ? s.data[i][e] = new u(s, r, e, i, s.tileWidth, s.tileHeight) : s.data[i][e].index = r);
                var h = s.data[i][e], l = -1 !== s.collideIndexes.indexOf(h.index);
                return f(h, l), n && a !== h.collides && d(e, i, s), h;
            };
        },
        function(t, e, i) {
            var n = i(29);
            t.exports = function(t) {
                return "isometric" === (t = t.toLowerCase()) ? n.ISOMETRIC : "staggered" === t ? n.STAGGERED : "hexagonal" === t ? n.HEXAGONAL : n.ORTHOGONAL;
            };
        },
        function(t, e, i) {
            var p = i(39), g = i(119), v = i(120), m = i(83);
            t.exports = function(t, e, i, n, s) {
                for(var r = new g({
                    tileWidth: i,
                    tileHeight: n
                }), o = new v({
                    name: t,
                    tileWidth: i,
                    tileHeight: n,
                    format: p.ARRAY_2D,
                    layers: [
                        r
                    ]
                }), a = [], h = e.length, l = 0, u = 0; u < e.length; u++){
                    a[u] = [];
                    for(var c = e[u], d = 0; d < c.length; d++){
                        var f = parseInt(c[d], 10);
                        isNaN(f) || -1 === f ? a[u][d] = s ? null : new m(r, -1, d, u, i, n) : a[u][d] = new m(r, f, d, u, i, n);
                    }
                    0 === l && (l = c.length);
                }
                return o.width = r.width = l, o.height = r.height = h, o.widthInPixels = r.widthInPixels = l * i, o.heightInPixels = r.heightInPixels = h * n, r.data = a, o;
            };
        },
        function(t, e, i) {
            function r(t) {
                return {
                    x: t.x,
                    y: t.y
                };
            }
            var o = i(567), a = i(257), h = [
                "id",
                "name",
                "type",
                "rotation",
                "properties",
                "visible",
                "x",
                "y",
                "width",
                "height"
            ];
            t.exports = function(t, e, i) {
                void 0 === e && (e = 0), void 0 === i && (i = 0);
                var n, s = o(t, h);
                return s.x += e, s.y += i, t.gid ? (n = a(t.gid), s.gid = n.gid, s.flippedHorizontal = n.flippedHorizontal, s.flippedVertical = n.flippedVertical, s.flippedAntiDiagonal = n.flippedAntiDiagonal) : t.polyline ? s.polyline = t.polyline.map(r) : t.polygon ? s.polygon = t.polygon.map(r) : t.ellipse ? s.ellipse = t.ellipse : t.text ? s.text = t.text : t.point ? s.point = !0 : s.rectangle = !0, s;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = Boolean(2147483648 & t), i = Boolean(1073741824 & t), n = Boolean(536870912 & t);
                t &= 536870911;
                var s = 0, r = !1;
                return e && i && n ? (s = Math.PI / 2, r = !0) : e && i && !n ? (s = Math.PI, r = !1) : e && !i && n ? (s = Math.PI / 2, r = !1) : !e || i || n ? !e && i && n ? (s = 3 * Math.PI / 2, r = !1) : e || !i || n ? e || i || !n ? e || i || n || (s = 0, r = !1) : (s = 3 * Math.PI / 2, r = !0) : (s = Math.PI, r = !0) : r = (s = 0, true), {
                    gid: t,
                    flippedHorizontal: e,
                    flippedVertical: i,
                    flippedAntiDiagonal: n,
                    rotation: s,
                    flipped: r
                };
            };
        },
        function(t, e, i) {
            var u = i(39), c = i(120), d = i(560), f = i(576);
            t.exports = function(t, e, i, n, s, r, o, a) {
                void 0 === i && (i = 32), void 0 === n && (n = 32), void 0 === s && (s = 10), void 0 === r && (r = 10), void 0 === a && (a = !1);
                var h, l = null;
                return Array.isArray(o) ? l = d(void 0 !== e ? e : "map", u.ARRAY_2D, o, i, n, a) : void 0 !== e && ((h = t.cache.tilemap.get(e)) ? l = d(e, h.format, h.data, i, n, a) : console.warn("No map data found for key " + e)), null === l && (l = new c({
                    tileWidth: i,
                    tileHeight: n,
                    width: s,
                    height: r
                })), new f(t, l);
            };
        },
        function(t, e, i) {
            var n = i(6);
            t.exports = function(t) {
                var e = n(t, "targets", null);
                return null === e || ("function" == typeof e && (e = e.call()), Array.isArray(e) || (e = [
                    e
                ])), e;
            };
        },
        function(t, e) {
            function g(t) {
                return !!t.getActive && "function" == typeof t.getActive;
            }
            function v(t) {
                return !!t.getStart && "function" == typeof t.getStart;
            }
            function m(t) {
                return !!t.getEnd && "function" == typeof t.getEnd;
            }
            var y = function(t, e) {
                var i, n, s, r, o, a, h, l = function(t, e, i) {
                    return i;
                }, u = function(t, e, i) {
                    return i;
                }, c = null, d = typeof e;
                if ("number" == d) l = function() {
                    return e;
                };
                else if ("string" == d) {
                    var f = e[0], p = parseFloat(e.substr(2));
                    switch(f){
                        case "+":
                            l = function(t, e, i) {
                                return i + p;
                            };
                            break;
                        case "-":
                            l = function(t, e, i) {
                                return i - p;
                            };
                            break;
                        case "*":
                            l = function(t, e, i) {
                                return i * p;
                            };
                            break;
                        case "/":
                            l = function(t, e, i) {
                                return i / p;
                            };
                            break;
                        default:
                            l = function() {
                                return parseFloat(e);
                            };
                    }
                } else "function" == d ? l = e : "object" == d && (v(h = e) || m(h) || g(h) ? (g(e) && (c = e.getActive), m(e) && (l = e.getEnd), v(e) && (u = e.getStart)) : e.hasOwnProperty("value") ? a = y(t, e.value) : (i = e.hasOwnProperty("to"), n = e.hasOwnProperty("from"), s = e.hasOwnProperty("start"), i && (n || s) && (a = y(t, e.to), s && (r = y(t, e.start), a.getActive = r.getEnd), n && (o = y(t, e.from), a.getStart = o.getEnd))));
                return a = a || {
                    getActive: c,
                    getEnd: l,
                    getStart: u
                };
            };
            t.exports = y;
        },
        function(t, e) {
            t.exports = {
                targets: null,
                delay: 0,
                duration: 1e3,
                ease: "Power0",
                easeParams: null,
                hold: 0,
                repeat: 0,
                repeatDelay: 0,
                yoyo: !1,
                flipX: !1,
                flipY: !1
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(9), u = i(263), r = i(16), o = i(5), c = i(97), a = i(14), h = new n({
                Extends: s,
                initialize: function(t, e, i) {
                    s.call(this), this.parent = t, this.parentIsTimeline = t.hasOwnProperty("isTimeline"), this.data = e, this.totalData = e.length, this.targets = i, this.totalTargets = i.length, this.useFrames = !1, this.timeScale = 1, this.loop = 0, this.loopDelay = 0, this.loopCounter = 0, this.startDelay = 0, this.hasStarted = !1, this.isSeeking = !1, this.completeDelay = 0, this.countdown = 0, this.offset = 0, this.calculatedOffset = 0, this.state = c.PENDING_ADD, this._pausedState = c.INIT, this.paused = !1, this.elapsed = 0, this.totalElapsed = 0, this.duration = 0, this.progress = 0, this.totalDuration = 0, this.totalProgress = 0, this.callbacks = {
                        onActive: null,
                        onComplete: null,
                        onLoop: null,
                        onRepeat: null,
                        onStart: null,
                        onStop: null,
                        onUpdate: null,
                        onYoyo: null
                    }, this.callbackScope;
                },
                getValue: function(t) {
                    return void 0 === t && (t = 0), this.data[t].current;
                },
                setTimeScale: function(t) {
                    return this.timeScale = t, this;
                },
                getTimeScale: function() {
                    return this.timeScale;
                },
                isPlaying: function() {
                    return this.state === c.ACTIVE;
                },
                isPaused: function() {
                    return this.state === c.PAUSED;
                },
                hasTarget: function(t) {
                    return -1 !== this.targets.indexOf(t);
                },
                updateTo: function(t, e, i) {
                    void 0 === i && (i = !1);
                    for(var n = 0; n < this.totalData; n++){
                        var s = this.data[n];
                        s.key === t && (s.end = e, i && (s.start = s.current));
                    }
                    return this;
                },
                restart: function() {
                    return this.elapsed = 0, this.progress = 0, this.totalElapsed = 0, this.totalProgress = 0, this.state === c.ACTIVE ? this.seek(0) : this.state === c.REMOVED ? (this.seek(0), this.parent.makeActive(this), this) : this.state === c.PENDING_ADD ? this : this.play();
                },
                calcDuration: function() {
                    for(var t = 0, e = a.MAX_SAFE_INTEGER, i = this.data, n = 0; n < this.totalData; n++){
                        var s = i[n];
                        s.t1 = s.duration + s.hold, s.yoyo && (s.t1 += s.duration), s.t2 = s.t1 + s.repeatDelay, s.totalDuration = s.delay + s.t1, -1 === s.repeat ? s.totalDuration += 999999999999 * s.t2 : 0 < s.repeat && (s.totalDuration += s.t2 * s.repeat), s.totalDuration > t && (t = s.totalDuration), s.delay < e && (e = s.delay);
                    }
                    this.duration = Math.max(t, .001), this.loopCounter = -1 === this.loop ? 999999999999 : this.loop, 0 < this.loopCounter ? this.totalDuration = this.duration + this.completeDelay + (this.duration + this.loopDelay) * this.loopCounter : this.totalDuration = this.duration + this.completeDelay, this.startDelay = e;
                },
                init: function() {
                    if (this.paused && !this.parentIsTimeline) return this.state = c.PENDING_ADD, this._pausedState = c.INIT, !1;
                    for(var t = this.data, e = this.totalTargets, i = 0; i < this.totalData; i++){
                        var n = t[i], s = n.target, r = n.gen, o = n.key, a = n.index;
                        n.delay = r.delay(s, o, 0, a, e, this), n.duration = Math.max(r.duration(s, o, 0, a, e, this), .001), n.hold = r.hold(s, o, 0, a, e, this), n.repeat = r.repeat(s, o, 0, a, e, this), n.repeatDelay = r.repeatDelay(s, o, 0, a, e, this);
                    }
                    return this.calcDuration(), this.progress = 0, this.totalProgress = 0, this.elapsed = 0, this.totalElapsed = 0, this.state = c.INIT, !0;
                },
                makeActive: function() {
                    this.parent.makeActive(this), this.dispatchTweenEvent(u.TWEEN_ACTIVE, this.callbacks.onActive);
                },
                nextState: function() {
                    0 < this.loopCounter ? (this.elapsed = 0, this.progress = 0, this.loopCounter--, this.resetTweenData(!0), 0 < this.loopDelay ? (this.countdown = this.loopDelay, this.state = c.LOOP_DELAY) : (this.state = c.ACTIVE, this.dispatchTweenEvent(u.TWEEN_LOOP, this.callbacks.onLoop))) : 0 < this.completeDelay ? (this.state = c.COMPLETE_DELAY, this.countdown = this.completeDelay) : (this.state = c.PENDING_REMOVE, this.dispatchTweenEvent(u.TWEEN_COMPLETE, this.callbacks.onComplete));
                },
                pause: function() {
                    return this.state === c.PAUSED || (this.paused = !0, this._pausedState = this.state, this.state = c.PAUSED), this;
                },
                play: function(t) {
                    void 0 === t && (t = !1);
                    var e = this.state;
                    return e !== c.INIT || this.parentIsTimeline ? e === c.ACTIVE || e === c.PENDING_ADD && this._pausedState === c.PENDING_ADD || (this.parentIsTimeline || e !== c.PENDING_REMOVE && e !== c.REMOVED ? this.parentIsTimeline ? (this.resetTweenData(t), 0 === this.calculatedOffset ? this.state = c.ACTIVE : (this.countdown = this.calculatedOffset, this.state = c.OFFSET_DELAY)) : (this.paused ? this.paused = !1 : (this.resetTweenData(t), this.state = c.ACTIVE), this.makeActive()) : (this.seek(0), this.parent.makeActive(this))) : (this.resetTweenData(!1), this.state = c.ACTIVE), this;
                },
                resetTweenData: function(t) {
                    for(var e = this.data, i = this.totalData, n = this.totalTargets, s = 0; s < i; s++){
                        var r = e[s], o = r.target, a = r.key, h = r.index;
                        r.progress = 0, r.elapsed = 0, r.repeatCounter = -1 === r.repeat ? 999999999999 : r.repeat, t ? (r.start = r.getStartValue(o, a, r.start, h, n, this), r.end = r.getEndValue(o, a, r.end, h, n, this), r.current = r.start, r.state = c.PLAYING_FORWARD) : r.state = c.PENDING_RENDER, 0 < r.delay && (r.elapsed = r.delay, r.state = c.DELAY), r.getActiveValue && (o[a] = r.getActiveValue(r.target, r.key, r.start));
                    }
                },
                resume: function() {
                    return this.state === c.PAUSED ? (this.paused = !1, this.state = this._pausedState) : this.play(), this;
                },
                seek: function(t, e) {
                    void 0 === e && (e = 16.6), this.state === c.REMOVED && this.makeActive(), this.elapsed = 0, this.progress = 0, this.totalElapsed = 0, this.totalProgress = 0;
                    for(var i = this.data, n = this.totalTargets, s = 0; s < this.totalData; s++){
                        var r = i[s], o = r.target, a = r.gen, h = r.key, l = r.index;
                        r.progress = 0, r.elapsed = 0, r.repeatCounter = -1 === r.repeat ? 999999999999 : r.repeat, r.delay = a.delay(o, h, 0, l, n, this), r.duration = Math.max(a.duration(o, h, 0, l, n, this), .001), r.hold = a.hold(o, h, 0, l, n, this), r.repeat = a.repeat(o, h, 0, l, n, this), r.repeatDelay = a.repeatDelay(o, h, 0, l, n, this), r.current = r.start, r.state = c.PLAYING_FORWARD, this.updateTweenData(this, r, 0, l, n), 0 < r.delay && (r.elapsed = r.delay, r.state = c.DELAY);
                    }
                    this.calcDuration();
                    var u = !1;
                    for(this.state === c.PAUSED && (u = !0, this.state = c.ACTIVE), this.isSeeking = !0; this.update(0, e), this.totalProgress < t;);
                    return this.isSeeking = !1, u && (this.state = c.PAUSED), this;
                },
                setCallback: function(t, e, i, n) {
                    return this.callbacks[t] = {
                        func: e,
                        scope: n,
                        params: i
                    }, this;
                },
                complete: function(t) {
                    return void 0 === t && (t = 0), t ? (this.state = c.COMPLETE_DELAY, this.countdown = t) : (this.state = c.PENDING_REMOVE, this.dispatchTweenEvent(u.TWEEN_COMPLETE, this.callbacks.onComplete)), this;
                },
                remove: function() {
                    return this.parent.remove(this), this;
                },
                stop: function(t) {
                    return this.state === c.ACTIVE && void 0 !== t && this.seek(t), this.state !== c.REMOVED && (this.state !== c.PAUSED && this.state !== c.PENDING_ADD || (this.parentIsTimeline ? (this.parent.manager._destroy.push(this), this.parent.manager._toProcess++) : (this.parent._destroy.push(this), this.parent._toProcess++)), this.dispatchTweenEvent(u.TWEEN_STOP, this.callbacks.onStop), this.removeAllListeners(), this.state = c.PENDING_REMOVE), this;
                },
                update: function(t, e) {
                    if (this.state === c.PAUSED) return !1;
                    switch(this.useFrames && (e = +this.parent.timeScale), e *= this.timeScale, this.elapsed += e, this.progress = Math.min(this.elapsed / this.duration, 1), this.totalElapsed += e, this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1), this.state){
                        case c.ACTIVE:
                            this.hasStarted || this.isSeeking || (this.startDelay -= e, this.startDelay <= 0 && (this.hasStarted = !0, this.dispatchTweenEvent(u.TWEEN_START, this.callbacks.onStart)));
                            for(var i = !1, n = 0; n < this.totalData; n++){
                                var s = this.data[n];
                                this.updateTweenData(this, s, e) && (i = !0);
                            }
                            i || this.nextState();
                            break;
                        case c.LOOP_DELAY:
                            this.countdown -= e, this.countdown <= 0 && (this.state = c.ACTIVE, this.dispatchTweenEvent(u.TWEEN_LOOP, this.callbacks.onLoop));
                            break;
                        case c.OFFSET_DELAY:
                            this.countdown -= e, this.countdown <= 0 && (this.state = c.ACTIVE);
                            break;
                        case c.COMPLETE_DELAY:
                            this.countdown -= e, this.countdown <= 0 && (this.state = c.PENDING_REMOVE, this.dispatchTweenEvent(u.TWEEN_COMPLETE, this.callbacks.onComplete));
                    }
                    return this.state === c.PENDING_REMOVE;
                },
                dispatchTweenDataEvent: function(t, e, i) {
                    this.isSeeking || (this.emit(t, this, i.key, i.target, i.current, i.previous), e && (e.params[1] = i.target, e.func.apply(e.scope, e.params)));
                },
                dispatchTweenEvent: function(t, e) {
                    this.isSeeking || (this.emit(t, this, this.targets), e && (e.params[1] = this.targets, e.func.apply(e.scope, e.params)));
                },
                setStateFromEnd: function(t, e, i) {
                    return e.yoyo ? (e.elapsed = i, e.progress = i / e.duration, e.flipX && e.target.toggleFlipX(), e.flipY && e.target.toggleFlipY(), this.dispatchTweenDataEvent(u.TWEEN_YOYO, t.callbacks.onYoyo, e), e.start = e.getStartValue(e.target, e.key, e.start, e.index, t.totalTargets, t), c.PLAYING_BACKWARD) : 0 < e.repeatCounter ? (e.repeatCounter--, e.elapsed = i, e.progress = i / e.duration, e.flipX && e.target.toggleFlipX(), e.flipY && e.target.toggleFlipY(), e.start = e.getStartValue(e.target, e.key, e.start, e.index, t.totalTargets, t), e.end = e.getEndValue(e.target, e.key, e.start, e.index, t.totalTargets, t), 0 < e.repeatDelay ? (e.elapsed = e.repeatDelay - i, e.current = e.start, e.target[e.key] = e.current, c.REPEAT_DELAY) : (this.dispatchTweenDataEvent(u.TWEEN_REPEAT, t.callbacks.onRepeat, e), c.PLAYING_FORWARD)) : c.COMPLETE;
                },
                setStateFromStart: function(t, e, i) {
                    return 0 < e.repeatCounter ? (e.repeatCounter--, e.elapsed = i, e.progress = i / e.duration, e.flipX && e.target.toggleFlipX(), e.flipY && e.target.toggleFlipY(), e.end = e.getEndValue(e.target, e.key, e.start, e.index, t.totalTargets, t), 0 < e.repeatDelay ? (e.elapsed = e.repeatDelay - i, e.current = e.start, e.target[e.key] = e.current, c.REPEAT_DELAY) : (this.dispatchTweenDataEvent(u.TWEEN_REPEAT, t.callbacks.onRepeat, e), c.PLAYING_FORWARD)) : c.COMPLETE;
                },
                updateTweenData: function(t, e, i) {
                    var n = e.target;
                    switch(e.state){
                        case c.PLAYING_FORWARD:
                        case c.PLAYING_BACKWARD:
                            if (!n) {
                                e.state = c.COMPLETE;
                                break;
                            }
                            var s = e.elapsed, r = e.duration, o = 0;
                            r < (s += i) && (o = s - r, s = r);
                            var a, h = e.state === c.PLAYING_FORWARD, l = s / r;
                            e.elapsed = s, e.progress = l, e.previous = e.current, 1 == l ? h ? (e.current = e.end, n[e.key] = e.end, 0 < e.hold ? (e.elapsed = e.hold - o, e.state = c.HOLD_DELAY) : e.state = this.setStateFromEnd(t, e, o)) : (e.current = e.start, n[e.key] = e.start, e.state = this.setStateFromStart(t, e, o)) : (a = h ? e.ease(l) : e.ease(1 - l), e.current = e.start + (e.end - e.start) * a, n[e.key] = e.current), this.dispatchTweenDataEvent(u.TWEEN_UPDATE, t.callbacks.onUpdate, e);
                            break;
                        case c.DELAY:
                            e.elapsed -= i, e.elapsed <= 0 && (e.elapsed = Math.abs(e.elapsed), e.state = c.PENDING_RENDER);
                            break;
                        case c.REPEAT_DELAY:
                            e.elapsed -= i, e.elapsed <= 0 && (e.elapsed = Math.abs(e.elapsed), e.state = c.PLAYING_FORWARD, this.dispatchTweenDataEvent(u.TWEEN_REPEAT, t.callbacks.onRepeat, e));
                            break;
                        case c.HOLD_DELAY:
                            e.elapsed -= i, e.elapsed <= 0 && (e.state = this.setStateFromEnd(t, e, Math.abs(e.elapsed)));
                            break;
                        case c.PENDING_RENDER:
                            n ? (e.start = e.getStartValue(n, e.key, n[e.key], e.index, t.totalTargets, t), e.end = e.getEndValue(n, e.key, e.start, e.index, t.totalTargets, t), e.current = e.start, n[e.key] = e.start, e.state = c.PLAYING_FORWARD) : e.state = c.COMPLETE;
                    }
                    return e.state !== c.COMPLETE;
                }
            });
            h.TYPES = [
                "onActive",
                "onComplete",
                "onLoop",
                "onRepeat",
                "onStart",
                "onStop",
                "onUpdate",
                "onYoyo"
            ], o.register("tween", function(t) {
                return this.scene.sys.tweens.add(t);
            }), r.register("tween", function(t) {
                return this.scene.sys.tweens.create(t);
            }), t.exports = h;
        },
        function(t, e, i) {
            t.exports = {
                TIMELINE_COMPLETE: i(1459),
                TIMELINE_LOOP: i(1460),
                TIMELINE_PAUSE: i(1461),
                TIMELINE_RESUME: i(1462),
                TIMELINE_START: i(1463),
                TIMELINE_UPDATE: i(1464),
                TWEEN_ACTIVE: i(1465),
                TWEEN_COMPLETE: i(1466),
                TWEEN_LOOP: i(1467),
                TWEEN_REPEAT: i(1468),
                TWEEN_START: i(1469),
                TWEEN_STOP: i(1470),
                TWEEN_UPDATE: i(1471),
                TWEEN_YOYO: i(1472)
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r, o, a, h, l, u, c, d, f, p) {
                return {
                    target: t,
                    index: e,
                    key: i,
                    getActiveValue: r,
                    getEndValue: n,
                    getStartValue: s,
                    ease: o,
                    duration: 0,
                    totalDuration: 0,
                    delay: 0,
                    yoyo: l,
                    hold: 0,
                    repeat: 0,
                    repeatDelay: 0,
                    flipX: f,
                    flipY: p,
                    progress: 0,
                    elapsed: 0,
                    repeatCounter: 0,
                    start: 0,
                    previous: 0,
                    current: 0,
                    end: 0,
                    t1: 0,
                    t2: 0,
                    gen: {
                        delay: a,
                        duration: h,
                        hold: u,
                        repeat: c,
                        repeatDelay: d
                    },
                    state: 0
                };
            };
        },
        function(t, e, i) {
            var n = i(66);
            t.exports = function(t) {
                return n(t, -Math.PI, Math.PI);
            };
        },
        function(t, e, i) {
            var n = i(66);
            t.exports = function(t) {
                return n(t, -180, 180);
            };
        },
        function(t, e, i) {
            var u = {};
            t.exports = u;
            var n = i(268);
            u._motionWakeThreshold = .18, u._motionSleepThreshold = .08, u._minBias = .9, u.update = function(t, e) {
                for(var i = e * e * e, n = 0; n < t.length; n++){
                    var s, r, o = t[n], a = o.speed * o.speed + o.angularSpeed * o.angularSpeed;
                    0 === o.force.x && 0 === o.force.y ? (s = Math.min(o.motion, a), r = Math.max(o.motion, a), o.motion = u._minBias * s + (1 - u._minBias) * r, 0 < o.sleepThreshold && o.motion < u._motionSleepThreshold * i ? (o.sleepCounter += 1, o.sleepCounter >= o.sleepThreshold && u.set(o, !0)) : 0 < o.sleepCounter && --o.sleepCounter) : u.set(o, !1);
                }
            }, u.afterCollisions = function(t, e) {
                for(var i = e * e * e, n = 0; n < t.length; n++){
                    var s, r, o, a, h, l = t[n];
                    l.isActive && (r = (s = l.collision).bodyA.parent, o = s.bodyB.parent, r.isSleeping && o.isSleeping || r.isStatic || o.isStatic || (r.isSleeping || o.isSleeping) && (h = (a = r.isSleeping && !r.isStatic ? r : o) === r ? o : r, !a.isStatic && h.motion > u._motionWakeThreshold * i && u.set(a, !1)));
                }
            }, u.set = function(t, e) {
                var i = t.isSleeping;
                e ? (t.isSleeping = !0, t.sleepCounter = t.sleepThreshold, t.positionImpulse.x = 0, t.positionImpulse.y = 0, t.positionPrev.x = t.position.x, t.positionPrev.y = t.position.y, t.anglePrev = t.angle, t.speed = 0, t.angularSpeed = 0, t.motion = 0, i || n.trigger(t, "sleepStart")) : (t.isSleeping = !1, t.sleepCounter = 0, i && n.trigger(t, "sleepEnd"));
            };
        },
        function(t, e, i) {
            var n = {};
            t.exports = n;
            var u = i(50);
            n.on = function(t, e, i) {
                for(var n, s = e.split(" "), r = 0; r < s.length; r++)n = s[r], t.events = t.events || {}, t.events[n] = t.events[n] || [], t.events[n].push(i);
                return i;
            }, n.off = function(t, e, i) {
                if (e) {
                    "function" == typeof e && (i = e, e = u.keys(t.events).join(" "));
                    for(var n = e.split(" "), s = 0; s < n.length; s++){
                        var r = t.events[n[s]], o = [];
                        if (i && r) for(var a = 0; a < r.length; a++)r[a] !== i && o.push(r[a]);
                        t.events[n[s]] = o;
                    }
                } else t.events = {};
            }, n.trigger = function(t, e, i) {
                var n, s, r, o, a = t.events;
                if (a && 0 < u.keys(a).length) {
                    i = i || {}, n = e.split(" ");
                    for(var h = 0; h < n.length; h++)if (r = a[s = n[h]]) {
                        (o = u.clone(i, !1)).name = s, o.source = t;
                        for(var l = 0; l < r.length; l++)r[l].apply(t, [
                            o
                        ]);
                    }
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                AlignTo: i(599),
                Angle: i(600),
                Call: i(601),
                GetFirst: i(602),
                GetLast: i(603),
                GridAlign: i(604),
                IncAlpha: i(654),
                IncX: i(655),
                IncXY: i(656),
                IncY: i(657),
                PlaceOnCircle: i(658),
                PlaceOnEllipse: i(659),
                PlaceOnLine: i(660),
                PlaceOnRectangle: i(661),
                PlaceOnTriangle: i(662),
                PlayAnimation: i(663),
                PropertyValueInc: i(44),
                PropertyValueSet: i(27),
                RandomCircle: i(664),
                RandomEllipse: i(665),
                RandomLine: i(666),
                RandomRectangle: i(667),
                RandomTriangle: i(668),
                Rotate: i(669),
                RotateAround: i(670),
                RotateAroundDistance: i(671),
                ScaleX: i(672),
                ScaleXY: i(673),
                ScaleY: i(674),
                SetAlpha: i(675),
                SetBlendMode: i(676),
                SetDepth: i(677),
                SetHitArea: i(678),
                SetOrigin: i(679),
                SetRotation: i(680),
                SetScale: i(681),
                SetScaleX: i(682),
                SetScaleY: i(683),
                SetScrollFactor: i(684),
                SetScrollFactorX: i(685),
                SetScrollFactorY: i(686),
                SetTint: i(687),
                SetVisible: i(688),
                SetX: i(689),
                SetXY: i(690),
                SetY: i(691),
                ShiftPosition: i(692),
                Shuffle: i(693),
                SmootherStep: i(694),
                SmoothStep: i(695),
                Spread: i(696),
                ToggleVisible: i(697),
                WrapInRectangle: i(698)
            };
        },
        function(t, e, i) {
            var n = i(122), r = [];
            r[n.BOTTOM_CENTER] = i(271), r[n.BOTTOM_LEFT] = i(272), r[n.BOTTOM_RIGHT] = i(273), r[n.LEFT_BOTTOM] = i(274), r[n.LEFT_CENTER] = i(275), r[n.LEFT_TOP] = i(276), r[n.RIGHT_BOTTOM] = i(277), r[n.RIGHT_CENTER] = i(278), r[n.RIGHT_TOP] = i(279), r[n.TOP_CENTER] = i(280), r[n.TOP_LEFT] = i(281), r[n.TOP_RIGHT] = i(282);
            t.exports = function(t, e, i, n, s) {
                return r[i](t, e, n, s);
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(84), o = i(85), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, r(e) + i), a(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(41), o = i(52), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, r(e) - i), a(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(42), o = i(53), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, r(e) + i), a(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(41), o = i(54), a = i(53);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) - i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(86), r = i(41), o = i(87), a = i(53);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) - i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(41), r = i(43), o = i(53), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, s(e) - i), a(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(42), o = i(54), a = i(52);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) + i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(86), r = i(42), o = i(87), a = i(52);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) + i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(42), r = i(43), o = i(52), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, s(e) + i), a(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(84), r = i(43), o = i(54), a = i(85);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, s(e) + i), o(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(41), r = i(43), o = i(54), a = i(52);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, s(e) - i), o(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(42), r = i(43), o = i(54), a = i(53);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, s(e) + i), o(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var n = i(122), r = [];
            r[n.BOTTOM_CENTER] = i(284), r[n.BOTTOM_LEFT] = i(285), r[n.BOTTOM_RIGHT] = i(286), r[n.CENTER] = i(287), r[n.LEFT_CENTER] = i(289), r[n.RIGHT_CENTER] = i(290), r[n.TOP_CENTER] = i(291), r[n.TOP_LEFT] = i(292), r[n.TOP_RIGHT] = i(293), r[n.LEFT_BOTTOM] = r[n.BOTTOM_LEFT], r[n.LEFT_TOP] = r[n.TOP_LEFT], r[n.RIGHT_BOTTOM] = r[n.BOTTOM_RIGHT], r[n.RIGHT_TOP] = r[n.TOP_RIGHT];
            t.exports = function(t, e, i, n, s) {
                return r[i](t, e, n, s);
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(84), o = i(54), a = i(85);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) + i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(41), o = i(54), a = i(52);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) - i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(42), o = i(54), a = i(53);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) + i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(288), r = i(84), o = i(86);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), s(t, r(e) + i, o(e) + n), t;
            };
        },
        function(t, e, i) {
            var n = i(85), s = i(87);
            t.exports = function(t, e, i) {
                return n(t, e), s(t, i);
            };
        },
        function(t, e, i) {
            var s = i(86), r = i(41), o = i(87), a = i(52);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) - i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(86), r = i(42), o = i(87), a = i(53);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), a(t, r(e) + i), o(t, s(e) + n), t;
            };
        },
        function(t, e, i) {
            var s = i(84), r = i(43), o = i(85), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, s(e) + i), a(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(41), r = i(43), o = i(52), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, s(e) - i), a(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(42), r = i(43), o = i(53), a = i(51);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = 0), o(t, s(e) + i), a(t, r(e) - n), t;
            };
        },
        function(t, e, i) {
            var s = i(165), r = i(95), o = i(14), a = i(4);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new a);
                var n = r(e, 0, o.PI2);
                return s(t, n, i);
            };
        },
        function(t, e, i) {
            var o = i(296), a = i(165), h = i(95), l = i(14);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = []), !e && 0 < i && (e = o(t) / i);
                for(var s = 0; s < e; s++){
                    var r = h(s / e, 0, l.PI2);
                    n.push(a(t, r));
                }
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.PI * t.radius * 2;
            };
        },
        function(t, e, i) {
            var n = i(18), s = {
                _alpha: 1,
                clearAlpha: function() {
                    return this.setAlpha(1);
                },
                setAlpha: function(t) {
                    return void 0 === t && (t = 1), this.alpha = t, this;
                },
                alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(t) {
                        var e = n(t, 0, 1);
                        0 === (this._alpha = e) ? this.renderFlags &= -3 : this.renderFlags |= 2;
                    }
                }
            };
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(34), s = {
                _blendMode: n.NORMAL,
                blendMode: {
                    get: function() {
                        return this._blendMode;
                    },
                    set: function(t) {
                        "string" == typeof t && (t = n[t]), -1 <= (t |= 0) && (this._blendMode = t);
                    }
                },
                setBlendMode: function(t) {
                    return this.blendMode = t, this;
                }
            };
            t.exports = s;
        },
        function(t, e) {
            var i = {
                _depth: 0,
                depth: {
                    get: function() {
                        return this._depth;
                    },
                    set: function(t) {
                        this.displayList && this.displayList.queueDepthSort(), this._depth = t;
                    }
                },
                setDepth: function(t) {
                    return void 0 === t && (t = 0), this.depth = t, this;
                }
            };
            t.exports = i;
        },
        function(t, e, i) {
            var o = i(167), a = i(128);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = []), !e && 0 < i && (e = a(t) / i);
                for(var s = 0; s < e; s++){
                    var r = s / e;
                    n.push(o(t, r));
                }
                return n;
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e, i) {
                return void 0 === i && (i = new n), i.x = t.x1 + (t.x2 - t.x1) * e, i.y = t.y1 + (t.y2 - t.y1) * e, i;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = Math.cos(n), r = Math.sin(n), o = t.x - e, a = t.y - i;
                return t.x = o * s - a * r + e, t.y = o * r + a * s + i, t;
            };
        },
        function(t, e, i) {
            var n = i(304), s = i(305), r = {
                mask: null,
                setMask: function(t) {
                    return this.mask = t, this;
                },
                clearMask: function(t) {
                    return void 0 === t && (t = !1), t && this.mask && this.mask.destroy(), this.mask = null, this;
                },
                createBitmapMask: function(t) {
                    return void 0 === t && (this.texture || this.shader) && (t = this), new n(this.scene, t);
                },
                createGeometryMask: function(t) {
                    return void 0 === t && "Graphics" === this.type && (t = this), new s(this.scene, t);
                }
            };
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(22), r = i(88), o = new n({
                initialize: function(t, e) {
                    var i = t.sys.renderer;
                    this.renderer = i, this.bitmapMask = e, this.maskTexture = null, this.mainTexture = null, this.dirty = !0, this.mainFramebuffer = null, this.maskFramebuffer = null, this.invertAlpha = !1, this.isStencil = !1, this.createMask(), t.sys.game.events.on(s.CONTEXT_RESTORED, this.createMask, this), i.on(r.RESIZE, this.createMask, this);
                },
                createMask: function() {
                    var t, e, i, n, s, r, o = this.renderer;
                    o.gl && (this.mainTexture && this.clearMask(), t = o.width, e = o.height, i = 0 == (t & t - 1) && 0 == (e & e - 1), n = o.gl, s = i ? n.REPEAT : n.CLAMP_TO_EDGE, r = n.LINEAR, this.mainTexture = o.createTexture2D(0, r, r, s, s, n.RGBA, null, t, e), this.maskTexture = o.createTexture2D(0, r, r, s, s, n.RGBA, null, t, e), this.mainFramebuffer = o.createFramebuffer(t, e, this.mainTexture, !0), this.maskFramebuffer = o.createFramebuffer(t, e, this.maskTexture, !0));
                },
                clearMask: function() {
                    var t = this.renderer;
                    t.gl && this.mainTexture && (t.deleteTexture(this.mainTexture), t.deleteTexture(this.maskTexture), t.deleteFramebuffer(this.mainFramebuffer), t.deleteFramebuffer(this.maskFramebuffer), this.mainTexture = null, this.maskTexture = null, this.mainFramebuffer = null, this.maskFramebuffer = null);
                },
                setBitmap: function(t) {
                    this.bitmapMask = t;
                },
                preRenderWebGL: function(t, e, i) {
                    t.pipelines.BITMAPMASK_PIPELINE.beginMask(this, e, i);
                },
                postRenderWebGL: function(t, e) {
                    t.pipelines.BITMAPMASK_PIPELINE.endMask(this, e);
                },
                preRenderCanvas: function() {},
                postRenderCanvas: function() {},
                destroy: function() {
                    this.clearMask(), this.renderer.off(r.RESIZE, this.createMask, this), this.bitmapMask = null, this.prevFramebuffer = null, this.renderer = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e) {
                    this.geometryMask = e, this.invertAlpha = !1, this.isStencil = !0, this.level = 0;
                },
                setShape: function(t) {
                    return this.geometryMask = t, this;
                },
                setInvertAlpha: function(t) {
                    return void 0 === t && (t = !0), this.invertAlpha = t, this;
                },
                preRenderWebGL: function(t, e, i) {
                    var n = t.gl;
                    t.flush(), 0 === t.maskStack.length && (n.enable(n.STENCIL_TEST), n.clear(n.STENCIL_BUFFER_BIT), t.maskCount = 0), t.currentCameraMask.mask !== this && (t.currentMask.mask = this), t.maskStack.push({
                        mask: this,
                        camera: i
                    }), this.applyStencil(t, i, !0), t.maskCount++;
                },
                applyStencil: function(t, e, i) {
                    var n = t.gl, s = this.geometryMask, r = t.maskCount;
                    n.colorMask(!1, !1, !1, !1), i ? (n.stencilFunc(n.EQUAL, r, 255), n.stencilOp(n.KEEP, n.KEEP, n.INCR)) : (n.stencilFunc(n.EQUAL, r + 1, 255), n.stencilOp(n.KEEP, n.KEEP, n.DECR)), s.renderWebGL(t, s, e), t.flush(), n.colorMask(!0, !0, !0, !0), n.stencilOp(n.KEEP, n.KEEP, n.KEEP), i ? this.invertAlpha ? n.stencilFunc(n.NOTEQUAL, r + 1, 255) : n.stencilFunc(n.EQUAL, r + 1, 255) : this.invertAlpha ? n.stencilFunc(n.NOTEQUAL, r, 255) : n.stencilFunc(n.EQUAL, r, 255);
                },
                postRenderWebGL: function(t) {
                    var e = t.gl;
                    t.maskStack.pop(), t.maskCount--, t.flush();
                    var i, n = t.currentMask;
                    0 === t.maskStack.length ? (n.mask = null, e.disable(e.STENCIL_TEST)) : ((i = t.maskStack[t.maskStack.length - 1]).mask.applyStencil(t, i.camera, !1), t.currentCameraMask.mask !== i.mask ? (n.mask = i.mask, n.camera = i.camera) : n.mask = null);
                },
                preRenderCanvas: function(t, e, i) {
                    var n = this.geometryMask;
                    t.currentContext.save(), n.renderCanvas(t, n, i, null, null, !0), t.currentContext.clip();
                },
                postRenderCanvas: function(t) {
                    t.currentContext.restore();
                },
                destroy: function() {
                    this.geometryMask = null;
                }
            });
            t.exports = n;
        },
        function(t, e) {
            var i = {
                scrollFactorX: 1,
                scrollFactorY: 1,
                setScrollFactor: function(t, e) {
                    return void 0 === e && (e = t), this.scrollFactorX = t, this.scrollFactorY = e, this;
                }
            };
            t.exports = i;
        },
        function(t, e, i) {
            var n = i(14), s = i(25), h = i(174), r = i(265), o = i(266), l = i(3), a = {
                _scaleX: 1,
                _scaleY: 1,
                _rotation: 0,
                x: 0,
                y: 0,
                z: 0,
                w: 0,
                scale: {
                    get: function() {
                        return (this._scaleX + this._scaleY) / 2;
                    },
                    set: function(t) {
                        this._scaleX = t, 0 === (this._scaleY = t) ? this.renderFlags &= -5 : this.renderFlags |= 4;
                    }
                },
                scaleX: {
                    get: function() {
                        return this._scaleX;
                    },
                    set: function(t) {
                        0 === (this._scaleX = t) ? this.renderFlags &= -5 : this.renderFlags |= 4;
                    }
                },
                scaleY: {
                    get: function() {
                        return this._scaleY;
                    },
                    set: function(t) {
                        0 === (this._scaleY = t) ? this.renderFlags &= -5 : this.renderFlags |= 4;
                    }
                },
                angle: {
                    get: function() {
                        return o(this._rotation * n.RAD_TO_DEG);
                    },
                    set: function(t) {
                        this.rotation = o(t) * n.DEG_TO_RAD;
                    }
                },
                rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(t) {
                        this._rotation = r(t);
                    }
                },
                setPosition: function(t, e, i, n) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), void 0 === i && (i = 0), void 0 === n && (n = 0), this.x = t, this.y = e, this.z = i, this.w = n, this;
                },
                copyPosition: function(t) {
                    return void 0 !== t.x && (this.x = t.x), void 0 !== t.y && (this.y = t.y), void 0 !== t.z && (this.z = t.z), void 0 !== t.w && (this.w = t.w), this;
                },
                setRandomPosition: function(t, e, i, n) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.scene.sys.scale.width), void 0 === n && (n = this.scene.sys.scale.height), this.x = t + Math.random() * i, this.y = e + Math.random() * n, this;
                },
                setRotation: function(t) {
                    return void 0 === t && (t = 0), this.rotation = t, this;
                },
                setAngle: function(t) {
                    return void 0 === t && (t = 0), this.angle = t, this;
                },
                setScale: function(t, e) {
                    return void 0 === t && (t = 1), void 0 === e && (e = t), this.scaleX = t, this.scaleY = e, this;
                },
                setX: function(t) {
                    return void 0 === t && (t = 0), this.x = t, this;
                },
                setY: function(t) {
                    return void 0 === t && (t = 0), this.y = t, this;
                },
                setZ: function(t) {
                    return void 0 === t && (t = 0), this.z = t, this;
                },
                setW: function(t) {
                    return void 0 === t && (t = 0), this.w = t, this;
                },
                getLocalTransformMatrix: function(t) {
                    return void 0 === t && (t = new s), t.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                },
                getWorldTransformMatrix: function(t, e) {
                    void 0 === t && (t = new s), void 0 === e && (e = new s);
                    var i = this.parentContainer;
                    if (!i) return this.getLocalTransformMatrix(t);
                    for(t.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY); i;)e.applyITRS(i.x, i.y, i._rotation, i._scaleX, i._scaleY), e.multiply(t, t), i = i.parentContainer;
                    return t;
                },
                getLocalPoint: function(t, e, i, n) {
                    i = i || new l;
                    var s = (n = n || this.scene.sys.cameras.main).scrollX, r = n.scrollY, o = t + s * this.scrollFactorX - s, a = e + r * this.scrollFactorY - r;
                    return this.parentContainer ? this.getWorldTransformMatrix().applyInverse(o, a, i) : h(o, a, this.x, this.y, this.rotation, this.scaleX, this.scaleY, i), this._originComponent && (i.x += this._displayOriginX, i.y += this._displayOriginY), i;
                },
                getParentRotation: function() {
                    for(var t = 0, e = this.parentContainer; e;)t += e.rotation, e = e.parentContainer;
                    return t;
                }
            };
            t.exports = a;
        },
        function(t, e) {
            var i = {
                _visible: !0,
                visible: {
                    get: function() {
                        return this._visible;
                    },
                    set: function(t) {
                        t ? (this._visible = !0, this.renderFlags |= 1) : (this._visible = !1, this.renderFlags &= -2);
                    }
                },
                setVisible: function(t) {
                    return this.visible = t, this;
                }
            };
            t.exports = i;
        },
        function(t, e, i) {
            t.exports = {
                CHANGE_DATA: i(636),
                CHANGE_DATA_KEY: i(637),
                DESTROY: i(638),
                REMOVE_DATA: i(639),
                SET_DATA: i(640)
            };
        },
        function(t, e, i) {
            var h = i(128), l = i(4);
            t.exports = function(t, e, i, n) {
                if (void 0 === n && (n = []), !e && !i) return n;
                e ? i = Math.round(h(t) / e) : e = h(t) / i;
                for(var s = t.x, r = t.y, o = 0, a = 0; a < i; a++)switch(n.push(new l(s, r)), o){
                    case 0:
                        (s += e) >= t.right && (o = 1, r += s - t.right, s = t.right);
                        break;
                    case 1:
                        (r += e) >= t.bottom && (o = 2, s -= r - t.bottom, r = t.bottom);
                        break;
                    case 2:
                        (s -= e) <= t.left && (o = 3, r -= t.left - s, s = t.left);
                        break;
                    case 3:
                        (r -= e) <= t.top && (o = 0, r = t.top);
                }
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === e && (e = 1), void 0 === i && (i = []);
                var n = Math.round(t.x1), s = Math.round(t.y1), r = Math.round(t.x2), o = Math.round(t.y2), a = Math.abs(r - n), h = Math.abs(o - s), l = n < r ? 1 : -1, u = s < o ? 1 : -1, c = a - h;
                i.push({
                    x: n,
                    y: s
                });
                for(var d = 1; n !== r || s !== o;){
                    var f = c << 1;
                    -h < f && (c -= h, n += l), f < a && (c += a, s += u), d % e == 0 && i.push({
                        x: n,
                        y: s
                    }), d++;
                }
                return i;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (!e.length) return NaN;
                if (1 === e.length) return e[0];
                var n, s, r = 1;
                if (i) {
                    if (t < e[0][i]) return e[0];
                    for(; e[r][i] < t;)r++;
                } else for(; e[r] < t;)r++;
                return r > e.length && (r = e.length), i ? (n = e[r - 1][i], (s = e[r][i]) - t <= t - n ? e[r] : e[r - 1]) : (n = e[r - 1], (s = e[r]) - t <= t - n ? s : n);
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n, s) {
                    void 0 === s && (s = !1), this.textureKey = t, this.textureFrame = e, this.index = i, this.frame = n, this.isFirst = !1, this.isLast = !1, this.prevFrame = null, this.nextFrame = null, this.duration = 0, this.progress = 0, this.isKeyFrame = s;
                },
                toJSON: function() {
                    return {
                        key: this.textureKey,
                        frame: this.textureFrame,
                        duration: this.duration,
                        keyframe: this.isKeyFrame
                    };
                },
                destroy: function() {
                    this.frame = void 0;
                }
            });
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                var i = /\D/g;
                return t.sort(function(t, e) {
                    return parseInt(t.replace(i, ""), 10) - parseInt(e.replace(i, ""), 10);
                }), t;
            };
        },
        function(t, e, i) {
            var n = i(182), s = i(0), r = i(99), o = i(9), a = i(130), h = i(22), T = i(2), d = i(6), f = i(183), p = i(316), l = new s({
                Extends: o,
                initialize: function(t) {
                    o.call(this), this.game = t, this.textureManager = null, this.globalTimeScale = 1, this.anims = new r, this.mixes = new r, this.paused = !1, this.name = "AnimationManager", t.events.once(h.BOOT, this.boot, this);
                },
                boot: function() {
                    this.textureManager = this.game.textures, this.game.events.once(h.DESTROY, this.destroy, this);
                },
                addMix: function(t, e, i) {
                    var n, s = this.anims, r = this.mixes, o = "string" == typeof t ? t : t.key, a = "string" == typeof e ? e : e.key;
                    return s.has(o) && s.has(a) && ((n = (n = r.get(o)) || {})[a] = i, r.set(o, n)), this;
                },
                removeMix: function(t, e) {
                    var i, n = this.mixes, s = "string" == typeof t ? t : t.key, r = n.get(s);
                    return r && (e ? (i = "string" == typeof e ? e : e.key, r.hasOwnProperty(i) && delete r[i]) : e || n.delete(s)), this;
                },
                getMix: function(t, e) {
                    var i = this.mixes, n = "string" == typeof t ? t : t.key, s = "string" == typeof e ? e : e.key, r = i.get(n);
                    return r && r.hasOwnProperty(s) ? r[s] : 0;
                },
                add: function(t, e) {
                    return this.anims.has(t) ? console.warn("Animation key exists: " + t) : (e.key = t, this.anims.set(t, e), this.emit(a.ADD_ANIMATION, t, e)), this;
                },
                exists: function(t) {
                    return this.anims.has(t);
                },
                createFromAseprite: function(g, v) {
                    var m = [], t = this.game.cache.json.get(g);
                    if (!t) return m;
                    var y = this, e = d(t, "meta", null), x = d(t, "frames", null);
                    return e && x && d(e, "frameTags", []).forEach(function(t) {
                        var e = [], i = T(t, "name", null), n = T(t, "from", 0), s = T(t, "to", 0), r = T(t, "direction", "forward");
                        if (i && (!v || v && -1 < v.indexOf(i))) {
                            for(var o = [], a = Number.MAX_SAFE_INTEGER, h = n; h <= s; h++){
                                var l, u = h.toString(), c = x[u];
                                c && ((l = T(c, "duration", Number.MAX_SAFE_INTEGER)) < a && (a = l), o.push({
                                    frame: u,
                                    duration: l
                                }));
                            }
                            o.forEach(function(t) {
                                e.push({
                                    key: g,
                                    frame: t.frame,
                                    duration: a - t.duration
                                });
                            });
                            var d = a * e.length;
                            "reverse" === r && (e = e.reverse());
                            var f = {
                                key: i,
                                frames: e,
                                duration: d,
                                yoyo: "pingpong" === r
                            }, p = y.create(f);
                            p && m.push(p);
                        }
                    }), m;
                },
                create: function(t) {
                    var e = t.key, i = !1;
                    return e && ((i = this.get(e)) || (i = new n(this, e, t), this.anims.set(e, i), this.emit(a.ADD_ANIMATION, e, i))), i;
                },
                fromJSON: function(t, e) {
                    void 0 === e && (e = !1), e && this.anims.clear(), "string" == typeof t && (t = JSON.parse(t));
                    var i = [];
                    if (t.hasOwnProperty("anims") && Array.isArray(t.anims)) {
                        for(var n = 0; n < t.anims.length; n++)i.push(this.create(t.anims[n]));
                        t.hasOwnProperty("globalTimeScale") && (this.globalTimeScale = t.globalTimeScale);
                    } else t.hasOwnProperty("key") && "frame" === t.type && i.push(this.create(t));
                    return i;
                },
                generateFrameNames: function(t, e) {
                    var i, n = d(e, "prefix", ""), s = d(e, "start", 0), r = d(e, "end", 0), o = d(e, "suffix", ""), a = d(e, "zeroPad", 0), h = d(e, "outputArray", []), l = d(e, "frames", !1), u = this.textureManager.get(t);
                    if (!u) return h;
                    if (e) for(l = l || p(s, r), i = 0; i < l.length; i++){
                        var c = n + f(l[i], a, "0", 1) + o;
                        u.has(c) ? h.push({
                            key: t,
                            frame: c
                        }) : console.warn("generateFrameNames: Frame missing: " + c + " from texture: " + t);
                    }
                    else for(l = u.getFrameNames(), i = 0; i < l.length; i++)h.push({
                        key: t,
                        frame: l[i]
                    });
                    return h;
                },
                generateFrameNumbers: function(t, e) {
                    var i = d(e, "start", 0), n = d(e, "end", -1), s = d(e, "first", !1), r = d(e, "outputArray", []), o = d(e, "frames", !1), a = this.textureManager.get(t);
                    if (!a) return r;
                    s && a.has(s) && r.push({
                        key: t,
                        frame: s
                    }), o || (-1 === n && (n = a.frameTotal - 2), o = p(i, n));
                    for(var h = 0; h < o.length; h++)a.has(o[h]) ? r.push({
                        key: t,
                        frame: o[h]
                    }) : console.warn("generateFrameNumbers: Frame " + h + " missing from texture: " + t);
                    return r;
                },
                get: function(t) {
                    return this.anims.get(t);
                },
                pauseAll: function() {
                    return this.paused || (this.paused = !0, this.emit(a.PAUSE_ALL)), this;
                },
                play: function(t, e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for(var i = 0; i < e.length; i++)e[i].anims.play(t);
                    return this;
                },
                staggerPlay: function(t, e, i, n) {
                    void 0 === i && (i = 0), void 0 === n && (n = !0), Array.isArray(e) || (e = [
                        e
                    ]);
                    var s = e.length;
                    n || s--;
                    for(var r = 0; r < e.length; r++){
                        var o = i < 0 ? Math.abs(i) * (s - r) : i * r;
                        e[r].anims.playAfterDelay(t, o);
                    }
                    return this;
                },
                remove: function(t) {
                    var e = this.get(t);
                    return e && (this.emit(a.REMOVE_ANIMATION, t, e), this.anims.delete(t), this.removeMix(t)), e;
                },
                resumeAll: function() {
                    return this.paused && (this.paused = !1, this.emit(a.RESUME_ALL)), this;
                },
                toJSON: function(t) {
                    var i = {
                        anims: [],
                        globalTimeScale: this.globalTimeScale
                    };
                    return void 0 !== t && "" !== t ? i.anims.push(this.anims.get(t).toJSON()) : this.anims.each(function(t, e) {
                        i.anims.push(e.toJSON());
                    }), i;
                },
                destroy: function() {
                    this.anims.clear(), this.mixes.clear(), this.textureManager = null, this.game = null;
                }
            });
            t.exports = l;
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s, r = [], o = !1;
                if ((i || n) && (o = !0, i = i || "", n = n || ""), e < t) for(s = t; e <= s; s--)o ? r.push(i + s.toString() + n) : r.push(s);
                else for(s = t; s <= e; s++)o ? r.push(i + s.toString() + n) : r.push(s);
                return r;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(99), r = i(9), o = i(318), a = new n({
                initialize: function() {
                    this.entries = new s, this.events = new r;
                },
                add: function(t, e) {
                    return this.entries.set(t, e), this.events.emit(o.ADD, this, t, e), this;
                },
                has: function(t) {
                    return this.entries.has(t);
                },
                exists: function(t) {
                    return this.entries.has(t);
                },
                get: function(t) {
                    return this.entries.get(t);
                },
                remove: function(t) {
                    var e = this.get(t);
                    return e && (this.entries.delete(t), this.events.emit(o.REMOVE, this, t, e.data)), this;
                },
                getKeys: function() {
                    return this.entries.keys();
                },
                destroy: function() {
                    this.entries.clear(), this.events.removeAllListeners(), this.entries = null, this.events = null;
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            t.exports = {
                ADD: i(712),
                REMOVE: i(713)
            };
        },
        function(t, e, i) {
            var n = i(317), s = i(0), r = i(22), o = new s({
                initialize: function(t) {
                    this.game = t, this.binary = new n, this.bitmapFont = new n, this.json = new n, this.physics = new n, this.shader = new n, this.audio = new n, this.video = new n, this.text = new n, this.html = new n, this.obj = new n, this.tilemap = new n, this.xml = new n, this.custom = {}, this.game.events.once(r.DESTROY, this.destroy, this);
                },
                addCustom: function(t) {
                    return this.custom.hasOwnProperty(t) || (this.custom[t] = new n), this.custom[t];
                },
                destroy: function() {
                    for(var t = [
                        "binary",
                        "bitmapFont",
                        "json",
                        "physics",
                        "shader",
                        "audio",
                        "video",
                        "text",
                        "html",
                        "obj",
                        "tilemap",
                        "xml"
                    ], e = 0; e < t.length; e++)this[t[e]].destroy(), this[t[e]] = null;
                    for(var i in this.custom)this.custom[i].destroy();
                    this.custom = null, this.game = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var s = i(131), w = i(187), u = i(18), n = i(0), r = i(11), o = i(327), b = i(36), E = i(133), a = i(10), h = i(3), l = new n({
                Extends: s,
                Mixins: [
                    r.Flip,
                    r.Tint,
                    r.Pipeline
                ],
                initialize: function(t, e, i, n) {
                    s.call(this, t, e, i, n), this.postPipelines = [], this.pipelineData = {}, this.inputEnabled = !0, this.fadeEffect = new o.Fade(this), this.flashEffect = new o.Flash(this), this.shakeEffect = new o.Shake(this), this.panEffect = new o.Pan(this), this.rotateToEffect = new o.RotateTo(this), this.zoomEffect = new o.Zoom(this), this.lerp = new h(1, 1), this.followOffset = new h, this.deadzone = null, this._follow = null;
                },
                setDeadzone: function(t, e) {
                    var i, n, s, r;
                    return void 0 === t ? this.deadzone = null : (this.deadzone ? (this.deadzone.width = t, this.deadzone.height = e) : this.deadzone = new a(0, 0, t, e), this._follow && (i = this.width / 2, n = this.height / 2, s = this._follow.x - this.followOffset.x, r = this._follow.y - this.followOffset.y, this.midPoint.set(s, r), this.scrollX = s - i, this.scrollY = r - n), w(this.deadzone, this.midPoint.x, this.midPoint.y)), this;
                },
                fadeIn: function(t, e, i, n, s, r) {
                    return this.fadeEffect.start(!1, t, e, i, n, !0, s, r);
                },
                fadeOut: function(t, e, i, n, s, r) {
                    return this.fadeEffect.start(!0, t, e, i, n, !0, s, r);
                },
                fadeFrom: function(t, e, i, n, s, r, o) {
                    return this.fadeEffect.start(!1, t, e, i, n, s, r, o);
                },
                fade: function(t, e, i, n, s, r, o) {
                    return this.fadeEffect.start(!0, t, e, i, n, s, r, o);
                },
                flash: function(t, e, i, n, s, r, o) {
                    return this.flashEffect.start(t, e, i, n, s, r, o);
                },
                shake: function(t, e, i, n, s) {
                    return this.shakeEffect.start(t, e, i, n, s);
                },
                pan: function(t, e, i, n, s, r, o) {
                    return this.panEffect.start(t, e, i, n, s, r, o);
                },
                rotateTo: function(t, e, i, n, s, r, o) {
                    return this.rotateToEffect.start(t, e, i, n, s, r, o);
                },
                zoomTo: function(t, e, i, n, s, r) {
                    return this.zoomEffect.start(t, e, i, n, s, r);
                },
                preRender: function() {
                    this.renderList.length = 0;
                    var t = this.width, e = this.height, i = .5 * t, n = .5 * e, s = this.zoom, r = this.matrix, o = t * this.originX, a = e * this.originY, h = this._follow, l = this.deadzone, u = this.scrollX, c = this.scrollY;
                    l && w(l, this.midPoint.x, this.midPoint.y);
                    var d, f, p = !1;
                    h && !this.panEffect.isRunning && (d = h.x - this.followOffset.x, f = h.y - this.followOffset.y, l ? (d < l.x ? u = E(u, u - (l.x - d), this.lerp.x) : d > l.right && (u = E(u, u + (d - l.right), this.lerp.x)), f < l.y ? c = E(c, c - (l.y - f), this.lerp.y) : f > l.bottom && (c = E(c, c + (f - l.bottom), this.lerp.y))) : (u = E(u, d - o, this.lerp.x), c = E(c, f - a, this.lerp.y)), p = !0), this.useBounds && (u = this.clampX(u), c = this.clampY(c)), this.roundPixels && (o = Math.round(o), a = Math.round(a), u = Math.round(u), c = Math.round(c));
                    var g = (this.scrollX = u) + i, v = (this.scrollY = c) + n;
                    this.midPoint.set(g, v);
                    var m = t / s, y = e / s, x = g - m / 2, T = v - y / 2;
                    this.roundPixels && (x = Math.round(x), T = Math.round(T)), this.worldView.setTo(x, T, m, y), r.applyITRS(this.x + o, this.y + a, this.rotation, s, s), r.translate(-o, -a), this.shakeEffect.preRender(), p && this.emit(b.FOLLOW_UPDATE, this, h);
                },
                setLerp: function(t, e) {
                    return void 0 === t && (t = 1), void 0 === e && (e = t), this.lerp.set(t, e), this;
                },
                setFollowOffset: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), this.followOffset.set(t, e), this;
                },
                startFollow: function(t, e, i, n, s, r) {
                    void 0 === e && (e = !1), void 0 === i && (i = 1), void 0 === n && (n = i), void 0 === s && (s = 0), void 0 === r && (r = s), this._follow = t, this.roundPixels = e, i = u(i, 0, 1), n = u(n, 0, 1), this.lerp.set(i, n), this.followOffset.set(s, r);
                    var o = this.width / 2, a = this.height / 2, h = t.x - s, l = t.y - r;
                    return this.midPoint.set(h, l), this.scrollX = h - o, this.scrollY = l - a, this.useBounds && (this.scrollX = this.clampX(this.scrollX), this.scrollY = this.clampY(this.scrollY)), this;
                },
                stopFollow: function() {
                    return this._follow = null, this;
                },
                resetFX: function() {
                    return this.rotateToEffect.reset(), this.panEffect.reset(), this.shakeEffect.reset(), this.flashEffect.reset(), this.fadeEffect.reset(), this;
                },
                update: function(t, e) {
                    this.visible && (this.rotateToEffect.update(t, e), this.panEffect.update(t, e), this.zoomEffect.update(t, e), this.shakeEffect.update(t, e), this.flashEffect.update(t, e), this.fadeEffect.update(t, e));
                },
                destroy: function() {
                    this.resetFX(), s.prototype.destroy.call(this), this._follow = null, this.deadzone = null;
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            var o = i(37);
            t.exports = function(t) {
                var e = new o;
                t = t.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i, function(t, e, i, n) {
                    return e + e + i + i + n + n;
                });
                var i, n, s, r = /^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
                return r && (i = parseInt(r[1], 16), n = parseInt(r[2], 16), s = parseInt(r[3], 16), e.setTo(i, n, s)), e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return n << 24 | t << 16 | e << 8 | i;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = {
                    h: 0,
                    s: 0,
                    v: 0
                }), t /= 255, e /= 255, i /= 255;
                var s = Math.min(t, e, i), r = Math.max(t, e, i), o = r - s, a = 0, h = 0 === r ? 0 : o / r, l = r;
                return r !== s && (r === t ? a = (e - i) / o + (e < i ? 6 : 0) : r === e ? a = (i - t) / o + 2 : r === i && (a = (t - e) / o + 4), a /= 6), n.hasOwnProperty("_h") ? (n._h = a, n._s = h, n._v = l) : (n.h = a, n.s = h, n.v = l), n;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 16777215 < t ? {
                    a: t >>> 24,
                    r: t >> 16 & 255,
                    g: t >> 8 & 255,
                    b: 255 & t
                } : {
                    a: 255,
                    r: t >> 16 & 255,
                    g: t >> 8 & 255,
                    b: 255 & t
                };
            };
        },
        function(t, e, i) {
            var n = i(37);
            t.exports = function(t) {
                return new n(t.r, t.g, t.b, t.a);
            };
        },
        function(t, e, i) {
            var a = i(37);
            t.exports = function(t) {
                var e, i, n, s, r = new a, o = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(t.toLowerCase());
                return o && (e = parseInt(o[1], 10), i = parseInt(o[2], 10), n = parseInt(o[3], 10), s = void 0 !== o[4] ? parseFloat(o[4]) : 1, r.setTo(e, i, n, 255 * s)), r;
            };
        },
        function(t, e, i) {
            t.exports = {
                Fade: i(737),
                Flash: i(738),
                Pan: i(739),
                Shake: i(772),
                RotateTo: i(773),
                Zoom: i(774)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(740),
                Out: i(741),
                InOut: i(742)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(743),
                Out: i(744),
                InOut: i(745)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(746),
                Out: i(747),
                InOut: i(748)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(749),
                Out: i(750),
                InOut: i(751)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(752),
                Out: i(753),
                InOut: i(754)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(755),
                Out: i(756),
                InOut: i(757)
            };
        },
        function(t, e, i) {
            t.exports = i(758);
        },
        function(t, e, i) {
            t.exports = {
                In: i(759),
                Out: i(760),
                InOut: i(761)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(762),
                Out: i(763),
                InOut: i(764)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(765),
                Out: i(766),
                InOut: i(767)
            };
        },
        function(t, e, i) {
            t.exports = {
                In: i(768),
                Out: i(769),
                InOut: i(770)
            };
        },
        function(t, e, i) {
            t.exports = i(771);
        },
        function(t, e, i) {
            var n = i(0), h = i(32), l = i(341), u = i(2), c = i(6), d = i(7), f = i(190), p = i(1), g = i(194), v = i(184), s = new n({
                initialize: function(t) {
                    void 0 === t && (t = {});
                    this.width = c(t, "width", 1024), this.height = c(t, "height", 768), this.zoom = c(t, "zoom", 1), this.parent = c(t, "parent", void 0), this.scaleMode = c(t, "scaleMode", 0), this.expandParent = c(t, "expandParent", !0), this.autoRound = c(t, "autoRound", !1), this.autoCenter = c(t, "autoCenter", 0), this.resizeInterval = c(t, "resizeInterval", 500), this.fullscreenTarget = c(t, "fullscreenTarget", null), this.minWidth = c(t, "minWidth", 0), this.maxWidth = c(t, "maxWidth", 0), this.minHeight = c(t, "minHeight", 0), this.maxHeight = c(t, "maxHeight", 0);
                    var e = c(t, "scale", null);
                    e && (this.width = c(e, "width", this.width), this.height = c(e, "height", this.height), this.zoom = c(e, "zoom", this.zoom), this.parent = c(e, "parent", this.parent), this.scaleMode = c(e, "mode", this.scaleMode), this.expandParent = c(e, "expandParent", this.expandParent), this.autoRound = c(e, "autoRound", this.autoRound), this.autoCenter = c(e, "autoCenter", this.autoCenter), this.resizeInterval = c(e, "resizeInterval", this.resizeInterval), this.fullscreenTarget = c(e, "fullscreenTarget", this.fullscreenTarget), this.minWidth = c(e, "min.width", this.minWidth), this.maxWidth = c(e, "max.width", this.maxWidth), this.minHeight = c(e, "min.height", this.minHeight), this.maxHeight = c(e, "max.height", this.maxHeight)), this.renderType = c(t, "type", h.AUTO), this.canvas = c(t, "canvas", null), this.context = c(t, "context", null), this.canvasStyle = c(t, "canvasStyle", null), this.customEnvironment = c(t, "customEnvironment", !1), this.sceneConfig = c(t, "scene", null), this.seed = c(t, "seed", [
                        (Date.now() * Math.random()).toString()
                    ]), f.RND = new f.RandomDataGenerator(this.seed), this.gameTitle = c(t, "title", ""), this.gameURL = c(t, "url", "https://phaser.io"), this.gameVersion = c(t, "version", ""), this.autoFocus = c(t, "autoFocus", !0), this.domCreateContainer = c(t, "dom.createContainer", !1), this.domBehindCanvas = c(t, "dom.behindCanvas", !1), this.inputKeyboard = c(t, "input.keyboard", !0), this.inputKeyboardEventTarget = c(t, "input.keyboard.target", window), this.inputKeyboardCapture = c(t, "input.keyboard.capture", []), this.inputMouse = c(t, "input.mouse", !0), this.inputMouseEventTarget = c(t, "input.mouse.target", null), this.inputMousePreventDefaultDown = c(t, "input.mouse.preventDefaultDown", !0), this.inputMousePreventDefaultUp = c(t, "input.mouse.preventDefaultUp", !0), this.inputMousePreventDefaultMove = c(t, "input.mouse.preventDefaultMove", !0), this.inputMousePreventDefaultWheel = c(t, "input.mouse.preventDefaultWheel", !0), this.inputTouch = c(t, "input.touch", l.input.touch), this.inputTouchEventTarget = c(t, "input.touch.target", null), this.inputTouchCapture = c(t, "input.touch.capture", !0), this.inputActivePointers = c(t, "input.activePointers", 1), this.inputSmoothFactor = c(t, "input.smoothFactor", 0), this.inputWindowEvents = c(t, "input.windowEvents", !0), this.inputGamepad = c(t, "input.gamepad", !1), this.inputGamepadEventTarget = c(t, "input.gamepad.target", window), this.disableContextMenu = c(t, "disableContextMenu", !1), this.audio = c(t, "audio", {}), this.hideBanner = !1 === c(t, "banner", null), this.hidePhaser = c(t, "banner.hidePhaser", !1), this.bannerTextColor = c(t, "banner.text", "#ffffff"), this.bannerBackgroundColor = c(t, "banner.background", [
                        "#ff0000",
                        "#ffff00",
                        "#00ff00",
                        "#00ffff",
                        "#000000"
                    ]), "" === this.gameTitle && this.hidePhaser && (this.hideBanner = !0), this.fps = c(t, "fps", null);
                    var i = c(t, "render", t);
                    this.pipeline = c(i, "pipeline", null), this.antialias = c(i, "antialias", !0), this.antialiasGL = c(i, "antialiasGL", !0), this.mipmapFilter = c(i, "mipmapFilter", "LINEAR"), this.desynchronized = c(i, "desynchronized", !1), this.roundPixels = c(i, "roundPixels", !1), this.pixelArt = c(i, "pixelArt", 1 !== this.zoom), this.pixelArt && (this.antialias = !1, this.antialiasGL = !1, this.roundPixels = !0), this.transparent = c(i, "transparent", !1), this.clearBeforeRender = c(i, "clearBeforeRender", !0), this.premultipliedAlpha = c(i, "premultipliedAlpha", !0), this.failIfMajorPerformanceCaveat = c(i, "failIfMajorPerformanceCaveat", !1), this.powerPreference = c(i, "powerPreference", "default"), this.batchSize = c(i, "batchSize", 4096), this.maxTextures = c(i, "maxTextures", -1), this.maxLights = c(i, "maxLights", 10);
                    var n = c(t, "backgroundColor", 0);
                    this.backgroundColor = v(n), this.transparent && (this.backgroundColor = v(0), this.backgroundColor.alpha = 0), this.preBoot = c(t, "callbacks.preBoot", p), this.postBoot = c(t, "callbacks.postBoot", p), this.physics = c(t, "physics", {}), this.defaultPhysicsSystem = c(this.physics, "default", !1), this.loaderBaseURL = c(t, "loader.baseURL", ""), this.loaderPath = c(t, "loader.path", "");
                    var s = l.os.android ? 6 : 32;
                    this.loaderMaxParallelDownloads = c(t, "loader.maxParallelDownloads", s), this.loaderCrossOrigin = c(t, "loader.crossOrigin", void 0), this.loaderResponseType = c(t, "loader.responseType", ""), this.loaderAsync = c(t, "loader.async", !0), this.loaderUser = c(t, "loader.user", ""), this.loaderPassword = c(t, "loader.password", ""), this.loaderTimeout = c(t, "loader.timeout", 0), this.loaderWithCredentials = c(t, "loader.withCredentials", !1), this.installGlobalPlugins = [], this.installScenePlugins = [];
                    var r = c(t, "plugins", null), o = g.DefaultScene;
                    r && (Array.isArray(r) ? this.defaultPlugins = r : d(r) && (this.installGlobalPlugins = u(r, "global", []), this.installScenePlugins = u(r, "scene", []), Array.isArray(r.default) ? o = r.default : Array.isArray(r.defaultMerge) && (o = o.concat(r.defaultMerge)))), this.defaultPlugins = o;
                    var a = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAg";
                    this.defaultImage = c(t, "images.default", a + "AQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg=="), this.missingImage = c(t, "images.missing", a + "CAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg=="), this.whiteImage = c(t, "images.white", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABdJREFUeNpi/P//PwMMMDEgAdwcgAADAJZuAwXJYZOzAAAAAElFTkSuQmCC"), window && (window.FORCE_WEBGL ? this.renderType = h.WEBGL : window.FORCE_CANVAS && (this.renderType = h.CANVAS));
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            t.exports = {
                os: i(102),
                browser: i(134),
                features: i(188),
                input: i(805),
                audio: i(806),
                video: i(807),
                fullscreen: i(808),
                canvasFeatures: i(342)
            };
        },
        function(t, e, i) {
            var n, s, r, o = i(31), a = {
                supportInverseAlpha: !1,
                supportNewBlendModes: !1
            };
            t.exports = (void 0 !== document && (a.supportNewBlendModes = (n = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/", s = "AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==", (r = new Image).onload = function() {
                var i = new Image;
                i.onload = function() {
                    var t = o.create(i, 6, 1).getContext("2d");
                    if (t.globalCompositeOperation = "multiply", t.drawImage(r, 0, 0), t.drawImage(i, 2, 0), !t.getImageData(2, 0, 1, 1)) return !1;
                    var e = t.getImageData(2, 0, 1, 1).data;
                    o.remove(i), a.supportNewBlendModes = 255 === e[0] && 0 === e[1] && 0 === e[2];
                }, i.src = n + "/wCKxvRF" + s;
            }, r.src = n + "AP804Oa6" + s, !1), a.supportInverseAlpha = function() {
                var t = o.create(this, 2, 1).getContext("2d");
                t.fillStyle = "rgba(10, 20, 30, 0.5)", t.fillRect(0, 0, 1, 1);
                var e = t.getImageData(0, 0, 1, 1);
                if (null === e) return !1;
                t.putImageData(e, 1, 0);
                var i = t.getImageData(1, 0, 1, 1);
                return i.data[0] === e.data[0] && i.data[1] === e.data[1] && i.data[2] === e.data[2] && i.data[3] === e.data[3];
            }()), a);
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return Math.atan2(n - e, i - t);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return Math.atan2(e.y - t.y, e.x - t.x);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 <= (t %= 2 * Math.PI) ? t : t + 2 * Math.PI;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.x - e.x, n = t.y - e.y;
                return Math.sqrt(i * i + n * n);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = t - i, r = e - n;
                return s * s + r * r;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return void 0 === i && (i = 1e-4), e - i < t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return void 0 === i && (i = 1e-4), t < e + i;
            };
        },
        function(t, e, i) {
            var n = i(351);
            t.exports = function(t, e) {
                return n(t) / n(e) / n(t - e);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if (0 === t) return 1;
                for(var e = t; --t;)e *= t;
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                var r, o, a, h, l;
                return (l = 1 - t) * l * l * e + 3 * (h = 1 - (a = t)) * h * a * i + 3 * (1 - (o = t)) * o * o * n + (r = t) * r * r * s;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s, r, o;
                return (o = 1 - t) * o * e + 2 * (1 - (r = t)) * r * i + (s = t) * s * n;
            };
        },
        function(t, e, i) {
            var n = i(181);
            t.exports = function(t, e, i) {
                return e + (i - e) * n(t, 0, 1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = Math.log(t) / .6931471805599453;
                return 1 << Math.ceil(e);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.x, n = t.y;
                return t.x = i * Math.cos(e) - n * Math.sin(e), t.y = i * Math.sin(e) + n * Math.cos(e), t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 < t ? Math.ceil(t) : Math.floor(t);
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t) {
                    this.val = new Float32Array(9), t ? this.copy(t) : this.identity();
                },
                clone: function() {
                    return new n(this);
                },
                set: function(t) {
                    return this.copy(t);
                },
                copy: function(t) {
                    var e = this.val, i = t.val;
                    return e[0] = i[0], e[1] = i[1], e[2] = i[2], e[3] = i[3], e[4] = i[4], e[5] = i[5], e[6] = i[6], e[7] = i[7], e[8] = i[8], this;
                },
                fromMat4: function(t) {
                    var e = t.val, i = this.val;
                    return i[0] = e[0], i[1] = e[1], i[2] = e[2], i[3] = e[4], i[4] = e[5], i[5] = e[6], i[6] = e[8], i[7] = e[9], i[8] = e[10], this;
                },
                fromArray: function(t) {
                    var e = this.val;
                    return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], this;
                },
                identity: function() {
                    var t = this.val;
                    return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, this;
                },
                transpose: function() {
                    var t = this.val, e = t[1], i = t[2], n = t[5];
                    return t[1] = t[3], t[2] = t[6], t[3] = e, t[5] = t[7], t[6] = i, t[7] = n, this;
                },
                invert: function() {
                    var t = this.val, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = t[6], h = t[7], l = t[8], u = l * r - o * h, c = -l * s + o * a, d = h * s - r * a, f = e * u + i * c + n * d;
                    return f ? (f = 1 / f, t[0] = u * f, t[1] = (-l * i + n * h) * f, t[2] = (o * i - n * r) * f, t[3] = c * f, t[4] = (l * e - n * a) * f, t[5] = (-o * e + n * s) * f, t[6] = d * f, t[7] = (-h * e + i * a) * f, t[8] = (r * e - i * s) * f, this) : null;
                },
                adjoint: function() {
                    var t = this.val, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = t[6], h = t[7], l = t[8];
                    return t[0] = r * l - o * h, t[1] = n * h - i * l, t[2] = i * o - n * r, t[3] = o * a - s * l, t[4] = e * l - n * a, t[5] = n * s - e * o, t[6] = s * h - r * a, t[7] = i * a - e * h, t[8] = e * r - i * s, this;
                },
                determinant: function() {
                    var t = this.val, e = t[0], i = t[1], n = t[2], s = t[3], r = t[4], o = t[5], a = t[6], h = t[7], l = t[8];
                    return e * (l * r - o * h) + i * (-l * s + o * a) + n * (h * s - r * a);
                },
                multiply: function(t) {
                    var e = this.val, i = e[0], n = e[1], s = e[2], r = e[3], o = e[4], a = e[5], h = e[6], l = e[7], u = e[8], c = t.val, d = c[0], f = c[1], p = c[2], g = c[3], v = c[4], m = c[5], y = c[6], x = c[7], T = c[8];
                    return e[0] = d * i + f * r + p * h, e[1] = d * n + f * o + p * l, e[2] = d * s + f * a + p * u, e[3] = g * i + v * r + m * h, e[4] = g * n + v * o + m * l, e[5] = g * s + v * a + m * u, e[6] = y * i + x * r + T * h, e[7] = y * n + x * o + T * l, e[8] = y * s + x * a + T * u, this;
                },
                translate: function(t) {
                    var e = this.val, i = t.x, n = t.y;
                    return e[6] = i * e[0] + n * e[3] + e[6], e[7] = i * e[1] + n * e[4] + e[7], e[8] = i * e[2] + n * e[5] + e[8], this;
                },
                rotate: function(t) {
                    var e = this.val, i = e[0], n = e[1], s = e[2], r = e[3], o = e[4], a = e[5], h = Math.sin(t), l = Math.cos(t);
                    return e[0] = l * i + h * r, e[1] = l * n + h * o, e[2] = l * s + h * a, e[3] = l * r - h * i, e[4] = l * o - h * n, e[5] = l * a - h * s, this;
                },
                scale: function(t) {
                    var e = this.val, i = t.x, n = t.y;
                    return e[0] = i * e[0], e[1] = i * e[1], e[2] = i * e[2], e[3] = n * e[3], e[4] = n * e[4], e[5] = n * e[5], this;
                },
                fromQuat: function(t) {
                    var e = t.x, i = t.y, n = t.z, s = t.w, r = e + e, o = i + i, a = n + n, h = e * r, l = e * o, u = e * a, c = i * o, d = i * a, f = n * a, p = s * r, g = s * o, v = s * a, m = this.val;
                    return m[0] = 1 - (c + f), m[3] = l + v, m[6] = u - g, m[1] = l - v, m[4] = 1 - (h + f), m[7] = d + p, m[2] = u + g, m[5] = d - p, m[8] = 1 - (h + c), this;
                },
                normalFromMat4: function(t) {
                    var e = t.val, i = this.val, n = e[0], s = e[1], r = e[2], o = e[3], a = e[4], h = e[5], l = e[6], u = e[7], c = e[8], d = e[9], f = e[10], p = e[11], g = e[12], v = e[13], m = e[14], y = e[15], x = n * h - s * a, T = n * l - r * a, w = n * u - o * a, b = s * l - r * h, E = s * u - o * h, S = r * u - o * l, A = c * v - d * g, _ = c * m - f * g, C = c * y - p * g, M = d * m - f * v, R = d * y - p * v, P = f * y - p * m, O = x * P - T * R + w * M + b * C - E * _ + S * A;
                    return O ? (O = 1 / O, i[0] = (h * P - l * R + u * M) * O, i[1] = (l * C - a * P - u * _) * O, i[2] = (a * R - h * C + u * A) * O, i[3] = (r * R - s * P - o * M) * O, i[4] = (n * P - r * C + o * _) * O, i[5] = (s * C - n * R - o * A) * O, i[6] = (v * S - m * E + y * b) * O, i[7] = (m * w - g * S - y * T) * O, i[8] = (g * E - v * w + y * x) * O, this) : null;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var n = i(0), s = i(358), r = i(1), o = i(38), a = new Int8Array([
                1,
                2,
                0
            ]), h = new Float32Array([
                0,
                0,
                0
            ]), l = new o(1, 0, 0), u = new o(0, 1, 0), c = new o, d = new s, f = new n({
                initialize: function(t, e, i, n) {
                    this.onChangeCallback = r, this.set(t, e, i, n);
                },
                x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(t) {
                        this._x = t, this.onChangeCallback(this);
                    }
                },
                y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(t) {
                        this._y = t, this.onChangeCallback(this);
                    }
                },
                z: {
                    get: function() {
                        return this._z;
                    },
                    set: function(t) {
                        this._z = t, this.onChangeCallback(this);
                    }
                },
                w: {
                    get: function() {
                        return this._w;
                    },
                    set: function(t) {
                        this._w = t, this.onChangeCallback(this);
                    }
                },
                copy: function(t) {
                    return this.set(t);
                },
                set: function(t, e, i, n, s) {
                    return void 0 === s && (s = !0), "object" == typeof t ? (this._x = t.x || 0, this._y = t.y || 0, this._z = t.z || 0, this._w = t.w || 0) : (this._x = t || 0, this._y = e || 0, this._z = i || 0, this._w = n || 0), s && this.onChangeCallback(this), this;
                },
                add: function(t) {
                    return this._x += t.x, this._y += t.y, this._z += t.z, this._w += t.w, this.onChangeCallback(this), this;
                },
                subtract: function(t) {
                    return this._x -= t.x, this._y -= t.y, this._z -= t.z, this._w -= t.w, this.onChangeCallback(this), this;
                },
                scale: function(t) {
                    return this._x *= t, this._y *= t, this._z *= t, this._w *= t, this.onChangeCallback(this), this;
                },
                length: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w;
                    return Math.sqrt(t * t + e * e + i * i + n * n);
                },
                lengthSq: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w;
                    return t * t + e * e + i * i + n * n;
                },
                normalize: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w, s = t * t + e * e + i * i + n * n;
                    return 0 < s && (s = 1 / Math.sqrt(s), this._x = t * s, this._y = e * s, this._z = i * s, this._w = n * s), this.onChangeCallback(this), this;
                },
                dot: function(t) {
                    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
                },
                lerp: function(t, e) {
                    void 0 === e && (e = 0);
                    var i = this.x, n = this.y, s = this.z, r = this.w;
                    return this.set(i + e * (t.x - i), n + e * (t.y - n), s + e * (t.z - s), r + e * (t.w - r));
                },
                rotationTo: function(t, e) {
                    var i = t.x * e.x + t.y * e.y + t.z * e.z;
                    return i < -0.999999 ? (c.copy(l).cross(t).length() < 1e-6 && c.copy(u).cross(t), c.normalize(), this.setAxisAngle(c, Math.PI)) : .999999 < i ? this.set(0, 0, 0, 1) : (c.copy(t).cross(e), this._x = c.x, this._y = c.y, this._z = c.z, this._w = 1 + i, this.normalize());
                },
                setAxes: function(t, e, i) {
                    var n = d.val;
                    return n[0] = e.x, n[3] = e.y, n[6] = e.z, n[1] = i.x, n[4] = i.y, n[7] = i.z, n[2] = -t.x, n[5] = -t.y, n[8] = -t.z, this.fromMat3(d).normalize();
                },
                identity: function() {
                    return this.set(0, 0, 0, 1);
                },
                setAxisAngle: function(t, e) {
                    e *= .5;
                    var i = Math.sin(e);
                    return this.set(i * t.x, i * t.y, i * t.z, Math.cos(e));
                },
                multiply: function(t) {
                    var e = this.x, i = this.y, n = this.z, s = this.w, r = t.x, o = t.y, a = t.z, h = t.w;
                    return this.set(e * h + s * r + i * a - n * o, i * h + s * o + n * r - e * a, n * h + s * a + e * o - i * r, s * h - e * r - i * o - n * a);
                },
                slerp: function(t, e) {
                    var i = this.x, n = this.y, s = this.z, r = this.w, o = t.x, a = t.y, h = t.z, l = t.w, u = i * o + n * a + s * h + r * l;
                    u < 0 && (u = -u, o = -o, a = -a, h = -h, l = -l);
                    var c, d, f = 1 - e, p = e;
                    return 1e-6 < 1 - u && (c = Math.acos(u), d = Math.sin(c), f = Math.sin((1 - e) * c) / d, p = Math.sin(e * c) / d), this.set(f * i + p * o, f * n + p * a, f * s + p * h, f * r + p * l);
                },
                invert: function() {
                    var t = this.x, e = this.y, i = this.z, n = this.w, s = t * t + e * e + i * i + n * n, r = s ? 1 / s : 0;
                    return this.set(-t * r, -e * r, -i * r, n * r);
                },
                conjugate: function() {
                    return this._x = -this.x, this._y = -this.y, this._z = -this.z, this.onChangeCallback(this), this;
                },
                rotateX: function(t) {
                    t *= .5;
                    var e = this.x, i = this.y, n = this.z, s = this.w, r = Math.sin(t), o = Math.cos(t);
                    return this.set(e * o + s * r, i * o + n * r, n * o - i * r, s * o - e * r);
                },
                rotateY: function(t) {
                    t *= .5;
                    var e = this.x, i = this.y, n = this.z, s = this.w, r = Math.sin(t), o = Math.cos(t);
                    return this.set(e * o - n * r, i * o + s * r, n * o + e * r, s * o - i * r);
                },
                rotateZ: function(t) {
                    t *= .5;
                    var e = this.x, i = this.y, n = this.z, s = this.w, r = Math.sin(t), o = Math.cos(t);
                    return this.set(e * o + i * r, i * o - e * r, n * o + s * r, s * o - n * r);
                },
                calculateW: function() {
                    var t = this.x, e = this.y, i = this.z;
                    return this.w = -Math.sqrt(1 - t * t - e * e - i * i), this;
                },
                setFromEuler: function(t, e) {
                    var i = t.x / 2, n = t.y / 2, s = t.z / 2, r = Math.cos(i), o = Math.cos(n), a = Math.cos(s), h = Math.sin(i), l = Math.sin(n), u = Math.sin(s);
                    switch(t.order){
                        case "XYZ":
                            this.set(h * o * a + r * l * u, r * l * a - h * o * u, r * o * u + h * l * a, r * o * a - h * l * u, e);
                            break;
                        case "YXZ":
                            this.set(h * o * a + r * l * u, r * l * a - h * o * u, r * o * u - h * l * a, r * o * a + h * l * u, e);
                            break;
                        case "ZXY":
                            this.set(h * o * a - r * l * u, r * l * a + h * o * u, r * o * u + h * l * a, r * o * a - h * l * u, e);
                            break;
                        case "ZYX":
                            this.set(h * o * a - r * l * u, r * l * a + h * o * u, r * o * u - h * l * a, r * o * a + h * l * u, e);
                            break;
                        case "YZX":
                            this.set(h * o * a + r * l * u, r * l * a + h * o * u, r * o * u - h * l * a, r * o * a - h * l * u, e);
                            break;
                        case "XZY":
                            this.set(h * o * a - r * l * u, r * l * a - h * o * u, r * o * u + h * l * a, r * o * a + h * l * u, e);
                    }
                    return this;
                },
                setFromRotationMatrix: function(t) {
                    var e, i = t.val, n = i[0], s = i[4], r = i[8], o = i[1], a = i[5], h = i[9], l = i[2], u = i[6], c = i[10], d = n + a + c;
                    return 0 < d ? (e = .5 / Math.sqrt(d + 1), this.set((u - h) * e, (r - l) * e, (o - s) * e, .25 / e)) : a < n && c < n ? (e = 2 * Math.sqrt(1 + n - a - c), this.set(.25 * e, (s + o) / e, (r + l) / e, (u - h) / e)) : c < a ? (e = 2 * Math.sqrt(1 + a - n - c), this.set((s + o) / e, .25 * e, (h + u) / e, (r - l) / e)) : (e = 2 * Math.sqrt(1 + c - n - a), this.set((r + l) / e, (h + u) / e, .25 * e, (o - s) / e)), this;
                },
                fromMat3: function(t) {
                    var e, i, n, s, r = t.val, o = r[0] + r[4] + r[8];
                    return 0 < o ? (s = Math.sqrt(o + 1), this.w = .5 * s, s = .5 / s, this._x = (r[7] - r[5]) * s, this._y = (r[2] - r[6]) * s, this._z = (r[3] - r[1]) * s) : (e = 0, r[4] > r[0] && (e = 1), r[8] > r[3 * e + e] && (e = 2), i = a[e], n = a[i], s = Math.sqrt(r[3 * e + e] - r[3 * i + i] - r[3 * n + n] + 1), h[e] = .5 * s, s = .5 / s, h[i] = (r[3 * i + e] + r[3 * e + i]) * s, h[n] = (r[3 * n + e] + r[3 * e + n]) * s, this._x = h[0], this._y = h[1], this._z = h[2], this._w = (r[3 * n + i] - r[3 * i + n]) * s), this.onChangeCallback(this), this;
                }
            });
            t.exports = f;
        },
        function(t, e, a) {
            var h = a(361), l = a(31), u = a(32), c = a(188);
            t.exports = function(t) {
                var e = t.config;
                if ((e.customEnvironment || e.canvas) && e.renderType === u.AUTO) throw new Error("Must set explicit renderType in custom environment");
                if (!e.customEnvironment && !e.canvas && e.renderType !== u.HEADLESS) {
                    if (e.renderType === u.CANVAS || e.renderType !== u.CANVAS && !c.webGL) {
                        if (!c.canvas) throw new Error("Cannot create Canvas or WebGL context, aborting.");
                        e.renderType = u.CANVAS;
                    } else e.renderType = u.WEBGL;
                }
                e.antialias || l.disableSmoothing();
                var i, n, s = t.scale.baseSize, r = s.width, o = s.height;
                e.canvas ? (t.canvas = e.canvas, t.canvas.width = r, t.canvas.height = o) : t.canvas = l.create(t, r, o, e.renderType), e.canvasStyle && (t.canvas.style = e.canvasStyle), e.antialias || h.setCrisp(t.canvas), e.renderType !== u.HEADLESS && (i = a(362), n = a(365), e.renderType === u.WEBGL ? t.renderer = new n(t) : (t.renderer = new i(t), t.context = t.renderer.gameContext));
            };
        },
        function(t, e) {
            t.exports = {
                setCrisp: function(e) {
                    return [
                        "optimizeSpeed",
                        "-moz-crisp-edges",
                        "-o-crisp-edges",
                        "-webkit-optimize-contrast",
                        "optimize-contrast",
                        "crisp-edges",
                        "pixelated"
                    ].forEach(function(t) {
                        e.style["image-rendering"] = t;
                    }), e.style.msInterpolationMode = "nearest-neighbor", e;
                },
                setBicubic: function(t) {
                    return t.style["image-rendering"] = "auto", t.style.msInterpolationMode = "bicubic", t;
                }
            };
        },
        function(t, e, i) {
            var d = i(36), u = i(363), n = i(0), s = i(32), r = i(9), f = i(88), o = i(364), a = i(101), h = i(103), l = i(25), c = new n({
                Extends: r,
                initialize: function(t) {
                    r.call(this);
                    var e = t.config;
                    this.config = {
                        clearBeforeRender: e.clearBeforeRender,
                        backgroundColor: e.backgroundColor,
                        antialias: e.antialias,
                        roundPixels: e.roundPixels
                    }, this.game = t, this.type = s.CANVAS, this.drawCount = 0, this.width = 0, this.height = 0, this.gameCanvas = t.canvas;
                    var i = {
                        alpha: t.config.transparent,
                        desynchronized: t.config.desynchronized
                    };
                    this.gameContext = e.context ? e.context : this.gameCanvas.getContext("2d", i), this.currentContext = this.gameContext, this.antialias = t.config.antialias, this.blendModes = o(), this.snapshotState = {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        getPixel: !1,
                        callback: null,
                        type: "image/png",
                        encoder: .92
                    }, this._tempMatrix1 = new l, this._tempMatrix2 = new l, this._tempMatrix3 = new l, this.isBooted = !1, this.init();
                },
                init: function() {
                    this.game.textures.once(h.READY, this.boot, this);
                },
                boot: function() {
                    var t = this.game, e = t.scale.baseSize;
                    this.width = e.width, this.height = e.height, this.isBooted = !0, t.scale.on(a.RESIZE, this.onResize, this), this.resize(e.width, e.height);
                },
                onResize: function(t, e) {
                    e.width === this.width && e.height === this.height || this.resize(e.width, e.height);
                },
                resize: function(t, e) {
                    this.width = t, this.height = e, this.emit(f.RESIZE, t, e);
                },
                resetTransform: function() {
                    this.currentContext.setTransform(1, 0, 0, 1, 0, 0);
                },
                setBlendMode: function(t) {
                    return this.currentContext.globalCompositeOperation = t, this;
                },
                setContext: function(t) {
                    return this.currentContext = t || this.gameContext, this;
                },
                setAlpha: function(t) {
                    return this.currentContext.globalAlpha = t, this;
                },
                preRender: function() {
                    var t = this.gameContext, e = this.config, i = this.width, n = this.height;
                    t.globalAlpha = 1, t.globalCompositeOperation = "source-over", t.setTransform(1, 0, 0, 1, 0, 0), e.clearBeforeRender && t.clearRect(0, 0, i, n), e.transparent || (t.fillStyle = e.backgroundColor.rgba, t.fillRect(0, 0, i, n)), t.save(), this.drawCount = 0, this.emit(f.PRE_RENDER);
                },
                render: function(t, e, i) {
                    var n = e.length;
                    this.emit(f.RENDER, t, i);
                    var s = i.x, r = i.y, o = i.width, a = i.height, h = i.renderToTexture ? i.context : t.sys.context;
                    h.save(), this.game.scene.customViewports && (h.beginPath(), h.rect(s, r, o, a), h.clip()), this.currentContext = h;
                    var l = i.mask;
                    l && l.preRenderCanvas(this, null, i._maskCamera), i.transparent || (h.fillStyle = i.backgroundColor.rgba, h.fillRect(s, r, o, a)), h.globalAlpha = i.alpha, h.globalCompositeOperation = "source-over", this.drawCount += n, i.renderToTexture && i.emit(d.PRE_RENDER, i), i.matrix.copyToContext(h);
                    for(var u = 0; u < n; u++){
                        var c = e[u];
                        c.mask && c.mask.preRenderCanvas(this, c, i), c.renderCanvas(this, c, i), c.mask && c.mask.postRenderCanvas(this, c, i);
                    }
                    h.setTransform(1, 0, 0, 1, 0, 0), h.globalCompositeOperation = "source-over", h.globalAlpha = 1, i.flashEffect.postRenderCanvas(h), i.fadeEffect.postRenderCanvas(h), i.dirty = !1, l && l.postRenderCanvas(this), h.restore(), i.renderToTexture && (i.emit(d.POST_RENDER, i), i.renderToGame && t.sys.context.drawImage(i.canvas, s, r));
                },
                postRender: function() {
                    this.gameContext.restore(), this.emit(f.POST_RENDER);
                    var t = this.snapshotState;
                    t.callback && (u(this.gameCanvas, t), t.callback = null);
                },
                snapshotCanvas: function(t, e, i, n, s, r, o, a, h) {
                    void 0 === i && (i = !1), this.snapshotArea(n, s, r, o, e, a, h);
                    var l = this.snapshotState;
                    return l.getPixel = i, u(this.canvas, l), l.callback = null, this;
                },
                snapshot: function(t, e, i) {
                    return this.snapshotArea(0, 0, this.gameCanvas.width, this.gameCanvas.height, t, e, i);
                },
                snapshotArea: function(t, e, i, n, s, r, o) {
                    var a = this.snapshotState;
                    return a.callback = s, a.type = r, a.encoder = o, a.getPixel = !1, a.x = t, a.y = e, a.width = Math.min(i, this.gameCanvas.width), a.height = Math.min(n, this.gameCanvas.height), this;
                },
                snapshotPixel: function(t, e, i) {
                    return this.snapshotArea(t, e, 1, 1, i), this.snapshotState.getPixel = !0, this;
                },
                batchSprite: function(t, e, i, n) {
                    var s, r, o, a, h, l, u, c, d, f, p, g, v, m, y, x, T, w = i.alpha * t.alpha;
                    0 != w && (s = this.currentContext, r = this._tempMatrix1, o = this._tempMatrix2, h = (a = e.canvasData).x, l = a.y, u = e.cutWidth, c = e.cutHeight, d = e.customPivot, f = e.source.resolution, p = t.displayOriginX, g = t.displayOriginY, v = -p + e.x, m = -g + e.y, t.isCropped && ((y = t._crop).flipX === t.flipX && y.flipY === t.flipY || e.updateCropUVs(y, t.flipX, t.flipY), u = y.cw, c = y.ch, h = y.cx, l = y.cy, v = -p + y.x, m = -g + y.y, t.flipX && (0 <= v ? v = -(v + u) : v < 0 && (v = Math.abs(v) - u)), t.flipY && (0 <= m ? m = -(m + c) : m < 0 && (m = Math.abs(m) - c))), T = x = 1, t.flipX && (d || (v += -e.realWidth + 2 * p), x = -1), t.flipY && (d || (m += -e.realHeight + 2 * g), T = -1), o.applyITRS(t.x, t.y, t.rotation, t.scaleX * x, t.scaleY * T), r.copyFrom(i.matrix), n ? (r.multiplyWithOffset(n, -i.scrollX * t.scrollFactorX, -i.scrollY * t.scrollFactorY), o.e = t.x, o.f = t.y) : (o.e -= i.scrollX * t.scrollFactorX, o.f -= i.scrollY * t.scrollFactorY), r.multiply(o), s.save(), r.setToContext(s), s.globalCompositeOperation = this.blendModes[t.blendMode], s.globalAlpha = w, s.imageSmoothingEnabled = !(!this.antialias || e.source.scaleMode), t.mask && t.mask.preRenderCanvas(this, t, i), s.drawImage(e.source.image, h, l, u, c, v, m, u / f, c / f), t.mask && t.mask.postRenderCanvas(this, t, i), s.restore());
                },
                destroy: function() {
                    this.removeAllListeners(), this.game = null, this.gameCanvas = null, this.gameContext = null;
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var f = i(31), p = i(37), g = i(2);
            t.exports = function(t, e) {
                var i, n, s, r, o = g(e, "callback"), a = g(e, "type", "image/png"), h = g(e, "encoder", .92), l = Math.abs(Math.round(g(e, "x", 0))), u = Math.abs(Math.round(g(e, "y", 0))), c = g(e, "width", t.width), d = g(e, "height", t.height);
                g(e, "getPixel", !1) ? (i = t.getContext("2d").getImageData(l, u, 1, 1).data, o.call(null, new p(i[0], i[1], i[2], i[3] / 255))) : 0 !== l || 0 !== u || c !== t.width || d !== t.height ? ((n = f.createWebGL(this, c, d)).getContext("2d").drawImage(t, l, u, c, d, 0, 0, c, d), (s = new Image).onerror = function() {
                    o.call(null), f.remove(n);
                }, s.onload = function() {
                    o.call(null, s), f.remove(n);
                }, s.src = n.toDataURL(a, h)) : ((r = new Image).onerror = function() {
                    o.call(null);
                }, r.onload = function() {
                    o.call(null, r);
                }, r.src = t.toDataURL(a, h));
            };
        },
        function(t, e, i) {
            var n = i(34), s = i(342);
            t.exports = function() {
                var t = [], e = s.supportNewBlendModes, i = "source-over";
                return t[n.NORMAL] = i, t[n.ADD] = "lighter", t[n.MULTIPLY] = e ? "multiply" : i, t[n.SCREEN] = e ? "screen" : i, t[n.OVERLAY] = e ? "overlay" : i, t[n.DARKEN] = e ? "darken" : i, t[n.LIGHTEN] = e ? "lighten" : i, t[n.COLOR_DODGE] = e ? "color-dodge" : i, t[n.COLOR_BURN] = e ? "color-burn" : i, t[n.HARD_LIGHT] = e ? "hard-light" : i, t[n.SOFT_LIGHT] = e ? "soft-light" : i, t[n.DIFFERENCE] = e ? "difference" : i, t[n.EXCLUSION] = e ? "exclusion" : i, t[n.HUE] = e ? "hue" : i, t[n.SATURATION] = e ? "saturation" : i, t[n.COLOR] = e ? "color" : i, t[n.LUMINOSITY] = e ? "luminosity" : i, t[n.ERASE] = "destination-out", t[n.SOURCE_IN] = "source-in", t[n.SOURCE_OUT] = "source-out", t[n.SOURCE_ATOP] = "source-atop", t[n.DESTINATION_OVER] = "destination-over", t[n.DESTINATION_IN] = "destination-in", t[n.DESTINATION_OUT] = "destination-out", t[n.DESTINATION_ATOP] = "destination-atop", t[n.LIGHTER] = "lighter", t[n.COPY] = "copy", t[n.XOR] = "xor", t;
            };
        },
        function(t, e, i) {
            var n = i(89), o = i(36), s = i(0), v = i(32), r = i(9), l = i(88), m = i(22), g = i(136), y = i(67), a = i(1), x = i(366), h = i(139), u = i(101), T = i(103), w = i(12), f = i(377), c = new s({
                Extends: r,
                initialize: function(t) {
                    r.call(this);
                    var e = t.config, i = {
                        alpha: e.transparent,
                        desynchronized: e.desynchronized,
                        depth: !1,
                        antialias: e.antialiasGL,
                        premultipliedAlpha: e.premultipliedAlpha,
                        stencil: !0,
                        failIfMajorPerformanceCaveat: e.failIfMajorPerformanceCaveat,
                        powerPreference: e.powerPreference
                    };
                    this.config = {
                        clearBeforeRender: e.clearBeforeRender,
                        antialias: e.antialias,
                        backgroundColor: e.backgroundColor,
                        contextCreation: i,
                        roundPixels: e.roundPixels,
                        maxTextures: e.maxTextures,
                        maxTextureSize: e.maxTextureSize,
                        batchSize: e.batchSize,
                        maxLights: e.maxLights,
                        mipmapFilter: e.mipmapFilter
                    }, this.game = t, this.type = v.WEBGL, this.pipelines = null, this.width = 0, this.height = 0, this.canvas = t.canvas, this.blendModes = [], this.contextLost = !1, this.snapshotState = {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        getPixel: !1,
                        callback: null,
                        type: "image/png",
                        encoder: .92,
                        isFramebuffer: !1,
                        bufferWidth: 0,
                        bufferHeight: 0
                    }, this.currentActiveTexture = 0, this.startActiveTexture = 0, this.maxTextures = 0, this.textureIndexes, this.tempTextures, this.textureZero, this.normalTexture, this.currentFramebuffer = null, this.fboStack = [], this.currentProgram = null, this.currentBlendMode = 1 / 0, this.currentScissorEnabled = !1, this.currentScissor = null, this.scissorStack = [], this.contextLostHandler = a, this.contextRestoredHandler = a, this.gl = null, this.supportedExtensions = null, this.instancedArraysExtension = null, this.vaoExtension = null, this.extensions = {}, this.glFormats = [], this.compression = {
                        ETC1: !1,
                        PVRTC: !1,
                        S3TC: !1
                    }, this.drawingBufferHeight = 0, this.blankTexture = null, this.whiteTexture = null, this.maskCount = 0, this.maskStack = [], this.currentMask = {
                        mask: null,
                        camera: null
                    }, this.currentCameraMask = {
                        mask: null,
                        camera: null
                    }, this.glFuncMap = null, this.currentType = "", this.newType = !1, this.nextTypeMatch = !1, this.finalType = !1, this.mipmapFilter = null, this.textureFlush = 0, this.isTextureClean = !1, this.defaultScissor = [
                        0,
                        0,
                        0,
                        0
                    ], this.isBooted = !1, this.renderTarget = null, this.projectionMatrix, this.projectionWidth = 0, this.projectionHeight = 0, this.init(this.config);
                },
                init: function(t) {
                    var e = this.game, i = this.canvas, n = t.backgroundColor, s = e.config.context ? e.config.context : i.getContext("webgl", t.contextCreation) || i.getContext("experimental-webgl", t.contextCreation);
                    if (!s || s.isContextLost()) throw this.contextLost = !0, new Error("WebGL unsupported");
                    this.gl = s;
                    var r = this;
                    this.contextLostHandler = function(t) {
                        r.contextLost = !0, r.game.events.emit(m.CONTEXT_LOST, r), t.preventDefault();
                    }, this.contextRestoredHandler = function() {
                        r.contextLost = !1, r.init(r.config), r.game.events.emit(m.CONTEXT_RESTORED, r);
                    }, i.addEventListener("webglcontextlost", this.contextLostHandler, !1), i.addEventListener("webglcontextrestored", this.contextRestoredHandler, !1), e.context = s;
                    for(var o = 0; o <= 27; o++)this.blendModes.push({
                        func: [
                            s.ONE,
                            s.ONE_MINUS_SRC_ALPHA
                        ],
                        equation: s.FUNC_ADD
                    });
                    this.blendModes[1].func = [
                        s.ONE,
                        s.DST_ALPHA
                    ], this.blendModes[2].func = [
                        s.DST_COLOR,
                        s.ONE_MINUS_SRC_ALPHA
                    ], this.blendModes[3].func = [
                        s.ONE,
                        s.ONE_MINUS_SRC_COLOR
                    ], this.blendModes[17] = {
                        func: [
                            s.ZERO,
                            s.ONE_MINUS_SRC_ALPHA
                        ],
                        equation: s.FUNC_REVERSE_SUBTRACT
                    }, this.glFormats[0] = s.BYTE, this.glFormats[1] = s.SHORT, this.glFormats[2] = s.UNSIGNED_BYTE, this.glFormats[3] = s.UNSIGNED_SHORT, this.glFormats[4] = s.FLOAT, this.glFuncMap = {
                        mat2: {
                            func: s.uniformMatrix2fv,
                            length: 1,
                            matrix: !0
                        },
                        mat3: {
                            func: s.uniformMatrix3fv,
                            length: 1,
                            matrix: !0
                        },
                        mat4: {
                            func: s.uniformMatrix4fv,
                            length: 1,
                            matrix: !0
                        },
                        "1f": {
                            func: s.uniform1f,
                            length: 1
                        },
                        "1fv": {
                            func: s.uniform1fv,
                            length: 1
                        },
                        "1i": {
                            func: s.uniform1i,
                            length: 1
                        },
                        "1iv": {
                            func: s.uniform1iv,
                            length: 1
                        },
                        "2f": {
                            func: s.uniform2f,
                            length: 2
                        },
                        "2fv": {
                            func: s.uniform2fv,
                            length: 1
                        },
                        "2i": {
                            func: s.uniform2i,
                            length: 2
                        },
                        "2iv": {
                            func: s.uniform2iv,
                            length: 1
                        },
                        "3f": {
                            func: s.uniform3f,
                            length: 3
                        },
                        "3fv": {
                            func: s.uniform3fv,
                            length: 1
                        },
                        "3i": {
                            func: s.uniform3i,
                            length: 3
                        },
                        "3iv": {
                            func: s.uniform3iv,
                            length: 1
                        },
                        "4f": {
                            func: s.uniform4f,
                            length: 4
                        },
                        "4fv": {
                            func: s.uniform4fv,
                            length: 1
                        },
                        "4i": {
                            func: s.uniform4i,
                            length: 4
                        },
                        "4iv": {
                            func: s.uniform4iv,
                            length: 1
                        }
                    };
                    var a = s.getSupportedExtensions();
                    t.maxTextures && -1 !== t.maxTextures || (t.maxTextures = s.getParameter(s.MAX_TEXTURE_IMAGE_UNITS)), t.maxTextureSize || (t.maxTextureSize = s.getParameter(s.MAX_TEXTURE_SIZE));
                    var h = "WEBGL_compressed_texture_", l = "WEBKIT_" + h;
                    this.compression.ETC1 = s.getExtension(h + "etc1") || s.getExtension(l + "etc1"), this.compression.PVRTC = s.getExtension(h + "pvrtc") || s.getExtension(l + "pvrtc"), this.compression.S3TC = s.getExtension(h + "s3tc") || s.getExtension(l + "s3tc"), this.supportedExtensions = a;
                    var u = "ANGLE_instanced_arrays";
                    this.instancedArraysExtension = -1 < a.indexOf(u) ? s.getExtension(u) : null;
                    var c = "OES_vertex_array_object";
                    this.vaoExtension = -1 < a.indexOf(c) ? s.getExtension(c) : null, s.disable(s.DEPTH_TEST), s.disable(s.CULL_FACE), s.enable(s.BLEND), s.clearColor(n.redGL, n.greenGL, n.blueGL, n.alphaGL), this.mipmapFilter = s[t.mipmapFilter], this.maxTextures = w.checkShaderMax(s, t.maxTextures), this.textureIndexes = [];
                    var d = this.tempTextures;
                    if (Array.isArray(d)) for(var f = 0; o < this.maxTextures; f++)s.deleteTexture(d[f]);
                    else d = new Array(this.maxTextures);
                    for(var p = 0; p < this.maxTextures; p++){
                        var g = s.createTexture();
                        s.activeTexture(s.TEXTURE0 + p), s.bindTexture(s.TEXTURE_2D, g), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, 1, 1, 0, s.RGBA, s.UNSIGNED_BYTE, new Uint8Array([
                            0,
                            0,
                            255,
                            255
                        ])), d[p] = g, this.textureIndexes.push(p);
                    }
                    return this.tempTextures = d, this.currentActiveTexture = 1, this.startActiveTexture++, s.activeTexture(s.TEXTURE1), this.pipelines = new x(this), this.setBlendMode(v.BlendModes.NORMAL), this.projectionMatrix = (new y).identity(), e.textures.once(T.READY, this.boot, this), this;
                },
                boot: function() {
                    var t = this.game, e = this.pipelines, i = t.scale.baseSize;
                    this.width = i.width, this.height = i.height, this.isBooted = !0, this.renderTarget = new h(this, this.width, this.height, 1, 0, !0, !0), e.boot(t.config.pipeline), this.blankTexture = t.textures.getFrame("__DEFAULT"), this.whiteTexture = t.textures.getFrame("__WHITE");
                    var n = this.gl;
                    n.bindFramebuffer(n.FRAMEBUFFER, null), n.enable(n.SCISSOR_TEST), t.scale.on(u.RESIZE, this.onResize, this), this.resize(i.width, i.height);
                },
                onResize: function(t, e) {
                    e.width === this.width && e.height === this.height || this.resize(e.width, e.height);
                },
                beginCapture: function(t, e) {
                    void 0 === t && (t = this.width), void 0 === e && (e = this.height), this.renderTarget.bind(!0, t, e), this.setProjectionMatrix(t, e), this.resetTextures();
                },
                endCapture: function() {
                    return this.renderTarget.unbind(!0), this.resetProjectionMatrix(), this.renderTarget;
                },
                resize: function(t, e) {
                    var i = this.gl;
                    return this.width = t, this.height = e, this.setProjectionMatrix(t, e), i.viewport(0, 0, t, e), this.drawingBufferHeight = i.drawingBufferHeight, i.scissor(0, i.drawingBufferHeight - e, t, e), this.defaultScissor[2] = t, this.defaultScissor[3] = e, this.emit(l.RESIZE, t, e), this;
                },
                getAspectRatio: function() {
                    return this.width / this.height;
                },
                setProjectionMatrix: function(t, e) {
                    return t === this.projectionWidth && e === this.projectionHeight || (this.projectionWidth = t, this.projectionHeight = e, this.projectionMatrix.ortho(0, t, e, 0, -1000, 1e3)), this;
                },
                resetProjectionMatrix: function() {
                    this.projectionWidth = this.width, this.projectionHeight = this.height, this.projectionMatrix.ortho(0, this.width, this.height, 0, -1000, 1e3);
                },
                hasExtension: function(t) {
                    return !!this.supportedExtensions && this.supportedExtensions.indexOf(t);
                },
                getExtension: function(t) {
                    return this.hasExtension(t) ? (t in this.extensions || (this.extensions[t] = this.gl.getExtension(t)), this.extensions[t]) : null;
                },
                flush: function() {
                    this.pipelines.flush();
                },
                pushScissor: function(t, e, i, n, s) {
                    void 0 === s && (s = this.drawingBufferHeight);
                    var r = [
                        t,
                        e,
                        i,
                        n
                    ];
                    return this.scissorStack.push(r), this.setScissor(t, e, i, n, s), this.currentScissor = r;
                },
                setScissor: function(t, e, i, n, s) {
                    void 0 === s && (s = this.drawingBufferHeight);
                    var r, o, a, h, l = this.gl, u = this.currentScissor, c = 0 < i && 0 < n;
                    u && c && (r = u[0], o = u[1], a = u[2], h = u[3], c = r !== t || o !== e || a !== i || h !== n), c && (this.flush(), l.scissor(t, s - e - n, i, n));
                },
                resetScissor: function() {
                    var t = this.gl;
                    t.enable(t.SCISSOR_TEST);
                    var e, i, n, s, r = this.currentScissor;
                    r && (e = r[0], i = r[1], n = r[2], s = r[3], 0 < n && 0 < s && t.scissor(e, this.drawingBufferHeight - i - s, n, s));
                },
                popScissor: function() {
                    var t = this.scissorStack;
                    t.pop();
                    var e = t[t.length - 1];
                    e && this.setScissor(e[0], e[1], e[2], e[3]), this.currentScissor = e;
                },
                hasActiveStencilMask: function() {
                    var t = this.currentMask.mask, e = this.currentCameraMask.mask;
                    return t && t.isStencil || e && e.isStencil;
                },
                resetViewport: function() {
                    var t = this.gl;
                    t.viewport(0, 0, this.width, this.height), this.drawingBufferHeight = t.drawingBufferHeight;
                },
                setBlendMode: function(t, e) {
                    void 0 === e && (e = !1);
                    var i = this.gl, n = this.blendModes[t];
                    return !!(e || t !== v.BlendModes.SKIP_CHECK && this.currentBlendMode !== t) && (this.flush(), i.enable(i.BLEND), i.blendEquation(n.equation), 2 < n.func.length ? i.blendFuncSeparate(n.func[0], n.func[1], n.func[2], n.func[3]) : i.blendFunc(n.func[0], n.func[1]), this.currentBlendMode = t, !0);
                },
                addBlendMode: function(t, e) {
                    return this.blendModes.push({
                        func: t,
                        equation: e
                    }) - 1;
                },
                updateBlendMode: function(t, e, i) {
                    return this.blendModes[t] && (this.blendModes[t].func = e, i && (this.blendModes[t].equation = i)), this;
                },
                removeBlendMode: function(t) {
                    return 17 < t && this.blendModes[t] && this.blendModes.splice(t, 1), this;
                },
                setBlankTexture: function() {
                    this.setTexture2D(this.blankTexture.glTexture);
                },
                setTextureSource: function(t) {
                    if (this.pipelines.forceZero()) return this.setTextureZero(t.glTexture, !0), 0;
                    var e = this.gl, i = this.currentActiveTexture;
                    return t.glIndexCounter < this.startActiveTexture && (t.glIndexCounter = this.startActiveTexture, i < this.maxTextures ? (t.glIndex = i, e.activeTexture(e.TEXTURE0 + i), e.bindTexture(e.TEXTURE_2D, t.glTexture), this.currentActiveTexture++) : (this.flush(), this.startActiveTexture++, this.textureFlush++, t.glIndexCounter = this.startActiveTexture, t.glIndex = 1, e.activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, t.glTexture), this.currentActiveTexture = 2)), this.isTextureClean = !1, t.glIndex;
                },
                isNewNormalMap: function(t, e) {
                    return this.textureZero !== t || this.normalTexture !== e;
                },
                setTextureZero: function(t, e) {
                    var i;
                    this.textureZero !== t && (e && this.flush(), (i = this.gl).activeTexture(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, t), this.textureZero = t);
                },
                clearTextureZero: function() {
                    this.textureZero = null;
                },
                setNormalMap: function(t) {
                    var e;
                    this.normalTexture !== t && ((e = this.gl).activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, t), this.normalTexture = t, 1 === this.currentActiveTexture && (this.currentActiveTexture = 2));
                },
                clearNormalMap: function() {
                    this.normalTexture = null, this.startActiveTexture++, this.currentActiveTexture = 1, this.textureFlush++;
                },
                unbindTextures: function() {
                    for(var t = this.gl, e = this.tempTextures, i = 0; i < e.length; i++)t.activeTexture(t.TEXTURE0 + i), t.bindTexture(t.TEXTURE_2D, null);
                    this.normalTexture = null, this.textureZero = null, this.currentActiveTexture = 1, this.startActiveTexture++, this.textureFlush++;
                },
                resetTextures: function(t) {
                    if (void 0 === t && (t = !1), !this.isTextureClean) {
                        this.flush();
                        var e = this.gl, i = this.tempTextures;
                        if (t) {
                            for(var n = 0; n < i.length; n++)e.activeTexture(e.TEXTURE0 + n), e.bindTexture(e.TEXTURE_2D, i[n]);
                            e.activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, i[1]), this.isTextureClean = !0;
                        } else e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, i[0]), e.activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, i[1]);
                        this.normalTexture = null, this.textureZero = null, this.currentActiveTexture = 1, this.startActiveTexture++, this.textureFlush++;
                    }
                },
                setTexture2D: function(t) {
                    if (this.pipelines.forceZero()) return this.setTextureZero(t, !0), 0;
                    var e = this.gl, i = this.currentActiveTexture;
                    return t.glIndexCounter < this.startActiveTexture && (t.glIndexCounter = this.startActiveTexture, i < this.maxTextures ? (t.glIndex = i, e.activeTexture(e.TEXTURE0 + i), e.bindTexture(e.TEXTURE_2D, t), this.currentActiveTexture++) : (this.flush(), this.startActiveTexture++, this.textureFlush++, t.glIndexCounter = this.startActiveTexture, t.glIndex = 1, e.activeTexture(e.TEXTURE1), e.bindTexture(e.TEXTURE_2D, t), this.currentActiveTexture = 2)), this.isTextureClean = !1, t.glIndex;
                },
                pushFramebuffer: function(t, e, i, n) {
                    return t === this.currentFramebuffer ? this : (this.fboStack.push(t), this.setFramebuffer(t, e, i, n));
                },
                setFramebuffer: function(t, e, i, n) {
                    if (void 0 === e && (e = !1), void 0 === i && (i = !1), void 0 === n && (n = !0), t === this.currentFramebuffer) return this;
                    var s = this.gl, r = this.width, o = this.height;
                    return t && t.renderTexture && n ? (r = t.renderTexture.width, o = t.renderTexture.height) : this.flush(), s.bindFramebuffer(s.FRAMEBUFFER, t), n && s.viewport(0, 0, r, o), e && (t ? (this.drawingBufferHeight = o, this.pushScissor(0, 0, r, o)) : (this.drawingBufferHeight = this.height, this.popScissor())), this.currentFramebuffer = t, i && this.resetTextures(), this;
                },
                popFramebuffer: function(t, e, i) {
                    void 0 === t && (t = !1), void 0 === e && (e = !1), void 0 === i && (i = !0);
                    var n = this.fboStack;
                    n.pop();
                    var s = (s = n[n.length - 1]) || null;
                    return this.setFramebuffer(s, t, e, i), s;
                },
                setProgram: function(t) {
                    return t !== this.currentProgram && (this.flush(), this.gl.useProgram(t), this.currentProgram = t, !0);
                },
                resetProgram: function() {
                    return this.gl.useProgram(this.currentProgram), this;
                },
                createTextureFromSource: function(t, e, i, n) {
                    var s = this.gl, r = s.NEAREST, o = s.NEAREST, a = s.CLAMP_TO_EDGE;
                    e = t ? t.width : e, i = t ? t.height : i;
                    var h = g(e, i);
                    return h && (a = s.REPEAT), n === v.ScaleModes.LINEAR && this.config.antialias && (r = h ? this.mipmapFilter : s.LINEAR, o = s.LINEAR), t || "number" != typeof e || "number" != typeof i ? this.createTexture2D(0, r, o, a, a, s.RGBA, t) : this.createTexture2D(0, r, o, a, a, s.RGBA, null, e, i);
                },
                createTexture2D: function(t, e, i, n, s, r, o, a, h, l, u, c) {
                    l = null == l || l, void 0 === u && (u = !1), void 0 === c && (c = !1);
                    var d = this.gl, f = d.createTexture();
                    d.activeTexture(d.TEXTURE0);
                    var p = d.getParameter(d.TEXTURE_BINDING_2D);
                    return d.bindTexture(d.TEXTURE_2D, f), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_MIN_FILTER, e), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_MAG_FILTER, i), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_WRAP_S, s), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_WRAP_T, n), d.pixelStorei(d.UNPACK_PREMULTIPLY_ALPHA_WEBGL, l), d.pixelStorei(d.UNPACK_FLIP_Y_WEBGL, c), null == o ? d.texImage2D(d.TEXTURE_2D, t, r, a, h, 0, r, d.UNSIGNED_BYTE, null) : (u || (a = o.width, h = o.height), d.texImage2D(d.TEXTURE_2D, t, r, r, d.UNSIGNED_BYTE, o)), g(a, h) && d.generateMipmap(d.TEXTURE_2D), p && d.bindTexture(d.TEXTURE_2D, p), f.isAlphaPremultiplied = l, f.isRenderTexture = !1, f.width = a, f.height = h, f.glIndex = 0, f.glIndexCounter = -1, f;
                },
                createFramebuffer: function(t, e, i, n) {
                    var s, r, o = this.gl, a = o.createFramebuffer();
                    if (this.setFramebuffer(a), n && (r = o.createRenderbuffer(), o.bindRenderbuffer(o.RENDERBUFFER, r), o.renderbufferStorage(o.RENDERBUFFER, o.DEPTH_STENCIL, t, e), o.framebufferRenderbuffer(o.FRAMEBUFFER, o.DEPTH_STENCIL_ATTACHMENT, o.RENDERBUFFER, r)), i.isRenderTexture = !0, i.isAlphaPremultiplied = !1, o.framebufferTexture2D(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, i, 0), (s = o.checkFramebufferStatus(o.FRAMEBUFFER)) === o.FRAMEBUFFER_COMPLETE) return a.renderTexture = i, this.setFramebuffer(null), this.resetTextures(), a;
                    throw new Error("Framebuffer status: " + ({
                        36054: "Incomplete Attachment",
                        36055: "Missing Attachment",
                        36057: "Incomplete Dimensions",
                        36061: "Framebuffer Unsupported"
                    })[s]);
                },
                createProgram: function(t, e) {
                    var i = this.gl, n = i.createProgram(), s = i.createShader(i.VERTEX_SHADER), r = i.createShader(i.FRAGMENT_SHADER);
                    if (i.shaderSource(s, t), i.shaderSource(r, e), i.compileShader(s), i.compileShader(r), !i.getShaderParameter(s, i.COMPILE_STATUS)) throw new Error("Vertex Shader failed:\n" + i.getShaderInfoLog(s));
                    if (!i.getShaderParameter(r, i.COMPILE_STATUS)) throw new Error("Fragment Shader failed:\n" + i.getShaderInfoLog(r));
                    if (i.attachShader(n, s), i.attachShader(n, r), i.linkProgram(n), !i.getProgramParameter(n, i.LINK_STATUS)) throw new Error("Link Program failed:\n" + i.getProgramInfoLog(n));
                    return i.useProgram(n), n;
                },
                createVertexBuffer: function(t, e) {
                    var i = this.gl, n = i.createBuffer();
                    return i.bindBuffer(i.ARRAY_BUFFER, n), i.bufferData(i.ARRAY_BUFFER, t, e), i.bindBuffer(i.ARRAY_BUFFER, null), n;
                },
                createIndexBuffer: function(t, e) {
                    var i = this.gl, n = i.createBuffer();
                    return i.bindBuffer(i.ELEMENT_ARRAY_BUFFER, n), i.bufferData(i.ELEMENT_ARRAY_BUFFER, t, e), i.bindBuffer(i.ELEMENT_ARRAY_BUFFER, null), n;
                },
                deleteTexture: function(t, e) {
                    return t && this.gl.deleteTexture(t), e && this.resetTextures(), this;
                },
                deleteFramebuffer: function(t) {
                    return t && (this.gl.deleteFramebuffer(t), n(this.fboStack, t), this.currentFramebuffer === t && (this.currentFramebuffer = null)), this;
                },
                deleteProgram: function(t) {
                    return t && this.gl.deleteProgram(t), this;
                },
                deleteBuffer: function(t) {
                    return this.gl.deleteBuffer(t), this;
                },
                preRenderCamera: function(t) {
                    var e = t.x, i = t.y, n = t.width, s = t.height, r = t.backgroundColor;
                    t.emit(o.PRE_RENDER, t), this.pipelines.preBatchCamera(t), this.pushScissor(e, i, n, s), t.mask && (this.currentCameraMask.mask = t.mask, this.currentCameraMask.camera = t._maskCamera, t.mask.preRenderWebGL(this, t, t._maskCamera)), 0 < r.alphaGL && this.pipelines.setMulti().drawFillRect(e, i, n, s, w.getTintFromFloats(r.blueGL, r.greenGL, r.redGL, 1), r.alphaGL);
                },
                getCurrentStencilMask: function() {
                    var t = null, e = this.maskStack, i = this.currentCameraMask;
                    return 0 < e.length ? t = e[e.length - 1] : i.mask && i.mask.isStencil && (t = i), t;
                },
                postRenderCamera: function(t) {
                    var e, i = t.flashEffect, n = t.fadeEffect;
                    (i.isRunning || n.isRunning || n.isComplete) && (e = this.pipelines.setMulti(), i.postRenderWebGL(e, w.getTintFromFloats), n.postRenderWebGL(e, w.getTintFromFloats)), t.dirty = !1, this.popScissor(), t.mask && (this.currentCameraMask.mask = null, t.mask.postRenderWebGL(this, t._maskCamera)), this.pipelines.postBatchCamera(t), t.emit(o.POST_RENDER, t);
                },
                preRender: function() {
                    var t, e;
                    this.contextLost || ((t = this.gl).bindFramebuffer(t.FRAMEBUFFER, null), this.config.clearBeforeRender && (e = this.config.backgroundColor, t.clearColor(e.redGL, e.greenGL, e.blueGL, e.alphaGL), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT | t.STENCIL_BUFFER_BIT)), t.enable(t.SCISSOR_TEST), this.currentScissor = this.defaultScissor, this.scissorStack.length = 0, this.scissorStack.push(this.currentScissor), this.game.scene.customViewports && t.scissor(0, this.drawingBufferHeight - this.height, this.width, this.height), this.currentMask.mask = null, this.currentCameraMask.mask = null, this.maskStack.length = 0, this.textureFlush = 0, this.emit(l.PRE_RENDER));
                },
                render: function(t, e, i) {
                    if (!this.contextLost) {
                        var n = e.length;
                        if (this.emit(l.RENDER, t, i), this.preRenderCamera(i), 0 === n) return this.setBlendMode(v.BlendModes.NORMAL), void this.postRenderCamera(i);
                        this.currentType = "";
                        for(var s = this.currentMask, r = 0; r < n; r++){
                            this.finalType = r === n - 1;
                            var o = e[r], a = o.mask;
                            (s = this.currentMask).mask && s.mask !== a && s.mask.postRenderWebGL(this, s.camera), a && s.mask !== a && a.preRenderWebGL(this, o, i), o.blendMode !== this.currentBlendMode && this.setBlendMode(o.blendMode);
                            var h = o.type;
                            h !== this.currentType && (this.newType = !0, this.currentType = h), this.finalType ? this.nextTypeMatch = !1 : this.nextTypeMatch = e[r + 1].type === this.currentType, o.renderWebGL(this, o, i), this.newType = !1;
                        }
                        (s = this.currentMask).mask && s.mask.postRenderWebGL(this, s.camera), this.setBlendMode(v.BlendModes.NORMAL), this.postRenderCamera(i);
                    }
                },
                postRender: function() {
                    var t;
                    this.contextLost || (this.flush(), this.emit(l.POST_RENDER), (t = this.snapshotState).callback && (f(this.canvas, t), t.callback = null), 0 < this.textureFlush && (this.startActiveTexture++, this.currentActiveTexture = 1));
                },
                snapshot: function(t, e, i) {
                    return this.snapshotArea(0, 0, this.gl.drawingBufferWidth, this.gl.drawingBufferHeight, t, e, i);
                },
                snapshotArea: function(t, e, i, n, s, r, o) {
                    var a = this.snapshotState;
                    return a.callback = s, a.type = r, a.encoder = o, a.getPixel = !1, a.x = t, a.y = e, a.width = Math.min(i, this.gl.drawingBufferWidth), a.height = Math.min(n, this.gl.drawingBufferHeight), this;
                },
                snapshotPixel: function(t, e, i) {
                    return this.snapshotArea(t, e, 1, 1, i), this.snapshotState.getPixel = !0, this;
                },
                snapshotFramebuffer: function(t, e, i, n, s, r, o, a, h, l, u) {
                    void 0 === s && (s = !1), void 0 === r && (r = 0), void 0 === o && (o = 0), void 0 === a && (a = e), void 0 === h && (h = i);
                    var c = this.currentFramebuffer;
                    this.snapshotArea(r, o, a, h, n, l, u);
                    var d = this.snapshotState;
                    return d.getPixel = s, d.isFramebuffer = !0, d.bufferWidth = e, d.bufferHeight = i, this.setFramebuffer(t), f(this.canvas, d), this.setFramebuffer(c), d.callback = null, d.isFramebuffer = !1, this;
                },
                canvasToTexture: function(t, e, i, n) {
                    return void 0 === i && (i = !1), void 0 === n && (n = !1), e ? this.updateCanvasTexture(t, e, n) : this.createCanvasTexture(t, i, n);
                },
                createCanvasTexture: function(t, e, i) {
                    void 0 === e && (e = !1), void 0 === i && (i = !1);
                    var n = this.gl, s = n.NEAREST, r = n.NEAREST, o = t.width, a = t.height, h = n.CLAMP_TO_EDGE, l = g(o, a);
                    return !e && l && (h = n.REPEAT), this.config.antialias && (s = l ? this.mipmapFilter : n.LINEAR, r = n.LINEAR), this.createTexture2D(0, s, r, h, h, n.RGBA, t, o, a, !0, !1, i);
                },
                updateCanvasTexture: function(t, e, i) {
                    void 0 === i && (i = !1);
                    var n, s = this.gl, r = t.width, o = t.height;
                    return 0 < r && 0 < o && (s.activeTexture(s.TEXTURE0), n = s.getParameter(s.TEXTURE_BINDING_2D), s.bindTexture(s.TEXTURE_2D, e), s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, i), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, t), e.width = r, e.height = o, n && s.bindTexture(s.TEXTURE_2D, n)), e;
                },
                createVideoTexture: function(t, e, i) {
                    void 0 === e && (e = !1), void 0 === i && (i = !1);
                    var n = this.gl, s = n.NEAREST, r = n.NEAREST, o = t.videoWidth, a = t.videoHeight, h = n.CLAMP_TO_EDGE, l = g(o, a);
                    return !e && l && (h = n.REPEAT), this.config.antialias && (s = l ? this.mipmapFilter : n.LINEAR, r = n.LINEAR), this.createTexture2D(0, s, r, h, h, n.RGBA, t, o, a, !0, !0, i);
                },
                updateVideoTexture: function(t, e, i) {
                    void 0 === i && (i = !1);
                    var n, s = this.gl, r = t.videoWidth, o = t.videoHeight;
                    return 0 < r && 0 < o && (s.activeTexture(s.TEXTURE0), n = s.getParameter(s.TEXTURE_BINDING_2D), s.bindTexture(s.TEXTURE_2D, e), s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, i), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, t), e.width = r, e.height = o, n && s.bindTexture(s.TEXTURE_2D, n)), e;
                },
                setTextureFilter: function(t, e) {
                    var i = this.gl, n = [
                        i.LINEAR,
                        i.NEAREST
                    ][e];
                    i.activeTexture(i.TEXTURE0);
                    var s = i.getParameter(i.TEXTURE_BINDING_2D);
                    return i.bindTexture(i.TEXTURE_2D, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, n), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, n), s && i.bindTexture(i.TEXTURE_2D, s), this;
                },
                getMaxTextureSize: function() {
                    return this.config.maxTextureSize;
                },
                destroy: function() {
                    this.canvas.removeEventListener("webglcontextlost", this.contextLostHandler, !1), this.canvas.removeEventListener("webglcontextrestored", this.contextRestoredHandler, !1);
                    for(var t = this.gl, e = this.tempTextures, i = 0; i < e.length; i++)t.deleteTexture(e[i]);
                    this.pipelines.destroy(), this.removeAllListeners(), this.fboStack = [], this.maskStack = [], this.extensions = {}, this.textureIndexes = [], this.gl = null, this.game = null, this.canvas = null, this.contextLost = !0, this.currentMask = null, this.currentCameraMask = null;
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var n = i(0), o = i(65), s = i(99), r = i(367), a = i(370), h = i(371), l = i(105), u = i(372), c = i(373), d = i(374), f = i(375), p = new n({
                initialize: function(t) {
                    this.game = t.game, this.renderer = t, this.classes = new s([
                        [
                            o.UTILITY_PIPELINE,
                            f
                        ],
                        [
                            o.MULTI_PIPELINE,
                            l
                        ],
                        [
                            o.BITMAPMASK_PIPELINE,
                            r
                        ],
                        [
                            o.SINGLE_PIPELINE,
                            d
                        ],
                        [
                            o.ROPE_PIPELINE,
                            c
                        ],
                        [
                            o.LIGHT_PIPELINE,
                            h
                        ],
                        [
                            o.POINTLIGHT_PIPELINE,
                            u
                        ],
                        [
                            o.GRAPHICS_PIPELINE,
                            a
                        ]
                    ]), this.postPipelineClasses = new s, this.pipelines = new s, this.current = null, this.previous = null, this.MULTI_PIPELINE = null, this.BITMAPMASK_PIPELINE = null, this.UTILITY_PIPELINE = null, this.fullFrame1, this.fullFrame2, this.halfFrame1, this.halfFrame2;
                },
                boot: function(t) {
                    var e, i = this, n = this.game;
                    if (this.classes.each(function(t, e) {
                        s = i.add(t, new e({
                            game: n
                        })), t === o.UTILITY_PIPELINE && (i.UTILITY_PIPELINE = s, i.fullFrame1 = s.fullFrame1, i.fullFrame2 = s.fullFrame2, i.halfFrame1 = s.halfFrame1, i.halfFrame2 = s.halfFrame2);
                    }), this.MULTI_PIPELINE = this.get(o.MULTI_PIPELINE), this.BITMAPMASK_PIPELINE = this.get(o.BITMAPMASK_PIPELINE), t) for(e in t){
                        var s, r = t[e];
                        (s = new r(n)).isPostFX ? this.postPipelineClasses.set(e, r) : this.has(e) || (this.classes.set(e, r), this.add(e, s));
                    }
                },
                add: function(t, e) {
                    if (!e.isPostFX) {
                        var i = this.pipelines, n = this.renderer;
                        return i.has(t) ? console.warn("Pipeline exists: " + t) : (e.name = t, e.manager = this, i.set(t, e)), e.hasBooted || e.boot(), 0 !== n.width && 0 !== n.height && e.resize(n.width, n.height), e;
                    }
                    console.warn(t + " is a Post Pipeline. Use `addPostPipeline` instead");
                },
                addPostPipeline: function(t, e) {
                    this.postPipelineClasses.has(t) || this.postPipelineClasses.set(t, e);
                },
                flush: function() {
                    this.current && this.current.flush();
                },
                has: function(t) {
                    var e = this.pipelines;
                    return "string" == typeof t ? e.has(t) : !!e.contains(t);
                },
                get: function(t) {
                    var e = this.pipelines;
                    return "string" == typeof t ? e.get(t) : e.contains(t) ? t : void 0;
                },
                getPostPipeline: function(t, e) {
                    var i, n = this.postPipelineClasses;
                    if ("string" == typeof t ? i = n.get(t) : "function" == typeof t ? n.contains(t) && (i = t) : "object" == typeof t && (i = n.get(t.name)), i) {
                        var s = new i(this.game);
                        return e && (s.gameObject = e), s;
                    }
                },
                remove: function(t, e, i) {
                    void 0 === e && (e = !0), void 0 === i && (i = !0), this.pipelines.delete(t), e && this.classes.delete(t), i && this.postPipelineClasses.delete(t);
                },
                set: function(t, e, i) {
                    if (!t.isPostFX) return this.isCurrent(t, i) || (this.flush(), this.current && this.current.unbind(), (this.current = t).bind(i)), t.updateProjectionMatrix(), t.onBind(e), t;
                },
                preBatch: function(t) {
                    if (t.hasPostPipeline) {
                        this.flush();
                        for(var e = t.postPipelines, i = e.length - 1; 0 <= i; i--){
                            var n = e[i];
                            n.active && n.preBatch(t);
                        }
                    }
                },
                postBatch: function(t) {
                    if (t.hasPostPipeline) {
                        this.flush();
                        for(var e = t.postPipelines, i = 0; i < e.length; i++){
                            var n = e[i];
                            n.active && n.postBatch(t);
                        }
                    }
                },
                preBatchCamera: function(t) {
                    if (t.hasPostPipeline) {
                        this.flush();
                        for(var e = t.postPipelines, i = e.length - 1; 0 <= i; i--){
                            var n = e[i];
                            n.active && n.preBatch(t);
                        }
                    }
                },
                postBatchCamera: function(t) {
                    if (t.hasPostPipeline) {
                        this.flush();
                        for(var e = t.postPipelines, i = 0; i < e.length; i++){
                            var n = e[i];
                            n.active && n.postBatch(t);
                        }
                    }
                },
                isCurrent: function(t, e) {
                    var i = this.renderer, n = this.current;
                    return n && !e && (e = n.currentShader), !(n !== t || e.program !== i.currentProgram);
                },
                copyFrame: function(t, e, i, n, s) {
                    return this.setUtility(this.UTILITY_PIPELINE.copyShader).copyFrame(t, e, i, n, s), this;
                },
                copyToGame: function(t) {
                    return this.setUtility(this.UTILITY_PIPELINE.copyShader).copyToGame(t), this;
                },
                drawFrame: function(t, e, i, n) {
                    return this.setUtility(this.UTILITY_PIPELINE.colorMatrixShader).drawFrame(t, e, i, n), this;
                },
                blendFrames: function(t, e, i, n, s) {
                    return this.setUtility(this.UTILITY_PIPELINE.linearShader).blendFrames(t, e, i, n, s), this;
                },
                blendFramesAdditive: function(t, e, i, n, s) {
                    return this.setUtility(this.UTILITY_PIPELINE.addShader).blendFramesAdditive(t, e, i, n, s), this;
                },
                clearFrame: function(t, e) {
                    return this.UTILITY_PIPELINE.clearFrame(t, e), this;
                },
                blitFrame: function(t, e, i, n, s, r) {
                    return this.setUtility(this.UTILITY_PIPELINE.copyShader).blitFrame(t, e, i, n, s, r), this;
                },
                copyFrameRect: function(t, e, i, n, s, r, o, a) {
                    return this.UTILITY_PIPELINE.copyFrameRect(t, e, i, n, s, r, o, a), this;
                },
                forceZero: function() {
                    return this.current && this.current.forceZero;
                },
                setMulti: function() {
                    return this.set(this.MULTI_PIPELINE);
                },
                setUtility: function(t) {
                    return this.UTILITY_PIPELINE.bind(t);
                },
                rebind: function(t) {
                    void 0 === t && this.previous && (t = this.previous);
                    var e = this.renderer, i = e.gl;
                    i.disable(i.DEPTH_TEST), i.disable(i.CULL_FACE), e.hasActiveStencilMask() ? i.clear(i.DEPTH_BUFFER_BIT) : (i.disable(i.STENCIL_TEST), i.clear(i.DEPTH_BUFFER_BIT | i.STENCIL_BUFFER_BIT)), i.viewport(0, 0, e.width, e.height), e.currentProgram = null, e.setBlendMode(0, !0), t && (this.current = t).rebind(), e.resetTextures();
                },
                clear: function() {
                    var t = this.renderer;
                    this.flush(), this.current ? (this.current.unbind(), this.previous = this.current, this.current = null) : this.previous = null, t.currentProgram = null, t.setBlendMode(0, !0);
                },
                destroy: function() {
                    this.flush(), this.classes.clear(), this.postPipelineClasses.clear(), this.pipelines.clear(), this.renderer = null, this.game = null, this.classes = null, this.postPipelineClasses = null, this.pipelines = null, this.current = null, this.previous = null;
                }
            });
            t.exports = p;
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = i(862), o = i(863), a = i(104), h = i(57), l = new n({
                Extends: h,
                initialize: function(t) {
                    t.fragShader = s(t, "fragShader", r), t.vertShader = s(t, "vertShader", o), t.batchSize = s(t, "batchSize", 1), t.vertices = s(t, "vertices", [
                        -1,
                        1,
                        -1,
                        -7,
                        7,
                        1
                    ]), t.attributes = s(t, "attributes", [
                        {
                            name: "inPosition",
                            size: 2,
                            type: a.FLOAT
                        }
                    ]), h.call(this, t);
                },
                boot: function() {
                    h.prototype.boot.call(this), this.set1i("uMainSampler", 0), this.set1i("uMaskSampler", 1);
                },
                resize: function(t, e) {
                    h.prototype.resize.call(this, t, e), this.set2f("uResolution", t, e);
                },
                beginMask: function(t, e, i) {
                    var n, s = this.gl;
                    t.bitmapMask && s && ((n = this.renderer).flush(), n.pushFramebuffer(t.mainFramebuffer), s.disable(s.STENCIL_TEST), s.clearColor(0, 0, 0, 0), s.clear(s.COLOR_BUFFER_BIT), n.currentCameraMask.mask !== t && (n.currentMask.mask = t, n.currentMask.camera = i));
                },
                endMask: function(t, e) {
                    var i, n = this.gl, s = this.renderer, r = t.bitmapMask;
                    r && n && (s.flush(), s.pushFramebuffer(t.maskFramebuffer), n.clearColor(0, 0, 0, 0), n.clear(n.COLOR_BUFFER_BIT), s.setBlendMode(0, !0), r.renderWebGL(s, r, e), s.flush(), s.popFramebuffer(), s.popFramebuffer(), (i = s.getCurrentStencilMask()) ? (n.enable(n.STENCIL_TEST), i.mask.applyStencil(s, i.camera, !0)) : s.currentMask.mask = null, s.pipelines.set(this), n.activeTexture(n.TEXTURE1), n.bindTexture(n.TEXTURE_2D, t.maskTexture), n.activeTexture(n.TEXTURE0), n.bindTexture(n.TEXTURE_2D, t.mainTexture), this.set1i("uInvertMaskAlpha", t.invertAlpha), n.drawArrays(this.topology, 0, 3), s.resetTextures());
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            t.exports = {
                AFTER_FLUSH: i(864),
                BEFORE_FLUSH: i(865),
                BIND: i(866),
                BOOT: i(867),
                DESTROY: i(868),
                REBIND: i(869),
                RESIZE: i(870)
            };
        },
        function(t, e, i) {
            var n = i(0), d = i(2), f = i(104), s = new n({
                initialize: function(t, e, i, n, s) {
                    this.pipeline = t, this.name = e, this.renderer = t.renderer, this.gl = this.renderer.gl, this.program = this.renderer.createProgram(i, n), this.attributes, this.vertexComponentCount = 0, this.vertexSize = 0, this.uniforms = {}, this.createAttributes(s), this.createUniforms();
                },
                createAttributes: function(t) {
                    for(var e = 0, i = 0, n = [], s = this.vertexComponentCount = 0; s < t.length; s++){
                        var r = t[s], o = r.name, a = d(r, "size", 1), h = d(r, "type", f.FLOAT), l = h.enum, u = h.size, c = !!r.normalized;
                        n.push({
                            name: o,
                            size: a,
                            type: l,
                            normalized: c,
                            offset: i,
                            enabled: !1,
                            location: -1
                        }), 4 === u ? e += a : e++, i += a * u;
                    }
                    this.vertexSize = i, this.vertexComponentCount = e, this.attributes = n;
                },
                bind: function(t, e) {
                    return void 0 === t && (t = !1), void 0 === e && (e = !1), e && this.pipeline.flush(), this.renderer.setProgram(this.program), t && this.setAttribPointers(), this;
                },
                rebind: function() {
                    return this.renderer.setProgram(this.program), this.setAttribPointers(!0), this;
                },
                setAttribPointers: function(t) {
                    void 0 === t && (t = !1);
                    for(var e = this.gl, i = this.vertexSize, n = this.attributes, s = this.program, r = 0; r < n.length; r++){
                        var o, a = n[r], h = a.size, l = a.type, u = a.offset, c = a.enabled, d = a.location, f = !!a.normalized;
                        t ? 0 <= (o = e.getAttribLocation(s, a.name)) ? (e.enableVertexAttribArray(o), e.vertexAttribPointer(o, h, l, f, i, u), a.enabled = !0, a.location = o) : -1 !== o && e.disableVertexAttribArray(o) : c ? e.vertexAttribPointer(d, h, l, f, i, u) : !c && -1 < d && (e.disableVertexAttribArray(d), a.location = -1);
                    }
                    return this;
                },
                createUniforms: function() {
                    for(var t, e, i = this.gl, n = this.program, s = this.uniforms, r = i.getProgramParameter(n, i.ACTIVE_UNIFORMS), o = 0; o < r; o++){
                        var a, h = i.getActiveUniform(n, o);
                        h && (t = h.name, null !== (e = i.getUniformLocation(n, t)) && (s[t] = {
                            name: t,
                            location: e,
                            value1: null,
                            value2: null,
                            value3: null,
                            value4: null
                        }), 0 < (a = t.indexOf("[")) && (t = t.substr(0, a), s.hasOwnProperty(t) || null !== (e = i.getUniformLocation(n, t)) && (s[t] = {
                            name: t,
                            location: e,
                            value1: null,
                            value2: null,
                            value3: null,
                            value4: null
                        })));
                    }
                    return this;
                },
                hasUniform: function(t) {
                    return this.uniforms.hasOwnProperty(t);
                },
                resetUniform: function(t) {
                    var e = this.uniforms[t];
                    return e && (e.value1 = null, e.value2 = null, e.value3 = null, e.value4 = null), this;
                },
                setUniform1: function(t, e, i) {
                    var n = this.uniforms[e];
                    return n && n.value1 !== i && (n.value1 = i, this.renderer.setProgram(this.program), t.call(this.gl, n.location, i), this.pipeline.currentShader = this), this;
                },
                setUniform2: function(t, e, i, n) {
                    var s = this.uniforms[e];
                    return s && (s.value1 === i && s.value2 === n || (s.value1 = i, s.value2 = n, this.renderer.setProgram(this.program), t.call(this.gl, s.location, i, n), this.pipeline.currentShader = this)), this;
                },
                setUniform3: function(t, e, i, n, s) {
                    var r = this.uniforms[e];
                    return r && (r.value1 === i && r.value2 === n && r.value3 === s || (r.value1 = i, r.value2 = n, r.value3 = s, this.renderer.setProgram(this.program), t.call(this.gl, r.location, i, n, s), this.pipeline.currentShader = this)), this;
                },
                setUniform4: function(t, e, i, n, s, r) {
                    var o = this.uniforms[e];
                    return o && (o.value1 === i && o.value2 === n && o.value3 === s && o.value4 === r || (o.value1 = i, o.value2 = n, o.value3 = s, o.value4 = r, this.renderer.setProgram(this.program), t.call(this.gl, o.location, i, n, s, r), this.pipeline.currentShader = this)), this;
                },
                set1f: function(t, e) {
                    return this.setUniform1(this.gl.uniform1f, t, e);
                },
                set2f: function(t, e, i) {
                    return this.setUniform2(this.gl.uniform2f, t, e, i);
                },
                set3f: function(t, e, i, n) {
                    return this.setUniform3(this.gl.uniform3f, t, e, i, n);
                },
                set4f: function(t, e, i, n, s) {
                    return this.setUniform4(this.gl.uniform4f, t, e, i, n, s);
                },
                set1fv: function(t, e) {
                    return this.setUniform1(this.gl.uniform1fv, t, e);
                },
                set2fv: function(t, e) {
                    return this.setUniform1(this.gl.uniform2fv, t, e);
                },
                set3fv: function(t, e) {
                    return this.setUniform1(this.gl.uniform3fv, t, e);
                },
                set4fv: function(t, e) {
                    return this.setUniform1(this.gl.uniform4fv, t, e);
                },
                set1iv: function(t, e) {
                    return this.setUniform1(this.gl.uniform1iv, t, e);
                },
                set2iv: function(t, e) {
                    return this.setUniform1(this.gl.uniform2iv, t, e);
                },
                set3iv: function(t, e) {
                    return this.setUniform1(this.gl.uniform3iv, t, e);
                },
                set4iv: function(t, e) {
                    return this.setUniform1(this.gl.uniform4iv, t, e);
                },
                set1i: function(t, e) {
                    return this.setUniform1(this.gl.uniform1i, t, e);
                },
                set2i: function(t, e, i) {
                    return this.setUniform2(this.gl.uniform2i, t, e, i);
                },
                set3i: function(t, e, i, n) {
                    return this.setUniform3(this.gl.uniform3i, t, e, i, n);
                },
                set4i: function(t, e, i, n, s) {
                    return this.setUniform4(this.gl.uniform4i, t, e, i, n, s);
                },
                setMatrix2fv: function(t, e, i) {
                    return this.setUniform2(this.gl.uniformMatrix2fv, t, e, i);
                },
                setMatrix3fv: function(t, e, i) {
                    return this.setUniform2(this.gl.uniformMatrix3fv, t, e, i);
                },
                setMatrix4fv: function(t, e, i) {
                    return this.setUniform2(this.gl.uniformMatrix4fv, t, e, i);
                },
                destroy: function() {
                    this.gl.deleteProgram(this.program), this.pipeline = null, this.renderer = null, this.gl = null, this.program = null, this.attributes = null, this.uniforms = null;
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(0), M = i(68), s = i(2), r = i(871), o = i(872), a = i(25), h = i(104), l = i(57), u = new n({
                Extends: l,
                initialize: function(t) {
                    t.fragShader = s(t, "fragShader", r), t.vertShader = s(t, "vertShader", o), t.attributes = s(t, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inColor",
                            size: 4,
                            type: h.UNSIGNED_BYTE,
                            normalized: !0
                        }
                    ]), l.call(this, t), this.calcMatrix = new a, this.tempTriangle = [
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        }
                    ], this.strokeTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    }, this.fillTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    }, this.currentFrame = {
                        u0: 0,
                        v0: 0,
                        u1: 1,
                        v1: 1
                    }, this.firstQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.prevQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.polygonCache = [];
                },
                batchFillRect: function(t, e, i, n, s, r) {
                    this.renderer.pipelines.set(this);
                    var o = this.calcMatrix;
                    r && r.multiply(s, o);
                    var a = t + i, h = e + n, l = o.getX(t, e), u = o.getY(t, e), c = o.getX(t, h), d = o.getY(t, h), f = o.getX(a, h), p = o.getY(a, h), g = o.getX(a, e), v = o.getY(a, e), m = this.fillTint;
                    this.batchQuad(l, u, c, d, f, p, g, v, m.TL, m.TR, m.BL, m.BR);
                },
                batchFillTriangle: function(t, e, i, n, s, r, o, a) {
                    this.renderer.pipelines.set(this);
                    var h = this.calcMatrix;
                    a && a.multiply(o, h);
                    var l = h.getX(t, e), u = h.getY(t, e), c = h.getX(i, n), d = h.getY(i, n), f = h.getX(s, r), p = h.getY(s, r), g = this.fillTint;
                    this.batchTri(l, u, c, d, f, p, g.TL, g.TR, g.BL);
                },
                batchStrokeTriangle: function(t, e, i, n, s, r, o, a, h) {
                    var l = this.tempTriangle;
                    l[0].x = t, l[0].y = e, l[0].width = o, l[1].x = i, l[1].y = n, l[1].width = o, l[2].x = s, l[2].y = r, l[2].width = o, l[3].x = t, l[3].y = e, l[3].width = o, this.batchStrokePath(l, o, !1, a, h);
                },
                batchFillPath: function(t, e, i) {
                    this.renderer.pipelines.set(this);
                    var n = this.calcMatrix;
                    i && i.multiply(e, n);
                    for(var s, r, o = t.length, a = this.polygonCache, h = this.fillTint.TL, l = this.fillTint.TR, u = this.fillTint.BL, c = 0; c < o; ++c)r = t[c], a.push(r.x, r.y);
                    o = (s = M(a)).length;
                    for(var d = 0; d < o; d += 3){
                        var f = 2 * s[d + 0], p = 2 * s[d + 1], g = 2 * s[d + 2], v = a[0 + f], m = a[1 + f], y = a[0 + p], x = a[1 + p], T = a[0 + g], w = a[1 + g], b = n.getX(v, m), E = n.getY(v, m), S = n.getX(y, x), A = n.getY(y, x), _ = n.getX(T, w), C = n.getY(T, w);
                        this.batchTri(b, E, S, A, _, C, h, l, u);
                    }
                    a.length = 0;
                },
                batchStrokePath: function(t, e, i, n, s) {
                    this.renderer.pipelines.set(this), this.prevQuad[4] = 0, this.firstQuad[4] = 0;
                    for(var r = t.length - 1, o = 0; o < r; o++){
                        var a = t[o], h = t[o + 1];
                        this.batchLine(a.x, a.y, h.x, h.y, a.width / 2, h.width / 2, e, o, !i && o === r - 1, n, s);
                    }
                },
                batchLine: function(t, e, i, n, s, r, o, a, h, l, u) {
                    this.renderer.pipelines.set(this);
                    var c = this.calcMatrix;
                    u && u.multiply(l, c);
                    var d, f, p = i - t, g = n - e, v = Math.sqrt(p * p + g * g), m = s * (n - e) / v, y = s * (t - i) / v, x = r * (n - e) / v, T = r * (t - i) / v, w = i - x, b = n - T, E = t - m, S = e - y, A = i + x, _ = n + T, C = t + m, M = e + y, R = c.getX(w, b), P = c.getY(w, b), O = c.getX(E, S), L = c.getY(E, S), D = c.getX(A, _), F = c.getY(A, _), k = c.getX(C, M), I = c.getY(C, M), B = this.strokeTint, N = B.TL, Y = B.TR, U = B.BL, X = B.BR;
                    this.batchQuad(k, I, O, L, R, P, D, F, N, Y, U, X), o <= 2 || (d = this.prevQuad, f = this.firstQuad, 0 < a && d[4] ? this.batchQuad(k, I, O, L, d[0], d[1], d[2], d[3], N, Y, U, X) : (f[0] = k, f[1] = I, f[2] = O, f[3] = L, f[4] = 1), h && f[4] ? this.batchQuad(R, P, D, F, f[0], f[1], f[2], f[3], N, Y, U, X) : (d[0] = R, d[1] = P, d[2] = D, d[3] = F, d[4] = 1));
                },
                batchVert: function(t, e, i) {
                    var n = this.vertexViewF32, s = this.vertexViewU32, r = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    n[++r] = t, n[++r] = e, s[++r] = i, this.vertexCount++;
                },
                batchQuad: function(t, e, i, n, s, r, o, a, h, l, u, c) {
                    var d = !1;
                    return this.shouldFlush(6) && (this.flush(), d = !0), this.batchVert(t, e, h), this.batchVert(i, n, u), this.batchVert(s, r, c), this.batchVert(t, e, h), this.batchVert(s, r, c), this.batchVert(o, a, l), d;
                },
                batchTri: function(t, e, i, n, s, r, o, a, h) {
                    var l = !1;
                    return this.shouldFlush(3) && (this.flush(), l = !0), this.batchVert(t, e, o), this.batchVert(i, n, a), this.batchVert(s, r, h), l;
                },
                destroy: function() {
                    return l.prototype.destroy.call(this), this.polygonCache = null, this;
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = i(873), o = i(105), a = i(3), h = i(57), l = 10, c = new a, u = new n({
                Extends: o,
                initialize: function(t) {
                    l = t.game.renderer.config.maxLights;
                    for(var e = s(t, "fragShader", r), i = [], n = 1; n <= l; n++)i.push({
                        name: "lights" + n,
                        fragShader: e.replace("%LIGHT_COUNT%", n.toString())
                    });
                    t.shaders = i, o.call(this, t), this.inverseRotationMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1
                    ]), this.defaultNormalMap;
                },
                boot: function() {
                    h.prototype.boot.call(this);
                    var t = this.gl, e = t.createTexture();
                    t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, e), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, new Uint8Array([
                        127,
                        127,
                        255,
                        255
                    ])), this.defaultNormalMap = {
                        glTexture: e
                    };
                    for(var i = 0; i < this.shaders.length; i++)this["lightShader" + (i + 1)] = this.shaders[i];
                },
                onRender: function(t, e) {
                    var i = t.sys.lights;
                    if (i && i.active) {
                        var n, s = i.getLights(e), r = s.length;
                        if (0 !== r) {
                            this.setShader(this["lightShader" + r], !0);
                            var o = this.renderer.height, a = e.matrix;
                            for(this.set1i("uMainSampler", 0), this.set1i("uNormSampler", 1), this.set2f("uResolution", this.width / 2, this.height / 2), this.set4f("uCamera", e.x, e.y, e.rotation, e.zoom), this.set3f("uAmbientLightColor", i.ambientColor.r, i.ambientColor.g, i.ambientColor.b), n = 0; n < r; n++){
                                var h = s[n].light, l = h.color, u = "uLights[" + n + "].";
                                a.transformPoint(h.x, h.y, c), this.set2f(u + "position", c.x - e.scrollX * h.scrollFactorX * e.zoom, o - (c.y - e.scrollY * h.scrollFactorY * e.zoom)), this.set3f(u + "color", l.r, l.g, l.b), this.set1f(u + "intensity", h.intensity), this.set1f(u + "radius", h.radius);
                            }
                            this.currentNormalMapRotation = null;
                        }
                    }
                },
                setNormalMapRotation: function(t) {
                    var e, i, n, s;
                    t === this.currentNormalMapRotation && 0 !== this.vertexCount || (0 < this.vertexCount && this.flush(), e = this.inverseRotationMatrix, t ? (i = -t, n = Math.cos(i), s = Math.sin(i), e[1] = s, e[3] = -s, e[0] = e[4] = n) : (e[0] = e[4] = 1, e[1] = e[3] = 0), this.setMatrix3fv("uInverseRotationMatrix", !1, e), this.currentNormalMapRotation = t);
                },
                setTexture2D: function(t, e) {
                    var i = this.renderer;
                    void 0 === t && (t = i.tempTextures[0]);
                    var n = this.getNormalMap(e);
                    i.isNewNormalMap(t, n) && (this.flush(), i.setTextureZero(t), i.setNormalMap(n));
                    var s = e ? e.rotation : 0;
                    return this.setNormalMapRotation(s), this.currentUnit = 0;
                },
                setGameObject: function(t, e) {
                    void 0 === e && (e = t.frame);
                    var i = this.renderer, n = e.glTexture, s = this.getNormalMap(t);
                    return i.isNewNormalMap() && (this.flush(), i.setTextureZero(n), i.setNormalMap(s)), this.setNormalMapRotation(t.rotation), this.currentUnit = 0;
                },
                getNormalMap: function(t) {
                    var e;
                    return t ? t.displayTexture ? e = t.displayTexture.dataSource[t.displayFrame.sourceIndex] : t.texture ? e = t.texture.dataSource[t.frame.sourceIndex] : t.tileset && (e = Array.isArray(t.tileset) ? t.tileset[0].image.dataSource[0] : t.tileset.image.dataSource[0]) : e = this.defaultNormalMap, (e = e || this.defaultNormalMap).glTexture;
                }
            });
            u.LIGHT_COUNT = l, t.exports = u;
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = i(876), o = i(877), a = i(57), h = new n({
                Extends: a,
                initialize: function(t) {
                    t.vertShader = s(t, "vertShader", o), t.fragShader = s(t, "fragShader", r), t.attributes = s(t, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inLightPosition",
                            size: 2
                        },
                        {
                            name: "inLightRadius"
                        },
                        {
                            name: "inLightAttenuation"
                        },
                        {
                            name: "inLightColor",
                            size: 4
                        }
                    ]), a.call(this, t);
                },
                onRender: function(t, e) {
                    this.set2f("uResolution", this.width, this.height), this.set1f("uCameraZoom", e.zoom);
                },
                batchPointLight: function(t, e, i, n, s, r, o, a, h, l, u, c) {
                    var d = t.color, f = t.intensity, p = t.radius, g = t.attenuation, v = d.r * f, m = d.g * f, y = d.b * f, x = e.alpha * t.alpha;
                    this.shouldFlush(6) && this.flush(), this.batchLightVert(i, n, u, c, p, g, v, m, y, x), this.batchLightVert(s, r, u, c, p, g, v, m, y, x), this.batchLightVert(o, a, u, c, p, g, v, m, y, x), this.batchLightVert(i, n, u, c, p, g, v, m, y, x), this.batchLightVert(o, a, u, c, p, g, v, m, y, x), this.batchLightVert(h, l, u, c, p, g, v, m, y, x);
                },
                batchLightVert: function(t, e, i, n, s, r, o, a, h, l) {
                    var u = this.vertexViewF32, c = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    u[++c] = t, u[++c] = e, u[++c] = i, u[++c] = n, u[++c] = s, u[++c] = r, u[++c] = o, u[++c] = a, u[++c] = h, u[++c] = l, this.vertexCount++;
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = i(105), o = new n({
                Extends: r,
                initialize: function(t) {
                    t.topology = 5, t.batchSize = s(t, "batchSize", 256), r.call(this, t);
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = i(105), o = i(878), a = i(879), h = i(57), l = new n({
                Extends: r,
                initialize: function(t) {
                    t.fragShader = s(t, "fragShader", o), t.vertShader = s(t, "vertShader", a), t.forceZero = !0, r.call(this, t);
                },
                boot: function() {
                    h.prototype.boot.call(this), this.set1i("uMainSampler", 0);
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            var n = i(880), l = i(34), s = i(0), r = i(195), o = i(881), a = i(882), h = i(2), u = i(883), c = i(376), d = i(57), f = new s({
                Extends: d,
                initialize: function(t) {
                    t.renderTarget = h(t, "renderTarget", [
                        {
                            scale: 1
                        },
                        {
                            scale: 1
                        },
                        {
                            scale: .5
                        },
                        {
                            scale: .5
                        }
                    ]), t.vertShader = h(t, "vertShader", c), t.shaders = h(t, "shaders", [
                        {
                            name: "Copy",
                            fragShader: a
                        },
                        {
                            name: "AddBlend",
                            fragShader: n
                        },
                        {
                            name: "LinearBlend",
                            fragShader: u
                        },
                        {
                            name: "ColorMatrix",
                            fragShader: o
                        }
                    ]), t.attributes = h(t, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inTexCoord",
                            size: 2
                        }
                    ]), t.vertices = [
                        -1,
                        -1,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        -1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        1,
                        0
                    ], t.batchSize = 1, d.call(this, t), this.colorMatrix = new r, this.copyShader, this.addShader, this.linearShader, this.colorMatrixShader, this.fullFrame1, this.fullFrame2, this.halfFrame1, this.halfFrame2;
                },
                boot: function() {
                    d.prototype.boot.call(this);
                    var t = this.shaders, e = this.renderTargets;
                    this.copyShader = t[0], this.addShader = t[1], this.linearShader = t[2], this.colorMatrixShader = t[3], this.fullFrame1 = e[0], this.fullFrame2 = e[1], this.halfFrame1 = e[2], this.halfFrame2 = e[3];
                },
                copyFrame: function(t, e, i, n, s) {
                    void 0 === i && (i = 1), void 0 === n && (n = !0), void 0 === s && (s = !0);
                    var r = this.gl;
                    this.setShader(this.copyShader), this.set1i("uMainSampler", 0), this.set1f("uBrightness", i), r.activeTexture(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, t.texture), e ? (r.viewport(0, 0, e.width, e.height), r.bindFramebuffer(r.FRAMEBUFFER, e.framebuffer), r.framebufferTexture2D(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, e.texture, 0)) : r.viewport(0, 0, t.width, t.height), n && (s ? r.clearColor(0, 0, 0, 0) : r.clearColor(0, 0, 0, 1), r.clear(r.COLOR_BUFFER_BIT)), r.bufferData(r.ARRAY_BUFFER, this.vertexData, r.STATIC_DRAW), r.drawArrays(r.TRIANGLES, 0, 6), r.bindFramebuffer(r.FRAMEBUFFER, null), r.bindTexture(r.TEXTURE_2D, null);
                },
                blitFrame: function(t, e, i, n, s, r) {
                    void 0 === i && (i = 1), void 0 === n && (n = !0), void 0 === s && (s = !0), void 0 === r && (r = !1);
                    var o, a, h = this.gl;
                    this.setShader(this.copyShader), this.set1i("uMainSampler", 0), this.set1f("uBrightness", i), h.activeTexture(h.TEXTURE0), h.bindTexture(h.TEXTURE_2D, t.texture), t.height > e.height ? (h.viewport(0, 0, t.width, t.height), this.setTargetUVs(t, e)) : (o = e.height - t.height, h.viewport(0, o, t.width, t.height)), h.bindFramebuffer(h.FRAMEBUFFER, e.framebuffer), h.framebufferTexture2D(h.FRAMEBUFFER, h.COLOR_ATTACHMENT0, h.TEXTURE_2D, e.texture, 0), n && (s ? h.clearColor(0, 0, 0, 0) : h.clearColor(0, 0, 0, 1), h.clear(h.COLOR_BUFFER_BIT)), r && (a = this.renderer.currentBlendMode, this.renderer.setBlendMode(l.ERASE)), h.bufferData(h.ARRAY_BUFFER, this.vertexData, h.STATIC_DRAW), h.drawArrays(h.TRIANGLES, 0, 6), r && this.renderer.setBlendMode(a), h.bindFramebuffer(h.FRAMEBUFFER, null), h.bindTexture(h.TEXTURE_2D, null), this.resetUVs();
                },
                copyFrameRect: function(t, e, i, n, s, r, o, a) {
                    void 0 === o && (o = !0), void 0 === a && (a = !0);
                    var h = this.gl;
                    h.bindFramebuffer(h.FRAMEBUFFER, t.framebuffer), h.framebufferTexture2D(h.FRAMEBUFFER, h.COLOR_ATTACHMENT0, h.TEXTURE_2D, t.texture, 0), o && (a ? h.clearColor(0, 0, 0, 0) : h.clearColor(0, 0, 0, 1), h.clear(h.COLOR_BUFFER_BIT)), h.activeTexture(h.TEXTURE0), h.bindTexture(h.TEXTURE_2D, e.texture), h.copyTexSubImage2D(h.TEXTURE_2D, 0, 0, 0, i, n, s, r), h.bindFramebuffer(h.FRAMEBUFFER, null), h.bindTexture(h.TEXTURE_2D, null);
                },
                copyToGame: function(t) {
                    var e = this.gl;
                    this.setShader(this.copyShader), this.set1i("uMainSampler", 0), this.set1f("uBrightness", 1), this.renderer.popFramebuffer(), e.activeTexture(e.TEXTURE0), e.bindTexture(e.TEXTURE_2D, t.texture), e.bufferData(e.ARRAY_BUFFER, this.vertexData, e.STATIC_DRAW), e.drawArrays(e.TRIANGLES, 0, 6), this.renderer.resetTextures();
                },
                drawFrame: function(t, e, i, n) {
                    void 0 === i && (i = !0), void 0 === n && (n = this.colorMatrix);
                    var s = this.gl;
                    this.setShader(this.colorMatrixShader), this.set1i("uMainSampler", 0), this.set1fv("uColorMatrix", n.getData()), this.set1f("uAlpha", n.alpha), s.activeTexture(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, t.texture), e ? (s.viewport(0, 0, e.width, e.height), s.bindFramebuffer(s.FRAMEBUFFER, e.framebuffer), s.framebufferTexture2D(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_2D, e.texture, 0)) : s.viewport(0, 0, t.width, t.height), i ? s.clearColor(0, 0, 0, 0) : s.clearColor(0, 0, 0, 1), s.clear(s.COLOR_BUFFER_BIT), s.bufferData(s.ARRAY_BUFFER, this.vertexData, s.STATIC_DRAW), s.drawArrays(s.TRIANGLES, 0, 6), s.bindFramebuffer(s.FRAMEBUFFER, null), s.bindTexture(s.TEXTURE_2D, null);
                },
                blendFrames: function(t, e, i, n, s, r) {
                    void 0 === n && (n = 1), void 0 === s && (s = !0), void 0 === r && (r = this.linearShader);
                    var o = this.gl;
                    this.setShader(r), this.set1i("uMainSampler1", 0), this.set1i("uMainSampler2", 1), this.set1f("uStrength", n), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, t.texture), o.activeTexture(o.TEXTURE1), o.bindTexture(o.TEXTURE_2D, e.texture), i ? (o.bindFramebuffer(o.FRAMEBUFFER, i.framebuffer), o.framebufferTexture2D(o.FRAMEBUFFER, o.COLOR_ATTACHMENT0, o.TEXTURE_2D, i.texture, 0), o.viewport(0, 0, i.width, i.height)) : o.viewport(0, 0, t.width, t.height), s ? o.clearColor(0, 0, 0, 0) : o.clearColor(0, 0, 0, 1), o.clear(o.COLOR_BUFFER_BIT), o.bufferData(o.ARRAY_BUFFER, this.vertexData, o.STATIC_DRAW), o.drawArrays(o.TRIANGLES, 0, 6), o.bindFramebuffer(o.FRAMEBUFFER, null), o.bindTexture(o.TEXTURE_2D, null);
                },
                blendFramesAdditive: function(t, e, i, n, s) {
                    this.blendFrames(t, e, i, n, s, this.addShader);
                },
                clearFrame: function(t, e) {
                    void 0 === e && (e = !0);
                    var i = this.gl;
                    i.viewport(0, 0, t.width, t.height), i.bindFramebuffer(i.FRAMEBUFFER, t.framebuffer), e ? i.clearColor(0, 0, 0, 0) : i.clearColor(0, 0, 0, 1), i.clear(i.COLOR_BUFFER_BIT);
                    var n = this.renderer.currentFramebuffer;
                    i.bindFramebuffer(i.FRAMEBUFFER, n);
                },
                setUVs: function(t, e, i, n, s, r, o, a) {
                    var h = this.vertexViewF32;
                    h[2] = t, h[3] = e, h[6] = i, h[7] = n, h[10] = s, h[11] = r, h[14] = t, h[15] = e, h[18] = s, h[19] = r, h[22] = o, h[23] = a;
                },
                setTargetUVs: function(t, e) {
                    var i = .5 < (i = e.height / t.height) ? .5 - (i - .5) : .5 - i + .5;
                    this.setUVs(0, i, 0, 1 + i, 1, 1 + i, 1, i);
                },
                flipX: function() {
                    this.setUVs(1, 0, 1, 1, 0, 1, 0, 0);
                },
                flipY: function() {
                    this.setUVs(0, 1, 0, 0, 1, 0, 1, 1);
                },
                resetUVs: function() {
                    this.setUVs(0, 0, 0, 1, 1, 1, 1, 0);
                }
            });
            t.exports = f;
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_QUAD_VS",
                "",
                "precision mediump float;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inTexCoord;",
                "",
                "varying vec2 outFragCoord;",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    outFragCoord = inPosition.xy * 0.5 + 0.5;",
                "    outTexCoord = inTexCoord;",
                "",
                "    gl_Position = vec4(inPosition, 0, 1);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e, i) {
            var _ = i(31), C = i(37), M = i(2);
            t.exports = function(t, e) {
                var i = t.getContext("experimental-webgl"), n = M(e, "callback"), s = M(e, "type", "image/png"), r = M(e, "encoder", .92), o = M(e, "x", 0), a = M(e, "y", 0), h = M(e, "getPixel", !1), l = M(e, "isFramebuffer", !1), u = l ? M(e, "bufferWidth", 1) : i.drawingBufferWidth, c = l ? M(e, "bufferHeight", 1) : i.drawingBufferHeight;
                if (h) {
                    var d = new Uint8Array(4), f = l ? a : c - a;
                    i.readPixels(o, f, 1, 1, i.RGBA, i.UNSIGNED_BYTE, d), n.call(null, new C(d[0], d[1], d[2], d[3] / 255));
                } else {
                    var p = M(e, "width", u), g = M(e, "height", c), v = new Uint8Array(p * g * 4);
                    i.readPixels(o, c - a - g, p, g, i.RGBA, i.UNSIGNED_BYTE, v);
                    for(var m = _.createWebGL(this, p, g), y = m.getContext("2d"), x = y.getImageData(0, 0, p, g), T = x.data, w = 0; w < g; w++)for(var b = 0; b < p; b++){
                        var E = 4 * ((g - w - 1) * p + b), S = 4 * (w * p + b);
                        T[0 + S] = v[0 + E], T[1 + S] = v[1 + E], T[2 + S] = v[2 + E], T[3 + S] = v[3 + E];
                    }
                    y.putImageData(x, 0, 0);
                    var A = new Image;
                    A.onerror = function() {
                        n.call(null), _.remove(m);
                    }, A.onload = function() {
                        n.call(null, A), _.remove(m);
                    }, A.src = m.toDataURL(s, r);
                }
            };
        },
        function(t, e, i) {
            var l = i(32);
            t.exports = function(t) {
                var e, i, n, s, r, o, a, h = t.config;
                h.hideBanner || (e = "WebGL", h.renderType === l.CANVAS ? e = "Canvas" : h.renderType === l.HEADLESS && (e = "Headless"), i = h.audio, a = (n = t.device.audio).webAudio && !i.disableWebAudio ? "Web Audio" : i.noAudio || !n.webAudio && !n.audioData ? "No Audio" : "HTML5 Audio", t.device.browser.ie ? window.console && console.log("Phaser v" + l.VERSION + " / https://phaser.io") : (r = [
                    s = ""
                ], Array.isArray(h.bannerBackgroundColor) ? (h.bannerBackgroundColor.forEach(function(t) {
                    s = s.concat("%c "), r.push("background: " + t), o = t;
                }), r[r.length - 1] = "color: " + h.bannerTextColor + "; background: " + o) : (s = s.concat("%c "), r.push("color: " + h.bannerTextColor + "; background: " + h.bannerBackgroundColor)), r.push("background: transparent"), h.gameTitle && (s = s.concat(h.gameTitle), h.gameVersion && (s = s.concat(" v" + h.gameVersion)), h.hidePhaser || (s = s.concat(" / "))), h.hidePhaser || (s = s.concat("Phaser v" + l.VERSION + " (" + e + " | " + a + ")")), s = s.concat(" %c " + h.gameURL), r[0] = s, console.log.apply(console, r)));
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(6), r = i(1), o = i(380), a = new n({
                initialize: function(t, e) {
                    this.game = t, this.raf = new o, this.started = !1, this.running = !1, this.minFps = s(e, "min", 5), this.targetFps = s(e, "target", 60), this._min = 1e3 / this.minFps, this._target = 1e3 / this.targetFps, this.actualFps = this.targetFps, this.nextFpsUpdate = 0, this.framesThisSecond = 0, this.callback = r, this.forceSetTimeOut = s(e, "forceSetTimeOut", !1), this.time = 0, this.startTime = 0, this.lastTime = 0, this.frame = 0, this.inFocus = !0, this._pauseTime = 0, this._coolDown = 0, this.delta = 0, this.deltaIndex = 0, this.deltaHistory = [], this.deltaSmoothingMax = s(e, "deltaHistory", 10), this.panicMax = s(e, "panicMax", 120), this.rawDelta = 0, this.now = 0, this.smoothStep = s(e, "smoothStep", !0);
                },
                blur: function() {
                    this.inFocus = !1;
                },
                focus: function() {
                    this.inFocus = !0, this.resetDelta();
                },
                pause: function() {
                    this._pauseTime = window.performance.now();
                },
                resume: function() {
                    this.resetDelta(), this.startTime += this.time - this._pauseTime;
                },
                resetDelta: function() {
                    var t = window.performance.now();
                    this.time = t, this.lastTime = t, this.nextFpsUpdate = t + 1e3;
                    for(var e = this.framesThisSecond = 0; e < this.deltaSmoothingMax; e++)this.deltaHistory[e] = Math.min(this._target, this.deltaHistory[e]);
                    this.delta = 0, this.deltaIndex = 0, this._coolDown = this.panicMax;
                },
                start: function(t) {
                    if (this.started) return this;
                    this.started = !0, this.running = !0;
                    for(var e = 0; e < this.deltaSmoothingMax; e++)this.deltaHistory[e] = this._target;
                    this.resetDelta(), this.startTime = window.performance.now(), this.callback = t, this.raf.start(this.step.bind(this), this.forceSetTimeOut, this._target);
                },
                step: function() {
                    var t = window.performance.now(), e = (this.now = t) - this.lastTime;
                    e < 0 && (e = 0), this.rawDelta = e;
                    var i = this.deltaIndex, n = this.deltaHistory, s = this.deltaSmoothingMax, r = e, o = e;
                    if (this.smoothStep) {
                        (0 < this._coolDown || !this.inFocus) && (this._coolDown--, r = Math.min(r, this._target)), r > this._min && (r = n[i], r = Math.min(r, this._min)), n[i] = r, this.deltaIndex++, this.deltaIndex > s && (this.deltaIndex = 0);
                        for(var a = o = 0; a < s; a++)o += n[a];
                        o /= s;
                    }
                    this.delta = o, this.time += this.rawDelta, t > this.nextFpsUpdate && (this.actualFps = .25 * this.framesThisSecond + .75 * this.actualFps, this.nextFpsUpdate = t + 1e3, this.framesThisSecond = 0), this.framesThisSecond++;
                    var h = o / this._target;
                    this.callback(t, o, h), this.lastTime = t, this.frame++;
                },
                tick: function() {
                    this.step();
                },
                sleep: function() {
                    this.running && (this.raf.stop(), this.running = !1);
                },
                wake: function(t) {
                    this.running || (t && (this.startTime += -this.lastTime + (this.lastTime + window.performance.now())), this.raf.start(this.step.bind(this), this.useRAF), this.running = !0, this.step());
                },
                getDuration: function() {
                    return Math.round(this.lastTime - this.startTime) / 1e3;
                },
                getDurationMS: function() {
                    return Math.round(this.lastTime - this.startTime);
                },
                stop: function() {
                    return this.running = !1, this.started = !1, this.raf.stop(), this;
                },
                destroy: function() {
                    this.stop(), this.callback = r, this.raf = null, this.game = null;
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(1), r = new n({
                initialize: function() {
                    this.isRunning = !1, this.callback = s, this.tick = 0, this.isSetTimeOut = !1, this.timeOutID = null, this.lastTime = 0, this.target = 0;
                    var n = this;
                    this.step = function t() {
                        var e = window.performance.now();
                        n.lastTime = n.tick, n.tick = e, n.callback(e), n.timeOutID = window.requestAnimationFrame(t);
                    }, this.stepTimeout = function t() {
                        var e = Date.now(), i = Math.min(Math.max(2 * n.target + n.tick - e, 0), n.target);
                        n.lastTime = n.tick, n.tick = e, n.callback(e), n.timeOutID = window.setTimeout(t, i);
                    };
                },
                start: function(t, e, i) {
                    this.isRunning || (this.callback = t, this.isSetTimeOut = e, this.target = i, this.isRunning = !0, this.timeOutID = e ? window.setTimeout(this.stepTimeout, 0) : window.requestAnimationFrame(this.step));
                },
                stop: function() {
                    this.isRunning = !1, this.isSetTimeOut ? clearTimeout(this.timeOutID) : window.cancelAnimationFrame(this.timeOutID);
                },
                destroy: function() {
                    this.stop(), this.callback = s;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(22);
            t.exports = function(t) {
                var e, i = t.events;
                void 0 !== document.hidden ? e = "visibilitychange" : [
                    "webkit",
                    "moz",
                    "ms"
                ].forEach(function(t) {
                    void 0 !== document[t + "Hidden"] && (document.hidden = function() {
                        return document[t + "Hidden"];
                    }, e = t + "visibilitychange");
                });
                e && document.addEventListener(e, function(t) {
                    document.hidden || "pause" === t.type ? i.emit(n.HIDDEN) : i.emit(n.VISIBLE);
                }, !1), window.onblur = function() {
                    i.emit(n.BLUR);
                }, window.onfocus = function() {
                    i.emit(n.FOCUS);
                }, window.focus && t.config.autoFocus && window.focus();
            };
        },
        function(t, e, i) {
            var m = i(383), y = i(31), x = i(6);
            t.exports = function(t) {
                var e = x(t, "data", []), i = x(t, "canvas", null), n = x(t, "palette", m), s = x(t, "pixelWidth", 1), r = x(t, "pixelHeight", s), o = x(t, "resizeCanvas", !0), a = x(t, "clearCanvas", !0), h = x(t, "preRender", null), l = x(t, "postRender", null), u = Math.floor(Math.abs(e[0].length * s)), c = Math.floor(Math.abs(e.length * r));
                i || (i = y.create2D(this, u, c), a = o = !1), o && (i.width = u, i.height = c);
                var d = i.getContext("2d");
                a && d.clearRect(0, 0, u, c), h && h(i, d);
                for(var f = 0; f < e.length; f++)for(var p = e[f], g = 0; g < p.length; g++){
                    var v = p[g];
                    "." !== v && " " !== v && (d.fillStyle = n[v], d.fillRect(g * s, f * r, s, r));
                }
                return l && l(i, d), i;
            };
        },
        function(t, e) {
            t.exports = {
                0: "#000",
                1: "#9D9D9D",
                2: "#FFF",
                3: "#BE2633",
                4: "#E06F8B",
                5: "#493C2B",
                6: "#A46422",
                7: "#EB8931",
                8: "#F7E26B",
                9: "#2F484E",
                A: "#44891A",
                B: "#A3CE27",
                C: "#1B2632",
                D: "#005784",
                E: "#31A2F2",
                F: "#B2DCEF"
            };
        },
        function(t, e, i) {
            var n = i(0), o = i(352), s = i(90), a = i(3), h = new n({
                Extends: s,
                initialize: function(t, e, i, n) {
                    s.call(this, "CubicBezierCurve"), Array.isArray(t) && (n = new a(t[6], t[7]), i = new a(t[4], t[5]), e = new a(t[2], t[3]), t = new a(t[0], t[1])), this.p0 = t, this.p1 = e, this.p2 = i, this.p3 = n;
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new a), t.copy(this.p0);
                },
                getResolution: function(t) {
                    return t;
                },
                getPoint: function(t, e) {
                    void 0 === e && (e = new a);
                    var i = this.p0, n = this.p1, s = this.p2, r = this.p3;
                    return e.set(o(t, i.x, n.x, s.x, r.x), o(t, i.y, n.y, s.y, r.y));
                },
                draw: function(t, e) {
                    void 0 === e && (e = 32);
                    var i = this.getPoints(e);
                    t.beginPath(), t.moveTo(this.p0.x, this.p0.y);
                    for(var n = 1; n < i.length; n++)t.lineTo(i[n].x, i[n].y);
                    return t.strokePath(), t;
                },
                toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y,
                            this.p2.x,
                            this.p2.y,
                            this.p3.x,
                            this.p3.y
                        ]
                    };
                }
            });
            h.fromJSON = function(t) {
                var e = t.points, i = new a(e[0], e[1]), n = new a(e[2], e[3]), s = new a(e[4], e[5]), r = new a(e[6], e[7]);
                return new h(i, n, s, r);
            }, t.exports = h;
        },
        function(t, e, i) {
            var n = i(0), l = i(90), u = i(35), c = i(6), s = i(193), d = i(3), r = new n({
                Extends: l,
                initialize: function(t, e, i, n, s, r, o, a) {
                    var h;
                    "object" == typeof t ? (t = c(h = t, "x", 0), e = c(h, "y", 0), i = c(h, "xRadius", 0), n = c(h, "yRadius", i), s = c(h, "startAngle", 0), r = c(h, "endAngle", 360), o = c(h, "clockwise", !1), a = c(h, "rotation", 0)) : (void 0 === n && (n = i), void 0 === s && (s = 0), void 0 === r && (r = 360), void 0 === o && (o = !1), void 0 === a && (a = 0)), l.call(this, "EllipseCurve"), this.p0 = new d(t, e), this._xRadius = i, this._yRadius = n, this._startAngle = u(s), this._endAngle = u(r), this._clockwise = o, this._rotation = u(a);
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new d), this.getPoint(0, t);
                },
                getResolution: function(t) {
                    return 2 * t;
                },
                getPoint: function(t, e) {
                    void 0 === e && (e = new d);
                    for(var i = 2 * Math.PI, n = this._endAngle - this._startAngle, s = Math.abs(n) < Number.EPSILON; n < 0;)n += i;
                    for(; i < n;)n -= i;
                    n < Number.EPSILON && (n = s ? 0 : i), this._clockwise && !s && (n === i ? n = -i : n -= i);
                    var r, o, a, h, l = this._startAngle + t * n, u = this.p0.x + this._xRadius * Math.cos(l), c = this.p0.y + this._yRadius * Math.sin(l);
                    return 0 !== this._rotation && (r = Math.cos(this._rotation), o = Math.sin(this._rotation), u = (a = u - this.p0.x) * r - (h = c - this.p0.y) * o + this.p0.x, c = a * o + h * r + this.p0.y), e.set(u, c);
                },
                setXRadius: function(t) {
                    return this.xRadius = t, this;
                },
                setYRadius: function(t) {
                    return this.yRadius = t, this;
                },
                setWidth: function(t) {
                    return this.xRadius = t / 2, this;
                },
                setHeight: function(t) {
                    return this.yRadius = t / 2, this;
                },
                setStartAngle: function(t) {
                    return this.startAngle = t, this;
                },
                setEndAngle: function(t) {
                    return this.endAngle = t, this;
                },
                setClockwise: function(t) {
                    return this.clockwise = t, this;
                },
                setRotation: function(t) {
                    return this.rotation = t, this;
                },
                x: {
                    get: function() {
                        return this.p0.x;
                    },
                    set: function(t) {
                        this.p0.x = t;
                    }
                },
                y: {
                    get: function() {
                        return this.p0.y;
                    },
                    set: function(t) {
                        this.p0.y = t;
                    }
                },
                xRadius: {
                    get: function() {
                        return this._xRadius;
                    },
                    set: function(t) {
                        this._xRadius = t;
                    }
                },
                yRadius: {
                    get: function() {
                        return this._yRadius;
                    },
                    set: function(t) {
                        this._yRadius = t;
                    }
                },
                startAngle: {
                    get: function() {
                        return s(this._startAngle);
                    },
                    set: function(t) {
                        this._startAngle = u(t);
                    }
                },
                endAngle: {
                    get: function() {
                        return s(this._endAngle);
                    },
                    set: function(t) {
                        this._endAngle = u(t);
                    }
                },
                clockwise: {
                    get: function() {
                        return this._clockwise;
                    },
                    set: function(t) {
                        this._clockwise = t;
                    }
                },
                angle: {
                    get: function() {
                        return s(this._rotation);
                    },
                    set: function(t) {
                        this._rotation = u(t);
                    }
                },
                rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(t) {
                        this._rotation = t;
                    }
                },
                toJSON: function() {
                    return {
                        type: this.type,
                        x: this.p0.x,
                        y: this.p0.y,
                        xRadius: this._xRadius,
                        yRadius: this._yRadius,
                        startAngle: s(this._startAngle),
                        endAngle: s(this._endAngle),
                        clockwise: this._clockwise,
                        rotation: s(this._rotation)
                    };
                }
            });
            r.fromJSON = function(t) {
                return new r(t);
            }, t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(90), r = i(196), o = i(10), a = i(3), h = new a, l = new n({
                Extends: s,
                initialize: function(t, e) {
                    s.call(this, "LineCurve"), Array.isArray(t) && (e = new a(t[2], t[3]), t = new a(t[0], t[1])), this.p0 = t, this.p1 = e, this.arcLengthDivisions = 1;
                },
                getBounds: function(t) {
                    return void 0 === t && (t = new o), r([
                        this.p0,
                        this.p1
                    ], t);
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new a), t.copy(this.p0);
                },
                getResolution: function(t) {
                    return void 0 === t && (t = 1), t;
                },
                getPoint: function(t, e) {
                    return void 0 === e && (e = new a), 1 === t ? e.copy(this.p1) : (e.copy(this.p1).subtract(this.p0).scale(t).add(this.p0), e);
                },
                getPointAt: function(t, e) {
                    return this.getPoint(t, e);
                },
                getTangent: function() {
                    return h.copy(this.p1).subtract(this.p0).normalize();
                },
                getUtoTmapping: function(t, e, i) {
                    var n, s;
                    return e ? (s = (n = this.getLengths(i))[n.length - 1], Math.min(e, s) / s) : t;
                },
                draw: function(t) {
                    return t.lineBetween(this.p0.x, this.p0.y, this.p1.x, this.p1.y), t;
                },
                toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y
                        ]
                    };
                }
            });
            l.fromJSON = function(t) {
                var e = t.points, i = new a(e[0], e[1]), n = new a(e[2], e[3]);
                return new l(i, n);
            }, t.exports = l;
        },
        function(t, e, i) {
            var n = i(0), s = i(3), r = new n({
                initialize: function(t, e) {
                    this.active = !1, this.p0 = new s(t, e);
                },
                getPoint: function(t, e) {
                    return void 0 === e && (e = new s), e.copy(this.p0);
                },
                getPointAt: function(t, e) {
                    return this.getPoint(t, e);
                },
                getResolution: function() {
                    return 1;
                },
                getLength: function() {
                    return 0;
                },
                toJSON: function() {
                    return {
                        type: "MoveTo",
                        points: [
                            this.p0.x,
                            this.p0.y
                        ]
                    };
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(90), r = i(353), o = i(3), a = new n({
                Extends: s,
                initialize: function(t, e, i) {
                    s.call(this, "QuadraticBezier"), Array.isArray(t) && (i = new o(t[4], t[5]), e = new o(t[2], t[3]), t = new o(t[0], t[1])), this.p0 = t, this.p1 = e, this.p2 = i;
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new o), t.copy(this.p0);
                },
                getResolution: function(t) {
                    return t;
                },
                getPoint: function(t, e) {
                    void 0 === e && (e = new o);
                    var i = this.p0, n = this.p1, s = this.p2;
                    return e.set(r(t, i.x, n.x, s.x), r(t, i.y, n.y, s.y));
                },
                draw: function(t, e) {
                    void 0 === e && (e = 32);
                    var i = this.getPoints(e);
                    t.beginPath(), t.moveTo(this.p0.x, this.p0.y);
                    for(var n = 1; n < i.length; n++)t.lineTo(i[n].x, i[n].y);
                    return t.strokePath(), t;
                },
                toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y,
                            this.p2.x,
                            this.p2.y
                        ]
                    };
                }
            });
            a.fromJSON = function(t) {
                var e = t.points, i = new o(e[0], e[1]), n = new o(e[2], e[3]), s = new o(e[4], e[5]);
                return new a(i, n, s);
            }, t.exports = a;
        },
        function(t, e, i) {
            var u = i(191), n = i(0), s = i(90), c = i(3), r = new n({
                Extends: s,
                initialize: function(t) {
                    void 0 === t && (t = []), s.call(this, "SplineCurve"), this.points = [], this.addPoints(t);
                },
                addPoints: function(t) {
                    for(var e = 0; e < t.length; e++){
                        var i = new c;
                        "number" == typeof t[e] ? (i.x = t[e], i.y = t[e + 1], e++) : Array.isArray(t[e]) ? (i.x = t[e][0], i.y = t[e][1]) : (i.x = t[e].x, i.y = t[e].y), this.points.push(i);
                    }
                    return this;
                },
                addPoint: function(t, e) {
                    var i = new c(t, e);
                    return this.points.push(i), i;
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new c), t.copy(this.points[0]);
                },
                getResolution: function(t) {
                    return t * this.points.length;
                },
                getPoint: function(t, e) {
                    void 0 === e && (e = new c);
                    var i = this.points, n = (i.length - 1) * t, s = Math.floor(n), r = n - s, o = i[0 === s ? s : s - 1], a = i[s], h = i[s > i.length - 2 ? i.length - 1 : s + 1], l = i[s > i.length - 3 ? i.length - 1 : s + 2];
                    return e.set(u(r, o.x, a.x, h.x, l.x), u(r, o.y, a.y, h.y, l.y));
                },
                toJSON: function() {
                    for(var t = [], e = 0; e < this.points.length; e++)t.push(this.points[e].x), t.push(this.points[e].y);
                    return {
                        type: this.type,
                        points: t
                    };
                }
            });
            r.fromJSON = function(t) {
                return new r(t.points);
            }, t.exports = r;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n) {
                    e && "" !== e || (e = [
                        "precision mediump float;",
                        "uniform vec2 resolution;",
                        "varying vec2 fragCoord;",
                        "void main () {",
                        "    vec2 uv = fragCoord / resolution.xy;",
                        "    gl_FragColor = vec4(uv.xyx, 1.0);",
                        "}"
                    ].join("\n")), i && "" !== i || (i = [
                        "precision mediump float;",
                        "uniform mat4 uProjectionMatrix;",
                        "uniform mat4 uViewMatrix;",
                        "uniform vec2 uResolution;",
                        "attribute vec2 inPosition;",
                        "varying vec2 fragCoord;",
                        "varying vec2 outTexCoord;",
                        "void main () {",
                        "   gl_Position = uProjectionMatrix * uViewMatrix * vec4(inPosition, 1.0, 1.0);",
                        "   fragCoord = vec2(inPosition.x, uResolution.y - inPosition.y);",
                        "   outTexCoord = vec2(inPosition.x / uResolution.x, fragCoord.y / uResolution.y);",
                        "}"
                    ].join("\n")), void 0 === n && (n = null), this.key = t, this.fragmentSrc = e, this.vertexSrc = i, this.uniforms = n;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var n = i(37);
            n.ColorSpectrum = i(905), n.ColorToRGBA = i(906), n.ComponentToHex = i(392), n.GetColor = i(100), n.GetColor32 = i(322), n.HexStringToColor = i(321), n.HSLToColor = i(907), n.HSVColorWheel = i(908), n.HSVToRGB = i(185), n.HueToComponent = i(393), n.IntegerToColor = i(186), n.IntegerToRGB = i(324), n.Interpolate = i(909), n.ObjectToColor = i(325), n.RandomRGB = i(910), n.RGBStringToColor = i(326), n.RGBToHSV = i(323), n.RGBToString = i(911), n.ValueToColor = i(184), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                var e = t.toString(16);
                return 1 === e.length ? "0" + e : e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return i < 0 && (i += 1), 1 < i && --i, i < 1 / 6 ? t + 6 * (e - t) * i : i < .5 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
            };
        },
        function(t, e, i) {
            var n = i(102);
            t.exports = function(t) {
                var e;
                "complete" !== document.readyState && "interactive" !== document.readyState ? (e = function() {
                    document.removeEventListener("deviceready", e, !0), document.removeEventListener("DOMContentLoaded", e, !0), window.removeEventListener("load", e, !0), t();
                }, document.body ? n.cordova ? document.addEventListener("deviceready", e, !1) : (document.addEventListener("DOMContentLoaded", e, !0), window.addEventListener("load", e, !0)) : window.setTimeout(e, 20)) : t();
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if (!t) return window.innerHeight;
                var e = Math.abs(window.orientation), i = {
                    w: 0,
                    h: 0
                }, n = document.createElement("div");
                return n.setAttribute("style", "position: fixed; height: 100vh; width: 0; top: 0"), document.documentElement.appendChild(n), i.w = 90 === e ? n.offsetHeight : window.innerWidth, i.h = 90 === e ? window.innerWidth : n.offsetHeight, document.documentElement.removeChild(n), n = null, 90 !== Math.abs(window.orientation) ? i.h : i.w;
            };
        },
        function(t, e, i) {
            var s = i(198);
            t.exports = function(t, e) {
                var i = window.screen, n = !!i && (i.orientation || i.mozOrientation || i.msOrientation);
                return n && "string" == typeof n.type ? n.type : "string" == typeof n ? n : "number" == typeof window.orientation ? 0 === window.orientation || 180 === window.orientation ? s.ORIENTATION.PORTRAIT : s.ORIENTATION.LANDSCAPE : window.matchMedia ? window.matchMedia("(orientation: portrait)").matches ? s.ORIENTATION.PORTRAIT : window.matchMedia("(orientation: landscape)").matches ? s.ORIENTATION.LANDSCAPE : void 0 : t < e ? s.ORIENTATION.PORTRAIT : s.ORIENTATION.LANDSCAPE;
            };
        },
        function(t, e) {
            t.exports = {
                NO_CENTER: 0,
                CENTER_BOTH: 1,
                CENTER_HORIZONTALLY: 2,
                CENTER_VERTICALLY: 3
            };
        },
        function(t, e) {
            t.exports = {
                LANDSCAPE: "landscape-primary",
                PORTRAIT: "portrait-primary"
            };
        },
        function(t, e) {
            t.exports = {
                NONE: 0,
                WIDTH_CONTROLS_HEIGHT: 1,
                HEIGHT_CONTROLS_WIDTH: 2,
                FIT: 3,
                ENVELOP: 4,
                RESIZE: 5
            };
        },
        function(t, e) {
            t.exports = {
                NO_ZOOM: 1,
                ZOOM_2X: 2,
                ZOOM_4X: 4,
                MAX_ZOOM: -1
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e;
                return "" !== t && ("string" == typeof t ? e = document.getElementById(t) : t && 1 === t.nodeType && (e = t)), e = e || document.body;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = "";
                try {
                    window.DOMParser ? e = (new DOMParser).parseFromString(t, "text/xml") : (e = new ActiveXObject("Microsoft.XMLDOM")).loadXML(t);
                } catch (t) {
                    e = null;
                }
                return e && e.documentElement && !e.getElementsByTagName("parsererror").length ? e : null;
            };
        },
        function(t, e, i) {
            var n = i(0), a = i(200), s = i(9), r = i(49), o = i(22), h = i(404), l = i(405), u = i(406), c = i(407), d = i(25), v = i(174), f = new n({
                initialize: function(t, e) {
                    this.game = t, this.scaleManager, this.canvas, this.config = e, this.enabled = !0, this.events = new s, this.isOver = !0, this.defaultCursor = "", this.keyboard = e.inputKeyboard ? new h(this) : null, this.mouse = e.inputMouse ? new l(this) : null, this.touch = e.inputTouch ? new c(this) : null, this.pointers = [], this.pointersTotal = e.inputActivePointers, e.inputTouch && 1 === this.pointersTotal && (this.pointersTotal = 2);
                    for(var i = 0; i <= this.pointersTotal; i++){
                        var n = new u(this, i);
                        n.smoothFactor = e.inputSmoothFactor, this.pointers.push(n);
                    }
                    this.mousePointer = e.inputMouse ? this.pointers[0] : null, this.activePointer = this.pointers[0], this.globalTopOnly = !0, this.time = 0, this._tempPoint = {
                        x: 0,
                        y: 0
                    }, this._tempHitTest = [], this._tempMatrix = new d, this._tempMatrix2 = new d, this._tempSkip = !1, this.mousePointerContainer = [
                        this.mousePointer
                    ], t.events.once(o.BOOT, this.boot, this);
                },
                boot: function() {
                    this.canvas = this.game.canvas, this.scaleManager = this.game.scale, this.events.emit(r.MANAGER_BOOT), this.game.events.on(o.PRE_RENDER, this.preRender, this), this.game.events.once(o.DESTROY, this.destroy, this);
                },
                setCanvasOver: function(t) {
                    this.isOver = !0, this.events.emit(r.GAME_OVER, t);
                },
                setCanvasOut: function(t) {
                    this.isOver = !1, this.events.emit(r.GAME_OUT, t);
                },
                preRender: function() {
                    var t = this.game.loop.now, e = this.game.loop.delta, i = this.game.scene.getScenes(!0, !0);
                    this.time = t, this.events.emit(r.MANAGER_UPDATE);
                    for(var n = 0; n < i.length; n++){
                        var s = i[n];
                        if (s.sys.input && s.sys.input.updatePoll(t, e) && this.globalTopOnly) return;
                    }
                },
                setDefaultCursor: function(t) {
                    this.defaultCursor = t, this.canvas.style.cursor !== t && (this.canvas.style.cursor = t);
                },
                setCursor: function(t) {
                    t.cursor && (this.canvas.style.cursor = t.cursor);
                },
                resetCursor: function(t) {
                    t.cursor && this.canvas && (this.canvas.style.cursor = this.defaultCursor);
                },
                addPointer: function(t) {
                    void 0 === t && (t = 1);
                    var e = [];
                    10 < this.pointersTotal + t && (t = 10 - this.pointersTotal);
                    for(var i = 0; i < t; i++){
                        var n = this.pointers.length, s = new u(this, n);
                        s.smoothFactor = this.config.inputSmoothFactor, this.pointers.push(s), this.pointersTotal++, e.push(s);
                    }
                    return e;
                },
                updateInputPlugins: function(t, e) {
                    var i = this.game.scene.getScenes(!0, !0);
                    this._tempSkip = !1;
                    for(var n = 0; n < i.length; n++){
                        var s = i[n];
                        if (s.sys.input) {
                            if (s.sys.input.update(t, e) && this.globalTopOnly || this._tempSkip) return;
                        }
                    }
                },
                onTouchStart: function(t) {
                    for(var e = this.pointers, i = [], n = 0; n < t.changedTouches.length; n++)for(var s = t.changedTouches[n], r = 1; r < this.pointersTotal; r++){
                        var o = e[r];
                        if (!o.active) {
                            o.touchstart(s, t), this.activePointer = o, i.push(o);
                            break;
                        }
                    }
                    this.updateInputPlugins(a.TOUCH_START, i);
                },
                onTouchMove: function(t) {
                    for(var e = this.pointers, i = [], n = 0; n < t.changedTouches.length; n++)for(var s = t.changedTouches[n], r = 1; r < this.pointersTotal; r++){
                        var o = e[r];
                        if (o.active && o.identifier === s.identifier) {
                            o.touchmove(s, t), this.activePointer = o, i.push(o);
                            break;
                        }
                    }
                    this.updateInputPlugins(a.TOUCH_MOVE, i);
                },
                onTouchEnd: function(t) {
                    for(var e = this.pointers, i = [], n = 0; n < t.changedTouches.length; n++)for(var s = t.changedTouches[n], r = 1; r < this.pointersTotal; r++){
                        var o = e[r];
                        if (o.active && o.identifier === s.identifier) {
                            o.touchend(s, t), i.push(o);
                            break;
                        }
                    }
                    this.updateInputPlugins(a.TOUCH_END, i);
                },
                onTouchCancel: function(t) {
                    for(var e = this.pointers, i = [], n = 0; n < t.changedTouches.length; n++)for(var s = t.changedTouches[n], r = 1; r < this.pointersTotal; r++){
                        var o = e[r];
                        if (o.active && o.identifier === s.identifier) {
                            o.touchcancel(s, t), i.push(o);
                            break;
                        }
                    }
                    this.updateInputPlugins(a.TOUCH_CANCEL, i);
                },
                onMouseDown: function(t) {
                    var e = this.mousePointer;
                    e.down(t), e.updateMotion(), this.activePointer = e, this.updateInputPlugins(a.MOUSE_DOWN, this.mousePointerContainer);
                },
                onMouseMove: function(t) {
                    var e = this.mousePointer;
                    e.move(t), e.updateMotion(), this.activePointer = e, this.updateInputPlugins(a.MOUSE_MOVE, this.mousePointerContainer);
                },
                onMouseUp: function(t) {
                    var e = this.mousePointer;
                    e.up(t), e.updateMotion(), this.activePointer = e, this.updateInputPlugins(a.MOUSE_UP, this.mousePointerContainer);
                },
                onMouseWheel: function(t) {
                    var e = this.mousePointer;
                    e.wheel(t), this.activePointer = e, this.updateInputPlugins(a.MOUSE_WHEEL, this.mousePointerContainer);
                },
                onPointerLockChange: function(t) {
                    var e = this.mouse.locked;
                    this.mousePointer.locked = e, this.events.emit(r.POINTERLOCK_CHANGE, t, e);
                },
                inputCandidate: function(t, e) {
                    var i = t.input;
                    if (!i || !i.enabled || !i.alwaysEnabled && !t.willRender(e)) return !1;
                    var n = !0, s = t.parentContainer;
                    if (s) do {
                        if (!s.willRender(e)) {
                            n = !1;
                            break;
                        }
                        s = s.parentContainer;
                    }while (s);
                    return n;
                },
                hitTest: function(t, e, i, n) {
                    void 0 === n && (n = this._tempHitTest);
                    var s = this._tempPoint, r = i.scrollX, o = i.scrollY;
                    n.length = 0;
                    var a = t.x, h = t.y;
                    i.getWorldPoint(a, h, s), t.worldX = s.x, t.worldY = s.y;
                    for(var l = {
                        x: 0,
                        y: 0
                    }, u = this._tempMatrix, c = this._tempMatrix2, d = 0; d < e.length; d++){
                        var f, p, g = e[d];
                        this.inputCandidate(g, i) && (f = s.x + r * g.scrollFactorX - r, p = s.y + o * g.scrollFactorY - o, g.parentContainer ? (g.getWorldTransformMatrix(u, c), u.applyInverse(f, p, l)) : v(f, p, g.x, g.y, g.rotation, g.scaleX, g.scaleY, l), this.pointWithinHitArea(g, l.x, l.y) && n.push(g));
                    }
                    return n;
                },
                pointWithinHitArea: function(t, e, i) {
                    e += t.displayOriginX, i += t.displayOriginY;
                    var n = t.input;
                    return !(!n || !n.hitAreaCallback(n.hitArea, e, i, t)) && (n.localX = e, n.localY = i, !0);
                },
                pointWithinInteractiveObject: function(t, e, i) {
                    return !!t.hitArea && (e += t.gameObject.displayOriginX, i += t.gameObject.displayOriginY, t.localX = e, t.localY = i, t.hitAreaCallback(t.hitArea, e, i, t));
                },
                transformPointer: function(t, e, i, n) {
                    var s = t.position, r = t.prevPosition;
                    r.x = s.x, r.y = s.y;
                    var o = this.scaleManager.transformX(e), a = this.scaleManager.transformY(i), h = t.smoothFactor;
                    n && 0 !== h ? (s.x = o * h + r.x * (1 - h), s.y = a * h + r.y * (1 - h)) : (s.x = o, s.y = a);
                },
                destroy: function() {
                    this.events.removeAllListeners(), this.game.events.off(o.PRE_RENDER), this.keyboard && this.keyboard.destroy(), this.mouse && this.mouse.destroy(), this.touch && this.touch.destroy();
                    for(var t = 0; t < this.pointers.length; t++)this.pointers[t].destroy();
                    this.pointers = [], this._tempHitTest = [], this._tempMatrix.destroy(), this.canvas = null, this.game = null;
                }
            });
            t.exports = f;
        },
        function(t, e, i) {
            var s = i(89), n = i(0), r = i(22), o = i(49), a = i(141), h = i(1), l = new n({
                initialize: function(t) {
                    this.manager = t, this.queue = [], this.preventDefault = !0, this.captures = [], this.enabled = !1, this.target, this.onKeyDown = h, this.onKeyUp = h, t.events.once(o.MANAGER_BOOT, this.boot, this);
                },
                boot: function() {
                    var t = this.manager.config;
                    this.enabled = t.inputKeyboard, this.target = t.inputKeyboardEventTarget, this.addCapture(t.inputKeyboardCapture), !this.target && window && (this.target = window), this.enabled && this.target && this.startListeners(), this.manager.game.events.on(r.POST_STEP, this.postUpdate, this);
                },
                startListeners: function() {
                    var i = this;
                    this.onKeyDown = function(t) {
                        var e;
                        !t.defaultPrevented && i.enabled && i.manager && (i.queue.push(t), i.manager.events.emit(o.MANAGER_PROCESS), e = t.altKey || t.ctrlKey || t.shiftKey || t.metaKey, i.preventDefault && !e && -1 < i.captures.indexOf(t.keyCode) && t.preventDefault());
                    }, this.onKeyUp = function(t) {
                        var e;
                        !t.defaultPrevented && i.enabled && i.manager && (i.queue.push(t), i.manager.events.emit(o.MANAGER_PROCESS), e = t.altKey || t.ctrlKey || t.shiftKey || t.metaKey, i.preventDefault && !e && -1 < i.captures.indexOf(t.keyCode) && t.preventDefault());
                    };
                    var t = this.target;
                    t && (t.addEventListener("keydown", this.onKeyDown, !1), t.addEventListener("keyup", this.onKeyUp, !1), this.enabled = !0);
                },
                stopListeners: function() {
                    var t = this.target;
                    t.removeEventListener("keydown", this.onKeyDown, !1), t.removeEventListener("keyup", this.onKeyUp, !1), this.enabled = !1;
                },
                postUpdate: function() {
                    this.queue = [];
                },
                addCapture: function(t) {
                    "string" == typeof t && (t = t.split(",")), Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = this.captures, i = 0; i < t.length; i++){
                        var n = t[i];
                        "string" == typeof n && (n = a[n.trim().toUpperCase()]), -1 === e.indexOf(n) && e.push(n);
                    }
                    this.preventDefault = 0 < e.length;
                },
                removeCapture: function(t) {
                    "string" == typeof t && (t = t.split(",")), Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = this.captures, i = 0; i < t.length; i++){
                        var n = t[i];
                        "string" == typeof n && (n = a[n.toUpperCase()]), s(e, n);
                    }
                    this.preventDefault = 0 < e.length;
                },
                clearCaptures: function() {
                    this.captures = [], this.preventDefault = !1;
                },
                destroy: function() {
                    this.stopListeners(), this.clearCaptures(), this.queue = [], this.manager.game.events.off(r.POST_RENDER, this.postUpdate, this), this.target = null, this.enabled = !1, this.manager = null;
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            var n = i(0), o = i(188), s = i(49), r = i(1), a = new n({
                initialize: function(t) {
                    this.manager = t, this.preventDefaultDown = !0, this.preventDefaultUp = !0, this.preventDefaultMove = !0, this.preventDefaultWheel = !1, this.enabled = !1, this.target, this.locked = !1, this.onMouseMove = r, this.onMouseDown = r, this.onMouseUp = r, this.onMouseDownWindow = r, this.onMouseUpWindow = r, this.onMouseOver = r, this.onMouseOut = r, this.onMouseWheel = r, this.pointerLockChange = r, this.isTop = !0, t.events.once(s.MANAGER_BOOT, this.boot, this);
                },
                boot: function() {
                    var t = this.manager.config;
                    this.enabled = t.inputMouse, this.target = t.inputMouseEventTarget, this.passive = t.inputMousePassive, this.preventDefaultDown = t.inputMousePreventDefaultDown, this.preventDefaultUp = t.inputMousePreventDefaultUp, this.preventDefaultMove = t.inputMousePreventDefaultMove, this.preventDefaultWheel = t.inputMousePreventDefaultWheel, this.target ? "string" == typeof this.target && (this.target = document.getElementById(this.target)) : this.target = this.manager.game.canvas, t.disableContextMenu && this.disableContextMenu(), this.enabled && this.target && this.startListeners();
                },
                disableContextMenu: function() {
                    return document.body.addEventListener("contextmenu", function(t) {
                        return t.preventDefault(), !1;
                    }), this;
                },
                requestPointerLock: function() {
                    var t;
                    o.pointerLock && ((t = this.target).requestPointerLock = t.requestPointerLock || t.mozRequestPointerLock || t.webkitRequestPointerLock, t.requestPointerLock());
                },
                releasePointerLock: function() {
                    o.pointerLock && (document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock, document.exitPointerLock());
                },
                startListeners: function() {
                    var t = this.target;
                    if (t) {
                        var i = this, n = this.manager, e = n.canvas, s = window && window.focus && n.game.config.autoFocus;
                        this.onMouseMove = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && (n.onMouseMove(t), i.preventDefaultMove && t.preventDefault());
                        }, this.onMouseDown = function(t) {
                            s && window.focus(), !t.defaultPrevented && i.enabled && n && n.enabled && (n.onMouseDown(t), i.preventDefaultDown && t.target === e && t.preventDefault());
                        }, this.onMouseDownWindow = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && t.target !== e && n.onMouseDown(t);
                        }, this.onMouseUp = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && (n.onMouseUp(t), i.preventDefaultUp && t.target === e && t.preventDefault());
                        }, this.onMouseUpWindow = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && t.target !== e && n.onMouseUp(t);
                        }, this.onMouseOver = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && n.setCanvasOver(t);
                        }, this.onMouseOut = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && n.setCanvasOut(t);
                        }, this.onMouseWheel = function(t) {
                            !t.defaultPrevented && i.enabled && n && n.enabled && n.onMouseWheel(t), i.preventDefaultWheel && t.target === e && t.preventDefault();
                        };
                        var r = {
                            passive: !0
                        };
                        if (t.addEventListener("mousemove", this.onMouseMove), t.addEventListener("mousedown", this.onMouseDown), t.addEventListener("mouseup", this.onMouseUp), t.addEventListener("mouseover", this.onMouseOver, r), t.addEventListener("mouseout", this.onMouseOut, r), this.preventDefaultWheel ? t.addEventListener("wheel", this.onMouseWheel, {
                            passive: !1
                        }) : t.addEventListener("wheel", this.onMouseWheel, r), window && n.game.config.inputWindowEvents) try {
                            window.top.addEventListener("mousedown", this.onMouseDownWindow, r), window.top.addEventListener("mouseup", this.onMouseUpWindow, r);
                        } catch (t) {
                            window.addEventListener("mousedown", this.onMouseDownWindow, r), window.addEventListener("mouseup", this.onMouseUpWindow, r), this.isTop = !1;
                        }
                        o.pointerLock && (this.pointerLockChange = function(t) {
                            var e = i.target;
                            i.locked = document.pointerLockElement === e || document.mozPointerLockElement === e || document.webkitPointerLockElement === e, n.onPointerLockChange(t);
                        }, document.addEventListener("pointerlockchange", this.pointerLockChange, !0), document.addEventListener("mozpointerlockchange", this.pointerLockChange, !0), document.addEventListener("webkitpointerlockchange", this.pointerLockChange, !0)), this.enabled = !0;
                    }
                },
                stopListeners: function() {
                    var t = this.target;
                    t.removeEventListener("mousemove", this.onMouseMove), t.removeEventListener("mousedown", this.onMouseDown), t.removeEventListener("mouseup", this.onMouseUp), t.removeEventListener("mouseover", this.onMouseOver), t.removeEventListener("mouseout", this.onMouseOut), window && ((t = this.isTop ? window.top : window).removeEventListener("mousedown", this.onMouseDownWindow), t.removeEventListener("mouseup", this.onMouseUpWindow)), o.pointerLock && (document.removeEventListener("pointerlockchange", this.pointerLockChange, !0), document.removeEventListener("mozpointerlockchange", this.pointerLockChange, !0), document.removeEventListener("webkitpointerlockchange", this.pointerLockChange, !0));
                },
                destroy: function() {
                    this.stopListeners(), this.target = null, this.enabled = !1, this.manager = null;
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var h = i(343), n = i(0), s = i(48), l = i(123), u = i(354), r = i(3), o = i(102), a = new n({
                initialize: function(t, e) {
                    this.manager = t, this.id = e, this.event, this.downElement, this.upElement, this.camera = null, this.button = 0, this.buttons = 0, this.position = new r, this.prevPosition = new r, this.midPoint = new r(-1, -1), this.velocity = new r, this.angle = 0, this.distance = 0, this.smoothFactor = 0, this.motionFactor = .2, this.worldX = 0, this.worldY = 0, this.moveTime = 0, this.downX = 0, this.downY = 0, this.downTime = 0, this.upX = 0, this.upY = 0, this.upTime = 0, this.primaryDown = !1, this.isDown = !1, this.wasTouch = !1, this.wasCanceled = !1, this.movementX = 0, this.movementY = 0, this.identifier = 0, this.pointerId = null, this.active = 0 === e, this.locked = !1, this.deltaX = 0, this.deltaY = 0, this.deltaZ = 0;
                },
                updateWorldPoint: function(t) {
                    var e = t.getWorldPoint(this.x, this.y);
                    return this.worldX = e.x, this.worldY = e.y, this;
                },
                positionToCamera: function(t, e) {
                    return t.getWorldPoint(this.x, this.y, e);
                },
                updateMotion: function() {
                    var t, e, i, n, s = this.position.x, r = this.position.y, o = this.midPoint.x, a = this.midPoint.y;
                    s === o && r === a || (t = u(this.motionFactor, o, s), e = u(this.motionFactor, a, r), l(t, s, .1) && (t = s), l(e, r, .1) && (e = r), this.midPoint.set(t, e), i = s - t, n = r - e, this.velocity.set(i, n), this.angle = h(t, e, s, r), this.distance = Math.sqrt(i * i + n * n));
                },
                up: function(t) {
                    "buttons" in t && (this.buttons = t.buttons), this.event = t, this.button = t.button, this.upElement = t.target, this.manager.transformPointer(this, t.pageX, t.pageY, !1), 0 === t.button && (this.primaryDown = !1, this.upX = this.x, this.upY = this.y), 0 === this.buttons && (this.isDown = !1, this.upTime = t.timeStamp, this.wasTouch = !1);
                },
                down: function(t) {
                    "buttons" in t && (this.buttons = t.buttons), this.event = t, this.button = t.button, this.downElement = t.target, this.manager.transformPointer(this, t.pageX, t.pageY, !1), 0 === t.button && (this.primaryDown = !0, this.downX = this.x, this.downY = this.y), o.macOS && t.ctrlKey && (this.buttons = 2, this.primaryDown = !1), this.isDown || (this.isDown = !0, this.downTime = t.timeStamp), this.wasTouch = !1;
                },
                move: function(t) {
                    "buttons" in t && (this.buttons = t.buttons), this.event = t, this.manager.transformPointer(this, t.pageX, t.pageY, !0), this.locked && (this.movementX = t.movementX || t.mozMovementX || t.webkitMovementX || 0, this.movementY = t.movementY || t.mozMovementY || t.webkitMovementY || 0), this.moveTime = t.timeStamp, this.wasTouch = !1;
                },
                wheel: function(t) {
                    "buttons" in t && (this.buttons = t.buttons), this.event = t, this.manager.transformPointer(this, t.pageX, t.pageY, !1), this.deltaX = t.deltaX, this.deltaY = t.deltaY, this.deltaZ = t.deltaZ, this.wasTouch = !1;
                },
                touchstart: function(t, e) {
                    t.pointerId && (this.pointerId = t.pointerId), this.identifier = t.identifier, this.target = t.target, this.active = !0, this.buttons = 1, this.event = e, this.downElement = t.target, this.manager.transformPointer(this, t.pageX, t.pageY, !1), this.primaryDown = !0, this.downX = this.x, this.downY = this.y, this.downTime = e.timeStamp, this.isDown = !0, this.wasTouch = !0, this.wasCanceled = !1, this.updateMotion();
                },
                touchmove: function(t, e) {
                    this.event = e, this.manager.transformPointer(this, t.pageX, t.pageY, !0), this.moveTime = e.timeStamp, this.wasTouch = !0, this.updateMotion();
                },
                touchend: function(t, e) {
                    this.buttons = 0, this.event = e, this.upElement = t.target, this.manager.transformPointer(this, t.pageX, t.pageY, !1), this.primaryDown = !1, this.upX = this.x, this.upY = this.y, this.upTime = e.timeStamp, this.isDown = !1, this.wasTouch = !0, this.wasCanceled = !1, this.active = !1, this.updateMotion();
                },
                touchcancel: function(t, e) {
                    this.buttons = 0, this.event = e, this.upElement = t.target, this.manager.transformPointer(this, t.pageX, t.pageY, !1), this.primaryDown = !1, this.upX = this.x, this.upY = this.y, this.upTime = e.timeStamp, this.isDown = !1, this.wasTouch = !0, this.wasCanceled = !0, this.active = !1;
                },
                noButtonDown: function() {
                    return 0 === this.buttons;
                },
                leftButtonDown: function() {
                    return !!(1 & this.buttons);
                },
                rightButtonDown: function() {
                    return !!(2 & this.buttons);
                },
                middleButtonDown: function() {
                    return !!(4 & this.buttons);
                },
                backButtonDown: function() {
                    return !!(8 & this.buttons);
                },
                forwardButtonDown: function() {
                    return !!(16 & this.buttons);
                },
                leftButtonReleased: function() {
                    return 0 === this.button && !this.isDown;
                },
                rightButtonReleased: function() {
                    return 2 === this.button && !this.isDown;
                },
                middleButtonReleased: function() {
                    return 1 === this.button && !this.isDown;
                },
                backButtonReleased: function() {
                    return 3 === this.button && !this.isDown;
                },
                forwardButtonReleased: function() {
                    return 4 === this.button && !this.isDown;
                },
                getDistance: function() {
                    return this.isDown ? s(this.downX, this.downY, this.x, this.y) : s(this.downX, this.downY, this.upX, this.upY);
                },
                getDistanceX: function() {
                    return this.isDown ? Math.abs(this.downX - this.x) : Math.abs(this.downX - this.upX);
                },
                getDistanceY: function() {
                    return this.isDown ? Math.abs(this.downY - this.y) : Math.abs(this.downY - this.upY);
                },
                getDuration: function() {
                    return this.isDown ? this.manager.time - this.downTime : this.upTime - this.downTime;
                },
                getAngle: function() {
                    return this.isDown ? h(this.downX, this.downY, this.x, this.y) : h(this.downX, this.downY, this.upX, this.upY);
                },
                getInterpolatedPosition: function(t, e) {
                    void 0 === t && (t = 10), void 0 === e && (e = []);
                    for(var i = this.prevPosition.x, n = this.prevPosition.y, s = this.position.x, r = this.position.y, o = 0; o < t; o++){
                        var a = 1 / t * o;
                        e[o] = {
                            x: u(a, i, s),
                            y: u(a, n, r)
                        };
                    }
                    return e;
                },
                destroy: function() {
                    this.camera = null, this.manager = null, this.position = null;
                },
                x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(t) {
                        this.position.x = t;
                    }
                },
                y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(t) {
                        this.position.y = t;
                    }
                },
                time: {
                    get: function() {
                        return this.event ? this.event.timeStamp : 0;
                    }
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(49), r = i(1), o = new n({
                initialize: function(t) {
                    this.manager = t, this.capture = !0, this.enabled = !1, this.target, this.onTouchStart = r, this.onTouchStartWindow = r, this.onTouchMove = r, this.onTouchEnd = r, this.onTouchEndWindow = r, this.onTouchCancel = r, this.onTouchCancelWindow = r, this.onTouchOver = r, this.onTouchOut = r, t.events.once(s.MANAGER_BOOT, this.boot, this);
                },
                boot: function() {
                    var t = this.manager.config;
                    this.enabled = t.inputTouch, this.target = t.inputTouchEventTarget, this.capture = t.inputTouchCapture, this.target || (this.target = this.manager.game.canvas), t.disableContextMenu && this.disableContextMenu(), this.enabled && this.target && this.startListeners();
                },
                disableContextMenu: function() {
                    return document.body.addEventListener("contextmenu", function(t) {
                        return t.preventDefault(), !1;
                    }), this;
                },
                startListeners: function() {
                    var e = this, i = this.manager.canvas, n = window && window.focus && this.manager.game.config.autoFocus;
                    this.onTouchStart = function(t) {
                        n && window.focus(), !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && (e.manager.onTouchStart(t), e.capture && t.cancelable && t.target === i && t.preventDefault());
                    }, this.onTouchStartWindow = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && t.target !== i && e.manager.onTouchStart(t);
                    }, this.onTouchMove = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && (e.manager.onTouchMove(t), e.capture && t.cancelable && t.preventDefault());
                    }, this.onTouchEnd = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && (e.manager.onTouchEnd(t), e.capture && t.cancelable && t.target === i && t.preventDefault());
                    }, this.onTouchEndWindow = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && t.target !== i && e.manager.onTouchEnd(t);
                    }, this.onTouchCancel = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && (e.manager.onTouchCancel(t), e.capture && t.preventDefault());
                    }, this.onTouchCancelWindow = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && e.manager.onTouchCancel(t);
                    }, this.onTouchOver = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && e.manager.setCanvasOver(t);
                    }, this.onTouchOut = function(t) {
                        !t.defaultPrevented && e.enabled && e.manager && e.manager.enabled && e.manager.setCanvasOut(t);
                    };
                    var t, s, r = this.target;
                    r && (s = {
                        passive: (t = {
                            passive: !0
                        }, false)
                    }, r.addEventListener("touchstart", this.onTouchStart, this.capture ? s : t), r.addEventListener("touchmove", this.onTouchMove, this.capture ? s : t), r.addEventListener("touchend", this.onTouchEnd, this.capture ? s : t), r.addEventListener("touchcancel", this.onTouchCancel, this.capture ? s : t), r.addEventListener("touchover", this.onTouchOver, this.capture ? s : t), r.addEventListener("touchout", this.onTouchOut, this.capture ? s : t), window && this.manager.game.config.inputWindowEvents && (window.addEventListener("touchstart", this.onTouchStartWindow, s), window.addEventListener("touchend", this.onTouchEndWindow, s), window.addEventListener("touchcancel", this.onTouchCancelWindow, s)), this.enabled = !0);
                },
                stopListeners: function() {
                    var t = this.target;
                    t.removeEventListener("touchstart", this.onTouchStart), t.removeEventListener("touchmove", this.onTouchMove), t.removeEventListener("touchend", this.onTouchEnd), t.removeEventListener("touchcancel", this.onTouchCancel), t.removeEventListener("touchover", this.onTouchOver), t.removeEventListener("touchout", this.onTouchOut), window && (window.removeEventListener("touchstart", this.onTouchStartWindow), window.removeEventListener("touchend", this.onTouchEndWindow));
                },
                destroy: function() {
                    this.stopListeners(), this.target = null, this.enabled = !1, this.manager = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), l = i(22), s = i(9), r = i(8), o = i(16), a = i(5), u = i(2), p = i(24), h = i(89), c = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.game = t, this.plugins = [], this.scenePlugins = [], this._pendingGlobal = [], this._pendingScene = [], t.isBooted ? this.boot() : t.events.once(l.BOOT, this.boot, this);
                },
                boot: function() {
                    for(var t, e, i, n, s, r, o = this.game.config, a = (a = o.installGlobalPlugins).concat(this._pendingGlobal), h = 0; h < a.length; h++)t = a[h], e = u(t, "key", null), i = u(t, "plugin", null), n = u(t, "start", !1), s = u(t, "mapping", null), r = u(t, "data", null), e && (i ? this.install(e, i, n, s, r) : console.warn("Missing `plugin` for key: " + e));
                    for(a = (a = o.installScenePlugins).concat(this._pendingScene), h = 0; h < a.length; h++)t = a[h], e = u(t, "key", null), i = u(t, "plugin", null), s = u(t, "mapping", null), e && (i ? this.installScenePlugin(e, i, s) : console.warn("Missing `plugin` for key: " + e));
                    this._pendingGlobal = [], this._pendingScene = [], this.game.events.once(l.DESTROY, this.destroy, this);
                },
                addToScene: function(t, e, i) {
                    for(var n, s = this.game, r = t.scene, o = t.settings.map, a = t.settings.isBooted, h = 0; h < e.length; h++)s[d = e[h]] ? (t[d] = s[d], o.hasOwnProperty(d) && (r[o[d]] = t[d])) : "game" === d && o.hasOwnProperty(d) && (r[o[d]] = s);
                    for(var l = 0; l < i.length; l++)for(n = i[l], h = 0; h < n.length; h++){
                        var u, c, d = n[h];
                        p.hasCore(d) && (c = new (u = p.getCore(d)).plugin(r, this), t[u.mapping] = c, u.custom ? r[u.mapping] = c : o.hasOwnProperty(u.mapping) && (r[o[u.mapping]] = c), a && c.boot());
                    }
                    for(n = this.plugins, h = 0; h < n.length; h++){
                        var f = n[h];
                        f.mapping && (r[f.mapping] = f.plugin);
                    }
                },
                getDefaultScenePlugins: function() {
                    return this.game.config.defaultPlugins.concat(this.scenePlugins);
                },
                installScenePlugin: function(t, e, i, n, s) {
                    if (void 0 === s && (s = !1), "function" == typeof e) {
                        if (p.hasCore(t)) {
                            if (!s && p.hasCore(t)) return void console.warn("Scene Plugin key in use: " + t);
                        } else p.register(t, e, i, !0), this.scenePlugins.push(t);
                        var r;
                        n && (r = new e(n, this), n.sys[t] = r, i && "" !== i && (n[i] = r), r.boot());
                    } else console.warn("Invalid Scene Plugin: " + t);
                },
                install: function(t, e, i, n, s) {
                    if (void 0 === i && (i = !1), void 0 === n && (n = null), void 0 === s && (s = null), "function" != typeof e) return console.warn("Invalid Plugin: " + t), null;
                    if (p.hasCustom(t)) return console.warn("Plugin key in use: " + t), null;
                    if (null !== n && (i = !0), this.game.isBooted) {
                        if (p.registerCustom(t, e, n, s), i) return this.start(t);
                    } else this._pendingGlobal.push({
                        key: t,
                        plugin: e,
                        start: i,
                        mapping: n,
                        data: s
                    });
                    return null;
                },
                getIndex: function(t) {
                    for(var e = this.plugins, i = 0; i < e.length; i++){
                        if (e[i].key === t) return i;
                    }
                    return -1;
                },
                getEntry: function(t) {
                    var e = this.getIndex(t);
                    if (-1 !== e) return this.plugins[e];
                },
                isActive: function(t) {
                    var e = this.getEntry(t);
                    return e && e.active;
                },
                start: function(t, e) {
                    void 0 === e && (e = t);
                    var i = this.getEntry(e);
                    return i && !i.active ? (i.active = !0, i.plugin.start()) : i = i || this.createEntry(t, e), i ? i.plugin : null;
                },
                createEntry: function(t, e) {
                    var i, n = p.getCustom(t);
                    return n && (n = {
                        key: e,
                        plugin: i = new n.plugin(this),
                        active: !0,
                        mapping: n.mapping,
                        data: n.data
                    }, this.plugins.push(n), i.init(n.data), i.start()), n;
                },
                stop: function(t) {
                    var e = this.getEntry(t);
                    return e && e.active && (e.active = !1, e.plugin.stop()), this;
                },
                get: function(t, e) {
                    void 0 === e && (e = !0);
                    var i = this.getEntry(t);
                    if (i) return i.plugin;
                    var n = this.getClass(t);
                    return n && e ? (i = this.createEntry(t, t)) ? i.plugin : null : n || null;
                },
                getClass: function(t) {
                    return p.getCustomClass(t);
                },
                removeGlobalPlugin: function(t) {
                    var e = this.getEntry(t);
                    e && h(this.plugins, e), p.removeCustom(t);
                },
                removeScenePlugin: function(t) {
                    h(this.scenePlugins, t), p.remove(t);
                },
                registerGameObject: function(t, e, i) {
                    return e && a.register(t, e), i && o.register(t, i), this;
                },
                removeGameObject: function(t, e, i) {
                    return void 0 === e && (e = !0), void 0 === i && (i = !0), e && a.remove(t), i && o.remove(t), this;
                },
                registerFileType: function(t, e, i) {
                    r.register(t, e), i && i.sys.load && (i.sys.load[t] = e);
                },
                destroy: function() {
                    for(var t = 0; t < this.plugins.length; t++)this.plugins[t].plugin.destroy();
                    p.destroyCustomPlugins(), this.game.noReturn && p.destroyCorePlugins(), this.game = null, this.plugins = [], this.scenePlugins = [];
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var u = i(198), n = i(0), s = i(9), r = i(101), o = i(22), a = i(395), h = i(401), c = i(396), l = i(1), d = i(10), f = i(410), p = i(76), g = i(3), v = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.game = t, this.canvas, this.canvasBounds = new d, this.parent = null, this.parentIsWindow = !1, this.parentSize = new f, this.gameSize = new f, this.baseSize = new f, this.displaySize = new f, this.scaleMode = u.SCALE_MODE.NONE, this.zoom = 1, this._resetZoom = !1, this.displayScale = new g(1, 1), this.autoRound = !1, this.autoCenter = u.CENTER.NO_CENTER, this.orientation = u.ORIENTATION.LANDSCAPE, this.fullscreen, this.fullscreenTarget = null, this._createdFullscreenTarget = !1, this.dirty = !1, this.resizeInterval = 500, this._lastCheck = 0, this._checkOrientation = !1, this.listeners = {
                        orientationChange: l,
                        windowResize: l,
                        fullScreenChange: l,
                        fullScreenError: l
                    };
                },
                preBoot: function() {
                    this.parseConfig(this.game.config), this.game.events.once(o.BOOT, this.boot, this);
                },
                boot: function() {
                    var t = this.game;
                    this.canvas = t.canvas, this.fullscreen = t.device.fullscreen, this.scaleMode !== u.SCALE_MODE.RESIZE && this.displaySize.setAspectMode(this.scaleMode), this.scaleMode === u.SCALE_MODE.NONE ? this.resize(this.width, this.height) : (this.getParentBounds(), 0 < this.parentSize.width && 0 < this.parentSize.height && this.displaySize.setParent(this.parentSize), this.refresh()), t.events.on(o.PRE_STEP, this.step, this), t.events.once(o.READY, this.refresh, this), t.events.once(o.DESTROY, this.destroy, this), this.startListeners();
                },
                parseConfig: function(t) {
                    this.getParent(t), this.getParentBounds();
                    var e, i, n, s, r = t.width, o = t.height, a = t.scaleMode, h = t.zoom, l = t.autoRound;
                    "string" == typeof r && (0 === (e = this.parentSize.width) && (e = window.innerWidth), i = parseInt(r, 10) / 100, r = Math.floor(e * i)), "string" == typeof o && (0 === (n = this.parentSize.height) && (n = window.innerHeight), s = parseInt(o, 10) / 100, o = Math.floor(n * s)), this.scaleMode = a, this.autoRound = l, this.autoCenter = t.autoCenter, this.resizeInterval = t.resizeInterval, l && (r = Math.floor(r), o = Math.floor(o)), this.gameSize.setSize(r, o), h === u.ZOOM.MAX_ZOOM && (h = this.getMaxZoom()), 1 !== (this.zoom = h) && (this._resetZoom = !0), this.baseSize.setSize(r, o), l && (this.baseSize.width = Math.floor(this.baseSize.width), this.baseSize.height = Math.floor(this.baseSize.height)), 0 < t.minWidth && this.displaySize.setMin(t.minWidth * h, t.minHeight * h), 0 < t.maxWidth && this.displaySize.setMax(t.maxWidth * h, t.maxHeight * h), this.displaySize.setSize(r, o), this.orientation = c(r, o);
                },
                getParent: function(t) {
                    var e, i = t.parent;
                    null !== i && (this.parent = h(i), this.parentIsWindow = this.parent === document.body, t.expandParent && t.scaleMode !== u.SCALE_MODE.NONE && (e = this.parent.getBoundingClientRect(), !this.parentIsWindow && 0 !== e.height || (document.documentElement.style.height = "100%", document.body.style.height = "100%", e = this.parent.getBoundingClientRect(), this.parentIsWindow || 0 !== e.height || (this.parent.style.overflow = "hidden", this.parent.style.width = "100%", this.parent.style.height = "100%"))), t.fullscreenTarget && !this.fullscreenTarget && (this.fullscreenTarget = h(t.fullscreenTarget)));
                },
                getParentBounds: function() {
                    if (!this.parent) return !1;
                    var t = this.parentSize, e = this.parent.getBoundingClientRect();
                    this.parentIsWindow && this.game.device.os.iOS && (e.height = a(!0));
                    var i = e.width, n = e.height;
                    return (t.width !== i || t.height !== n) && (t.setSize(i, n), !0);
                },
                lockOrientation: function(t) {
                    var e = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation;
                    return !!e && e.call(screen, t);
                },
                setParentSize: function(t, e) {
                    return this.parentSize.setSize(t, e), this.refresh();
                },
                setGameSize: function(t, e) {
                    var i = this.autoRound;
                    i && (t = Math.floor(t), e = Math.floor(e));
                    var n = this.width, s = this.height;
                    return this.gameSize.resize(t, e), this.baseSize.resize(t, e), i && (this.baseSize.width = Math.floor(this.baseSize.width), this.baseSize.height = Math.floor(this.baseSize.height)), this.displaySize.setAspectRatio(t / e), this.canvas.width = this.baseSize.width, this.canvas.height = this.baseSize.height, this.refresh(n, s);
                },
                resize: function(t, e) {
                    var i = this.zoom, n = this.autoRound;
                    n && (t = Math.floor(t), e = Math.floor(e));
                    var s = this.width, r = this.height;
                    this.gameSize.resize(t, e), this.baseSize.resize(t, e), n && (this.baseSize.width = Math.floor(this.baseSize.width), this.baseSize.height = Math.floor(this.baseSize.height)), this.displaySize.setSize(t * i, e * i), this.canvas.width = this.baseSize.width, this.canvas.height = this.baseSize.height;
                    var o = this.canvas.style, a = t * i, h = e * i;
                    return n && (a = Math.floor(a), h = Math.floor(h)), a === t && h === e || (o.width = a + "px", o.height = h + "px"), this.refresh(s, r);
                },
                setZoom: function(t) {
                    return this.zoom = t, this._resetZoom = !0, this.refresh();
                },
                setMaxZoom: function() {
                    return this.zoom = this.getMaxZoom(), this._resetZoom = !0, this.refresh();
                },
                refresh: function(t, e) {
                    void 0 === t && (t = this.width), void 0 === e && (e = this.height), this.updateScale(), this.updateBounds(), this.updateOrientation(), this.displayScale.set(this.baseSize.width / this.canvasBounds.width, this.baseSize.height / this.canvasBounds.height);
                    var i, n, s = this.game.domContainer;
                    return s && (this.baseSize.setCSS(s), i = this.canvas.style, (n = s.style).transform = "scale(" + this.displaySize.width / this.baseSize.width + "," + this.displaySize.height / this.baseSize.height + ")", n.marginLeft = i.marginLeft, n.marginTop = i.marginTop), this.emit(r.RESIZE, this.gameSize, this.baseSize, this.displaySize, t, e), this;
                },
                updateOrientation: function() {
                    var t;
                    this._checkOrientation && (this._checkOrientation = !1, (t = c(this.width, this.height)) !== this.orientation && (this.orientation = t, this.emit(r.ORIENTATION_CHANGE, t)));
                },
                updateScale: function() {
                    var t, e, i = this.canvas.style, n = this.gameSize.width, s = this.gameSize.height, r = this.zoom, o = this.autoRound;
                    this.scaleMode === u.SCALE_MODE.NONE ? (this.displaySize.setSize(n * r, s * r), t = this.displaySize.width, e = this.displaySize.height, o && (t = Math.floor(t), e = Math.floor(e)), this._resetZoom && (i.width = t + "px", i.height = e + "px", this._resetZoom = !1)) : this.scaleMode === u.SCALE_MODE.RESIZE ? (this.displaySize.setSize(this.parentSize.width, this.parentSize.height), this.gameSize.setSize(this.displaySize.width, this.displaySize.height), this.baseSize.setSize(this.displaySize.width, this.displaySize.height), t = this.displaySize.width, e = this.displaySize.height, o && (t = Math.floor(t), e = Math.floor(e)), this.canvas.width = t, this.canvas.height = e) : (this.displaySize.setSize(this.parentSize.width, this.parentSize.height), t = this.displaySize.width, e = this.displaySize.height, o && (t = Math.floor(t), e = Math.floor(e)), i.width = t + "px", i.height = e + "px"), this.getParentBounds(), this.updateCenter();
                },
                getMaxZoom: function() {
                    var t = p(this.parentSize.width, this.gameSize.width, 0, !0), e = p(this.parentSize.height, this.gameSize.height, 0, !0);
                    return Math.max(Math.min(t, e), 1);
                },
                updateCenter: function() {
                    var t, e, i, n, s, r, o, a = this.autoCenter;
                    a !== u.CENTER.NO_CENTER && (e = (t = this.canvas).style, n = (i = t.getBoundingClientRect()).width, s = i.height, r = Math.floor((this.parentSize.width - n) / 2), o = Math.floor((this.parentSize.height - s) / 2), a === u.CENTER.CENTER_HORIZONTALLY ? o = 0 : a === u.CENTER.CENTER_VERTICALLY && (r = 0), e.marginLeft = r + "px", e.marginTop = o + "px");
                },
                updateBounds: function() {
                    var t = this.canvasBounds, e = this.canvas.getBoundingClientRect();
                    t.x = e.left + (window.pageXOffset || 0) - (document.documentElement.clientLeft || 0), t.y = e.top + (window.pageYOffset || 0) - (document.documentElement.clientTop || 0), t.width = e.width, t.height = e.height;
                },
                transformX: function(t) {
                    return (t - this.canvasBounds.left) * this.displayScale.x;
                },
                transformY: function(t) {
                    return (t - this.canvasBounds.top) * this.displayScale.y;
                },
                startFullscreen: function(t) {
                    void 0 === t && (t = {
                        navigationUI: "hide"
                    });
                    var e, i = this.fullscreen;
                    i.available ? i.active || (e = this.getFullscreenTarget(), i.keyboard ? e[i.request](Element.ALLOW_KEYBOARD_INPUT) : e[i.request](t)) : this.emit(r.FULLSCREEN_UNSUPPORTED);
                },
                fullscreenSuccessHandler: function() {
                    this.getParentBounds(), this.refresh(), this.emit(r.ENTER_FULLSCREEN);
                },
                fullscreenErrorHandler: function(t) {
                    this.removeFullscreenTarget(), this.emit(r.FULLSCREEN_FAILED, t);
                },
                getFullscreenTarget: function() {
                    var t;
                    return this.fullscreenTarget || ((t = document.createElement("div")).style.margin = "0", t.style.padding = "0", t.style.width = "100%", t.style.height = "100%", this.fullscreenTarget = t, this._createdFullscreenTarget = !0), this._createdFullscreenTarget && (this.canvas.parentNode.insertBefore(this.fullscreenTarget, this.canvas), this.fullscreenTarget.appendChild(this.canvas)), this.fullscreenTarget;
                },
                removeFullscreenTarget: function() {
                    var t, e;
                    !this._createdFullscreenTarget || (t = this.fullscreenTarget) && t.parentNode && ((e = t.parentNode).insertBefore(this.canvas, t), e.removeChild(t));
                },
                stopFullscreen: function() {
                    var t = this.fullscreen;
                    if (!t.available) return this.emit(r.FULLSCREEN_UNSUPPORTED), !1;
                    t.active && document[t.cancel](), this.removeFullscreenTarget(), this.getParentBounds(), this.emit(r.LEAVE_FULLSCREEN), this.refresh();
                },
                toggleFullscreen: function(t) {
                    this.fullscreen.active ? this.stopFullscreen() : this.startFullscreen(t);
                },
                startListeners: function() {
                    var e = this, i = this.listeners;
                    i.orientationChange = function() {
                        e.updateBounds(), e._checkOrientation = !0, e.dirty = !0;
                    }, i.windowResize = function() {
                        e.updateBounds(), e.dirty = !0;
                    }, window.addEventListener("orientationchange", i.orientationChange, !1), window.addEventListener("resize", i.windowResize, !1), this.fullscreen.available && (i.fullScreenChange = function(t) {
                        return e.onFullScreenChange(t);
                    }, i.fullScreenError = function(t) {
                        return e.onFullScreenError(t);
                    }, [
                        "webkit",
                        "moz",
                        ""
                    ].forEach(function(t) {
                        document.addEventListener(t + "fullscreenchange", i.fullScreenChange, !1), document.addEventListener(t + "fullscreenerror", i.fullScreenError, !1);
                    }), document.addEventListener("MSFullscreenChange", i.fullScreenChange, !1), document.addEventListener("MSFullscreenError", i.fullScreenError, !1));
                },
                onFullScreenChange: function() {
                    document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.mozFullScreenElement ? this.fullscreenSuccessHandler() : this.stopFullscreen();
                },
                onFullScreenError: function() {
                    this.removeFullscreenTarget();
                },
                step: function(t, e) {
                    this.parent && (this._lastCheck += e, (this.dirty || this._lastCheck > this.resizeInterval) && (this.getParentBounds() && this.refresh(), this.dirty = !1, this._lastCheck = 0));
                },
                stopListeners: function() {
                    var e = this.listeners;
                    window.removeEventListener("orientationchange", e.orientationChange, !1), window.removeEventListener("resize", e.windowResize, !1);
                    [
                        "webkit",
                        "moz",
                        ""
                    ].forEach(function(t) {
                        document.removeEventListener(t + "fullscreenchange", e.fullScreenChange, !1), document.removeEventListener(t + "fullscreenerror", e.fullScreenError, !1);
                    }), document.removeEventListener("MSFullscreenChange", e.fullScreenChange, !1), document.removeEventListener("MSFullscreenError", e.fullScreenError, !1);
                },
                destroy: function() {
                    this.removeAllListeners(), this.stopListeners(), this.game = null, this.canvas = null, this.canvasBounds = null, this.parent = null, this.fullscreenTarget = null, this.parentSize.destroy(), this.gameSize.destroy(), this.baseSize.destroy(), this.displaySize.destroy();
                },
                isFullscreen: {
                    get: function() {
                        return this.fullscreen.active;
                    }
                },
                width: {
                    get: function() {
                        return this.gameSize.width;
                    }
                },
                height: {
                    get: function() {
                        return this.gameSize.height;
                    }
                },
                isPortrait: {
                    get: function() {
                        return this.orientation === u.ORIENTATION.PORTRAIT;
                    }
                },
                isLandscape: {
                    get: function() {
                        return this.orientation === u.ORIENTATION.LANDSCAPE;
                    }
                },
                isGamePortrait: {
                    get: function() {
                        return this.height > this.width;
                    }
                },
                isGameLandscape: {
                    get: function() {
                        return this.width > this.height;
                    }
                }
            });
            t.exports = v;
        },
        function(t, e, i) {
            var n = i(18), s = i(0), r = i(76), o = i(3), a = new s({
                initialize: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = t), void 0 === i && (i = 0), void 0 === n && (n = null), this._width = t, this._height = e, this._parent = n, this.aspectMode = i, this.aspectRatio = 0 === e ? 1 : t / e, this.minWidth = 0, this.minHeight = 0, this.maxWidth = Number.MAX_VALUE, this.maxHeight = Number.MAX_VALUE, this.snapTo = new o;
                },
                setAspectMode: function(t) {
                    return void 0 === t && (t = 0), this.aspectMode = t, this.setSize(this._width, this._height);
                },
                setSnap: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this.snapTo.set(t, e), this.setSize(this._width, this._height);
                },
                setParent: function(t) {
                    return this._parent = t, this.setSize(this._width, this._height);
                },
                setMin: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this.minWidth = n(t, 0, this.maxWidth), this.minHeight = n(e, 0, this.maxHeight), this.setSize(this._width, this._height);
                },
                setMax: function(t, e) {
                    return void 0 === t && (t = Number.MAX_VALUE), void 0 === e && (e = t), this.maxWidth = n(t, this.minWidth, Number.MAX_VALUE), this.maxHeight = n(e, this.minHeight, Number.MAX_VALUE), this.setSize(this._width, this._height);
                },
                setSize: function(t, e) {
                    switch(void 0 === t && (t = 0), void 0 === e && (e = t), this.aspectMode){
                        case a.NONE:
                            this._width = this.getNewWidth(r(t, this.snapTo.x)), this._height = this.getNewHeight(r(e, this.snapTo.y)), this.aspectRatio = 0 === this._height ? 1 : this._width / this._height;
                            break;
                        case a.WIDTH_CONTROLS_HEIGHT:
                            this._width = this.getNewWidth(r(t, this.snapTo.x)), this._height = this.getNewHeight(this._width * (1 / this.aspectRatio), !1);
                            break;
                        case a.HEIGHT_CONTROLS_WIDTH:
                            this._height = this.getNewHeight(r(e, this.snapTo.y)), this._width = this.getNewWidth(this._height * this.aspectRatio, !1);
                            break;
                        case a.FIT:
                            this.constrain(t, e, !0);
                            break;
                        case a.ENVELOP:
                            this.constrain(t, e, !1);
                    }
                    return this;
                },
                setAspectRatio: function(t) {
                    return this.aspectRatio = t, this.setSize(this._width, this._height);
                },
                resize: function(t, e) {
                    return this._width = this.getNewWidth(r(t, this.snapTo.x)), this._height = this.getNewHeight(r(e, this.snapTo.y)), this.aspectRatio = 0 === this._height ? 1 : this._width / this._height, this;
                },
                getNewWidth: function(t, e) {
                    return void 0 === e && (e = !0), t = n(t, this.minWidth, this.maxWidth), e && this._parent && t > this._parent.width && (t = Math.max(this.minWidth, this._parent.width)), t;
                },
                getNewHeight: function(t, e) {
                    return void 0 === e && (e = !0), t = n(t, this.minHeight, this.maxHeight), e && this._parent && t > this._parent.height && (t = Math.max(this.minHeight, this._parent.height)), t;
                },
                constrain: function(t, e, i) {
                    void 0 === t && (t = 0), void 0 === e && (e = t), void 0 === i && (i = !0), t = this.getNewWidth(t), e = this.getNewHeight(e);
                    var n = this.snapTo, s = 0 === e ? 1 : t / e;
                    return i && this.aspectRatio > s || !i && this.aspectRatio < s ? (e = (t = r(t, n.x)) / this.aspectRatio, 0 < n.y && (t = (e = r(e, n.y)) * this.aspectRatio)) : (i && this.aspectRatio < s || !i && this.aspectRatio > s) && (t = (e = r(e, n.y)) * this.aspectRatio, 0 < n.x && (e = (t = r(t, n.x)) * (1 / this.aspectRatio))), this._width = t, this._height = e, this;
                },
                fitTo: function(t, e) {
                    return this.constrain(t, e, !0);
                },
                envelop: function(t, e) {
                    return this.constrain(t, e, !1);
                },
                setWidth: function(t) {
                    return this.setSize(t, this._height);
                },
                setHeight: function(t) {
                    return this.setSize(this._width, t);
                },
                toString: function() {
                    return "[{ Size (width=" + this._width + " height=" + this._height + " aspectRatio=" + this.aspectRatio + " aspectMode=" + this.aspectMode + ") }]";
                },
                setCSS: function(t) {
                    t && t.style && (t.style.width = this._width + "px", t.style.height = this._height + "px");
                },
                copy: function(t) {
                    return t.setAspectMode(this.aspectMode), t.aspectRatio = this.aspectRatio, t.setSize(this.width, this.height);
                },
                destroy: function() {
                    this._parent = null, this.snapTo = null;
                },
                width: {
                    get: function() {
                        return this._width;
                    },
                    set: function(t) {
                        this.setSize(t, this._height);
                    }
                },
                height: {
                    get: function() {
                        return this._height;
                    },
                    set: function(t) {
                        this.setSize(this._width, t);
                    }
                }
            });
            a.NONE = 0, a.WIDTH_CONTROLS_HEIGHT = 1, a.HEIGHT_CONTROLS_WIDTH = 2, a.FIT = 3, a.ENVELOP = 4, t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), r = i(142), s = i(21), o = i(22), l = i(6), a = i(91), h = i(1), u = i(412), c = i(201), d = new n({
                initialize: function(t, e) {
                    if (this.game = t, this.keys = {}, this.scenes = [], this._pending = [], this._start = [], this._queue = [], this._data = {}, this.isProcessing = !1, this.isBooted = !1, this.customViewports = 0, e) {
                        Array.isArray(e) || (e = [
                            e
                        ]);
                        for(var i = 0; i < e.length; i++)this._pending.push({
                            key: "default",
                            scene: e[i],
                            autoStart: 0 === i,
                            data: {}
                        });
                    }
                    t.events.once(o.READY, this.bootQueue, this);
                },
                bootQueue: function() {
                    if (!this.isBooted) {
                        for(var t = 0; t < this._pending.length; t++){
                            var e, i, n, s = (i = this._pending[t]).key;
                            (n = i.scene) instanceof u ? e = this.createSceneFromInstance(s, n) : "object" == typeof n ? e = this.createSceneFromObject(s, n) : "function" == typeof n && (e = this.createSceneFromFunction(s, n)), s = e.sys.settings.key, this.keys[s] = e, this.scenes.push(e), this._data[s] && (e.sys.settings.data = this._data[s].data, this._data[s].autoStart && (i.autoStart = !0)), (i.autoStart || e.sys.settings.active) && this._start.push(s);
                        }
                        for(this._pending.length = 0, this._data = {}, this.isBooted = !0, t = 0; t < this._start.length; t++)i = this._start[t], this.start(i);
                        this._start.length = 0;
                    }
                },
                processQueue: function() {
                    var t, e, i = this._pending.length, n = this._queue.length;
                    if (0 !== i || 0 !== n) {
                        if (i) {
                            for(t = 0; t < i; t++)e = this._pending[t], this.add(e.key, e.scene, e.autoStart, e.data);
                            for(t = 0; t < this._start.length; t++)e = this._start[t], this.start(e);
                            return this._start.length = 0, void (this._pending.length = 0);
                        }
                        for(t = 0; t < this._queue.length; t++)this[(e = this._queue[t]).op](e.keyA, e.keyB);
                        this._queue.length = 0;
                    }
                },
                add: function(t, e, i, n) {
                    var s;
                    return void 0 === i && (i = !1), void 0 === n && (n = {}), this.isProcessing || !this.isBooted ? (this._pending.push({
                        key: t,
                        scene: e,
                        autoStart: i,
                        data: n
                    }), this.isBooted || (this._data[t] = {
                        data: n
                    }), null) : (t = this.getKey(t, e), e instanceof u ? s = this.createSceneFromInstance(t, e) : "object" == typeof e ? (e.key = t, s = this.createSceneFromObject(t, e)) : "function" == typeof e && (s = this.createSceneFromFunction(t, e)), s.sys.settings.data = n, t = s.sys.settings.key, this.keys[t] = s, this.scenes.push(s), (i || s.sys.settings.active) && (this._pending.length ? this._start.push(t) : this.start(t)), s);
                },
                remove: function(t) {
                    if (this.isProcessing) this._queue.push({
                        op: "remove",
                        keyA: t,
                        keyB: null
                    });
                    else {
                        var e = this.getScene(t);
                        if (!e || e.sys.isTransitioning()) return this;
                        var i = this.scenes.indexOf(e), n = e.sys.settings.key;
                        -1 < i && (delete this.keys[n], this.scenes.splice(i, 1), -1 < this._start.indexOf(n) && (i = this._start.indexOf(n), this._start.splice(i, 1)), e.sys.destroy());
                    }
                    return this;
                },
                bootScene: function(t) {
                    var e, i = t.sys, n = i.settings;
                    i.sceneUpdate = h, t.init && (t.init.call(t, n.data), n.status = r.INIT, n.isTransition && i.events.emit(s.TRANSITION_INIT, n.transitionFrom, n.transitionDuration)), i.load && (e = i.load).reset(), e && t.preload ? (t.preload.call(t), 0 === e.list.size ? this.create(t) : (n.status = r.LOADING, e.once(a.COMPLETE, this.loadComplete, this), e.start())) : this.create(t);
                },
                loadComplete: function(t) {
                    var e = t.scene;
                    this.game.sound && this.game.sound.onBlurPausedSounds && this.game.sound.unlock(), this.create(e);
                },
                payloadComplete: function(t) {
                    this.bootScene(t.scene);
                },
                update: function(t, e) {
                    this.processQueue(), this.isProcessing = !0;
                    for(var i = this.scenes.length - 1; 0 <= i; i--){
                        var n = this.scenes[i].sys;
                        n.settings.status > r.START && n.settings.status <= r.RUNNING && n.step(t, e);
                    }
                },
                render: function(t) {
                    for(var e = 0; e < this.scenes.length; e++){
                        var i = this.scenes[e].sys;
                        i.settings.visible && i.settings.status >= r.LOADING && i.settings.status < r.SLEEPING && i.render(t);
                    }
                    this.isProcessing = !1;
                },
                create: function(t) {
                    var e = t.sys, i = e.settings;
                    t.create && (i.status = r.CREATING, t.create.call(t, i.data), i.status === r.DESTROYED) || (i.isTransition && e.events.emit(s.TRANSITION_START, i.transitionFrom, i.transitionDuration), t.update && (e.sceneUpdate = t.update), i.status = r.RUNNING, e.events.emit(s.CREATE, t));
                },
                createSceneFromFunction: function(t, e) {
                    var i = new e;
                    if (i instanceof u) {
                        var n = i.sys.settings.key;
                        if ("" !== n && (t = n), this.keys.hasOwnProperty(t)) throw new Error("Cannot add a Scene with duplicate key: " + t);
                        return this.createSceneFromInstance(t, i);
                    }
                    return i.sys = new c(i), i.sys.settings.key = t, i.sys.init(this.game), i;
                },
                createSceneFromInstance: function(t, e) {
                    return "" === e.sys.settings.key && (e.sys.settings.key = t), e.sys.init(this.game), e;
                },
                createSceneFromObject: function(t, e) {
                    var i = new u(e), n = i.sys.settings.key;
                    "" !== n ? t = n : i.sys.settings.key = t, i.sys.init(this.game);
                    for(var s, r = [
                        "init",
                        "preload",
                        "create",
                        "update",
                        "render"
                    ], o = 0; o < r.length; o++){
                        var a = l(e, r[o], null);
                        a && (i[r[o]] = a);
                    }
                    if (e.hasOwnProperty("extend")) for(var h in e.extend)e.extend.hasOwnProperty(h) && (s = e.extend[h], "data" === h && i.hasOwnProperty("data") && "object" == typeof s ? i.data.merge(s) : "sys" !== h && (i[h] = s));
                    return i;
                },
                getKey: function(t, e) {
                    if (t = t || "default", "function" == typeof e) return t;
                    if (e instanceof u ? t = e.sys.settings.key : "object" == typeof e && e.hasOwnProperty("key") && (t = e.key), this.keys.hasOwnProperty(t)) throw new Error("Cannot add a Scene with duplicate key: " + t);
                    return t;
                },
                getScenes: function(t, e) {
                    void 0 === t && (t = !0), void 0 === e && (e = !1);
                    for(var i = [], n = this.scenes, s = 0; s < n.length; s++){
                        var r = n[s];
                        r && (!t || t && r.sys.isActive()) && i.push(r);
                    }
                    return e ? i.reverse() : i;
                },
                getScene: function(t) {
                    if ("string" == typeof t) {
                        if (this.keys[t]) return this.keys[t];
                    } else for(var e = 0; e < this.scenes.length; e++)if (t === this.scenes[e]) return t;
                    return null;
                },
                isActive: function(t) {
                    var e = this.getScene(t);
                    return e ? e.sys.isActive() : null;
                },
                isPaused: function(t) {
                    var e = this.getScene(t);
                    return e ? e.sys.isPaused() : null;
                },
                isVisible: function(t) {
                    var e = this.getScene(t);
                    return e ? e.sys.isVisible() : null;
                },
                isSleeping: function(t) {
                    var e = this.getScene(t);
                    return e ? e.sys.isSleeping() : null;
                },
                pause: function(t, e) {
                    var i = this.getScene(t);
                    return i && i.sys.pause(e), this;
                },
                resume: function(t, e) {
                    var i = this.getScene(t);
                    return i && i.sys.resume(e), this;
                },
                sleep: function(t, e) {
                    var i = this.getScene(t);
                    return i && !i.sys.isTransitioning() && i.sys.sleep(e), this;
                },
                wake: function(t, e) {
                    var i = this.getScene(t);
                    return i && i.sys.wake(e), this;
                },
                run: function(t, e) {
                    var i = this.getScene(t);
                    if (!i) {
                        for(var n = 0; n < this._pending.length; n++)if (this._pending[n].key === t) {
                            this.queueOp("start", t, e);
                            break;
                        }
                        return this;
                    }
                    i.sys.isSleeping() ? i.sys.wake(e) : i.sys.isPaused() ? i.sys.resume(e) : this.start(t, e);
                },
                start: function(t, e) {
                    if (!this.isBooted) return this._data[t] = {
                        autoStart: !0,
                        data: e
                    }, this;
                    var i = this.getScene(t);
                    if (i) {
                        var n, s = i.sys;
                        if (s.isActive() || s.isPaused()) s.shutdown(), s.sceneUpdate = h, s.start(e);
                        else if (s.sceneUpdate = h, s.start(e), s.load && (n = s.load), n && s.settings.hasOwnProperty("pack") && (n.reset(), n.addPack({
                            payload: s.settings.pack
                        }))) return s.settings.status = r.LOADING, n.once(a.COMPLETE, this.payloadComplete, this), n.start(), this;
                        this.bootScene(i);
                    }
                    return this;
                },
                stop: function(t, e) {
                    var i = this.getScene(t);
                    return i && !i.sys.isTransitioning() && i.sys.shutdown(e), this;
                },
                switch: function(t, e) {
                    var i = this.getScene(t), n = this.getScene(e);
                    return i && n && i !== n && (this.sleep(t), this.isSleeping(e) ? this.wake(e) : this.start(e)), this;
                },
                getAt: function(t) {
                    return this.scenes[t];
                },
                getIndex: function(t) {
                    var e = this.getScene(t);
                    return this.scenes.indexOf(e);
                },
                bringToTop: function(t) {
                    var e, i;
                    return this.isProcessing ? this._queue.push({
                        op: "bringToTop",
                        keyA: t,
                        keyB: null
                    }) : -1 !== (e = this.getIndex(t)) && e < this.scenes.length && (i = this.getScene(t), this.scenes.splice(e, 1), this.scenes.push(i)), this;
                },
                sendToBack: function(t) {
                    var e, i;
                    return this.isProcessing ? this._queue.push({
                        op: "sendToBack",
                        keyA: t,
                        keyB: null
                    }) : -1 !== (e = this.getIndex(t)) && 0 < e && (i = this.getScene(t), this.scenes.splice(e, 1), this.scenes.unshift(i)), this;
                },
                moveDown: function(t) {
                    var e, i, n, s;
                    return this.isProcessing ? this._queue.push({
                        op: "moveDown",
                        keyA: t,
                        keyB: null
                    }) : 0 < (e = this.getIndex(t)) && (i = e - 1, n = this.getScene(t), s = this.getAt(i), this.scenes[e] = s, this.scenes[i] = n), this;
                },
                moveUp: function(t) {
                    var e, i, n, s;
                    return this.isProcessing ? this._queue.push({
                        op: "moveUp",
                        keyA: t,
                        keyB: null
                    }) : (e = this.getIndex(t)) < this.scenes.length - 1 && (i = e + 1, n = this.getScene(t), s = this.getAt(i), this.scenes[e] = s, this.scenes[i] = n), this;
                },
                moveAbove: function(t, e) {
                    var i, n, s;
                    return t === e || (this.isProcessing ? this._queue.push({
                        op: "moveAbove",
                        keyA: t,
                        keyB: e
                    }) : (i = this.getIndex(t), n = this.getIndex(e), -1 !== i && -1 !== n && (s = this.getAt(n), this.scenes.splice(n, 1), this.scenes.splice(i + 1, 0, s)))), this;
                },
                moveBelow: function(t, e) {
                    var i, n, s;
                    return t === e || (this.isProcessing ? this._queue.push({
                        op: "moveBelow",
                        keyA: t,
                        keyB: e
                    }) : (i = this.getIndex(t), n = this.getIndex(e), -1 !== i && -1 !== n && (s = this.getAt(n), this.scenes.splice(n, 1), 0 === i ? this.scenes.unshift(s) : this.scenes.splice(i, 0, s)))), this;
                },
                queueOp: function(t, e, i) {
                    return this._queue.push({
                        op: t,
                        keyA: e,
                        keyB: i
                    }), this;
                },
                swapPosition: function(t, e) {
                    var i, n, s;
                    return t === e || (this.isProcessing ? this._queue.push({
                        op: "swapPosition",
                        keyA: t,
                        keyB: e
                    }) : (i = this.getIndex(t)) !== (n = this.getIndex(e)) && -1 !== i && -1 !== n && (s = this.getAt(i), this.scenes[i] = this.scenes[n], this.scenes[n] = s)), this;
                },
                dump: function() {
                    for(var t = [], e = [
                        "pending",
                        "init",
                        "start",
                        "loading",
                        "creating",
                        "running",
                        "paused",
                        "sleeping",
                        "shutdown",
                        "destroyed"
                    ], i = 0; i < this.scenes.length; i++){
                        var n = this.scenes[i].sys, s = !n.settings.visible || n.settings.status !== r.RUNNING && n.settings.status !== r.PAUSED ? "[-] " : "[*] ";
                        s += n.settings.key + " (" + e[n.settings.status] + ")", t.push(s);
                    }
                    console.log(t.join("\n"));
                },
                destroy: function() {
                    for(var t = 0; t < this.scenes.length; t++)this.scenes[t].sys.destroy();
                    this.update = h, this.scenes = [], this._pending = [], this._start = [], this._queue = [], this.game = null;
                }
            });
            t.exports = d;
        },
        function(t, e, i) {
            var n = i(0), s = i(201), r = new n({
                initialize: function(t) {
                    this.sys = new s(this, t), this.game, this.anims, this.cache, this.registry, this.sound, this.textures, this.events, this.cameras, this.add, this.make, this.scene, this.children, this.lights, this.data, this.input, this.load, this.time, this.tweens, this.physics, this.matter, this.scale, this.plugins, this.renderer;
                },
                update: function() {}
            });
            t.exports = r;
        },
        function(t, e, i) {
            var r = i(2), o = i(202);
            t.exports = function(t) {
                var e = t.game.config.defaultPhysicsSystem, i = r(t.settings, "physics", !1);
                if (e || i) {
                    var n = [];
                    if (e && n.push(o(e + "Physics")), i) for(var s in i)s = o(s.concat("Physics")), -1 === n.indexOf(s) && n.push(s);
                    return n;
                }
            };
        },
        function(t, e, i) {
            var n = i(2);
            t.exports = function(t) {
                var e = t.plugins.getDefaultScenePlugins(), i = n(t.settings, "plugins", !1);
                return Array.isArray(i) ? i : e || [];
            };
        },
        function(t, e, i) {
            var n = i(142), s = i(6), r = i(143), o = i(974), a = {
                create: function(t) {
                    return "string" == typeof t ? t = {
                        key: t
                    } : void 0 === t && (t = {}), {
                        status: n.PENDING,
                        key: s(t, "key", ""),
                        active: s(t, "active", !1),
                        visible: s(t, "visible", !0),
                        isBooted: !1,
                        isTransition: !1,
                        transitionFrom: null,
                        transitionDuration: 0,
                        transitionAllowInput: !0,
                        data: {},
                        pack: s(t, "pack", !1),
                        cameras: s(t, "cameras", null),
                        map: s(t, "map", r(o, s(t, "mapAdd", {}))),
                        physics: s(t, "physics", {}),
                        loader: s(t, "loader", {}),
                        plugins: s(t, "plugins", !1),
                        input: s(t, "input", {})
                    };
                }
            };
            t.exports = a;
        },
        function(t, e, i) {
            var h = i(31), s = i(417), n = i(0), l = i(37), r = i(32), o = i(9), u = i(103), a = i(22), c = i(382), d = i(6), f = i(419), p = i(203), g = new n({
                Extends: o,
                initialize: function(t) {
                    o.call(this), this.game = t, this.name = "TextureManager", this.list = {}, this._tempCanvas = h.create2D(this, 1, 1), this._tempContext = this._tempCanvas.getContext("2d"), this._pending = 0, t.events.once(a.BOOT, this.boot, this);
                },
                boot: function() {
                    this.on(u.LOAD, this.updatePending, this), this.on(u.ERROR, this.updatePending, this);
                    var t = this.game.config;
                    this.addBase64("__DEFAULT", t.defaultImage), this.addBase64("__MISSING", t.missingImage), this.addBase64("__WHITE", t.whiteImage), this._pending = 3, this.game.events.once(a.DESTROY, this.destroy, this);
                },
                updatePending: function() {
                    this._pending--, 0 === this._pending && (this.off(u.LOAD), this.off(u.ERROR), this.emit(u.READY));
                },
                checkKey: function(t) {
                    return !this.exists(t) || (console.error("Texture key already in use: " + t), !1);
                },
                remove: function(t) {
                    if ("string" == typeof t) {
                        if (!this.exists(t)) return console.warn("No texture found matching key: " + t), this;
                        t = this.get(t);
                    }
                    return this.list.hasOwnProperty(t.key) && (t.destroy(), this.emit(u.REMOVE, t.key)), this;
                },
                removeKey: function(t) {
                    return this.list.hasOwnProperty(t) && delete this.list[t], this;
                },
                addBase64: function(e, t) {
                    var i, n;
                    return this.checkKey(e) && (i = this, (n = new Image).onerror = function() {
                        i.emit(u.ERROR, e);
                    }, n.onload = function() {
                        var t = i.create(e, n);
                        f.Image(t, 0), i.emit(u.ADD, e, t), i.emit(u.LOAD, e, t);
                    }, n.src = t), this;
                },
                getBase64: function(t, e, i, n) {
                    void 0 === i && (i = "image/png"), void 0 === n && (n = .92);
                    var s, r, o = "", a = this.getFrame(t, e);
                    return a && (a.source.isRenderTexture || a.source.isGLTexture) ? console.warn("Cannot getBase64 from WebGL Texture") : a && (s = a.canvasData, (r = h.create2D(this, s.width, s.height)).getContext("2d").drawImage(a.source.image, s.x, s.y, s.width, s.height, 0, 0, s.width, s.height), o = r.toDataURL(i, n), h.remove(r)), o;
                },
                addImage: function(t, e, i) {
                    var n = null;
                    return this.checkKey(t) && (n = this.create(t, e), f.Image(n, 0), i && n.setDataSource(i), this.emit(u.ADD, t, n)), n;
                },
                addGLTexture: function(t, e, i, n) {
                    var s = null;
                    return this.checkKey(t) && (void 0 === i && (i = e.width), void 0 === n && (n = e.height), (s = this.create(t, e, i, n)).add("__BASE", 0, 0, 0, i, n), this.emit(u.ADD, t, s)), s;
                },
                addRenderTexture: function(t, e) {
                    var i = null;
                    return this.checkKey(t) && ((i = this.create(t, e)).add("__BASE", 0, 0, 0, e.width, e.height), this.emit(u.ADD, t, i)), i;
                },
                generate: function(t, e) {
                    if (this.checkKey(t)) {
                        var i = h.create(this, 1, 1);
                        return e.canvas = i, c(e), this.addCanvas(t, i);
                    }
                    return null;
                },
                createCanvas: function(t, e, i) {
                    if (void 0 === e && (e = 256), void 0 === i && (i = 256), this.checkKey(t)) {
                        var n = h.create(this, e, i, r.CANVAS, !0);
                        return this.addCanvas(t, n);
                    }
                    return null;
                },
                addCanvas: function(t, e, i) {
                    void 0 === i && (i = !1);
                    var n = null;
                    return i ? n = new s(this, t, e, e.width, e.height) : this.checkKey(t) && (n = new s(this, t, e, e.width, e.height), this.list[t] = n, this.emit(u.ADD, t, n)), n;
                },
                addAtlas: function(t, e, i, n) {
                    return Array.isArray(i.textures) || Array.isArray(i.frames) ? this.addAtlasJSONArray(t, e, i, n) : this.addAtlasJSONHash(t, e, i, n);
                },
                addAtlasJSONArray: function(t, e, i, n) {
                    var s = null;
                    if (this.checkKey(t)) {
                        if (s = this.create(t, e), Array.isArray(i)) for(var r = 1 === i.length, o = 0; o < s.source.length; o++){
                            var a = r ? i[0] : i[o];
                            f.JSONArray(s, o, a);
                        }
                        else f.JSONArray(s, 0, i);
                        n && s.setDataSource(n), this.emit(u.ADD, t, s);
                    }
                    return s;
                },
                addAtlasJSONHash: function(t, e, i, n) {
                    var s = null;
                    if (this.checkKey(t)) {
                        if (s = this.create(t, e), Array.isArray(i)) for(var r = 0; r < i.length; r++)f.JSONHash(s, r, i[r]);
                        else f.JSONHash(s, 0, i);
                        n && s.setDataSource(n), this.emit(u.ADD, t, s);
                    }
                    return s;
                },
                addAtlasXML: function(t, e, i, n) {
                    var s = null;
                    return this.checkKey(t) && (s = this.create(t, e), f.AtlasXML(s, 0, i), n && s.setDataSource(n), this.emit(u.ADD, t, s)), s;
                },
                addUnityAtlas: function(t, e, i, n) {
                    var s = null;
                    return this.checkKey(t) && (s = this.create(t, e), f.UnityYAML(s, 0, i), n && s.setDataSource(n), this.emit(u.ADD, t, s)), s;
                },
                addSpriteSheet: function(t, e, i) {
                    var n, s, r = null;
                    return this.checkKey(t) && (n = (r = this.create(t, e)).source[0].width, s = r.source[0].height, f.SpriteSheet(r, 0, 0, 0, n, s, i), this.emit(u.ADD, t, r)), r;
                },
                addSpriteSheetFromAtlas: function(t, e) {
                    if (!this.checkKey(t)) return null;
                    var i = d(e, "atlas", null), n = d(e, "frame", null);
                    if (i && n) {
                        var s = this.get(i).get(n);
                        if (s) {
                            var r = this.create(t, s.source.image);
                            return s.trimmed ? f.SpriteSheetFromAtlas(r, s, e) : f.SpriteSheet(r, 0, s.cutX, s.cutY, s.cutWidth, s.cutHeight, e), this.emit(u.ADD, t, r), r;
                        }
                    }
                },
                create: function(t, e, i, n) {
                    var s = null;
                    return this.checkKey(t) && (s = new p(this, t, e, i, n), this.list[t] = s), s;
                },
                exists: function(t) {
                    return this.list.hasOwnProperty(t);
                },
                get: function(t) {
                    return void 0 === t && (t = "__DEFAULT"), this.list[t] ? this.list[t] : t instanceof p ? t : this.list.__MISSING;
                },
                cloneFrame: function(t, e) {
                    if (this.list[t]) return this.list[t].get(e).clone();
                },
                getFrame: function(t, e) {
                    if (this.list[t]) return this.list[t].get(e);
                },
                getTextureKeys: function() {
                    var t = [];
                    for(var e in this.list)"__DEFAULT" !== e && "__MISSING" !== e && t.push(e);
                    return t;
                },
                getPixel: function(t, e, i, n) {
                    var s = this.getFrame(i, n);
                    if (s) {
                        t -= s.x, e -= s.y;
                        var r = s.data.cut;
                        if (t += r.x, e += r.y, t >= r.x && t < r.r && e >= r.y && e < r.b) {
                            var o = this._tempContext;
                            o.clearRect(0, 0, 1, 1), o.drawImage(s.source.image, t, e, 1, 1, 0, 0, 1, 1);
                            var a = o.getImageData(0, 0, 1, 1);
                            return new l(a.data[0], a.data[1], a.data[2], a.data[3]);
                        }
                    }
                    return null;
                },
                getPixelAlpha: function(t, e, i, n) {
                    var s = this.getFrame(i, n);
                    if (s) {
                        t -= s.x, e -= s.y;
                        var r = s.data.cut;
                        if (t += r.x, e += r.y, t >= r.x && t < r.r && e >= r.y && e < r.b) {
                            var o = this._tempContext;
                            return o.clearRect(0, 0, 1, 1), o.drawImage(s.source.image, t, e, 1, 1, 0, 0, 1, 1), o.getImageData(0, 0, 1, 1).data[3];
                        }
                    }
                    return null;
                },
                setTexture: function(t, e, i) {
                    return this.list[e] && (t.texture = this.list[e], t.frame = t.texture.get(i)), t;
                },
                renameTexture: function(t, e) {
                    var i = this.get(t);
                    return !(!i || t === e) && (i.key = e, this.list[e] = i, delete this.list[t], !0);
                },
                each: function(t, e) {
                    for(var i = [
                        null
                    ], n = 1; n < arguments.length; n++)i.push(arguments[n]);
                    for(var s in this.list)i[0] = this.list[s], t.apply(e, i);
                },
                destroy: function() {
                    for(var t in this.list)this.list[t].destroy();
                    this.list = {}, this.game = null, h.remove(this._tempCanvas);
                }
            });
            t.exports = g;
        },
        function(t, e, i) {
            var n = i(0), f = i(18), p = i(37), s = i(32), r = i(136), o = i(203), a = new n({
                Extends: o,
                initialize: function(t, e, i, n, s) {
                    o.call(this, t, e, i, n, s), this.add("__BASE", 0, 0, 0, n, s), this._source = this.frames.__BASE.source, this.canvas = this._source.image, this.context = this.canvas.getContext("2d"), this.width = n, this.height = s, this.imageData = this.context.getImageData(0, 0, n, s), this.data = null, this.imageData && (this.data = this.imageData.data), this.pixels = null, this.buffer, this.data && (this.imageData.data.buffer ? (this.buffer = this.imageData.data.buffer, this.pixels = new Uint32Array(this.buffer)) : window.ArrayBuffer ? (this.buffer = new ArrayBuffer(this.imageData.data.length), this.pixels = new Uint32Array(this.buffer)) : this.pixels = this.imageData.data);
                },
                update: function() {
                    return this.imageData = this.context.getImageData(0, 0, this.width, this.height), this.data = this.imageData.data, this.imageData.data.buffer ? (this.buffer = this.imageData.data.buffer, this.pixels = new Uint32Array(this.buffer)) : window.ArrayBuffer ? (this.buffer = new ArrayBuffer(this.imageData.data.length), this.pixels = new Uint32Array(this.buffer)) : this.pixels = this.imageData.data, this.manager.game.config.renderType === s.WEBGL && this.refresh(), this;
                },
                draw: function(t, e, i) {
                    return this.context.drawImage(i, t, e), this.update();
                },
                drawFrame: function(t, e, i, n) {
                    void 0 === i && (i = 0), void 0 === n && (n = 0);
                    var s = this.manager.getFrame(t, e);
                    if (s) {
                        var r = s.canvasData, o = s.cutWidth, a = s.cutHeight, h = s.source.resolution;
                        return this.context.drawImage(s.source.image, r.x, r.y, o, a, i, n, o / h, a / h), this.update();
                    }
                    return this;
                },
                setPixel: function(t, e, i, n, s, r) {
                    var o;
                    return void 0 === r && (r = 255), t = Math.abs(Math.floor(t)), e = Math.abs(Math.floor(e)), -1 < this.getIndex(t, e) && ((o = this.context.getImageData(t, e, 1, 1)).data[0] = i, o.data[1] = n, o.data[2] = s, o.data[3] = r, this.context.putImageData(o, t, e)), this;
                },
                putData: function(t, e, i, n, s, r, o) {
                    return void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = t.width), void 0 === o && (o = t.height), this.context.putImageData(t, e, i, n, s, r, o), this;
                },
                getData: function(t, e, i, n) {
                    return t = f(Math.floor(t), 0, this.width - 1), e = f(Math.floor(e), 0, this.height - 1), i = f(i, 1, this.width - t), n = f(n, 1, this.height - e), this.context.getImageData(t, e, i, n);
                },
                getPixel: function(t, e, i) {
                    i = i || new p;
                    var n, s, r, o, a, h = this.getIndex(t, e);
                    return -1 < h && (s = (n = this.data)[h + 0], r = n[h + 1], o = n[h + 2], a = n[h + 3], i.setTo(s, r, o, a)), i;
                },
                getPixels: function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.width), void 0 === n && (n = i), t = Math.abs(Math.round(t)), e = Math.abs(Math.round(e));
                    for(var s = f(t, 0, this.width), r = f(t + i, 0, this.width), o = f(e, 0, this.height), a = f(e + n, 0, this.height), h = new p, l = [], u = o; u < a; u++){
                        for(var c = [], d = s; d < r; d++)h = this.getPixel(d, u, h), c.push({
                            x: d,
                            y: u,
                            color: h.color,
                            alpha: h.alphaGL
                        });
                        l.push(c);
                    }
                    return l;
                },
                getIndex: function(t, e) {
                    return t = Math.abs(Math.round(t)), e = Math.abs(Math.round(e)), t < this.width && e < this.height ? 4 * (t + e * this.width) : -1;
                },
                refresh: function() {
                    return this._source.update(), this;
                },
                getCanvas: function() {
                    return this.canvas;
                },
                getContext: function() {
                    return this.context;
                },
                clear: function(t, e, i, n) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.width), void 0 === n && (n = this.height), this.context.clearRect(t, e, i, n), this.update();
                },
                setSize: function(t, e) {
                    return void 0 === e && (e = t), t === this.width && e === this.height || (this.canvas.width = t, this.canvas.height = e, this._source.width = t, this._source.height = e, this._source.isPowerOf2 = r(t, e), this.frames.__BASE.setSize(t, e, 0, 0), this.width = t, this.height = e, this.refresh()), this;
                },
                destroy: function() {
                    o.prototype.destroy.call(this), this._source = null, this.canvas = null, this.context = null, this.imageData = null, this.data = null, this.pixels = null, this.buffer = null;
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(31), s = i(0), o = i(136), a = i(164), r = new s({
                initialize: function(t, e, i, n, s) {
                    void 0 === s && (s = !1);
                    var r = t.manager.game;
                    this.renderer = r.renderer, this.texture = t, this.source = e, this.image = e, this.compressionAlgorithm = null, this.resolution = 1, this.width = i || e.naturalWidth || e.videoWidth || e.width || 0, this.height = n || e.naturalHeight || e.videoHeight || e.height || 0, this.scaleMode = a.DEFAULT, this.isCanvas = e instanceof HTMLCanvasElement, this.isVideo = window.hasOwnProperty("HTMLVideoElement") && e instanceof HTMLVideoElement, this.isRenderTexture = "RenderTexture" === e.type, this.isGLTexture = window.hasOwnProperty("WebGLTexture") && e instanceof WebGLTexture, this.isPowerOf2 = o(this.width, this.height), this.glTexture = null, this.glIndex = 0, this.glIndexCounter = -1, this.flipY = s, this.init(r);
                },
                init: function(t) {
                    var e = this.renderer;
                    e && (e.gl ? this.isCanvas ? this.glTexture = e.createCanvasTexture(this.image, !1, this.flipY) : this.isVideo ? this.glTexture = e.createVideoTexture(this.image, !1, this.flipY) : this.isRenderTexture ? (this.image = this.source.canvas, this.glTexture = e.createTextureFromSource(null, this.width, this.height, this.scaleMode)) : this.isGLTexture ? this.glTexture = this.source : this.glTexture = e.createTextureFromSource(this.image, this.width, this.height, this.scaleMode) : this.isRenderTexture && (this.image = this.source.canvas)), t.config.antialias || this.setFilter(1);
                },
                setFilter: function(t) {
                    this.renderer.gl && this.renderer.setTextureFilter(this.glTexture, t), this.scaleMode = t;
                },
                setFlipY: function(t) {
                    return void 0 === t && (t = !0), this.flipY = t, this;
                },
                update: function() {
                    var t = this.renderer.gl;
                    t && this.isCanvas ? this.glTexture = this.renderer.updateCanvasTexture(this.image, this.glTexture, this.flipY) : t && this.isVideo && (this.glTexture = this.renderer.updateVideoTexture(this.image, this.glTexture, this.flipY));
                },
                destroy: function() {
                    this.glTexture && this.renderer.deleteTexture(this.glTexture, !1), this.isCanvas && n.remove(this.image), this.renderer = null, this.texture = null, this.source = null, this.image = null, this.glTexture = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            t.exports = {
                AtlasXML: i(975),
                Canvas: i(976),
                Image: i(977),
                JSONArray: i(978),
                JSONHash: i(979),
                SpriteSheet: i(980),
                SpriteSheetFromAtlas: i(981),
                UnityYAML: i(982)
            };
        },
        function(t, e, i) {
            var n = i(421), s = i(424), r = i(426), o = {
                create: function(t) {
                    var e = t.config.audio, i = t.device.audio;
                    return new (e.noAudio || !i.webAudio && !i.audioData ? s : i.webAudio && !e.disableWebAudio ? r : n)(t);
                }
            };
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(144), s = i(0), o = i(69), r = i(423), a = new s({
                Extends: n,
                initialize: function(t) {
                    this.override = !0, this.audioPlayDelay = .1, this.loopEndOffset = .05, this.onBlurPausedSounds = [], this.locked = "ontouchstart" in window, this.lockedActionsQueue = this.locked ? [] : null, this._mute = !1, this._volume = 1, n.call(this, t);
                },
                add: function(t, e) {
                    var i = new r(this, t, e);
                    return this.sounds.push(i), i;
                },
                unlock: function() {
                    this.locked = !1;
                    var e, i, n, r = this;
                    this.game.cache.audio.entries.each(function(t, e) {
                        for(var i = 0; i < e.length; i++)if ("true" === e[i].dataset.locked) return r.locked = !0, false;
                        return !0;
                    }), this.locked && (e = !1, i = function() {
                        e = !0;
                    }, n = function() {
                        var s, t;
                        e ? e = !1 : (document.body.removeEventListener("touchmove", i), document.body.removeEventListener("touchend", n), s = [], r.game.cache.audio.entries.each(function(t, e) {
                            for(var i = 0; i < e.length; i++){
                                var n = e[i];
                                "true" === n.dataset.locked && s.push(n);
                            }
                            return !0;
                        }), 0 !== s.length && ((t = s[s.length - 1]).oncanplaythrough = function() {
                            t.oncanplaythrough = null, s.forEach(function(t) {
                                t.dataset.locked = "false";
                            }), r.unlocked = !0;
                        }, s.forEach(function(t) {
                            t.load();
                        })));
                    }, this.once(o.UNLOCKED, function() {
                        for(this.forEachActiveSound(function(t) {
                            null === t.currentMarker && 0 === t.duration && (t.duration = t.tags[0].duration), t.totalDuration = t.tags[0].duration;
                        }); this.lockedActionsQueue.length;){
                            var t = this.lockedActionsQueue.shift();
                            t.sound[t.prop].apply ? t.sound[t.prop].apply(t.sound, t.value || []) : t.sound[t.prop] = t.value;
                        }
                    }, this), document.body.addEventListener("touchmove", i, !1), document.body.addEventListener("touchend", n, !1));
                },
                onBlur: function() {
                    this.forEachActiveSound(function(t) {
                        t.isPlaying && (this.onBlurPausedSounds.push(t), t.onBlur());
                    });
                },
                onFocus: function() {
                    this.onBlurPausedSounds.forEach(function(t) {
                        t.onFocus();
                    }), this.onBlurPausedSounds.length = 0;
                },
                destroy: function() {
                    n.prototype.destroy.call(this), this.onBlurPausedSounds.length = 0, this.onBlurPausedSounds = null;
                },
                isLocked: function(t, e, i) {
                    return "true" === t.tags[0].dataset.locked && (this.lockedActionsQueue.push({
                        sound: t,
                        prop: e,
                        value: i
                    }), !0);
                },
                setMute: function(t) {
                    return this.mute = t, this;
                },
                mute: {
                    get: function() {
                        return this._mute;
                    },
                    set: function(t) {
                        this._mute = t, this.forEachActiveSound(function(t) {
                            t.updateMute();
                        }), this.emit(o.GLOBAL_MUTE, this, t);
                    }
                },
                setVolume: function(t) {
                    return this.volume = t, this;
                },
                volume: {
                    get: function() {
                        return this._volume;
                    },
                    set: function(t) {
                        this._volume = t, this.forEachActiveSound(function(t) {
                            t.updateVolume();
                        }), this.emit(o.GLOBAL_VOLUME, this, t);
                    }
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var a = i(78);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === n && (n = 0), void 0 === s && (s = t.length), a(t, n, s)) for(var r = n; r < s; r++){
                    var o = t[r];
                    if (!e || e && void 0 === i && o.hasOwnProperty(e) || e && void 0 !== i && o[e] === i) return o;
                }
                return null;
            };
        },
        function(t, e, i) {
            var n = i(145), s = i(0), r = i(69), o = i(18), a = new s({
                Extends: n,
                initialize: function(t, e, i) {
                    if (void 0 === i && (i = {}), this.tags = t.game.cache.audio.get(e), !this.tags) throw new Error('There is no audio asset with key "' + e + '" in the audio cache');
                    this.audio = null, this.startTime = 0, this.previousTime = 0, this.duration = this.tags[0].duration, this.totalDuration = this.tags[0].duration, n.call(this, t, e, i);
                },
                play: function(t, e) {
                    return !this.manager.isLocked(this, "play", [
                        t,
                        e
                    ]) && !!n.prototype.play.call(this, t, e) && !!this.pickAndPlayAudioTag() && (this.emit(r.PLAY, this), !0);
                },
                pause: function() {
                    return !this.manager.isLocked(this, "pause") && !(0 < this.startTime) && !!n.prototype.pause.call(this) && (this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0), this.stopAndReleaseAudioTag(), this.emit(r.PAUSE, this), !0);
                },
                resume: function() {
                    return !this.manager.isLocked(this, "resume") && !(0 < this.startTime) && !!n.prototype.resume.call(this) && !!this.pickAndPlayAudioTag() && (this.emit(r.RESUME, this), !0);
                },
                stop: function() {
                    return !this.manager.isLocked(this, "stop") && !!n.prototype.stop.call(this) && (this.stopAndReleaseAudioTag(), this.emit(r.STOP, this), !0);
                },
                pickAndPlayAudioTag: function() {
                    if (!this.pickAudioTag()) return this.reset(), !1;
                    var t = this.currentConfig.seek, e = this.currentConfig.delay, i = (this.currentMarker ? this.currentMarker.start : 0) + t;
                    return this.previousTime = i, this.audio.currentTime = i, this.applyConfig(), 0 === e ? (this.startTime = 0, this.audio.paused && this.playCatchPromise()) : (this.startTime = window.performance.now() + 1e3 * e, this.audio.paused || this.audio.pause()), this.resetConfig(), !0;
                },
                pickAudioTag: function() {
                    if (this.audio) return !0;
                    for(var t = 0; t < this.tags.length; t++){
                        var e = this.tags[t];
                        if ("false" === e.dataset.used) return e.dataset.used = "true", this.audio = e, !0;
                    }
                    if (!this.manager.override) return !1;
                    var i = [];
                    this.manager.forEachActiveSound(function(t) {
                        t.key === this.key && t.audio && i.push(t);
                    }, this), i.sort(function(t, e) {
                        return t.loop === e.loop ? e.seek / e.duration - t.seek / t.duration : t.loop ? 1 : -1;
                    });
                    var n = i[0];
                    return this.audio = n.audio, n.reset(), n.audio = null, n.startTime = 0, n.previousTime = 0, true;
                },
                playCatchPromise: function() {
                    var t = this.audio.play();
                    t && t.catch(function(t) {
                        console.warn(t);
                    });
                },
                stopAndReleaseAudioTag: function() {
                    this.startTime = 0, this.previousTime = 0, this.audio && (this.audio.pause(), this.audio.dataset.used = "false", this.audio = null);
                },
                reset: function() {
                    n.prototype.stop.call(this);
                },
                onBlur: function() {
                    this.isPlaying = !1, this.isPaused = !0, this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0), this.currentConfig.delay = Math.max(0, (this.startTime - window.performance.now()) / 1e3), this.stopAndReleaseAudioTag();
                },
                onFocus: function() {
                    this.isPlaying = !0, this.isPaused = !1, this.pickAndPlayAudioTag();
                },
                update: function(t) {
                    if (this.isPlaying) {
                        if (0 < this.startTime) this.startTime < t - this.manager.audioPlayDelay && (this.audio.currentTime += Math.max(0, t - this.startTime) / 1e3, this.startTime = 0, this.previousTime = this.audio.currentTime, this.playCatchPromise());
                        else {
                            var e = this.currentMarker ? this.currentMarker.start : 0, i = e + this.duration, n = this.audio.currentTime;
                            if (this.currentConfig.loop) n >= i - this.manager.loopEndOffset ? (this.audio.currentTime = e + Math.max(0, n - i), n = this.audio.currentTime) : n < e && (this.audio.currentTime += e, n = this.audio.currentTime), n < this.previousTime && this.emit(r.LOOPED, this);
                            else if (i <= n) return this.reset(), this.stopAndReleaseAudioTag(), void this.emit(r.COMPLETE, this);
                            this.previousTime = n;
                        }
                    }
                },
                destroy: function() {
                    n.prototype.destroy.call(this), this.tags = null, this.audio && this.stopAndReleaseAudioTag();
                },
                updateMute: function() {
                    this.audio && (this.audio.muted = this.currentConfig.mute || this.manager.mute);
                },
                updateVolume: function() {
                    this.audio && (this.audio.volume = o(this.currentConfig.volume * this.manager.volume, 0, 1));
                },
                calculateRate: function() {
                    n.prototype.calculateRate.call(this), this.audio && (this.audio.playbackRate = this.totalRate);
                },
                mute: {
                    get: function() {
                        return this.currentConfig.mute;
                    },
                    set: function(t) {
                        this.currentConfig.mute = t, this.manager.isLocked(this, "mute", t) || (this.updateMute(), this.emit(r.MUTE, this, t));
                    }
                },
                setMute: function(t) {
                    return this.mute = t, this;
                },
                volume: {
                    get: function() {
                        return this.currentConfig.volume;
                    },
                    set: function(t) {
                        this.currentConfig.volume = t, this.manager.isLocked(this, "volume", t) || (this.updateVolume(), this.emit(r.VOLUME, this, t));
                    }
                },
                setVolume: function(t) {
                    return this.volume = t, this;
                },
                rate: {
                    get: function() {
                        return this.currentConfig.rate;
                    },
                    set: function(t) {
                        this.currentConfig.rate = t, this.manager.isLocked(this, r.RATE, t) || (this.calculateRate(), this.emit(r.RATE, this, t));
                    }
                },
                setRate: function(t) {
                    return this.rate = t, this;
                },
                detune: {
                    get: function() {
                        return this.currentConfig.detune;
                    },
                    set: function(t) {
                        this.currentConfig.detune = t, this.manager.isLocked(this, r.DETUNE, t) || (this.calculateRate(), this.emit(r.DETUNE, this, t));
                    }
                },
                setDetune: function(t) {
                    return this.detune = t, this;
                },
                seek: {
                    get: function() {
                        return this.isPlaying ? this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0) : this.isPaused ? this.currentConfig.seek : 0;
                    },
                    set: function(t) {
                        this.manager.isLocked(this, "seek", t) || 0 < this.startTime || (this.isPlaying || this.isPaused) && (t = Math.min(Math.max(0, t), this.duration), this.isPlaying ? (this.previousTime = t, this.audio.currentTime = t) : this.isPaused && (this.currentConfig.seek = t), this.emit(r.SEEK, this, t));
                    }
                },
                setSeek: function(t) {
                    return this.seek = t, this;
                },
                loop: {
                    get: function() {
                        return this.currentConfig.loop;
                    },
                    set: function(t) {
                        this.currentConfig.loop = t, this.manager.isLocked(this, "loop", t) || (this.audio && (this.audio.loop = t), this.emit(r.LOOP, this, t));
                    }
                },
                setLoop: function(t) {
                    return this.loop = t, this;
                },
                pan: {
                    get: function() {
                        return this.currentConfig.pan;
                    },
                    set: function(t) {
                        this.currentConfig.pan = t, this.emit(r.PAN, this, t);
                    }
                },
                setPan: function(t) {
                    return this.pan = t, this;
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(144), s = i(0), r = i(9), o = i(425), a = i(1), h = new s({
                Extends: r,
                initialize: function(t) {
                    r.call(this), this.game = t, this.sounds = [], this.mute = !1, this.volume = 1, this.rate = 1, this.detune = 0, this.pauseOnBlur = !0, this.locked = !1;
                },
                add: function(t, e) {
                    var i = new o(this, t, e);
                    return this.sounds.push(i), i;
                },
                addAudioSprite: function(t, e) {
                    var i = this.add(t, e);
                    return i.spritemap = {}, i;
                },
                play: function(t, e) {
                    return !1;
                },
                playAudioSprite: function(t, e, i) {
                    return !1;
                },
                remove: function(t) {
                    return n.prototype.remove.call(this, t);
                },
                removeByKey: function(t) {
                    return n.prototype.removeByKey.call(this, t);
                },
                pauseAll: a,
                resumeAll: a,
                stopAll: a,
                update: a,
                setRate: a,
                setDetune: a,
                setMute: a,
                setVolume: a,
                forEachActiveSound: function(t, e) {
                    n.prototype.forEachActiveSound.call(this, t, e);
                },
                destroy: function() {
                    n.prototype.destroy.call(this);
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            function n() {
                return !1;
            }
            function s() {
                return this;
            }
            var r = i(145), o = i(0), a = i(9), h = i(17), l = new o({
                Extends: a,
                initialize: function(t, e, i) {
                    void 0 === i && (i = {}), a.call(this), this.manager = t, this.key = e, this.isPlaying = !1, this.isPaused = !1, this.totalRate = 1, this.duration = 0, this.totalDuration = 0, this.config = h({
                        mute: !1,
                        volume: 1,
                        rate: 1,
                        detune: 0,
                        seek: 0,
                        loop: !1,
                        delay: 0,
                        pan: 0
                    }, i), this.currentConfig = this.config, this.mute = !1, this.volume = 1, this.rate = 1, this.detune = 0, this.seek = 0, this.loop = !1, this.pan = 0, this.markers = {}, this.currentMarker = null, this.pendingRemove = !1;
                },
                addMarker: n,
                updateMarker: n,
                removeMarker: function() {
                    return null;
                },
                play: n,
                pause: n,
                resume: n,
                stop: n,
                destroy: function() {
                    r.prototype.destroy.call(this);
                },
                setMute: s,
                setVolume: s,
                setRate: s,
                setDetune: s,
                setSeek: s,
                setLoop: s,
                setPan: s
            });
            t.exports = l;
        },
        function(t, e, i) {
            var c = i(427), n = i(144), s = i(0), d = i(69), r = i(22), o = i(428), a = new s({
                Extends: n,
                initialize: function(t) {
                    this.context = this.createAudioContext(t), this.masterMuteNode = this.context.createGain(), this.masterVolumeNode = this.context.createGain(), this.masterMuteNode.connect(this.masterVolumeNode), this.masterVolumeNode.connect(this.context.destination), this.destination = this.masterMuteNode, this.locked = "suspended" === this.context.state && ("ontouchstart" in window || "onclick" in window), n.call(this, t), this.locked && t.isBooted ? this.unlock() : t.events.once(r.BOOT, this.unlock, this);
                },
                createAudioContext: function(t) {
                    var e = t.config.audio;
                    return e.context ? (e.context.resume(), e.context) : new AudioContext;
                },
                setAudioContext: function(t) {
                    return this.context && this.context.close(), this.masterMuteNode && this.masterMuteNode.disconnect(), this.masterVolumeNode && this.masterVolumeNode.disconnect(), this.context = t, this.masterMuteNode = t.createGain(), this.masterVolumeNode = t.createGain(), this.masterMuteNode.connect(this.masterVolumeNode), this.masterVolumeNode.connect(t.destination), this.destination = this.masterMuteNode, this;
                },
                add: function(t, e) {
                    var i = new o(this, t, e);
                    return this.sounds.push(i), i;
                },
                decodeAudio: function(t, e) {
                    for(var i = Array.isArray(t) ? t : [
                        {
                            key: t,
                            data: e
                        }
                    ], n = this.game.cache.audio, s = i.length, r = 0; r < i.length; r++){
                        var o = i[r], a = o.key, h = o.data;
                        "string" == typeof h && (h = c(h));
                        var l = (function(t, e) {
                            n.add(t, e), this.emit(d.DECODED, t), 0 === --s && this.emit(d.DECODED_ALL);
                        }).bind(this, a), u = (function(t, e) {
                            console.error("Error decoding audio: " + t + " - ", e ? e.message : ""), 0 === --s && this.emit(d.DECODED_ALL);
                        }).bind(this, a);
                        this.context.decodeAudioData(h, l, u);
                    }
                },
                unlock: function() {
                    function t() {
                        e.context && e.context.resume().then(function() {
                            i.removeEventListener("touchstart", t), i.removeEventListener("touchend", t), i.removeEventListener("click", t), i.removeEventListener("keydown", t), e.unlocked = !0;
                        }, function() {
                            i.removeEventListener("touchstart", t), i.removeEventListener("touchend", t), i.removeEventListener("click", t), i.removeEventListener("keydown", t);
                        });
                    }
                    var e = this, i = document.body;
                    i && (i.addEventListener("touchstart", t, !1), i.addEventListener("touchend", t, !1), i.addEventListener("click", t, !1), i.addEventListener("keydown", t, !1));
                },
                onBlur: function() {
                    this.locked || this.context.suspend();
                },
                onFocus: function() {
                    this.locked || this.context.resume();
                },
                destroy: function() {
                    var t;
                    this.destination = null, this.masterVolumeNode.disconnect(), this.masterVolumeNode = null, this.masterMuteNode.disconnect(), this.masterMuteNode = null, this.game.config.audio.context ? this.context.suspend() : (t = this).context.close().then(function() {
                        t.context = null;
                    }), n.prototype.destroy.call(this);
                },
                setMute: function(t) {
                    return this.mute = t, this;
                },
                mute: {
                    get: function() {
                        return 0 === this.masterMuteNode.gain.value;
                    },
                    set: function(t) {
                        this.masterMuteNode.gain.setValueAtTime(t ? 0 : 1, 0), this.emit(d.GLOBAL_MUTE, this, t);
                    }
                },
                setVolume: function(t) {
                    return this.volume = t, this;
                },
                volume: {
                    get: function() {
                        return this.masterVolumeNode.gain.value;
                    },
                    set: function(t) {
                        this.masterVolumeNode.gain.setValueAtTime(t, 0), this.emit(d.GLOBAL_VOLUME, this, t);
                    }
                }
            });
            t.exports = a;
        },
        function(t, e) {
            for(var i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = new Uint8Array(256), n = 0; n < i.length; n++)c[i.charCodeAt(n)] = n;
            t.exports = function(t) {
                var e, i, n, s, r = (t = t.substr(t.indexOf(",") + 1)).length, o = .75 * r, a = 0;
                "=" === t[r - 1] && (o--, "=" === t[r - 2] && o--);
                for(var h = new ArrayBuffer(o), l = new Uint8Array(h), u = 0; u < r; u += 4)e = c[t.charCodeAt(u)], i = c[t.charCodeAt(u + 1)], n = c[t.charCodeAt(u + 2)], s = c[t.charCodeAt(u + 3)], l[a++] = e << 2 | i >> 4, l[a++] = (15 & i) << 4 | n >> 2, l[a++] = (3 & n) << 6 | 63 & s;
                return h;
            };
        },
        function(t, e, i) {
            var n = i(145), s = i(0), r = i(69), o = new s({
                Extends: n,
                initialize: function(t, e, i) {
                    if (void 0 === i && (i = {}), this.audioBuffer = t.game.cache.audio.get(e), !this.audioBuffer) throw new Error('Audio key "' + e + '" missing from cache');
                    this.source = null, this.loopSource = null, this.muteNode = t.context.createGain(), this.volumeNode = t.context.createGain(), this.pannerNode = null, this.playTime = 0, this.startTime = 0, this.loopTime = 0, this.rateUpdates = [], this.hasEnded = !1, this.hasLooped = !1, this.muteNode.connect(this.volumeNode), t.context.createStereoPanner ? (this.pannerNode = t.context.createStereoPanner(), this.volumeNode.connect(this.pannerNode), this.pannerNode.connect(t.destination)) : this.volumeNode.connect(t.destination), this.duration = this.audioBuffer.duration, this.totalDuration = this.audioBuffer.duration, n.call(this, t, e, i);
                },
                play: function(t, e) {
                    return !!n.prototype.play.call(this, t, e) && (this.stopAndRemoveBufferSource(), this.createAndStartBufferSource(), this.emit(r.PLAY, this), !0);
                },
                pause: function() {
                    return !(this.manager.context.currentTime < this.startTime) && !!n.prototype.pause.call(this) && (this.currentConfig.seek = this.getCurrentTime(), this.stopAndRemoveBufferSource(), this.emit(r.PAUSE, this), !0);
                },
                resume: function() {
                    return !(this.manager.context.currentTime < this.startTime) && !!n.prototype.resume.call(this) && (this.createAndStartBufferSource(), this.emit(r.RESUME, this), !0);
                },
                stop: function() {
                    return !!n.prototype.stop.call(this) && (this.stopAndRemoveBufferSource(), this.emit(r.STOP, this), !0);
                },
                createAndStartBufferSource: function() {
                    var t = this.currentConfig.seek, e = this.currentConfig.delay, i = this.manager.context.currentTime + e, n = (this.currentMarker ? this.currentMarker.start : 0) + t, s = this.duration - t;
                    this.playTime = i - t, this.startTime = i, this.source = this.createBufferSource(), this.applyConfig(), this.source.start(Math.max(0, i), Math.max(0, n), Math.max(0, s)), this.resetConfig();
                },
                createAndStartLoopBufferSource: function() {
                    var t = this.getLoopTime(), e = this.currentMarker ? this.currentMarker.start : 0, i = this.duration;
                    this.loopTime = t, this.loopSource = this.createBufferSource(), this.loopSource.playbackRate.setValueAtTime(this.totalRate, 0), this.loopSource.start(Math.max(0, t), Math.max(0, e), Math.max(0, i));
                },
                createBufferSource: function() {
                    var e = this, t = this.manager.context.createBufferSource();
                    return t.buffer = this.audioBuffer, t.connect(this.muteNode), t.onended = function(t) {
                        t.target === e.source && (e.currentConfig.loop ? e.hasLooped = !0 : e.hasEnded = !0);
                    }, t;
                },
                stopAndRemoveBufferSource: function() {
                    this.source && (this.source.stop(), this.source.disconnect(), this.source = null), this.playTime = 0, this.startTime = 0, this.stopAndRemoveLoopBufferSource();
                },
                stopAndRemoveLoopBufferSource: function() {
                    this.loopSource && (this.loopSource.stop(), this.loopSource.disconnect(), this.loopSource = null), this.loopTime = 0;
                },
                applyConfig: function() {
                    this.rateUpdates.length = 0, this.rateUpdates.push({
                        time: 0,
                        rate: 1
                    }), n.prototype.applyConfig.call(this);
                },
                update: function() {
                    this.hasEnded ? (this.hasEnded = !1, n.prototype.stop.call(this), this.stopAndRemoveBufferSource(), this.emit(r.COMPLETE, this)) : this.hasLooped && (this.hasLooped = !1, this.source = this.loopSource, this.loopSource = null, this.playTime = this.startTime = this.loopTime, this.rateUpdates.length = 0, this.rateUpdates.push({
                        time: 0,
                        rate: this.totalRate
                    }), this.createAndStartLoopBufferSource(), this.emit(r.LOOPED, this));
                },
                destroy: function() {
                    n.prototype.destroy.call(this), this.audioBuffer = null, this.stopAndRemoveBufferSource(), this.muteNode.disconnect(), this.muteNode = null, this.volumeNode.disconnect(), this.volumeNode = null, this.pannerNode && (this.pannerNode.disconnect(), this.pannerNode = null), this.rateUpdates.length = 0, this.rateUpdates = null;
                },
                calculateRate: function() {
                    n.prototype.calculateRate.call(this);
                    var t = this.manager.context.currentTime;
                    this.source && "number" == typeof this.totalRate && this.source.playbackRate.setValueAtTime(this.totalRate, t), this.isPlaying && (this.rateUpdates.push({
                        time: Math.max(this.startTime, t) - this.playTime,
                        rate: this.totalRate
                    }), this.loopSource && (this.stopAndRemoveLoopBufferSource(), this.createAndStartLoopBufferSource()));
                },
                getCurrentTime: function() {
                    for(var t = 0, e = 0; e < this.rateUpdates.length; e++)t += ((e < this.rateUpdates.length - 1 ? this.rateUpdates[e + 1].time : this.manager.context.currentTime - this.playTime) - this.rateUpdates[e].time) * this.rateUpdates[e].rate;
                    return t;
                },
                getLoopTime: function() {
                    for(var t = 0, e = 0; e < this.rateUpdates.length - 1; e++)t += (this.rateUpdates[e + 1].time - this.rateUpdates[e].time) * this.rateUpdates[e].rate;
                    var i = this.rateUpdates[this.rateUpdates.length - 1];
                    return this.playTime + i.time + (this.duration - t) / i.rate;
                },
                rate: {
                    get: function() {
                        return this.currentConfig.rate;
                    },
                    set: function(t) {
                        this.currentConfig.rate = t, this.calculateRate(), this.emit(r.RATE, this, t);
                    }
                },
                setRate: function(t) {
                    return this.rate = t, this;
                },
                detune: {
                    get: function() {
                        return this.currentConfig.detune;
                    },
                    set: function(t) {
                        this.currentConfig.detune = t, this.calculateRate(), this.emit(r.DETUNE, this, t);
                    }
                },
                setDetune: function(t) {
                    return this.detune = t, this;
                },
                mute: {
                    get: function() {
                        return 0 === this.muteNode.gain.value;
                    },
                    set: function(t) {
                        this.currentConfig.mute = t, this.muteNode.gain.setValueAtTime(t ? 0 : 1, 0), this.emit(r.MUTE, this, t);
                    }
                },
                setMute: function(t) {
                    return this.mute = t, this;
                },
                volume: {
                    get: function() {
                        return this.volumeNode.gain.value;
                    },
                    set: function(t) {
                        this.currentConfig.volume = t, this.volumeNode.gain.setValueAtTime(t, 0), this.emit(r.VOLUME, this, t);
                    }
                },
                setVolume: function(t) {
                    return this.volume = t, this;
                },
                seek: {
                    get: function() {
                        return this.isPlaying ? this.manager.context.currentTime < this.startTime ? this.startTime - this.playTime : this.getCurrentTime() : this.isPaused ? this.currentConfig.seek : 0;
                    },
                    set: function(t) {
                        this.manager.context.currentTime < this.startTime || (this.isPlaying || this.isPaused) && (t = Math.min(Math.max(0, t), this.duration), this.currentConfig.seek = t, this.isPlaying && (this.stopAndRemoveBufferSource(), this.createAndStartBufferSource()), this.emit(r.SEEK, this, t));
                    }
                },
                setSeek: function(t) {
                    return this.seek = t, this;
                },
                loop: {
                    get: function() {
                        return this.currentConfig.loop;
                    },
                    set: function(t) {
                        this.currentConfig.loop = t, this.isPlaying && (this.stopAndRemoveLoopBufferSource(), t && this.createAndStartLoopBufferSource()), this.emit(r.LOOP, this, t);
                    }
                },
                setLoop: function(t) {
                    return this.loop = t, this;
                },
                pan: {
                    get: function() {
                        return this.pannerNode ? this.pannerNode.pan.value : 0;
                    },
                    set: function(t) {
                        this.currentConfig.pan = t, this.pannerNode && this.pannerNode.pan.setValueAtTime(t, this.manager.context.currentTime), this.emit(r.PAN, this, t);
                    }
                },
                setPan: function(t) {
                    return this.pan = t, this;
                }
            });
            t.exports = o;
        },
        function(t, e) {
            t.exports = function(t) {
                for(var e = t.length, i = t[0].length, n = new Array(i), s = 0; s < i; s++){
                    n[s] = new Array(e);
                    for(var r = e - 1; -1 < r; r--)n[s][r] = t[r][s];
                }
                return n;
            };
        },
        function(t, e) {
            function g(t, e, i) {
                var n = t[e];
                t[e] = t[i], t[i] = n;
            }
            function v(t, e) {
                return t < e ? -1 : e < t ? 1 : 0;
            }
            var m = function(t, e, i, n, s) {
                for(void 0 === i && (i = 0), void 0 === n && (n = t.length - 1), void 0 === s && (s = v); i < n;){
                    var r, o, a, h, l, u, c;
                    600 < n - i && (r = n - i + 1, o = e - i + 1, a = Math.log(r), h = .5 * Math.exp(2 * a / 3), l = .5 * Math.sqrt(a * h * (r - h) / r) * (o - r / 2 < 0 ? -1 : 1), u = Math.max(i, Math.floor(e - o * h / r + l)), c = Math.min(n, Math.floor(e + (r - o) * h / r + l)), m(t, e, u, c, s));
                    var d = t[e], f = i, p = n;
                    for(g(t, i, e), 0 < s(t[n], d) && g(t, i, n); f < p;){
                        for(g(t, f, p), f++, p--; s(t[f], d) < 0;)f++;
                        for(; 0 < s(t[p], d);)p--;
                    }
                    0 === s(t[i], d) ? g(t, i, p) : g(t, ++p, n), p <= e && (i = p + 1), e <= p && (n = p - 1);
                }
            };
            t.exports = m;
        },
        function(t, e, i) {
            var f = i(6), p = i(129);
            t.exports = function(t, e, i) {
                var n, s = f(i, "max", 0), r = f(i, "qty", 1), o = f(i, "random", !1), a = f(i, "randomB", !1), h = f(i, "repeat", 0), l = f(i, "yoyo", !1), u = [];
                a && p(e), -1 === h && (h = 0 === s ? 0 : (n = t.length * e.length * r, l && (n *= 2), Math.ceil(s / n)));
                for(var c = 0; c <= h; c++){
                    var d = function(t, e, i) {
                        for(var n = [], s = 0; s < t.length; s++)for(var r = 0; r < e.length; r++)for(var o = 0; o < i; o++)n.push({
                            a: t[s],
                            b: e[r]
                        });
                        return n;
                    }(t, e, r);
                    o && p(d), u = u.concat(d), l && (d.reverse(), u = u.concat(d));
                }
                return s && u.splice(s), u;
            };
        },
        function(t, e, i) {
            t.exports = {
                PROCESS_QUEUE_ADD: i(1035),
                PROCESS_QUEUE_REMOVE: i(1036)
            };
        },
        function(t, e, i) {
            var f = i(13);
            t.exports = function(t, e) {
                var i, n, s, r, o, a, h, l, u, c, d = f(e, "anims", null);
                return null === d || ("string" == typeof d ? t.anims.play(d) : "object" == typeof d && (i = t.anims, (n = f(d, "key", void 0)) && (s = f(d, "startFrame", void 0), r = f(d, "delay", 0), o = f(d, "repeat", 0), a = f(d, "repeatDelay", 0), h = f(d, "yoyo", !1), l = f(d, "play", !1), u = f(d, "delayedPlay", 0), c = {
                    key: n,
                    delay: r,
                    repeat: o,
                    repeatDelay: a,
                    yoyo: h,
                    startFrame: s
                }, l ? i.play(c) : 0 < u ? i.playAfterDelay(c, u) : i.load(c)))), t;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(106), r = new n({
                initialize: function(t, e, i, n, s) {
                    this.parent = t, this.x = e, this.y = i, this.frame = n, this.data = {}, this.tint = 16777215, this._visible = s, this._alpha = 1, this.flipX = !1, this.flipY = !1;
                },
                setFrame: function(t) {
                    return void 0 === t ? this.frame = this.parent.frame : t instanceof s && t.texture === this.parent.texture ? this.frame = t : this.frame = this.parent.texture.get(t), this;
                },
                resetFlip: function() {
                    return this.flipX = !1, this.flipY = !1, this;
                },
                reset: function(t, e, i) {
                    return this.x = t, this.y = e, this.flipX = !1, this.flipY = !1, this._alpha = 1, this._visible = !0, this.parent.dirty = !0, i && this.setFrame(i), this;
                },
                setPosition: function(t, e) {
                    return this.x = t, this.y = e, this;
                },
                setFlipX: function(t) {
                    return this.flipX = t, this;
                },
                setFlipY: function(t) {
                    return this.flipY = t, this;
                },
                setFlip: function(t, e) {
                    return this.flipX = t, this.flipY = e, this;
                },
                setVisible: function(t) {
                    return this.visible = t, this;
                },
                setAlpha: function(t) {
                    return this.alpha = t, this;
                },
                setTint: function(t) {
                    return this.tint = t, this;
                },
                destroy: function() {
                    this.parent.dirty = !0, this.parent.children.remove(this), this.parent = void 0, this.frame = void 0, this.data = void 0;
                },
                visible: {
                    get: function() {
                        return this._visible;
                    },
                    set: function(t) {
                        this.parent.dirty |= this._visible !== t, this._visible = t;
                    }
                },
                alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(t) {
                        this.parent.dirty |= 0 < this._alpha != 0 < t, this._alpha = t;
                    }
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var a = i(10);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new a);
                var n = Math.min(t.x, e.x), s = Math.min(t.y, e.y), r = Math.max(t.right, e.right) - n, o = Math.max(t.bottom, e.bottom) - s;
                return i.setTo(n, s, r, o);
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(1049), o = i(15), a = i(7), h = i(199), l = i(21), u = i(138), c = new n({
                Extends: o,
                Mixins: [
                    s.AlphaSingle,
                    s.BlendMode,
                    s.Depth,
                    s.Origin,
                    s.ScrollFactor,
                    s.Transform,
                    s.Visible,
                    r
                ],
                initialize: function(t, e, i, n, s, r) {
                    o.call(this, t, "DOMElement"), this.parent = t.sys.game.domContainer, this.cache = t.sys.cache.html, this.node, this.transformOnly = !1, this.skewX = 0, this.skewY = 0, this.rotate3d = new u, this.rotate3dAngle = "deg", this.width = 0, this.height = 0, this.displayWidth = 0, this.displayHeight = 0, this.handler = this.dispatchNativeEvent.bind(this), this.setPosition(e, i), "string" == typeof n ? "#" === n[0] ? this.setElement(n.substr(1), s, r) : this.createElement(n, s, r) : n && this.setElement(n, s, r), t.sys.events.on(l.SLEEP, this.handleSceneEvent, this), t.sys.events.on(l.WAKE, this.handleSceneEvent, this);
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                handleSceneEvent: function(t) {
                    var e = this.node, i = e.style;
                    e && (i.display = t.settings.visible ? "block" : "none");
                },
                setSkew: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this.skewX = t, this.skewY = e, this;
                },
                setPerspective: function(t) {
                    return this.parent.style.perspective = t + "px", this;
                },
                perspective: {
                    get: function() {
                        return parseFloat(this.parent.style.perspective);
                    },
                    set: function(t) {
                        this.parent.style.perspective = t + "px";
                    }
                },
                addListener: function(t) {
                    if (this.node) {
                        t = t.split(" ");
                        for(var e = 0; e < t.length; e++)this.node.addEventListener(t[e], this.handler, !1);
                    }
                    return this;
                },
                removeListener: function(t) {
                    if (this.node) {
                        t = t.split(" ");
                        for(var e = 0; e < t.length; e++)this.node.removeEventListener(t[e], this.handler);
                    }
                    return this;
                },
                dispatchNativeEvent: function(t) {
                    this.emit(t.type, t);
                },
                createElement: function(t, e, i) {
                    return this.setElement(document.createElement(t), e, i);
                },
                setElement: function(t, e, i) {
                    var n;
                    if (this.removeElement(), "string" == typeof t ? ("#" === t[0] && (t = t.substr(1)), n = document.getElementById(t)) : "object" == typeof t && 1 === t.nodeType && (n = t), !n) return this;
                    if (this.node = n, e && a(e)) for(var s in e)n.style[s] = e[s];
                    else "string" == typeof e && (n.style = e);
                    return n.style.zIndex = "0", n.style.display = "inline", n.style.position = "absolute", (n.phaser = this).parent && this.parent.appendChild(n), i && (n.innerText = i), this.updateSize();
                },
                createFromCache: function(t, e) {
                    var i = this.cache.get(t);
                    return i && this.createFromHTML(i, e), this;
                },
                createFromHTML: function(t, e) {
                    void 0 === e && (e = "div"), this.removeElement();
                    var i = document.createElement(e);
                    return (this.node = i).style.zIndex = "0", i.style.display = "inline", i.style.position = "absolute", (i.phaser = this).parent && this.parent.appendChild(i), i.innerHTML = t, this.updateSize();
                },
                removeElement: function() {
                    return this.node && (h(this.node), this.node = null), this;
                },
                updateSize: function() {
                    var t = this.node, e = t.getBoundingClientRect();
                    return this.width = t.clientWidth, this.height = t.clientHeight, this.displayWidth = e.width || 0, this.displayHeight = e.height || 0, this;
                },
                getChildByProperty: function(t, e) {
                    if (this.node) {
                        for(var i = this.node.querySelectorAll("*"), n = 0; n < i.length; n++)if (i[n][t] === e) return i[n];
                    }
                    return null;
                },
                getChildByID: function(t) {
                    return this.getChildByProperty("id", t);
                },
                getChildByName: function(t) {
                    return this.getChildByProperty("name", t);
                },
                setClassName: function(t) {
                    return this.node && (this.node.className = t, this.updateSize()), this;
                },
                setText: function(t) {
                    return this.node && (this.node.innerText = t, this.updateSize()), this;
                },
                setHTML: function(t) {
                    return this.node && (this.node.innerHTML = t, this.updateSize()), this;
                },
                preUpdate: function() {
                    var t = this.parentContainer, e = this.node;
                    e && t && !t.willRender() && (e.style.display = "none");
                },
                willRender: function() {
                    return !0;
                },
                preDestroy: function() {
                    this.removeElement(), this.scene.sys.events.off(l.SLEEP, this.handleSceneEvent, this), this.scene.sys.events.off(l.WAKE, this.handleSceneEvent, this);
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var v = i(1050), m = i(15), n = i(25), y = new n, x = new n, T = new n;
            t.exports = function(t, e, i, n) {
                var s, r, o, a, h, l, u, c, d, f = e.node, p = f.style, g = e.scene.sys.settings;
                !(f && p && g.visible && m.RENDER_MASK === e.renderFlags) || 0 !== e.cameraFilter && e.cameraFilter & i.id || e.parentContainer && !e.parentContainer.willRender() ? f && (p.display = "none") : (s = e.parentContainer, r = i.alpha * e.alpha, s && (r *= s.alpha), o = y, a = x, h = T, u = l = 0, d = c = "0%", n ? (l = e.width * e.scaleX * e.originX, u = e.height * e.scaleY * e.originY, a.applyITRS(e.x - l, e.y - u, e.rotation, e.scaleX, e.scaleY), o.copyFrom(i.matrix), o.multiplyWithOffset(n, -i.scrollX * e.scrollFactorX, -i.scrollY * e.scrollFactorY), a.e = e.x - l, a.f = e.y - u) : (l = e.width * e.originX, u = e.height * e.originY, a.applyITRS(e.x - l, e.y - u, e.rotation, e.scaleX, e.scaleY), o.copyFrom(i.matrix), c = 100 * e.originX + "%", d = 100 * e.originY + "%", a.e -= i.scrollX * e.scrollFactorX, a.f -= i.scrollY * e.scrollFactorY), o.multiply(a, h), e.transformOnly || (p.display = "block", p.opacity = r, p.zIndex = e._depth, p.pointerEvents = "auto", p.mixBlendMode = v[e._blendMode]), p.transform = h.getCSSMatrix() + " skew(" + e.skewX + "rad, " + e.skewY + "rad) rotate3d(" + e.rotate3d.x + "," + e.rotate3d.y + "," + e.rotate3d.z + "," + e.rotate3d.w + e.rotate3dAngle + ")", p.transformOrigin = c + " " + d);
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(11), r = i(15), o = i(1054), a = new n({
                Extends: r,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.Depth,
                    s.Flip,
                    s.Origin,
                    s.ScrollFactor,
                    s.Size,
                    s.Texture,
                    s.Tint,
                    s.Transform,
                    s.Visible,
                    o
                ],
                initialize: function(t) {
                    r.call(this, t, "Extern");
                },
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                preUpdate: function() {},
                render: function() {}
            });
            t.exports = a;
        },
        function(t, e, i) {
            var s = i(215), r = i(95), o = i(14), a = i(4);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new a);
                var n = r(e, 0, o.PI2);
                return s(t, n, i);
            };
        },
        function(t, e, i) {
            var o = i(441), a = i(215), h = i(95), l = i(14);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = []), !e && 0 < i && (e = o(t) / i);
                for(var s = 0; s < e; s++){
                    var r = h(s / e, 0, l.PI2);
                    n.push(a(t, r));
                }
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = t.width / 2, i = t.height / 2, n = Math.pow(e - i, 2) / Math.pow(e + i, 2);
                return Math.PI * (e + i) * (1 + 3 * n / (10 + Math.sqrt(4 - 3 * n)));
            };
        },
        function(t, e, i) {
            var y = i(214), x = i(30);
            t.exports = function(t, e, i, n, s, r) {
                var o = e.commandBuffer, a = o.length, h = s || t.currentContext;
                if (0 !== a && x(t, h, e, i, n)) {
                    i.addToRenderList(e);
                    var l, u, c, d, f, p = 0, g = 0, v = 0;
                    h.beginPath();
                    for(var m = 0; m < a; ++m)switch(o[m]){
                        case y.ARC:
                            h.arc(o[m + 1], o[m + 2], o[m + 3], o[m + 4], o[m + 5], o[m + 6]), m += 7;
                            break;
                        case y.LINE_STYLE:
                            f = o[m + 1], c = o[m + 2], l = o[m + 3], p = (16711680 & c) >>> 16, g = (65280 & c) >>> 8, v = 255 & c, h.strokeStyle = "rgba(" + p + "," + g + "," + v + "," + l + ")", h.lineWidth = f, m += 3;
                            break;
                        case y.FILL_STYLE:
                            d = o[m + 1], u = o[m + 2], p = (16711680 & d) >>> 16, g = (65280 & d) >>> 8, v = 255 & d, h.fillStyle = "rgba(" + p + "," + g + "," + v + "," + u + ")", m += 2;
                            break;
                        case y.BEGIN_PATH:
                            h.beginPath();
                            break;
                        case y.CLOSE_PATH:
                            h.closePath();
                            break;
                        case y.FILL_PATH:
                            r || h.fill();
                            break;
                        case y.STROKE_PATH:
                            r || h.stroke();
                            break;
                        case y.FILL_RECT:
                            r ? h.rect(o[m + 1], o[m + 2], o[m + 3], o[m + 4]) : h.fillRect(o[m + 1], o[m + 2], o[m + 3], o[m + 4]), m += 4;
                            break;
                        case y.FILL_TRIANGLE:
                            h.beginPath(), h.moveTo(o[m + 1], o[m + 2]), h.lineTo(o[m + 3], o[m + 4]), h.lineTo(o[m + 5], o[m + 6]), h.closePath(), r || h.fill(), m += 6;
                            break;
                        case y.STROKE_TRIANGLE:
                            h.beginPath(), h.moveTo(o[m + 1], o[m + 2]), h.lineTo(o[m + 3], o[m + 4]), h.lineTo(o[m + 5], o[m + 6]), h.closePath(), r || h.stroke(), m += 6;
                            break;
                        case y.LINE_TO:
                            h.lineTo(o[m + 1], o[m + 2]), m += 2;
                            break;
                        case y.MOVE_TO:
                            h.moveTo(o[m + 1], o[m + 2]), m += 2;
                            break;
                        case y.LINE_FX_TO:
                            h.lineTo(o[m + 1], o[m + 2]), m += 5;
                            break;
                        case y.MOVE_FX_TO:
                            h.moveTo(o[m + 1], o[m + 2]), m += 5;
                            break;
                        case y.SAVE:
                            h.save();
                            break;
                        case y.RESTORE:
                            h.restore();
                            break;
                        case y.TRANSLATE:
                            h.translate(o[m + 1], o[m + 2]), m += 2;
                            break;
                        case y.SCALE:
                            h.scale(o[m + 1], o[m + 2]), m += 2;
                            break;
                        case y.ROTATE:
                            h.rotate(o[m + 1]), m += 1;
                            break;
                        case y.GRADIENT_FILL_STYLE:
                            m += 5;
                            break;
                        case y.GRADIENT_LINE_STYLE:
                            m += 6;
                    }
                    h.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(135), r = i(80), o = i(2), a = i(66), h = new n({
                initialize: function(t, e, i, n) {
                    void 0 === n && (n = !1), this.propertyKey = e, this.propertyValue = i, this.defaultValue = i, this.steps = 0, this.counter = 0, this.start = 0, this.end = 0, this.ease, this.emitOnly = n, this.onEmit = this.defaultEmit, this.onUpdate = this.defaultUpdate, this.loadConfig(t);
                },
                loadConfig: function(t, e) {
                    void 0 === t && (t = {}), e && (this.propertyKey = e), this.propertyValue = o(t, this.propertyKey, this.defaultValue), this.setMethods(), this.emitOnly && (this.onUpdate = this.defaultUpdate);
                },
                toJSON: function() {
                    return this.propertyValue;
                },
                onChange: function(t) {
                    return this.propertyValue = t, this.setMethods();
                },
                setMethods: function() {
                    var t, e, i, n = this.propertyValue, s = typeof n;
                    return this.onEmit = this.defaultEmit, this.onUpdate = this.defaultUpdate, "number" == s ? (this.onEmit = this.staticValueEmit, this.onUpdate = this.staticValueUpdate) : Array.isArray(n) ? this.onEmit = this.randomStaticValueEmit : "function" == s ? this.emitOnly ? this.onEmit = n : this.onUpdate = n : "object" == s && this.hasBoth(n, "start", "end") ? (this.start = n.start, this.end = n.end, (t = this.has(n, "random")) && (this.onEmit = this.randomRangedValueEmit), this.has(n, "steps") ? (this.steps = n.steps, this.counter = this.start, this.onEmit = this.steppedEmit) : (e = this.has(n, "ease") ? n.ease : "Linear", this.ease = r(e, n.easeParams), t || (this.onEmit = this.easedValueEmit), this.onUpdate = this.easeValueUpdate)) : "object" == s && this.hasBoth(n, "min", "max") ? (this.start = n.min, this.end = n.max, this.onEmit = this.randomRangedValueEmit) : "object" == s && this.has(n, "random") ? (i = n.random, Array.isArray(i) && (this.start = i[0], this.end = i[1]), this.onEmit = this.randomRangedValueEmit) : "object" == s && this.hasEither(n, "onEmit", "onUpdate") && (this.has(n, "onEmit") && (this.onEmit = n.onEmit), this.has(n, "onUpdate") && (this.onUpdate = n.onUpdate)), this;
                },
                has: function(t, e) {
                    return t.hasOwnProperty(e);
                },
                hasBoth: function(t, e, i) {
                    return t.hasOwnProperty(e) && t.hasOwnProperty(i);
                },
                hasEither: function(t, e, i) {
                    return t.hasOwnProperty(e) || t.hasOwnProperty(i);
                },
                defaultEmit: function(t, e, i) {
                    return i;
                },
                defaultUpdate: function(t, e, i, n) {
                    return n;
                },
                staticValueEmit: function() {
                    return this.propertyValue;
                },
                staticValueUpdate: function() {
                    return this.propertyValue;
                },
                randomStaticValueEmit: function() {
                    var t = Math.floor(Math.random() * this.propertyValue.length);
                    return this.propertyValue[t];
                },
                randomRangedValueEmit: function(t, e) {
                    var i = s(this.start, this.end);
                    return t && t.data[e] && (t.data[e].min = i), i;
                },
                steppedEmit: function() {
                    var t = this.counter, e = this.counter + (this.end - this.start) / this.steps;
                    return this.counter = a(e, this.start, this.end), t;
                },
                easedValueEmit: function(t, e) {
                    var i;
                    return t && t.data[e] && ((i = t.data[e]).min = this.start, i.max = this.end), this.start;
                },
                easeValueUpdate: function(t, e, i) {
                    var n = t.data[e];
                    return (n.max - n.min) * this.ease(i) + n.min;
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var n = i(0), o = i(2), s = new n({
                initialize: function(t, e, i, n, s) {
                    var r;
                    "object" == typeof t ? (t = o(r = t, "x", 0), e = o(r, "y", 0), i = o(r, "power", 0), n = o(r, "epsilon", 100), s = o(r, "gravity", 50)) : (void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 100), void 0 === s && (s = 50)), this.x = t, this.y = e, this.active = !0, this._gravity = s, this._power = 0, this._epsilon = 0, this.power = i, this.epsilon = n;
                },
                update: function(t, e) {
                    var i, n, s = this.x - t.x, r = this.y - t.y, o = s * s + r * r;
                    0 !== o && (i = Math.sqrt(o), o < this._epsilon && (o = this._epsilon), n = this._power * e / (o * i) * 100, t.velocityX += s * n, t.velocityY += r * n);
                },
                epsilon: {
                    get: function() {
                        return Math.sqrt(this._epsilon);
                    },
                    set: function(t) {
                        this._epsilon = t * t;
                    }
                },
                power: {
                    get: function() {
                        return this._power / this._gravity;
                    },
                    set: function(t) {
                        this._power = t * this._gravity;
                    }
                },
                gravity: {
                    get: function() {
                        return this._gravity;
                    },
                    set: function(t) {
                        var e = this.power;
                        this._gravity = t, this.power = e;
                    }
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(0), u = i(35), c = i(48), s = new n({
                initialize: function(t) {
                    this.emitter = t, this.frame = null, this.x = 0, this.y = 0, this.velocityX = 0, this.velocityY = 0, this.accelerationX = 0, this.accelerationY = 0, this.maxVelocityX = 1e4, this.maxVelocityY = 1e4, this.bounce = 0, this.scaleX = 1, this.scaleY = 1, this.alpha = 1, this.angle = 0, this.rotation = 0, this.tint = 16777215, this.life = 1e3, this.lifeCurrent = 1e3, this.delayCurrent = 0, this.lifeT = 0, this.data = {
                        tint: {
                            min: 16777215,
                            max: 16777215,
                            current: 16777215
                        },
                        alpha: {
                            min: 1,
                            max: 1
                        },
                        rotate: {
                            min: 0,
                            max: 0
                        },
                        scaleX: {
                            min: 1,
                            max: 1
                        },
                        scaleY: {
                            min: 1,
                            max: 1
                        }
                    };
                },
                isAlive: function() {
                    return 0 < this.lifeCurrent;
                },
                resetPosition: function() {
                    this.x = 0, this.y = 0;
                },
                fire: function(t, e) {
                    var i = this.emitter;
                    this.frame = i.getFrame(), i.emitZone && i.emitZone.getPoint(this), this.x += void 0 === t ? i.x.onEmit(this, "x") : t, this.y += void 0 === e ? i.y.onEmit(this, "y") : e, this.life = i.lifespan.onEmit(this, "lifespan"), this.lifeCurrent = this.life, this.lifeT = 0;
                    var n, s, r, o, a, h = i.speedX.onEmit(this, "speedX"), l = i.speedY ? i.speedY.onEmit(this, "speedY") : h;
                    i.radial ? (n = u(i.angle.onEmit(this, "angle")), this.velocityX = Math.cos(n) * Math.abs(h), this.velocityY = Math.sin(n) * Math.abs(l)) : i.moveTo ? (s = i.moveToX.onEmit(this, "moveToX"), r = i.moveToY ? i.moveToY.onEmit(this, "moveToY") : s, o = Math.atan2(r - this.y, s - this.x), a = c(this.x, this.y, s, r) / (this.life / 1e3), this.velocityX = Math.cos(o) * a, this.velocityY = Math.sin(o) * a) : (this.velocityX = h, this.velocityY = l), i.acceleration && (this.accelerationX = i.accelerationX.onEmit(this, "accelerationX"), this.accelerationY = i.accelerationY.onEmit(this, "accelerationY")), this.maxVelocityX = i.maxVelocityX.onEmit(this, "maxVelocityX"), this.maxVelocityY = i.maxVelocityY.onEmit(this, "maxVelocityY"), this.delayCurrent = i.delay.onEmit(this, "delay"), this.scaleX = i.scaleX.onEmit(this, "scaleX"), this.scaleY = i.scaleY ? i.scaleY.onEmit(this, "scaleY") : this.scaleX, this.angle = i.rotate.onEmit(this, "rotate"), this.rotation = u(this.angle), this.bounce = i.bounce.onEmit(this, "bounce"), this.alpha = i.alpha.onEmit(this, "alpha"), this.tint = i.tint.onEmit(this, "tint");
                },
                computeVelocity: function(t, e, i, n) {
                    var s = this.velocityX, r = this.velocityY, o = this.accelerationX, a = this.accelerationY, h = this.maxVelocityX, l = this.maxVelocityY;
                    s += t.gravityX * i, r += t.gravityY * i, o && (s += o * i), a && (r += a * i), h < s ? s = h : s < -h && (s = -h), l < r ? r = l : r < -l && (r = -l), this.velocityX = s, this.velocityY = r;
                    for(var u = 0; u < n.length; u++)n[u].update(this, e, i);
                },
                checkBounds: function(t) {
                    var e = t.bounds, i = -this.bounce;
                    this.x < e.x && t.collideLeft ? (this.x = e.x, this.velocityX *= i) : this.x > e.right && t.collideRight && (this.x = e.right, this.velocityX *= i), this.y < e.y && t.collideTop ? (this.y = e.y, this.velocityY *= i) : this.y > e.bottom && t.collideBottom && (this.y = e.bottom, this.velocityY *= i);
                },
                update: function(t, e, i) {
                    if (0 < this.delayCurrent) return this.delayCurrent -= t, !1;
                    var n = this.emitter, s = 1 - this.lifeCurrent / this.life;
                    return this.lifeT = s, this.computeVelocity(n, t, e, i), this.x += this.velocityX * e, this.y += this.velocityY * e, n.bounds && this.checkBounds(n), n.deathZone && n.deathZone.willKill(this) ? (this.lifeCurrent = 0, true) : (this.scaleX = n.scaleX.onUpdate(this, "scaleX", s, this.scaleX), n.scaleY ? this.scaleY = n.scaleY.onUpdate(this, "scaleY", s, this.scaleY) : this.scaleY = this.scaleX, this.angle = n.rotate.onUpdate(this, "rotate", s, this.angle), this.rotation = u(this.angle), this.alpha = n.alpha.onUpdate(this, "alpha", s, this.alpha), this.tint = n.tint.onUpdate(this, "tint", s, this.tint), this.lifeCurrent -= t, this.lifeCurrent <= 0);
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(34), s = i(0), r = i(11), o = i(447), a = i(448), h = i(443), l = i(2), u = i(207), c = i(449), d = i(125), f = i(445), p = i(450), g = i(10), v = i(79), m = i(3), y = i(66), x = new s({
                Mixins: [
                    r.BlendMode,
                    r.Mask,
                    r.ScrollFactor,
                    r.Visible
                ],
                initialize: function(t, e) {
                    this.manager = t, this.texture = t.texture, this.frames = [
                        t.defaultFrame
                    ], this.defaultFrame = t.defaultFrame, this.configFastMap = [
                        "active",
                        "blendMode",
                        "collideBottom",
                        "collideLeft",
                        "collideRight",
                        "collideTop",
                        "deathCallback",
                        "deathCallbackScope",
                        "emitCallback",
                        "emitCallbackScope",
                        "follow",
                        "frequency",
                        "gravityX",
                        "gravityY",
                        "maxParticles",
                        "name",
                        "on",
                        "particleBringToTop",
                        "particleClass",
                        "radial",
                        "timeScale",
                        "trackVisible",
                        "visible"
                    ], this.configOpMap = [
                        "accelerationX",
                        "accelerationY",
                        "angle",
                        "alpha",
                        "bounce",
                        "delay",
                        "lifespan",
                        "maxVelocityX",
                        "maxVelocityY",
                        "moveToX",
                        "moveToY",
                        "quantity",
                        "rotate",
                        "scaleX",
                        "scaleY",
                        "speedX",
                        "speedY",
                        "tint",
                        "x",
                        "y"
                    ], this.name = "", this.particleClass = f, this.x = new h(e, "x", 0, !0), this.y = new h(e, "y", 0, !0), this.radial = !0, this.gravityX = 0, this.gravityY = 0, this.acceleration = !1, this.accelerationX = new h(e, "accelerationX", 0, !0), this.accelerationY = new h(e, "accelerationY", 0, !0), this.maxVelocityX = new h(e, "maxVelocityX", 1e4, !0), this.maxVelocityY = new h(e, "maxVelocityY", 1e4, !0), this.speedX = new h(e, "speedX", 0, !0), this.speedY = new h(e, "speedY", 0, !0), this.moveTo = !1, this.moveToX = new h(e, "moveToX", 0, !0), this.moveToY = new h(e, "moveToY", 0, !0), this.bounce = new h(e, "bounce", 0, !0), this.scaleX = new h(e, "scaleX", 1), this.scaleY = new h(e, "scaleY", 1), this.tint = new h(e, "tint", 16777215), this.alpha = new h(e, "alpha", 1), this.lifespan = new h(e, "lifespan", 1e3, !0), this.angle = new h(e, "angle", {
                        min: 0,
                        max: 360
                    }, !0), this.rotate = new h(e, "rotate", 0), this.emitCallback = null, this.emitCallbackScope = null, this.deathCallback = null, this.deathCallbackScope = null, this.maxParticles = 0, this.quantity = new h(e, "quantity", 1, !0), this.delay = new h(e, "delay", 0, !0), this.frequency = 0, this.on = !0, this.particleBringToTop = !0, this.timeScale = 1, this.emitZone = null, this.deathZone = null, this.bounds = null, this.collideLeft = !0, this.collideRight = !0, this.collideTop = !0, this.collideBottom = !0, this.active = !0, this.visible = !0, this.blendMode = n.NORMAL, this.follow = null, this.followOffset = new m, this.trackVisible = !1, this.currentFrame = 0, this.randomFrame = !0, this.frameQuantity = 1, this.dead = [], this.alive = [], this._counter = 0, this._frameCounter = 0, e && this.fromJSON(e);
                },
                fromJSON: function(t) {
                    if (!t) return this;
                    for(var e, i = 0, n = "", i = 0; i < this.configFastMap.length; i++)n = this.configFastMap[i], d(t, n) && (this[n] = l(t, n));
                    for(i = 0; i < this.configOpMap.length; i++)n = this.configOpMap[i], d(t, n) && this[n].loadConfig(t);
                    return this.acceleration = 0 !== this.accelerationX.propertyValue || 0 !== this.accelerationY.propertyValue, this.moveTo = 0 !== this.moveToX.propertyValue || 0 !== this.moveToY.propertyValue, d(t, "speed") && (this.speedX.loadConfig(t, "speed"), this.speedY = null), (c(t, [
                        "speedX",
                        "speedY"
                    ]) || this.moveTo) && (this.radial = !1), d(t, "scale") && (this.scaleX.loadConfig(t, "scale"), this.scaleY = null), d(t, "callbackScope") && (e = l(t, "callbackScope", null), this.emitCallbackScope = e, this.deathCallbackScope = e), d(t, "emitZone") && this.setEmitZone(t.emitZone), d(t, "deathZone") && this.setDeathZone(t.deathZone), d(t, "bounds") && this.setBounds(t.bounds), d(t, "followOffset") && this.followOffset.setFromObject(l(t, "followOffset", 0)), d(t, "frame") && this.setFrame(t.frame), d(t, "reserve") && this.reserve(t.reserve), this;
                },
                toJSON: function(t) {
                    void 0 === t && (t = {});
                    for(var e = 0, i = "", e = 0; e < this.configFastMap.length; e++)t[i = this.configFastMap[e]] = this[i];
                    for(e = 0; e < this.configOpMap.length; e++)this[i = this.configOpMap[e]] && (t[i] = this[i].toJSON());
                    return this.speedY || (delete t.speedX, t.speed = this.speedX.toJSON()), this.scaleY || (delete t.scaleX, t.scale = this.scaleX.toJSON()), t;
                },
                startFollow: function(t, e, i, n) {
                    return void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = !1), this.follow = t, this.followOffset.set(e, i), this.trackVisible = n, this;
                },
                stopFollow: function() {
                    return this.follow = null, this.followOffset.set(0, 0), this.trackVisible = !1, this;
                },
                getFrame: function() {
                    if (1 === this.frames.length) return this.defaultFrame;
                    if (this.randomFrame) return u(this.frames);
                    var t = this.frames[this.currentFrame];
                    return this._frameCounter++, this._frameCounter === this.frameQuantity && (this._frameCounter = 0, this.currentFrame = y(this.currentFrame + 1, 0, this._frameLength)), t;
                },
                setFrame: function(t, e, i) {
                    void 0 === e && (e = !0), void 0 === i && (i = 1), this.randomFrame = e, this.frameQuantity = i, this.currentFrame = 0, this._frameCounter = 0;
                    var n, s, r = typeof t;
                    return Array.isArray(t) || "string" == r || "number" == r ? this.manager.setEmitterFrames(t, this) : "object" == r && ((t = l(n = t, "frames", null)) && this.manager.setEmitterFrames(t, this), s = l(n, "cycle", !1), this.randomFrame = !s, this.frameQuantity = l(n, "quantity", i)), this._frameLength = this.frames.length, 1 === this._frameLength && (this.frameQuantity = 1, this.randomFrame = !1), this;
                },
                setRadial: function(t) {
                    return void 0 === t && (t = !0), this.radial = t, this;
                },
                setPosition: function(t, e) {
                    return this.x.onChange(t), this.y.onChange(e), this;
                },
                setBounds: function(t, e, i, n) {
                    var s;
                    return "object" == typeof t && (t = (s = t).x, e = s.y, i = d(s, "w") ? s.w : s.width, n = d(s, "h") ? s.h : s.height), this.bounds ? this.bounds.setTo(t, e, i, n) : this.bounds = new g(t, e, i, n), this;
                },
                setSpeedX: function(t) {
                    return this.speedX.onChange(t), this.radial = !1, this;
                },
                setSpeedY: function(t) {
                    return this.speedY && (this.speedY.onChange(t), this.radial = !1), this;
                },
                setSpeed: function(t) {
                    return this.speedX.onChange(t), this.speedY = null, this.radial = !0, this;
                },
                setScaleX: function(t) {
                    return this.scaleX.onChange(t), this;
                },
                setScaleY: function(t) {
                    return this.scaleY.onChange(t), this;
                },
                setScale: function(t) {
                    return this.scaleX.onChange(t), this.scaleY = null, this;
                },
                setGravityX: function(t) {
                    return this.gravityX = t, this;
                },
                setGravityY: function(t) {
                    return this.gravityY = t, this;
                },
                setGravity: function(t, e) {
                    return this.gravityX = t, this.gravityY = e, this;
                },
                setAlpha: function(t) {
                    return this.alpha.onChange(t), this;
                },
                setTint: function(t) {
                    return this.tint.onChange(t), this;
                },
                setEmitterAngle: function(t) {
                    return this.angle.onChange(t), this;
                },
                setAngle: function(t) {
                    return this.angle.onChange(t), this;
                },
                setLifespan: function(t) {
                    return this.lifespan.onChange(t), this;
                },
                setQuantity: function(t) {
                    return this.quantity.onChange(t), this;
                },
                setFrequency: function(t, e) {
                    return this.frequency = t, this._counter = 0, e && this.quantity.onChange(e), this;
                },
                setEmitZone: function(t) {
                    if (void 0 === t) this.emitZone = null;
                    else {
                        var e = l(t, "type", "random"), i = l(t, "source", null);
                        switch(e){
                            case "random":
                                this.emitZone = new p(i);
                                break;
                            case "edge":
                                var n = l(t, "quantity", 1), s = l(t, "stepRate", 0), r = l(t, "yoyo", !1), o = l(t, "seamless", !0);
                                this.emitZone = new a(i, n, s, r, o);
                        }
                    }
                    return this;
                },
                setDeathZone: function(t) {
                    var e, i, n;
                    return void 0 === t ? this.deathZone = null : (e = l(t, "type", "onEnter"), (i = l(t, "source", null)) && "function" == typeof i.contains && (n = "onEnter" === e, this.deathZone = new o(i, n))), this;
                },
                reserve: function(t) {
                    for(var e = this.dead, i = 0; i < t; i++)e.push(new this.particleClass(this));
                    return this;
                },
                getAliveParticleCount: function() {
                    return this.alive.length;
                },
                getDeadParticleCount: function() {
                    return this.dead.length;
                },
                getParticleCount: function() {
                    return this.getAliveParticleCount() + this.getDeadParticleCount();
                },
                atLimit: function() {
                    return 0 < this.maxParticles && this.getParticleCount() === this.maxParticles;
                },
                onParticleEmit: function(t, e) {
                    return void 0 === t ? (this.emitCallback = null, this.emitCallbackScope = null) : "function" == typeof t && (this.emitCallback = t, e && (this.emitCallbackScope = e)), this;
                },
                onParticleDeath: function(t, e) {
                    return void 0 === t ? (this.deathCallback = null, this.deathCallbackScope = null) : "function" == typeof t && (this.deathCallback = t, e && (this.deathCallbackScope = e)), this;
                },
                killAll: function() {
                    for(var t = this.dead, e = this.alive; 0 < e.length;)t.push(e.pop());
                    return this;
                },
                forEachAlive: function(t, e) {
                    for(var i = this.alive, n = i.length, s = 0; s < n; ++s)t.call(e, i[s], this);
                    return this;
                },
                forEachDead: function(t, e) {
                    for(var i = this.dead, n = i.length, s = 0; s < n; ++s)t.call(e, i[s], this);
                    return this;
                },
                start: function() {
                    return this.on = !0, this._counter = 0, this;
                },
                stop: function() {
                    return this.on = !1, this;
                },
                pause: function() {
                    return this.active = !1, this;
                },
                resume: function() {
                    return this.active = !0, this;
                },
                remove: function() {
                    return this.manager.removeEmitter(this), this;
                },
                depthSort: function() {
                    return v(this.alive, this.depthSortCallback), this;
                },
                flow: function(t, e) {
                    return void 0 === e && (e = 1), this.frequency = t, this.quantity.onChange(e), this.start();
                },
                explode: function(t, e, i) {
                    return this.frequency = -1, this.emitParticle(t, e, i);
                },
                emitParticleAt: function(t, e, i) {
                    return this.emitParticle(i, t, e);
                },
                emitParticle: function(t, e, i) {
                    if (!this.atLimit()) {
                        void 0 === t && (t = this.quantity.onEmit());
                        for(var n = this.dead, s = this.follow ? this.follow.x + this.followOffset.x : e, r = this.follow ? this.follow.y + this.followOffset.y : i, o = 0; o < t; o++){
                            var a = n.pop();
                            if ((a = a || new this.particleClass(this)).fire(s, r), this.particleBringToTop ? this.alive.push(a) : this.alive.unshift(a), this.emitCallback && this.emitCallback.call(this.emitCallbackScope, a, this), this.atLimit()) break;
                        }
                        return a;
                    }
                },
                preUpdate: function(t, e) {
                    var i = (e *= this.timeScale) / 1e3;
                    this.trackVisible && (this.visible = this.follow.visible);
                    var n = this.manager.getProcessors(), s = this.alive, r = this.dead, o = 0, a = [], h = s.length;
                    for(o = 0; o < h; o++){
                        var l = s[o];
                        l.update(e, i, n) && a.push({
                            index: o,
                            particle: l
                        });
                    }
                    if (0 < (h = a.length)) for(var u = this.deathCallback, c = this.deathCallbackScope, o = h - 1; 0 <= o; o--){
                        var d = a[o];
                        s.splice(d.index, 1), r.push(d.particle), u && u.call(c, d.particle), d.particle.resetPosition();
                    }
                    this.on && (0 === this.frequency ? this.emitParticle() : 0 < this.frequency && (this._counter -= e, this._counter <= 0 && (this.emitParticle(), this._counter = this.frequency - Math.abs(this._counter))));
                },
                depthSortCallback: function(t, e) {
                    return t.y - e.y;
                }
            });
            t.exports = x;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e) {
                    this.source = t, this.killOnEnter = e;
                },
                willKill: function(t) {
                    var e = this.source.contains(t.x, t.y);
                    return e && this.killOnEnter || !e && !this.killOnEnter;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n, s) {
                    void 0 === n && (n = !1), void 0 === s && (s = !0), this.source = t, this.points = [], this.quantity = e, this.stepRate = i, this.yoyo = n, this.counter = -1, this.seamless = s, this._length = 0, this._direction = 0, this.updateSource();
                },
                updateSource: function() {
                    var t, e;
                    this.points = this.source.getPoints(this.quantity, this.stepRate), this.seamless && (t = this.points[0], e = this.points[this.points.length - 1], t.x === e.x && t.y === e.y && this.points.pop());
                    var i = this._length;
                    return this._length = this.points.length, this._length < i && this.counter > this._length && (this.counter = this._length - 1), this;
                },
                changeSource: function(t) {
                    return this.source = t, this.updateSource();
                },
                getPoint: function(t) {
                    0 === this._direction ? (this.counter++, this.counter >= this._length && (this.yoyo ? (this._direction = 1, this.counter = this._length - 1) : this.counter = 0)) : (this.counter--, -1 === this.counter && (this.yoyo ? (this._direction = 0, this.counter = 0) : this.counter = this._length - 1));
                    var e = this.points[this.counter];
                    e && (t.x = e.x, t.y = e.y);
                }
            });
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var i = 0; i < e.length; i++)if (t.hasOwnProperty(e[i])) return !0;
                return !1;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(3), r = new n({
                initialize: function(t) {
                    this.source = t, this._tempVec = new s;
                },
                getPoint: function(t) {
                    var e = this._tempVec;
                    this.source.getRandomPoint(e), t.x = e.x, t.y = e.y;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(11), o = i(73), r = new n({
                Extends: o,
                Mixins: [
                    s.PathFollower
                ],
                initialize: function(t, e, i, n, s, r) {
                    o.call(this, t, i, n, s, r), this.path = e;
                },
                preUpdate: function(t, e) {
                    this.anims.update(t, e), this.pathUpdate(t);
                }
            });
            t.exports = r;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = t.canvas, s = t.context, r = t.style, o = [], a = 0, h = i.length;
                0 < r.maxLines && r.maxLines < i.length && (h = r.maxLines), r.syncFont(n, s);
                for(var l = 0; l < h; l++){
                    var u = r.strokeThickness;
                    u += s.measureText(i[l]).width, r.wordWrap && (u -= s.measureText(" ").width), o[l] = Math.ceil(u), a = Math.max(a, o[l]);
                }
                var c = e.fontSize + r.strokeThickness, d = c * h, f = t.lineSpacing;
                return 1 < h && (d += f * (h - 1)), {
                    width: a,
                    height: d,
                    lines: h,
                    lineWidths: o,
                    lineSpacing: f,
                    lineHeight: c
                };
            };
        },
        function(t, e, i) {
            var n = i(0), a = i(13), h = i(6), s = i(454), l = {
                fontFamily: [
                    "fontFamily",
                    "Courier"
                ],
                fontSize: [
                    "fontSize",
                    "16px"
                ],
                fontStyle: [
                    "fontStyle",
                    ""
                ],
                backgroundColor: [
                    "backgroundColor",
                    null
                ],
                color: [
                    "color",
                    "#fff"
                ],
                stroke: [
                    "stroke",
                    "#fff"
                ],
                strokeThickness: [
                    "strokeThickness",
                    0
                ],
                shadowOffsetX: [
                    "shadow.offsetX",
                    0
                ],
                shadowOffsetY: [
                    "shadow.offsetY",
                    0
                ],
                shadowColor: [
                    "shadow.color",
                    "#000"
                ],
                shadowBlur: [
                    "shadow.blur",
                    0
                ],
                shadowStroke: [
                    "shadow.stroke",
                    !1
                ],
                shadowFill: [
                    "shadow.fill",
                    !1
                ],
                align: [
                    "align",
                    "left"
                ],
                maxLines: [
                    "maxLines",
                    0
                ],
                fixedWidth: [
                    "fixedWidth",
                    0
                ],
                fixedHeight: [
                    "fixedHeight",
                    0
                ],
                resolution: [
                    "resolution",
                    0
                ],
                rtl: [
                    "rtl",
                    !1
                ],
                testString: [
                    "testString",
                    "|M\xc3\u2030qgy"
                ],
                baselineX: [
                    "baselineX",
                    1.2
                ],
                baselineY: [
                    "baselineY",
                    1.4
                ],
                wordWrapWidth: [
                    "wordWrap.width",
                    null
                ],
                wordWrapCallback: [
                    "wordWrap.callback",
                    null
                ],
                wordWrapCallbackScope: [
                    "wordWrap.callbackScope",
                    null
                ],
                wordWrapUseAdvanced: [
                    "wordWrap.useAdvancedWrap",
                    !1
                ]
            }, r = new n({
                initialize: function(t, e) {
                    this.parent = t, this.fontFamily, this.fontSize, this.fontStyle, this.backgroundColor, this.color, this.stroke, this.strokeThickness, this.shadowOffsetX, this.shadowOffsetY, this.shadowColor, this.shadowBlur, this.shadowStroke, this.shadowFill, this.align, this.maxLines, this.fixedWidth, this.fixedHeight, this.resolution, this.rtl, this.testString, this.baselineX, this.baselineY, this.wordWrapWidth, this.wordWrapCallback, this.wordWrapCallbackScope, this.wordWrapUseAdvanced, this._font, this.setStyle(e, !1, !0);
                    var i = h(e, "metrics", !1);
                    this.metrics = i ? {
                        ascent: h(i, "ascent", 0),
                        descent: h(i, "descent", 0),
                        fontSize: h(i, "fontSize", 0)
                    } : s(this);
                },
                setStyle: function(t, e, i) {
                    for(var n in void 0 === e && (e = !0), void 0 === i && (i = !1), t && t.hasOwnProperty("fontSize") && "number" == typeof t.fontSize && (t.fontSize = t.fontSize.toString() + "px"), l){
                        var s = i ? l[n][1] : this[n];
                        this[n] = ("wordWrapCallback" === n || "wordWrapCallbackScope" === n ? h : a)(t, l[n][0], s);
                    }
                    var r = h(t, "font", null);
                    null !== r && this.setFont(r, !1), this._font = [
                        this.fontStyle,
                        this.fontSize,
                        this.fontFamily
                    ].join(" ").trim();
                    var o = h(t, "fill", null);
                    return null !== o && (this.color = o), e ? this.update(!0) : this.parent;
                },
                syncFont: function(t, e) {
                    e.font = this._font;
                },
                syncStyle: function(t, e) {
                    e.textBaseline = "alphabetic", e.fillStyle = this.color, e.strokeStyle = this.stroke, e.lineWidth = this.strokeThickness, e.lineCap = "round", e.lineJoin = "round";
                },
                syncShadow: function(t, e) {
                    e ? (t.shadowOffsetX = this.shadowOffsetX, t.shadowOffsetY = this.shadowOffsetY, t.shadowColor = this.shadowColor, t.shadowBlur = this.shadowBlur) : (t.shadowOffsetX = 0, t.shadowOffsetY = 0, t.shadowColor = 0, t.shadowBlur = 0);
                },
                update: function(t) {
                    return t && (this._font = [
                        this.fontStyle,
                        this.fontSize,
                        this.fontFamily
                    ].join(" ").trim(), this.metrics = s(this)), this.parent.updateText();
                },
                setFont: function(t, e) {
                    void 0 === e && (e = !0);
                    var i, n, s = t, r = "", o = "";
                    return "string" != typeof t ? (s = h(t, "fontFamily", "Courier"), r = h(t, "fontSize", "16px"), o = h(t, "fontStyle", "")) : (n = 0, o = 2 < (i = t.split(" ")).length ? i[n++] : "", r = i[n++] || "16px", s = i[n++] || "Courier"), s === this.fontFamily && r === this.fontSize && o === this.fontStyle || (this.fontFamily = s, this.fontSize = r, this.fontStyle = o, e && this.update(!0)), this.parent;
                },
                setFontFamily: function(t) {
                    return this.fontFamily !== t && (this.fontFamily = t, this.update(!0)), this.parent;
                },
                setFontStyle: function(t) {
                    return this.fontStyle !== t && (this.fontStyle = t, this.update(!0)), this.parent;
                },
                setFontSize: function(t) {
                    return "number" == typeof t && (t = t.toString() + "px"), this.fontSize !== t && (this.fontSize = t, this.update(!0)), this.parent;
                },
                setTestString: function(t) {
                    return this.testString = t, this.update(!0);
                },
                setFixedSize: function(t, e) {
                    return this.fixedWidth = t, this.fixedHeight = e, t && (this.parent.width = t), e && (this.parent.height = e), this.update(!1);
                },
                setBackgroundColor: function(t) {
                    return this.backgroundColor = t, this.update(!1);
                },
                setFill: function(t) {
                    return this.color = t, this.update(!1);
                },
                setColor: function(t) {
                    return this.color = t, this.update(!1);
                },
                setResolution: function(t) {
                    return this.resolution = t, this.update(!1);
                },
                setStroke: function(t, e) {
                    return void 0 === e && (e = this.strokeThickness), void 0 === t && 0 !== this.strokeThickness ? (this.strokeThickness = 0, this.update(!0)) : this.stroke === t && this.strokeThickness === e || (this.stroke = t, this.strokeThickness = e, this.update(!0)), this.parent;
                },
                setShadow: function(t, e, i, n, s, r) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = "#000"), void 0 === n && (n = 0), void 0 === s && (s = !1), void 0 === r && (r = !0), this.shadowOffsetX = t, this.shadowOffsetY = e, this.shadowColor = i, this.shadowBlur = n, this.shadowStroke = s, this.shadowFill = r, this.update(!1);
                },
                setShadowOffset: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this.shadowOffsetX = t, this.shadowOffsetY = e, this.update(!1);
                },
                setShadowColor: function(t) {
                    return void 0 === t && (t = "#000"), this.shadowColor = t, this.update(!1);
                },
                setShadowBlur: function(t) {
                    return void 0 === t && (t = 0), this.shadowBlur = t, this.update(!1);
                },
                setShadowStroke: function(t) {
                    return this.shadowStroke = t, this.update(!1);
                },
                setShadowFill: function(t) {
                    return this.shadowFill = t, this.update(!1);
                },
                setWordWrapWidth: function(t, e) {
                    return void 0 === e && (e = !1), this.wordWrapWidth = t, this.wordWrapUseAdvanced = e, this.update(!1);
                },
                setWordWrapCallback: function(t, e) {
                    return void 0 === e && (e = null), this.wordWrapCallback = t, this.wordWrapCallbackScope = e, this.update(!1);
                },
                setAlign: function(t) {
                    return void 0 === t && (t = "left"), this.align = t, this.update(!1);
                },
                setMaxLines: function(t) {
                    return void 0 === t && (t = 0), this.maxLines = t, this.update(!1);
                },
                getTextMetrics: function() {
                    var t = this.metrics;
                    return {
                        ascent: t.ascent,
                        descent: t.descent,
                        fontSize: t.fontSize
                    };
                },
                toJSON: function() {
                    var t = {};
                    for(var e in l)t[e] = this[e];
                    return t.metrics = this.getTextMetrics(), t;
                },
                destroy: function() {
                    this.parent = void 0;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var m = i(31);
            t.exports = function(t) {
                var e = m.create(this), i = e.getContext("2d");
                t.syncFont(e, i);
                var n = i.measureText(t.testString);
                if (n.hasOwnProperty("actualBoundingBoxAscent")) {
                    var s = n.actualBoundingBoxAscent, r = n.actualBoundingBoxDescent;
                    return m.remove(e), {
                        ascent: s,
                        descent: r,
                        fontSize: s + r
                    };
                }
                var o = Math.ceil(n.width * t.baselineX), a = 2 * (h = o), h = h * t.baselineY | 0;
                e.width = o, e.height = a, i.fillStyle = "#f00", i.fillRect(0, 0, o, a), i.font = t._font, i.textBaseline = "alphabetic", i.fillStyle = "#000", i.fillText(t.testString, 0, h);
                var l = {
                    ascent: 0,
                    descent: 0,
                    fontSize: 0
                };
                if (!i.getImageData(0, 0, o, a)) return l.ascent = h, l.descent = 6 + h, l.fontSize = l.ascent + l.descent, m.remove(e), l;
                for(var u, c = i.getImageData(0, 0, o, a).data, d = c.length, f = 4 * o, p = 0, g = !1, v = 0; v < h; v++){
                    for(u = 0; u < f; u += 4)if (255 !== c[p + u]) {
                        g = !0;
                        break;
                    }
                    if (g) break;
                    p += f;
                }
                for(l.ascent = h - v, p = d - f, g = !1, v = a; h < v; v--){
                    for(u = 0; u < f; u += 4)if (255 !== c[p + u]) {
                        g = !0;
                        break;
                    }
                    if (g) break;
                    p -= f;
                }
                return l.descent = v - h, l.fontSize = l.ascent + l.descent, m.remove(e), l;
            };
        },
        function(t, e, i) {
            var n = i(1091), s = i(0), l = i(35), u = i(68), c = i(62), d = i(14), f = i(33), r = new s({
                Extends: f,
                Mixins: [
                    n
                ],
                initialize: function(t, e, i, n, s, r, o, a, h) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 128), void 0 === s && (s = 0), void 0 === r && (r = 360), void 0 === o && (o = !1), f.call(this, t, "Arc", new c(0, 0, n)), this._startAngle = s, this._endAngle = r, this._anticlockwise = o, this._iterations = .01, this.setPosition(e, i);
                    var l = 2 * this.geom.radius;
                    this.setSize(l, l), void 0 !== a && this.setFillStyle(a, h), this.updateDisplayOrigin(), this.updateData();
                },
                iterations: {
                    get: function() {
                        return this._iterations;
                    },
                    set: function(t) {
                        this._iterations = t, this.updateData();
                    }
                },
                radius: {
                    get: function() {
                        return this.geom.radius;
                    },
                    set: function(t) {
                        var e = 2 * (this.geom.radius = t);
                        this.setSize(e, e), this.updateDisplayOrigin(), this.updateData();
                    }
                },
                startAngle: {
                    get: function() {
                        return this._startAngle;
                    },
                    set: function(t) {
                        this._startAngle = t, this.updateData();
                    }
                },
                endAngle: {
                    get: function() {
                        return this._endAngle;
                    },
                    set: function(t) {
                        this._endAngle = t, this.updateData();
                    }
                },
                anticlockwise: {
                    get: function() {
                        return this._anticlockwise;
                    },
                    set: function(t) {
                        this._anticlockwise = t, this.updateData();
                    }
                },
                setRadius: function(t) {
                    return this.radius = t, this;
                },
                setIterations: function(t) {
                    return void 0 === t && (t = .01), this.iterations = t, this;
                },
                setStartAngle: function(t, e) {
                    return this._startAngle = t, void 0 !== e && (this._anticlockwise = e), this.updateData();
                },
                setEndAngle: function(t, e) {
                    return this._endAngle = t, void 0 !== e && (this._anticlockwise = e), this.updateData();
                },
                updateData: function() {
                    var t = this._iterations, e = t, i = this.geom.radius, n = l(this._startAngle), s = l(this._endAngle), r = i, o = i;
                    s -= n, this._anticlockwise ? s < -d.PI2 ? s = -d.PI2 : 0 < s && (s = -d.PI2 + s % d.PI2) : s > d.PI2 ? s = d.PI2 : s < 0 && (s = d.PI2 + s % d.PI2);
                    for(var a, h = [
                        r + Math.cos(n) * i,
                        o + Math.sin(n) * i
                    ]; e < 1;)a = s * e + n, h.push(r + Math.cos(a) * i, o + Math.sin(a) * i), e += t;
                    return a = s + n, h.push(r + Math.cos(a) * i, o + Math.sin(a) * i), h.push(r + Math.cos(n) * i, o + Math.sin(n) * i), this.pathIndexes = u(h), this.pathData = h, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(1094), r = i(68), o = i(10), a = i(33), h = new n({
                Extends: a,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), a.call(this, t, "Curve", n), this._smoothness = 32, this._curveBounds = new o, this.closePath = !1, this.setPosition(e, i), void 0 !== s && this.setFillStyle(s, r), this.updateData();
                },
                smoothness: {
                    get: function() {
                        return this._smoothness;
                    },
                    set: function(t) {
                        this._smoothness = t, this.updateData();
                    }
                },
                setSmoothness: function(t) {
                    return this._smoothness = t, this.updateData();
                },
                updateData: function() {
                    var t = this._curveBounds, e = this._smoothness;
                    this.geom.getBounds(t, e), this.setSize(t.width, t.height), this.updateDisplayOrigin();
                    for(var i = [], n = this.geom.getPoints(e), s = 0; s < n.length; s++)i.push(n[s].x, n[s].y);
                    return i.push(n[0].x, n[0].y), this.pathIndexes = r(i), this.pathData = i, this;
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var n = i(0), s = i(68), r = i(1097), a = i(108), h = i(33), o = new n({
                Extends: h,
                Mixins: [
                    r
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 128), void 0 === s && (s = 128), h.call(this, t, "Ellipse", new a(n / 2, s / 2, n, s)), this._smoothness = 64, this.setPosition(e, i), this.width = n, this.height = s, void 0 !== r && this.setFillStyle(r, o), this.updateDisplayOrigin(), this.updateData();
                },
                smoothness: {
                    get: function() {
                        return this._smoothness;
                    },
                    set: function(t) {
                        this._smoothness = t, this.updateData();
                    }
                },
                setSize: function(t, e) {
                    return this.width = t, this.height = e, this.geom.setPosition(t / 2, e / 2), this.geom.setSize(t, e), this.updateData();
                },
                setSmoothness: function(t) {
                    return this._smoothness = t, this.updateData();
                },
                updateData: function() {
                    for(var t = [], e = this.geom.getPoints(this._smoothness), i = 0; i < e.length; i++)t.push(e[i].x, e[i].y);
                    return t.push(e[0].x, e[0].y), this.pathIndexes = s(t), this.pathData = t, this;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), c = i(33), s = i(1100), r = new n({
                Extends: c,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r, o, a, h, l, u) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 128), void 0 === s && (s = 128), void 0 === r && (r = 32), void 0 === o && (o = 32), c.call(this, t, "Grid", null), this.cellWidth = r, this.cellHeight = o, this.showCells = !0, this.outlineFillColor = 0, this.outlineFillAlpha = 0, this.showOutline = !0, this.showAltCells = !1, this.altFillColor, this.altFillAlpha, this.setPosition(e, i), this.setSize(n, s), this.setFillStyle(a, h), void 0 !== l && this.setOutlineStyle(l, u), this.updateDisplayOrigin();
                },
                setFillStyle: function(t, e) {
                    return void 0 === e && (e = 1), void 0 === t ? this.showCells = !1 : (this.fillColor = t, this.fillAlpha = e, this.showCells = !0), this;
                },
                setAltFillStyle: function(t, e) {
                    return void 0 === e && (e = 1), void 0 === t ? this.showAltCells = !1 : (this.altFillColor = t, this.altFillAlpha = e, this.showAltCells = !0), this;
                },
                setOutlineStyle: function(t, e) {
                    return void 0 === e && (e = 1), void 0 === t ? this.showOutline = !1 : (this.outlineFillColor = t, this.outlineFillAlpha = e, this.showOutline = !0), this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(1103), s = i(0), h = i(33), r = new s({
                Extends: h,
                Mixins: [
                    n
                ],
                initialize: function(t, e, i, n, s, r, o, a) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 48), void 0 === s && (s = 32), void 0 === r && (r = 15658734), void 0 === o && (o = 10066329), void 0 === a && (a = 13421772), h.call(this, t, "IsoBox", null), this.projection = 4, this.fillTop = r, this.fillLeft = o, this.fillRight = a, this.showTop = !0, this.showLeft = !0, this.showRight = !0, this.isFilled = !0, this.setPosition(e, i), this.setSize(n, s), this.updateDisplayOrigin();
                },
                setProjection: function(t) {
                    return this.projection = t, this;
                },
                setFaces: function(t, e, i) {
                    return void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), this.showTop = t, this.showLeft = e, this.showRight = i, this;
                },
                setFillStyle: function(t, e, i) {
                    return this.fillTop = t, this.fillLeft = e, this.fillRight = i, this.isFilled = !0, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(1106), l = i(33), r = new n({
                Extends: l,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r, o, a, h) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 48), void 0 === s && (s = 32), void 0 === r && (r = !1), void 0 === o && (o = 15658734), void 0 === a && (a = 10066329), void 0 === h && (h = 13421772), l.call(this, t, "IsoTriangle", null), this.projection = 4, this.fillTop = o, this.fillLeft = a, this.fillRight = h, this.showTop = !0, this.showLeft = !0, this.showRight = !0, this.isReversed = r, this.isFilled = !0, this.setPosition(e, i), this.setSize(n, s), this.updateDisplayOrigin();
                },
                setProjection: function(t) {
                    return this.projection = t, this;
                },
                setReversed: function(t) {
                    return this.isReversed = t, this;
                },
                setFaces: function(t, e, i) {
                    return void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), this.showTop = t, this.showLeft = e, this.showRight = i, this;
                },
                setFillStyle: function(t, e, i) {
                    return this.fillTop = t, this.fillLeft = e, this.fillRight = i, this.isFilled = !0, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), c = i(33), d = i(45), s = i(1109), r = new n({
                Extends: c,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r, o, a, h) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = 128), void 0 === o && (o = 0), c.call(this, t, "Line", new d(n, s, r, o));
                    var l = Math.max(1, this.geom.right - this.geom.left), u = Math.max(1, this.geom.bottom - this.geom.top);
                    this.lineWidth = 1, this._startWidth = 1, this._endWidth = 1, this.setPosition(e, i), this.setSize(l, u), void 0 !== a && this.setStrokeStyle(1, a, h), this.updateDisplayOrigin();
                },
                setLineWidth: function(t, e) {
                    return void 0 === e && (e = t), this._startWidth = t, this._endWidth = e, this.lineWidth = t, this;
                },
                setTo: function(t, e, i, n) {
                    return this.geom.setTo(t, e, i, n), this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(1112), s = i(0), r = i(68), a = i(463), h = i(224), l = i(33), o = i(466), u = new s({
                Extends: l,
                Mixins: [
                    n
                ],
                initialize: function(t, e, i, n, s, r) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), l.call(this, t, "Polygon", new h(n));
                    var o = a(this.geom);
                    this.setPosition(e, i), this.setSize(o.width, o.height), void 0 !== s && this.setFillStyle(s, r), this.updateDisplayOrigin(), this.updateData();
                },
                smooth: function(t) {
                    void 0 === t && (t = 1);
                    for(var e = 0; e < t; e++)o(this.geom);
                    return this.updateData();
                },
                updateData: function() {
                    for(var t = [], e = this.geom.points, i = 0; i < e.length; i++)t.push(e[i].x, e[i].y);
                    return t.push(e[0].x, e[0].y), this.pathIndexes = r(t), this.pathData = t, this;
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var h = i(10);
            t.exports = function(t, e) {
                void 0 === e && (e = new h);
                for(var i, n = 1 / 0, s = 1 / 0, r = -n, o = -s, a = 0; a < t.points.length; a++)i = t.points[a], n = Math.min(n, i.x), s = Math.min(s, i.y), r = Math.max(r, i.x), o = Math.max(o, i.y);
                return e.x = n, e.y = s, e.width = r - n, e.height = o - s, e;
            };
        },
        function(t, e, i) {
            var g = i(64), v = i(45), m = i(465);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = []);
                var s = t.points, r = m(t);
                !e && 0 < i && (e = r / i);
                for(var o = 0; o < e; o++)for(var a = r * (o / e), h = 0, l = 0; l < s.length; l++){
                    var u = s[l], c = s[(l + 1) % s.length], d = new v(u.x, u.y, c.x, c.y), f = g(d);
                    if (!(a < h || h + f < a)) {
                        var p = d.getPoint((a - h) / f);
                        n.push(p);
                        break;
                    }
                    h += f;
                }
                return n;
            };
        },
        function(t, e, i) {
            var a = i(64), h = i(45);
            t.exports = function(t) {
                for(var e = t.points, i = 0, n = 0; n < e.length; n++){
                    var s = e[n], r = e[(n + 1) % e.length], o = new h(s.x, s.y, r.x, r.y);
                    i += a(o);
                }
                return i;
            };
        },
        function(t, e) {
            function c(t, e) {
                return t[0] = e[0], t[1] = e[1], t;
            }
            t.exports = function(t) {
                for(var e = [], i = t.points, n = 0; n < i.length; n++)e.push([
                    i[n].x,
                    i[n].y
                ]);
                var s = [];
                for(0 < e.length && s.push(c([
                    0,
                    0
                ], e[0])), n = 0; n < e.length - 1; n++){
                    var r = e[n], o = e[n + 1], a = r[0], h = r[1], l = o[0], u = o[1];
                    s.push([
                        .85 * a + .15 * l,
                        .85 * h + .15 * u
                    ]), s.push([
                        .15 * a + .85 * l,
                        .15 * h + .85 * u
                    ]);
                }
                return 1 < e.length && s.push(c([
                    0,
                    0
                ], e[e.length - 1])), t.setTo(s);
            };
        },
        function(t, e, i) {
            var n = i(0), a = i(10), h = i(33), s = i(1115), r = new n({
                Extends: h,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 128), void 0 === s && (s = 128), h.call(this, t, "Rectangle", new a(0, 0, n, s)), this.setPosition(e, i), this.setSize(n, s), void 0 !== r && this.setFillStyle(r, o), this.updateDisplayOrigin(), this.updateData();
                },
                setSize: function(t, e) {
                    return this.width = t, this.height = e, this.geom.setSize(t, e), this.updateData(), this;
                },
                updateData: function() {
                    var t = [], e = this.geom, i = this._tempLine;
                    return e.getLineA(i), t.push(i.x1, i.y1, i.x2, i.y2), e.getLineB(i), t.push(i.x2, i.y2), e.getLineC(i), t.push(i.x2, i.y2), e.getLineD(i), t.push(i.x2, i.y2), this.pathData = t, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(1118), s = i(0), l = i(68), h = i(33), r = new s({
                Extends: h,
                Mixins: [
                    n
                ],
                initialize: function(t, e, i, n, s, r, o, a) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 5), void 0 === s && (s = 32), void 0 === r && (r = 64), h.call(this, t, "Star", null), this._points = n, this._innerRadius = s, this._outerRadius = r, this.setPosition(e, i), this.setSize(2 * r, 2 * r), void 0 !== o && this.setFillStyle(o, a), this.updateDisplayOrigin(), this.updateData();
                },
                setPoints: function(t) {
                    return this._points = t, this.updateData();
                },
                setInnerRadius: function(t) {
                    return this._innerRadius = t, this.updateData();
                },
                setOuterRadius: function(t) {
                    return this._outerRadius = t, this.updateData();
                },
                points: {
                    get: function() {
                        return this._points;
                    },
                    set: function(t) {
                        this._points = t, this.updateData();
                    }
                },
                innerRadius: {
                    get: function() {
                        return this._innerRadius;
                    },
                    set: function(t) {
                        this._innerRadius = t, this.updateData();
                    }
                },
                outerRadius: {
                    get: function() {
                        return this._outerRadius;
                    },
                    set: function(t) {
                        this._outerRadius = t, this.updateData();
                    }
                },
                updateData: function() {
                    var t = [], e = this._points, i = this._innerRadius, n = this._outerRadius, s = Math.PI / 2 * 3, r = Math.PI / e, o = n, a = n;
                    t.push(o, a + -n);
                    for(var h = 0; h < e; h++)t.push(o + Math.cos(s) * n, a + Math.sin(s) * n), s += r, t.push(o + Math.cos(s) * i, a + Math.sin(s) * i), s += r;
                    return t.push(o, a + -n), this.pathIndexes = l(t), this.pathData = t, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), f = i(33), p = i(82), s = i(1121), r = new n({
                Extends: f,
                Mixins: [
                    s
                ],
                initialize: function(t, e, i, n, s, r, o, a, h, l, u) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = 128), void 0 === r && (r = 64), void 0 === o && (o = 0), void 0 === a && (a = 128), void 0 === h && (h = 128), f.call(this, t, "Triangle", new p(n, s, r, o, a, h));
                    var c = this.geom.right - this.geom.left, d = this.geom.bottom - this.geom.top;
                    this.setPosition(e, i), this.setSize(c, d), void 0 !== l && this.setFillStyle(l, u), this.updateDisplayOrigin(), this.updateData();
                },
                setTo: function(t, e, i, n, s, r) {
                    return this.geom.setTo(t, e, i, n, s, r), this.updateData();
                },
                updateData: function() {
                    var t = [], e = this.geom, i = this._tempLine;
                    return e.getLineA(i), t.push(i.x1, i.y1, i.x2, i.y2), e.getLineB(i), t.push(i.x2, i.y2), e.getLineC(i), t.push(i.x2, i.y2), this.pathData = t, this;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var c = i(4), d = i(64);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new c);
                var n = t.getLineA(), s = t.getLineB(), r = t.getLineC();
                if (e <= 0 || 1 <= e) return i.x = n.x1, i.y = n.y1, i;
                var o = d(n), a = d(s), h = d(r), l = (o + a + h) * e, u = 0;
                return l < o ? (u = l / o, i.x = n.x1 + (n.x2 - n.x1) * u, i.y = n.y1 + (n.y2 - n.y1) * u) : o + a < l ? (u = (l -= o + a) / h, i.x = r.x1 + (r.x2 - r.x1) * u, i.y = r.y1 + (r.y2 - r.y1) * u) : (u = (l -= o) / a, i.x = s.x1 + (s.x2 - s.x1) * u, i.y = s.y1 + (s.y2 - s.y1) * u), i;
            };
        },
        function(t, e, i) {
            var g = i(64), v = i(4);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = []);
                var s = t.getLineA(), r = t.getLineB(), o = t.getLineC(), a = g(s), h = g(r), l = g(o), u = a + h + l;
                !e && 0 < i && (e = u / i);
                for(var c = 0; c < e; c++){
                    var d = u * (c / e), f = 0, p = new v;
                    d < a ? (f = d / a, p.x = s.x1 + (s.x2 - s.x1) * f, p.y = s.y1 + (s.y2 - s.y1) * f) : a + h < d ? (f = (d -= a + h) / l, p.x = o.x1 + (o.x2 - o.x1) * f, p.y = o.y1 + (o.y2 - o.y1) * f) : (f = (d -= a) / h, p.x = r.x1 + (r.x2 - r.x1) * f, p.y = r.y1 + (r.y2 - r.y1) * f), n.push(p);
                }
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (!t || "number" == typeof t) return !1;
                if (t.hasOwnProperty(e)) return t[e] = i, !0;
                if (-1 === e.indexOf(".")) return !1;
                for(var n = e.split("."), s = t, r = t, o = 0; o < n.length; o++){
                    if (!s.hasOwnProperty(n[o])) return !1;
                    s = (r = s)[n[o]];
                }
                return r[n[n.length - 1]] = i, !0;
            };
        },
        function(t, e, i) {
            var P = i(113), O = i(115);
            t.exports = function(t, e, i, n, s, r, o) {
                if (void 0 === n && (n = !1), void 0 === r && (r = 16777215), void 0 === o && (o = 1), t.length === e.length) {
                    var a = {
                        faces: [],
                        vertices: []
                    }, h = n ? 3 : 2, l = Array.isArray(r), u = Array.isArray(o);
                    if (Array.isArray(i) && 0 < i.length) for(_ = 0; _ < i.length; _++){
                        var c = i[_], d = 2 * i[_], f = i[_] * h, p = t[f], g = t[1 + f], v = n ? t[2 + f] : 0, m = e[d], y = e[1 + d], x = l ? r[c] : r, T = u ? o[c] : o, w = 0, b = 0, E = 0;
                        s && (w = s[f], b = s[1 + f], E = n ? s[2 + f] : 0), a.vertices.push(new O(p, g, v, m, y, x, T, w, b, E));
                    }
                    else for(var S = 0, A = 0, _ = 0; _ < t.length; _ += h)p = t[_], g = t[_ + 1], v = n ? t[_ + 2] : 0, m = e[S], y = e[S + 1], x = l ? r[A] : r, T = u ? o[A] : o, E = b = w = 0, s && (w = s[_], b = s[_ + 1], E = n ? s[_ + 2] : 0), a.vertices.push(new O(p, g, v, m, y, x, T, w, b, E)), S += 2, A++;
                    for(_ = 0; _ < a.vertices.length; _ += 3){
                        var C = a.vertices[_], M = a.vertices[_ + 1], R = a.vertices[_ + 2];
                        a.faces.push(new P(C, M, R));
                    }
                    return a;
                }
                console.warn("GenerateVerts: vertices and uvs count not equal");
            };
        },
        function(t, e, i) {
            var k = i(113), n = i(67), s = i(38), I = i(115), B = new s, N = new s, Y = new n;
            t.exports = function(t, e, i, n, s, r, o, a, h, l) {
                void 0 === i && (i = 1), void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = 0), void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === h && (h = 0), void 0 === l && (l = !0);
                var u = {
                    faces: [],
                    verts: []
                }, c = t.materials;
                B.set(n, s, r), N.set(o, a, h), Y.fromRotationXYTranslation(N, B, l);
                for(var d = 0; d < t.models.length; d++)for(var f = t.models[d], p = f.vertices, g = f.textureCoords, v = f.faces, m = 0; m < v.length; m++){
                    var y = v[m], x = y.vertices[0], T = y.vertices[1], w = y.vertices[2], b = p[x.vertexIndex], E = p[T.vertexIndex], S = p[w.vertexIndex], A = x.textureCoordsIndex, _ = T.textureCoordsIndex, C = w.textureCoordsIndex, M = -1 === A ? {
                        u: 0,
                        v: 1
                    } : g[A], R = -1 === _ ? {
                        u: 0,
                        v: 0
                    } : g[_], P = -1 === C ? {
                        u: 1,
                        v: 1
                    } : g[C], O = 16777215;
                    "" !== y.material && c[y.material] && (O = c[y.material]);
                    var L = new I(b.x * i, b.y * i, b.z * i, M.u, M.v, O).transformMat4(Y), D = new I(E.x * i, E.y * i, E.z * i, R.u, R.v, O).transformMat4(Y), F = new I(S.x * i, S.y * i, S.z * i, P.u, P.v, O).transformMat4(Y);
                    u.verts.push(L, D, F), u.faces.push(new k(L, D, F));
                }
                return e && (e.faces = e.faces.concat(u.faces), e.vertices = e.vertices.concat(u.verts)), u;
            };
        },
        function(t, e, i) {
            var a = i(62), n = i(0), s = i(11), h = i(197), r = i(12), o = new n({
                Extends: a,
                Mixins: [
                    s.ScrollFactor,
                    s.Visible
                ],
                initialize: function(t, e, i, n, s, r, o) {
                    a.call(this, t, e, i), this.color = new h(n, s, r), this.intensity = o, this.renderFlags = 15, this.cameraFilter = 0, this.setScrollFactor(1, 1);
                },
                willRender: function(t) {
                    return !(o.RENDER_MASK !== this.renderFlags || 0 !== this.cameraFilter && this.cameraFilter & t.id);
                },
                setColor: function(t) {
                    var e = r.getFloatsFromUintRGB(t);
                    return this.color.set(e[0], e[1], e[2]), this;
                },
                setIntensity: function(t) {
                    return this.intensity = t, this;
                },
                setRadius: function(t) {
                    return this.radius = t, this;
                }
            });
            o.RENDER_MASK = 15, t.exports = o;
        },
        function(t, e, i) {
            var o = i(150), n = i(0), a = i(48), h = i(475), r = i(149), s = i(197), l = i(74), u = i(79), c = i(12), d = new n({
                initialize: function() {
                    this.lights = [], this.ambientColor = new s(.1, .1, .1), this.active = !1, this.maxLights = -1, this.visibleLights = 0;
                },
                addPointLight: function(t, e, i, n, s) {
                    return this.systems.displayList.add(new r(this.scene, t, e, i, n, s));
                },
                enable: function() {
                    return -1 === this.maxLights && (this.maxLights = this.scene.sys.renderer.config.maxLights), this.active = !0, this;
                },
                disable: function() {
                    return this.active = !1, this;
                },
                getLights: function(t) {
                    for(var e = this.lights, i = t.worldView, n = [], s = 0; s < e.length; s++){
                        var r = e[s];
                        r.willRender(t) && o(r, i) && n.push({
                            light: r,
                            distance: a(r.x, r.y, i.centerX, i.centerY)
                        });
                    }
                    return n.length > this.maxLights && (u(n, this.sortByDistance), n = n.slice(0, this.maxLights)), this.visibleLights = n.length, n;
                },
                sortByDistance: function(t, e) {
                    return t.distance >= e.distance;
                },
                setAmbientColor: function(t) {
                    var e = c.getFloatsFromUintRGB(t);
                    return this.ambientColor.set(e[0], e[1], e[2]), this;
                },
                getMaxVisibleLights: function() {
                    return this.maxLights;
                },
                getLightCount: function() {
                    return this.lights.length;
                },
                addLight: function(t, e, i, n, s) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 128), void 0 === n && (n = 16777215), void 0 === s && (s = 1);
                    var r = c.getFloatsFromUintRGB(n), o = new h(t, e, i, r[0], r[1], r[2], s);
                    return this.lights.push(o), o;
                },
                removeLight: function(t) {
                    var e = this.lights.indexOf(t);
                    return 0 <= e && l(this.lights, e), this;
                },
                shutdown: function() {
                    this.lights.length = 0;
                },
                destroy: function() {
                    this.shutdown();
                }
            });
            t.exports = d;
        },
        function(t, e, i) {
            var n = i(55), s = i(17)(!1, s = {
                Circle: i(1185),
                Ellipse: i(1195),
                Intersects: i(478),
                Line: i(1215),
                Mesh: i(1237),
                Point: i(1240),
                Polygon: i(1254),
                Rectangle: i(496),
                Triangle: i(1287)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            t.exports = {
                CircleToCircle: i(228),
                CircleToRectangle: i(150),
                GetCircleToCircle: i(1205),
                GetCircleToRectangle: i(1206),
                GetLineToCircle: i(229),
                GetLineToLine: i(479),
                GetLineToPoints: i(480),
                GetLineToPolygon: i(481),
                GetLineToRectangle: i(231),
                GetRaysFromPointToPolygon: i(1207),
                GetRectangleIntersection: i(1208),
                GetRectangleToRectangle: i(1209),
                GetRectangleToTriangle: i(1210),
                GetTriangleToCircle: i(1211),
                GetTriangleToLine: i(486),
                GetTriangleToTriangle: i(1212),
                LineToCircle: i(230),
                LineToLine: i(92),
                LineToRectangle: i(482),
                PointToLine: i(490),
                PointToLineSegment: i(1213),
                RectangleToRectangle: i(114),
                RectangleToTriangle: i(483),
                RectangleToValues: i(1214),
                TriangleToCircle: i(485),
                TriangleToLine: i(487),
                TriangleToTriangle: i(488)
            };
        },
        function(t, e, i) {
            var g = i(38);
            t.exports = function(t, e, i) {
                var n = t.x1, s = t.y1, r = t.x2, o = t.y2, a = e.x1, h = e.y1, l = r - n, u = o - s, c = e.x2 - a, d = e.y2 - h;
                if (0 == l || 0 == d * l - c * u) return !1;
                var f = (l * (h - s) + u * (n - a)) / (c * u - d * l), p = (a + c * f - n) / l;
                return p < 0 || f < 0 || 1 < f ? null : (void 0 === i && (i = new g), i.set(n + l * p, s + u * p, p));
            };
        },
        function(t, e, i) {
            var a = i(38), h = i(479), l = new (i(45)), u = new a;
            t.exports = function(t, e, i) {
                void 0 === i && (i = new a);
                var n = !1;
                i.set(), u.set();
                for(var s = e[0], r = 1; r < e.length; r++){
                    var o = e[r];
                    l.setTo(s.x, s.y, o.x, o.y), s = o, h(t, l, u) && (!n || u.z < i.z) && (i.copy(u), n = !0);
                }
                return n ? i : null;
            };
        },
        function(t, e, i) {
            var n = i(38), r = i(138), o = i(480), a = new n;
            t.exports = function(t, e, i) {
                void 0 === i && (i = new r), Array.isArray(e) || (e = [
                    e
                ]);
                var n = !1;
                i.set(), a.set();
                for(var s = 0; s < e.length; s++)o(t, e[s].points, a) && (!n || a.z < i.z) && (i.set(a.x, a.y, a.z, s), n = !0);
                return n ? i : null;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.x1, n = t.y1, s = t.x2, r = t.y2, o = e.x, a = e.y, h = e.right, l = e.bottom, u = 0;
                if (o <= i && i <= h && a <= n && n <= l || o <= s && s <= h && a <= r && r <= l) return !0;
                if (i < o && o <= s) {
                    if (a < (u = n + (r - n) * (o - i) / (s - i)) && u <= l) return !0;
                } else if (h < i && s <= h && a <= (u = n + (r - n) * (h - i) / (s - i)) && u <= l) return !0;
                if (n < a && a <= r) {
                    if (o <= (u = i + (s - i) * (a - n) / (r - n)) && u <= h) return !0;
                } else if (l < n && r <= l && o <= (u = i + (s - i) * (l - n) / (r - n)) && u <= h) return !0;
                return !1;
            };
        },
        function(t, e, i) {
            var u = i(92), c = i(56), d = i(232), f = i(484);
            t.exports = function(t, e) {
                if (e.left > t.right || e.right < t.left || e.top > t.bottom || e.bottom < t.top) return !1;
                var i = e.getLineA(), n = e.getLineB(), s = e.getLineC();
                if (c(t, i.x1, i.y1) || c(t, i.x2, i.y2)) return !0;
                if (c(t, n.x1, n.y1) || c(t, n.x2, n.y2)) return !0;
                if (c(t, s.x1, s.y1) || c(t, s.x2, s.y2)) return !0;
                var r = t.getLineA(), o = t.getLineB(), a = t.getLineC(), h = t.getLineD();
                if (u(i, r) || u(i, o) || u(i, a) || u(i, h)) return !0;
                if (u(n, r) || u(n, o) || u(n, a) || u(n, h)) return !0;
                if (u(s, r) || u(s, o) || u(s, a) || u(s, h)) return !0;
                var l = f(t);
                return 0 < d(e, l, !0).length;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = []), e.push({
                    x: t.x,
                    y: t.y
                }), e.push({
                    x: t.right,
                    y: t.y
                }), e.push({
                    x: t.right,
                    y: t.bottom
                }), e.push({
                    x: t.x,
                    y: t.bottom
                }), e;
            };
        },
        function(t, e, i) {
            var n = i(230), s = i(112);
            t.exports = function(t, e) {
                return !(t.left > e.right || t.right < e.left || t.top > e.bottom || t.bottom < e.top) && (!!s(t, e.x, e.y) || !!n(t.getLineA(), e) || !!n(t.getLineB(), e) || !!n(t.getLineC(), e));
            };
        },
        function(t, e, i) {
            var l = i(4), u = i(487), c = i(92);
            t.exports = function(t, e, i) {
                if (void 0 === i && (i = []), u(t, e)) for(var n = t.getLineA(), s = t.getLineB(), r = t.getLineC(), o = [
                    new l,
                    new l,
                    new l
                ], a = [
                    c(n, e, o[0]),
                    c(s, e, o[1]),
                    c(r, e, o[2])
                ], h = 0; h < 3; h++)a[h] && i.push(o[h]);
                return i;
            };
        },
        function(t, e, i) {
            var n = i(92);
            t.exports = function(t, e) {
                return !(!t.contains(e.x1, e.y1) && !t.contains(e.x2, e.y2)) || !!n(t.getLineA(), e) || !!n(t.getLineB(), e) || !!n(t.getLineC(), e);
            };
        },
        function(t, e, i) {
            var u = i(232), c = i(489), d = i(92);
            t.exports = function(t, e) {
                if (t.left > e.right || t.right < e.left || t.top > e.bottom || t.bottom < e.top) return !1;
                var i = t.getLineA(), n = t.getLineB(), s = t.getLineC(), r = e.getLineA(), o = e.getLineB(), a = e.getLineC();
                if (d(i, r) || d(i, o) || d(i, a)) return !0;
                if (d(n, r) || d(n, o) || d(n, a)) return !0;
                if (d(s, r) || d(s, o) || d(s, a)) return !0;
                var h = c(t), l = u(e, h, !0);
                return 0 < l.length || (h = c(e), 0 < u(t, h, !0).length);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = []), e.push({
                    x: t.x1,
                    y: t.y1
                }), e.push({
                    x: t.x2,
                    y: t.y2
                }), e.push({
                    x: t.x3,
                    y: t.y3
                }), e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === i && (i = 1);
                var n = e.x1, s = e.y1, r = e.x2, o = e.y2, a = t.x, h = t.y, l = (r - n) * (r - n) + (o - s) * (o - s);
                if (0 == l) return !1;
                var u = ((a - n) * (r - n) + (h - s) * (o - s)) / l;
                if (u < 0) return Math.sqrt((n - a) * (n - a) + (s - h) * (s - h)) <= i;
                if (0 <= u && u <= 1) {
                    var c = ((s - h) * (r - n) - (n - a) * (o - s)) / l;
                    return Math.abs(c) * Math.sqrt(l) <= i;
                }
                return Math.sqrt((r - a) * (r - a) + (o - h) * (o - h)) <= i;
            };
        },
        function(t, e, i) {
            var n = i(14), s = i(66), r = i(93);
            t.exports = function(t) {
                var e = r(t) - n.TAU;
                return s(e, -Math.PI, Math.PI);
            };
        },
        function(t, e) {
            var D = !0, F = "untitled", k = "", I = "";
            function B(t) {
                return 0 === t.models.length && t.models.push({
                    faces: [],
                    name: F,
                    textureCoords: [],
                    vertexNormals: [],
                    vertices: []
                }), k = "", t.models[t.models.length - 1];
            }
            t.exports = function(t, e) {
                void 0 === e && (e = !0), D = e;
                var i = {
                    materials: {},
                    materialLibraries: [],
                    models: []
                };
                I = k = "";
                for(var n, s, r, o, a, h, l, u, c, d, f, p, g, v, m, y, x, T, w, b, E, S, A, _, C, M, R, P = t.split("\n"), O = 0; O < P.length; O++){
                    var L = (M = P[O], R = void 0, -1 < (R = M.indexOf("#")) ? M.substring(0, R) : M).replace(/\s\s+/g, " ").trim().split(" ");
                    switch(L[0].toLowerCase()){
                        case "o":
                            _ = i, C = void 0, C = 2 <= (A = L).length ? A[1] : F, _.models.push({
                                faces: [],
                                name: C,
                                textureCoords: [],
                                vertexNormals: [],
                                vertices: []
                            }), k = "";
                            break;
                        case "g":
                            2 === (S = L).length && (k = S[1]);
                            break;
                        case "v":
                            x = i, E = b = w = T = void 0, T = (y = L).length, w = 2 <= T ? parseFloat(y[1]) : 0, b = 3 <= T ? parseFloat(y[2]) : 0, E = 4 <= T ? parseFloat(y[3]) : 0, B(x).vertices.push({
                                x: w,
                                y: b,
                                z: E
                            });
                            break;
                        case "vt":
                            f = i, m = v = g = p = void 0, p = (d = L).length, g = 2 <= p ? parseFloat(d[1]) : 0, v = 3 <= p ? parseFloat(d[2]) : 0, m = 4 <= p ? parseFloat(d[3]) : 0, isNaN(g) && (g = 0), isNaN(v) && (v = 0), isNaN(m) && (m = 0), D && (v = 1 - v), B(f).textureCoords.push({
                                u: g,
                                v: v,
                                w: m
                            });
                            break;
                        case "vn":
                            a = i, c = u = l = h = void 0, h = (o = L).length, l = 2 <= h ? parseFloat(o[1]) : 0, u = 3 <= h ? parseFloat(o[2]) : 0, c = 4 <= h ? parseFloat(o[3]) : 0, B(a).vertexNormals.push({
                                x: l,
                                y: u,
                                z: c
                            });
                            break;
                        case "f":
                            !function(t, e) {
                                var i = t.length - 1;
                                if (!(i < 3)) {
                                    for(var n = {
                                        group: k,
                                        material: I,
                                        vertices: []
                                    }, s = 0; s < i; s++){
                                        var r, o, a, h = t[s + 1].split("/"), l = h.length;
                                        l < 1 || 3 < l || (o = r = a = 0, a = parseInt(h[0], 10), 1 < l && "" !== h[1] && (r = parseInt(h[1], 10)), 2 < l && (o = parseInt(h[2], 10)), 0 !== a && (a < 0 && (a = B(e).vertices.length + 1 + a), --r, --a, --o, n.vertices.push({
                                            textureCoordsIndex: r,
                                            vertexIndex: a,
                                            vertexNormalIndex: o
                                        })));
                                    }
                                    B(e).faces.push(n);
                                }
                            }(L, i);
                            break;
                        case "mtllib":
                            r = i, 2 <= (s = L).length && r.materialLibraries.push(s[1]);
                            break;
                        case "usemtl":
                            2 <= (n = L).length && (I = n[1]);
                    }
                }
                return i;
            };
        },
        function(t, e, i) {
            var u = i(100);
            t.exports = function(t) {
                for(var e = {}, i = t.split("\n"), n = "", s = 0; s < i.length; s++){
                    var r = i[s].trim();
                    if (0 !== r.indexOf("#") && "" !== r) {
                        var o = r.replace(/\s\s+/g, " ").trim().split(" ");
                        switch(o[0].toLowerCase()){
                            case "newmtl":
                                n = o[1];
                                break;
                            case "kd":
                                var a = Math.floor(255 * o[1]), h = 2 <= o.length ? Math.floor(255 * o[2]) : a, l = 3 <= o.length ? Math.floor(255 * o[3]) : a;
                                e[n] = u(a, h, l);
                        }
                    }
                }
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.sqrt(t.x * t.x + t.y * t.y);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x * t.x + t.y * t.y;
            };
        },
        function(t, e, i) {
            var n = i(10);
            n.Area = i(1261), n.Ceil = i(1262), n.CeilAll = i(1263), n.CenterOn = i(187), n.Clone = i(1264), n.Contains = i(56), n.ContainsPoint = i(1265), n.ContainsRect = i(497), n.CopyFrom = i(1266), n.Decompose = i(484), n.Equals = i(1267), n.FitInside = i(1268), n.FitOutside = i(1269), n.Floor = i(1270), n.FloorAll = i(1271), n.FromPoints = i(196), n.FromXY = i(1272), n.GetAspectRatio = i(234), n.GetCenter = i(1273), n.GetPoint = i(167), n.GetPoints = i(300), n.GetSize = i(1274), n.Inflate = i(1275), n.Intersection = i(1276), n.MarchingAnts = i(310), n.MergePoints = i(1277), n.MergeRect = i(1278), n.MergeXY = i(1279), n.Offset = i(1280), n.OffsetPoint = i(1281), n.Overlaps = i(1282), n.Perimeter = i(128), n.PerimeterPoint = i(1283), n.Random = i(170), n.RandomOutside = i(1284), n.SameDimensions = i(1285), n.Scale = i(1286), n.Union = i(435), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return !(e.width * e.height > t.width * t.height) && e.x > t.x && e.x < t.right && e.right > t.x && e.right < t.right && e.y > t.y && e.y < t.bottom && e.bottom > t.y && e.bottom < t.bottom;
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = (t.x1 + t.x2 + t.x3) / 3, e.y = (t.y1 + t.y2 + t.y3) / 3, e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t.x1 += e, t.y1 += i, t.x2 += e, t.y2 += i, t.x3 += e, t.y3 += i, t;
            };
        },
        function(t, e, i) {
            var d = i(4);
            function f(t, e, i, n) {
                var s = t - i, r = e - n, o = s * s + r * r;
                return Math.sqrt(o);
            }
            t.exports = function(t, e) {
                void 0 === e && (e = new d);
                var i = t.x1, n = t.y1, s = t.x2, r = t.y2, o = t.x3, a = t.y3, h = f(o, a, s, r), l = f(i, n, o, a), u = f(s, r, i, n), c = h + l + u;
                return e.x = (i * h + s * l + o * u) / c, e.y = (n * h + r * l + a * u) / c, e;
            };
        },
        function(t, e) {
            t.exports = function(r, o) {
                return function(t, e, i, n) {
                    var s = r.getPixelAlpha(e, i, n.texture.key, n.frame.name);
                    return s && o <= s;
                };
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return {
                    gameObject: t,
                    enabled: !0,
                    alwaysEnabled: !1,
                    draggable: !1,
                    dropZone: !1,
                    cursor: !1,
                    target: null,
                    camera: null,
                    hitArea: e,
                    hitAreaCallback: i,
                    hitAreaDebug: null,
                    customHitArea: !1,
                    localX: 0,
                    localY: 0,
                    dragState: 0,
                    dragStartX: 0,
                    dragStartY: 0,
                    dragStartXGlobal: 0,
                    dragStartYGlobal: 0,
                    dragX: 0,
                    dragY: 0
                };
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e) {
                    this.pad = t, this.events = t.events, this.index = e, this.value = 0, this.threshold = .1;
                },
                update: function(t) {
                    this.value = t;
                },
                getValue: function() {
                    return Math.abs(this.value) < this.threshold ? 0 : this.value;
                },
                destroy: function() {
                    this.pad = null, this.events = null;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var n = i(0), s = i(236), r = new n({
                initialize: function(t, e) {
                    this.pad = t, this.events = t.manager, this.index = e, this.value = 0, this.threshold = 1, this.pressed = !1;
                },
                update: function(t) {
                    this.value = t;
                    var e = this.pad, i = this.index;
                    t >= this.threshold ? this.pressed || (this.pressed = !0, this.events.emit(s.BUTTON_DOWN, e, this, t), this.pad.emit(s.GAMEPAD_BUTTON_DOWN, i, t, this)) : this.pressed && (this.pressed = !1, this.events.emit(s.BUTTON_UP, e, this, t), this.pad.emit(s.GAMEPAD_BUTTON_UP, i, t, this));
                },
                destroy: function() {
                    this.pad = null, this.events = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var a = i(503), h = i(504), n = i(0), l = i(9), u = i(3), s = new n({
                Extends: l,
                initialize: function(t, e) {
                    l.call(this), this.manager = t, this.pad = e, this.id = e.id, this.index = e.index;
                    for(var i = [], n = 0; n < e.buttons.length; n++)i.push(new h(this, n));
                    this.buttons = i;
                    for(var s = [], n = 0; n < e.axes.length; n++)s.push(new a(this, n));
                    this.axes = s, this.vibration = e.vibrationActuator;
                    var r = {
                        value: 0,
                        pressed: !1
                    };
                    this._LCLeft = i[14] ? i[14] : r, this._LCRight = i[15] ? i[15] : r, this._LCTop = i[12] ? i[12] : r, this._LCBottom = i[13] ? i[13] : r, this._RCLeft = i[2] ? i[2] : r, this._RCRight = i[1] ? i[1] : r, this._RCTop = i[3] ? i[3] : r, this._RCBottom = i[0] ? i[0] : r, this._FBLeftTop = i[4] ? i[4] : r, this._FBLeftBottom = i[6] ? i[6] : r, this._FBRightTop = i[5] ? i[5] : r, this._FBRightBottom = i[7] ? i[7] : r;
                    var o = {
                        value: 0
                    };
                    this._HAxisLeft = s[0] ? s[0] : o, this._VAxisLeft = s[1] ? s[1] : o, this._HAxisRight = s[2] ? s[2] : o, this._VAxisRight = s[3] ? s[3] : o, this.leftStick = new u, this.rightStick = new u, this._created = performance.now();
                },
                getAxisTotal: function() {
                    return this.axes.length;
                },
                getAxisValue: function(t) {
                    return this.axes[t].getValue();
                },
                setAxisThreshold: function(t) {
                    for(var e = 0; e < this.axes.length; e++)this.axes[e].threshold = t;
                },
                getButtonTotal: function() {
                    return this.buttons.length;
                },
                getButtonValue: function(t) {
                    return this.buttons[t].value;
                },
                isButtonDown: function(t) {
                    return this.buttons[t].pressed;
                },
                update: function(t) {
                    if (!(t.timestamp < this._created)) {
                        for(var e = this.buttons, i = t.buttons, n = e.length, s = 0; s < n; s++)e[s].update(i[s].value);
                        var r = this.axes, o = t.axes, n = r.length;
                        for(s = 0; s < n; s++)r[s].update(o[s]);
                        2 <= n && (this.leftStick.set(r[0].getValue(), r[1].getValue()), 4 <= n && this.rightStick.set(r[2].getValue(), r[3].getValue()));
                    }
                },
                destroy: function() {
                    var t;
                    for(this.removeAllListeners(), this.manager = null, this.pad = null, t = 0; t < this.buttons.length; t++)this.buttons[t].destroy();
                    for(t = 0; t < this.axes.length; t++)this.axes[t].destroy();
                    this.buttons = [], this.axes = [];
                },
                connected: {
                    get: function() {
                        return this.pad.connected;
                    }
                },
                timestamp: {
                    get: function() {
                        return this.pad.timestamp;
                    }
                },
                left: {
                    get: function() {
                        return this._LCLeft.pressed;
                    }
                },
                right: {
                    get: function() {
                        return this._LCRight.pressed;
                    }
                },
                up: {
                    get: function() {
                        return this._LCTop.pressed;
                    }
                },
                down: {
                    get: function() {
                        return this._LCBottom.pressed;
                    }
                },
                A: {
                    get: function() {
                        return this._RCBottom.pressed;
                    }
                },
                Y: {
                    get: function() {
                        return this._RCTop.pressed;
                    }
                },
                X: {
                    get: function() {
                        return this._RCLeft.pressed;
                    }
                },
                B: {
                    get: function() {
                        return this._RCRight.pressed;
                    }
                },
                L1: {
                    get: function() {
                        return this._FBLeftTop.value;
                    }
                },
                L2: {
                    get: function() {
                        return this._FBLeftBottom.value;
                    }
                },
                R1: {
                    get: function() {
                        return this._FBRightTop.value;
                    }
                },
                R2: {
                    get: function() {
                        return this._FBRightBottom.value;
                    }
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(0), s = i(9), r = i(152), o = new n({
                Extends: s,
                initialize: function(t, e) {
                    s.call(this), this.plugin = t, this.keyCode = e, this.originalEvent = void 0, this.enabled = !0, this.isDown = !1, this.isUp = !0, this.altKey = !1, this.ctrlKey = !1, this.shiftKey = !1, this.metaKey = !1, this.location = 0, this.timeDown = 0, this.duration = 0, this.timeUp = 0, this.emitOnRepeat = !1, this.repeats = 0, this._justDown = !1, this._justUp = !1, this._tick = -1;
                },
                setEmitOnRepeat: function(t) {
                    return this.emitOnRepeat = t, this;
                },
                onDown: function(t) {
                    this.originalEvent = t, this.enabled && (this.altKey = t.altKey, this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.metaKey = t.metaKey, this.location = t.location, this.repeats++, this.isDown ? this.emitOnRepeat && this.emit(r.DOWN, this, t) : (this.isDown = !0, this.isUp = !1, this.timeDown = t.timeStamp, this.duration = 0, this._justDown = !0, this._justUp = !1, this.emit(r.DOWN, this, t)));
                },
                onUp: function(t) {
                    this.originalEvent = t, this.enabled && (this.isDown = !1, this.isUp = !0, this.timeUp = t.timeStamp, this.duration = this.timeUp - this.timeDown, this.repeats = 0, this._justDown = !1, this._justUp = !0, this._tick = -1, this.emit(r.UP, this, t));
                },
                reset: function() {
                    return this.preventDefault = !0, this.enabled = !0, this.isDown = !1, this.isUp = !0, this.altKey = !1, this.ctrlKey = !1, this.shiftKey = !1, this.metaKey = !1, this.timeDown = 0, this.duration = 0, this.timeUp = 0, this.repeats = 0, this._justDown = !1, this._justUp = !1, this._tick = -1, this;
                },
                getDuration: function() {
                    return this.isDown ? this.plugin.game.loop.time - this.timeDown : 0;
                },
                destroy: function() {
                    this.removeAllListeners(), this.originalEvent = null, this.plugin = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), o = i(152), a = i(2), h = i(508), l = i(510), s = new n({
                initialize: function(t, e, i) {
                    if (void 0 === i && (i = {}), e.length < 2) return !1;
                    this.manager = t, this.enabled = !0, this.keyCodes = [];
                    for(var n = 0; n < e.length; n++){
                        var s = e[n];
                        "string" == typeof s ? this.keyCodes.push(s.toUpperCase().charCodeAt(0)) : "number" == typeof s ? this.keyCodes.push(s) : s.hasOwnProperty("keyCode") && this.keyCodes.push(s.keyCode);
                    }
                    this.current = this.keyCodes[0], this.index = 0, this.size = this.keyCodes.length, this.timeLastMatched = 0, this.matched = !1, this.timeMatched = 0, this.resetOnWrongKey = a(i, "resetOnWrongKey", !0), this.maxKeyDelay = a(i, "maxKeyDelay", 0), this.resetOnMatch = a(i, "resetOnMatch", !1), this.deleteOnMatch = a(i, "deleteOnMatch", !1);
                    var r = this;
                    this.onKeyDown = function(t) {
                        !r.matched && r.enabled && h(t, r) && (r.manager.emit(o.COMBO_MATCH, r, t), r.resetOnMatch ? l(r) : r.deleteOnMatch && r.destroy());
                    }, this.manager.on(o.ANY_KEY_DOWN, this.onKeyDown);
                },
                progress: {
                    get: function() {
                        return this.index / this.size;
                    }
                },
                destroy: function() {
                    this.enabled = !1, this.keyCodes = [], this.manager.off(o.ANY_KEY_DOWN, this.onKeyDown), this.manager = null;
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var r = i(509);
            t.exports = function(t, e) {
                if (e.matched) return !0;
                var i, n = !1, s = !1;
                return t.keyCode === e.current && (0 < e.index && 0 < e.maxKeyDelay ? (i = e.timeLastMatched + e.maxKeyDelay, t.timeStamp <= i && (s = !0, n = r(t, e))) : (s = !0, n = r(t, e))), !s && e.resetOnWrongKey && (e.index = 0, e.current = e.keyCodes[0]), n && (e.timeLastMatched = t.timeStamp, e.matched = !0, e.timeMatched = t.timeStamp), n;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.timeLastMatched = t.timeStamp, e.index++, e.index === e.size || (e.current = e.keyCodes[e.index], !1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.current = t.keyCodes[0], t.index = 0, t.timeLastMatched = 0, t.matched = !1, t.timeMatched = 0, t;
            };
        },
        function(t, e, i) {
            var r = i(237);
            t.exports = function(t, e) {
                var i = r(e, t.xhrSettings), n = new XMLHttpRequest;
                if (n.open("GET", t.src, i.async, i.user, i.password), n.responseType = t.xhrSettings.responseType, n.timeout = i.timeout, i.headers) for(var s in i.headers)n.setRequestHeader(s, i.headers[s]);
                return i.header && i.headerValue && n.setRequestHeader(i.header, i.headerValue), i.requestedWith && n.setRequestHeader("X-Requested-With", i.requestedWith), i.overrideMimeType && n.overrideMimeType(i.overrideMimeType), i.withCredentials && (n.withCredentials = !0), n.onload = t.onLoad.bind(t, n), n.onerror = t.onError.bind(t, n), n.onprogress = t.onProgress.bind(t), n.send(), n;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), l = i(2), u = i(513), c = i(7), d = new n({
                Extends: a,
                initialize: function(t, e, i, n, s) {
                    var r;
                    c(e) && (e = l(r = e, "key"), n = l(r, "xhrSettings"), s = l(r, "context", s));
                    var o = {
                        type: "audio",
                        cache: t.cacheManager.audio,
                        extension: i.type,
                        responseType: "arraybuffer",
                        key: e,
                        url: i.url,
                        xhrSettings: n,
                        config: {
                            context: s
                        }
                    };
                    a.call(this, t, o);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING;
                    var e = this;
                    this.config.context.decodeAudioData(this.xhrLoader.response, function(t) {
                        e.data = t, e.onProcessComplete();
                    }, function(t) {
                        console.error("Error decoding audio: " + e.key + " - ", t ? t.message : null), e.onProcessError();
                    }), this.config.context = null;
                }
            });
            d.create = function(t, e, i, n, s) {
                var r = t.systems.game, o = r.config.audio, a = r.device.audio;
                c(e) && (i = l(e, "url", []), n = l(e, "config", {}));
                var h = d.getAudioURL(r, i);
                return h ? a.webAudio && !o.disableWebAudio ? new d(t, e, h, s, r.sound.context) : new u(t, e, h, n) : null;
            }, d.getAudioURL = function(t, e) {
                Array.isArray(e) || (e = [
                    e
                ]);
                for(var i = 0; i < e.length; i++){
                    var n = l(e[i], "url", e[i]);
                    if (0 === n.indexOf("blob:") || 0 === n.indexOf("data:")) return {
                        url: n,
                        type: ""
                    };
                    var s = n.match(/\.([a-zA-Z0-9]+)($|\?)/), s = l(e[i], "type", s ? s[1] : "").toLowerCase();
                    if (t.device.audio[s]) return {
                        url: n,
                        type: s
                    };
                }
                return null;
            }, r.register("audio", function(t, e, i, n) {
                var s, r = this.systems.game, o = r.config.audio, a = r.device.audio;
                if (o.noAudio || !a.webAudio && !a.audioData) return this;
                if (Array.isArray(t)) for(var h = 0; h < t.length; h++)(s = d.create(this, t[h])) && this.addFile(s);
                else (s = d.create(this, t, e, i, n)) && this.addFile(s);
                return this;
            }), t.exports = d;
        },
        function(t, e, i) {
            var n = i(0), s = i(91), o = i(23), a = i(2), r = i(153), h = i(7), l = new n({
                Extends: o,
                initialize: function(t, e, i, n) {
                    var s;
                    h(e) && (e = a(s = e, "key"), n = a(s, "config", n));
                    var r = {
                        type: "audio",
                        cache: t.cacheManager.audio,
                        extension: i.type,
                        key: e,
                        url: i.url,
                        config: n
                    };
                    o.call(this, t, r), this.locked = "ontouchstart" in window, this.loaded = !1, this.filesLoaded = 0, this.filesTotal = 0;
                },
                onLoad: function() {
                    this.loaded || (this.loaded = !0, this.loader.nextFile(this, !0));
                },
                onError: function() {
                    for(var t = 0; t < this.data.length; t++){
                        var e = this.data[t];
                        e.oncanplaythrough = null, e.onerror = null;
                    }
                    this.loader.nextFile(this, !1);
                },
                onProgress: function(t) {
                    var e = t.target;
                    e.oncanplaythrough = null, e.onerror = null, this.filesLoaded++, this.percentComplete = Math.min(this.filesLoaded / this.filesTotal, 1), this.loader.emit(s.FILE_PROGRESS, this, this.percentComplete), this.filesLoaded === this.filesTotal && this.onLoad();
                },
                load: function() {
                    this.data = [];
                    var t = this.config && this.config.instances || 1;
                    this.filesTotal = t, this.filesLoaded = 0;
                    for(var e = this.percentComplete = 0; e < t; e++){
                        var i = new Audio;
                        i.dataset || (i.dataset = {}), i.dataset.name = this.key + ("0" + e).slice(-2), i.dataset.used = "false", this.locked ? i.dataset.locked = "true" : (i.dataset.locked = "false", i.preload = "auto", i.oncanplaythrough = this.onProgress.bind(this), i.onerror = this.onError.bind(this)), this.data.push(i);
                    }
                    for(e = 0; e < this.data.length; e++)(i = this.data[e]).src = r(this, this.loader.baseURL), this.locked || i.load();
                    this.locked && setTimeout(this.onLoad.bind(this));
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), h = i(2), l = i(7), o = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    var s, r = "js";
                    l(e) && (e = h(s = e, "key"), i = h(s, "url"), n = h(s, "xhrSettings"), r = h(s, "extension", r));
                    var o = {
                        type: "script",
                        cache: !1,
                        extension: r,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    a.call(this, t, o);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = document.createElement("script"), this.data.language = "javascript", this.data.type = "text/javascript", this.data.defer = !1, this.data.text = this.xhrLoader.responseText, document.head.appendChild(this.data), this.onProcessComplete();
                }
            });
            r.register("script", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var r = i(516), o = i(155), n = i(0), a = i(60), s = i(518), h = i(519), l = new n({
                initialize: function(t) {
                    this.world = t, this.scene = t.scene, this.sys = t.scene.sys;
                },
                collider: function(t, e, i, n, s) {
                    return this.world.addCollider(t, e, i, n, s);
                },
                overlap: function(t, e, i, n, s) {
                    return this.world.addOverlap(t, e, i, n, s);
                },
                existing: function(t, e) {
                    var i = e ? a.STATIC_BODY : a.DYNAMIC_BODY;
                    return this.world.enableBody(t, i), t;
                },
                staticImage: function(t, e, i, n) {
                    var s = new r(this.scene, t, e, i, n);
                    return this.sys.displayList.add(s), this.world.enableBody(s, a.STATIC_BODY), s;
                },
                image: function(t, e, i, n) {
                    var s = new r(this.scene, t, e, i, n);
                    return this.sys.displayList.add(s), this.world.enableBody(s, a.DYNAMIC_BODY), s;
                },
                staticSprite: function(t, e, i, n) {
                    var s = new o(this.scene, t, e, i, n);
                    return this.sys.displayList.add(s), this.sys.updateList.add(s), this.world.enableBody(s, a.STATIC_BODY), s;
                },
                sprite: function(t, e, i, n) {
                    var s = new o(this.scene, t, e, i, n);
                    return this.sys.displayList.add(s), this.sys.updateList.add(s), this.world.enableBody(s, a.DYNAMIC_BODY), s;
                },
                staticGroup: function(t, e) {
                    return this.sys.updateList.add(new h(this.world, this.world.scene, t, e));
                },
                group: function(t, e) {
                    return this.sys.updateList.add(new s(this.world, this.world.scene, t, e));
                },
                destroy: function() {
                    this.world = null, this.scene = null, this.sys = null;
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            var n = i(0), s = i(240), r = i(124), o = new n({
                Extends: r,
                Mixins: [
                    s.Acceleration,
                    s.Angular,
                    s.Bounce,
                    s.Debug,
                    s.Drag,
                    s.Enable,
                    s.Friction,
                    s.Gravity,
                    s.Immovable,
                    s.Mass,
                    s.Pushable,
                    s.Size,
                    s.Velocity
                ],
                initialize: function(t, e, i, n, s) {
                    r.call(this, t, e, i, n, s), this.body = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var d = i(241), f = i(62), p = i(228), g = i(150);
            t.exports = function(t, e, i, n, s, r) {
                var o = d(t, e - n, i - n, 2 * n, 2 * n, s, r);
                if (0 === o.length) return o;
                for(var a = new f(e, i, n), h = new f, l = [], u = 0; u < o.length; u++){
                    var c = o[u];
                    c.isCircle ? (h.setTo(c.center.x, c.center.y, c.halfWidth), p(a, h) && l.push(c)) : g(a, c) && l.push(c);
                }
                return l;
            };
        },
        function(t, e, i) {
            var r = i(155), n = i(0), o = i(60), a = i(2), h = i(110), l = i(7), s = new n({
                Extends: h,
                initialize: function(t, e, i, n) {
                    var s;
                    i || n ? l(i) ? (n = i, i = null, n.internalCreateCallback = this.createCallbackHandler, n.internalRemoveCallback = this.removeCallbackHandler) : Array.isArray(i) && l(i[0]) ? (n = i[0], s = this, i.forEach(function(t) {
                        t.internalCreateCallback = s.createCallbackHandler, t.internalRemoveCallback = s.removeCallbackHandler;
                    }), i = null) : n = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    } : n = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    }, this.world = t, n.classType = a(n, "classType", r), this.physicsType = o.DYNAMIC_BODY, this.defaults = {
                        setCollideWorldBounds: a(n, "collideWorldBounds", !1),
                        setBoundsRectangle: a(n, "customBoundsRectangle", null),
                        setAccelerationX: a(n, "accelerationX", 0),
                        setAccelerationY: a(n, "accelerationY", 0),
                        setAllowDrag: a(n, "allowDrag", !0),
                        setAllowGravity: a(n, "allowGravity", !0),
                        setAllowRotation: a(n, "allowRotation", !0),
                        setBounceX: a(n, "bounceX", 0),
                        setBounceY: a(n, "bounceY", 0),
                        setDragX: a(n, "dragX", 0),
                        setDragY: a(n, "dragY", 0),
                        setEnable: a(n, "enable", !0),
                        setGravityX: a(n, "gravityX", 0),
                        setGravityY: a(n, "gravityY", 0),
                        setFrictionX: a(n, "frictionX", 0),
                        setFrictionY: a(n, "frictionY", 0),
                        setMaxVelocityX: a(n, "maxVelocityX", 1e4),
                        setMaxVelocityY: a(n, "maxVelocityY", 1e4),
                        setVelocityX: a(n, "velocityX", 0),
                        setVelocityY: a(n, "velocityY", 0),
                        setAngularVelocity: a(n, "angularVelocity", 0),
                        setAngularAcceleration: a(n, "angularAcceleration", 0),
                        setAngularDrag: a(n, "angularDrag", 0),
                        setMass: a(n, "mass", 1),
                        setImmovable: a(n, "immovable", !1)
                    }, h.call(this, e, i, n), this.type = "PhysicsGroup";
                },
                createCallbackHandler: function(t) {
                    t.body || this.world.enableBody(t, o.DYNAMIC_BODY);
                    var e = t.body;
                    for(var i in this.defaults)e[i](this.defaults[i]);
                },
                removeCallbackHandler: function(t) {
                    t.body && this.world.disableBody(t);
                },
                setVelocity: function(t, e, i) {
                    void 0 === i && (i = 0);
                    for(var n = this.getChildren(), s = 0; s < n.length; s++)n[s].body.velocity.set(t + s * i, e + s * i);
                    return this;
                },
                setVelocityX: function(t, e) {
                    void 0 === e && (e = 0);
                    for(var i = this.getChildren(), n = 0; n < i.length; n++)i[n].body.velocity.x = t + n * e;
                    return this;
                },
                setVelocityY: function(t, e) {
                    void 0 === e && (e = 0);
                    for(var i = this.getChildren(), n = 0; n < i.length; n++)i[n].body.velocity.y = t + n * e;
                    return this;
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var s = i(155), n = i(0), r = i(60), o = i(2), a = i(110), h = i(7), l = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    i || n ? h(i) ? (n = i, i = null, n.internalCreateCallback = this.createCallbackHandler, n.internalRemoveCallback = this.removeCallbackHandler, n.createMultipleCallback = this.createMultipleCallbackHandler, n.classType = o(n, "classType", s)) : Array.isArray(i) && h(i[0]) ? (n = i, i = null, n.forEach(function(t) {
                        t.internalCreateCallback = this.createCallbackHandler, t.internalRemoveCallback = this.removeCallbackHandler, t.createMultipleCallback = this.createMultipleCallbackHandler, t.classType = o(t, "classType", s);
                    })) : n = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    } : n = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler,
                        createMultipleCallback: this.createMultipleCallbackHandler,
                        classType: s
                    }, this.world = t, this.physicsType = r.STATIC_BODY, a.call(this, e, i, n), this.type = "StaticPhysicsGroup";
                },
                createCallbackHandler: function(t) {
                    t.body || this.world.enableBody(t, r.STATIC_BODY);
                },
                removeCallbackHandler: function(t) {
                    t.body && this.world.disableBody(t);
                },
                createMultipleCallbackHandler: function() {
                    this.refresh();
                },
                refresh: function() {
                    for(var t = this.children.entries, e = 0; e < t.length; e++)t[e].body.reset();
                    return this;
                }
            });
            t.exports = l;
        },
        function(t, e, i) {
            var v = i(344), n = i(521), p = i(18), s = i(0), o = i(522), g = i(60), m = i(48), r = i(9), y = i(242), x = i(123), T = i(348), w = i(349), b = i(243), E = i(244), S = i(523), a = i(6), A = i(14), h = i(208), _ = i(524), l = i(10), u = i(525), C = i(526), M = i(531), R = i(532), c = i(148), d = i(533), P = i(245), f = i(25), O = i(3), L = i(66), D = new s({
                Extends: r,
                initialize: function(t, e) {
                    r.call(this), this.scene = t, this.bodies = new c, this.staticBodies = new c, this.pendingDestroy = new c, this.colliders = new h, this.gravity = new O(a(e, "gravity.x", 0), a(e, "gravity.y", 0)), this.bounds = new l(a(e, "x", 0), a(e, "y", 0), a(e, "width", t.sys.scale.width), a(e, "height", t.sys.scale.height)), this.checkCollision = {
                        up: a(e, "checkCollision.up", !0),
                        down: a(e, "checkCollision.down", !0),
                        left: a(e, "checkCollision.left", !0),
                        right: a(e, "checkCollision.right", !0)
                    }, this.fps = a(e, "fps", 60), this.fixedStep = a(e, "fixedStep", !0), this._elapsed = 0, this._frameTime = 1 / this.fps, this._frameTimeMS = 1e3 * this._frameTime, this.stepsLastFrame = 0, this.timeScale = a(e, "timeScale", 1), this.OVERLAP_BIAS = a(e, "overlapBias", 4), this.TILE_BIAS = a(e, "tileBias", 16), this.forceX = a(e, "forceX", !1), this.isPaused = a(e, "isPaused", !1), this._total = 0, this.drawDebug = a(e, "debug", !1), this.debugGraphic, this.defaults = {
                        debugShowBody: a(e, "debugShowBody", !0),
                        debugShowStaticBody: a(e, "debugShowStaticBody", !0),
                        debugShowVelocity: a(e, "debugShowVelocity", !0),
                        bodyDebugColor: a(e, "debugBodyColor", 16711935),
                        staticBodyDebugColor: a(e, "debugStaticBodyColor", 255),
                        velocityDebugColor: a(e, "debugVelocityColor", 65280)
                    }, this.maxEntries = a(e, "maxEntries", 16), this.useTree = a(e, "useTree", !0), this.tree = new u(this.maxEntries), this.staticTree = new u(this.maxEntries), this.treeMinMax = {
                        minX: 0,
                        minY: 0,
                        maxX: 0,
                        maxY: 0
                    }, this._tempMatrix = new f, this._tempMatrix2 = new f, this.drawDebug && this.createDebugGraphic();
                },
                enable: function(t, e) {
                    void 0 === e && (e = g.DYNAMIC_BODY), Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        if (n.isParent) for(var s = n.getChildren(), r = 0; r < s.length; r++){
                            var o = s[r];
                            o.isParent ? this.enable(o, e) : this.enableBody(o, e);
                        }
                        else this.enableBody(n, e);
                    }
                },
                enableBody: function(t, e) {
                    return void 0 === e && (e = g.DYNAMIC_BODY), t.body || (e === g.DYNAMIC_BODY ? t.body = new n(this, t) : e === g.STATIC_BODY && (t.body = new d(this, t))), this.add(t.body), t;
                },
                add: function(t) {
                    return t.physicsType === g.DYNAMIC_BODY ? this.bodies.set(t) : t.physicsType === g.STATIC_BODY && (this.staticBodies.set(t), this.staticTree.insert(t)), t.enable = !0, t;
                },
                disable: function(t) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = 0; e < t.length; e++){
                        var i = t[e];
                        if (i.isParent) for(var n = i.getChildren(), s = 0; s < n.length; s++){
                            var r = n[s];
                            r.isParent ? this.disable(r) : this.disableBody(r.body);
                        }
                        else this.disableBody(i.body);
                    }
                },
                disableBody: function(t) {
                    this.remove(t), t.enable = !1;
                },
                remove: function(t) {
                    t.physicsType === g.DYNAMIC_BODY ? (this.tree.remove(t), this.bodies.delete(t)) : t.physicsType === g.STATIC_BODY && (this.staticBodies.delete(t), this.staticTree.remove(t));
                },
                createDebugGraphic: function() {
                    var t = this.scene.sys.add.graphics({
                        x: 0,
                        y: 0
                    });
                    return t.setDepth(Number.MAX_VALUE), this.debugGraphic = t, this.drawDebug = !0, t;
                },
                setBounds: function(t, e, i, n, s, r, o, a) {
                    return this.bounds.setTo(t, e, i, n), void 0 !== s && this.setBoundsCollision(s, r, o, a), this;
                },
                setBoundsCollision: function(t, e, i, n) {
                    return void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === n && (n = !0), this.checkCollision.left = t, this.checkCollision.right = e, this.checkCollision.up = i, this.checkCollision.down = n, this;
                },
                pause: function() {
                    return this.isPaused = !0, this.emit(y.PAUSE), this;
                },
                resume: function() {
                    return this.isPaused = !1, this.emit(y.RESUME), this;
                },
                addCollider: function(t, e, i, n, s) {
                    void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i);
                    var r = new o(this, !1, t, e, i, n, s);
                    return this.colliders.add(r), r;
                },
                addOverlap: function(t, e, i, n, s) {
                    void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i);
                    var r = new o(this, !0, t, e, i, n, s);
                    return this.colliders.add(r), r;
                },
                removeCollider: function(t) {
                    return this.colliders.remove(t), this;
                },
                setFPS: function(t) {
                    return this.fps = t, this._frameTime = 1 / this.fps, this._frameTimeMS = 1e3 * this._frameTime, this;
                },
                update: function(t, e) {
                    if (!this.isPaused && 0 !== this.bodies.size) {
                        var i, n = this._frameTime, s = this._frameTimeMS * this.timeScale;
                        this._elapsed += e;
                        var r = this.bodies.entries, o = this._elapsed >= s;
                        for(this.fixedStep || (n = .001 * e, o = !0, this._elapsed = 0), h = 0; h < r.length; h++)(i = r[h]).enable && i.preUpdate(o, n);
                        if (o) {
                            this._elapsed -= s, this.stepsLastFrame = 1, this.useTree && (this.tree.clear(), this.tree.load(r));
                            for(var a = this.colliders.update(), h = 0; h < a.length; h++){
                                var l = a[h];
                                l.active && l.update();
                            }
                            this.emit(y.WORLD_STEP, n);
                        }
                        for(; this._elapsed >= s;)this._elapsed -= s, this.step(n);
                    }
                },
                step: function(t) {
                    for(var e, i = this.bodies.entries, n = i.length, s = 0; s < n; s++)(e = i[s]).enable && e.update(t);
                    this.useTree && (this.tree.clear(), this.tree.load(i));
                    var r = this.colliders.update();
                    for(s = 0; s < r.length; s++){
                        var o = r[s];
                        o.active && o.update();
                    }
                    this.emit(y.WORLD_STEP, t), this.stepsLastFrame++;
                },
                postUpdate: function() {
                    var t, e = (o = this.bodies.entries).length, i = this.bodies, n = this.staticBodies;
                    if (this.stepsLastFrame) for(l = this.stepsLastFrame = 0; l < e; l++)(t = o[l]).enable && t.postUpdate();
                    if (this.drawDebug) {
                        var s = this.debugGraphic;
                        for(s.clear(), l = 0; l < e; l++)(t = o[l]).willDrawDebug() && t.drawDebug(s);
                        for(e = (o = n.entries).length, l = 0; l < e; l++)(t = o[l]).willDrawDebug() && t.drawDebug(s);
                    }
                    var r = this.pendingDestroy;
                    if (0 < r.size) {
                        for(var o, a = this.tree, h = this.staticTree, e = (o = r.entries).length, l = 0; l < e; l++)(t = o[l]).physicsType === g.DYNAMIC_BODY ? (a.remove(t), i.delete(t)) : t.physicsType === g.STATIC_BODY && (h.remove(t), n.delete(t)), t.world = void 0, t.gameObject = void 0;
                        r.clear();
                    }
                },
                updateMotion: function(t, e) {
                    t.allowRotation && this.computeAngularVelocity(t, e), this.computeVelocity(t, e);
                },
                computeAngularVelocity: function(t, e) {
                    var i = t.angularVelocity, n = t.angularAcceleration, s = t.angularDrag, r = t.maxAngular;
                    n ? i += n * e : t.allowDrag && s && (T(i - (s *= e), 0, .1) ? i -= s : w(i + s, 0, .1) ? i += s : i = 0);
                    var o = (i = p(i, -r, r)) - t.angularVelocity;
                    t.angularVelocity += o, t.rotation += t.angularVelocity * e;
                },
                computeVelocity: function(t, e) {
                    var i = t.velocity.x, n = t.acceleration.x, s = t.drag.x, r = t.maxVelocity.x, o = t.velocity.y, a = t.acceleration.y, h = t.drag.y, l = t.maxVelocity.y, u = t.speed, c = t.maxSpeed, d = t.allowDrag, f = t.useDamping;
                    t.allowGravity && (i += (this.gravity.x + t.gravity.x) * e, o += (this.gravity.y + t.gravity.y) * e), n ? i += n * e : d && s && (f ? (i *= s = Math.pow(s, e), u = Math.sqrt(i * i + o * o), x(u, 0, .001) && (i = 0)) : T(i - (s *= e), 0, .01) ? i -= s : w(i + s, 0, .01) ? i += s : i = 0), a ? o += a * e : d && h && (f ? (o *= h = Math.pow(h, e), u = Math.sqrt(i * i + o * o), x(u, 0, .001) && (o = 0)) : T(o - (h *= e), 0, .01) ? o -= h : w(o + h, 0, .01) ? o += h : o = 0), i = p(i, -r, r), o = p(o, -l, l), t.velocity.set(i, o), -1 < c && c < u && (t.velocity.normalize().scale(c), u = c), t.speed = u;
                },
                separate: function(t, e, i, n, s, r) {
                    if (!r && !t.enable || !e.enable || t.checkCollision.none || e.checkCollision.none || !this.intersects(t, e)) return !1;
                    if (i && !1 === i.call(n, t.gameObject, e.gameObject)) return !1;
                    if (t.isCircle && e.isCircle) return this.separateCircle(t, e, s);
                    if (t.isCircle !== e.isCircle) {
                        var o = t.isCircle ? e : t, a = t.isCircle ? t : e, h = o.x, l = o.y, u = o.right, c = o.bottom, d = a.center;
                        if ((d.y < l || d.y > c) && (d.x < h || d.x > u)) return this.separateCircle(t, e, s);
                    }
                    var f = !1, p = !1;
                    s ? (f = M(t, e, s, this.OVERLAP_BIAS), p = R(t, e, s, this.OVERLAP_BIAS)) : this.forceX || Math.abs(this.gravity.y + t.gravity.y) < Math.abs(this.gravity.x + t.gravity.x) ? (f = M(t, e, s, this.OVERLAP_BIAS), this.intersects(t, e) && (p = R(t, e, s, this.OVERLAP_BIAS))) : (p = R(t, e, s, this.OVERLAP_BIAS), this.intersects(t, e) && (f = M(t, e, s, this.OVERLAP_BIAS)));
                    var g = f || p;
                    return g && (s ? (t.onOverlap || e.onOverlap) && this.emit(y.OVERLAP, t.gameObject, e.gameObject, t, e) : (t.onCollide || e.onCollide) && this.emit(y.COLLIDE, t.gameObject, e.gameObject, t, e)), g;
                },
                separateCircle: function(t, e, i, n) {
                    b(t, e, !1, n), E(t, e, !1, n);
                    var s, r, o = 0;
                    if (t.isCircle !== e.isCircle ? (s = {
                        x: e.isCircle ? t.position.x : e.position.x,
                        y: e.isCircle ? t.position.y : e.position.y,
                        right: e.isCircle ? t.right : e.right,
                        bottom: e.isCircle ? t.bottom : e.bottom
                    }, (r = {
                        x: t.isCircle ? t.center.x : e.center.x,
                        y: t.isCircle ? t.center.y : e.center.y,
                        radius: t.isCircle ? t.halfWidth : e.halfWidth
                    }).y < s.y ? r.x < s.x ? o = m(r.x, r.y, s.x, s.y) - r.radius : s.right < r.x && (o = m(r.x, r.y, s.right, s.y) - r.radius) : s.bottom < r.y && (r.x < s.x ? o = m(r.x, r.y, s.x, s.bottom) - r.radius : s.right < r.x && (o = m(r.x, r.y, s.right, s.bottom) - r.radius)), o *= -1) : o = t.halfWidth + e.halfWidth - m(t.center.x, t.center.y, e.center.x, e.center.y), t.overlapR = o, e.overlapR = o, i || 0 === o || t.immovable && e.immovable || t.customSeparateX || e.customSeparateX) return 0 !== o && (t.onOverlap || e.onOverlap) && this.emit(y.OVERLAP, t.gameObject, e.gameObject, t, e), 0 !== o;
                    var a = t.center.x - e.center.x, h = t.center.y - e.center.y, l = Math.sqrt(Math.pow(a, 2) + Math.pow(h, 2)), u = (e.center.x - t.center.x) / l || 0, c = (e.center.y - t.center.y) / l || 0, d = 2 * (t.velocity.x * u + t.velocity.y * c - e.velocity.x * u - e.velocity.y * c) / (t.mass + e.mass);
                    (t.immovable || e.immovable) && (d *= 2), t.immovable || (t.velocity.x = t.velocity.x - d / t.mass * u, t.velocity.y = t.velocity.y - d / t.mass * c), e.immovable || (e.velocity.x = e.velocity.x + d / e.mass * u, e.velocity.y = e.velocity.y + d / e.mass * c), t.immovable || e.immovable || (o /= 2);
                    var f = v(t.center, e.center), p = (o + A.EPSILON) * Math.cos(f), g = (o + A.EPSILON) * Math.sin(f);
                    return t.immovable || (t.x -= p, t.y -= g, t.updateCenter()), e.immovable || (e.x += p, e.y += g, e.updateCenter()), t.velocity.x *= t.bounce.x, t.velocity.y *= t.bounce.y, e.velocity.x *= e.bounce.x, e.velocity.y *= e.bounce.y, (t.onCollide || e.onCollide) && this.emit(y.COLLIDE, t.gameObject, e.gameObject, t, e), !0;
                },
                intersects: function(t, e) {
                    return t !== e && (t.isCircle || e.isCircle ? t.isCircle ? e.isCircle ? m(t.center.x, t.center.y, e.center.x, e.center.y) <= t.halfWidth + e.halfWidth : this.circleBodyIntersects(t, e) : this.circleBodyIntersects(e, t) : !(t.right <= e.position.x || t.bottom <= e.position.y || t.position.x >= e.right || t.position.y >= e.bottom));
                },
                circleBodyIntersects: function(t, e) {
                    var i = p(t.center.x, e.left, e.right), n = p(t.center.y, e.top, e.bottom);
                    return (t.center.x - i) * (t.center.x - i) + (t.center.y - n) * (t.center.y - n) <= t.halfWidth * t.halfWidth;
                },
                overlap: function(t, e, i, n, s) {
                    return void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i), this.collideObjects(t, e, i, n, s, !0);
                },
                collide: function(t, e, i, n, s) {
                    return void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i), this.collideObjects(t, e, i, n, s, !1);
                },
                collideObjects: function(t, e, i, n, s, r) {
                    var o;
                    t.isParent && void 0 === t.physicsType && (t = t.children.entries), e && e.isParent && void 0 === e.physicsType && (e = e.children.entries);
                    var a = Array.isArray(t), h = Array.isArray(e);
                    if (this._total = 0, a || h) {
                        if (!a && h) for(o = 0; o < e.length; o++)this.collideHandler(t, e[o], i, n, s, r);
                        else if (a && !h) {
                            if (e) for(o = 0; o < t.length; o++)this.collideHandler(t[o], e, i, n, s, r);
                            else for(o = 0; o < t.length; o++)for(var l = t[o], u = o + 1; u < t.length; u++)o !== u && this.collideHandler(l, t[u], i, n, s, r);
                        } else for(o = 0; o < t.length; o++)for(u = 0; u < e.length; u++)this.collideHandler(t[o], e[u], i, n, s, r);
                    } else this.collideHandler(t, e, i, n, s, r);
                    return 0 < this._total;
                },
                collideHandler: function(t, e, i, n, s, r) {
                    if (void 0 === e && t.isParent) return this.collideGroupVsGroup(t, t, i, n, s, r);
                    if (!t || !e) return !1;
                    if (t.body) {
                        if (e.body) return this.collideSpriteVsSprite(t, e, i, n, s, r);
                        if (e.isParent) return this.collideSpriteVsGroup(t, e, i, n, s, r);
                        if (e.isTilemap) return this.collideSpriteVsTilemapLayer(t, e, i, n, s, r);
                    } else if (t.isParent) {
                        if (e.body) return this.collideSpriteVsGroup(e, t, i, n, s, r);
                        if (e.isParent) return this.collideGroupVsGroup(t, e, i, n, s, r);
                        if (e.isTilemap) return this.collideGroupVsTilemapLayer(t, e, i, n, s, r);
                    } else if (t.isTilemap) {
                        if (e.body) return this.collideSpriteVsTilemapLayer(e, t, i, n, s, r);
                        if (e.isParent) return this.collideGroupVsTilemapLayer(e, t, i, n, s, r);
                    }
                },
                collideSpriteVsSprite: function(t, e, i, n, s, r) {
                    return !(!t.body || !e.body) && (this.separate(t.body, e.body, n, s, r) && (i && i.call(s, t, e), this._total++), !0);
                },
                collideSpriteVsGroup: function(t, e, i, n, s, r) {
                    var o, a = t.body;
                    if (0 !== e.length && a && a.enable && !a.checkCollision.none) {
                        if (this.useTree || e.physicsType === g.STATIC_BODY) {
                            var h = this.treeMinMax;
                            h.minX = a.left, h.minY = a.top, h.maxX = a.right, h.maxY = a.bottom;
                            for(var l = e.physicsType === g.DYNAMIC_BODY ? this.tree.search(h) : this.staticTree.search(h), u = l.length, c = 0; c < u; c++)a !== (o = l[c]) && o.enable && !o.checkCollision.none && e.contains(o.gameObject) && this.separate(a, o, n, s, r, !0) && (i && i.call(s, a.gameObject, o.gameObject), this._total++);
                        } else {
                            var d = e.getChildren(), f = e.children.entries.indexOf(t);
                            for(u = d.length, c = 0; c < u; c++)(o = d[c].body) && c !== f && o.enable && this.separate(a, o, n, s, r) && (i && i.call(s, a.gameObject, o.gameObject), this._total++);
                        }
                    }
                },
                collideGroupVsTilemapLayer: function(t, e, i, n, s, r) {
                    var o = t.getChildren();
                    if (0 === o.length) return !1;
                    for(var a = !1, h = 0; h < o.length; h++)o[h].body && this.collideSpriteVsTilemapLayer(o[h], e, i, n, s, r) && (a = !0);
                    return a;
                },
                collideTiles: function(t, e, i, n, s) {
                    return !(!t.body.enable || 0 === e.length) && this.collideSpriteVsTilesHandler(t, e, i, n, s, !1, !1);
                },
                overlapTiles: function(t, e, i, n, s) {
                    return !(!t.body.enable || 0 === e.length) && this.collideSpriteVsTilesHandler(t, e, i, n, s, !0, !1);
                },
                collideSpriteVsTilemapLayer: function(t, e, i, n, s, r) {
                    var o = t.body;
                    if (!o.enable || o.checkCollision.none) return !1;
                    var a, h = o.position.x, l = o.position.y, u = o.width, c = o.height, d = e.layer;
                    d.tileWidth > d.baseTileWidth && (h -= a = (d.tileWidth - d.baseTileWidth) * e.scaleX, u += a), d.tileHeight > d.baseTileHeight && (c += (d.tileHeight - d.baseTileHeight) * e.scaleY);
                    var f = S(h, l, u, c, null, e.scene.cameras.main, e.layer);
                    return 0 !== f.length && this.collideSpriteVsTilesHandler(t, f, i, n, s, r, !0);
                },
                collideSpriteVsTilesHandler: function(t, e, i, n, s, r, o) {
                    for(var a, h, l = t.body, u = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }, c = !1, d = 0; d < e.length; d++){
                        var f = (h = (a = e[d]).tilemapLayer).tileToWorldXY(a.x, a.y);
                        u.left = f.x, u.top = f.y, a.baseHeight !== a.height && (u.top -= (a.height - a.baseHeight) * h.scaleY), u.right = u.left + a.width * h.scaleX, u.bottom = u.top + a.height * h.scaleY, P(u, l) && (!n || n.call(s, t, a)) && _(a, t) && (r || C(d, l, a, u, h, this.TILE_BIAS, o)) && (this._total++, c = !0, i && i.call(s, t, a), r && l.onOverlap ? this.emit(y.TILE_OVERLAP, t, a, l) : l.onCollide && this.emit(y.TILE_COLLIDE, t, a, l));
                    }
                    return c;
                },
                collideGroupVsGroup: function(t, e, i, n, s, r) {
                    if (0 !== t.length && 0 !== e.length) for(var o = t.getChildren(), a = 0; a < o.length; a++)this.collideSpriteVsGroup(o[a], e, i, n, s, r);
                },
                wrap: function(t, e) {
                    t.body ? this.wrapObject(t, e) : t.getChildren ? this.wrapArray(t.getChildren(), e) : Array.isArray(t) ? this.wrapArray(t, e) : this.wrapObject(t, e);
                },
                wrapArray: function(t, e) {
                    for(var i = 0; i < t.length; i++)this.wrapObject(t[i], e);
                },
                wrapObject: function(t, e) {
                    void 0 === e && (e = 0), t.x = L(t.x, this.bounds.left - e, this.bounds.right + e), t.y = L(t.y, this.bounds.top - e, this.bounds.bottom + e);
                },
                shutdown: function() {
                    this.tree.clear(), this.staticTree.clear(), this.bodies.clear(), this.staticBodies.clear(), this.colliders.destroy(), this.removeAllListeners();
                },
                destroy: function() {
                    this.shutdown(), this.scene = null;
                }
            });
            t.exports = D;
        },
        function(t, e, i) {
            var n = i(0), s = i(60), r = i(242), a = i(193), o = i(10), h = i(56), l = i(3), u = new n({
                initialize: function(t, e) {
                    var i = e.displayWidth ? e.displayWidth : 64, n = e.displayHeight ? e.displayHeight : 64;
                    this.world = t, this.gameObject = e, this.transform = {
                        x: e.x,
                        y: e.y,
                        rotation: e.angle,
                        scaleX: e.scaleX,
                        scaleY: e.scaleY,
                        displayOriginX: e.displayOriginX,
                        displayOriginY: e.displayOriginY
                    }, this.debugShowBody = t.defaults.debugShowBody, this.debugShowVelocity = t.defaults.debugShowVelocity, this.debugBodyColor = t.defaults.bodyDebugColor, this.enable = !0, this.isCircle = !1, this.radius = 0, this.offset = new l, this.position = new l(e.x - e.scaleX * e.displayOriginX, e.y - e.scaleY * e.displayOriginY), this.prev = this.position.clone(), this.prevFrame = this.position.clone(), this.allowRotation = !0, this.rotation = e.angle, this.preRotation = e.angle, this.width = i, this.height = n, this.sourceWidth = i, this.sourceHeight = n, e.frame && (this.sourceWidth = e.frame.realWidth, this.sourceHeight = e.frame.realHeight), this.halfWidth = Math.abs(i / 2), this.halfHeight = Math.abs(n / 2), this.center = new l(this.position.x + this.halfWidth, this.position.y + this.halfHeight), this.velocity = new l, this.newVelocity = new l, this.deltaMax = new l, this.acceleration = new l, this.allowDrag = !0, this.drag = new l, this.allowGravity = !0, this.gravity = new l, this.bounce = new l, this.worldBounce = null, this.customBoundsRectangle = t.bounds, this.onWorldBounds = !1, this.onCollide = !1, this.onOverlap = !1, this.maxVelocity = new l(1e4, 1e4), this.maxSpeed = -1, this.friction = new l(1, 0), this.useDamping = !1, this.angularVelocity = 0, this.angularAcceleration = 0, this.angularDrag = 0, this.maxAngular = 1e3, this.mass = 1, this.angle = 0, this.speed = 0, this.facing = s.FACING_NONE, this.immovable = !1, this.pushable = !0, this.moves = !0, this.customSeparateX = !1, this.customSeparateY = !1, this.overlapX = 0, this.overlapY = 0, this.overlapR = 0, this.embedded = !1, this.collideWorldBounds = !1, this.checkCollision = {
                        none: !1,
                        up: !0,
                        down: !0,
                        left: !0,
                        right: !0
                    }, this.touching = {
                        none: !0,
                        up: !1,
                        down: !1,
                        left: !1,
                        right: !1
                    }, this.wasTouching = {
                        none: !0,
                        up: !1,
                        down: !1,
                        left: !1,
                        right: !1
                    }, this.blocked = {
                        none: !0,
                        up: !1,
                        down: !1,
                        left: !1,
                        right: !1
                    }, this.syncBounds = !1, this.physicsType = s.DYNAMIC_BODY, this._sx = e.scaleX, this._sy = e.scaleY, this._dx = 0, this._dy = 0, this._tx = 0, this._ty = 0, this._bounds = new o;
                },
                updateBounds: function() {
                    var t, e = this.gameObject, i = this.transform;
                    e.parentContainer ? (t = e.getWorldTransformMatrix(this.world._tempMatrix, this.world._tempMatrix2), i.x = t.tx, i.y = t.ty, i.rotation = a(t.rotation), i.scaleX = t.scaleX, i.scaleY = t.scaleY) : (i.x = e.x, i.y = e.y, i.rotation = e.angle, i.scaleX = e.scaleX, i.scaleY = e.scaleY), i.displayOriginX = e.displayOriginX, i.displayOriginY = e.displayOriginY;
                    var n, s, r, o = !1;
                    this.syncBounds ? (n = e.getBounds(this._bounds), this.width = n.width, this.height = n.height, o = !0) : (s = Math.abs(i.scaleX), r = Math.abs(i.scaleY), this._sx === s && this._sy === r || (this.width = this.sourceWidth * s, this.height = this.sourceHeight * r, this._sx = s, this._sy = r, o = !0)), o && (this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.updateCenter());
                },
                updateCenter: function() {
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                },
                updateFromGameObject: function() {
                    this.updateBounds();
                    var t = this.transform;
                    this.position.x = t.x + t.scaleX * (this.offset.x - t.displayOriginX), this.position.y = t.y + t.scaleY * (this.offset.y - t.displayOriginY), this.updateCenter();
                },
                resetFlags: function(t) {
                    void 0 === t && (t = !1);
                    var e = this.wasTouching, i = this.touching, n = this.blocked;
                    t ? (e.none = !0, e.up = !1, e.down = !1, e.left = !1, e.right = !1) : (e.none = i.none, e.up = i.up, e.down = i.down, e.left = i.left, e.right = i.right), i.none = !0, i.up = !1, i.down = !1, i.left = !1, i.right = !1, n.none = !0, n.up = !1, n.down = !1, n.left = !1, n.right = !1, this.overlapR = 0, this.overlapX = 0, this.overlapY = 0, this.embedded = !1;
                },
                preUpdate: function(t, e) {
                    t && this.resetFlags(), this.updateFromGameObject(), this.rotation = this.transform.rotation, this.preRotation = this.rotation, this.moves && (this.prev.x = this.position.x, this.prev.y = this.position.y, this.prevFrame.x = this.position.x, this.prevFrame.y = this.position.y), t && this.update(e);
                },
                update: function(t) {
                    var e, i;
                    this.prev.x = this.position.x, this.prev.y = this.position.y, this.moves && (this.world.updateMotion(this, t), e = this.velocity.x, i = this.velocity.y, this.newVelocity.set(e * t, i * t), this.position.add(this.newVelocity), this.updateCenter(), this.angle = Math.atan2(i, e), this.speed = Math.sqrt(e * e + i * i), this.collideWorldBounds && this.checkWorldBounds() && this.onWorldBounds && this.world.emit(r.WORLD_BOUNDS, this, this.blocked.up, this.blocked.down, this.blocked.left, this.blocked.right)), this._dx = this.position.x - this.prev.x, this._dy = this.position.y - this.prev.y;
                },
                postUpdate: function() {
                    var t, e, i = this.position.x - this.prevFrame.x, n = this.position.y - this.prevFrame.y;
                    this.moves && (0 !== (t = this.deltaMax.x) && 0 !== i && (i < 0 && i < -t ? i = -t : 0 < i && t < i && (i = t)), 0 !== (e = this.deltaMax.y) && 0 !== n && (n < 0 && n < -e ? n = -e : 0 < n && e < n && (n = e)), this.gameObject.x += i, this.gameObject.y += n), i < 0 ? this.facing = s.FACING_LEFT : 0 < i && (this.facing = s.FACING_RIGHT), n < 0 ? this.facing = s.FACING_UP : 0 < n && (this.facing = s.FACING_DOWN), this.allowRotation && (this.gameObject.angle += this.deltaZ()), this._tx = i, this._ty = n;
                },
                setBoundsRectangle: function(t) {
                    return this.customBoundsRectangle = t || this.world.bounds, this;
                },
                checkWorldBounds: function() {
                    var t = this.position, e = this.customBoundsRectangle, i = this.world.checkCollision, n = this.worldBounce ? -this.worldBounce.x : -this.bounce.x, s = this.worldBounce ? -this.worldBounce.y : -this.bounce.y, r = !1;
                    return t.x < e.x && i.left ? (t.x = e.x, this.velocity.x *= n, r = this.blocked.left = !0) : this.right > e.right && i.right && (t.x = e.right - this.width, this.velocity.x *= n, r = this.blocked.right = !0), t.y < e.y && i.up ? (t.y = e.y, this.velocity.y *= s, r = this.blocked.up = !0) : this.bottom > e.bottom && i.down && (t.y = e.bottom - this.height, this.velocity.y *= s, r = this.blocked.down = !0), r && (this.blocked.none = !1, this.updateCenter()), r;
                },
                setOffset: function(t, e) {
                    return void 0 === e && (e = t), this.offset.set(t, e), this;
                },
                setSize: function(t, e, i) {
                    void 0 === i && (i = !0);
                    var n, s, r = this.gameObject;
                    return !t && r.frame && (t = r.frame.realWidth), !e && r.frame && (e = r.frame.realHeight), this.sourceWidth = t, this.sourceHeight = e, this.width = this.sourceWidth * this._sx, this.height = this.sourceHeight * this._sy, this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.updateCenter(), i && r.getCenter && (n = (r.width - t) / 2, s = (r.height - e) / 2, this.offset.set(n, s)), this.isCircle = !1, this.radius = 0, this;
                },
                setCircle: function(t, e, i) {
                    return void 0 === e && (e = this.offset.x), void 0 === i && (i = this.offset.y), 0 < t ? (this.isCircle = !0, this.radius = t, this.sourceWidth = 2 * t, this.sourceHeight = 2 * t, this.width = this.sourceWidth * this._sx, this.height = this.sourceHeight * this._sy, this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.offset.set(e, i), this.updateCenter()) : this.isCircle = !1, this;
                },
                reset: function(t, e) {
                    this.stop();
                    var i = this.gameObject;
                    i.setPosition(t, e), i.getTopLeft ? i.getTopLeft(this.position) : this.position.set(t, e), this.prev.copy(this.position), this.prevFrame.copy(this.position), this.rotation = i.angle, this.preRotation = i.angle, this.updateBounds(), this.updateCenter(), this.resetFlags(!0);
                },
                stop: function() {
                    return this.velocity.set(0), this.acceleration.set(0), this.speed = 0, this.angularVelocity = 0, this.angularAcceleration = 0, this;
                },
                getBounds: function(t) {
                    return t.x = this.x, t.y = this.y, t.right = this.right, t.bottom = this.bottom, t;
                },
                hitTest: function(t, e) {
                    return this.isCircle ? 0 < this.radius && t >= this.left && t <= this.right && e >= this.top && e <= this.bottom && (this.center.x - t) * (this.center.x - t) + (this.center.y - e) * (this.center.y - e) <= this.radius * this.radius : h(this, t, e);
                },
                onFloor: function() {
                    return this.blocked.down;
                },
                onCeiling: function() {
                    return this.blocked.up;
                },
                onWall: function() {
                    return this.blocked.left || this.blocked.right;
                },
                deltaAbsX: function() {
                    return 0 < this._dx ? this._dx : -this._dx;
                },
                deltaAbsY: function() {
                    return 0 < this._dy ? this._dy : -this._dy;
                },
                deltaX: function() {
                    return this._dx;
                },
                deltaY: function() {
                    return this._dy;
                },
                deltaXFinal: function() {
                    return this._tx;
                },
                deltaYFinal: function() {
                    return this._ty;
                },
                deltaZ: function() {
                    return this.rotation - this.preRotation;
                },
                destroy: function() {
                    this.enable = !1, this.world && this.world.pendingDestroy.set(this);
                },
                drawDebug: function(t) {
                    var e = this.position, i = e.x + this.halfWidth, n = e.y + this.halfHeight;
                    this.debugShowBody && (t.lineStyle(t.defaultStrokeWidth, this.debugBodyColor), this.isCircle ? t.strokeCircle(i, n, this.width / 2) : (this.checkCollision.up && t.lineBetween(e.x, e.y, e.x + this.width, e.y), this.checkCollision.right && t.lineBetween(e.x + this.width, e.y, e.x + this.width, e.y + this.height), this.checkCollision.down && t.lineBetween(e.x, e.y + this.height, e.x + this.width, e.y + this.height), this.checkCollision.left && t.lineBetween(e.x, e.y, e.x, e.y + this.height))), this.debugShowVelocity && (t.lineStyle(t.defaultStrokeWidth, this.world.defaults.velocityDebugColor, 1), t.lineBetween(i, n, i + this.velocity.x / 2, n + this.velocity.y / 2));
                },
                willDrawDebug: function() {
                    return this.debugShowBody || this.debugShowVelocity;
                },
                setCollideWorldBounds: function(t, e, i, n) {
                    void 0 === t && (t = !0), this.collideWorldBounds = t;
                    var s = void 0 !== e, r = void 0 !== i;
                    return (s || r) && (this.worldBounce || (this.worldBounce = new l), s && (this.worldBounce.x = e), r && (this.worldBounce.y = i)), void 0 !== n && (this.onWorldBounds = n), this;
                },
                setVelocity: function(t, e) {
                    return this.velocity.set(t, e), t = this.velocity.x, e = this.velocity.y, this.speed = Math.sqrt(t * t + e * e), this;
                },
                setVelocityX: function(t) {
                    this.velocity.x = t;
                    var e = this.velocity.y;
                    return this.speed = Math.sqrt(t * t + e * e), this;
                },
                setVelocityY: function(t) {
                    this.velocity.y = t;
                    var e = this.velocity.x;
                    return this.speed = Math.sqrt(e * e + t * t), this;
                },
                setMaxVelocity: function(t, e) {
                    return this.maxVelocity.set(t, e), this;
                },
                setMaxVelocityX: function(t) {
                    return this.maxVelocity.x = t, this;
                },
                setMaxVelocityY: function(t) {
                    return this.maxVelocity.y = t, this;
                },
                setMaxSpeed: function(t) {
                    return this.maxSpeed = t, this;
                },
                setBounce: function(t, e) {
                    return this.bounce.set(t, e), this;
                },
                setBounceX: function(t) {
                    return this.bounce.x = t, this;
                },
                setBounceY: function(t) {
                    return this.bounce.y = t, this;
                },
                setAcceleration: function(t, e) {
                    return this.acceleration.set(t, e), this;
                },
                setAccelerationX: function(t) {
                    return this.acceleration.x = t, this;
                },
                setAccelerationY: function(t) {
                    return this.acceleration.y = t, this;
                },
                setAllowDrag: function(t) {
                    return void 0 === t && (t = !0), this.allowDrag = t, this;
                },
                setAllowGravity: function(t) {
                    return void 0 === t && (t = !0), this.allowGravity = t, this;
                },
                setAllowRotation: function(t) {
                    return void 0 === t && (t = !0), this.allowRotation = t, this;
                },
                setDrag: function(t, e) {
                    return this.drag.set(t, e), this;
                },
                setDamping: function(t) {
                    return this.useDamping = t, this;
                },
                setDragX: function(t) {
                    return this.drag.x = t, this;
                },
                setDragY: function(t) {
                    return this.drag.y = t, this;
                },
                setGravity: function(t, e) {
                    return this.gravity.set(t, e), this;
                },
                setGravityX: function(t) {
                    return this.gravity.x = t, this;
                },
                setGravityY: function(t) {
                    return this.gravity.y = t, this;
                },
                setFriction: function(t, e) {
                    return this.friction.set(t, e), this;
                },
                setFrictionX: function(t) {
                    return this.friction.x = t, this;
                },
                setFrictionY: function(t) {
                    return this.friction.y = t, this;
                },
                setAngularVelocity: function(t) {
                    return this.angularVelocity = t, this;
                },
                setAngularAcceleration: function(t) {
                    return this.angularAcceleration = t, this;
                },
                setAngularDrag: function(t) {
                    return this.angularDrag = t, this;
                },
                setMass: function(t) {
                    return this.mass = t, this;
                },
                setImmovable: function(t) {
                    return void 0 === t && (t = !0), this.immovable = t, this;
                },
                setEnable: function(t) {
                    return void 0 === t && (t = !0), this.enable = t, this;
                },
                processX: function(t, e, i, n) {
                    this.x += t, this.updateCenter(), null !== e && (this.velocity.x = e);
                    var s = this.blocked;
                    i && (s.left = !0), n && (s.right = !0);
                },
                processY: function(t, e, i, n) {
                    this.y += t, this.updateCenter(), null !== e && (this.velocity.y = e);
                    var s = this.blocked;
                    i && (s.up = !0), n && (s.down = !0);
                },
                x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(t) {
                        this.position.x = t;
                    }
                },
                y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(t) {
                        this.position.y = t;
                    }
                },
                left: {
                    get: function() {
                        return this.position.x;
                    }
                },
                right: {
                    get: function() {
                        return this.position.x + this.width;
                    }
                },
                top: {
                    get: function() {
                        return this.position.y;
                    }
                },
                bottom: {
                    get: function() {
                        return this.position.y + this.height;
                    }
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n, s, r, o) {
                    this.world = t, this.name = "", this.active = !0, this.overlapOnly = e, this.object1 = i, this.object2 = n, this.collideCallback = s, this.processCallback = r, this.callbackContext = o;
                },
                setName: function(t) {
                    return this.name = t, this;
                },
                update: function() {
                    this.world.collideObjects(this.object1, this.object2, this.collideCallback, this.processCallback, this.callbackContext, this.overlapOnly);
                },
                destroy: function() {
                    this.world.removeCollider(this), this.active = !1, this.world = null, this.object1 = null, this.object2 = null, this.collideCallback = null, this.processCallback = null, this.callbackContext = null;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var d = i(26), n = i(3), f = new n, p = new n;
            t.exports = function(t, e, i, n, s, r, o) {
                var a = o.tilemapLayer.tilemap._convert.WorldToTileXY;
                a(t, e, !0, f, r, o);
                var h = f.x, l = f.y;
                a(t + i, e + n, !1, p, r, o);
                var u = Math.ceil(p.x), c = Math.ceil(p.y);
                return d(h, l, u - h, c - l, s, o);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.collisionCallback ? !t.collisionCallback.call(t.collisionCallbackContext, e, t) : !t.layer.callbacks[t.index] || !t.layer.callbacks[t.index].callback.call(t.layer.callbacks[t.index].callbackContext, e, t);
            };
        },
        function(t, e, i) {
            var a = i(430);
            function n(t) {
                if (!(this instanceof n)) return new n(t);
                this._maxEntries = Math.max(4, t || 9), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
            }
            function f(t, e) {
                m(t, 0, t.children.length, e, t);
            }
            function m(t, e, i, n, s) {
                (s = s || p(null)).minX = 1 / 0, s.minY = 1 / 0, s.maxX = -1 / 0, s.maxY = -1 / 0;
                for(var r, o = e; o < i; o++)r = t.children[o], u(s, t.leaf ? n(r) : r);
                return s;
            }
            function u(t, e) {
                return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
            }
            function r(t, e) {
                return t.minX - e.minX;
            }
            function o(t, e) {
                return t.minY - e.minY;
            }
            function y(t) {
                return (t.maxX - t.minX) * (t.maxY - t.minY);
            }
            function c(t) {
                return t.maxX - t.minX + (t.maxY - t.minY);
            }
            function d(t, e) {
                return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
            }
            function l(t, e) {
                return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
            }
            function p(t) {
                return {
                    children: t,
                    height: 1,
                    leaf: !0,
                    minX: 1 / 0,
                    minY: 1 / 0,
                    maxX: -1 / 0,
                    maxY: -1 / 0
                };
            }
            function g(t, e, i, n, s) {
                for(var r, o = [
                    e,
                    i
                ]; o.length;)(i = o.pop()) - (e = o.pop()) <= n || (r = e + Math.ceil((i - e) / n / 2) * n, a(t, r, e, i, s), o.push(e, r, r, i));
            }
            n.prototype = {
                all: function() {
                    return this._all(this.data, []);
                },
                search: function(t) {
                    var e = this.data, i = [], n = this.toBBox;
                    if (!l(t, e)) return i;
                    for(var s, r, o, a, h = []; e;){
                        for(s = 0, r = e.children.length; s < r; s++)o = e.children[s], l(t, a = e.leaf ? n(o) : o) && (e.leaf ? i.push(o) : d(t, a) ? this._all(o, i) : h.push(o));
                        e = h.pop();
                    }
                    return i;
                },
                collides: function(t) {
                    var e = this.data, i = this.toBBox;
                    if (!l(t, e)) return !1;
                    for(var n, s, r, o, a = []; e;){
                        for(n = 0, s = e.children.length; n < s; n++)if (r = e.children[n], l(t, o = e.leaf ? i(r) : r)) {
                            if (e.leaf || d(t, o)) return !0;
                            a.push(r);
                        }
                        e = a.pop();
                    }
                    return !1;
                },
                load: function(t) {
                    if (!t || !t.length) return this;
                    if (t.length < this._minEntries) {
                        for(var e = 0, i = t.length; e < i; e++)this.insert(t[e]);
                        return this;
                    }
                    var n, s = this._build(t.slice(), 0, t.length - 1, 0);
                    return this.data.children.length ? this.data.height === s.height ? this._splitRoot(this.data, s) : (this.data.height < s.height && (n = this.data, this.data = s, s = n), this._insert(s, this.data.height - s.height - 1, !0)) : this.data = s, this;
                },
                insert: function(t) {
                    return t && this._insert(t, this.data.height - 1), this;
                },
                clear: function() {
                    return this.data = p([]), this;
                },
                remove: function(t, e) {
                    if (!t) return this;
                    for(var i, n, s, r, o = this.data, a = this.toBBox(t), h = [], l = []; o || h.length;){
                        if (o || (o = h.pop(), n = h[h.length - 1], i = l.pop(), r = !0), o.leaf && -1 !== (s = function(t, e, i) {
                            if (!i) return e.indexOf(t);
                            for(var n = 0; n < e.length; n++)if (i(t, e[n])) return n;
                            return -1;
                        }(t, o.children, e))) return o.children.splice(s, 1), h.push(o), this._condense(h), this;
                        r || o.leaf || !d(o, a) ? n ? (i++, o = n.children[i], r = !1) : o = null : (h.push(o), l.push(i), i = 0, o = (n = o).children[0]);
                    }
                    return this;
                },
                toBBox: function(t) {
                    return {
                        minX: t.left,
                        minY: t.top,
                        maxX: t.right,
                        maxY: t.bottom
                    };
                },
                compareMinX: function(t, e) {
                    return t.left - e.left;
                },
                compareMinY: function(t, e) {
                    return t.top - e.top;
                },
                toJSON: function() {
                    return this.data;
                },
                fromJSON: function(t) {
                    return this.data = t, this;
                },
                _all: function(t, e) {
                    for(var i = []; t;)t.leaf ? e.push.apply(e, t.children) : i.push.apply(i, t.children), t = i.pop();
                    return e;
                },
                _build: function(t, e, i, n) {
                    var s, r = i - e + 1, o = this._maxEntries;
                    if (r <= o) return f(s = p(t.slice(e, i + 1)), this.toBBox), s;
                    n || (n = Math.ceil(Math.log(r) / Math.log(o)), o = Math.ceil(r / Math.pow(o, n - 1))), (s = p([])).leaf = !1, s.height = n;
                    var a, h, l, u, c = Math.ceil(r / o), d = c * Math.ceil(Math.sqrt(o));
                    for(g(t, e, i, d, this.compareMinX), a = e; a <= i; a += d)for(g(t, a, l = Math.min(a + d - 1, i), c, this.compareMinY), h = a; h <= l; h += c)u = Math.min(h + c - 1, l), s.children.push(this._build(t, h, u, n - 1));
                    return f(s, this.toBBox), s;
                },
                _chooseSubtree: function(t, e, i, n) {
                    for(var s, r, o, a, h, l, u, c, d, f; n.push(e), !e.leaf && n.length - 1 !== i;){
                        for(u = c = 1 / 0, s = 0, r = e.children.length; s < r; s++)h = y(o = e.children[s]), d = t, f = o, (l = (Math.max(f.maxX, d.maxX) - Math.min(f.minX, d.minX)) * (Math.max(f.maxY, d.maxY) - Math.min(f.minY, d.minY)) - h) < c ? (c = l, u = h < u ? h : u, a = o) : l === c && h < u && (u = h, a = o);
                        e = a || e.children[0];
                    }
                    return e;
                },
                _insert: function(t, e, i) {
                    var n = this.toBBox, s = i ? t : n(t), r = [], o = this._chooseSubtree(s, this.data, e, r);
                    for(o.children.push(t), u(o, s); 0 <= e && r[e].children.length > this._maxEntries;)this._split(r, e), e--;
                    this._adjustParentBBoxes(s, r, e);
                },
                _split: function(t, e) {
                    var i = t[e], n = i.children.length, s = this._minEntries;
                    this._chooseSplitAxis(i, s, n);
                    var r = this._chooseSplitIndex(i, s, n), o = p(i.children.splice(r, i.children.length - r));
                    o.height = i.height, o.leaf = i.leaf, f(i, this.toBBox), f(o, this.toBBox), e ? t[e - 1].children.push(o) : this._splitRoot(i, o);
                },
                _splitRoot: function(t, e) {
                    this.data = p([
                        t,
                        e
                    ]), this.data.height = t.height + 1, this.data.leaf = !1, f(this.data, this.toBBox);
                },
                _chooseSplitIndex: function(t, e, i) {
                    for(var n, s, r, o, a, h, l, u, c, d, f, p, g = a = 1 / 0, v = e; v <= i - e; v++)n = m(t, 0, v, this.toBBox), s = m(t, v, i, this.toBBox), l = n, u = s, p = f = d = c = void 0, c = Math.max(l.minX, u.minX), d = Math.max(l.minY, u.minY), f = Math.min(l.maxX, u.maxX), p = Math.min(l.maxY, u.maxY), r = Math.max(0, f - c) * Math.max(0, p - d), o = y(n) + y(s), r < g ? (g = r, h = v, a = o < a ? o : a) : r === g && o < a && (a = o, h = v);
                    return h;
                },
                _chooseSplitAxis: function(t, e, i) {
                    var n = t.leaf ? this.compareMinX : r, s = t.leaf ? this.compareMinY : o;
                    this._allDistMargin(t, e, i, n) < this._allDistMargin(t, e, i, s) && t.children.sort(n);
                },
                _allDistMargin: function(t, e, i, n) {
                    t.children.sort(n);
                    for(var s, r = this.toBBox, o = m(t, 0, e, r), a = m(t, i - e, i, r), h = c(o) + c(a), l = e; l < i - e; l++)s = t.children[l], u(o, t.leaf ? r(s) : s), h += c(o);
                    for(l = i - e - 1; e <= l; l--)s = t.children[l], u(a, t.leaf ? r(s) : s), h += c(a);
                    return h;
                },
                _adjustParentBBoxes: function(t, e, i) {
                    for(var n = i; 0 <= n; n--)u(e[n], t);
                },
                _condense: function(t) {
                    for(var e, i = t.length - 1; 0 <= i; i--)0 === t[i].children.length ? 0 < i ? (e = t[i - 1].children).splice(e.indexOf(t[i]), 1) : this.clear() : f(t[i], this.toBBox);
                }
            }, t.exports = n;
        },
        function(t, e, i) {
            var m = i(527), y = i(529), x = i(245);
            t.exports = function(t, e, i, n, s, r, o) {
                var a = n.left, h = n.top, l = n.right, u = n.bottom, c = i.faceLeft || i.faceRight, d = i.faceTop || i.faceBottom;
                if (o || (d = c = !0), !c && !d) return !1;
                var f = 0, p = 0, g = 0, v = 1;
                if (e.deltaAbsX() > e.deltaAbsY() ? g = -1 : e.deltaAbsX() < e.deltaAbsY() && (v = -1), 0 !== e.deltaX() && 0 !== e.deltaY() && c && d && (g = Math.min(Math.abs(e.position.x - l), Math.abs(e.right - a)), v = Math.min(Math.abs(e.position.y - u), Math.abs(e.bottom - h))), g < v) {
                    if (c && 0 !== (f = m(e, i, a, l, r, o)) && !x(n, e)) return !0;
                    d && (p = y(e, i, h, u, r, o));
                } else {
                    if (d && 0 !== (p = y(e, i, h, u, r, o)) && !x(n, e)) return !0;
                    c && (f = m(e, i, a, l, r, o));
                }
                return 0 !== f || 0 !== p;
            };
        },
        function(t, e, i) {
            var c = i(528);
            t.exports = function(t, e, i, n, s, r) {
                var o = 0, a = e.faceLeft, h = e.faceRight, l = e.collideLeft, u = e.collideRight;
                return r || (u = l = h = a = !0), t.deltaX() < 0 && u && t.checkCollision.left ? h && t.x < n && (o = t.x - n) < -s && (o = 0) : 0 < t.deltaX() && l && t.checkCollision.right && a && t.right > i && s < (o = t.right - i) && (o = 0), 0 !== o && (t.customSeparateX ? t.overlapX = o : c(t, o)), o;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                e < 0 ? (t.blocked.none = !1, t.blocked.left = !0) : 0 < e && (t.blocked.none = !1, t.blocked.right = !0), t.position.x -= e, 0 === t.bounce.x ? t.velocity.x = 0 : t.velocity.x = -t.velocity.x * t.bounce.x;
            };
        },
        function(t, e, i) {
            var c = i(530);
            t.exports = function(t, e, i, n, s, r) {
                var o = 0, a = e.faceTop, h = e.faceBottom, l = e.collideUp, u = e.collideDown;
                return r || (u = l = h = a = !0), t.deltaY() < 0 && u && t.checkCollision.up ? h && t.y < n && (o = t.y - n) < -s && (o = 0) : 0 < t.deltaY() && l && t.checkCollision.down && a && t.bottom > i && s < (o = t.bottom - i) && (o = 0), 0 !== o && (t.customSeparateY ? t.overlapY = o : c(t, o)), o;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                e < 0 ? (t.blocked.none = !1, t.blocked.up = !0) : 0 < e && (t.blocked.none = !1, t.blocked.down = !0), t.position.y -= e, 0 === t.bounce.y ? t.velocity.y = 0 : t.velocity.y = -t.velocity.y * t.bounce.y;
            };
        },
        function(t, e, i) {
            var h = i(243), l = i(1383);
            t.exports = function(t, e, i, n) {
                var s = h(t, e, i, n), r = t.immovable, o = e.immovable;
                if (i || 0 === s || r && o || t.customSeparateX || e.customSeparateX) return 0 !== s || t.embedded && e.embedded;
                var a = l.Set(t, e, s);
                return r || o ? (r ? l.RunImmovableBody1(a) : o && l.RunImmovableBody2(a), !0) : 0 < a || l.Check();
            };
        },
        function(t, e, i) {
            var h = i(244), l = i(1384);
            t.exports = function(t, e, i, n) {
                var s = h(t, e, i, n), r = t.immovable, o = e.immovable;
                if (i || 0 === s || r && o || t.customSeparateY || e.customSeparateY) return 0 !== s || t.embedded && e.embedded;
                var a = l.Set(t, e, s);
                return r || o ? (r ? l.RunImmovableBody1(a) : o && l.RunImmovableBody2(a), !0) : 0 < a || l.Check();
            };
        },
        function(t, e, i) {
            var n = i(63), s = i(0), r = i(60), o = i(56), a = i(3), h = new s({
                initialize: function(t, e) {
                    var i = e.displayWidth ? e.displayWidth : 64, n = e.displayHeight ? e.displayHeight : 64;
                    this.world = t, this.gameObject = e, this.debugShowBody = t.defaults.debugShowStaticBody, this.debugBodyColor = t.defaults.staticBodyDebugColor, this.enable = !0, this.isCircle = !1, this.radius = 0, this.offset = new a, this.position = new a(e.x - i * e.originX, e.y - n * e.originY), this.width = i, this.height = n, this.halfWidth = Math.abs(this.width / 2), this.halfHeight = Math.abs(this.height / 2), this.center = new a(this.position.x + this.halfWidth, this.position.y + this.halfHeight), this.velocity = a.ZERO, this.allowGravity = !1, this.gravity = a.ZERO, this.bounce = a.ZERO, this.onWorldBounds = !1, this.onCollide = !1, this.onOverlap = !1, this.mass = 1, this.immovable = !0, this.pushable = !1, this.customSeparateX = !1, this.customSeparateY = !1, this.overlapX = 0, this.overlapY = 0, this.overlapR = 0, this.embedded = !1, this.collideWorldBounds = !1, this.checkCollision = {
                        none: !1,
                        up: !0,
                        down: !0,
                        left: !0,
                        right: !0
                    }, this.touching = {
                        none: !0,
                        up: !1,
                        down: !1,
                        left: !1,
                        right: !1
                    }, this.wasTouching = {
                        none: !0,
                        up: !1,
                        down: !1,
                        left: !1,
                        right: !1
                    }, this.blocked = {
                        none: !0,
                        up: !1,
                        down: !1,
                        left: !1,
                        right: !1
                    }, this.physicsType = r.STATIC_BODY, this._dx = 0, this._dy = 0;
                },
                setGameObject: function(t, e) {
                    return t && t !== this.gameObject && (this.gameObject.body = null, (t.body = this).gameObject = t), e && this.updateFromGameObject(), this;
                },
                updateFromGameObject: function() {
                    this.world.staticTree.remove(this);
                    var t = this.gameObject;
                    return t.getTopLeft(this.position), this.width = t.displayWidth, this.height = t.displayHeight, this.halfWidth = Math.abs(this.width / 2), this.halfHeight = Math.abs(this.height / 2), this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight), this.world.staticTree.insert(this), this;
                },
                setOffset: function(t, e) {
                    return void 0 === e && (e = t), this.world.staticTree.remove(this), this.position.x -= this.offset.x, this.position.y -= this.offset.y, this.offset.set(t, e), this.position.x += this.offset.x, this.position.y += this.offset.y, this.updateCenter(), this.world.staticTree.insert(this), this;
                },
                setSize: function(t, e, i) {
                    void 0 === i && (i = !0);
                    var n, s, r = this.gameObject;
                    return !t && r.frame && (t = r.frame.realWidth), !e && r.frame && (e = r.frame.realHeight), this.world.staticTree.remove(this), this.width = t, this.height = e, this.halfWidth = Math.floor(t / 2), this.halfHeight = Math.floor(e / 2), i && r.getCenter && (n = r.displayWidth / 2, s = r.displayHeight / 2, this.position.x -= this.offset.x, this.position.y -= this.offset.y, this.offset.set(n - this.halfWidth, s - this.halfHeight), this.position.x += this.offset.x, this.position.y += this.offset.y), this.updateCenter(), this.isCircle = !1, this.radius = 0, this.world.staticTree.insert(this), this;
                },
                setCircle: function(t, e, i) {
                    return void 0 === e && (e = this.offset.x), void 0 === i && (i = this.offset.y), 0 < t ? (this.world.staticTree.remove(this), this.isCircle = !0, this.radius = t, this.width = 2 * t, this.height = 2 * t, this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.offset.set(e, i), this.updateCenter(), this.world.staticTree.insert(this)) : this.isCircle = !1, this;
                },
                updateCenter: function() {
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                },
                reset: function(t, e) {
                    var i = this.gameObject;
                    void 0 === t && (t = i.x), void 0 === e && (e = i.y), this.world.staticTree.remove(this), i.setPosition(t, e), i.getTopLeft(this.position), this.updateCenter(), this.world.staticTree.insert(this);
                },
                stop: function() {
                    return this;
                },
                getBounds: function(t) {
                    return t.x = this.x, t.y = this.y, t.right = this.right, t.bottom = this.bottom, t;
                },
                hitTest: function(t, e) {
                    return (this.isCircle ? n : o)(this, t, e);
                },
                postUpdate: function() {},
                deltaAbsX: function() {
                    return 0;
                },
                deltaAbsY: function() {
                    return 0;
                },
                deltaX: function() {
                    return 0;
                },
                deltaY: function() {
                    return 0;
                },
                deltaZ: function() {
                    return 0;
                },
                destroy: function() {
                    this.enable = !1, this.world.pendingDestroy.set(this);
                },
                drawDebug: function(t) {
                    var e = this.position, i = e.x + this.halfWidth, n = e.y + this.halfHeight;
                    this.debugShowBody && (t.lineStyle(t.defaultStrokeWidth, this.debugBodyColor, 1), this.isCircle ? t.strokeCircle(i, n, this.width / 2) : t.strokeRect(e.x, e.y, this.width, this.height));
                },
                willDrawDebug: function() {
                    return this.debugShowBody;
                },
                setMass: function(t) {
                    return t <= 0 && (t = .1), this.mass = t, this;
                },
                x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(t) {
                        this.world.staticTree.remove(this), this.position.x = t, this.world.staticTree.insert(this);
                    }
                },
                y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(t) {
                        this.world.staticTree.remove(this), this.position.y = t, this.world.staticTree.insert(this);
                    }
                },
                left: {
                    get: function() {
                        return this.position.x;
                    }
                },
                right: {
                    get: function() {
                        return this.position.x + this.width;
                    }
                },
                top: {
                    get: function() {
                        return this.position.y;
                    }
                },
                bottom: {
                    get: function() {
                        return this.position.y + this.height;
                    }
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            t.exports = {
                Bounce: i(1500),
                Collision: i(1501),
                Force: i(1502),
                Friction: i(1503),
                Gravity: i(1504),
                Mass: i(1505),
                Sensor: i(1506),
                SetBody: i(1507),
                Sleep: i(1508),
                Static: i(1525),
                Transform: i(1526),
                Velocity: i(1527)
            };
        },
        function(t, e) {
            var l = {};
            (t.exports = l).create = function(t, e) {
                var i = t.bodyA, n = t.bodyB, s = {
                    id: l.id(i, n),
                    bodyA: i,
                    bodyB: n,
                    activeContacts: [],
                    separation: 0,
                    isActive: !0,
                    confirmedActive: !0,
                    isSensor: i.isSensor || n.isSensor,
                    timeCreated: e,
                    timeUpdated: e,
                    collision: null,
                    inverseMass: 0,
                    friction: 0,
                    frictionStatic: 0,
                    restitution: 0,
                    slop: 0
                };
                return l.update(s, t, e), s;
            }, l.update = function(t, e, i) {
                if ((t.collision = e).collided) {
                    var n = e.supports, s = t.activeContacts, r = e.parentA, o = e.parentB;
                    t.inverseMass = r.inverseMass + o.inverseMass, t.friction = Math.min(r.friction, o.friction), t.frictionStatic = Math.max(r.frictionStatic, o.frictionStatic), t.restitution = Math.max(r.restitution, o.restitution), t.slop = Math.max(r.slop, o.slop);
                    for(var a = 0; a < n.length; a++)s[a] = n[a].contact;
                    var h = n.length;
                    h < s.length && (s.length = h), t.separation = e.depth, l.setActive(t, !0, i);
                } else !0 === t.isActive && l.setActive(t, !1, i);
            }, l.setActive = function(t, e, i) {
                e ? (t.isActive = !0, t.timeUpdated = i) : (t.isActive = !1, t.activeContacts.length = 0);
            }, l.id = function(t, e) {
                return t.id < e.id ? "A" + t.id + "B" + e.id : "A" + e.id + "B" + t.id;
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t) {
                    this.pluginManager = t, this.game = t.game;
                },
                init: function() {},
                start: function() {},
                stop: function() {},
                destroy: function() {
                    this.pluginManager = null, this.game = null, this.scene = null, this.systems = null;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var h = new (i(3));
            t.exports = function(t, e, i, n) {
                var s = i.tilemapLayer, r = s.cullPaddingX, o = s.cullPaddingY, a = s.tilemap.tileToWorldXY(t, e, h, n, s);
                return a.x > n.worldView.x + s.scaleX * i.tileWidth * (-r - .5) && a.x < n.worldView.right + s.scaleX * i.tileWidth * (r - .5) && a.y > n.worldView.y + s.scaleY * i.tileHeight * (-o - 1) && a.y < n.worldView.bottom + s.scaleY * i.tileHeight * (o - .5);
            };
        },
        function(t, e, i) {
            var l = i(26);
            t.exports = function(t, e, i, n, s, r, o) {
                for(var a = l(i, n, s, r, null, o), h = 0; h < a.length; h++)a[h] && a[h].index === t && (a[h].index = e);
            };
        },
        function(t, e, i) {
            var n = i(10), u = i(137), c = i(76), d = new n;
            t.exports = function(t, e) {
                var i = t.tilemapLayer.tilemap, n = t.tilemapLayer, s = Math.floor(i.tileWidth * n.scaleX), r = Math.floor(i.tileHeight * n.scaleY), o = c(e.worldView.x - n.x, s, 0, !0) - n.cullPaddingX, a = u(e.worldView.right - n.x, s, 0, !0) + n.cullPaddingX, h = c(e.worldView.y - n.y, r, 0, !0) - n.cullPaddingY, l = u(e.worldView.bottom - n.y, r, 0, !0) + n.cullPaddingY;
                return d.setTo(o, h, a - o, l - h);
            };
        },
        function(t, e, i) {
            var o = i(539), a = i(157);
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = []), void 0 === n && (n = 0), i.length = 0;
                var s = t.tilemapLayer, r = o(t, e);
                return !s.skipCull && 1 === s.scrollFactorX && 1 === s.scrollFactorY || (r.left = 0, r.right = t.width, r.top = 0, r.bottom = t.height), a(t, r, n, i), i;
            };
        },
        function(t, e, i) {
            var o = i(542), a = i(157);
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = []), void 0 === n && (n = 0), i.length = 0;
                var s, r = t.tilemapLayer;
                return r.skipCull || 1 !== r.scrollFactorX || 1 !== r.scrollFactorY || (s = o(t, e), a(t, s, n, i)), i;
            };
        },
        function(t, e, i) {
            var h = i(137), l = i(76);
            t.exports = function(t, e) {
                var i = t.tilemapLayer.tilemap, n = t.tilemapLayer, s = Math.floor(i.tileWidth * n.scaleX), r = Math.floor(i.tileHeight * n.scaleY), o = t.hexSideLength, a = (r - o) / 2 + o;
                return {
                    left: l(e.worldView.x - n.x, s, 0, !0) - n.cullPaddingX,
                    right: h(e.worldView.right - n.x, s, 0, !0) + n.cullPaddingX,
                    top: l(e.worldView.y - n.y, a, 0, !0) - n.cullPaddingY,
                    bottom: h(e.worldView.bottom - n.y, a, 0, !0) + n.cullPaddingY
                };
            };
        },
        function(t, e, i) {
            var f = i(537);
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = []), void 0 === n && (n = 0), i.length = 0;
                var s, r, o, a = t.tilemapLayer, h = t.data, l = t.width, u = t.height, c = l, d = u;
                if (!a.skipCull) {
                    if (0 === n) {
                        for(r = 0; r < d; r++)for(s = 0; h[r] && s < c; s++)if (f(s, r, t, e)) {
                            if (!(o = h[r][s]) || -1 === o.index || !o.visible || 0 === o.alpha) continue;
                            i.push(o);
                        }
                    } else if (1 === n) {
                        for(r = 0; r < d; r++)for(s = c; h[r] && 0 <= s; s--)if (f(s, r, t, e)) {
                            if (!(o = h[r][s]) || -1 === o.index || !o.visible || 0 === o.alpha) continue;
                            i.push(o);
                        }
                    } else if (2 === n) {
                        for(r = d; 0 <= r; r--)for(s = 0; h[r] && s < c; s++)if (f(s, r, t, e)) {
                            if (!(o = h[r][s]) || -1 === o.index || !o.visible || 0 === o.alpha) continue;
                            i.push(o);
                        }
                    } else if (3 === n) {
                        for(r = d; 0 <= r; r--)for(s = c; h[r] && 0 <= s; s--)if (f(s, r, t, e)) {
                            if (!(o = h[r][s]) || -1 === o.index || !o.visible || 0 === o.alpha) continue;
                            i.push(o);
                        }
                    }
                }
                return a.tilesDrawn = i.length, a.tilesTotal = l * u, i;
            };
        },
        function(t, e, i) {
            var o = i(545), a = i(157);
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = []), void 0 === n && (n = 0), i.length = 0;
                var s, r = t.tilemapLayer;
                return r.skipCull || 1 !== r.scrollFactorX || 1 !== r.scrollFactorY || (s = o(t, e), a(t, s, n, i)), i;
            };
        },
        function(t, e, i) {
            var o = i(137), a = i(76);
            t.exports = function(t, e) {
                var i = t.tilemapLayer.tilemap, n = t.tilemapLayer, s = Math.floor(i.tileWidth * n.scaleX), r = Math.floor(i.tileHeight * n.scaleY);
                return {
                    left: a(e.worldView.x - n.x, s, 0, !0) - n.cullPaddingX,
                    right: o(e.worldView.right - n.x, s, 0, !0) + n.cullPaddingX,
                    top: a(e.worldView.y - n.y, r / 2, 0, !0) - n.cullPaddingY,
                    bottom: o(e.worldView.bottom - n.y, r / 2, 0, !0) + n.cullPaddingY
                };
            };
        },
        function(t, e, i) {
            var f = i(3);
            t.exports = function(t, e, i, n, s) {
                i = i || new f;
                var r = s.baseTileWidth, o = s.baseTileHeight, a = s.tilemapLayer, h = 0, l = 0;
                a && (n = n || a.scene.cameras.main, h = a.x + n.scrollX * (1 - a.scrollFactorX), r *= a.scaleX, l = a.y + n.scrollY * (1 - a.scrollFactorY), o *= a.scaleY);
                var u = s.hexSideLength, c = h + t * r + e % 2 * (r / 2), d = l + e * ((o - u) / 2 + u);
                return i.set(c, d);
            };
        },
        function(t, e, i) {
            var d = i(3);
            t.exports = function(t, e, i, n, s) {
                i = i || new d;
                var r = s.baseTileWidth, o = s.baseTileHeight, a = s.tilemapLayer, h = 0, l = 0;
                a && (n = n || a.scene.cameras.main, h = a.x + n.scrollX * (1 - a.scrollFactorX), r *= a.scaleX, l = a.y + n.scrollY * (1 - a.scrollFactorY), o *= a.scaleY);
                var u = h + r / 2 * (t - e), c = l + (t + e) * (o / 2);
                return i.set(u, c);
            };
        },
        function(t, e, i) {
            var d = i(3);
            t.exports = function(t, e, i, n, s) {
                i = i || new d;
                var r = s.baseTileWidth, o = s.baseTileHeight, a = s.tilemapLayer, h = 0, l = 0;
                a && (n = n || a.scene.cameras.main, h = a.x + n.scrollX * (1 - a.scrollFactorX), r *= a.scaleX, l = a.y + n.scrollY * (1 - a.scrollFactorY), o *= a.scaleY);
                var u = h + t * r + e % 2 * (r / 2), c = l + e * (o / 2);
                return i.set(u, c);
            };
        },
        function(t, e, i) {
            var r = i(249), o = i(250), a = i(3);
            t.exports = function(t, e, i, n, s) {
                return (i = i || new a(0, 0)).x = r(t, n, s), i.y = o(e, n, s), i;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = i.baseTileHeight, s = i.tilemapLayer, r = 0;
                s && (void 0 === e && (e = s.scene.cameras.main), r = s.y + e.scrollY * (1 - s.scrollFactorY), n *= s.scaleY);
                var o = s.tilemap.hexSideLength;
                return r + t * ((n - o) / 2 + o);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = i.baseTileHeight, s = i.tilemapLayer, r = 0;
                return s && (void 0 === e && (e = s.scene.cameras.main), r = s.y + e.scrollY * (1 - s.scrollFactorY), n *= s.scaleY), r + t * (n / 2);
            };
        },
        function(t, e, i) {
            var f = i(3);
            t.exports = function(t, e, i, n, s, r) {
                n = n || new f;
                var o = r.baseTileWidth, a = r.baseTileHeight, h = r.tilemapLayer;
                h && (s = s || h.scene.cameras.main, e -= h.y + s.scrollY * (1 - h.scrollFactorY), a *= h.scaleY, t -= h.x + s.scrollX * (1 - h.scrollFactorX), o *= h.scaleX);
                var l = r.hexSideLength, u = (a - l) / 2 + l, c = i ? Math.floor(e / u) : e / u, d = i ? Math.floor((t - c % 2 * .5 * o) / o) : (t - c % 2 * .5 * o) / o;
                return n.set(d, c);
            };
        },
        function(t, e, i) {
            var c = i(3);
            t.exports = function(t, e, i, n, s, r) {
                n = n || new c;
                var o = r.baseTileWidth, a = r.baseTileHeight, h = r.tilemapLayer;
                h && (s = s || h.scene.cameras.main, e -= h.y + s.scrollY * (1 - h.scrollFactorY), a *= h.scaleY, t -= h.x + s.scrollX * (1 - h.scrollFactorX), o *= h.scaleX), t -= o / 2;
                var l = i ? Math.floor((t / (o / 2) + e / (a / 2)) / 2) : (t / (o / 2) + e / (a / 2)) / 2, u = i ? Math.floor((e / (a / 2) - t / (o / 2)) / 2) : (e / (a / 2) - t / (o / 2)) / 2;
                return n.set(l, u);
            };
        },
        function(t, e, i) {
            var c = i(3);
            t.exports = function(t, e, i, n, s, r) {
                n = n || new c;
                var o = r.baseTileWidth, a = r.baseTileHeight, h = r.tilemapLayer;
                h && (s = s || h.scene.cameras.main, e -= h.y + s.scrollY * (1 - h.scrollFactorY), a *= h.scaleY, t -= h.x + s.scrollX * (1 - h.scrollFactorX), o *= h.scaleX);
                var l = i ? Math.floor(e / (a / 2)) : e / (a / 2), u = i ? Math.floor((t + l % 2 * .5 * o) / o) : (t + l % 2 * .5 * o) / o;
                return n.set(u, l);
            };
        },
        function(t, e, i) {
            var o = i(251), a = i(252), h = i(3);
            t.exports = function(t, e, i, n, s, r) {
                return void 0 === i && (i = !0), (n = n || new h(0, 0)).x = o(t, i, s, r), n.y = a(e, i, s, r), n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = n.baseTileHeight, r = n.tilemapLayer;
                r && (i = i || r.scene.cameras.main, t -= r.y + i.scrollY * (1 - r.scrollFactorY), s *= r.scaleY);
                var o = n.hexSideLength, a = (s - o) / 2 + o;
                return e ? Math.floor(t / a) : t / a;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = n.baseTileHeight, r = n.tilemapLayer;
                return r && (i = i || r.scene.cameras.main, t -= r.y + i.scrollY * (1 - r.scrollFactorY), s *= r.scaleY), e ? Math.floor(t / (s / 2)) : t / (s / 2);
            };
        },
        function(t, e, i) {
            var s = i(118);
            t.exports = function(t, e, i) {
                if (s(t, e, i)) {
                    var n = i.data[e][t];
                    return null !== n && -1 < n.index;
                }
                return !1;
            };
        },
        function(t, e, i) {
            var o = i(83), a = i(118), h = i(248);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === i && (i = !0), void 0 === n && (n = !0), !a(t, e, s)) return null;
                var r = s.data[e][t];
                return r ? (s.data[e][t] = i ? null : new o(s, -1, t, e, s.tileWidth, s.tileHeight), n && r && r.collides && h(t, e, s), r) : null;
            };
        },
        function(t, e, i) {
            var a = i(39), h = i(255), l = i(561), u = i(562), c = i(573);
            t.exports = function(t, e, i, n, s, r) {
                var o;
                switch(e){
                    case a.ARRAY_2D:
                        o = h(t, i, n, s, r);
                        break;
                    case a.CSV:
                        o = l(t, i, n, s, r);
                        break;
                    case a.TILED_JSON:
                        o = u(t, i, r);
                        break;
                    case a.WELTMEISTER:
                        o = c(t, i, r);
                        break;
                    default:
                        console.warn("Unrecognized tilemap data format: " + e), o = null;
                }
                return o;
            };
        },
        function(t, e, i) {
            var a = i(39), h = i(255);
            t.exports = function(t, e, i, n, s) {
                var r = e.trim().split("\n").map(function(t) {
                    return t.split(",");
                }), o = h(t, r, i, n, s);
                return o.format = a.CSV, o;
            };
        },
        function(t, e, i) {
            var r = i(563), o = i(564), a = i(29), h = i(39), l = i(254), u = i(120), c = i(565), d = i(566), f = i(569), p = i(571);
            t.exports = function(t, e, i) {
                var n = new u({
                    width: e.width,
                    height: e.height,
                    name: t,
                    tileWidth: e.tilewidth,
                    tileHeight: e.tileheight,
                    orientation: l(e.orientation),
                    format: h.TILED_JSON,
                    version: e.version,
                    properties: e.properties,
                    renderOrder: e.renderorder,
                    infinite: e.infinite
                });
                n.orientation === a.HEXAGONAL && (n.hexSideLength = e.hexsidelength), n.layers = f(e, i), n.images = c(e);
                var s = p(e);
                return n.tilesets = s.tilesets, n.imageCollections = s.imageCollections, n.objects = d(e), n.tiles = o(n), r(n), n;
            };
        },
        function(t, e, i) {
            var l = i(17);
            t.exports = function(t) {
                for(var e, i, n, s, r, o = 0; o < t.layers.length; o++){
                    e = t.layers[o];
                    for(var a = 0; a < e.data.length; a++){
                        r = e.data[a];
                        for(var h = 0; h < r.length; h++)null === (i = r[h]) || i.index < 0 || (n = t.tiles[i.index][2], s = t.tilesets[n], i.width = s.tileWidth, i.height = s.tileHeight, s.tileProperties && s.tileProperties[i.index - s.firstgid] && (i.properties = l(i.properties, s.tileProperties[i.index - s.firstgid])));
                    }
                }
            };
        },
        function(t, e, i) {
            var p = i(121);
            t.exports = function(t) {
                for(var e = [], i = 0; i < t.imageCollections.length; i++)for(var n = t.imageCollections[i], s = n.images, r = 0; r < s.length; r++){
                    var o, a = s[r];
                    (o = new p(a.image, a.gid, n.imageWidth, n.imageHeight, 0, 0)).updateTileData(n.imageWidth, n.imageHeight), t.tilesets.push(o);
                }
                for(i = 0; i < t.tilesets.length; i++)for(var h = (o = t.tilesets[i]).tileMargin, l = o.tileMargin, u = 0, c = 0, d = 0, f = o.firstgid; f < o.firstgid + o.total && (e[f] = [
                    h,
                    l,
                    i
                ], h += o.tileWidth + o.tileSpacing, ++u !== o.total) && (++c !== o.columns || (h = o.tileMargin, l += o.tileHeight + o.tileSpacing, c = 0, ++d !== o.rows)); f++);
                return e;
            };
        },
        function(t, e, i) {
            var h = i(2), l = i(159);
            t.exports = function(t) {
                for(var e = [], i = [], n = l(t); n.i < n.layers.length || 0 < i.length;)if (n.i >= n.layers.length) {
                    if (i.length < 1) {
                        console.warn("TilemapParser.parseTiledJSON - Invalid layer group hierarchy");
                        break;
                    }
                    n = i.pop();
                } else {
                    var s, r, o, a = n.layers[n.i];
                    n.i++, "imagelayer" === a.type ? (s = h(a, "offsetx", 0) + h(a, "startx", 0), r = h(a, "offsety", 0) + h(a, "starty", 0), e.push({
                        name: n.name + a.name,
                        image: a.image,
                        x: n.x + s + a.x,
                        y: n.y + r + a.y,
                        alpha: n.opacity * a.opacity,
                        visible: n.visible && a.visible,
                        properties: h(a, "properties", {})
                    })) : "group" === a.type && (o = l(t, a, n), i.push(n), n = o);
                }
                return e;
            };
        },
        function(t, e, i) {
            var d = i(2), f = i(256), p = i(568), g = i(159);
            t.exports = function(t) {
                for(var e = [], i = [], n = g(t); n.i < n.layers.length || 0 < i.length;)if (n.i >= n.layers.length) {
                    if (i.length < 1) {
                        console.warn("TilemapParser.parseTiledJSON - Invalid layer group hierarchy");
                        break;
                    }
                    n = i.pop();
                } else {
                    var s, r = n.layers[n.i];
                    if (n.i++, r.opacity *= n.opacity, r.visible = n.visible && r.visible, "objectgroup" === r.type) {
                        r.name = n.name + r.name;
                        for(var o = n.x + d(r, "startx", 0) + d(r, "offsetx", 0), a = n.y + d(r, "starty", 0) + d(r, "offsety", 0), h = [], l = 0; l < r.objects.length; l++){
                            var u = f(r.objects[l], o, a);
                            h.push(u);
                        }
                        var c = new p(r);
                        c.objects = h, e.push(c);
                    } else "group" === r.type && (s = g(t, r, n), i.push(n), n = s);
                }
                return e;
            };
        },
        function(t, e, i) {
            var r = i(125);
            t.exports = function(t, e) {
                for(var i = {}, n = 0; n < e.length; n++){
                    var s = e[n];
                    r(t, s) && (i[s] = t[s]);
                }
                return i;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = new n({
                initialize: function(t) {
                    void 0 === t && (t = {}), this.name = s(t, "name", "object layer"), this.opacity = s(t, "opacity", 1), this.properties = s(t, "properties", {}), this.propertyTypes = s(t, "propertytypes", {}), this.type = s(t, "type", "objectgroup"), this.visible = s(t, "visible", !0), this.objects = s(t, "objects", []);
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var P = i(570), O = i(29), L = i(159), D = i(254), F = i(2), k = i(119), I = i(257), B = i(83);
            t.exports = function(t, e) {
                for(var i = F(t, "infinite", !1), n = [], s = [], r = L(t); r.i < r.layers.length || 0 < s.length;)if (r.i >= r.layers.length) {
                    if (s.length < 1) {
                        console.warn("TilemapParser.parseTiledJSON - Invalid layer group hierarchy");
                        break;
                    }
                    r = s.pop();
                } else {
                    var o, a = r.layers[r.i];
                    if (r.i++, "tilelayer" === a.type) {
                        if (a.compression) console.warn("TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer '" + a.name + "'");
                        else {
                            if (a.encoding && "base64" === a.encoding) {
                                if (a.chunks) for(var h = 0; h < a.chunks.length; h++)a.chunks[h].data = P(a.chunks[h].data);
                                a.data && (a.data = P(a.data)), delete a.encoding;
                            }
                            var l, u, c = [], d = 0;
                            if (i) {
                                var f, p = F(a, "startx", 0) + a.x, g = F(a, "starty", 0) + a.y;
                                (f = new k({
                                    name: r.name + a.name,
                                    x: r.x + F(a, "offsetx", 0) + p * t.tilewidth,
                                    y: r.y + F(a, "offsety", 0) + g * t.tileheight,
                                    width: a.width,
                                    height: a.height,
                                    tileWidth: t.tilewidth,
                                    tileHeight: t.tileheight,
                                    alpha: r.opacity * a.opacity,
                                    visible: r.visible && a.visible,
                                    properties: F(a, "properties", []),
                                    orientation: D(t.orientation)
                                })).orientation === O.HEXAGONAL && (f.hexSideLength = t.hexsidelength);
                                for(var v = 0; v < a.height; v++){
                                    c.push([
                                        null
                                    ]);
                                    for(var m = 0; m < a.width; m++)c[v][m] = null;
                                }
                                for(v = 0, R = a.chunks.length; v < R; v++)for(var y = a.chunks[v], x = y.x - p, T = y.y - g, w = 0, b = 0, E = y.data.length; b < E; b++){
                                    var S, A = d + x, _ = w + T;
                                    0 < (S = I(y.data[b])).gid ? ((l = new B(f, S.gid, A, _, t.tilewidth, t.tileheight)).rotation = S.rotation, l.flipX = S.flipped, c[_][A] = l) : (u = e ? null : new B(f, -1, A, _, t.tilewidth, t.tileheight), c[_][A] = u), ++d === y.width && (w++, d = 0);
                                }
                            } else {
                                (f = new k({
                                    name: r.name + a.name,
                                    x: r.x + F(a, "offsetx", 0) + a.x,
                                    y: r.y + F(a, "offsety", 0) + a.y,
                                    width: a.width,
                                    height: a.height,
                                    tileWidth: t.tilewidth,
                                    tileHeight: t.tileheight,
                                    alpha: r.opacity * a.opacity,
                                    visible: r.visible && a.visible,
                                    properties: F(a, "properties", []),
                                    orientation: D(t.orientation)
                                })).orientation === O.HEXAGONAL && (f.hexSideLength = t.hexsidelength);
                                for(var C = [], M = 0, R = a.data.length; M < R; M++)0 < (S = I(a.data[M])).gid ? ((l = new B(f, S.gid, d, c.length, t.tilewidth, t.tileheight)).rotation = S.rotation, l.flipX = S.flipped, C.push(l)) : (u = e ? null : new B(f, -1, d, c.length, t.tilewidth, t.tileheight), C.push(u)), ++d === a.width && (c.push(C), d = 0, C = []);
                            }
                            f.data = c, n.push(f);
                        }
                    } else "group" === a.type && (o = L(t, a, r), s.push(r), r = o);
                }
                return n;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                for(var e = window.atob(t), i = e.length, n = new Array(i / 4), s = 0; s < i; s += 4)n[s / 4] = (e.charCodeAt(s) | e.charCodeAt(s + 1) << 8 | e.charCodeAt(s + 2) << 16 | e.charCodeAt(s + 3) << 24) >>> 0;
                return n;
            };
        },
        function(t, e, i) {
            var w = i(121), b = i(572), E = i(256);
            t.exports = function(t) {
                for(var e, i = [], n = [], s = null, r = 0; r < t.tilesets.length; r++){
                    var o = t.tilesets[r];
                    if (o.source) console.warn("External tilesets unsupported. Use Embed Tileset and re-export");
                    else if (o.image) {
                        var a = new w(o.name, o.firstgid, o.tilewidth, o.tileheight, o.margin, o.spacing);
                        if (1 < t.version) {
                            if (Array.isArray(o.tiles)) {
                                for(var h = {}, l = {}, u = 0; u < o.tiles.length; u++){
                                    var c, d, f = o.tiles[u];
                                    f.properties && (c = {}, f.properties.forEach(function(t) {
                                        c[t.name] = t.value;
                                    }), l[f.id] = c), f.objectgroup && (h[f.id] = {
                                        objectgroup: f.objectgroup
                                    }, f.objectgroup.objects && (d = f.objectgroup.objects.map(function(t) {
                                        return E(t);
                                    }), h[f.id].objectgroup.objects = d)), f.animation && (h.hasOwnProperty(f.id) ? h[f.id].animation = f.animation : h[f.id] = {
                                        animation: f.animation
                                    });
                                }
                                a.tileData = h, a.tileProperties = l;
                            }
                        } else if (o.tileproperties && (a.tileProperties = o.tileproperties), o.tiles) for(e in a.tileData = o.tiles, a.tileData){
                            var p, g = a.tileData[e].objectgroup;
                            g && g.objects && (p = g.objects.map(function(t) {
                                return E(t);
                            }), a.tileData[e].objectgroup.objects = p);
                        }
                        a.updateTileData(o.imagewidth, o.imageheight), i.push(a);
                    } else {
                        for(var v = new b(o.name, o.firstgid, o.tilewidth, o.tileheight, o.margin, o.spacing, o.properties), m = 0, u = 0; u < o.tiles.length; u++){
                            var y = (f = o.tiles[u]).image, x = parseInt(f.id, 10), T = o.firstgid + x;
                            v.addImage(T, y), m = Math.max(x, m);
                        }
                        v.maxId = m, n.push(v);
                    }
                    s && (s.lastgid = o.firstgid - 1), s = o;
                }
                return {
                    tilesets: i,
                    imageCollections: n
                };
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t, e, i, n, s, r, o) {
                    (void 0 === i || i <= 0) && (i = 32), (void 0 === n || n <= 0) && (n = 32), void 0 === s && (s = 0), void 0 === r && (r = 0), this.name = t, this.firstgid = 0 | e, this.imageWidth = 0 | i, this.imageHeight = 0 | n, this.imageMargin = 0 | s, this.imageSpacing = 0 | r, this.properties = o || {}, this.images = [], this.total = 0;
                },
                containsImageIndex: function(t) {
                    return t >= this.firstgid && t < this.firstgid + this.total;
                },
                addImage: function(t, e) {
                    return this.images.push({
                        gid: t,
                        image: e
                    }), this.total++, this;
                }
            });
            t.exports = n;
        },
        function(t, e, i) {
            var a = i(39), h = i(120), l = i(574), u = i(575);
            t.exports = function(t, e, i) {
                if (0 === e.layer.length) return console.warn("No layers found in the Weltmeister map: " + t), null;
                for(var n = 0, s = 0, r = 0; r < e.layer.length; r++)e.layer[r].width > n && (n = e.layer[r].width), e.layer[r].height > s && (s = e.layer[r].height);
                var o = new h({
                    width: n,
                    height: s,
                    name: t,
                    tileWidth: e.layer[0].tilesize,
                    tileHeight: e.layer[0].tilesize,
                    format: a.WELTMEISTER
                });
                return o.layers = l(e, i), o.tilesets = u(e), o;
            };
        },
        function(t, e, i) {
            var d = i(119), f = i(83);
            t.exports = function(t, e) {
                for(var i = [], n = 0; n < t.layer.length; n++){
                    for(var s = t.layer[n], r = new d({
                        name: s.name,
                        width: s.width,
                        height: s.height,
                        tileWidth: s.tilesize,
                        tileHeight: s.tilesize,
                        visible: 1 === s.visible
                    }), o = [], a = [], h = 0; h < s.data.length; h++){
                        for(var l = 0; l < s.data[h].length; l++){
                            var u = s.data[h][l] - 1, c = -1 < u ? new f(r, u, l, h, s.tilesize, s.tilesize) : e ? null : new f(r, -1, l, h, s.tilesize, s.tilesize);
                            o.push(c);
                        }
                        a.push(o), o = [];
                    }
                    r.data = a, i.push(r);
                }
                return i;
            };
        },
        function(t, e, i) {
            var o = i(121);
            t.exports = function(t) {
                for(var e = [], i = [], n = 0; n < t.layer.length; n++){
                    var s = t.layer[n], r = s.tilesetName;
                    "" !== r && -1 === i.indexOf(r) && (i.push(r), e.push(new o(r, 0, s.tilesize, s.tilesize, 0, 0)));
                }
                return e;
            };
        },
        function(t, e, i) {
            var n = i(0), E = i(35), u = i(39), S = i(2), f = i(119), s = i(29), A = i(356), r = i(74), _ = i(73), p = i(83), h = i(247), g = i(577), c = i(121), o = new n({
                initialize: function(t, e) {
                    this.scene = t, this.tileWidth = e.tileWidth, this.tileHeight = e.tileHeight, this.width = e.width, this.height = e.height, this.orientation = e.orientation, this.renderOrder = e.renderOrder, this.format = e.format, this.version = e.version, this.properties = e.properties, this.widthInPixels = e.widthInPixels, this.heightInPixels = e.heightInPixels, this.imageCollections = e.imageCollections, this.images = e.images, this.layers = e.layers, this.tilesets = e.tilesets, this.objects = e.objects, this.currentLayerIndex = 0, this.hexSideLength = e.hexSideLength;
                    var i = this.orientation;
                    this._convert = {
                        WorldToTileXY: h.GetWorldToTileXYFunction(i),
                        WorldToTileX: h.GetWorldToTileXFunction(i),
                        WorldToTileY: h.GetWorldToTileYFunction(i),
                        TileToWorldXY: h.GetTileToWorldXYFunction(i),
                        TileToWorldX: h.GetTileToWorldXFunction(i),
                        TileToWorldY: h.GetTileToWorldYFunction(i)
                    };
                },
                createBlankDynamicLayer: function(t, e, i, n, s, r, o, a) {
                    return console.warn("createBlankDynamicLayer is deprecated. Use createBlankLayer"), this.createBlankLayer(t, e, i, n, s, r, o, a);
                },
                createDynamicLayer: function(t, e, i, n) {
                    return console.warn("createDynamicLayer is deprecated. Use createLayer"), this.createLayer(t, e, i, n);
                },
                createStaticLayer: function(t, e, i, n) {
                    return console.warn("createStaticLayer is deprecated. Use createLayer"), this.createLayer(t, e, i, n);
                },
                setRenderOrder: function(t) {
                    var e = [
                        "right-down",
                        "left-down",
                        "right-up",
                        "left-up"
                    ];
                    return "number" == typeof t && (t = e[t]), -1 < e.indexOf(t) && (this.renderOrder = t), this;
                },
                addTilesetImage: function(t, e, i, n, s, r, o) {
                    if (void 0 === t) return null;
                    if (null == e && (e = t), !this.scene.sys.textures.exists(e)) return console.warn("Invalid Tileset Image: " + e), null;
                    var a = this.scene.sys.textures.get(e), h = this.getTilesetIndex(t);
                    if (null === h && this.format === u.TILED_JSON) return console.warn("No data found for Tileset: " + t), null;
                    var l = this.tilesets[h];
                    return l ? (l.setTileSize(i, n), l.setSpacing(s, r), l.setImage(a)) : (void 0 === i && (i = this.tileWidth), void 0 === n && (n = this.tileHeight), void 0 === s && (s = 0), void 0 === r && (r = 0), void 0 === o && (o = 0), (l = new c(t, o, i, n, s, r)).setImage(a), this.tilesets.push(l)), l;
                },
                copy: function(t, e, i, n, s, r, o, a) {
                    return null !== (a = this.getLayer(a)) ? (h.Copy(t, e, i, n, s, r, o, a), this) : null;
                },
                createBlankLayer: function(t, e, i, n, s, r, o, a) {
                    if (void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = this.width), void 0 === r && (r = this.height), void 0 === o && (o = this.tileWidth), void 0 === a && (a = this.tileHeight), null !== this.getLayerIndex(t)) return console.warn("Invalid Tilemap Layer ID: " + t), null;
                    for(var h, l = new f({
                        name: t,
                        tileWidth: o,
                        tileHeight: a,
                        width: s,
                        height: r,
                        orientation: this.orientation
                    }), u = 0; u < r; u++){
                        h = [];
                        for(var c = 0; c < s; c++)h.push(new p(l, -1, c, u, o, a, this.tileWidth, this.tileHeight));
                        l.data.push(h);
                    }
                    this.layers.push(l), this.currentLayerIndex = this.layers.length - 1;
                    var d = new g(this.scene, this, this.currentLayerIndex, e, i, n);
                    return d.setRenderOrder(this.renderOrder), this.scene.sys.displayList.add(d), d;
                },
                createLayer: function(t, e, i, n) {
                    var s = this.getLayerIndex(t);
                    if (null === s) return console.warn("Invalid Tilemap Layer ID: " + t), "string" == typeof t && console.warn("Valid tilelayer names:\n	" + this.getTileLayerNames().join(",\n	")), null;
                    var r = this.layers[s];
                    if (r.tilemapLayer) return console.warn("Tilemap Layer ID already exists:" + t), null;
                    this.currentLayerIndex = s, void 0 === i && (i = r.x), void 0 === n && (n = r.y);
                    var o = new g(this.scene, this, s, e, i, n);
                    return o.setRenderOrder(this.renderOrder), this.scene.sys.displayList.add(o), o;
                },
                createFromObjects: function(t, e) {
                    var i = [], n = this.getObjectLayer(t);
                    if (!n) return console.warn("createFromObjects: Invalid objectLayerName given: " + t), i;
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for(var s = n.objects, r = 0; r < e.length; r++){
                        for(var o, a = e[r], h = S(a, "id", null), l = S(a, "gid", null), u = S(a, "name", null), c = [], d = 0; d < s.length; d++)o = s[d], (null === h && null === l && null === u || null !== h && o.id === h || null !== l && o.gid === l || null !== u && o.name === u) && c.push(o);
                        for(var f = S(a, "classType", _), p = S(a, "scene", this.scene), g = S(a, "container", null), v = S(a, "key", null), m = S(a, "frame", null), y = 0; y < c.length; y++){
                            o = c[y];
                            var x = new f(p);
                            x.setName(o.name), x.setPosition(o.x, o.y), x.setTexture(v, m), o.width && (x.displayWidth = o.width), o.height && (x.displayHeight = o.height);
                            var T, w = {
                                x: x.originX * o.width,
                                y: (x.originY - 1) * o.height
                            };
                            for(var b in o.rotation && (T = E(o.rotation), A(w, T), x.rotation = T), x.x += w.x, x.y += w.y, void 0 === o.flippedHorizontal && void 0 === o.flippedVertical || x.setFlip(o.flippedHorizontal, o.flippedVertical), o.visible || (x.visible = !1), o.properties)void 0 !== x[b] ? x[b] = o.properties[b] : x.setData(b, o.properties[b]);
                            g ? g.add(x) : p.add.existing(x), i.push(x);
                        }
                    }
                    return i;
                },
                createFromTiles: function(t, e, i, n, s, r) {
                    return null === (r = this.getLayer(r)) ? null : h.CreateFromTiles(t, e, i, n, s, r);
                },
                fill: function(t, e, i, n, s, r, o) {
                    return void 0 === r && (r = !0), null === (o = this.getLayer(o)) ? null : (h.Fill(t, e, i, n, s, r, o), this);
                },
                filterObjects: function(t, e, i) {
                    if ("string" == typeof t) {
                        var n = t;
                        if (!(t = this.getObjectLayer(t))) return console.warn("No object layer found with the name: " + n), null;
                    }
                    return t.objects.filter(e, i);
                },
                filterTiles: function(t, e, i, n, s, r, o, a) {
                    return null === (a = this.getLayer(a)) ? null : h.FilterTiles(t, e, i, n, s, r, o, a);
                },
                findByIndex: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : h.FindByIndex(t, e, i, n);
                },
                findObject: function(t, e, i) {
                    if ("string" == typeof t) {
                        var n = t;
                        if (!(t = this.getObjectLayer(t))) return console.warn("No object layer found with the name: " + n), null;
                    }
                    return t.objects.find(e, i) || null;
                },
                findTile: function(t, e, i, n, s, r, o, a) {
                    return null === (a = this.getLayer(a)) ? null : h.FindTile(t, e, i, n, s, r, o, a);
                },
                forEachTile: function(t, e, i, n, s, r, o, a) {
                    return null === (a = this.getLayer(a)) ? null : (h.ForEachTile(t, e, i, n, s, r, o, a), this);
                },
                getImageIndex: function(t) {
                    return this.getIndex(this.images, t);
                },
                getImageLayerNames: function() {
                    return this.images && Array.isArray(this.images) ? this.images.map(function(t) {
                        return t.name;
                    }) : [];
                },
                getIndex: function(t, e) {
                    for(var i = 0; i < t.length; i++)if (t[i].name === e) return i;
                    return null;
                },
                getLayer: function(t) {
                    var e = this.getLayerIndex(t);
                    return null !== e ? this.layers[e] : null;
                },
                getObjectLayer: function(t) {
                    var e = this.getIndex(this.objects, t);
                    return null !== e ? this.objects[e] : null;
                },
                getObjectLayerNames: function() {
                    return this.objects && Array.isArray(this.objects) ? this.objects.map(function(t) {
                        return t.name;
                    }) : [];
                },
                getLayerIndex: function(t) {
                    return void 0 === t ? this.currentLayerIndex : "string" == typeof t ? this.getLayerIndexByName(t) : "number" == typeof t && t < this.layers.length ? t : t instanceof g ? t.layerIndex : null;
                },
                getLayerIndexByName: function(t) {
                    return this.getIndex(this.layers, t);
                },
                getTileAt: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : h.GetTileAt(t, e, i, n);
                },
                getTileAtWorldXY: function(t, e, i, n, s) {
                    return null === (s = this.getLayer(s)) ? null : h.GetTileAtWorldXY(t, e, i, n, s);
                },
                getTileLayerNames: function() {
                    return this.layers && Array.isArray(this.layers) ? this.layers.map(function(t) {
                        return t.name;
                    }) : [];
                },
                getTilesWithin: function(t, e, i, n, s, r) {
                    return null === (r = this.getLayer(r)) ? null : h.GetTilesWithin(t, e, i, n, s, r);
                },
                getTilesWithinShape: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : h.GetTilesWithinShape(t, e, i, n);
                },
                getTilesWithinWorldXY: function(t, e, i, n, s, r, o) {
                    return null === (o = this.getLayer(o)) ? null : h.GetTilesWithinWorldXY(t, e, i, n, s, r, o);
                },
                getTileset: function(t) {
                    var e = this.getIndex(this.tilesets, t);
                    return null !== e ? this.tilesets[e] : null;
                },
                getTilesetIndex: function(t) {
                    return this.getIndex(this.tilesets, t);
                },
                hasTileAt: function(t, e, i) {
                    return null === (i = this.getLayer(i)) ? null : h.HasTileAt(t, e, i);
                },
                hasTileAtWorldXY: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : h.HasTileAtWorldXY(t, e, i, n);
                },
                layer: {
                    get: function() {
                        return this.layers[this.currentLayerIndex];
                    },
                    set: function(t) {
                        this.setLayer(t);
                    }
                },
                putTileAt: function(t, e, i, n, s) {
                    return void 0 === n && (n = !0), null === (s = this.getLayer(s)) ? null : h.PutTileAt(t, e, i, n, s);
                },
                putTileAtWorldXY: function(t, e, i, n, s, r) {
                    return void 0 === n && (n = !0), null === (r = this.getLayer(r)) ? null : h.PutTileAtWorldXY(t, e, i, n, s, r);
                },
                putTilesAt: function(t, e, i, n, s) {
                    return void 0 === n && (n = !0), null === (s = this.getLayer(s)) ? null : (h.PutTilesAt(t, e, i, n, s), this);
                },
                randomize: function(t, e, i, n, s, r) {
                    return null === (r = this.getLayer(r)) ? null : (h.Randomize(t, e, i, n, s, r), this);
                },
                calculateFacesAt: function(t, e, i) {
                    return null === (i = this.getLayer(i)) ? null : (h.CalculateFacesAt(t, e, i), this);
                },
                calculateFacesWithin: function(t, e, i, n, s) {
                    return null === (s = this.getLayer(s)) ? null : (h.CalculateFacesWithin(t, e, i, n, s), this);
                },
                removeLayer: function(t) {
                    var e = this.getLayerIndex(t);
                    if (null === e) return null;
                    r(this.layers, e);
                    for(var i = e; i < this.layers.length; i++)this.layers[i].tilemapLayer && this.layers[i].tilemapLayer.layerIndex--;
                    return this.currentLayerIndex === e && (this.currentLayerIndex = 0), this;
                },
                destroyLayer: function(t) {
                    var e = this.getLayerIndex(t);
                    return null !== e ? ((t = this.layers[e]).destroy(), r(this.layers, e), this.currentLayerIndex === e && (this.currentLayerIndex = 0), this) : null;
                },
                removeAllLayers: function() {
                    for(var t = this.layers, e = 0; e < t.length; e++)t[e].tilemapLayer && t[e].tilemapLayer.destroy(!1);
                    return t.length = 0, this.currentLayerIndex = 0, this;
                },
                removeTile: function(t, e, i) {
                    void 0 === e && (e = -1), void 0 === i && (i = !0);
                    var n = [];
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var s = 0; s < t.length; s++){
                        var r = t[s];
                        n.push(this.removeTileAt(r.x, r.y, !0, i, r.tilemapLayer)), -1 < e && this.putTileAt(e, r.x, r.y, i, r.tilemapLayer);
                    }
                    return n;
                },
                removeTileAt: function(t, e, i, n, s) {
                    return void 0 === i && (i = !0), void 0 === n && (n = !0), null === (s = this.getLayer(s)) ? null : h.RemoveTileAt(t, e, i, n, s);
                },
                removeTileAtWorldXY: function(t, e, i, n, s, r) {
                    return void 0 === i && (i = !0), void 0 === n && (n = !0), null === (r = this.getLayer(r)) ? null : h.RemoveTileAtWorldXY(t, e, i, n, s, r);
                },
                renderDebug: function(t, e, i) {
                    return null === (i = this.getLayer(i)) ? null : (this.orientation === s.ORTHOGONAL && h.RenderDebug(t, e, i), this);
                },
                renderDebugFull: function(t, e) {
                    for(var i = this.layers, n = 0; n < i.length; n++)h.RenderDebug(t, e, i[n]);
                    return this;
                },
                replaceByIndex: function(t, e, i, n, s, r, o) {
                    return null === (o = this.getLayer(o)) ? null : (h.ReplaceByIndex(t, e, i, n, s, r, o), this);
                },
                setCollision: function(t, e, i, n, s) {
                    return void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === s && (s = !0), null === (n = this.getLayer(n)) ? null : (h.SetCollision(t, e, i, n, s), this);
                },
                setCollisionBetween: function(t, e, i, n, s) {
                    return void 0 === i && (i = !0), void 0 === n && (n = !0), null === (s = this.getLayer(s)) ? null : (h.SetCollisionBetween(t, e, i, n, s), this);
                },
                setCollisionByProperty: function(t, e, i, n) {
                    return void 0 === e && (e = !0), void 0 === i && (i = !0), null === (n = this.getLayer(n)) ? null : (h.SetCollisionByProperty(t, e, i, n), this);
                },
                setCollisionByExclusion: function(t, e, i, n) {
                    return void 0 === e && (e = !0), void 0 === i && (i = !0), null === (n = this.getLayer(n)) ? null : (h.SetCollisionByExclusion(t, e, i, n), this);
                },
                setCollisionFromCollisionGroup: function(t, e, i) {
                    return void 0 === t && (t = !0), void 0 === e && (e = !0), null === (i = this.getLayer(i)) ? null : (h.SetCollisionFromCollisionGroup(t, e, i), this);
                },
                setTileIndexCallback: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : (h.SetTileIndexCallback(t, e, i, n), this);
                },
                setTileLocationCallback: function(t, e, i, n, s, r, o) {
                    return null === (o = this.getLayer(o)) ? null : (h.SetTileLocationCallback(t, e, i, n, s, r, o), this);
                },
                setLayer: function(t) {
                    var e = this.getLayerIndex(t);
                    return null !== e && (this.currentLayerIndex = e), this;
                },
                setBaseTileSize: function(t, e) {
                    this.tileWidth = t, this.tileHeight = e, this.widthInPixels = this.width * t, this.heightInPixels = this.height * e;
                    for(var i = 0; i < this.layers.length; i++){
                        this.layers[i].baseTileWidth = t, this.layers[i].baseTileHeight = e;
                        for(var n = this.layers[i].data, s = this.layers[i].width, r = this.layers[i].height, o = 0; o < r; o++)for(var a = 0; a < s; a++){
                            var h = n[o][a];
                            null !== h && h.setSize(void 0, void 0, t, e);
                        }
                    }
                    return this;
                },
                setLayerTileSize: function(t, e, i) {
                    if (null === (i = this.getLayer(i))) return this;
                    i.tileWidth = t, i.tileHeight = e;
                    for(var n = i.data, s = i.width, r = i.height, o = 0; o < r; o++)for(var a = 0; a < s; a++){
                        var h = n[o][a];
                        null !== h && h.setSize(t, e);
                    }
                    return this;
                },
                shuffle: function(t, e, i, n, s) {
                    return null === (s = this.getLayer(s)) ? null : (h.Shuffle(t, e, i, n, s), this);
                },
                swapByIndex: function(t, e, i, n, s, r, o) {
                    return null === (o = this.getLayer(o)) ? null : (h.SwapByIndex(t, e, i, n, s, r, o), this);
                },
                tileToWorldX: function(t, e, i) {
                    return null === (i = this.getLayer(i)) ? null : this._convert.TileToWorldX(t, e, i);
                },
                tileToWorldY: function(t, e, i) {
                    return null === (i = this.getLayer(i)) ? null : this._convert.TileToWorldY(t, e, i);
                },
                tileToWorldXY: function(t, e, i, n, s) {
                    return null === (s = this.getLayer(s)) ? null : this._convert.TileToWorldXY(t, e, i, n, s);
                },
                weightedRandomize: function(t, e, i, n, s, r) {
                    return null === (r = this.getLayer(r)) ? null : (h.WeightedRandomize(e, i, n, s, t, r), this);
                },
                worldToTileX: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : this._convert.WorldToTileX(t, e, i, n);
                },
                worldToTileY: function(t, e, i, n) {
                    return null === (n = this.getLayer(n)) ? null : this._convert.WorldToTileY(t, e, i, n);
                },
                worldToTileXY: function(t, e, i, n, s, r) {
                    return null === (r = this.getLayer(r)) ? null : this._convert.WorldToTileXY(t, e, i, n, s, r);
                },
                destroy: function() {
                    this.removeAllLayers(), this.tilesets.length = 0, this.objects.length = 0, this.scene = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(11), o = i(15), a = i(247), r = i(1449), h = new n({
                Extends: o,
                Mixins: [
                    s.Alpha,
                    s.BlendMode,
                    s.ComputedSize,
                    s.Depth,
                    s.Flip,
                    s.GetBounds,
                    s.Origin,
                    s.Pipeline,
                    s.Transform,
                    s.Visible,
                    s.ScrollFactor,
                    r
                ],
                initialize: function(t, e, i, n, s, r) {
                    o.call(this, t, "TilemapLayer"), this.isTilemap = !0, this.tilemap = e, this.layerIndex = i, this.layer = e.layers[i], (this.layer.tilemapLayer = this).tileset = [], this.tilesDrawn = 0, this.tilesTotal = this.layer.width * this.layer.height, this.culledTiles = [], this.skipCull = !1, this.cullPaddingX = 1, this.cullPaddingY = 1, this.cullCallback = a.GetCullTilesFunction(this.layer.orientation), this._renderOrder = 0, this.gidMap = [], this.setTilesets(n), this.setAlpha(this.layer.alpha), this.setPosition(s, r), this.setOrigin(), this.setSize(e.tileWidth * this.layer.width, e.tileHeight * this.layer.height), this.initPipeline();
                },
                setTilesets: function(t) {
                    var e = [], i = [], n = this.tilemap;
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var s = 0; s < t.length; s++){
                        var r = t[s];
                        if ("string" == typeof r && (r = n.getTileset(r)), r) {
                            i.push(r);
                            for(var o = r.firstgid, a = 0; a < r.total; a++)e[o + a] = r;
                        }
                    }
                    this.gidMap = e, this.tileset = i;
                },
                setRenderOrder: function(t) {
                    return "string" == typeof t && (t = [
                        "right-down",
                        "left-down",
                        "right-up",
                        "left-up"
                    ].indexOf(t)), 0 <= t && t < 4 && (this._renderOrder = t), this;
                },
                calculateFacesAt: function(t, e) {
                    return a.CalculateFacesAt(t, e, this.layer), this;
                },
                calculateFacesWithin: function(t, e, i, n) {
                    return a.CalculateFacesWithin(t, e, i, n, this.layer), this;
                },
                createFromTiles: function(t, e, i, n, s) {
                    return a.CreateFromTiles(t, e, i, n, s, this.layer);
                },
                cull: function(t) {
                    return this.cullCallback(this.layer, t, this.culledTiles, this._renderOrder);
                },
                copy: function(t, e, i, n, s, r, o) {
                    return a.Copy(t, e, i, n, s, r, o, this.layer), this;
                },
                fill: function(t, e, i, n, s, r) {
                    return a.Fill(t, e, i, n, s, r, this.layer), this;
                },
                filterTiles: function(t, e, i, n, s, r, o) {
                    return a.FilterTiles(t, e, i, n, s, r, o, this.layer);
                },
                findByIndex: function(t, e, i) {
                    return a.FindByIndex(t, e, i, this.layer);
                },
                findTile: function(t, e, i, n, s, r, o) {
                    return a.FindTile(t, e, i, n, s, r, o, this.layer);
                },
                forEachTile: function(t, e, i, n, s, r, o) {
                    return a.ForEachTile(t, e, i, n, s, r, o, this.layer), this;
                },
                getTileAt: function(t, e, i) {
                    return a.GetTileAt(t, e, i, this.layer);
                },
                getTileAtWorldXY: function(t, e, i, n) {
                    return a.GetTileAtWorldXY(t, e, i, n, this.layer);
                },
                getTilesWithin: function(t, e, i, n, s) {
                    return a.GetTilesWithin(t, e, i, n, s, this.layer);
                },
                getTilesWithinShape: function(t, e, i) {
                    return a.GetTilesWithinShape(t, e, i, this.layer);
                },
                getTilesWithinWorldXY: function(t, e, i, n, s, r) {
                    return a.GetTilesWithinWorldXY(t, e, i, n, s, r, this.layer);
                },
                hasTileAt: function(t, e) {
                    return a.HasTileAt(t, e, this.layer);
                },
                hasTileAtWorldXY: function(t, e, i) {
                    return a.HasTileAtWorldXY(t, e, i, this.layer);
                },
                putTileAt: function(t, e, i, n) {
                    return a.PutTileAt(t, e, i, n, this.layer);
                },
                putTileAtWorldXY: function(t, e, i, n, s) {
                    return a.PutTileAtWorldXY(t, e, i, n, s, this.layer);
                },
                putTilesAt: function(t, e, i, n) {
                    return a.PutTilesAt(t, e, i, n, this.layer), this;
                },
                randomize: function(t, e, i, n, s) {
                    return a.Randomize(t, e, i, n, s, this.layer), this;
                },
                removeTileAt: function(t, e, i, n) {
                    return a.RemoveTileAt(t, e, i, n, this.layer);
                },
                removeTileAtWorldXY: function(t, e, i, n, s) {
                    return a.RemoveTileAtWorldXY(t, e, i, n, s, this.layer);
                },
                renderDebug: function(t, e) {
                    return a.RenderDebug(t, e, this.layer), this;
                },
                replaceByIndex: function(t, e, i, n, s, r) {
                    return a.ReplaceByIndex(t, e, i, n, s, r, this.layer), this;
                },
                setSkipCull: function(t) {
                    return void 0 === t && (t = !0), this.skipCull = t, this;
                },
                setCullPadding: function(t, e) {
                    return void 0 === t && (t = 1), void 0 === e && (e = 1), this.cullPaddingX = t, this.cullPaddingY = e, this;
                },
                setCollision: function(t, e, i, n) {
                    return a.SetCollision(t, e, i, this.layer, n), this;
                },
                setCollisionBetween: function(t, e, i, n) {
                    return a.SetCollisionBetween(t, e, i, n, this.layer), this;
                },
                setCollisionByProperty: function(t, e, i) {
                    return a.SetCollisionByProperty(t, e, i, this.layer), this;
                },
                setCollisionByExclusion: function(t, e, i) {
                    return a.SetCollisionByExclusion(t, e, i, this.layer), this;
                },
                setCollisionFromCollisionGroup: function(t, e) {
                    return a.SetCollisionFromCollisionGroup(t, e, this.layer), this;
                },
                setTileIndexCallback: function(t, e, i) {
                    return a.SetTileIndexCallback(t, e, i, this.layer), this;
                },
                setTileLocationCallback: function(t, e, i, n, s, r) {
                    return a.SetTileLocationCallback(t, e, i, n, s, r, this.layer), this;
                },
                shuffle: function(t, e, i, n) {
                    return a.Shuffle(t, e, i, n, this.layer), this;
                },
                swapByIndex: function(t, e, i, n, s, r) {
                    return a.SwapByIndex(t, e, i, n, s, r, this.layer), this;
                },
                tileToWorldX: function(t, e) {
                    return this.tilemap.tileToWorldX(t, e, this);
                },
                tileToWorldY: function(t, e) {
                    return this.tilemap.tileToWorldY(t, e, this);
                },
                tileToWorldXY: function(t, e, i, n) {
                    return this.tilemap.tileToWorldXY(t, e, i, n, this);
                },
                weightedRandomize: function(t, e, i, n, s) {
                    return a.WeightedRandomize(e, i, n, s, t, this.layer), this;
                },
                worldToTileX: function(t, e, i) {
                    return this.tilemap.worldToTileX(t, e, i, this);
                },
                worldToTileY: function(t, e, i) {
                    return this.tilemap.worldToTileY(t, e, i, this);
                },
                worldToTileXY: function(t, e, i, n, s) {
                    return this.tilemap.worldToTileXY(t, e, i, n, s, this);
                },
                destroy: function(t) {
                    void 0 === t && (t = !0), this.tilemap && (this.layer.tilemapLayer === this && (this.layer.tilemapLayer = void 0), t && this.tilemap.removeLayer(this), this.tilemap = void 0, this.layer = void 0, this.culledTiles.length = 0, this.cullCallback = null, this.gidMap = [], this.tileset = [], o.prototype.destroy.call(this));
                }
            });
            t.exports = h;
        },
        function(t, e, i) {
            var n = i(0), s = i(2), r = new n({
                initialize: function(t) {
                    this.delay = 0, this.repeat = 0, this.repeatCount = 0, this.loop = !1, this.callback, this.callbackScope, this.args, this.timeScale = 1, this.startAt = 0, this.elapsed = 0, this.paused = !1, this.hasDispatched = !1, this.reset(t);
                },
                reset: function(t) {
                    return this.delay = s(t, "delay", 0), this.repeat = s(t, "repeat", 0), this.loop = s(t, "loop", !1), this.callback = s(t, "callback", void 0), this.callbackScope = s(t, "callbackScope", this.callback), this.args = s(t, "args", []), this.timeScale = s(t, "timeScale", 1), this.startAt = s(t, "startAt", 0), this.paused = s(t, "paused", !1), this.elapsed = this.startAt, this.hasDispatched = !1, this.repeatCount = -1 === this.repeat || this.loop ? 999999999999 : this.repeat, this;
                },
                getProgress: function() {
                    return this.elapsed / this.delay;
                },
                getOverallProgress: function() {
                    if (0 < this.repeat) {
                        var t = this.delay + this.delay * this.repeat;
                        return (this.elapsed + this.delay * (this.repeat - this.repeatCount)) / t;
                    }
                    return this.getProgress();
                },
                getRepeatCount: function() {
                    return this.repeatCount;
                },
                getElapsed: function() {
                    return this.elapsed;
                },
                getElapsedSeconds: function() {
                    return .001 * this.elapsed;
                },
                getRemaining: function() {
                    return this.delay - this.elapsed;
                },
                getRemainingSeconds: function() {
                    return .001 * this.getRemaining();
                },
                getOverallRemaining: function() {
                    return this.delay * (1 + this.repeatCount) - this.elapsed;
                },
                getOverallRemainingSeconds: function() {
                    return .001 * this.getOverallRemaining();
                },
                remove: function(t) {
                    void 0 === t && (t = !1), this.elapsed = this.delay, this.hasDispatched = !t, this.repeatCount = 0;
                },
                destroy: function() {
                    this.callback = void 0, this.callbackScope = void 0, this.args = [];
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(1458);
            t.exports = function(t) {
                var e, i = [];
                if (t.hasOwnProperty("props")) for(e in t.props)"_" !== e.substr(0, 1) && i.push({
                    key: e,
                    value: t.props[e]
                });
                else for(e in t)-1 === n.indexOf(e) && "_" !== e.substr(0, 1) && i.push({
                    key: e,
                    value: t[e]
                });
                return i;
            };
        },
        function(t, e, i) {
            var n = i(6);
            t.exports = function(t) {
                var e = n(t, "tweens", null);
                return null === e ? [] : ("function" == typeof e && (e = e.call()), Array.isArray(e) || (e = [
                    e
                ]), e);
            };
        },
        function(t, e, i) {
            var _ = i(261), C = i(13), M = i(96), R = i(80), P = i(160), O = i(6), L = i(260), D = i(262), F = i(264);
            t.exports = function(t, e, i) {
                void 0 === i && (i = _);
                var n = O(e, "from", 0), s = O(e, "to", 1), r = [
                    {
                        value: n
                    }
                ], o = P(e, "delay", i.delay), a = P(e, "duration", i.duration), h = O(e, "easeParams", i.easeParams), l = R(O(e, "ease", i.ease), h), u = P(e, "hold", i.hold), c = P(e, "repeat", i.repeat), d = P(e, "repeatDelay", i.repeatDelay), f = M(e, "yoyo", i.yoyo), p = [], g = L("value", s), v = F(r[0], 0, "value", g.getEnd, g.getStart, g.getActive, l, o, a, f, u, c, d, !1, !1);
                v.start = n, v.current = n, v.to = s, p.push(v);
                var m = new D(t, p, r);
                m.offset = C(e, "offset", null), m.completeDelay = C(e, "completeDelay", 0), m.loop = Math.round(C(e, "loop", 0)), m.loopDelay = Math.round(C(e, "loopDelay", 0)), m.paused = M(e, "paused", !1), m.useFrames = M(e, "useFrames", !1);
                for(var y = O(e, "callbackScope", m), x = [
                    m,
                    null
                ], T = D.TYPES, w = 0; w < T.length; w++){
                    var b, E, S = T[w], A = O(e, S, !1);
                    A && (b = O(e, S + "Scope", y), E = O(e, S + "Params", []), m.setCallback(S, A, x.concat(E), b));
                }
                return m;
            };
        },
        function(t, e, i) {
            var _ = i(80), C = i(6), M = i(14);
            t.exports = function(t, e) {
                void 0 === e && (e = {});
                var h = C(e, "start", 0), i = C(e, "ease", null), n = C(e, "grid", null), a = C(e, "from", 0), l = "first" === a, u = "center" === a, c = "last" === a, d = "number" == typeof a, f = Array.isArray(t), p = f ? parseFloat(t[0]) : parseFloat(t), g = f ? parseFloat(t[1]) : 0, v = Math.max(p, g);
                if (f && (h += p), n) {
                    var s, r, m = n[0], y = n[1], o = 0, x = 0, T = [];
                    c ? (o = m - 1, x = y - 1) : d ? (o = a % m, x = Math.floor(a / m)) : u && (o = (m - 1) / 2, x = (y - 1) / 2);
                    for(var w = M.MIN_SAFE_INTEGER, b = 0; b < y; b++){
                        T[b] = [];
                        for(var E = 0; E < m; E++){
                            s = o - E, r = x - b;
                            var S = Math.sqrt(s * s + r * r);
                            w < S && (w = S), T[b][E] = S;
                        }
                    }
                }
                var A = i ? _(i) : null;
                return n ? function(t, e, i, n) {
                    var s, r = 0, o = n % m, a = Math.floor(n / m);
                    return 0 <= o && o < m && 0 <= a && a < y && (r = T[a][o]), (f ? (s = g - p, A ? r / w * s * A(r / w) : r / w * s) : A ? r * p * A(r / w) : r * p) + h;
                } : function(t, e, i, n, s) {
                    var r, o;
                    return s--, l ? r = n : u ? r = Math.abs(s / 2 - n) : c ? r = s - n : d && (r = Math.abs(a - n)), (f ? (o = u ? (g - p) / s * (2 * r) : (g - p) / s * r, A ? o * A(r / s) : o) : A ? s * v * A(r / s) : r * p) + h;
                };
            };
        },
        function(t, e, i) {
            var S = i(77), A = i(261), _ = i(13), C = i(96), M = i(80), R = i(160), P = i(259), O = i(580), L = i(6), D = i(584), F = i(161);
            t.exports = function(t, e) {
                var i = new D(t);
                i.completeDelay = _(e, "completeDelay", 0), i.loop = Math.round(_(e, "loop", 0)), i.loopDelay = Math.round(_(e, "loopDelay", 0)), i.paused = C(e, "paused", !1), i.useFrames = C(e, "useFrames", !1);
                var n, s, r = L(e, "callbackScope", i), o = [
                    i
                ], a = L(e, "onStart", !1);
                a && (n = L(e, "onStartScope", r), s = L(e, "onStartParams", []), i.setCallback("onStart", a, o.concat(s), n));
                var h, l, u = L(e, "onUpdate", !1);
                u && (h = L(e, "onUpdateScope", r), l = L(e, "onUpdateParams", []), i.setCallback("onUpdate", u, o.concat(l), h));
                var c, d, f = L(e, "onLoop", !1);
                f && (c = L(e, "onLoopScope", r), d = L(e, "onLoopParams", []), i.setCallback("onLoop", f, o.concat(d), c));
                var p, g, v = L(e, "onYoyo", !1);
                v && (p = L(e, "onYoyoScope", r), g = L(e, "onYoyoParams", []), i.setCallback("onYoyo", v, o.concat(null, g), p));
                var m, y, x = L(e, "onComplete", !1);
                x && (m = L(e, "onCompleteScope", r), y = L(e, "onCompleteParams", []), i.setCallback("onComplete", x, o.concat(y), m));
                var T = O(e);
                if (0 === T.length) return i.paused = !0, i;
                var w = S(A);
                w.targets = P(e);
                var b = _(e, "totalDuration", 0);
                w.duration = 0 < b ? Math.floor(b / T.length) : R(e, "duration", w.duration), w.delay = R(e, "delay", w.delay), w.easeParams = L(e, "easeParams", w.easeParams), w.ease = M(L(e, "ease", w.ease), w.easeParams), w.hold = R(e, "hold", w.hold), w.repeat = R(e, "repeat", w.repeat), w.repeatDelay = R(e, "repeatDelay", w.repeatDelay), w.yoyo = C(e, "yoyo", w.yoyo), w.flipX = C(e, "flipX", w.flipX), w.flipY = C(e, "flipY", w.flipY);
                for(var E = 0; E < T.length; E++)i.queue(F(i, T[E], w));
                return i;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(9), r = i(263), o = i(161), a = i(97), h = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.manager = t, this.isTimeline = !0, this.data = [], this.totalData = 0, this.useFrames = !1, this.timeScale = 1, this.loop = 0, this.loopDelay = 0, this.loopCounter = 0, this.completeDelay = 0, this.countdown = 0, this.state = a.PENDING_ADD, this._pausedState = a.PENDING_ADD, this.paused = !1, this.elapsed = 0, this.totalElapsed = 0, this.duration = 0, this.progress = 0, this.totalDuration = 0, this.totalProgress = 0, this.callbacks = {
                        onComplete: null,
                        onLoop: null,
                        onStart: null,
                        onUpdate: null,
                        onYoyo: null
                    }, this.callbackScope;
                },
                dispatchTimelineEvent: function(t, e) {
                    this.emit(t, this), e && e.func.apply(e.scope, e.params);
                },
                setTimeScale: function(t) {
                    return this.timeScale = t, this;
                },
                getTimeScale: function() {
                    return this.timeScale;
                },
                isPlaying: function() {
                    return this.state === a.ACTIVE;
                },
                add: function(t) {
                    return this.queue(o(this, t));
                },
                queue: function(t) {
                    return this.isPlaying() || (t.parent = this, t.parentIsTimeline = !0, this.data.push(t), this.totalData = this.data.length), this;
                },
                hasOffset: function(t) {
                    return null !== t.offset;
                },
                isOffsetAbsolute: function(t) {
                    return "number" == typeof t;
                },
                isOffsetRelative: function(t) {
                    if ("string" == typeof t) {
                        var e = t[0];
                        if ("-" === e || "+" === e) return !0;
                    }
                    return !1;
                },
                getRelativeOffset: function(t, e) {
                    var i = t[0], n = parseFloat(t.substr(2)), s = e;
                    switch(i){
                        case "+":
                            s += n;
                            break;
                        case "-":
                            s -= n;
                    }
                    return Math.max(0, s);
                },
                calcDuration: function() {
                    for(var t = 0, e = 0, i = 0, n = 0; n < this.totalData; n++){
                        var s = this.data[n];
                        s.init(), this.hasOffset(s) ? this.isOffsetAbsolute(s.offset) ? (s.calculatedOffset = s.offset, 0 === s.offset && (i = 0)) : this.isOffsetRelative(s.offset) && (s.calculatedOffset = this.getRelativeOffset(s.offset, t)) : s.calculatedOffset = i, t = s.totalDuration + s.calculatedOffset, e += s.totalDuration, i += s.totalDuration;
                    }
                    this.duration = e, this.loopCounter = -1 === this.loop ? 999999999999 : this.loop, 0 < this.loopCounter ? this.totalDuration = this.duration + this.completeDelay + (this.duration + this.loopDelay) * this.loopCounter : this.totalDuration = this.duration + this.completeDelay;
                },
                init: function() {
                    return this.calcDuration(), this.progress = 0, this.totalProgress = 0, !this.paused || (this.state = a.PAUSED, !1);
                },
                resetTweens: function(t) {
                    for(var e = 0; e < this.totalData; e++)this.data[e].play(t);
                },
                setCallback: function(t, e, i, n) {
                    return -1 !== h.TYPES.indexOf(t) && (this.callbacks[t] = {
                        func: e,
                        scope: n,
                        params: i
                    }), this;
                },
                makeActive: function(t) {
                    return this.manager.makeActive(t);
                },
                play: function() {
                    if (this.state !== a.ACTIVE) {
                        if (this.paused) return this.paused = !1, void this.manager.makeActive(this);
                        this.resetTweens(!1), this.state = a.ACTIVE, this.dispatchTimelineEvent(r.TIMELINE_START, this.callbacks.onStart);
                    }
                },
                nextState: function() {
                    0 < this.loopCounter ? (this.elapsed = 0, this.progress = 0, this.loopCounter--, this.resetTweens(!0), 0 < this.loopDelay ? (this.countdown = this.loopDelay, this.state = a.LOOP_DELAY) : (this.state = a.ACTIVE, this.dispatchTimelineEvent(r.TIMELINE_LOOP, this.callbacks.onLoop))) : 0 < this.completeDelay ? (this.state = a.COMPLETE_DELAY, this.countdown = this.completeDelay) : (this.state = a.PENDING_REMOVE, this.dispatchTimelineEvent(r.TIMELINE_COMPLETE, this.callbacks.onComplete));
                },
                update: function(t, e) {
                    if (this.state !== a.PAUSED) {
                        switch(this.useFrames && (e = +this.manager.timeScale), e *= this.timeScale, this.elapsed += e, this.progress = Math.min(this.elapsed / this.duration, 1), this.totalElapsed += e, this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1), this.state){
                            case a.ACTIVE:
                                for(var i = this.totalData, n = 0; n < this.totalData; n++)this.data[n].update(t, e) && i--;
                                this.dispatchTimelineEvent(r.TIMELINE_UPDATE, this.callbacks.onUpdate), 0 === i && this.nextState();
                                break;
                            case a.LOOP_DELAY:
                                this.countdown -= e, this.countdown <= 0 && (this.state = a.ACTIVE, this.dispatchTimelineEvent(r.TIMELINE_LOOP, this.callbacks.onLoop));
                                break;
                            case a.COMPLETE_DELAY:
                                this.countdown -= e, this.countdown <= 0 && (this.state = a.PENDING_REMOVE, this.dispatchTimelineEvent(r.TIMELINE_COMPLETE, this.callbacks.onComplete));
                        }
                        return this.state === a.PENDING_REMOVE;
                    }
                },
                stop: function() {
                    this.state = a.PENDING_REMOVE;
                },
                pause: function() {
                    if (this.state !== a.PAUSED) return this.paused = !0, this._pausedState = this.state, this.state = a.PAUSED, this.emit(r.TIMELINE_PAUSE, this), this;
                },
                resume: function() {
                    return this.state === a.PAUSED && (this.paused = !1, this.state = this._pausedState, this.emit(r.TIMELINE_RESUME, this)), this;
                },
                hasTarget: function(t) {
                    for(var e = 0; e < this.data.length; e++)if (this.data[e].hasTarget(t)) return !0;
                    return !1;
                },
                destroy: function() {
                    for(var t = 0; t < this.data.length; t++)this.data[t].stop();
                }
            });
            h.TYPES = [
                "onStart",
                "onUpdate",
                "onLoop",
                "onComplete",
                "onYoyo"
            ], t.exports = h;
        },
        function(t, e, i) {
            var n = {};
            t.exports = n;
            var r = i(116), o = i(50);
            n.fromVertices = function(t) {
                for(var e = {}, i = 0; i < t.length; i++){
                    var n = (i + 1) % t.length, s = r.normalise({
                        x: t[n].y - t[i].y,
                        y: t[i].x - t[n].x
                    });
                    e[(0 === s.y ? 1 / 0 : s.x / s.y).toFixed(3).toString()] = s;
                }
                return o.values(e);
            }, n.rotate = function(t, e) {
                if (0 !== e) for(var i = Math.cos(e), n = Math.sin(e), s = 0; s < t.length; s++){
                    var r = t[s], o = r.x * i - r.y * n;
                    r.y = r.x * n + r.y * i, r.x = o;
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                AFTER_ADD: i(1509),
                AFTER_REMOVE: i(1510),
                AFTER_UPDATE: i(1511),
                BEFORE_ADD: i(1512),
                BEFORE_REMOVE: i(1513),
                BEFORE_UPDATE: i(1514),
                COLLISION_ACTIVE: i(1515),
                COLLISION_END: i(1516),
                COLLISION_START: i(1517),
                DRAG_END: i(1518),
                DRAG: i(1519),
                DRAG_START: i(1520),
                PAUSE: i(1521),
                RESUME: i(1522),
                SLEEP_END: i(1523),
                SLEEP_START: i(1524)
            };
        },
        function(t, e, i) {
            var g = {};
            t.exports = g;
            var v = i(588), m = i(535), y = i(117);
            g.collisions = function(t, e) {
                for(var i = [], n = e.pairs.table, s = e.metrics, r = 0; r < t.length; r++){
                    var o = t[r][0], a = t[r][1];
                    if ((!o.isStatic && !o.isSleeping || !a.isStatic && !a.isSleeping) && g.canCollide(o.collisionFilter, a.collisionFilter) && (s.midphaseTests += 1, y.overlaps(o.bounds, a.bounds))) for(var h = 1 < o.parts.length ? 1 : 0; h < o.parts.length; h++)for(var l = o.parts[h], u = 1 < a.parts.length ? 1 : 0; u < a.parts.length; u++){
                        var c, d, f, p = a.parts[u];
                        (l === o && p === a || y.overlaps(l.bounds, p.bounds)) && (d = (c = n[m.id(l, p)]) && c.isActive ? c.collision : null, f = v.collides(l, p, d), s.narrowphaseTests += 1, f.reused && (s.narrowReuseCount += 1), f.collided && (i.push(f), s.narrowDetections += 1));
                    }
                }
                return i;
            }, g.canCollide = function(t, e) {
                return t.group === e.group && 0 !== t.group ? 0 < t.group : 0 != (t.mask & e.category) && 0 != (e.mask & t.category);
            };
        },
        function(t, e, i) {
            var m = {};
            t.exports = m;
            var y = i(94), x = i(116);
            m.collides = function(t, e, i) {
                var n, s, r, o, a, h, l = !1;
                if (h = i ? (r = t.parent, o = e.parent, a = r.speed * r.speed + r.angularSpeed * r.angularSpeed + o.speed * o.speed + o.angularSpeed * o.angularSpeed, l = i && i.collided && a < .2, i) : {
                    collided: !1,
                    bodyA: t,
                    bodyB: e
                }, i && l) {
                    var u = h.axisBody, c = u === t ? e : t, d = [
                        u.axes[i.axisNumber]
                    ], f = m._overlapAxes(u.vertices, c.vertices, d);
                    if (h.reused = !0, f.overlap <= 0) return h.collided = !1, h;
                } else {
                    if ((n = m._overlapAxes(t.vertices, e.vertices, t.axes)).overlap <= 0) return h.collided = !1, h;
                    if ((s = m._overlapAxes(e.vertices, t.vertices, e.axes)).overlap <= 0) return h.collided = !1, h;
                    n.overlap < s.overlap ? (f = n, h.axisBody = t) : (f = s, h.axisBody = e), h.axisNumber = f.axisNumber;
                }
                h.bodyA = t.id < e.id ? t : e, h.bodyB = t.id < e.id ? e : t, h.collided = !0, h.depth = f.overlap, h.parentA = h.bodyA.parent, h.parentB = h.bodyB.parent, t = h.bodyA, e = h.bodyB, x.dot(f.axis, x.sub(e.position, t.position)) < 0 ? h.normal = {
                    x: f.axis.x,
                    y: f.axis.y
                } : h.normal = {
                    x: -f.axis.x,
                    y: -f.axis.y
                }, h.tangent = x.perp(h.normal), h.penetration = h.penetration || {}, h.penetration.x = h.normal.x * h.depth, h.penetration.y = h.normal.y * h.depth;
                var p, g = m._findSupports(t, e, h.normal), v = [];
                return y.contains(t.vertices, g[0]) && v.push(g[0]), y.contains(t.vertices, g[1]) && v.push(g[1]), v.length < 2 && (p = m._findSupports(e, t, x.neg(h.normal)), y.contains(e.vertices, p[0]) && v.push(p[0]), v.length < 2 && y.contains(e.vertices, p[1]) && v.push(p[1])), v.length < 1 && (v = [
                    g[0]
                ]), h.supports = v, h;
            }, m._overlapAxes = function(t, e, i) {
                for(var n, s, r = x._temp[0], o = x._temp[1], a = {
                    overlap: Number.MAX_VALUE
                }, h = 0; h < i.length; h++){
                    if (s = i[h], m._projectToAxis(r, t, s), m._projectToAxis(o, e, s), (n = Math.min(r.max - o.min, o.max - r.min)) <= 0) return a.overlap = n, a;
                    n < a.overlap && (a.overlap = n, a.axis = s, a.axisNumber = h);
                }
                return a;
            }, m._projectToAxis = function(t, e, i) {
                for(var n = x.dot(e[0], i), s = n, r = 1; r < e.length; r += 1){
                    var o = x.dot(e[r], i);
                    s < o ? s = o : o < n && (n = o);
                }
                t.min = n, t.max = s;
            }, m._findSupports = function(t, e, i) {
                for(var n, s, r, o = Number.MAX_VALUE, a = x._temp[0], h = e.vertices, l = t.position, u = 0; u < h.length; u++)c = h[u], a.x = c.x - l.x, a.y = c.y - l.y, (n = -x.dot(i, a)) < o && (o = n, s = c);
                var c = h[0 <= s.index - 1 ? s.index - 1 : h.length - 1];
                return a.x = c.x - l.x, a.y = c.y - l.y, o = -x.dot(i, a), r = c, c = h[(s.index + 1) % h.length], a.x = c.x - l.x, a.y = c.y - l.y, (n = -x.dot(i, a)) < o && (r = c), [
                    s,
                    r
                ];
            };
        },
        function(t, e) {
            var i = function() {
                return this;
            }();
            try {
                i = i || new Function("return this")();
            } catch (t) {
                "object" == typeof window && (i = window);
            }
            t.exports = i;
        },
        function(t, e, i) {
            i(591), i(592), i(593), i(594), i(595), i(596), i(597), i(598);
        },
        function(t, e) {
            Array.prototype.forEach || (Array.prototype.forEach = function(t) {
                "use strict";
                if (null == this) throw new TypeError;
                var e = Object(this), i = e.length >>> 0;
                if ("function" != typeof t) throw new TypeError;
                for(var n = 2 <= arguments.length ? arguments[1] : void 0, s = 0; s < i; s++)s in e && t.call(n, e[s], s, e);
            });
        },
        function(t, e) {
            Array.isArray || (Array.isArray = function(t) {
                return "[object Array]" === Object.prototype.toString.call(t);
            });
        },
        function(t, e) {
            function i(t) {
                t && (t.setTargetAtTime || (t.setTargetAtTime = t.setTargetValueAtTime));
            }
            window.hasOwnProperty("webkitAudioContext") && !window.hasOwnProperty("AudioContext") && (window.AudioContext = webkitAudioContext, AudioContext.prototype.hasOwnProperty("createGain") || (AudioContext.prototype.createGain = AudioContext.prototype.createGainNode), AudioContext.prototype.hasOwnProperty("createDelay") || (AudioContext.prototype.createDelay = AudioContext.prototype.createDelayNode), AudioContext.prototype.hasOwnProperty("createScriptProcessor") || (AudioContext.prototype.createScriptProcessor = AudioContext.prototype.createJavaScriptNode), AudioContext.prototype.hasOwnProperty("createPeriodicWave") || (AudioContext.prototype.createPeriodicWave = AudioContext.prototype.createWaveTable), AudioContext.prototype.internal_createGain = AudioContext.prototype.createGain, AudioContext.prototype.createGain = function() {
                var t = this.internal_createGain();
                return i(t.gain), t;
            }, AudioContext.prototype.internal_createDelay = AudioContext.prototype.createDelay, AudioContext.prototype.createDelay = function(t) {
                var e = t ? this.internal_createDelay(t) : this.internal_createDelay();
                return i(e.delayTime), e;
            }, AudioContext.prototype.internal_createBufferSource = AudioContext.prototype.createBufferSource, AudioContext.prototype.createBufferSource = function() {
                var n = this.internal_createBufferSource();
                return n.start ? (n.internal_start = n.start, n.start = function(t, e, i) {
                    void 0 !== i ? n.internal_start(t || 0, e, i) : n.internal_start(t || 0, e || 0);
                }) : n.start = function(t, e, i) {
                    e || i ? this.noteGrainOn(t || 0, e, i) : this.noteOn(t || 0);
                }, n.stop ? (n.internal_stop = n.stop, n.stop = function(t) {
                    n.internal_stop(t || 0);
                }) : n.stop = function(t) {
                    this.noteOff(t || 0);
                }, i(n.playbackRate), n;
            }, AudioContext.prototype.internal_createDynamicsCompressor = AudioContext.prototype.createDynamicsCompressor, AudioContext.prototype.createDynamicsCompressor = function() {
                var t = this.internal_createDynamicsCompressor();
                return i(t.threshold), i(t.knee), i(t.ratio), i(t.reduction), i(t.attack), i(t.release), t;
            }, AudioContext.prototype.internal_createBiquadFilter = AudioContext.prototype.createBiquadFilter, AudioContext.prototype.createBiquadFilter = function() {
                var t = this.internal_createBiquadFilter();
                return i(t.frequency), i(t.detune), i(t.Q), i(t.gain), t;
            }, AudioContext.prototype.hasOwnProperty("createOscillator") && (AudioContext.prototype.internal_createOscillator = AudioContext.prototype.createOscillator, AudioContext.prototype.createOscillator = function() {
                var e = this.internal_createOscillator();
                return e.start ? (e.internal_start = e.start, e.start = function(t) {
                    e.internal_start(t || 0);
                }) : e.start = function(t) {
                    this.noteOn(t || 0);
                }, e.stop ? (e.internal_stop = e.stop, e.stop = function(t) {
                    e.internal_stop(t || 0);
                }) : e.stop = function(t) {
                    this.noteOff(t || 0);
                }, e.setPeriodicWave || (e.setPeriodicWave = e.setWaveTable), i(e.frequency), i(e.detune), e;
            })), window.hasOwnProperty("webkitOfflineAudioContext") && !window.hasOwnProperty("OfflineAudioContext") && (window.OfflineAudioContext = webkitOfflineAudioContext);
        },
        function(t, e) {
            window.console || (window.console = {}, window.console.log = window.console.assert = function() {}, window.console.warn = window.console.assert = function() {});
        },
        function(t, e) {
            Math.trunc || (Math.trunc = function(t) {
                return t < 0 ? Math.ceil(t) : Math.floor(t);
            });
        },
        function(t, e) {
            var i;
            "performance" in window == !1 && (window.performance = {}), Date.now = Date.now || function() {
                return (new Date).getTime();
            }, "now" in window.performance == !1 && (i = Date.now(), performance.timing && performance.timing.navigationStart && (i = performance.timing.navigationStart), window.performance.now = function() {
                return Date.now() - i;
            });
        },
        function(t, e) {
            for(var n = Date.now(), i = [
                "ms",
                "moz",
                "webkit",
                "o"
            ], s = 0; s < i.length && !window.requestAnimationFrame; s++)window.requestAnimationFrame = window[i[s] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[s] + "CancelAnimationFrame"] || window[i[s] + "CancelRequestAnimationFrame"];
            window.requestAnimationFrame || (window.requestAnimationFrame = function(t) {
                if ("function" != typeof t) throw new TypeError(t + "is not a function");
                var e = Date.now(), i = 16 + n - e;
                return i < 0 && (i = 0), n = e, setTimeout(function() {
                    n = Date.now(), t(performance.now());
                }, i);
            }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(t) {
                clearTimeout(t);
            });
        },
        function(t, e) {
            var i;
            "function" != typeof window.Uint32Array && "object" != typeof window.Uint32Array && ((i = function(t) {
                var e = new Array;
                window[t] = function(t) {
                    if ("number" == typeof t) {
                        Array.call(this, t), this.length = t;
                        for(var e = 0; e < this.length; e++)this[e] = 0;
                    } else {
                        Array.call(this, t.length), this.length = t.length;
                        for(e = 0; e < this.length; e++)this[e] = t[e];
                    }
                }, window[t].prototype = e, window[t].constructor = window[t];
            })("Float32Array"), i("Uint32Array"), i("Uint16Array"), i("Int16Array"), i("ArrayBuffer"));
        },
        function(t, e, i) {
            var a = i(270);
            t.exports = function(t, e, i, n) {
                for(var s = t[0], r = 1; r < t.length; r++){
                    var o = t[r];
                    a(o, s, e, i, n), s = o;
                }
                return t;
            };
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "angle", e, i, n, s);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                for(var n = 0; n < t.length; n++){
                    var s = t[n];
                    e.call(i, s);
                }
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === i && (i = 0);
                for(var n = i; n < t.length; n++){
                    var s = t[n], r = !0;
                    for(var o in e)s[o] !== e[o] && (r = !1);
                    if (r) return s;
                }
                return null;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === i && (i = 0);
                for(var n = i; n < t.length; n++){
                    var s = t[n], r = !0;
                    for(var o in e)s[o] !== e[o] && (r = !1);
                    if (r) return s;
                }
                return null;
            };
        },
        function(t, e, i) {
            var v = i(283), m = i(122), y = i(2), n = i(1), x = new (i(127))({
                sys: {
                    queueDepthSort: n,
                    events: {
                        once: n
                    }
                }
            }, 0, 0, 1, 1);
            t.exports = function(t, e) {
                void 0 === e && (e = {});
                var i = e.hasOwnProperty("width"), n = e.hasOwnProperty("height"), s = y(e, "width", -1), r = y(e, "height", -1), o = y(e, "cellWidth", 1), a = y(e, "cellHeight", o), h = y(e, "position", m.TOP_LEFT), l = y(e, "x", 0), u = y(e, "y", 0), c = 0, d = 0, f = s * o, p = r * a;
                x.setPosition(l, u), x.setSize(o, a);
                for(var g = 0; g < t.length; g++)if (v(t[g], x, h), i && -1 === s) x.x += o;
                else if (n && -1 === r) x.y += a;
                else if (n && !i) {
                    if (d += a, x.y += a, d === p && (d = 0, c += o, x.y = u, x.x += o, c === f)) break;
                } else if (c += o, x.x += o, c === f && (c = 0, d += a, x.x = l, x.y += a, d === p)) break;
                return t;
            };
        },
        function(t, e, i) {
            var s = i(18), n = {
                _alpha: 1,
                _alphaTL: 1,
                _alphaTR: 1,
                _alphaBL: 1,
                _alphaBR: 1,
                clearAlpha: function() {
                    return this.setAlpha(1);
                },
                setAlpha: function(t, e, i, n) {
                    return void 0 === t && (t = 1), void 0 === e ? this.alpha = t : (this._alphaTL = s(t, 0, 1), this._alphaTR = s(e, 0, 1), this._alphaBL = s(i, 0, 1), this._alphaBR = s(n, 0, 1)), this;
                },
                alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(t) {
                        var e = s(t, 0, 1);
                        this._alpha = e, this._alphaTL = e, this._alphaTR = e, this._alphaBL = e, 0 === (this._alphaBR = e) ? this.renderFlags &= -3 : this.renderFlags |= 2;
                    }
                },
                alphaTopLeft: {
                    get: function() {
                        return this._alphaTL;
                    },
                    set: function(t) {
                        var e = s(t, 0, 1);
                        0 !== (this._alphaTL = e) && (this.renderFlags |= 2);
                    }
                },
                alphaTopRight: {
                    get: function() {
                        return this._alphaTR;
                    },
                    set: function(t) {
                        var e = s(t, 0, 1);
                        0 !== (this._alphaTR = e) && (this.renderFlags |= 2);
                    }
                },
                alphaBottomLeft: {
                    get: function() {
                        return this._alphaBL;
                    },
                    set: function(t) {
                        var e = s(t, 0, 1);
                        0 !== (this._alphaBL = e) && (this.renderFlags |= 2);
                    }
                },
                alphaBottomRight: {
                    get: function() {
                        return this._alphaBR;
                    },
                    set: function(t) {
                        var e = s(t, 0, 1);
                        0 !== (this._alphaBR = e) && (this.renderFlags |= 2);
                    }
                }
            };
            t.exports = n;
        },
        function(t, e) {
            t.exports = {
                width: 0,
                height: 0,
                displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(t) {
                        this.scaleX = t / this.width;
                    }
                },
                displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(t) {
                        this.scaleY = t / this.height;
                    }
                },
                setSize: function(t, e) {
                    return this.width = t, this.height = e, this;
                },
                setDisplaySize: function(t, e) {
                    return this.displayWidth = t, this.displayHeight = e, this;
                }
            };
        },
        function(t, e) {
            var i = {
                texture: null,
                frame: null,
                isCropped: !1,
                setCrop: function(t, e, i, n) {
                    return void 0 === t ? this.isCropped = !1 : this.frame && ("number" == typeof t ? this.frame.setCropUVs(this._crop, t, e, i, n, this.flipX, this.flipY) : this.frame.setCropUVs(this._crop, t.x, t.y, t.width, t.height, this.flipX, this.flipY), this.isCropped = !0), this;
                },
                resetCropObject: function() {
                    return {
                        u0: 0,
                        v0: 0,
                        u1: 0,
                        v1: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        flipX: !1,
                        flipY: !1,
                        cx: 0,
                        cy: 0,
                        cw: 0,
                        ch: 0
                    };
                }
            };
            t.exports = i;
        },
        function(t, e) {
            t.exports = {
                flipX: !1,
                flipY: !1,
                toggleFlipX: function() {
                    return this.flipX = !this.flipX, this;
                },
                toggleFlipY: function() {
                    return this.flipY = !this.flipY, this;
                },
                setFlipX: function(t) {
                    return this.flipX = t, this;
                },
                setFlipY: function(t) {
                    return this.flipY = t, this;
                },
                setFlip: function(t, e) {
                    return this.flipX = t, this.flipY = e, this;
                },
                resetFlip: function() {
                    return this.flipX = !1, this.flipY = !1, this;
                }
            };
        },
        function(t, e, i) {
            var u = i(10), n = i(302), s = i(3), r = {
                prepareBoundsOutput: function(t, e) {
                    return void 0 === e && (e = !1), 0 !== this.rotation && n(t, this.x, this.y, this.rotation), e && this.parentContainer && this.parentContainer.getBoundsTransformMatrix().transformPoint(t.x, t.y, t), t;
                },
                getCenter: function(t) {
                    return void 0 === t && (t = new s), t.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2, t.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2, t;
                },
                getTopLeft: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX, t.y = this.y - this.displayHeight * this.originY, this.prepareBoundsOutput(t, e);
                },
                getTopCenter: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX + this.displayWidth / 2, t.y = this.y - this.displayHeight * this.originY, this.prepareBoundsOutput(t, e);
                },
                getTopRight: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX + this.displayWidth, t.y = this.y - this.displayHeight * this.originY, this.prepareBoundsOutput(t, e);
                },
                getLeftCenter: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX, t.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2, this.prepareBoundsOutput(t, e);
                },
                getRightCenter: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX + this.displayWidth, t.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2, this.prepareBoundsOutput(t, e);
                },
                getBottomLeft: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX, t.y = this.y - this.displayHeight * this.originY + this.displayHeight, this.prepareBoundsOutput(t, e);
                },
                getBottomCenter: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX + this.displayWidth / 2, t.y = this.y - this.displayHeight * this.originY + this.displayHeight, this.prepareBoundsOutput(t, e);
                },
                getBottomRight: function(t, e) {
                    return (t = t || new s).x = this.x - this.displayWidth * this.originX + this.displayWidth, t.y = this.y - this.displayHeight * this.originY + this.displayHeight, this.prepareBoundsOutput(t, e);
                },
                getBounds: function(t) {
                    var e, i, n, s, r, o, a, h, l;
                    return void 0 === t && (t = new u), h = (a = (this.parentContainer ? (l = this.parentContainer.getBoundsTransformMatrix(), this.getTopLeft(t), l.transformPoint(t.x, t.y, t), e = t.x, i = t.y, this.getTopRight(t), l.transformPoint(t.x, t.y, t), n = t.x, s = t.y, this.getBottomLeft(t), l.transformPoint(t.x, t.y, t), r = t.x, o = t.y, this.getBottomRight(t), l.transformPoint(t.x, t.y, t)) : (this.getTopLeft(t), e = t.x, i = t.y, this.getTopRight(t), n = t.x, s = t.y, this.getBottomLeft(t), r = t.x, o = t.y, this.getBottomRight(t)), t.x), t.y), t.x = Math.min(e, n, r, a), t.y = Math.min(i, s, o, h), t.width = Math.max(e, n, r, a) - t.x, t.height = Math.max(i, s, o, h) - t.y, t;
                }
            };
            t.exports = r;
        },
        function(t, e) {
            t.exports = "blur";
        },
        function(t, e) {
            t.exports = "boot";
        },
        function(t, e) {
            t.exports = "contextlost";
        },
        function(t, e) {
            t.exports = "contextrestored";
        },
        function(t, e) {
            t.exports = "destroy";
        },
        function(t, e) {
            t.exports = "focus";
        },
        function(t, e) {
            t.exports = "hidden";
        },
        function(t, e) {
            t.exports = "pause";
        },
        function(t, e) {
            t.exports = "postrender";
        },
        function(t, e) {
            t.exports = "poststep";
        },
        function(t, e) {
            t.exports = "prerender";
        },
        function(t, e) {
            t.exports = "prestep";
        },
        function(t, e) {
            t.exports = "ready";
        },
        function(t, e) {
            t.exports = "resume";
        },
        function(t, e) {
            t.exports = "step";
        },
        function(t, e) {
            t.exports = "visible";
        },
        function(t, e) {
            t.exports = "postrender";
        },
        function(t, e) {
            t.exports = "prerender";
        },
        function(t, e) {
            t.exports = "render";
        },
        function(t, e) {
            t.exports = "resize";
        },
        function(t, e) {
            var i = {
                _originComponent: !0,
                originX: .5,
                originY: .5,
                _displayOriginX: 0,
                _displayOriginY: 0,
                displayOriginX: {
                    get: function() {
                        return this._displayOriginX;
                    },
                    set: function(t) {
                        this._displayOriginX = t, this.originX = t / this.width;
                    }
                },
                displayOriginY: {
                    get: function() {
                        return this._displayOriginY;
                    },
                    set: function(t) {
                        this._displayOriginY = t, this.originY = t / this.height;
                    }
                },
                setOrigin: function(t, e) {
                    return void 0 === t && (t = .5), void 0 === e && (e = t), this.originX = t, this.originY = e, this.updateDisplayOrigin();
                },
                setOriginFromFrame: function() {
                    return this.frame && this.frame.customPivot ? (this.originX = this.frame.pivotX, this.originY = this.frame.pivotY, this.updateDisplayOrigin()) : this.setOrigin();
                },
                setDisplayOrigin: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this.displayOriginX = t, this.displayOriginY = e, this;
                },
                updateDisplayOrigin: function() {
                    return this._displayOriginX = this.originX * this.width, this._displayOriginY = this.originY * this.height, this;
                }
            };
            t.exports = i;
        },
        function(t, e, i) {
            var h = i(35), o = i(96), a = i(6), l = i(97), u = i(3), n = {
                path: null,
                rotateToPath: !1,
                pathRotationOffset: 0,
                pathOffset: null,
                pathVector: null,
                pathDelta: null,
                pathTween: null,
                pathConfig: null,
                _prevDirection: l.PLAYING_FORWARD,
                setPath: function(t, e) {
                    void 0 === e && (e = this.pathConfig);
                    var i = this.pathTween;
                    return i && i.isPlaying() && i.stop(), this.path = t, e && this.startFollow(e), this;
                },
                setRotateToPath: function(t, e) {
                    return void 0 === e && (e = 0), this.rotateToPath = t, this.pathRotationOffset = e, this;
                },
                isFollowing: function() {
                    var t = this.pathTween;
                    return t && t.isPlaying();
                },
                startFollow: function(t, e) {
                    void 0 === t && (t = {}), void 0 === e && (e = 0);
                    var i = this.pathTween;
                    i && i.isPlaying() && i.stop(), "number" == typeof t && (t = {
                        duration: t
                    }), t.from = a(t, "from", 0), t.to = a(t, "to", 1);
                    var n = o(t, "positionOnPath", !1);
                    this.rotateToPath = o(t, "rotateToPath", !1), this.pathRotationOffset = a(t, "rotationOffset", 0);
                    var s, r = a(t, "startAt", e);
                    return r && (t.onStart = function(t) {
                        var e = t.data[0];
                        e.progress = r, e.elapsed = e.duration * r;
                        var i = e.ease(e.progress);
                        e.current = e.start + (e.end - e.start) * i, e.target[e.key] = e.current;
                    }), this.pathOffset || (this.pathOffset = new u(this.x, this.y)), this.pathVector || (this.pathVector = new u), this.pathDelta || (this.pathDelta = new u), this.pathDelta.reset(), this.pathTween = this.scene.sys.tweens.addCounter(t), this.path.getStartPoint(this.pathOffset), n && (this.x = this.pathOffset.x, this.y = this.pathOffset.y), this.pathOffset.x = this.x - this.pathOffset.x, this.pathOffset.y = this.y - this.pathOffset.y, this._prevDirection = l.PLAYING_FORWARD, this.rotateToPath && (s = this.path.getPoint(.1), this.rotation = Math.atan2(s.y - this.y, s.x - this.x) + h(this.pathRotationOffset)), this.pathConfig = t, this;
                },
                pauseFollow: function() {
                    var t = this.pathTween;
                    return t && t.isPlaying() && t.pause(), this;
                },
                resumeFollow: function() {
                    var t = this.pathTween;
                    return t && t.isPaused() && t.resume(), this;
                },
                stopFollow: function() {
                    var t = this.pathTween;
                    return t && t.isPlaying() && t.stop(), this;
                },
                pathUpdate: function() {
                    var t = this.pathTween;
                    if (t) {
                        var e = t.data[0], i = this.pathDelta, n = this.pathVector;
                        if (i.copy(n).negate(), e.state === l.COMPLETE) return this.path.getPoint(1, n), i.add(n), n.add(this.pathOffset), void this.setPosition(n.x, n.y);
                        if (e.state !== l.PLAYING_FORWARD && e.state !== l.PLAYING_BACKWARD) return;
                        this.path.getPoint(t.getValue(), n), i.add(n), n.add(this.pathOffset);
                        var s = this.x, r = this.y;
                        this.setPosition(n.x, n.y);
                        var o = this.x - s, a = this.y - r;
                        if (0 == o && 0 == a) return;
                        if (e.state !== this._prevDirection) return void (this._prevDirection = e.state);
                        this.rotateToPath && (this.rotation = Math.atan2(a, o) + h(this.pathRotationOffset));
                    }
                }
            };
            t.exports = n;
        },
        function(t, e) {
            var i = {
                _sizeComponent: !0,
                width: 0,
                height: 0,
                displayWidth: {
                    get: function() {
                        return Math.abs(this.scaleX * this.frame.realWidth);
                    },
                    set: function(t) {
                        this.scaleX = t / this.frame.realWidth;
                    }
                },
                displayHeight: {
                    get: function() {
                        return Math.abs(this.scaleY * this.frame.realHeight);
                    },
                    set: function(t) {
                        this.scaleY = t / this.frame.realHeight;
                    }
                },
                setSizeToFrame: function(t) {
                    return void 0 === t && (t = this.frame), this.width = t.realWidth, this.height = t.realHeight, this;
                },
                setSize: function(t, e) {
                    return this.width = t, this.height = e, this;
                },
                setDisplaySize: function(t, e) {
                    return this.displayWidth = t, this.displayHeight = e, this;
                }
            };
            t.exports = i;
        },
        function(t, e) {
            var i = {
                texture: null,
                frame: null,
                isCropped: !1,
                setTexture: function(t, e) {
                    return this.texture = this.scene.sys.textures.get(t), this.setFrame(e);
                },
                setFrame: function(t, e, i) {
                    return void 0 === e && (e = !0), void 0 === i && (i = !0), this.frame = this.texture.get(t), this.frame.cutWidth && this.frame.cutHeight ? this.renderFlags |= 8 : this.renderFlags &= -9, this._sizeComponent && e && this.setSizeToFrame(), this._originComponent && i && (this.frame.customPivot ? this.setOrigin(this.frame.pivotX, this.frame.pivotY) : this.updateDisplayOrigin()), this;
                }
            };
            t.exports = i;
        },
        function(t, e) {
            var i = {
                texture: null,
                frame: null,
                isCropped: !1,
                setCrop: function(t, e, i, n) {
                    return void 0 === t ? this.isCropped = !1 : this.frame && ("number" == typeof t ? this.frame.setCropUVs(this._crop, t, e, i, n, this.flipX, this.flipY) : this.frame.setCropUVs(this._crop, t.x, t.y, t.width, t.height, this.flipX, this.flipY), this.isCropped = !0), this;
                },
                setTexture: function(t, e) {
                    return this.texture = this.scene.sys.textures.get(t), this.setFrame(e);
                },
                setFrame: function(t, e, i) {
                    return void 0 === e && (e = !0), void 0 === i && (i = !0), this.frame = this.texture.get(t), this.frame.cutWidth && this.frame.cutHeight ? this.renderFlags |= 8 : this.renderFlags &= -9, this._sizeComponent && e && this.setSizeToFrame(), this._originComponent && i && (this.frame.customPivot ? this.setOrigin(this.frame.pivotX, this.frame.pivotY) : this.updateDisplayOrigin()), this.isCropped && this.frame.updateCropUVs(this._crop, this.flipX, this.flipY), this;
                },
                resetCropObject: function() {
                    return {
                        u0: 0,
                        v0: 0,
                        u1: 0,
                        v1: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        flipX: !1,
                        flipY: !1,
                        cx: 0,
                        cy: 0,
                        cw: 0,
                        ch: 0
                    };
                }
            };
            t.exports = i;
        },
        function(t, e) {
            var i = {
                tintTopLeft: 16777215,
                tintTopRight: 16777215,
                tintBottomLeft: 16777215,
                tintBottomRight: 16777215,
                tintFill: !1,
                clearTint: function() {
                    return this.setTint(16777215), this;
                },
                setTint: function(t, e, i, n) {
                    return void 0 === t && (t = 16777215), void 0 === e && (n = i = e = t), this.tintTopLeft = t, this.tintTopRight = e, this.tintBottomLeft = i, this.tintBottomRight = n, this.tintFill = !1, this;
                },
                setTintFill: function(t, e, i, n) {
                    return this.setTint(t, e, i, n), this.tintFill = !0, this;
                },
                tint: {
                    set: function(t) {
                        this.setTint(t, t, t, t);
                    }
                },
                isTinted: {
                    get: function() {
                        var t = 16777215;
                        return this.tintFill || this.tintTopLeft !== t || this.tintTopRight !== t || this.tintBottomLeft !== t || this.tintBottomRight !== t;
                    }
                }
            };
            t.exports = i;
        },
        function(t, e) {
            t.exports = "changedata";
        },
        function(t, e) {
            t.exports = "changedata-";
        },
        function(t, e) {
            t.exports = "destroy";
        },
        function(t, e) {
            t.exports = "removedata";
        },
        function(t, e) {
            t.exports = "setdata";
        },
        function(t, e) {
            t.exports = "addedtoscene";
        },
        function(t, e) {
            t.exports = "destroy";
        },
        function(t, e) {
            t.exports = "removedfromscene";
        },
        function(t, e) {
            t.exports = "complete";
        },
        function(t, e) {
            t.exports = "created";
        },
        function(t, e) {
            t.exports = "error";
        },
        function(t, e) {
            t.exports = "loop";
        },
        function(t, e) {
            t.exports = "play";
        },
        function(t, e) {
            t.exports = "seeked";
        },
        function(t, e) {
            t.exports = "seeking";
        },
        function(t, e) {
            t.exports = "stop";
        },
        function(t, e) {
            t.exports = "timeout";
        },
        function(t, e) {
            t.exports = "unlocked";
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "alpha", e, i, n, s);
            };
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "x", e, i, n, s);
            };
        },
        function(t, e, i) {
            var a = i(44);
            t.exports = function(t, e, i, n, s, r, o) {
                return null == i && (i = e), a(t, "x", e, n, r, o), a(t, "y", i, s, r, o);
            };
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "y", e, i, n, s);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = 0), void 0 === n && (n = 6.28);
                for(var s = i, r = (n - i) / t.length, o = 0; o < t.length; o++)t[o].x = e.x + e.radius * Math.cos(s), t[o].y = e.y + e.radius * Math.sin(s), s += r;
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = 0), void 0 === n && (n = 6.28);
                for(var s = i, r = (n - i) / t.length, o = e.width / 2, a = e.height / 2, h = 0; h < t.length; h++)t[h].x = e.x + o * Math.cos(s), t[h].y = e.y + a * Math.sin(s), s += r;
                return t;
            };
        },
        function(t, e, i) {
            var o = i(168);
            t.exports = function(t, e) {
                for(var i = o(e, t.length), n = 0; n < t.length; n++){
                    var s = t[n], r = i[n];
                    s.x = r.x, s.y = r.y;
                }
                return t;
            };
        },
        function(t, e, i) {
            var r = i(310), o = i(175), a = i(176);
            t.exports = function(t, e, i) {
                void 0 === i && (i = 0);
                var n = r(e, !1, t.length);
                0 < i ? o(n, i) : i < 0 && a(n, Math.abs(i));
                for(var s = 0; s < t.length; s++)t[s].x = n[s].x, t[s].y = n[s].y;
                return t;
            };
        },
        function(t, e, i) {
            var c = i(311);
            t.exports = function(t, e, i) {
                var n = c({
                    x1: e.x1,
                    y1: e.y1,
                    x2: e.x2,
                    y2: e.y2
                }, i), s = c({
                    x1: e.x2,
                    y1: e.y2,
                    x2: e.x3,
                    y2: e.y3
                }, i), r = c({
                    x1: e.x3,
                    y1: e.y3,
                    x2: e.x1,
                    y2: e.y1
                }, i);
                n.pop(), s.pop(), r.pop();
                for(var o = (n = n.concat(s, r)).length / t.length, a = 0, h = 0; h < t.length; h++){
                    var l = t[h], u = n[Math.floor(a)];
                    l.x = u.x, l.y = u.y, a += o;
                }
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                for(var n = 0; n < t.length; n++)t[n].anims.play(e, i);
                return t;
            };
        },
        function(t, e, i) {
            var n = i(166);
            t.exports = function(t, e) {
                for(var i = 0; i < t.length; i++)n(e, t[i]);
                return t;
            };
        },
        function(t, e, i) {
            var n = i(177);
            t.exports = function(t, e) {
                for(var i = 0; i < t.length; i++)n(e, t[i]);
                return t;
            };
        },
        function(t, e, i) {
            var n = i(169);
            t.exports = function(t, e) {
                for(var i = 0; i < t.length; i++)n(e, t[i]);
                return t;
            };
        },
        function(t, e, i) {
            var n = i(170);
            t.exports = function(t, e) {
                for(var i = 0; i < t.length; i++)n(e, t[i]);
                return t;
            };
        },
        function(t, e, i) {
            var n = i(178);
            t.exports = function(t, e) {
                for(var i = 0; i < t.length; i++)n(e, t[i]);
                return t;
            };
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "rotation", e, i, n, s);
            };
        },
        function(t, e, i) {
            var a = i(179), h = i(48);
            t.exports = function(t, e, i) {
                for(var n = e.x, s = e.y, r = 0; r < t.length; r++){
                    var o = t[r];
                    a(o, n, s, i, Math.max(1, h(o.x, o.y, n, s)));
                }
                return t;
            };
        },
        function(t, e, i) {
            var a = i(179);
            t.exports = function(t, e, i, n) {
                var s = e.x, r = e.y;
                if (0 === n) return t;
                for(var o = 0; o < t.length; o++)a(t[o], s, r, i, n);
                return t;
            };
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "scaleX", e, i, n, s);
            };
        },
        function(t, e, i) {
            var a = i(44);
            t.exports = function(t, e, i, n, s, r, o) {
                return null == i && (i = e), a(t, "scaleX", e, n, r, o), a(t, "scaleY", i, s, r, o);
            };
        },
        function(t, e, i) {
            var r = i(44);
            t.exports = function(t, e, i, n, s) {
                return r(t, "scaleY", e, i, n, s);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "alpha", e, i, n, s);
            };
        },
        function(t, e, i) {
            var s = i(27);
            t.exports = function(t, e, i, n) {
                return s(t, "blendMode", e, 0, i, n);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "depth", e, i, n, s);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                for(var n = 0; n < t.length; n++)t[n].setInteractive(e, i);
                return t;
            };
        },
        function(t, e, i) {
            var a = i(27);
            t.exports = function(t, e, i, n, s, r, o) {
                return null == i && (i = e), a(t, "originX", e, n, r, o), a(t, "originY", i, s, r, o), t.forEach(function(t) {
                    t.updateDisplayOrigin();
                }), t;
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "rotation", e, i, n, s);
            };
        },
        function(t, e, i) {
            var a = i(27);
            t.exports = function(t, e, i, n, s, r, o) {
                return null == i && (i = e), a(t, "scaleX", e, n, r, o), a(t, "scaleY", i, s, r, o);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "scaleX", e, i, n, s);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "scaleY", e, i, n, s);
            };
        },
        function(t, e, i) {
            var a = i(27);
            t.exports = function(t, e, i, n, s, r, o) {
                return null == i && (i = e), a(t, "scrollFactorX", e, n, r, o), a(t, "scrollFactorY", i, s, r, o);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "scrollFactorX", e, i, n, s);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "scrollFactorY", e, i, n, s);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                for(var r = 0; r < t.length; r++)t[r].setTint(e, i, n, s);
                return t;
            };
        },
        function(t, e, i) {
            var s = i(27);
            t.exports = function(t, e, i, n) {
                return s(t, "visible", e, 0, i, n);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "x", e, i, n, s);
            };
        },
        function(t, e, i) {
            var a = i(27);
            t.exports = function(t, e, i, n, s, r, o) {
                return null == i && (i = e), a(t, "x", e, n, r, o), a(t, "y", i, s, r, o);
            };
        },
        function(t, e, i) {
            var r = i(27);
            t.exports = function(t, e, i, n, s) {
                return r(t, "y", e, i, n, s);
            };
        },
        function(t, e, i) {
            var d = i(3);
            t.exports = function(t, e, i, n, s) {
                var r, o, a;
                if (void 0 === n && (n = 0), void 0 === s && (s = new d), 1 < t.length) {
                    if (0 === n) {
                        for(var h = t.length - 1, l = t[h].x, u = t[h].y, c = h - 1; 0 <= c; c--)r = (a = t[c]).x, o = a.y, a.x = l, a.y = u, l = r, u = o;
                        t[h].x = e, t[h].y = i;
                    } else {
                        for(l = t[0].x, u = t[0].y, c = 1; c < t.length; c++)r = (a = t[c]).x, o = a.y, a.x = l, a.y = u, l = r, u = o;
                        t[0].x = e, t[0].y = i;
                    }
                } else l = t[0].x, u = t[0].y, t[0].x = e, t[0].y = i;
                return s.x = l, s.y = u, s;
            };
        },
        function(t, e, i) {
            var n = i(129);
            t.exports = function(t) {
                return n(t);
            };
        },
        function(t, e, i) {
            var a = i(180);
            t.exports = function(t, e, i, n, s) {
                void 0 === s && (s = !1);
                var r, o = Math.abs(n - i) / t.length;
                if (s) for(r = 0; r < t.length; r++)t[r][e] += a(r * o, i, n);
                else for(r = 0; r < t.length; r++)t[r][e] = a(r * o, i, n);
                return t;
            };
        },
        function(t, e, i) {
            var a = i(181);
            t.exports = function(t, e, i, n, s) {
                void 0 === s && (s = !1);
                var r, o = Math.abs(n - i) / t.length;
                if (s) for(r = 0; r < t.length; r++)t[r][e] += a(r * o, i, n);
                else for(r = 0; r < t.length; r++)t[r][e] = a(r * o, i, n);
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                void 0 === s && (s = !1);
                var r, o = Math.abs(n - i) / t.length;
                if (s) for(r = 0; r < t.length; r++)t[r][e] += r * o + i;
                else for(r = 0; r < t.length; r++)t[r][e] = r * o + i;
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                for(var e = 0; e < t.length; e++)t[e].visible = !t[e].visible;
                return t;
            };
        },
        function(t, e, i) {
            var r = i(66);
            t.exports = function(t, e, i) {
                void 0 === i && (i = 0);
                for(var n = 0; n < t.length; n++){
                    var s = t[n];
                    s.x = r(s.x, e.left - i, e.right + i), s.y = r(s.y, e.top - i, e.bottom + i);
                }
                return t;
            };
        },
        function(t, e, i) {
            t.exports = {
                Animation: i(182),
                AnimationFrame: i(313),
                AnimationManager: i(315),
                AnimationState: i(162),
                Events: i(130)
            };
        },
        function(t, e) {
            t.exports = "add";
        },
        function(t, e) {
            t.exports = "animationcomplete";
        },
        function(t, e) {
            t.exports = "animationcomplete-";
        },
        function(t, e) {
            t.exports = "animationrepeat";
        },
        function(t, e) {
            t.exports = "animationrestart";
        },
        function(t, e) {
            t.exports = "animationstart";
        },
        function(t, e) {
            t.exports = "animationstop";
        },
        function(t, e) {
            t.exports = "animationupdate";
        },
        function(t, e) {
            t.exports = "pauseall";
        },
        function(t, e) {
            t.exports = "remove";
        },
        function(t, e) {
            t.exports = "resumeall";
        },
        function(t, e, i) {
            t.exports = {
                BaseCache: i(317),
                CacheManager: i(319),
                Events: i(318)
            };
        },
        function(t, e) {
            t.exports = "add";
        },
        function(t, e) {
            t.exports = "remove";
        },
        function(t, e, i) {
            t.exports = {
                Controls: i(715),
                Scene2D: i(718)
            };
        },
        function(t, e, i) {
            t.exports = {
                FixedKeyControl: i(716),
                SmoothedKeyControl: i(717)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(6), r = new n({
                initialize: function(t) {
                    this.camera = s(t, "camera", null), this.left = s(t, "left", null), this.right = s(t, "right", null), this.up = s(t, "up", null), this.down = s(t, "down", null), this.zoomIn = s(t, "zoomIn", null), this.zoomOut = s(t, "zoomOut", null), this.zoomSpeed = s(t, "zoomSpeed", .01), this.speedX = 0, this.speedY = 0;
                    var e = s(t, "speed", null);
                    "number" == typeof e ? (this.speedX = e, this.speedY = e) : (this.speedX = s(t, "speed.x", 0), this.speedY = s(t, "speed.y", 0)), this._zoom = 0, this.active = null !== this.camera;
                },
                start: function() {
                    return this.active = null !== this.camera, this;
                },
                stop: function() {
                    return this.active = !1, this;
                },
                setCamera: function(t) {
                    return this.camera = t, this;
                },
                update: function(t) {
                    var e;
                    this.active && (void 0 === t && (t = 1), e = this.camera, this.up && this.up.isDown ? e.scrollY -= this.speedY * t | 0 : this.down && this.down.isDown && (e.scrollY += this.speedY * t | 0), this.left && this.left.isDown ? e.scrollX -= this.speedX * t | 0 : this.right && this.right.isDown && (e.scrollX += this.speedX * t | 0), this.zoomIn && this.zoomIn.isDown ? (e.zoom -= this.zoomSpeed, e.zoom < .1 && (e.zoom = .1)) : this.zoomOut && this.zoomOut.isDown && (e.zoom += this.zoomSpeed));
                },
                destroy: function() {
                    this.camera = null, this.left = null, this.right = null, this.up = null, this.down = null, this.zoomIn = null, this.zoomOut = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(6), r = new n({
                initialize: function(t) {
                    this.camera = s(t, "camera", null), this.left = s(t, "left", null), this.right = s(t, "right", null), this.up = s(t, "up", null), this.down = s(t, "down", null), this.zoomIn = s(t, "zoomIn", null), this.zoomOut = s(t, "zoomOut", null), this.zoomSpeed = s(t, "zoomSpeed", .01), this.accelX = 0, this.accelY = 0;
                    var e = s(t, "acceleration", null);
                    "number" == typeof e ? (this.accelX = e, this.accelY = e) : (this.accelX = s(t, "acceleration.x", 0), this.accelY = s(t, "acceleration.y", 0)), this.dragX = 0, this.dragY = 0;
                    var i = s(t, "drag", null);
                    "number" == typeof i ? (this.dragX = i, this.dragY = i) : (this.dragX = s(t, "drag.x", 0), this.dragY = s(t, "drag.y", 0)), this.maxSpeedX = 0, this.maxSpeedY = 0;
                    var n = s(t, "maxSpeed", null);
                    "number" == typeof n ? (this.maxSpeedX = n, this.maxSpeedY = n) : (this.maxSpeedX = s(t, "maxSpeed.x", 0), this.maxSpeedY = s(t, "maxSpeed.y", 0)), this._speedX = 0, this._speedY = 0, this._zoom = 0, this.active = null !== this.camera;
                },
                start: function() {
                    return this.active = null !== this.camera, this;
                },
                stop: function() {
                    return this.active = !1, this;
                },
                setCamera: function(t) {
                    return this.camera = t, this;
                },
                update: function(t) {
                    var e;
                    this.active && (void 0 === t && (t = 1), e = this.camera, 0 < this._speedX ? (this._speedX -= this.dragX * t, this._speedX < 0 && (this._speedX = 0)) : this._speedX < 0 && (this._speedX += this.dragX * t, 0 < this._speedX && (this._speedX = 0)), 0 < this._speedY ? (this._speedY -= this.dragY * t, this._speedY < 0 && (this._speedY = 0)) : this._speedY < 0 && (this._speedY += this.dragY * t, 0 < this._speedY && (this._speedY = 0)), this.up && this.up.isDown ? (this._speedY += this.accelY, this._speedY > this.maxSpeedY && (this._speedY = this.maxSpeedY)) : this.down && this.down.isDown && (this._speedY -= this.accelY, this._speedY < -this.maxSpeedY && (this._speedY = -this.maxSpeedY)), this.left && this.left.isDown ? (this._speedX += this.accelX, this._speedX > this.maxSpeedX && (this._speedX = this.maxSpeedX)) : this.right && this.right.isDown && (this._speedX -= this.accelX, this._speedX < -this.maxSpeedX && (this._speedX = -this.maxSpeedX)), this.zoomIn && this.zoomIn.isDown ? this._zoom = -this.zoomSpeed : this.zoomOut && this.zoomOut.isDown ? this._zoom = this.zoomSpeed : this._zoom = 0, 0 !== this._speedX && (e.scrollX -= this._speedX * t | 0), 0 !== this._speedY && (e.scrollY -= this._speedY * t | 0), 0 !== this._zoom && (e.zoom += this._zoom, e.zoom < .001 && (e.zoom = .001)));
                },
                destroy: function() {
                    this.camera = null, this.left = null, this.right = null, this.up = null, this.down = null, this.zoomIn = null, this.zoomOut = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            t.exports = {
                Camera: i(320),
                BaseCamera: i(131),
                CameraManager: i(775),
                Effects: i(327),
                Events: i(36)
            };
        },
        function(t, e) {
            t.exports = "cameradestroy";
        },
        function(t, e) {
            t.exports = "camerafadeincomplete";
        },
        function(t, e) {
            t.exports = "camerafadeinstart";
        },
        function(t, e) {
            t.exports = "camerafadeoutcomplete";
        },
        function(t, e) {
            t.exports = "camerafadeoutstart";
        },
        function(t, e) {
            t.exports = "cameraflashcomplete";
        },
        function(t, e) {
            t.exports = "cameraflashstart";
        },
        function(t, e) {
            t.exports = "followupdate";
        },
        function(t, e) {
            t.exports = "camerapancomplete";
        },
        function(t, e) {
            t.exports = "camerapanstart";
        },
        function(t, e) {
            t.exports = "postrender";
        },
        function(t, e) {
            t.exports = "prerender";
        },
        function(t, e) {
            t.exports = "camerarotatecomplete";
        },
        function(t, e) {
            t.exports = "camerarotatestart";
        },
        function(t, e) {
            t.exports = "camerashakecomplete";
        },
        function(t, e) {
            t.exports = "camerashakestart";
        },
        function(t, e) {
            t.exports = "camerazoomcomplete";
        },
        function(t, e) {
            t.exports = "camerazoomstart";
        },
        function(t, e, i) {
            var n = i(18), s = i(0), l = i(36), r = new s({
                initialize: function(t) {
                    this.camera = t, this.isRunning = !1, this.isComplete = !1, this.direction = !0, this.duration = 0, this.red = 0, this.green = 0, this.blue = 0, this.alpha = 0, this.progress = 0, this._elapsed = 0, this._onUpdate, this._onUpdateScope;
                },
                start: function(t, e, i, n, s, r, o, a) {
                    if (void 0 === t && (t = !0), void 0 === e && (e = 1e3), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === r && (r = !1), void 0 === o && (o = null), void 0 === a && (a = this.camera.scene), !r && this.isRunning) return this.camera;
                    this.isRunning = !0, this.isComplete = !1, this.duration = e, this.direction = t, this.progress = 0, this.red = i, this.green = n, this.blue = s, this.alpha = t ? Number.MIN_VALUE : 1, this._elapsed = 0, this._onUpdate = o, this._onUpdateScope = a;
                    var h = t ? l.FADE_OUT_START : l.FADE_IN_START;
                    return this.camera.emit(h, this.camera, this, e, i, n, s), this.camera;
                },
                update: function(t, e) {
                    this.isRunning && (this._elapsed += e, this.progress = n(this._elapsed / this.duration, 0, 1), this._onUpdate && this._onUpdate.call(this._onUpdateScope, this.camera, this.progress), this._elapsed < this.duration ? this.alpha = this.direction ? this.progress : 1 - this.progress : (this.alpha = this.direction ? 1 : 0, this.effectComplete()));
                },
                postRenderCanvas: function(t) {
                    if (!this.isRunning && !this.isComplete) return !1;
                    var e = this.camera;
                    return t.fillStyle = "rgba(" + this.red + "," + this.green + "," + this.blue + "," + this.alpha + ")", t.fillRect(e.x, e.y, e.width, e.height), !0;
                },
                postRenderWebGL: function(t, e) {
                    if (!this.isRunning && !this.isComplete) return !1;
                    var i = this.camera, n = this.red / 255, s = this.green / 255, r = this.blue / 255;
                    return t.drawFillRect(i.x, i.y, i.width, i.height, e(r, s, n, 1), this.alpha), !0;
                },
                effectComplete: function() {
                    this._onUpdate = null, this._onUpdateScope = null, this.isRunning = !1, this.isComplete = !0;
                    var t = this.direction ? l.FADE_OUT_COMPLETE : l.FADE_IN_COMPLETE;
                    this.camera.emit(t, this.camera, this);
                },
                reset: function() {
                    this.isRunning = !1, this.isComplete = !1, this._onUpdate = null, this._onUpdateScope = null;
                },
                destroy: function() {
                    this.reset(), this.camera = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(18), s = i(0), a = i(36), r = new s({
                initialize: function(t) {
                    this.camera = t, this.isRunning = !1, this.duration = 0, this.red = 0, this.green = 0, this.blue = 0, this.alpha = 0, this.progress = 0, this._elapsed = 0, this._onUpdate, this._onUpdateScope;
                },
                start: function(t, e, i, n, s, r, o) {
                    return void 0 === t && (t = 250), void 0 === e && (e = 255), void 0 === i && (i = 255), void 0 === n && (n = 255), void 0 === s && (s = !1), void 0 === r && (r = null), void 0 === o && (o = this.camera.scene), !s && this.isRunning || (this.isRunning = !0, this.duration = t, this.progress = 0, this.red = e, this.green = i, this.blue = n, this.alpha = 1, this._elapsed = 0, this._onUpdate = r, this._onUpdateScope = o, this.camera.emit(a.FLASH_START, this.camera, this, t, e, i, n)), this.camera;
                },
                update: function(t, e) {
                    this.isRunning && (this._elapsed += e, this.progress = n(this._elapsed / this.duration, 0, 1), this._onUpdate && this._onUpdate.call(this._onUpdateScope, this.camera, this.progress), this._elapsed < this.duration ? this.alpha = 1 - this.progress : this.effectComplete());
                },
                postRenderCanvas: function(t) {
                    if (!this.isRunning) return !1;
                    var e = this.camera;
                    return t.fillStyle = "rgba(" + this.red + "," + this.green + "," + this.blue + "," + this.alpha + ")", t.fillRect(e.x, e.y, e.width, e.height), !0;
                },
                postRenderWebGL: function(t, e) {
                    if (!this.isRunning) return !1;
                    var i = this.camera, n = this.red / 255, s = this.green / 255, r = this.blue / 255;
                    return t.drawFillRect(i.x, i.y, i.width, i.height, e(r, s, n, 1), this.alpha), !0;
                },
                effectComplete: function() {
                    this._onUpdate = null, this._onUpdateScope = null, this.isRunning = !1, this.camera.emit(a.FLASH_COMPLETE, this.camera, this);
                },
                reset: function() {
                    this.isRunning = !1, this._onUpdate = null, this._onUpdateScope = null;
                },
                destroy: function() {
                    this.reset(), this.camera = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var a = i(18), n = i(0), h = i(132), l = i(36), s = i(3), r = new n({
                initialize: function(t) {
                    this.camera = t, this.isRunning = !1, this.duration = 0, this.source = new s, this.current = new s, this.destination = new s, this.ease, this.progress = 0, this._elapsed = 0, this._onUpdate, this._onUpdateScope;
                },
                start: function(t, e, i, n, s, r, o) {
                    void 0 === i && (i = 1e3), void 0 === n && (n = h.Linear), void 0 === s && (s = !1), void 0 === r && (r = null), void 0 === o && (o = this.camera.scene);
                    var a = this.camera;
                    return !s && this.isRunning || (this.isRunning = !0, this.duration = i, this.progress = 0, this.source.set(a.scrollX, a.scrollY), this.destination.set(t, e), a.getScroll(t, e, this.current), "string" == typeof n && h.hasOwnProperty(n) ? this.ease = h[n] : "function" == typeof n && (this.ease = n), this._elapsed = 0, this._onUpdate = r, this._onUpdateScope = o, this.camera.emit(l.PAN_START, this.camera, this, i, t, e)), a;
                },
                update: function(t, e) {
                    var i, n, s, r, o;
                    this.isRunning && (this._elapsed += e, i = a(this._elapsed / this.duration, 0, 1), this.progress = i, n = this.camera, this._elapsed < this.duration ? (s = this.ease(i), n.getScroll(this.destination.x, this.destination.y, this.current), r = this.source.x + (this.current.x - this.source.x) * s, o = this.source.y + (this.current.y - this.source.y) * s, n.setScroll(r, o), this._onUpdate && this._onUpdate.call(this._onUpdateScope, n, i, r, o)) : (n.centerOn(this.destination.x, this.destination.y), this._onUpdate && this._onUpdate.call(this._onUpdateScope, n, i, n.scrollX, n.scrollY), this.effectComplete()));
                },
                effectComplete: function() {
                    this._onUpdate = null, this._onUpdateScope = null, this.isRunning = !1, this.camera.emit(l.PAN_COMPLETE, this.camera, this);
                },
                reset: function() {
                    this.isRunning = !1, this._onUpdate = null, this._onUpdateScope = null;
                },
                destroy: function() {
                    this.reset(), this.camera = null, this.source = null, this.destination = null;
                }
            });
            t.exports = r;
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = 1.70158), t * t * ((e + 1) * t - e);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = 1.70158), --t * t * ((e + 1) * t + e) + 1;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 1.70158);
                var i = 1.525 * e;
                return (t *= 2) < 1 ? t * t * ((1 + i) * t - i) * .5 : .5 * ((t -= 2) * t * ((1 + i) * t + i) + 2);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t = 1 - t) < 1 / 2.75 ? 1 - 7.5625 * t * t : t < 2 / 2.75 ? 1 - (7.5625 * (t -= 1.5 / 2.75) * t + .75) : t < 2.5 / 2.75 ? 1 - (7.5625 * (t -= 2.25 / 2.75) * t + .9375) : 1 - (7.5625 * (t -= 2.625 / 2.75) * t + .984375);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = !1;
                return t < .5 ? (t = 1 - 2 * t, e = !0) : t = 2 * t - 1, t < 1 / 2.75 ? t *= 7.5625 * t : t = t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375, e ? .5 * (1 - t) : .5 * t + .5;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.sqrt(1 - --t * t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t *= 2) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t * t * t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return --t * t * t + 1;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t *= 2) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (void 0 === e && (e = .1), void 0 === i && (i = .1), 0 === t) return 0;
                if (1 === t) return 1;
                var n = i / 4;
                return e < 1 ? e = 1 : n = i * Math.asin(1 / e) / (2 * Math.PI), -(e * Math.pow(2, 10 * --t) * Math.sin((t - n) * (2 * Math.PI) / i));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (void 0 === e && (e = .1), void 0 === i && (i = .1), 0 === t) return 0;
                if (1 === t) return 1;
                var n = i / 4;
                return e < 1 ? e = 1 : n = i * Math.asin(1 / e) / (2 * Math.PI), e * Math.pow(2, -10 * t) * Math.sin((t - n) * (2 * Math.PI) / i) + 1;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (void 0 === e && (e = .1), void 0 === i && (i = .1), 0 === t) return 0;
                if (1 === t) return 1;
                var n = i / 4;
                return e < 1 ? e = 1 : n = i * Math.asin(1 / e) / (2 * Math.PI), (t *= 2) < 1 ? e * Math.pow(2, 10 * --t) * Math.sin((t - n) * (2 * Math.PI) / i) * -0.5 : e * Math.pow(2, -10 * --t) * Math.sin((t - n) * (2 * Math.PI) / i) * .5 + 1;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.pow(2, 10 * (t - 1)) - .001;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 1 - Math.pow(2, -10 * t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t *= 2) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t * t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t * (2 - t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t *= 2) < 1 ? .5 * t * t : -0.5 * (--t * (t - 2) - 1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t * t * t * t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 1 - --t * t * t * t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t *= 2) < 1 ? .5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t * t * t * t * t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return --t * t * t * t * t + 1;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t *= 2) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 === t ? 0 : 1 === t ? 1 : 1 - Math.cos(t * Math.PI / 2);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 === t ? 0 : 1 === t ? 1 : Math.sin(t * Math.PI / 2);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 === t ? 0 : 1 === t ? 1 : .5 * (1 - Math.cos(Math.PI * t));
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = 1), t <= 0 ? 0 : 1 <= t ? 1 : 1 / e * (1 + (e * t | 0));
            };
        },
        function(t, e, i) {
            var o = i(18), n = i(0), r = i(36), s = i(3), a = new n({
                initialize: function(t) {
                    this.camera = t, this.isRunning = !1, this.duration = 0, this.intensity = new s, this.progress = 0, this._elapsed = 0, this._offsetX = 0, this._offsetY = 0, this._onUpdate, this._onUpdateScope;
                },
                start: function(t, e, i, n, s) {
                    return void 0 === t && (t = 100), void 0 === e && (e = .05), void 0 === i && (i = !1), void 0 === n && (n = null), void 0 === s && (s = this.camera.scene), !i && this.isRunning || (this.isRunning = !0, this.duration = t, this.progress = 0, "number" == typeof e ? this.intensity.set(e) : this.intensity.set(e.x, e.y), this._elapsed = 0, this._offsetX = 0, this._offsetY = 0, this._onUpdate = n, this._onUpdateScope = s, this.camera.emit(r.SHAKE_START, this.camera, this, t, e)), this.camera;
                },
                preRender: function() {
                    this.isRunning && this.camera.matrix.translate(this._offsetX, this._offsetY);
                },
                update: function(t, e) {
                    var i, n, s, r;
                    this.isRunning && (this._elapsed += e, this.progress = o(this._elapsed / this.duration, 0, 1), this._onUpdate && this._onUpdate.call(this._onUpdateScope, this.camera, this.progress), this._elapsed < this.duration ? (i = this.intensity, n = this.camera.width, s = this.camera.height, r = this.camera.zoom, this._offsetX = (Math.random() * i.x * n * 2 - i.x * n) * r, this._offsetY = (Math.random() * i.y * s * 2 - i.y * s) * r, this.camera.roundPixels && (this._offsetX = Math.round(this._offsetX), this._offsetY = Math.round(this._offsetY))) : this.effectComplete());
                },
                effectComplete: function() {
                    this._offsetX = 0, this._offsetY = 0, this._onUpdate = null, this._onUpdateScope = null, this.isRunning = !1, this.camera.emit(r.SHAKE_COMPLETE, this.camera, this);
                },
                reset: function() {
                    this.isRunning = !1, this._offsetX = 0, this._offsetY = 0, this._onUpdate = null, this._onUpdateScope = null;
                },
                destroy: function() {
                    this.reset(), this.camera = null, this.intensity = null;
                }
            });
            t.exports = a;
        },
        function(t, e, i) {
            var u = i(18), n = i(0), d = i(36), f = i(132), s = new n({
                initialize: function(t) {
                    this.camera = t, this.isRunning = !1, this.duration = 0, this.source = 0, this.current = 0, this.destination = 0, this.ease, this.progress = 0, this._elapsed = 0, this._onUpdate, this._onUpdateScope, this.clockwise = !0, this.shortestPath = !1;
                },
                start: function(t, e, i, n, s, r, o) {
                    void 0 === i && (i = 1e3), void 0 === n && (n = f.Linear), void 0 === s && (s = !1), void 0 === r && (r = null), void 0 === o && (o = this.camera.scene), void 0 === e && (e = !1), this.shortestPath = e;
                    var a = t;
                    t < 0 ? (a = -1 * t, this.clockwise = !1) : this.clockwise = !0;
                    var h = 360 * Math.PI / 180;
                    a -= Math.floor(a / h) * h;
                    var l, u, c = this.camera;
                    return !s && this.isRunning || (this.isRunning = !0, this.duration = i, this.progress = 0, this.source = c.rotation, this.destination = a, "string" == typeof n && f.hasOwnProperty(n) ? this.ease = f[n] : "function" == typeof n && (this.ease = n), this._elapsed = 0, this._onUpdate = r, this._onUpdateScope = o, this.shortestPath && (u = l = 0, (l = this.destination > this.source ? Math.abs(this.destination - this.source) : Math.abs(this.destination + h) - this.source) < (u = this.source > this.destination ? Math.abs(this.source - this.destination) : Math.abs(this.source + h) - this.destination) ? this.clockwise = !0 : u < l && (this.clockwise = !1)), this.camera.emit(d.ROTATE_START, this.camera, this, i, a)), c;
                },
                update: function(t, e) {
                    var i, n, s, r, o, a, h, l;
                    this.isRunning && (this._elapsed += e, i = u(this._elapsed / this.duration, 0, 1), this.progress = i, n = this.camera, this._elapsed < this.duration ? (s = this.ease(i), this.current = n.rotation, r = 0, o = 360 * Math.PI / 180, a = this.destination, h = this.current, !1 === this.clockwise && (a = this.current, h = this.destination), r = h <= a ? Math.abs(a - h) : Math.abs(a + o) - h, l = 0, l = this.clockwise ? n.rotation + r * s : n.rotation - r * s, n.rotation = l, this._onUpdate && this._onUpdate.call(this._onUpdateScope, n, i, l)) : (n.rotation = this.destination, this._onUpdate && this._onUpdate.call(this._onUpdateScope, n, i, this.destination), this.effectComplete()));
                },
                effectComplete: function() {
                    this._onUpdate = null, this._onUpdateScope = null, this.isRunning = !1, this.camera.emit(d.ROTATE_COMPLETE, this.camera, this);
                },
                reset: function() {
                    this.isRunning = !1, this._onUpdate = null, this._onUpdateScope = null;
                },
                destroy: function() {
                    this.reset(), this.camera = null, this.source = null, this.destination = null;
                }
            });
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(18), s = i(0), a = i(132), h = i(36), r = new s({
                initialize: function(t) {
                    this.camera = t, this.isRunning = !1, this.duration = 0, this.source = 1, this.destination = 1, this.ease, this.progress = 0, this._elapsed = 0, this._onUpdate, this._onUpdateScope;
                },
                start: function(t, e, i, n, s, r) {
                    void 0 === e && (e = 1e3), void 0 === i && (i = a.Linear), void 0 === n && (n = !1), void 0 === s && (s = null), void 0 === r && (r = this.camera.scene);
                    var o = this.camera;
                    return !n && this.isRunning || (this.isRunning = !0, this.duration = e, this.progress = 0, this.source = o.zoom, this.destination = t, "string" == typeof i && a.hasOwnProperty(i) ? this.ease = a[i] : "function" == typeof i && (this.ease = i), this._elapsed = 0, this._onUpdate = s, this._onUpdateScope = r, this.camera.emit(h.ZOOM_START, this.camera, this, e, t)), o;
                },
                update: function(t, e) {
                    this.isRunning && (this._elapsed += e, this.progress = n(this._elapsed / this.duration, 0, 1), this._elapsed < this.duration ? (this.camera.zoom = this.source + (this.destination - this.source) * this.ease(this.progress), this._onUpdate && this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.camera.zoom)) : (this.camera.zoom = this.destination, this._onUpdate && this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.destination), this.effectComplete()));
                },
                effectComplete: function() {
                    this._onUpdate = null, this._onUpdateScope = null, this.isRunning = !1, this.camera.emit(h.ZOOM_COMPLETE, this.camera, this);
                },
                reset: function() {
                    this.isRunning = !1, this._onUpdate = null, this._onUpdateScope = null;
                },
                destroy: function() {
                    this.reset(), this.camera = null;
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var a = i(320), n = i(0), v = i(2), s = i(24), h = i(56), r = i(101), o = i(21), l = new n({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.roundPixels = t.sys.game.config.roundPixels, this.cameras = [], this.main, this.default, t.sys.events.once(o.BOOT, this.boot, this), t.sys.events.on(o.START, this.start, this);
                },
                boot: function() {
                    var t = this.systems;
                    t.settings.cameras ? this.fromJSON(t.settings.cameras) : this.add(), this.main = this.cameras[0], this.default = new a(0, 0, t.scale.width, t.scale.height).setScene(this.scene), t.game.scale.on(r.RESIZE, this.onResize, this), this.systems.events.once(o.DESTROY, this.destroy, this);
                },
                start: function() {
                    var t;
                    this.main || ((t = this.systems).settings.cameras ? this.fromJSON(t.settings.cameras) : this.add(), this.main = this.cameras[0]);
                    var e = this.systems.events;
                    e.on(o.UPDATE, this.update, this), e.once(o.SHUTDOWN, this.shutdown, this);
                },
                add: function(t, e, i, n, s, r) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.scene.sys.scale.width), void 0 === n && (n = this.scene.sys.scale.height), void 0 === s && (s = !1), void 0 === r && (r = "");
                    var o = new a(t, e, i, n);
                    return o.setName(r), o.setScene(this.scene), o.setRoundPixels(this.roundPixels), o.id = this.getNextID(), this.cameras.push(o), s && (this.main = o), o;
                },
                addExisting: function(t, e) {
                    return void 0 === e && (e = !1), -1 === this.cameras.indexOf(t) ? (t.id = this.getNextID(), t.setRoundPixels(this.roundPixels), this.cameras.push(t), e && (this.main = t), t) : null;
                },
                getNextID: function() {
                    for(var t = this.cameras, e = 1, i = 0; i < 32; i++){
                        for(var n = !1, s = 0; s < t.length; s++){
                            var r = t[s];
                            r && r.id === e && (n = !0);
                        }
                        if (!n) return e;
                        e <<= 1;
                    }
                    return 0;
                },
                getTotal: function(t) {
                    void 0 === t && (t = !1);
                    for(var e = 0, i = this.cameras, n = 0; n < i.length; n++){
                        var s = i[n];
                        (!t || t && s.visible) && e++;
                    }
                    return e;
                },
                fromJSON: function(t) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = this.scene.sys.scale.width, i = this.scene.sys.scale.height, n = 0; n < t.length; n++){
                        var s = t[n], r = v(s, "x", 0), o = v(s, "y", 0), a = v(s, "width", e), h = v(s, "height", i), l = this.add(r, o, a, h);
                        l.name = v(s, "name", ""), l.zoom = v(s, "zoom", 1), l.rotation = v(s, "rotation", 0), l.scrollX = v(s, "scrollX", 0), l.scrollY = v(s, "scrollY", 0), l.roundPixels = v(s, "roundPixels", !1), l.visible = v(s, "visible", !0);
                        var u = v(s, "backgroundColor", !1);
                        u && l.setBackgroundColor(u);
                        var c, d, f, p, g = v(s, "bounds", null);
                        g && (c = v(g, "x", 0), d = v(g, "y", 0), f = v(g, "width", e), p = v(g, "height", i), l.setBounds(c, d, f, p));
                    }
                    return this;
                },
                getCamera: function(t) {
                    for(var e = this.cameras, i = 0; i < e.length; i++)if (e[i].name === t) return e[i];
                    return null;
                },
                getCamerasBelowPointer: function(t) {
                    for(var e = this.cameras, i = t.x, n = t.y, s = [], r = 0; r < e.length; r++){
                        var o = e[r];
                        o.visible && o.inputEnabled && h(o, i, n) && s.unshift(o);
                    }
                    return s;
                },
                remove: function(t, e) {
                    void 0 === e && (e = !0), Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0, n = this.cameras, s = 0; s < t.length; s++){
                        var r = n.indexOf(t[s]);
                        -1 !== r && (e ? n[r].destroy() : n[r].renderList = [], n.splice(r, 1), i++);
                    }
                    return !this.main && n[0] && (this.main = n[0]), i;
                },
                render: function(t, e) {
                    for(var i = this.scene, n = this.cameras, s = 0; s < this.cameras.length; s++){
                        var r, o = n[s];
                        o.visible && 0 < o.alpha && (o.preRender(), r = this.getVisibleChildren(e.getChildren(), o), t.render(i, r, o));
                    }
                },
                getVisibleChildren: function(t, e) {
                    for(var i = [], n = 0; n < t.length; n++){
                        var s = t[n];
                        s.willRender(e) && i.push(s);
                    }
                    return i;
                },
                resetAll: function() {
                    for(var t = 0; t < this.cameras.length; t++)this.cameras[t].destroy();
                    return this.cameras = [], this.main = this.add(), this.main;
                },
                update: function(t, e) {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].update(t, e);
                },
                onResize: function(t, e, i, n, s) {
                    for(var r = 0; r < this.cameras.length; r++){
                        var o = this.cameras[r];
                        0 === o._x && 0 === o._y && o._width === n && o._height === s && o.setSize(e.width, e.height);
                    }
                },
                resize: function(t, e) {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].setSize(t, e);
                },
                shutdown: function() {
                    this.main = void 0;
                    for(var t = 0; t < this.cameras.length; t++)this.cameras[t].destroy();
                    this.cameras = [];
                    var e = this.systems.events;
                    e.off(o.UPDATE, this.update, this), e.off(o.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.default.destroy(), this.scene.sys.events.off(o.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            s.register("CameraManager", l, "cameras"), t.exports = l;
        },
        function(t, e) {
            t.exports = "enterfullscreen";
        },
        function(t, e) {
            t.exports = "fullscreenfailed";
        },
        function(t, e) {
            t.exports = "fullscreenunsupported";
        },
        function(t, e) {
            t.exports = "leavefullscreen";
        },
        function(t, e) {
            t.exports = "orientationchange";
        },
        function(t, e) {
            t.exports = "resize";
        },
        function(t, e) {
            t.exports = "addedtoscene";
        },
        function(t, e) {
            t.exports = "boot";
        },
        function(t, e) {
            t.exports = "create";
        },
        function(t, e) {
            t.exports = "destroy";
        },
        function(t, e) {
            t.exports = "pause";
        },
        function(t, e) {
            t.exports = "postupdate";
        },
        function(t, e) {
            t.exports = "preupdate";
        },
        function(t, e) {
            t.exports = "ready";
        },
        function(t, e) {
            t.exports = "removedfromscene";
        },
        function(t, e) {
            t.exports = "render";
        },
        function(t, e) {
            t.exports = "resume";
        },
        function(t, e) {
            t.exports = "shutdown";
        },
        function(t, e) {
            t.exports = "sleep";
        },
        function(t, e) {
            t.exports = "start";
        },
        function(t, e) {
            t.exports = "transitioncomplete";
        },
        function(t, e) {
            t.exports = "transitioninit";
        },
        function(t, e) {
            t.exports = "transitionout";
        },
        function(t, e) {
            t.exports = "transitionstart";
        },
        function(t, e) {
            t.exports = "transitionwake";
        },
        function(t, e) {
            t.exports = "update";
        },
        function(t, e) {
            t.exports = "wake";
        },
        function(t, e, i) {
            t.exports = {
                Config: i(340),
                CreateRenderer: i(360),
                DebugHeader: i(378),
                Events: i(22),
                TimeStep: i(379),
                VisibilityHandler: i(381)
            };
        },
        function(t, e) {
            var i, n, s = t.exports = {};
            function r() {
                throw new Error("setTimeout has not been defined");
            }
            function o() {
                throw new Error("clearTimeout has not been defined");
            }
            function a(e) {
                if (i === setTimeout) return setTimeout(e, 0);
                if ((i === r || !i) && setTimeout) return i = setTimeout, setTimeout(e, 0);
                try {
                    return i(e, 0);
                } catch (t) {
                    try {
                        return i.call(null, e, 0);
                    } catch (t) {
                        return i.call(this, e, 0);
                    }
                }
            }
            !function() {
                try {
                    i = "function" == typeof setTimeout ? setTimeout : r;
                } catch (t) {
                    i = r;
                }
                try {
                    n = "function" == typeof clearTimeout ? clearTimeout : o;
                } catch (t) {
                    n = o;
                }
            }();
            var h, l = [], u = !1, c = -1;
            function d() {
                u && h && (u = !1, h.length ? l = h.concat(l) : c = -1, l.length && f());
            }
            function f() {
                if (!u) {
                    var t = a(d);
                    u = !0;
                    for(var e = l.length; e;){
                        for(h = l, l = []; ++c < e;)h && h[c].run();
                        c = -1, e = l.length;
                    }
                    h = null, u = !1, function(e) {
                        if (n === clearTimeout) return clearTimeout(e);
                        if ((n === o || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);
                        try {
                            n(e);
                        } catch (t) {
                            try {
                                return n.call(null, e);
                            } catch (t) {
                                return n.call(this, e);
                            }
                        }
                    }(t);
                }
            }
            function p(t, e) {
                this.fun = t, this.array = e;
            }
            function g() {}
            s.nextTick = function(t) {
                var e = new Array(arguments.length - 1);
                if (1 < arguments.length) for(var i = 1; i < arguments.length; i++)e[i - 1] = arguments[i];
                l.push(new p(t, e)), 1 !== l.length || u || a(f);
            }, p.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = g, s.addListener = g, s.once = g, s.off = g, s.removeListener = g, s.removeAllListeners = g, s.emit = g, s.prependListener = g, s.prependOnceListener = g, s.listeners = function(t) {
                return [];
            }, s.binding = function(t) {
                throw new Error("process.binding is not supported");
            }, s.cwd = function() {
                return "/";
            }, s.chdir = function(t) {
                throw new Error("process.chdir is not supported");
            }, s.umask = function() {
                return 0;
            };
        },
        function(t, e, i) {
            var n = i(134), s = {
                gamepads: !1,
                mspointer: !1,
                touch: !1,
                wheelEvent: null
            };
            t.exports = (("ontouchstart" in document.documentElement || navigator.maxTouchPoints && 1 <= navigator.maxTouchPoints) && (s.touch = !0), (navigator.msPointerEnabled || navigator.pointerEnabled) && (s.mspointer = !0), navigator.getGamepads && (s.gamepads = !0), "onwheel" in window || n.ie && "WheelEvent" in window ? s.wheelEvent = "wheel" : "onmousewheel" in window ? s.wheelEvent = "mousewheel" : n.firefox && "MouseScrollEvent" in window && (s.wheelEvent = "DOMMouseScroll"), s);
        },
        function(t, e, i) {
            var s = i(134), r = {
                audioData: !1,
                dolby: !1,
                m4a: !1,
                mp3: !1,
                ogg: !1,
                opus: !1,
                wav: !1,
                webAudio: !1,
                webm: !1
            };
            t.exports = function() {
                r.audioData = !!window.Audio, r.webAudio = !(!window.AudioContext && !window.webkitAudioContext);
                var t, e, i = document.createElement("audio"), n = !!i.canPlayType;
                try {
                    n && (i.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "") && (r.ogg = !0), (i.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, "") || i.canPlayType("audio/opus;").replace(/^no$/, "")) && (r.opus = !0), i.canPlayType("audio/mpeg;").replace(/^no$/, "") && (r.mp3 = !0), i.canPlayType("audio/wav").replace(/^no$/, "") && (r.wav = !0), (i.canPlayType("audio/x-m4a;") || i.canPlayType("audio/aac;").replace(/^no$/, "")) && (r.m4a = !0), i.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "") && (r.webm = !0), "" !== i.canPlayType('audio/mp4;codecs="ec-3"') && (s.edge ? r.dolby = !0 : s.safari && 9 <= s.safariVersion && /Mac OS X (\d+)_(\d+)/.test(navigator.userAgent) && (t = parseInt(RegExp.$1, 10), e = parseInt(RegExp.$2, 10), (10 === t && 11 <= e || 10 < t) && (r.dolby = !0))));
                } catch (t) {}
                return r;
            }();
        },
        function(t, e) {
            var i = {
                h264: !1,
                hls: !1,
                mp4: !1,
                ogg: !1,
                vp9: !1,
                webm: !1
            };
            t.exports = function() {
                var t = document.createElement("video"), e = !!t.canPlayType;
                try {
                    e && (t.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, "") && (i.ogg = !0), t.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, "") && (i.h264 = !0, i.mp4 = !0), t.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, "") && (i.webm = !0), t.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, "") && (i.vp9 = !0), t.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, "") && (i.hls = !0));
                } catch (t) {}
                return i;
            }();
        },
        function(t, e) {
            var r = {
                available: !1,
                cancel: "",
                keyboard: !1,
                request: ""
            };
            t.exports = function() {
                for(var t = "Fullscreen", e = "FullScreen", i = [
                    "request" + t,
                    "request" + e,
                    "webkitRequest" + t,
                    "webkitRequest" + e,
                    "msRequest" + t,
                    "msRequest" + e,
                    "mozRequest" + e,
                    "mozRequest" + t
                ], n = 0; n < i.length; n++)if (document.documentElement[i[n]]) {
                    r.available = !0, r.request = i[n];
                    break;
                }
                var s = [
                    "cancel" + e,
                    "exit" + t,
                    "webkitCancel" + e,
                    "webkitExit" + t,
                    "msCancel" + e,
                    "msExit" + t,
                    "mozCancel" + e,
                    "mozExit" + t
                ];
                if (r.available) {
                    for(n = 0; n < s.length; n++)if (document[s[n]]) {
                        r.cancel = s[n];
                        break;
                    }
                }
                return window.Element && Element.ALLOW_KEYBOARD_INPUT && !/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent) && (r.keyboard = !0), Object.defineProperty(r, "active", {
                    get: function() {
                        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
                    }
                }), r;
            }();
        },
        function(t, e, i) {
            t.exports = {
                Between: i(343),
                BetweenPoints: i(344),
                BetweenPointsY: i(810),
                BetweenY: i(811),
                CounterClockwise: i(812),
                Normalize: i(345),
                Random: i(813),
                RandomDegrees: i(814),
                Reverse: i(815),
                RotateTo: i(816),
                ShortestBetween: i(817),
                Wrap: i(265),
                WrapDegrees: i(266)
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return Math.atan2(e.x - t.x, e.y - t.y);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return Math.atan2(i - t, n - e);
            };
        },
        function(t, e, i) {
            var n = i(14);
            t.exports = function(t) {
                return t > Math.PI && (t -= n.PI2), Math.abs(((t + n.TAU) % n.PI2 - n.PI2) % n.PI2);
            };
        },
        function(t, e, i) {
            var n = i(135);
            t.exports = function() {
                return n(-Math.PI, Math.PI);
            };
        },
        function(t, e, i) {
            var n = i(135);
            t.exports = function() {
                return n(-180, 180);
            };
        },
        function(t, e, i) {
            var n = i(345);
            t.exports = function(t) {
                return n(t + Math.PI);
            };
        },
        function(t, e, i) {
            var n = i(14);
            t.exports = function(t, e, i) {
                return void 0 === i && (i = .05), t === e || (Math.abs(e - t) <= i || Math.abs(e - t) >= n.PI2 - i ? t = e : (Math.abs(e - t) > Math.PI && (e < t ? e += n.PI2 : e -= n.PI2), t < e ? t += i : e < t && (t -= i))), t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = e - t;
                return 0 == i ? 0 : i - 360 * Math.floor((i + 180) / 360);
            };
        },
        function(t, e, i) {
            t.exports = {
                Between: i(48),
                BetweenPoints: i(346),
                BetweenPointsSquared: i(819),
                Chebyshev: i(820),
                Power: i(821),
                Snake: i(822),
                Squared: i(347)
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.x - e.x, n = t.y - e.y;
                return i * i + n * n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return Math.max(Math.abs(t - i), Math.abs(e - n));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                return void 0 === s && (s = 2), Math.sqrt(Math.pow(i - t, s) + Math.pow(n - e, s));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return Math.abs(t - i) + Math.abs(e - n);
            };
        },
        function(t, e, i) {
            t.exports = {
                Back: i(328),
                Bounce: i(329),
                Circular: i(330),
                Cubic: i(331),
                Elastic: i(332),
                Expo: i(333),
                Linear: i(334),
                Quadratic: i(335),
                Quartic: i(336),
                Quintic: i(337),
                Sine: i(338),
                Stepped: i(339)
            };
        },
        function(t, e, i) {
            t.exports = {
                Ceil: i(825),
                Equal: i(123),
                Floor: i(826),
                GreaterThan: i(348),
                LessThan: i(349)
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = 1e-4), Math.ceil(t - e);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = 1e-4), Math.floor(t + e);
            };
        },
        function(t, e, i) {
            t.exports = {
                Bezier: i(828),
                CatmullRom: i(829),
                CubicBezier: i(352),
                Linear: i(830),
                QuadraticBezier: i(353),
                SmoothStep: i(354),
                SmootherStep: i(831)
            };
        },
        function(t, e, i) {
            var r = i(350);
            t.exports = function(t, e) {
                for(var i = 0, n = t.length - 1, s = 0; s <= n; s++)i += Math.pow(1 - e, n - s) * Math.pow(e, s) * t[s] * r(n, s);
                return i;
            };
        },
        function(t, e, i) {
            var r = i(191);
            t.exports = function(t, e) {
                var i = t.length - 1, n = i * e, s = Math.floor(n);
                return t[0] === t[i] ? (e < 0 && (s = Math.floor(n = i * (1 + e))), r(n - s, t[(s - 1 + i) % i], t[s], t[(s + 1) % i], t[(s + 2) % i])) : e < 0 ? t[0] - (r(-n, t[0], t[0], t[1], t[1]) - t[0]) : 1 < e ? t[i] - (r(n - i, t[i], t[i], t[i - 1], t[i - 1]) - t[i]) : r(n - s, t[s ? s - 1 : 0], t[s], t[i < s + 1 ? i : s + 1], t[i < s + 2 ? i : s + 2]);
            };
        },
        function(t, e, i) {
            var r = i(133);
            t.exports = function(t, e) {
                var i = t.length - 1, n = i * e, s = Math.floor(n);
                return e < 0 ? r(t[0], t[1], n) : 1 < e ? r(t[i], t[i - 1], i - n) : r(t[s], t[i < s + 1 ? i : s + 1], n - s);
            };
        },
        function(t, e, i) {
            var n = i(180);
            t.exports = function(t, e, i) {
                return e + (i - e) * n(t, 0, 1);
            };
        },
        function(t, e, i) {
            t.exports = {
                GetNext: i(355),
                IsSize: i(136),
                IsValue: i(833)
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 < t && 0 == (t & t - 1);
            };
        },
        function(t, e, i) {
            t.exports = {
                Ceil: i(137),
                Floor: i(76),
                To: i(835)
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), 0 === e ? t : (t -= i, t = e * Math.round(t / e), n ? (i + t) / e : i + t);
            };
        },
        function(t, e, i) {
            var n = new (i(0))({
                initialize: function(t) {
                    void 0 === t && (t = [
                        (Date.now() * Math.random()).toString()
                    ]), this.c = 1, this.s0 = 0, this.s1 = 0, this.s2 = 0, this.n = 0, this.signs = [
                        -1,
                        1
                    ], t && this.init(t);
                },
                rnd: function() {
                    var t = 2091639 * this.s0 + 2.3283064365386963e-10 * this.c;
                    return this.c = 0 | t, this.s0 = this.s1, this.s1 = this.s2, this.s2 = t - this.c, this.s2;
                },
                hash: function(t) {
                    var e, i = this.n;
                    t = t.toString();
                    for(var n = 0; n < t.length; n++)e = .02519603282416938 * (i += t.charCodeAt(n)), e -= i = e >>> 0, i = (e *= i) >>> 0, i += 4294967296 * (e -= i);
                    return 2.3283064365386963e-10 * ((this.n = i) >>> 0);
                },
                init: function(t) {
                    "string" == typeof t ? this.state(t) : this.sow(t);
                },
                sow: function(t) {
                    if (this.n = 4022871197, this.s0 = this.hash(" "), this.s1 = this.hash(" "), this.s2 = this.hash(" "), this.c = 1, t) for(var e = 0; e < t.length && null != t[e]; e++){
                        var i = t[e];
                        this.s0 -= this.hash(i), this.s0 += ~~(this.s0 < 0), this.s1 -= this.hash(i), this.s1 += ~~(this.s1 < 0), this.s2 -= this.hash(i), this.s2 += ~~(this.s2 < 0);
                    }
                },
                integer: function() {
                    return 4294967296 * this.rnd();
                },
                frac: function() {
                    return this.rnd() + 11102230246251565e-32 * (2097152 * this.rnd() | 0);
                },
                real: function() {
                    return this.integer() + this.frac();
                },
                integerInRange: function(t, e) {
                    return Math.floor(this.realInRange(0, e - t + 1) + t);
                },
                between: function(t, e) {
                    return Math.floor(this.realInRange(0, e - t + 1) + t);
                },
                realInRange: function(t, e) {
                    return this.frac() * (e - t) + t;
                },
                normal: function() {
                    return 1 - 2 * this.frac();
                },
                uuid: function() {
                    for(var t = "", e = "", e = t = ""; t++ < 36; e += ~t % 5 | 3 * t & 4 ? (15 ^ t ? 8 ^ this.frac() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-");
                    return e;
                },
                pick: function(t) {
                    return t[this.integerInRange(0, t.length - 1)];
                },
                sign: function() {
                    return this.pick(this.signs);
                },
                weightedPick: function(t) {
                    return t[~~(Math.pow(this.frac(), 2) * (t.length - 1) + .5)];
                },
                timestamp: function(t, e) {
                    return this.realInRange(t || 9466848e5, e || 1577862e6);
                },
                angle: function() {
                    return this.integerInRange(-180, 180);
                },
                rotation: function() {
                    return this.realInRange(-3.1415926, 3.1415926);
                },
                state: function(t) {
                    return "string" == typeof t && t.match(/^!rnd/) && (t = t.split(","), this.c = parseFloat(t[1]), this.s0 = parseFloat(t[2]), this.s1 = parseFloat(t[3]), this.s2 = parseFloat(t[4])), [
                        "!rnd",
                        this.c,
                        this.s0,
                        this.s1,
                        this.s2
                    ].join(",");
                },
                shuffle: function(t) {
                    for(var e = t.length - 1; 0 < e; e--){
                        var i = Math.floor(this.frac() * (e + 1)), n = t[i];
                        t[i] = t[e], t[e] = n;
                    }
                    return t;
                }
            });
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                for(var e = 0, i = 0; i < t.length; i++)e += +t[i];
                return e / t.length;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === e && (e = 0), void 0 === i && (i = 10);
                var n = Math.pow(i, -e);
                return Math.ceil(t * n) / n;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return Math.abs(t - e);
            };
        },
        function(t, e, i) {
            var m = i(18), n = i(0), s = i(67), r = i(1), o = new s, a = new n({
                initialize: function t(e, i, n, s) {
                    void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === s && (s = t.DefaultOrder), this._x = e, this._y = i, this._z = n, this._order = s, this.onChangeCallback = r;
                },
                x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(t) {
                        this._x = t, this.onChangeCallback(this);
                    }
                },
                y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(t) {
                        this._y = t, this.onChangeCallback(this);
                    }
                },
                z: {
                    get: function() {
                        return this._z;
                    },
                    set: function(t) {
                        this._z = t, this.onChangeCallback(this);
                    }
                },
                order: {
                    get: function() {
                        return this._order;
                    },
                    set: function(t) {
                        this._order = t, this.onChangeCallback(this);
                    }
                },
                set: function(t, e, i, n) {
                    return void 0 === n && (n = this._order), this._x = t, this._y = e, this._z = i, this._order = n, this.onChangeCallback(this), this;
                },
                copy: function(t) {
                    return this.set(t.x, t.y, t.z, t.order);
                },
                setFromQuaternion: function(t, e, i) {
                    return void 0 === e && (e = this._order), void 0 === i && (i = !1), o.fromQuat(t), this.setFromRotationMatrix(o, e, i);
                },
                setFromRotationMatrix: function(t, e, i) {
                    void 0 === e && (e = this._order), void 0 === i && (i = !1);
                    var n = t.val, s = n[0], r = n[4], o = n[8], a = n[1], h = n[5], l = n[9], u = n[2], c = n[6], d = n[10], f = 0, p = 0, g = 0, v = .99999;
                    switch(e){
                        case "XYZ":
                            p = Math.asin(m(o, -1, 1)), Math.abs(o) < v ? (f = Math.atan2(-l, d), g = Math.atan2(-r, s)) : f = Math.atan2(c, h);
                            break;
                        case "YXZ":
                            f = Math.asin(-m(l, -1, 1)), Math.abs(l) < v ? (p = Math.atan2(o, d), g = Math.atan2(a, h)) : p = Math.atan2(-u, s);
                            break;
                        case "ZXY":
                            f = Math.asin(m(c, -1, 1)), g = Math.abs(c) < v ? (p = Math.atan2(-u, d), Math.atan2(-r, h)) : Math.atan2(a, s);
                            break;
                        case "ZYX":
                            p = Math.asin(-m(u, -1, 1)), g = Math.abs(u) < v ? (f = Math.atan2(c, d), Math.atan2(a, s)) : Math.atan2(-r, h);
                            break;
                        case "YZX":
                            g = Math.asin(m(a, -1, 1)), p = Math.abs(a) < v ? (f = Math.atan2(-l, h), Math.atan2(-u, s)) : Math.atan2(o, d);
                            break;
                        case "XZY":
                            g = Math.asin(-m(r, -1, 1)), Math.abs(r) < v ? (f = Math.atan2(c, h), p = Math.atan2(o, s)) : f = Math.atan2(-l, d);
                    }
                    return this._x = f, this._y = p, this._z = g, this._order = e, i && this.onChangeCallback(this), this;
                }
            });
            a.RotationOrders = [
                "XYZ",
                "YXZ",
                "ZXY",
                "ZYX",
                "YZX",
                "XZY"
            ], a.DefaultOrder = "XYZ", t.exports = a;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === e && (e = 0), void 0 === i && (i = 10);
                var n = Math.pow(i, -e);
                return Math.floor(t * n) / n;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t / e / 1e3;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t == parseFloat(t) ? !(t % 2) : void 0;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t === parseFloat(t) ? !(t % 2) : void 0;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return Math.min(t + e, i);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return Math.max(t - e, i);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === i && (i = e + 1);
                var s = (t - e) / (i - e);
                return 1 < s ? void 0 !== n ? (s = (n - t) / (n - i)) < 0 && (s = 0) : s = 1 : s < 0 && (s = 0), s;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 1);
                var i = 2 * Math.random() * Math.PI;
                return t.x = Math.cos(i) * e, t.y = Math.sin(i) * e, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 1);
                var i = 2 * Math.random() * Math.PI, n = 2 * Math.random() - 1, s = Math.sqrt(1 - n * n) * e;
                return t.x = Math.cos(i) * s, t.y = Math.sin(i) * s, t.z = n * e, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = 1), t.x = (2 * Math.random() - 1) * e, t.y = (2 * Math.random() - 1) * e, t.z = (2 * Math.random() - 1) * e, t.w = (2 * Math.random() - 1) * e, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                return t.x = e + s * Math.cos(n), t.y = i + s * Math.sin(n), t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                void 0 === e && (e = 0), void 0 === i && (i = 10);
                var n = Math.pow(i, -e);
                return Math.round(t * n) / n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = 1), void 0 === i && (i = 1), void 0 === n && (n = 1), n *= Math.PI / t;
                for(var s = [], r = [], o = 0; o < t; o++)e += (i -= e * n) * n, s[o] = i, r[o] = e;
                return {
                    sin: r,
                    cos: s,
                    length: t
                };
            };
        },
        function(t, e, i) {
            var o = i(3);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = new o);
                var s = 0, r = 0;
                return 0 < t && t <= e * i && (s = e - 1 < t ? t - (r = Math.floor(t / e)) * e : t, n.set(s, r)), n;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return Math.abs(t - e) <= i;
            };
        },
        function(t, e, i) {
            var n = i(38), s = i(67), r = i(359), o = new s, a = new r, h = new n;
            t.exports = function(t, e, i) {
                return a.setAxisAngle(e, i), o.fromRotationTranslation(a, h.set(0, 0, 0)), t.transformMat4(o);
            };
        },
        function(t, e) {
            t.exports = "addtexture";
        },
        function(t, e) {
            t.exports = "onerror";
        },
        function(t, e) {
            t.exports = "onload";
        },
        function(t, e) {
            t.exports = "ready";
        },
        function(t, e) {
            t.exports = "removetexture";
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_BITMAP_MASK_FS",
                "",
                "precision mediump float;",
                "",
                "uniform vec2 uResolution;",
                "uniform sampler2D uMainSampler;",
                "uniform sampler2D uMaskSampler;",
                "uniform bool uInvertMaskAlpha;",
                "",
                "void main ()",
                "{",
                "    vec2 uv = gl_FragCoord.xy / uResolution;",
                "    vec4 mainColor = texture2D(uMainSampler, uv);",
                "    vec4 maskColor = texture2D(uMaskSampler, uv);",
                "    float alpha = mainColor.a;",
                "",
                "    if (!uInvertMaskAlpha)",
                "    {",
                "        alpha *= (maskColor.a);",
                "    }",
                "    else",
                "    {",
                "        alpha *= (1.0 - maskColor.a);",
                "    }",
                "",
                "    gl_FragColor = vec4(mainColor.rgb * alpha, alpha);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_BITMAP_MASK_VS",
                "",
                "precision mediump float;",
                "",
                "attribute vec2 inPosition;",
                "",
                "void main ()",
                "{",
                "    gl_Position = vec4(inPosition, 0.0, 1.0);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = "pipelineafterflush";
        },
        function(t, e) {
            t.exports = "pipelinebeforeflush";
        },
        function(t, e) {
            t.exports = "pipelinebind";
        },
        function(t, e) {
            t.exports = "pipelineboot";
        },
        function(t, e) {
            t.exports = "pipelinedestroy";
        },
        function(t, e) {
            t.exports = "pipelinerebind";
        },
        function(t, e) {
            t.exports = "pipelineresize";
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_GRAPHICS_FS",
                "",
                "precision mediump float;",
                "",
                "varying vec4 outColor;",
                "",
                "void main ()",
                "{",
                "    gl_FragColor = vec4(outColor.bgr * outColor.a, outColor.a);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_GRAPHICS_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec4 inColor;",
                "",
                "varying vec4 outColor;",
                "",
                "void main ()",
                "{",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "",
                "    outColor = inColor;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_LIGHT_FS",
                "",
                "precision mediump float;",
                "",
                "struct Light",
                "{",
                "    vec2 position;",
                "    vec3 color;",
                "    float intensity;",
                "    float radius;",
                "};",
                "",
                "const int kMaxLights = %LIGHT_COUNT%;",
                "",
                "uniform vec4 uCamera; /* x, y, rotation, zoom */",
                "uniform vec2 uResolution;",
                "uniform sampler2D uMainSampler;",
                "uniform sampler2D uNormSampler;",
                "uniform vec3 uAmbientLightColor;",
                "uniform Light uLights[kMaxLights];",
                "uniform mat3 uInverseRotationMatrix;",
                "",
                "varying vec2 outTexCoord;",
                "varying vec4 outTint;",
                "",
                "void main()",
                "{",
                "    vec3 finalColor = vec3(0.0, 0.0, 0.0);",
                "    vec4 color = texture2D(uMainSampler, outTexCoord) * vec4(outTint.bgr * outTint.a, outTint.a);",
                "    vec3 normalMap = texture2D(uNormSampler, outTexCoord).rgb;",
                "    vec3 normal = normalize(uInverseRotationMatrix * vec3(normalMap * 2.0 - 1.0));",
                "    vec2 res = vec2(min(uResolution.x, uResolution.y)) * uCamera.w;",
                "",
                "    for (int index = 0; index < kMaxLights; ++index)",
                "    {",
                "        Light light = uLights[index];",
                "        vec3 lightDir = vec3((light.position.xy / res) - (gl_FragCoord.xy / res), 0.1);",
                "        vec3 lightNormal = normalize(lightDir);",
                "        float distToSurf = length(lightDir) * uCamera.w;",
                "        float diffuseFactor = max(dot(normal, lightNormal), 0.0);",
                "        float radius = (light.radius / res.x * uCamera.w) * uCamera.w;",
                "        float attenuation = clamp(1.0 - distToSurf * distToSurf / (radius * radius), 0.0, 1.0);",
                "        vec3 diffuse = light.color * diffuseFactor;",
                "        finalColor += (attenuation * diffuse) * light.intensity;",
                "    }",
                "",
                "    vec4 colorOutput = vec4(uAmbientLightColor + finalColor, 1.0);",
                "",
                "    gl_FragColor = color * vec4(colorOutput.rgb * colorOutput.a, colorOutput.a);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_MULTI_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler[%count%];",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTexId;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    vec4 texture;",
                "",
                "    %forloop%",
                "",
                "    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);",
                "",
                "    //  Multiply texture tint",
                "    vec4 color = texture * texel;",
                "",
                "    if (outTintEffect == 1.0)",
                "    {",
                "        //  Solid color + texture alpha",
                "        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);",
                "    }",
                "    else if (outTintEffect == 2.0)",
                "    {",
                "        //  Solid color, no texture",
                "        color = texel;",
                "    }",
                "",
                "    gl_FragColor = color;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_MULTI_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inTexCoord;",
                "attribute float inTexId;",
                "attribute float inTintEffect;",
                "attribute vec4 inTint;",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTexId;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "",
                "    outTexCoord = inTexCoord;",
                "    outTexId = inTexId;",
                "    outTint = inTint;",
                "    outTintEffect = inTintEffect;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_POINTLIGHT_FS",
                "",
                "precision mediump float;",
                "",
                "uniform vec2 uResolution;",
                "uniform float uCameraZoom;",
                "",
                "varying vec4 lightPosition;",
                "varying vec4 lightColor;",
                "varying float lightRadius;",
                "varying float lightAttenuation;",
                "",
                "void main ()",
                "{",
                "    vec2 center = (lightPosition.xy + 1.0) * (uResolution.xy * 0.5);",
                "",
                "    float distToSurf = length(center - gl_FragCoord.xy);",
                "",
                "    float radius = 1.0 - distToSurf / (lightRadius * uCameraZoom);",
                "",
                "    float intensity = smoothstep(0.0, 1.0, radius * lightAttenuation);",
                "",
                "    vec4 color = vec4(intensity, intensity, intensity, 0.0) * lightColor;",
                "",
                "    gl_FragColor = vec4(color.rgb * lightColor.a, color.a);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_POINTLIGHT_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inLightPosition;",
                "attribute vec4 inLightColor;",
                "attribute float inLightRadius;",
                "attribute float inLightAttenuation;",
                "",
                "varying vec4 lightPosition;",
                "varying vec4 lightColor;",
                "varying float lightRadius;",
                "varying float lightAttenuation;",
                "",
                "void main ()",
                "{",
                "    lightColor = inLightColor;",
                "    lightRadius = inLightRadius;",
                "    lightAttenuation = inLightAttenuation;",
                "    lightPosition = uProjectionMatrix * vec4(inLightPosition, 1.0, 1.0);",
                "",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_SINGLE_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    vec4 texture = texture2D(uMainSampler, outTexCoord);",
                "    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);",
                "",
                "    //  Multiply texture tint",
                "    vec4 color = texture * texel;",
                "",
                "    if (outTintEffect == 1.0)",
                "    {",
                "        //  Solid color + texture alpha",
                "        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);",
                "    }",
                "    else if (outTintEffect == 2.0)",
                "    {",
                "        //  Solid color, no texture",
                "        color = texel;",
                "    }",
                "",
                "    gl_FragColor = color;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_SINGLE_VS",
                "",
                "precision mediump float;",
                "",
                "uniform mat4 uProjectionMatrix;",
                "",
                "attribute vec2 inPosition;",
                "attribute vec2 inTexCoord;",
                "attribute float inTexId;",
                "attribute float inTintEffect;",
                "attribute vec4 inTint;",
                "",
                "varying vec2 outTexCoord;",
                "varying float outTintEffect;",
                "varying vec4 outTint;",
                "",
                "void main ()",
                "{",
                "    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);",
                "",
                "    outTexCoord = inTexCoord;",
                "    outTint = inTint;",
                "    outTintEffect = inTintEffect;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_ADD_BLEND_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler1;",
                "uniform sampler2D uMainSampler2;",
                "uniform float uStrength;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);",
                "    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);",
                "",
                "    gl_FragColor = frame1 + frame2 * uStrength;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_COLORMATRIX_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "uniform float uColorMatrix[20];",
                "uniform float uAlpha;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    vec4 c = texture2D(uMainSampler, outTexCoord);",
                "",
                "    if (uAlpha == 0.0)",
                "    {",
                "        gl_FragColor = c;",
                "",
                "        return;",
                "    }",
                "",
                "    if (c.a > 0.0)",
                "    {",
                "        c.rgb /= c.a;",
                "    }",
                "",
                "    vec4 result;",
                "",
                "    result.r = (uColorMatrix[0] * c.r) + (uColorMatrix[1] * c.g) + (uColorMatrix[2] * c.b) + (uColorMatrix[3] * c.a) + uColorMatrix[4];",
                "    result.g = (uColorMatrix[5] * c.r) + (uColorMatrix[6] * c.g) + (uColorMatrix[7] * c.b) + (uColorMatrix[8] * c.a) + uColorMatrix[9];",
                "    result.b = (uColorMatrix[10] * c.r) + (uColorMatrix[11] * c.g) + (uColorMatrix[12] * c.b) + (uColorMatrix[13] * c.a) + uColorMatrix[14];",
                "    result.a = (uColorMatrix[15] * c.r) + (uColorMatrix[16] * c.g) + (uColorMatrix[17] * c.b) + (uColorMatrix[18] * c.a) + uColorMatrix[19];",
                "",
                "    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);",
                "",
                "    rgb *= result.a;",
                "",
                "    gl_FragColor = vec4(rgb, result.a);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_COPY_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "uniform float uBrightness;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    gl_FragColor = texture2D(uMainSampler, outTexCoord) * uBrightness;",
                "}",
                ""
            ].join("\n");
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_LINEAR_BLEND_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler1;",
                "uniform sampler2D uMainSampler2;",
                "uniform float uStrength;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);",
                "    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);",
                "",
                "    gl_FragColor = mix(frame1, frame2 * uStrength, 0.5);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e, i) {
            t.exports = {
                GenerateTexture: i(382),
                Palettes: i(885)
            };
        },
        function(t, e, i) {
            t.exports = {
                ARNE16: i(383),
                C64: i(886),
                CGA: i(887),
                JMP: i(888),
                MSX: i(889)
            };
        },
        function(t, e) {
            t.exports = {
                0: "#000",
                1: "#fff",
                2: "#8b4131",
                3: "#7bbdc5",
                4: "#8b41ac",
                5: "#6aac41",
                6: "#3931a4",
                7: "#d5de73",
                8: "#945a20",
                9: "#5a4100",
                A: "#bd736a",
                B: "#525252",
                C: "#838383",
                D: "#acee8b",
                E: "#7b73de",
                F: "#acacac"
            };
        },
        function(t, e) {
            t.exports = {
                0: "#000",
                1: "#2234d1",
                2: "#0c7e45",
                3: "#44aacc",
                4: "#8a3622",
                5: "#5c2e78",
                6: "#aa5c3d",
                7: "#b5b5b5",
                8: "#5e606e",
                9: "#4c81fb",
                A: "#6cd947",
                B: "#7be2f9",
                C: "#eb8a60",
                D: "#e23d69",
                E: "#ffd93f",
                F: "#fff"
            };
        },
        function(t, e) {
            t.exports = {
                0: "#000",
                1: "#191028",
                2: "#46af45",
                3: "#a1d685",
                4: "#453e78",
                5: "#7664fe",
                6: "#833129",
                7: "#9ec2e8",
                8: "#dc534b",
                9: "#e18d79",
                A: "#d6b97b",
                B: "#e9d8a1",
                C: "#216c4b",
                D: "#d365c8",
                E: "#afaab9",
                F: "#f5f4eb"
            };
        },
        function(t, e) {
            t.exports = {
                0: "#000",
                1: "#191028",
                2: "#46af45",
                3: "#a1d685",
                4: "#453e78",
                5: "#7664fe",
                6: "#833129",
                7: "#9ec2e8",
                8: "#dc534b",
                9: "#e18d79",
                A: "#d6b97b",
                B: "#e9d8a1",
                C: "#216c4b",
                D: "#d365c8",
                E: "#afaab9",
                F: "#fff"
            };
        },
        function(t, e, i) {
            t.exports = {
                Path: i(891),
                MoveTo: i(387),
                CubicBezier: i(384),
                Curve: i(90),
                Ellipse: i(385),
                Line: i(386),
                QuadraticBezier: i(388),
                Spline: i(389)
            };
        },
        function(t, e, i) {
            var n = i(0), u = i(384), l = i(385), s = i(5), r = i(386), o = i(387), a = i(388), h = i(10), c = i(389), d = i(3), f = i(14), p = new n({
                initialize: function(t, e) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), this.name = "", this.curves = [], this.cacheLengths = [], this.autoClose = !1, this.startPoint = new d, this._tmpVec2A = new d, this._tmpVec2B = new d, "object" == typeof t ? this.fromJSON(t) : this.startPoint.set(t, e);
                },
                add: function(t) {
                    return this.curves.push(t), this;
                },
                circleTo: function(t, e, i) {
                    return void 0 === e && (e = !1), this.ellipseTo(t, t, 0, 360, e, i);
                },
                closePath: function() {
                    var t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
                    return t.equals(e) || this.curves.push(new r(e, t)), this;
                },
                cubicBezierTo: function(t, e, i, n, s, r) {
                    var o, a, h = this.getEndPoint(), l = t instanceof d ? (o = t, a = e, i) : (o = new d(i, n), a = new d(s, r), new d(t, e));
                    return this.add(new u(h, o, a, l));
                },
                quadraticBezierTo: function(t, e, i, n) {
                    var s, r = this.getEndPoint(), o = t instanceof d ? (s = t, e) : (s = new d(i, n), new d(t, e));
                    return this.add(new a(r, s, o));
                },
                draw: function(t, e) {
                    for(var i = 0; i < this.curves.length; i++){
                        var n = this.curves[i];
                        n.active && n.draw(t, e);
                    }
                    return t;
                },
                ellipseTo: function(t, e, i, n, s, r) {
                    var o = new l(0, 0, t, e, i, n, s, r), a = this.getEndPoint(this._tmpVec2A), h = o.getStartPoint(this._tmpVec2B);
                    return a.subtract(h), o.x = a.x, o.y = a.y, this.add(o);
                },
                fromJSON: function(t) {
                    this.curves = [], this.cacheLengths = [], this.startPoint.set(t.x, t.y), this.autoClose = t.autoClose;
                    for(var e = 0; e < t.curves.length; e++){
                        var i = t.curves[e];
                        switch(i.type){
                            case "LineCurve":
                                this.add(r.fromJSON(i));
                                break;
                            case "EllipseCurve":
                                this.add(l.fromJSON(i));
                                break;
                            case "SplineCurve":
                                this.add(c.fromJSON(i));
                                break;
                            case "CubicBezierCurve":
                                this.add(u.fromJSON(i));
                                break;
                            case "QuadraticBezierCurve":
                                this.add(a.fromJSON(i));
                        }
                    }
                    return this;
                },
                getBounds: function(t, e) {
                    void 0 === t && (t = new h), void 0 === e && (e = 16), t.x = Number.MAX_VALUE, t.y = Number.MAX_VALUE;
                    for(var i = new h, n = f.MIN_SAFE_INTEGER, s = f.MIN_SAFE_INTEGER, r = 0; r < this.curves.length; r++){
                        var o = this.curves[r];
                        o.active && (o.getBounds(i, e), t.x = Math.min(t.x, i.x), t.y = Math.min(t.y, i.y), n = Math.max(n, i.right), s = Math.max(s, i.bottom));
                    }
                    return t.right = n, t.bottom = s, t;
                },
                getCurveLengths: function() {
                    if (this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                    for(var t = [], e = 0, i = 0; i < this.curves.length; i++)e += this.curves[i].getLength(), t.push(e);
                    return this.cacheLengths = t;
                },
                getEndPoint: function(t) {
                    return void 0 === t && (t = new d), 0 < this.curves.length ? this.curves[this.curves.length - 1].getPoint(1, t) : t.copy(this.startPoint), t;
                },
                getLength: function() {
                    var t = this.getCurveLengths();
                    return t[t.length - 1];
                },
                getPoint: function(t, e) {
                    void 0 === e && (e = new d);
                    for(var i = t * this.getLength(), n = this.getCurveLengths(), s = 0; s < n.length;){
                        if (n[s] >= i) {
                            var r = n[s] - i, o = this.curves[s], a = o.getLength(), h = 0 === a ? 0 : 1 - r / a;
                            return o.getPointAt(h, e);
                        }
                        s++;
                    }
                    return null;
                },
                getPoints: function(t) {
                    void 0 === t && (t = 12);
                    for(var e, i = [], n = 0; n < this.curves.length; n++){
                        var s = this.curves[n];
                        if (s.active) for(var r = s.getResolution(t), o = s.getPoints(r), a = 0; a < o.length; a++){
                            var h = o[a];
                            e && e.equals(h) || (i.push(h), e = h);
                        }
                    }
                    return this.autoClose && 1 < i.length && !i[i.length - 1].equals(i[0]) && i.push(i[0]), i;
                },
                getRandomPoint: function(t) {
                    return void 0 === t && (t = new d), this.getPoint(Math.random(), t);
                },
                getSpacedPoints: function(t) {
                    void 0 === t && (t = 40);
                    for(var e = [], i = 0; i <= t; i++)e.push(this.getPoint(i / t));
                    return this.autoClose && e.push(e[0]), e;
                },
                getStartPoint: function(t) {
                    return void 0 === t && (t = new d), t.copy(this.startPoint);
                },
                getTangent: function(t, e) {
                    void 0 === e && (e = new d);
                    for(var i = t * this.getLength(), n = this.getCurveLengths(), s = 0; s < n.length;){
                        if (n[s] >= i) {
                            var r = n[s] - i, o = this.curves[s], a = o.getLength(), h = 0 === a ? 0 : 1 - r / a;
                            return o.getTangentAt(h, e);
                        }
                        s++;
                    }
                    return null;
                },
                lineTo: function(t, e) {
                    t instanceof d ? this._tmpVec2B.copy(t) : this._tmpVec2B.set(t, e);
                    var i = this.getEndPoint(this._tmpVec2A);
                    return this.add(new r([
                        i.x,
                        i.y,
                        this._tmpVec2B.x,
                        this._tmpVec2B.y
                    ]));
                },
                splineTo: function(t) {
                    return t.unshift(this.getEndPoint()), this.add(new c(t));
                },
                moveTo: function(t, e) {
                    return t instanceof d ? this.add(new o(t.x, t.y)) : this.add(new o(t, e));
                },
                toJSON: function() {
                    for(var t = [], e = 0; e < this.curves.length; e++)t.push(this.curves[e].toJSON());
                    return {
                        type: "Path",
                        x: this.startPoint.x,
                        y: this.startPoint.y,
                        autoClose: this.autoClose,
                        curves: t
                    };
                },
                updateArcLengths: function() {
                    this.cacheLengths = [], this.getCurveLengths();
                },
                destroy: function() {
                    this.curves.length = 0, this.cacheLengths.length = 0, this.startPoint = void 0;
                }
            });
            s.register("path", function(t, e) {
                return new p(t, e);
            }), t.exports = p;
        },
        function(t, e, i) {
            t.exports = {
                DataManager: i(98),
                DataManagerPlugin: i(893),
                Events: i(309)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(98), r = i(24), o = i(21), a = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this, t, t.sys.events), this.scene = t, this.systems = t.sys, t.sys.events.once(o.BOOT, this.boot, this), t.sys.events.on(o.START, this.start, this);
                },
                boot: function() {
                    this.events = this.systems.events, this.events.once(o.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.events.once(o.SHUTDOWN, this.shutdown, this);
                },
                shutdown: function() {
                    this.systems.events.off(o.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    s.prototype.destroy.call(this), this.events.off(o.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            r.register("DataManagerPlugin", a, "data"), t.exports = a;
        },
        function(t, e, i) {
            t.exports = {
                Align: i(895),
                BaseShader: i(390),
                Bounds: i(898),
                Canvas: i(902),
                Color: i(391),
                ColorMatrix: i(195),
                Masks: i(912),
                RGB: i(197)
            };
        },
        function(t, e, i) {
            var n = i(122), s = i(17)(!1, s = {
                In: i(896),
                To: i(897)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            t.exports = {
                BottomCenter: i(284),
                BottomLeft: i(285),
                BottomRight: i(286),
                Center: i(287),
                LeftCenter: i(289),
                QuickSet: i(283),
                RightCenter: i(290),
                TopCenter: i(291),
                TopLeft: i(292),
                TopRight: i(293)
            };
        },
        function(t, e, i) {
            t.exports = {
                BottomCenter: i(271),
                BottomLeft: i(272),
                BottomRight: i(273),
                LeftBottom: i(274),
                LeftCenter: i(275),
                LeftTop: i(276),
                QuickSet: i(270),
                RightBottom: i(277),
                RightCenter: i(278),
                RightTop: i(279),
                TopCenter: i(280),
                TopLeft: i(281),
                TopRight: i(282)
            };
        },
        function(t, e, i) {
            t.exports = {
                CenterOn: i(288),
                GetBottom: i(40),
                GetBounds: i(899),
                GetCenterX: i(84),
                GetCenterY: i(86),
                GetLeft: i(41),
                GetOffsetX: i(900),
                GetOffsetY: i(901),
                GetRight: i(42),
                GetTop: i(43),
                SetBottom: i(54),
                SetCenterX: i(85),
                SetCenterY: i(87),
                SetLeft: i(52),
                SetRight: i(53),
                SetTop: i(51)
            };
        },
        function(t, e, i) {
            var s = i(40), r = i(41), o = i(42), a = i(43);
            t.exports = function(t, e) {
                void 0 === e && (e = {});
                var i = r(t), n = a(t);
                return e.x = i, e.y = n, e.width = o(t) - i, e.height = s(t) - n, e;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.width * t.originX;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.height * t.originY;
            };
        },
        function(t, e, i) {
            t.exports = {
                CanvasInterpolation: i(361),
                CanvasPool: i(31),
                Smoothing: i(189),
                TouchAction: i(903),
                UserSelect: i(904)
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return void 0 === e && (e = "none"), t.style.msTouchAction = e, t.style["ms-touch-action"] = e, t.style["touch-action"] = e, t;
            };
        },
        function(t, e) {
            t.exports = function(e, i) {
                void 0 === i && (i = "none");
                return [
                    "-webkit-",
                    "-khtml-",
                    "-moz-",
                    "-ms-",
                    ""
                ].forEach(function(t) {
                    e.style[t + "user-select"] = i;
                }), e.style["-webkit-touch-callout"] = i, e.style["-webkit-tap-highlight-color"] = "rgba(0, 0, 0, 0)", e;
            };
        },
        function(t, e, i) {
            var l = i(100);
            t.exports = function(t) {
                void 0 === t && (t = 1024);
                var e = [], i = 255, n = 0, s = 0;
                for(h = 0; h <= 255; h++)e.push({
                    r: i,
                    g: h,
                    b: s,
                    color: l(i, h, s)
                });
                for(h = n = 255; 0 <= h; h--)e.push({
                    r: h,
                    g: n,
                    b: s,
                    color: l(h, n, s)
                });
                for(h = i = 0; h <= 255; h++, n--)e.push({
                    r: i,
                    g: n,
                    b: h,
                    color: l(i, n, h)
                });
                for(s = 255, h = n = 0; h <= 255; h++, s--, i++)e.push({
                    r: i,
                    g: n,
                    b: s,
                    color: l(i, n, s)
                });
                if (1024 === t) return e;
                for(var r = [], o = 0, a = 1024 / t, h = 0; h < t; h++)r.push(e[Math.floor(o)]), o += a;
                return r;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                var e = {
                    r: t >> 16 & 255,
                    g: t >> 8 & 255,
                    b: 255 & t,
                    a: 255
                };
                return 16777215 < t && (e.a = t >>> 24), e;
            };
        },
        function(t, e, i) {
            var h = i(37), l = i(393);
            t.exports = function(t, e, i) {
                var n, s, r = i, o = i, a = i;
                return 0 !== e && (r = l(s = 2 * i - (n = i < .5 ? i * (1 + e) : i + e - i * e), n, t + 1 / 3), o = l(s, n, t), a = l(s, n, t - 1 / 3)), (new h).setGLTo(r, o, a, 1);
            };
        },
        function(t, e, i) {
            var s = i(185);
            t.exports = function(t, e) {
                void 0 === t && (t = 1), void 0 === e && (e = 1);
                for(var i = [], n = 0; n <= 359; n++)i.push(s(n / 359, t, e));
                return i;
            };
        },
        function(t, e, i) {
            function o(t, e, i, n, s, r, o, a) {
                void 0 === o && (o = 100), void 0 === a && (a = 0);
                var h = a / o;
                return {
                    r: l(t, n, h),
                    g: l(e, s, h),
                    b: l(i, r, h)
                };
            }
            var l = i(133);
            t.exports = {
                RGBWithRGB: o,
                ColorWithRGB: function(t, e, i, n, s, r) {
                    return void 0 === s && (s = 100), void 0 === r && (r = 0), o(t.r, t.g, t.b, e, i, n, s, r);
                },
                ColorWithColor: function(t, e, i, n) {
                    return void 0 === i && (i = 100), void 0 === n && (n = 0), o(t.r, t.g, t.b, e.r, e.g, e.b, i, n);
                }
            };
        },
        function(t, e, i) {
            var n = i(192), s = i(37);
            t.exports = function(t, e) {
                return void 0 === t && (t = 0), void 0 === e && (e = 255), new s(n(t, e), n(t, e), n(t, e));
            };
        },
        function(t, e, i) {
            var r = i(392);
            t.exports = function(t, e, i, n, s) {
                return void 0 === n && (n = 255), void 0 === s && (s = "#"), "#" === s ? "#" + (16777216 + (t << 16) + (e << 8) + i).toString(16).slice(1) : "0x" + r(n) + r(t) + r(e) + r(i);
            };
        },
        function(t, e, i) {
            t.exports = {
                BitmapMask: i(304),
                GeometryMask: i(305)
            };
        },
        function(t, e, i) {
            var n = {
                AddToDOM: i(140),
                DOMContentLoaded: i(394),
                GetInnerHeight: i(395),
                GetScreenOrientation: i(396),
                GetTarget: i(401),
                ParseXML: i(402),
                RemoveFromDOM: i(199),
                RequestAnimationFrame: i(380)
            };
            t.exports = n;
        },
        function(t, e, i) {
            t.exports = {
                EventEmitter: i(915)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(9), r = i(24), o = new n({
                Extends: s,
                initialize: function() {
                    s.call(this);
                },
                shutdown: function() {
                    this.removeAllListeners();
                },
                destroy: function() {
                    this.removeAllListeners();
                }
            });
            r.register("EventEmitter", o, "events"), t.exports = o;
        },
        function(t, e, i) {
            var n = i(140), s = i(315), r = i(319), o = i(31), a = i(0), h = i(340), l = i(917), u = i(360), c = i(98), d = i(378), f = i(341), p = i(394), g = i(9), v = i(22), m = i(403), y = i(24), x = i(408), T = i(409), w = i(411), b = i(103), E = i(416), S = i(379), A = i(381), _ = i(420), C = new a({
                initialize: function(t) {
                    this.config = new h(t), this.renderer = null, this.domContainer = null, this.canvas = null, this.context = null, this.isBooted = !1, this.isRunning = !1, this.events = new g, this.anims = new s(this), this.textures = new E(this), this.cache = new r(this), this.registry = new c(this), this.input = new m(this, this.config), this.scene = new w(this, this.config.sceneConfig), this.device = f, this.scale = new T(this, this.config), this.sound = null, this.sound = _.create(this), this.loop = new S(this, this.config.fps), this.plugins = new x(this, this.config), this.pendingDestroy = !1, this.removeCanvas = !1, this.noReturn = !1, this.hasFocus = !1, p(this.boot.bind(this));
                },
                boot: function() {
                    y.hasCore("EventEmitter") ? (this.isBooted = !0, this.config.preBoot(this), this.scale.preBoot(), u(this), l(this), d(this), n(this.canvas, this.config.parent), this.textures.once(b.READY, this.texturesReady, this), this.events.emit(v.BOOT)) : console.warn("Aborting. Core Plugins missing.");
                },
                texturesReady: function() {
                    this.events.emit(v.READY), this.start();
                },
                start: function() {
                    this.isRunning = !0, this.config.postBoot(this), this.renderer ? this.loop.start(this.step.bind(this)) : this.loop.start(this.headlessStep.bind(this)), A(this);
                    var t = this.events;
                    t.on(v.HIDDEN, this.onHidden, this), t.on(v.VISIBLE, this.onVisible, this), t.on(v.BLUR, this.onBlur, this), t.on(v.FOCUS, this.onFocus, this);
                },
                step: function(t, e) {
                    if (this.pendingDestroy) return this.runDestroy();
                    var i = this.events;
                    i.emit(v.PRE_STEP, t, e), i.emit(v.STEP, t, e), this.scene.update(t, e), i.emit(v.POST_STEP, t, e);
                    var n = this.renderer;
                    n.preRender(), i.emit(v.PRE_RENDER, n, t, e), this.scene.render(n), n.postRender(), i.emit(v.POST_RENDER, n, t, e);
                },
                headlessStep: function(t, e) {
                    if (this.pendingDestroy) return this.runDestroy();
                    var i = this.events;
                    i.emit(v.PRE_STEP, t, e), i.emit(v.STEP, t, e), this.scene.update(t, e), i.emit(v.POST_STEP, t, e), i.emit(v.PRE_RENDER), i.emit(v.POST_RENDER);
                },
                onHidden: function() {
                    this.loop.pause(), this.events.emit(v.PAUSE);
                },
                onVisible: function() {
                    this.loop.resume(), this.events.emit(v.RESUME);
                },
                onBlur: function() {
                    this.hasFocus = !1, this.loop.blur();
                },
                onFocus: function() {
                    this.hasFocus = !0, this.loop.focus();
                },
                getFrame: function() {
                    return this.loop.frame;
                },
                getTime: function() {
                    return this.loop.now;
                },
                destroy: function(t, e) {
                    void 0 === e && (e = !1), this.pendingDestroy = !0, this.removeCanvas = t, this.noReturn = e;
                },
                runDestroy: function() {
                    this.scene.destroy(), this.events.emit(v.DESTROY), this.events.removeAllListeners(), this.renderer && this.renderer.destroy(), this.removeCanvas && this.canvas && (o.remove(this.canvas), this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas)), this.domContainer && this.domContainer.parentNode.removeChild(this.domContainer), this.loop.destroy(), this.pendingDestroy = !1;
                }
            });
            t.exports = C;
        },
        function(t, e, i) {
            var n = i(140);
            t.exports = function(t) {
                var e, i = t.config;
                i.parent && i.domCreateContainer && ((e = document.createElement("div")).style.cssText = [
                    "display: block;",
                    "width: " + t.scale.width + "px;",
                    "height: " + t.scale.height + "px;",
                    "padding: 0; margin: 0;",
                    "position: absolute;",
                    "overflow: hidden;",
                    "pointer-events: none;",
                    "transform: scale(1);",
                    "transform-origin: left top;"
                ].join(" "), t.domContainer = e, n(e, i.parent));
            };
        },
        function(t, e) {
            t.exports = "boot";
        },
        function(t, e) {
            t.exports = "destroy";
        },
        function(t, e) {
            t.exports = "dragend";
        },
        function(t, e) {
            t.exports = "dragenter";
        },
        function(t, e) {
            t.exports = "drag";
        },
        function(t, e) {
            t.exports = "dragleave";
        },
        function(t, e) {
            t.exports = "dragover";
        },
        function(t, e) {
            t.exports = "dragstart";
        },
        function(t, e) {
            t.exports = "drop";
        },
        function(t, e) {
            t.exports = "gameout";
        },
        function(t, e) {
            t.exports = "gameover";
        },
        function(t, e) {
            t.exports = "gameobjectdown";
        },
        function(t, e) {
            t.exports = "dragend";
        },
        function(t, e) {
            t.exports = "dragenter";
        },
        function(t, e) {
            t.exports = "drag";
        },
        function(t, e) {
            t.exports = "dragleave";
        },
        function(t, e) {
            t.exports = "dragover";
        },
        function(t, e) {
            t.exports = "dragstart";
        },
        function(t, e) {
            t.exports = "drop";
        },
        function(t, e) {
            t.exports = "gameobjectmove";
        },
        function(t, e) {
            t.exports = "gameobjectout";
        },
        function(t, e) {
            t.exports = "gameobjectover";
        },
        function(t, e) {
            t.exports = "pointerdown";
        },
        function(t, e) {
            t.exports = "pointermove";
        },
        function(t, e) {
            t.exports = "pointerout";
        },
        function(t, e) {
            t.exports = "pointerover";
        },
        function(t, e) {
            t.exports = "pointerup";
        },
        function(t, e) {
            t.exports = "wheel";
        },
        function(t, e) {
            t.exports = "gameobjectup";
        },
        function(t, e) {
            t.exports = "gameobjectwheel";
        },
        function(t, e) {
            t.exports = "boot";
        },
        function(t, e) {
            t.exports = "process";
        },
        function(t, e) {
            t.exports = "update";
        },
        function(t, e) {
            t.exports = "pointerdown";
        },
        function(t, e) {
            t.exports = "pointerdownoutside";
        },
        function(t, e) {
            t.exports = "pointermove";
        },
        function(t, e) {
            t.exports = "pointerout";
        },
        function(t, e) {
            t.exports = "pointerover";
        },
        function(t, e) {
            t.exports = "pointerup";
        },
        function(t, e) {
            t.exports = "pointerupoutside";
        },
        function(t, e) {
            t.exports = "wheel";
        },
        function(t, e) {
            t.exports = "pointerlockchange";
        },
        function(t, e) {
            t.exports = "preupdate";
        },
        function(t, e) {
            t.exports = "shutdown";
        },
        function(t, e) {
            t.exports = "start";
        },
        function(t, e) {
            t.exports = "update";
        },
        function(t, e) {
            t.exports = "addfile";
        },
        function(t, e) {
            t.exports = "complete";
        },
        function(t, e) {
            t.exports = "filecomplete";
        },
        function(t, e) {
            t.exports = "filecomplete-";
        },
        function(t, e) {
            t.exports = "loaderror";
        },
        function(t, e) {
            t.exports = "load";
        },
        function(t, e) {
            t.exports = "fileprogress";
        },
        function(t, e) {
            t.exports = "postprocess";
        },
        function(t, e) {
            t.exports = "progress";
        },
        function(t, e) {
            t.exports = "start";
        },
        function(t, e, i) {
            t.exports = {
                game: "game",
                renderer: "renderer",
                anims: "anims",
                cache: "cache",
                plugins: "plugins",
                registry: "registry",
                scale: "scale",
                sound: "sound",
                textures: "textures",
                events: "events",
                cameras: "cameras",
                add: "add",
                make: "make",
                scenePlugin: "scene",
                displayList: "children",
                lights: "lights",
                data: "data",
                input: "input",
                load: "load",
                time: "time",
                tweens: "tweens",
                arcadePhysics: "physics",
                impactPhysics: "impact",
                matterPhysics: "matter"
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (i.getElementsByTagName("TextureAtlas")) {
                    var n = t.source[e];
                    t.add("__BASE", e, 0, 0, n.width, n.height);
                    for(var s = i.getElementsByTagName("SubTexture"), r = 0; r < s.length; r++){
                        var o, a, h, l, u = s[r].attributes, c = u.name.value, d = parseInt(u.x.value, 10), f = parseInt(u.y.value, 10), p = parseInt(u.width.value, 10), g = parseInt(u.height.value, 10), v = t.add(c, e, d, f, p, g);
                        u.frameX && (o = Math.abs(parseInt(u.frameX.value, 10)), a = Math.abs(parseInt(u.frameY.value, 10)), h = parseInt(u.frameWidth.value, 10), l = parseInt(u.frameHeight.value, 10), v.setTrim(p, g, o, a, h, l));
                    }
                    return t;
                }
                console.warn("Invalid Texture Atlas XML given");
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.source[e];
                return t.add("__BASE", e, 0, 0, i.width, i.height), t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.source[e];
                return t.add("__BASE", e, 0, 0, i.width, i.height), t;
            };
        },
        function(t, e, i) {
            var u = i(77);
            t.exports = function(t, e, i) {
                if (i.frames || i.textures) {
                    var n = t.source[e];
                    t.add("__BASE", e, 0, 0, n.width, n.height);
                    for(var s = Array.isArray(i.textures) ? i.textures[e].frames : i.frames, r = 0; r < s.length; r++){
                        var o = s[r], a = t.add(o.filename, e, o.frame.x, o.frame.y, o.frame.w, o.frame.h);
                        o.trimmed && a.setTrim(o.sourceSize.w, o.sourceSize.h, o.spriteSourceSize.x, o.spriteSourceSize.y, o.spriteSourceSize.w, o.spriteSourceSize.h), o.rotated && (a.rotated = !0, a.updateUVsInverted());
                        var h = o.anchor || o.pivot;
                        h && (a.customPivot = !0, a.pivotX = h.x, a.pivotY = h.y), a.customData = u(o);
                    }
                    for(var l in i)"frames" !== l && (Array.isArray(i[l]) ? t.customData[l] = i[l].slice(0) : t.customData[l] = i[l]);
                    return t;
                }
                console.warn("Invalid Texture Atlas JSON Array");
            };
        },
        function(t, e, i) {
            var u = i(77);
            t.exports = function(t, e, i) {
                if (i.frames) {
                    var n = t.source[e];
                    t.add("__BASE", e, 0, 0, n.width, n.height);
                    var s, r, o, a = i.frames;
                    for(var h in a)a.hasOwnProperty(h) && (s = a[h], r = t.add(h, e, s.frame.x, s.frame.y, s.frame.w, s.frame.h), s.trimmed && r.setTrim(s.sourceSize.w, s.sourceSize.h, s.spriteSourceSize.x, s.spriteSourceSize.y, s.spriteSourceSize.w, s.spriteSourceSize.h), s.rotated && (r.rotated = !0, r.updateUVsInverted()), (o = s.anchor || s.pivot) && (r.customPivot = !0, r.pivotX = o.x, r.pivotY = o.y), r.customData = u(s));
                    for(var l in i)"frames" !== l && (Array.isArray(i[l]) ? t.customData[l] = i[l].slice(0) : t.customData[l] = i[l]);
                    return t;
                }
                console.warn("Invalid Texture Atlas JSON Hash given, missing 'frames' Object");
            };
        },
        function(t, e, i) {
            var b = i(2);
            t.exports = function(t, e, i, n, s, r, o) {
                var a = b(o, "frameWidth", null), h = b(o, "frameHeight", a);
                if (null === a) throw new Error("TextureManager.SpriteSheet: Invalid frameWidth given.");
                var l = t.source[e];
                t.add("__BASE", e, 0, 0, l.width, l.height);
                var u = b(o, "startFrame", 0), c = b(o, "endFrame", -1), d = b(o, "margin", 0), f = b(o, "spacing", 0), p = Math.floor((s - d + f) / (a + f)) * Math.floor((r - d + f) / (h + f));
                0 === p && console.warn("SpriteSheet frame dimensions will result in zero frames for texture:", t.key), (p < u || u < -p) && (u = 0), u < 0 && (u = p + u), -1 !== c && (p = u + (c + 1));
                for(var g = d, v = d, m = 0, y = 0, x = 0; x < p; x++){
                    y = m = 0;
                    var T = g + a, w = v + h;
                    s < T && (m = T - s), r < w && (y = w - r), t.add(x, e, i + g, n + v, a - m, h - y), s < (g += a + f) + a && (g = d, v += h + f);
                }
                return t;
            };
        },
        function(t, e, i) {
            var z = i(2);
            t.exports = function(t, e, i) {
                var n = z(i, "frameWidth", null), s = z(i, "frameHeight", n);
                if (!n) throw new Error("TextureManager.SpriteSheetFromAtlas: Invalid frameWidth given.");
                var r = t.source[0];
                t.add("__BASE", 0, 0, 0, r.width, r.height);
                var o = z(i, "startFrame", 0), a = z(i, "endFrame", -1), h = z(i, "margin", 0), l = z(i, "spacing", 0), u = e.cutX, c = e.cutY, d = e.cutWidth, f = e.cutHeight, p = e.realWidth, g = e.realHeight, v = Math.floor((p - h + l) / (n + l)), m = Math.floor((g - h + l) / (s + l)), y = v * m, x = e.x, T = n - x, w = n - (p - d - x), b = e.y, E = s - b, S = s - (g - f - b);
                (y < o || o < -y) && (o = 0), o < 0 && (o = y + o), -1 !== a && (y = o + (a + 1));
                for(var A = h, _ = h, C = 0, M = e.sourceIndex, R = 0; R < m; R++){
                    for(var P = 0 === R, O = R === m - 1, L = 0; L < v; L++){
                        var D, F, k, I, B, N, Y = 0 === L, U = L === v - 1, X = t.add(C, M, u + A, c + _, n, s);
                        (Y || P || U || O) && (D = Y ? x : 0, F = P ? b : 0, I = k = 0, Y && (k += n - T), U && (k += n - w), P && (I += s - E), O && (I += s - S), B = n - k, N = s - I, X.cutWidth = B, X.cutHeight = N, X.setTrim(n, s, D, F, B, N)), A += l, A += Y ? T : U ? w : n, C++;
                    }
                    A = h, _ += l, _ += P ? E : O ? S : s;
                }
                return t;
            };
        },
        function(t, e) {
            function p(t, e, i, n) {
                var s = g - n.y - n.height;
                t.add(i, e, n.x, s, n.width, n.height);
            }
            var g = 0;
            t.exports = function(t, e, i) {
                var n = t.source[e];
                t.add("__BASE", e, 0, 0, n.width, n.height), g = n.height;
                for(var s = i.split("\n"), r = /^[ ]*(- )*(\w+)+[: ]+(.*)/, o = "", a = "", h = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }, l = 0; l < s.length; l++){
                    var u = s[l].match(r);
                    if (u) {
                        var c = "- " === u[1], d = u[2], f = u[3];
                        if (c && (a !== o && (p(t, e, a, h), o = a), h = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        }), "name" !== d) switch(d){
                            case "x":
                            case "y":
                            case "width":
                            case "height":
                                h[d] = parseInt(f, 10);
                        }
                        else a = f;
                    }
                }
                return a !== o && p(t, e, a, h), t;
            };
        },
        function(t, e) {
            t.exports = "complete";
        },
        function(t, e) {
            t.exports = "decoded";
        },
        function(t, e) {
            t.exports = "decodedall";
        },
        function(t, e) {
            t.exports = "destroy";
        },
        function(t, e) {
            t.exports = "detune";
        },
        function(t, e) {
            t.exports = "detune";
        },
        function(t, e) {
            t.exports = "mute";
        },
        function(t, e) {
            t.exports = "rate";
        },
        function(t, e) {
            t.exports = "volume";
        },
        function(t, e) {
            t.exports = "loop";
        },
        function(t, e) {
            t.exports = "looped";
        },
        function(t, e) {
            t.exports = "mute";
        },
        function(t, e) {
            t.exports = "pan";
        },
        function(t, e) {
            t.exports = "pauseall";
        },
        function(t, e) {
            t.exports = "pause";
        },
        function(t, e) {
            t.exports = "play";
        },
        function(t, e) {
            t.exports = "rate";
        },
        function(t, e) {
            t.exports = "resumeall";
        },
        function(t, e) {
            t.exports = "resume";
        },
        function(t, e) {
            t.exports = "seek";
        },
        function(t, e) {
            t.exports = "stopall";
        },
        function(t, e) {
            t.exports = "stop";
        },
        function(t, e) {
            t.exports = "unlocked";
        },
        function(t, e) {
            t.exports = "volume";
        },
        function(t, e, i) {
            var n = {
                Events: i(75),
                DisplayList: i(1008),
                GameObjectCreator: i(16),
                GameObjectFactory: i(5),
                UpdateList: i(1034),
                Components: i(11),
                GetCalcMatrix: i(19),
                BuildGameObject: i(28),
                BuildGameObjectAnimation: i(433),
                GameObject: i(15),
                BitmapText: i(147),
                Blitter: i(210),
                Bob: i(434),
                Container: i(211),
                DOMElement: i(436),
                DynamicBitmapText: i(212),
                Extern: i(438),
                Graphics: i(213),
                Group: i(110),
                Image: i(124),
                Layer: i(216),
                Particles: i(1068),
                PathFollower: i(451),
                RenderTexture: i(218),
                RetroFont: i(1076),
                Rope: i(220),
                Sprite: i(73),
                Text: i(221),
                GetTextSize: i(452),
                MeasureText: i(454),
                TextStyle: i(453),
                TileSprite: i(222),
                Zone: i(127),
                Video: i(223),
                Shape: i(33),
                Arc: i(455),
                Curve: i(456),
                Ellipse: i(457),
                Grid: i(458),
                IsoBox: i(459),
                IsoTriangle: i(460),
                Line: i(461),
                Polygon: i(462),
                Rectangle: i(467),
                Star: i(468),
                Triangle: i(469),
                Factories: {
                    Blitter: i(1124),
                    Container: i(1125),
                    DOMElement: i(1126),
                    DynamicBitmapText: i(1127),
                    Extern: i(1128),
                    Graphics: i(1129),
                    Group: i(1130),
                    Image: i(1131),
                    Layer: i(1132),
                    Particles: i(1133),
                    PathFollower: i(1134),
                    RenderTexture: i(1135),
                    Rope: i(1136),
                    Sprite: i(1137),
                    StaticBitmapText: i(1138),
                    Text: i(1139),
                    TileSprite: i(1140),
                    Zone: i(1141),
                    Video: i(1142),
                    Arc: i(1143),
                    Curve: i(1144),
                    Ellipse: i(1145),
                    Grid: i(1146),
                    IsoBox: i(1147),
                    IsoTriangle: i(1148),
                    Line: i(1149),
                    Polygon: i(1150),
                    Rectangle: i(1151),
                    Star: i(1152),
                    Triangle: i(1153)
                },
                Creators: {
                    Blitter: i(1154),
                    Container: i(1155),
                    DynamicBitmapText: i(1156),
                    Graphics: i(1157),
                    Group: i(1158),
                    Image: i(1159),
                    Layer: i(1160),
                    Particles: i(1161),
                    RenderTexture: i(1162),
                    Rope: i(1163),
                    Sprite: i(1164),
                    StaticBitmapText: i(1165),
                    Text: i(1166),
                    TileSprite: i(1167),
                    Zone: i(1168),
                    Video: i(1169)
                }
            };
            n.Shader = i(226), n.Mesh = i(227), n.PointLight = i(149), n.Factories.Shader = i(1178), n.Factories.Mesh = i(1179), n.Factories.PointLight = i(1180), n.Creators.Shader = i(1181), n.Creators.Mesh = i(1182), n.Creators.PointLight = i(1183), n.Light = i(475), n.LightsManager = i(476), n.LightsPlugin = i(1184), t.exports = n;
        },
        function(t, e, i) {
            var n = i(0), s = i(107), r = i(24), o = i(75), a = i(21), h = i(79), l = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this, t), this.sortChildrenFlag = !1, this.scene = t, this.systems = t.sys, this.events = t.sys.events, this.addCallback = this.addChildCallback, this.removeCallback = this.removeChildCallback, this.events.once(a.BOOT, this.boot, this), this.events.on(a.START, this.start, this);
                },
                boot: function() {
                    this.events.once(a.DESTROY, this.destroy, this);
                },
                addChildCallback: function(t) {
                    t.emit(o.ADDED_TO_SCENE, t, this.scene), t.displayList && t.displayList.remove(t), (t.displayList = this).queueDepthSort(), this.events.emit(a.ADDED_TO_SCENE, t, this.scene);
                },
                removeChildCallback: function(t) {
                    t.emit(o.REMOVED_FROM_SCENE, t, this.scene), t.displayList = null, this.queueDepthSort(), this.events.emit(a.REMOVED_FROM_SCENE, t, this.scene);
                },
                start: function() {
                    this.events.once(a.SHUTDOWN, this.shutdown, this);
                },
                queueDepthSort: function() {
                    this.sortChildrenFlag = !0;
                },
                depthSort: function() {
                    this.sortChildrenFlag && (h(this.list, this.sortByDepth), this.sortChildrenFlag = !1);
                },
                sortByDepth: function(t, e) {
                    return t._depth - e._depth;
                },
                getChildren: function() {
                    return this.list;
                },
                shutdown: function() {
                    for(var t = this.list, e = t.length; e--;)t[e].destroy(!0);
                    t.length = 0, this.events.off(a.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.events.off(a.START, this.start, this), this.scene = null, this.systems = null, this.events = null;
                }
            });
            r.register("DisplayList", l, "displayList"), t.exports = l;
        },
        function(t, e, i) {
            t.exports = {
                CheckMatrix: i(206),
                MatrixToString: i(1010),
                ReverseColumns: i(1011),
                ReverseRows: i(1012),
                Rotate180: i(1013),
                RotateLeft: i(1014),
                RotateMatrix: i(146),
                RotateRight: i(1015),
                Translate: i(1016),
                TransposeMatrix: i(429)
            };
        },
        function(t, e, i) {
            var o = i(183), a = i(206);
            t.exports = function(t) {
                var e = "";
                if (!a(t)) return e;
                for(var i = 0; i < t.length; i++){
                    for(var n = 0; n < t[i].length; n++){
                        var s = t[i][n].toString();
                        e += "undefined" !== s ? o(s, 2) : "?", n < t[i].length - 1 && (e += " |");
                    }
                    if (i < t.length - 1) {
                        e += "\n";
                        for(var r = 0; r < t[i].length; r++)e += "---", r < t[i].length - 1 && (e += "+");
                        e += "\n";
                    }
                }
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.reverse();
            };
        },
        function(t, e) {
            t.exports = function(t) {
                for(var e = 0; e < t.length; e++)t[e].reverse();
                return t;
            };
        },
        function(t, e, i) {
            var n = i(146);
            t.exports = function(t) {
                return n(t, 180);
            };
        },
        function(t, e, i) {
            var n = i(146);
            t.exports = function(t) {
                return n(t, 90);
            };
        },
        function(t, e, i) {
            var n = i(146);
            t.exports = function(t) {
                return n(t, -90);
            };
        },
        function(t, e, i) {
            var r = i(175), o = i(176);
            t.exports = function(t, e, i) {
                if (void 0 === e && (e = 0), void 0 === i && (i = 0), 0 !== i && (i < 0 ? r(t, Math.abs(i)) : o(t, i)), 0 !== e) for(var n = 0; n < t.length; n++){
                    var s = t[n];
                    e < 0 ? r(s, Math.abs(e)) : o(s, e);
                }
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                if (void 0 === s && (s = t), 0 < i) {
                    var r = i - t.length;
                    if (r <= 0) return null;
                }
                if (!Array.isArray(e)) return -1 === t.indexOf(e) ? (t.push(e), n && n.call(s, e), e) : null;
                for(var o = e.length - 1; 0 <= o;)-1 !== t.indexOf(e[o]) && e.splice(o, 1), o--;
                if (0 === (o = e.length)) return null;
                0 < i && r < o && (e.splice(r), o = r);
                for(var a = 0; a < o; a++){
                    var h = e[a];
                    t.push(h), n && n.call(s, h);
                }
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r) {
                if (void 0 === i && (i = 0), void 0 === r && (r = t), 0 < n) {
                    var o = n - t.length;
                    if (o <= 0) return null;
                }
                if (!Array.isArray(e)) return -1 === t.indexOf(e) ? (t.splice(i, 0, e), s && s.call(r, e), e) : null;
                for(var a = e.length - 1; 0 <= a;)-1 !== t.indexOf(e[a]) && e.pop(), a--;
                if (0 === (a = e.length)) return null;
                0 < n && o < a && (e.splice(o), a = o);
                for(var h = a - 1; 0 <= h; h--){
                    var l = e[h];
                    t.splice(i, 0, l), s && s.call(r, l);
                }
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.indexOf(e);
                return -1 !== i && i < t.length && (t.splice(i, 1), t.push(e)), e;
            };
        },
        function(t, e, i) {
            var a = i(78);
            t.exports = function(t, e, i, n, s) {
                void 0 === n && (n = 0), void 0 === s && (s = t.length);
                var r = 0;
                if (a(t, n, s)) for(var o = n; o < s; o++)t[o][e] === i && r++;
                return r;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                for(var n = [
                    null
                ], s = 3; s < arguments.length; s++)n.push(arguments[s]);
                for(s = 0; s < t.length; s++)n[0] = t[s], e.apply(i, n);
                return t;
            };
        },
        function(t, e, i) {
            var a = i(78);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === n && (n = 0), void 0 === s && (s = t.length), a(t, n, s)) {
                    for(var r = [
                        null
                    ], o = 5; o < arguments.length; o++)r.push(arguments[o]);
                    for(o = n; o < s; o++)r[0] = t[o], e.apply(i, r);
                }
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i, n, s = t.indexOf(e);
                return 0 < s && (i = t[s - 1], n = t.indexOf(i), t[s] = i, t[n] = e), t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = t.indexOf(e);
                if (-1 === n || i < 0 || i >= t.length) throw new Error("Supplied index out of bounds");
                return n !== i && (t.splice(n, 1), t.splice(i, 0, e)), e;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i, n, s = t.indexOf(e);
                return -1 !== s && s < t.length - 1 && (i = t[s + 1], n = t.indexOf(i), t[s] = i, t[n] = e), t;
            };
        },
        function(t, e, i) {
            var o = i(357);
            t.exports = function(t, e, i) {
                void 0 === t && (t = 0), void 0 === e && (e = null), void 0 === i && (i = 1), null === e && (e = t, t = 0);
                for(var n = [], s = Math.max(o((e - t) / (i || 1)), 0), r = 0; r < s; r++)n.push(t), t += i;
                return n;
            };
        },
        function(t, e, i) {
            var r = i(74);
            t.exports = function(t, e, i, n) {
                if (void 0 === n && (n = t), e < 0 || e > t.length - 1) throw new Error("Index out of bounds");
                var s = r(t, e);
                return i && i.call(n, s), s;
            };
        },
        function(t, e, i) {
            var l = i(78);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === e && (e = 0), void 0 === i && (i = t.length), void 0 === s && (s = t), l(t, e, i)) {
                    var r = i - e, o = t.splice(e, r);
                    if (n) for(var a = 0; a < o.length; a++){
                        var h = o[a];
                        n.call(s, h);
                    }
                    return o;
                }
                return [];
            };
        },
        function(t, e, i) {
            var s = i(74);
            t.exports = function(t, e, i) {
                void 0 === e && (e = 0), void 0 === i && (i = t.length);
                var n = e + Math.floor(Math.random() * i);
                return s(t, n);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = t.indexOf(e), s = t.indexOf(i);
                return -1 !== n && -1 === s && (t[n] = i, !0);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.indexOf(e);
                return -1 !== i && 0 < i && (t.splice(i, 1), t.unshift(e)), e;
            };
        },
        function(t, e, i) {
            var a = i(78);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === n && (n = 0), void 0 === s && (s = t.length), a(t, n, s)) for(var r = n; r < s; r++){
                    var o = t[r];
                    o.hasOwnProperty(e) && (o[e] = i);
                }
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                if (e !== i) {
                    var n = t.indexOf(e), s = t.indexOf(i);
                    if (n < 0 || s < 0) throw new Error("Supplied items must be elements of the same array");
                    return t[n] = i, t[s] = e, t;
                }
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(208), r = i(24), o = i(21), a = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.checkQueue = !0, this.scene = t, this.systems = t.sys, t.sys.events.once(o.BOOT, this.boot, this), t.sys.events.on(o.START, this.start, this);
                },
                boot: function() {
                    this.systems.events.once(o.DESTROY, this.destroy, this);
                },
                start: function() {
                    var t = this.systems.events;
                    t.on(o.PRE_UPDATE, this.update, this), t.on(o.UPDATE, this.sceneUpdate, this), t.once(o.SHUTDOWN, this.shutdown, this);
                },
                sceneUpdate: function(t, e) {
                    for(var i = this._active, n = i.length, s = 0; s < n; s++){
                        var r = i[s];
                        r.active && r.preUpdate.call(r, t, e);
                    }
                },
                shutdown: function() {
                    for(var t = this._active.length; t--;)this._active[t].destroy(!0);
                    for(t = this._pending.length; t--;)this._pending[t].destroy(!0);
                    for(t = this._destroy.length; t--;)this._destroy[t].destroy(!0);
                    this._toProcess = 0, this._pending = [], this._active = [], this._destroy = [], this.removeAllListeners();
                    var e = this.systems.events;
                    e.off(o.PRE_UPDATE, this.preUpdate, this), e.off(o.UPDATE, this.sceneUpdate, this), e.off(o.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.systems.events.off(o.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            r.register("UpdateList", a, "updateList"), t.exports = a;
        },
        function(t, e) {
            t.exports = "add";
        },
        function(t, e) {
            t.exports = "remove";
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                if (void 0 === i && (i = !1), void 0 === n) return n = {
                    local: {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    },
                    global: {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    },
                    lines: {
                        shortest: 0,
                        longest: 0,
                        lengths: null,
                        height: 0
                    },
                    wrappedText: "",
                    words: [],
                    characters: [],
                    scaleX: 0,
                    scaleY: 0
                };
                var s, r, o, a, h = t.text, l = h.length, u = t.maxWidth, c = t.wordWrapCharCode, d = Number.MAX_VALUE, f = Number.MAX_VALUE, p = 0, g = 0, v = t.fontData.chars, m = t.fontData.lineHeight, y = t.letterSpacing, x = 0, T = 0, w = 0, b = null, E = t._align, S = 0, A = t.fontSize / t.fontData.size, _ = A * t.scaleX, C = A * t.scaleY, M = null, R = 0, P = [], O = Number.MAX_VALUE, L = 0, D = 0, F = 0, k = [], I = [], B = null;
                if (0 < u) {
                    for(U = 0; U < l; U++)10 !== (w = h.charCodeAt(U)) ? (b = v[w]) && (null !== M && (s = b.kerning[R]), w === c ? null !== B && (k.push({
                        word: B.word,
                        i: B.i,
                        x: B.x * _,
                        y: B.y * C,
                        w: B.w * _,
                        h: B.h * C,
                        cr: !1
                    }), B = null) : (null === B && (B = {
                        word: "",
                        i: U,
                        x: x,
                        y: T,
                        w: 0,
                        h: m,
                        cr: !1
                    }), B.word = B.word.concat(h[U]), B.w += b.xOffset + b.xAdvance + (void 0 !== s ? s : 0)), x += b.xAdvance + y, M = b, R = w) : (null !== B && (k.push({
                        word: B.word,
                        i: B.i,
                        x: B.x * _,
                        y: B.y * C,
                        w: B.w * _,
                        h: B.h * C,
                        cr: !0
                    }), B = null), x = 0, T += m, M = null);
                    null !== B && k.push({
                        word: B.word,
                        i: B.i,
                        x: B.x * _,
                        y: B.y * C,
                        w: B.w * _,
                        h: B.h * C,
                        cr: !1
                    }), M = null;
                    for(var N = R = T = x = 0, Y = [], U = 0; U < k.length; U++){
                        var X, z = k[U], G = z.x, W = z.x + z.w;
                        X && (N = G - (G - (X.x + X.w) + X.w), X = null), u < G - N || u < W - N ? (Y.push(z.i - 1), X = z.cr ? (Y.push(z.i + z.word.length), N = 0, null) : z) : z.cr && (Y.push(z.i + z.word.length), N = 0, X = null);
                    }
                    for(U = Y.length - 1; 0 <= U; U--)r = h, o = Y[U], a = "\n", h = r.substr(0, o) + a + r.substr(o + 1);
                    l = (n.wrappedText = h).length, k = [], B = null;
                }
                var V, H, j, q, K = 0;
                for(U = 0; U < l; U++)10 !== (w = h.charCodeAt(U)) ? (b = v[w]) && (S = x, null !== M && (S += void 0 !== (V = b.kerning[R]) ? V : 0), S < d && (d = S), T < f && (f = T), p < (H = S + b.xAdvance) && (p = H), g < (j = T + m) && (g = j), q = b.xOffset + b.xAdvance + (void 0 !== V ? V : 0), w === c ? null !== B && (k.push({
                    word: B.word,
                    i: B.i,
                    x: B.x * _,
                    y: B.y * C,
                    w: B.w * _,
                    h: B.h * C
                }), B = null) : (null === B && (B = {
                    word: "",
                    i: K,
                    x: x,
                    y: T,
                    w: 0,
                    h: m
                }), B.word = B.word.concat(h[U]), B.w += q), I.push({
                    i: K,
                    char: h[U],
                    code: w,
                    x: (b.xOffset + x) * A,
                    y: (b.yOffset + T) * A,
                    w: b.width * A,
                    h: b.height * A,
                    t: T * A,
                    r: H * A,
                    b: m * A,
                    line: D,
                    glyph: b
                }), x += b.xAdvance + y, M = b, R = w, F = H * A, K++) : (null !== B && (k.push({
                    word: B.word,
                    i: B.i,
                    x: B.x * _,
                    y: B.y * C,
                    w: B.w * _,
                    h: B.h * C
                }), B = null), x = 0, T += m, M = null, L < (P[D] = F) && (L = F), F < O && (O = F), D++, F = 0);
                if (null !== B && k.push({
                    word: B.word,
                    i: B.i,
                    x: B.x * _,
                    y: B.y * C,
                    w: B.w * _,
                    h: B.h * C
                }), L < (P[D] = F) && (L = F), F < O && (O = F), 0 < E) for(var Z = 0; Z < I.length; Z++){
                    var J, Q, $ = I[Z];
                    1 === E ? (J = (L - P[$.line]) / 2, $.x += J, $.r += J) : 2 === E && (Q = L - P[$.line], $.x += Q, $.r += Q);
                }
                var tt = n.local, et = n.global, it = n.lines;
                return tt.x = d * A, tt.y = f * A, tt.width = p * A, tt.height = g * A, et.x = t.x - t._displayOriginX + d * _, et.y = t.y - t._displayOriginY + f * C, et.width = p * _, et.height = g * C, it.shortest = O, it.longest = L, it.lengths = P, e && (tt.x = Math.ceil(tt.x), tt.y = Math.ceil(tt.y), tt.width = Math.ceil(tt.width), tt.height = Math.ceil(tt.height), et.x = Math.ceil(et.x), et.y = Math.ceil(et.y), et.width = Math.ceil(et.width), et.height = Math.ceil(et.height), it.shortest = Math.ceil(O), it.longest = Math.ceil(L)), i && (t._displayOriginX = t.originX * tt.width, t._displayOriginY = t.originY * tt.height, et.x = t.x - t._displayOriginX * t.scaleX, et.y = t.y - t._displayOriginY * t.scaleY, e && (et.x = Math.ceil(et.x), et.y = Math.ceil(et.y))), n.words = k, n.characters = I, n.lines.height = m, n.scale = A, n.scaleX = t.scaleX, n.scaleY = t.scaleY, n;
            };
        },
        function(t, e, i) {
            var c = i(209);
            t.exports = function(t, e, i, n, s, r, o) {
                var a = t.sys.textures.get(i), h = a.get(n), l = t.sys.cache.xml.get(s);
                if (h && l) {
                    var u = c(l, h, r, o, a);
                    return t.sys.cache.bitmapFont.add(e, {
                        data: u,
                        texture: i,
                        frame: n
                    }), !0;
                }
                return !1;
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1040), s = i(1042);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var I = i(1041), B = i(19), N = i(12);
            t.exports = function(t, e, i, n) {
                if (0 !== e._text.length) {
                    i.addToRenderList(e);
                    var s, r = t.pipelines.set(e.pipeline, e), o = B(e, i, n).calc, a = i.roundPixels, h = i.alpha, l = e.charColors, u = e.tintFill, c = N.getTintAppendFloatAlpha, d = c(e.tintTopLeft, h * e._alphaTL), f = c(e.tintTopRight, h * e._alphaTR), p = c(e.tintBottomLeft, h * e._alphaBL), g = c(e.tintBottomRight, h * e._alphaBR), v = e.frame.glTexture, m = r.setGameObject(e), y = e.getTextBounds(!1).characters, x = e.dropShadowX, T = e.dropShadowY, w = 0 !== x || 0 !== T;
                    if (t.pipelines.preBatch(e), w) for(var b = e.dropShadowColor, E = e.dropShadowAlpha, S = c(b, h * E * e._alphaTL), A = c(b, h * E * e._alphaTR), _ = c(b, h * E * e._alphaBL), C = c(b, h * E * e._alphaBR), M = 0; M < y.length; M++)k = (s = y[M]).glyph, 32 !== s.code && 0 !== k.width && 0 !== k.height && I(r, e, s, k, x, T, o, a, S, A, _, C, 1, v, m);
                    for(M = 0; M < y.length; M++){
                        var R, P, O, L, D, F, k = (s = y[M]).glyph;
                        32 !== s.code && 0 !== k.width && 0 !== k.height && (l[s.i] ? (P = (R = l[s.i]).tintEffect, O = c(R.tintTL, h * e._alphaTL), L = c(R.tintTR, h * e._alphaTR), D = c(R.tintBL, h * e._alphaBL), F = c(R.tintBR, h * e._alphaBR), I(r, e, s, k, 0, 0, o, a, O, L, D, F, P, v, m)) : I(r, e, s, k, 0, 0, o, a, d, f, p, g, u, v, m));
                    }
                    t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r, o, a, h, l, u, c, d, f, p) {
                var g = i.x - e.displayOriginX + s, v = i.y - e.displayOriginY + r, m = g + i.w, y = v + i.h, x = o.getXRound(g, v, a), T = o.getYRound(g, v, a), w = o.getXRound(g, y, a), b = o.getYRound(g, y, a), E = o.getXRound(m, y, a), S = o.getYRound(m, y, a), A = o.getXRound(m, v, a), _ = o.getYRound(m, v, a);
                t.batchQuad(e, x, T, w, b, E, S, A, _, n.u0, n.v0, n.u1, n.v1, h, l, u, c, d, f, p);
            };
        },
        function(t, e, i) {
            var k = i(30);
            t.exports = function(t, e, i, n) {
                var s = e._text, r = s.length, o = t.currentContext;
                if (0 !== r && k(t, o, e, i, n)) {
                    i.addToRenderList(e);
                    var a, h = e.texture.frames.__BASE, l = e.fontData.chars, u = e.fontData.lineHeight, c = e._letterSpacing, d = 0, f = 0, p = null, g = 0, v = 0, m = 0, y = 0, x = 0, T = 0, w = null, b = 0, E = h.source.image, S = h.cutX, A = h.cutY, _ = e._fontSize / e.fontData.size, C = e._align, M = 0, R = 0, P = e.getTextBounds(!1);
                    0 < e.maxWidth && (r = (s = P.wrappedText).length);
                    var O = e._bounds.lines;
                    1 === C ? R = (O.longest - O.lengths[0]) / 2 : 2 === C && (R = O.longest - O.lengths[0]), o.translate(-e.displayOriginX, -e.displayOriginY);
                    for(var L, D = i.roundPixels, F = 0; F < r; F++)10 !== (a = s.charCodeAt(F)) ? (p = l[a]) && (g = S + p.x, v = A + p.y, m = p.width, y = p.height, x = p.xOffset + d, T = p.yOffset + f, null !== w && (x += void 0 !== (L = p.kerning[b]) ? L : 0), x *= _, T *= _, x += R, d += p.xAdvance + c, w = p, b = a, 0 !== m && 0 !== y && 32 !== a && (D && (x = Math.round(x), T = Math.round(T)), o.save(), o.translate(x, T), o.scale(_, _), o.drawImage(E, g, v, m, y, 0, 0, m, y), o.restore())) : (M++, 1 === C ? R = (O.longest - O.lengths[M]) / 2 : 2 === C && (R = O.longest - O.lengths[M]), d = 0, f += u, w = null);
                    o.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1044), s = i(1045);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var n = i(25), P = i(12), O = new n;
            t.exports = function(t, e, i, n) {
                var s = e.getRenderList();
                if (0 === s.length) return e.clearRenderDepth(i);
                e.setRenderDepth(i);
                var r = t.pipelines.set(this.pipeline, e), o = i.scrollX * e.scrollFactorX, a = i.scrollY * e.scrollFactorY, h = O.copyFrom(i.matrix);
                n && (h.multiplyWithOffset(n, -o, -a), a = o = 0);
                var l = e.x - o, u = e.y - a, c = -1, d = i.alpha * e.alpha, f = i.roundPixels;
                t.pipelines.preBatch(e);
                for(var p = 0; p < s.length; p++){
                    var g, v, m, y, x, T, w, b, E, S, A, _, C = s[p], M = C.frame, R = C.alpha * d;
                    0 != R && (g = M.width, v = M.height, m = l + C.x + M.x, y = u + C.y + M.y, C.flipX && (g *= -1, m += M.width), C.flipY && (v *= -1, y += M.height), x = m + g, T = y + v, w = h.getX(m, y), b = h.getY(m, y), E = h.getX(x, T), S = h.getY(x, T), A = P.getTintAppendFloatAlpha(C.tint, R), M.sourceIndex !== c && (_ = r.setGameObject(e, M), c = M.sourceIndex), f && (w = Math.round(w), b = Math.round(b), E = Math.round(E), S = Math.round(S)), r.batchQuad(e, w, b, w, S, E, S, E, b, M.u0, M.v0, M.u1, M.v1, A, A, A, A, !1, M.glTexture, _) && (c = -1));
                }
                t.pipelines.postBatch(e);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = e.getRenderList();
                if (0 !== s.length) {
                    var r = t.currentContext, o = i.alpha * e.alpha;
                    if (0 != o) {
                        i.addToRenderList(e), r.globalCompositeOperation = t.blendModes[e.blendMode], r.imageSmoothingEnabled = !(!t.antialias || e.frame.source.scaleMode);
                        var a = e.x - i.scrollX * e.scrollFactorX, h = e.y - i.scrollY * e.scrollFactorY;
                        r.save(), n && n.copyToContext(r);
                        for(var l = i.roundPixels, u = 0; u < s.length; u++){
                            var c = s[u], d = c.flipX || c.flipY, f = c.frame, p = f.canvasData, g = f.x, v = f.y, m = 1, y = 1, x = c.alpha * o;
                            0 != x && (r.globalAlpha = x, d ? (c.flipX && (m = -1, g -= p.width), c.flipY && (y = -1, v -= p.height), r.save(), r.translate(c.x + a, c.y + h), r.scale(m, y), r.drawImage(f.source.image, p.x, p.y, p.width, p.height, g, v, p.width, p.height), r.restore()) : (l && (g = Math.round(g), v = Math.round(v)), r.drawImage(f.source.image, p.x, p.y, p.width, p.height, g + c.x + a, v + c.y + h, p.width, p.height)));
                        }
                        r.restore();
                    }
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1047), s = i(1048);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = e.list, r = s.length;
                if (0 !== r) {
                    var o = e.localTransform;
                    n ? (o.loadIdentity(), o.multiply(n), o.translate(e.x, e.y), o.rotate(e.rotation), o.scale(e.scaleX, e.scaleY)) : o.applyITRS(e.x, e.y, e.rotation, e.scaleX, e.scaleY), t.pipelines.preBatch(e);
                    var a = -1 !== e.blendMode;
                    a || t.setBlendMode(0);
                    for(var h = e.alpha, l = e.scrollFactorX, u = e.scrollFactorY, c = 0; c < r; c++){
                        var d, f, p, g, v, m, y, x, T = s[c];
                        T.willRender(i) && (g = void 0 !== T.alphaTopLeft ? (d = T.alphaTopLeft, f = T.alphaTopRight, p = T.alphaBottomLeft, T.alphaBottomRight) : p = f = d = T.alpha, v = T.scrollFactorX, m = T.scrollFactorY, a || T.blendMode === t.currentBlendMode || t.setBlendMode(T.blendMode), (y = T.mask) && y.preRenderWebGL(t, T, i), (x = T.type) !== t.currentType && (t.newType = !0, t.currentType = x), t.nextTypeMatch = c < r - 1 && s[c + 1].type === t.currentType, T.setScrollFactor(v * l, m * u), T.setAlpha(d * h, f * h, p * h, g * h), T.renderWebGL(t, T, i, o), T.setAlpha(d, f, p, g), T.setScrollFactor(v, m), y && y.postRenderWebGL(t, i), t.newType = !1);
                    }
                    t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s = e.list;
                if (0 !== s.length) {
                    var r = e.localTransform;
                    n ? (r.loadIdentity(), r.multiply(n), r.translate(e.x, e.y), r.rotate(e.rotation), r.scale(e.scaleX, e.scaleY)) : r.applyITRS(e.x, e.y, e.rotation, e.scaleX, e.scaleY);
                    var o = -1 !== e.blendMode;
                    o || t.setBlendMode(0);
                    var a = e._alpha, h = e.scrollFactorX, l = e.scrollFactorY;
                    e.mask && e.mask.preRenderCanvas(t, null, i);
                    for(var u = 0; u < s.length; u++){
                        var c, d, f, p = s[u];
                        p.willRender(i) && (c = p.alpha, d = p.scrollFactorX, f = p.scrollFactorY, o || p.blendMode === t.currentBlendMode || t.setBlendMode(p.blendMode), p.setScrollFactor(d * h, f * l), p.setAlpha(c * a), p.renderCanvas(t, p, i, r), p.setAlpha(c), p.setScrollFactor(d, f));
                    }
                    e.mask && e.mask.postRenderCanvas(t);
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(437), s = i(437);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e) {
            t.exports = [
                "normal",
                "multiply",
                "multiply",
                "screen",
                "overlay",
                "darken",
                "lighten",
                "color-dodge",
                "color-burn",
                "hard-light",
                "soft-light",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
            ];
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1052), s = i(1053);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var ot = i(19), n = i(25), at = i(12), ht = new n;
            t.exports = function(t, e, i, n) {
                var s = e.text, r = s.length;
                if (0 !== r) {
                    i.addToRenderList(e);
                    var o = t.pipelines.set(e.pipeline, e), a = ot(e, i, n), h = a.sprite, l = a.calc, u = ht, c = 0 < e.cropWidth || 0 < e.cropHeight;
                    c && (o.flush(), t.pushScissor(l.tx, l.ty, e.cropWidth * l.scaleX, e.cropHeight * l.scaleY));
                    var d, f, p, g, v = e.frame.glTexture, m = e.tintFill, y = at.getTintAppendFloatAlpha(e.tintTopLeft, i.alpha * e._alphaTL), x = at.getTintAppendFloatAlpha(e.tintTopRight, i.alpha * e._alphaTR), T = at.getTintAppendFloatAlpha(e.tintBottomLeft, i.alpha * e._alphaBL), w = at.getTintAppendFloatAlpha(e.tintBottomRight, i.alpha * e._alphaBR), b = o.setGameObject(e), E = 0, S = 0, A = 0, _ = e.letterSpacing, C = e.scrollX, M = e.scrollY, R = e.fontData, P = R.chars, O = R.lineHeight, L = e.fontSize / R.size, D = 0, F = e._align, k = 0, I = 0, B = e.getTextBounds(!1);
                    0 < e.maxWidth && (r = (s = B.wrappedText).length);
                    var N = e._bounds.lines;
                    1 === F ? I = (N.longest - N.lengths[0]) / 2 : 2 === F && (I = N.longest - N.lengths[0]);
                    var Y = i.roundPixels, U = e.displayCallback, X = e.callbackData;
                    t.pipelines.preBatch(e);
                    for(var z, G, W, V, H, j, q, K, Z, J, Q, $, tt, et, it, nt, st, rt = 0; rt < r; rt++)10 !== (d = s.charCodeAt(rt)) ? (st = P[d]) && (f = st.width, p = st.height, W = st.xOffset + E - C, V = st.yOffset + S - M, null !== g && (W += void 0 !== (z = st.kerning[A]) ? z : 0), E += st.xAdvance + _, g = st, A = d, 0 !== f && 0 !== p && 32 !== d && (L = e.fontSize / e.fontData.size, D = 0, U && (X.color = 0, X.tint.topLeft = y, X.tint.topRight = x, X.tint.bottomLeft = T, X.tint.bottomRight = w, X.index = rt, X.charCode = d, X.x = W, X.y = V, X.scale = L, X.rotation = D, X.data = st.data, W = (G = U(X)).x, V = G.y, L = G.scale, D = G.rotation, w = G.color ? (y = G.color, x = G.color, T = G.color, G.color) : (y = G.tint.topLeft, x = G.tint.topRight, T = G.tint.bottomLeft, G.tint.bottomRight), y = at.getTintAppendFloatAlpha(y, i.alpha * e._alphaTL), x = at.getTintAppendFloatAlpha(x, i.alpha * e._alphaTR), T = at.getTintAppendFloatAlpha(T, i.alpha * e._alphaBL), w = at.getTintAppendFloatAlpha(w, i.alpha * e._alphaBR)), W *= L, V *= L, W -= e.displayOriginX, V -= e.displayOriginY, W += I, u.applyITRS(W, V, D, L, L), l.multiply(u, h), H = st.u0, j = st.v0, q = st.u1, K = st.v1, Z = h.e, J = h.f, Q = p * h.c + h.e, $ = p * h.d + h.f, tt = f * h.a + p * h.c + h.e, et = f * h.b + p * h.d + h.f, it = f * h.a + h.e, nt = f * h.b + h.f, Y && (Z = Math.round(Z), J = Math.round(J), Q = Math.round(Q), $ = Math.round($), tt = Math.round(tt), et = Math.round(et), it = Math.round(it), nt = Math.round(nt)), o.batchQuad(e, Z, J, Q, $, tt, et, it, nt, H, j, q, K, y, x, T, w, m, v, b))) : (k++, 1 === F ? I = (N.longest - N.lengths[k]) / 2 : 2 === F && (I = N.longest - N.lengths[k]), E = 0, S += O, g = null);
                    c && (o.flush(), t.popScissor()), t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e, i) {
            var Y = i(30);
            t.exports = function(t, e, i, n) {
                var s = e._text, r = s.length, o = t.currentContext;
                if (0 !== r && Y(t, o, e, i, n)) {
                    i.addToRenderList(e);
                    var a, h = e.frame, l = e.displayCallback, u = e.callbackData, c = e.fontData.chars, d = e.fontData.lineHeight, f = e._letterSpacing, p = 0, g = 0, v = null, m = 0, y = 0, x = 0, T = 0, w = 0, b = 0, E = null, S = 0, A = e.frame.source.image, _ = h.cutX, C = h.cutY, M = 0, R = 0, P = e._fontSize / e.fontData.size, O = e._align, L = 0, D = 0;
                    e.getTextBounds(!1);
                    var F = e._bounds.lines;
                    1 === O ? D = (F.longest - F.lengths[0]) / 2 : 2 === O && (D = F.longest - F.lengths[0]), o.translate(-e.displayOriginX, -e.displayOriginY);
                    var k = i.roundPixels;
                    0 < e.cropWidth && 0 < e.cropHeight && (o.beginPath(), o.rect(0, 0, e.cropWidth, e.cropHeight), o.clip());
                    for(var I, B, N = 0; N < r; N++)R = P, M = 0, 10 !== (a = s.charCodeAt(N)) ? (v = c[a]) && (m = _ + v.x, y = C + v.y, x = v.width, T = v.height, w = v.xOffset + p - e.scrollX, b = v.yOffset + g - e.scrollY, null !== E && (w += void 0 !== (I = v.kerning[S]) ? I : 0), l && (u.index = N, u.charCode = a, u.x = w, u.y = b, u.scale = R, u.rotation = M, u.data = v.data, w = (B = l(u)).x, b = B.y, R = B.scale, M = B.rotation), w *= R, b *= R, w += D, p += v.xAdvance + f, E = v, S = a, 0 !== x && 0 !== T && 32 !== a && (k && (w = Math.round(w), b = Math.round(b)), o.save(), o.translate(w, b), o.rotate(M), o.scale(R, R), o.drawImage(A, m, y, x, T, 0, 0, x, T), o.restore())) : (L++, 1 === O ? D = (F.longest - F.lengths[L]) / 2 : 2 === O && (D = F.longest - F.lengths[L]), p = 0, g += d, E = null);
                    o.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1055), s = i(1056);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var r = i(19);
            t.exports = function(t, e, i, n) {
                t.pipelines.clear();
                var s = r(e, i, n).calc;
                e.render.call(e, t, i, s), t.pipelines.rebind();
            };
        },
        function(t, e) {},
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1058), s = i(442);
            s = i(442), t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            function B(t, e, i) {
                this.x = t, this.y = e, this.width = i;
            }
            function N(t, e, i) {
                this.points = [], this.pointsLength = 1, this.points[0] = new B(t, e, i);
            }
            var Y = i(214), U = i(19), n = i(25), X = i(12), z = [], G = new n;
            t.exports = function(t, e, i, n) {
                if (0 !== e.commandBuffer.length) {
                    i.addToRenderList(e);
                    var s = t.pipelines.set(e.pipeline, e);
                    t.pipelines.preBatch(e);
                    for(var r = U(e, i, n).calc, o = G.loadIdentity(), a = e.commandBuffer, h = i.alpha * e.alpha, l = 1, u = s.fillTint, c = s.strokeTint, d = 0, f = 0, p = 0, g = 2 * Math.PI, v = [], m = 0, y = !0, x = null, T = X.getTintAppendFloatAlpha, w = 0; w < a.length; w++)switch(a[w]){
                        case Y.BEGIN_PATH:
                            v.length = 0, y = (x = null, true);
                            break;
                        case Y.CLOSE_PATH:
                            y = !1, x && x.points.length && x.points.push(x.points[0]);
                            break;
                        case Y.FILL_PATH:
                            for(m = 0; m < v.length; m++)s.batchFillPath(v[m].points, o, r);
                            break;
                        case Y.STROKE_PATH:
                            for(m = 0; m < v.length; m++)s.batchStrokePath(v[m].points, l, y, o, r);
                            break;
                        case Y.LINE_STYLE:
                            l = a[++w];
                            var b = T(a[++w], a[++w] * h);
                            c.TL = b, c.TR = b, c.BL = b, c.BR = b;
                            break;
                        case Y.FILL_STYLE:
                            var E = T(a[++w], a[++w] * h);
                            u.TL = E, u.TR = E, u.BL = E, u.BR = E;
                            break;
                        case Y.GRADIENT_FILL_STYLE:
                            var S = a[++w] * h, A = a[++w] * h, _ = a[++w] * h, C = a[++w] * h;
                            u.TL = T(a[++w], S), u.TR = T(a[++w], A), u.BL = T(a[++w], _), u.BR = T(a[++w], C);
                            break;
                        case Y.GRADIENT_LINE_STYLE:
                            l = a[++w];
                            var M = a[++w] * h;
                            c.TL = T(a[++w], M), c.TR = T(a[++w], M), c.BL = T(a[++w], M), c.BR = T(a[++w], M);
                            break;
                        case Y.ARC:
                            var R = 0, P = a[++w], O = a[++w], L = a[++w], D = a[++w], F = a[++w], k = a[++w], I = a[++w];
                            for(F -= D, k ? F < -g ? F = -g : 0 < F && (F = F % g - g) : g < F ? F = g : F < 0 && (F = g + F % g), null === x && (x = new N(P + Math.cos(D) * L, O + Math.sin(D) * L, l), v.push(x), R += .01); R < 1 + I;)p = F * R + D, d = P + Math.cos(p) * L, f = O + Math.sin(p) * L, x.points.push(new B(d, f, l)), R += .01;
                            p = F + D, d = P + Math.cos(p) * L, f = O + Math.sin(p) * L, x.points.push(new B(d, f, l));
                            break;
                        case Y.FILL_RECT:
                            s.batchFillRect(a[++w], a[++w], a[++w], a[++w], o, r);
                            break;
                        case Y.FILL_TRIANGLE:
                            s.batchFillTriangle(a[++w], a[++w], a[++w], a[++w], a[++w], a[++w], o, r);
                            break;
                        case Y.STROKE_TRIANGLE:
                            s.batchStrokeTriangle(a[++w], a[++w], a[++w], a[++w], a[++w], a[++w], l, o, r);
                            break;
                        case Y.LINE_TO:
                            null !== x ? x.points.push(new B(a[++w], a[++w], l)) : (x = new N(a[++w], a[++w], l), v.push(x));
                            break;
                        case Y.MOVE_TO:
                            x = new N(a[++w], a[++w], l), v.push(x);
                            break;
                        case Y.SAVE:
                            z.push(o.copyToArray());
                            break;
                        case Y.RESTORE:
                            o.copyFromArray(z.pop());
                            break;
                        case Y.TRANSLATE:
                            P = a[++w], O = a[++w], o.translate(P, O);
                            break;
                        case Y.SCALE:
                            P = a[++w], O = a[++w], o.scale(P, O);
                            break;
                        case Y.ROTATE:
                            o.rotate(a[++w]);
                    }
                    t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1060), s = i(1061);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e), e.pipeline.batchSprite(e, i, n);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e), t.batchSprite(e, e.frame, i, n);
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1063), s = i(1064);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e), this.pipeline.batchSprite(e, i, n);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e), t.batchSprite(e, e.frame, i, n);
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1066), s = i(1067);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = e.list, s = n.length;
                if (0 !== s) {
                    e.depthSort(), t.pipelines.preBatch(e);
                    var r = -1 !== e.blendMode;
                    r || t.setBlendMode(0);
                    for(var o = e.alpha, a = 0; a < s; a++){
                        var h, l, u, c, d, f, p = n[a];
                        p.willRender(i) && (c = void 0 !== p.alphaTopLeft ? (h = p.alphaTopLeft, l = p.alphaTopRight, u = p.alphaBottomLeft, p.alphaBottomRight) : u = l = h = p.alpha, r || p.blendMode === t.currentBlendMode || t.setBlendMode(p.blendMode), (d = p.mask) && d.preRenderWebGL(t, p, i), (f = p.type) !== t.currentType && (t.newType = !0, t.currentType = f), t.nextTypeMatch = a < s - 1 && n[a + 1].type === t.currentType, p.setAlpha(h * o, l * o, u * o, c * o), p.renderWebGL(t, p, i), p.setAlpha(h, l, u, c), d && d.postRenderWebGL(t, i), t.newType = !1);
                    }
                    t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = e.list;
                if (0 !== n.length) {
                    e.depthSort();
                    var s = -1 !== e.blendMode;
                    s || t.setBlendMode(0);
                    var r = e._alpha;
                    e.mask && e.mask.preRenderCanvas(t, null, i);
                    for(var o = 0; o < n.length; o++){
                        var a, h = n[o];
                        h.willRender(i) && (a = h.alpha, s || h.blendMode === t.currentBlendMode || t.setBlendMode(h.blendMode), h.setAlpha(a * r), h.renderCanvas(t, h, i), h.setAlpha(a));
                    }
                    e.mask && e.mask.postRenderCanvas(t);
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                EmitterOp: i(443),
                GravityWell: i(444),
                Particle: i(445),
                ParticleEmitter: i(446),
                ParticleEmitterManager: i(217),
                Zones: i(1072)
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1070), s = i(1071);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var n = i(25), N = i(12), Y = new n, U = new n, X = new n, z = new n;
            t.exports = function(t, e, i, n) {
                var s = e.emitters.list, r = s.length;
                if (0 !== r) {
                    var o = t.pipelines.set(e.pipeline), a = Y, h = U, l = X, u = z;
                    n ? (u.loadIdentity(), u.multiply(n), u.translate(e.x, e.y), u.rotate(e.rotation), u.scale(e.scaleX, e.scaleY)) : u.applyITRS(e.x, e.y, e.rotation, e.scaleX, e.scaleY);
                    var c = i.roundPixels, d = e.defaultFrame.glTexture, f = N.getTintAppendFloatAlpha, p = o.setGameObject(e, e.defaultFrame);
                    t.pipelines.preBatch(e);
                    for(var g = 0; g < r; g++){
                        var v = s[g], m = v.alive, y = m.length;
                        if (v.visible && 0 !== y) {
                            i.addToRenderList(v);
                            var x = v.scrollFactorX, T = v.scrollFactorY;
                            t.setBlendMode(v.blendMode), v.mask && (v.mask.preRenderWebGL(t, v, i), t.pipelines.set(e.pipeline));
                            for(var w = 0; w < y; w++){
                                var b, E, S, A, _, C, M, R, P, O, L, D, F, k, I = m[w], B = I.alpha * i.alpha;
                                B <= 0 || (l.applyITRS(I.x, I.y, I.rotation, I.scaleX, I.scaleY), a.copyFrom(i.matrix), a.multiplyWithOffset(u, -i.scrollX * x, -i.scrollY * T), l.e = I.x, l.f = I.y, a.multiply(l, h), E = -(b = I.frame).halfWidth, S = -b.halfHeight, A = E + b.width, _ = S + b.height, C = h.getXRound(E, S, c), M = h.getYRound(E, S, c), R = h.getXRound(E, _, c), P = h.getYRound(E, _, c), O = h.getXRound(A, _, c), L = h.getYRound(A, _, c), D = h.getXRound(A, S, c), F = h.getYRound(A, S, c), k = f(I.tint, B), o.batchQuad(v, C, M, R, P, O, L, D, F, b.u0, b.v0, b.u1, b.v1, k, k, k, k, 0, d, p));
                            }
                            v.mask && v.mask.postRenderWebGL(t, i);
                        }
                    }
                    t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e, i) {
            var n = i(25), C = new n, M = new n, R = new n, P = new n;
            t.exports = function(t, e, i, n) {
                var s = e.emitters.list, r = s.length;
                if (0 !== r) {
                    var o = C.copyFrom(i.matrix), a = M, h = R, l = P;
                    n ? (l.loadIdentity(), l.multiply(n), l.translate(e.x, e.y), l.rotate(e.rotation), l.scale(e.scaleX, e.scaleY)) : l.applyITRS(e.x, e.y, e.rotation, e.scaleX, e.scaleY);
                    for(var u = t.currentContext, c = i.roundPixels, d = 0; d < r; d++){
                        var f = s[d], p = f.alive, g = p.length;
                        if (f.visible && 0 !== g) {
                            i.addToRenderList(f);
                            var v = f.follow ? f.follow.x + f.followOffset.x : 0, m = f.follow ? f.follow.y + f.followOffset.y : 0, y = f.scrollFactorX, x = f.scrollFactorY;
                            u.save(), u.globalCompositeOperation = t.blendModes[f.blendMode];
                            for(var T = 0; T < g; T++){
                                var w, b, E, S, A = p[T], _ = A.alpha * i.alpha;
                                _ <= 0 || (h.applyITRS(A.x, A.y, A.rotation, A.scaleX, A.scaleY), o.copyFrom(i.matrix), o.multiplyWithOffset(l, v + -i.scrollX * y, m + -i.scrollY * x), h.e = A.x, h.f = A.y, o.multiply(h, a), b = (w = A.frame).canvasData, E = -w.halfWidth, S = -w.halfHeight, u.globalAlpha = _, u.save(), a.setToContext(u), c && (E = Math.round(E), S = Math.round(S)), u.imageSmoothingEnabled = !(!t.antialias || w.source.scaleMode), u.drawImage(w.source.image, b.x, b.y, b.width, b.height, E, S, b.width, b.height), u.restore());
                            }
                            u.restore();
                        }
                    }
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                DeathZone: i(447),
                EdgeZone: i(448),
                RandomZone: i(450)
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1074), s = i(1075);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var c = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = i.alpha, r = e.renderTarget, o = r.width, a = r.height, h = c.getTintAppendFloatAlpha, l = t.pipelines.set(e.pipeline), u = l.setTexture2D(r.texture);
                t.pipelines.preBatch(e), l.batchTexture(e, r.texture, o, a, e.x, e.y, o, a, e.scaleX, e.scaleY, e.rotation, e.flipX, !e.flipY, e.scrollFactorX, e.scrollFactorY, e.displayOriginX, e.displayOriginY, 0, 0, o, a, h(e.tintTopLeft, s * e._alphaTL), h(e.tintTopRight, s * e._alphaTR), h(e.tintBottomLeft, s * e._alphaBL), h(e.tintBottomRight, s * e._alphaBR), e.tintFill, 0, 0, i, n, !0, u), t.resetTextures(), t.pipelines.postBatch(e);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e), t.batchSprite(e, e.frame, i, n);
            };
        },
        function(t, e, i) {
            var n = i(1077), s = i(17)(!1, s = {
                Parse: i(1078)
            }, n);
            t.exports = s;
        },
        function(t, e) {
            t.exports = {
                TEXT_SET1: " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~",
                TEXT_SET2: " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                TEXT_SET3: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ",
                TEXT_SET4: "ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789",
                TEXT_SET5: "ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789",
                TEXT_SET6: "ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789\"(),-.' ",
                TEXT_SET7: "AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW\")28FLRX-'39",
                TEXT_SET8: "0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                TEXT_SET9: "ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'\"?!",
                TEXT_SET10: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                TEXT_SET11: "ABCDEFGHIJKLMNOPQRSTUVWXYZ.,\"-+!?()':;0123456789"
            };
        },
        function(t, e, i) {
            var R = i(6);
            t.exports = function(t, e) {
                var i = e.width, n = e.height, s = Math.floor(i / 2), r = Math.floor(n / 2), o = R(e, "chars", "");
                if ("" !== o) {
                    var a = R(e, "image", ""), h = t.sys.textures.getFrame(a), l = h.cutX, u = h.cutY, c = h.source.width, d = h.source.height, f = R(e, "offset.x", 0), p = R(e, "offset.y", 0), g = R(e, "spacing.x", 0), v = R(e, "spacing.y", 0), m = R(e, "lineSpacing", 0), y = R(e, "charsPerRow", null);
                    null === y && (y = c / i) > o.length && (y = o.length);
                    for(var x = f, T = p, w = {
                        retroFont: !0,
                        font: a,
                        size: i,
                        lineHeight: n + m,
                        chars: {}
                    }, b = 0, E = 0; E < o.length; E++){
                        var S = o.charCodeAt(E), A = (l + x) / c, _ = (u + T) / d, C = (l + x + i) / c, M = (u + T + n) / d;
                        w.chars[S] = {
                            x: x,
                            y: T,
                            width: i,
                            height: n,
                            centerX: s,
                            centerY: r,
                            xOffset: 0,
                            yOffset: 0,
                            xAdvance: i,
                            data: {},
                            kerning: {},
                            u0: A,
                            v0: _,
                            u1: C,
                            v1: M
                        }, ++b === y ? (b = 0, x = f, T += n + v) : x += i + g;
                    }
                    return {
                        data: w,
                        frame: null,
                        texture: a
                    };
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1080), s = i(1081);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var M = i(19), R = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline, e), r = M(e, i, n).calc, o = e.vertices, a = e.uv, h = e.colors, l = e.alphas, u = e.alpha, c = R.getTintAppendFloatAlpha, d = i.roundPixels, f = o.length, p = Math.floor(.5 * f);
                s.flush(), t.pipelines.preBatch(e);
                var g = s.setGameObject(e), v = s.vertexViewF32, m = s.vertexViewU32, y = s.vertexCount * s.currentShader.vertexComponentCount - 1, x = 0, T = e.tintFill;
                e.dirty && e.updateVertices();
                for(var w = e.debugCallback, b = [], E = 0; E < f; E += 2){
                    var S = o[E + 0], A = o[E + 1], _ = S * r.a + A * r.c + r.e, C = S * r.b + A * r.d + r.f;
                    d && (_ = Math.round(_), C = Math.round(C)), v[++y] = _, v[++y] = C, v[++y] = a[E + 0], v[++y] = a[E + 1], v[++y] = g, v[++y] = T, m[++y] = c(h[x], i.alpha * (l[x] * u)), x++, w && (b[E + 0] = _, b[E + 1] = C);
                }
                w && w.call(e, e, f, b), s.vertexCount += p, t.pipelines.postBatch(e);
            };
        },
        function(t, e) {
            t.exports = function() {};
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1083), s = i(1084);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var u = i(12);
            t.exports = function(t, e, i, n) {
                var s, r, o, a, h, l;
                0 !== e.width && 0 !== e.height && (i.addToRenderList(e), r = (s = e.frame).width, o = s.height, a = u.getTintAppendFloatAlpha, l = (h = t.pipelines.set(e.pipeline, e)).setTexture2D(s.glTexture, e), t.pipelines.preBatch(e), h.batchTexture(e, s.glTexture, r, o, e.x, e.y, r / e.style.resolution, o / e.style.resolution, e.scaleX, e.scaleY, e.rotation, e.flipX, e.flipY, e.scrollFactorX, e.scrollFactorY, e.displayOriginX, e.displayOriginY, 0, 0, r, o, a(e.tintTopLeft, i.alpha * e._alphaTL), a(e.tintTopRight, i.alpha * e._alphaTR), a(e.tintBottomLeft, i.alpha * e._alphaBL), a(e.tintBottomRight, i.alpha * e._alphaBR), e.tintFill, 0, 0, i, n, !1, l), t.pipelines.postBatch(e));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                0 !== e.width && 0 !== e.height && (i.addToRenderList(e), t.batchSprite(e, e.frame, i, n));
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1086), s = i(1087);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var l = i(12);
            t.exports = function(t, e, i, n) {
                e.updateCanvas();
                var s, r, o, a = e.width, h = e.height;
                0 !== a && 0 !== h && (i.addToRenderList(e), t.pipelines.preBatch(e), s = l.getTintAppendFloatAlpha, o = (r = t.pipelines.set(e.pipeline, e)).setTexture2D(e.fillPattern, e), r.batchTexture(e, e.fillPattern, e.displayFrame.width * e.tileScaleX, e.displayFrame.height * e.tileScaleY, e.x, e.y, a, h, e.scaleX, e.scaleY, e.rotation, e.flipX, e.flipY, e.scrollFactorX, e.scrollFactorY, e.originX * a, e.originY * h, 0, 0, a, h, s(e.tintTopLeft, i.alpha * e._alphaTL), s(e.tintTopRight, i.alpha * e._alphaTR), s(e.tintBottomLeft, i.alpha * e._alphaBL), s(e.tintBottomRight, i.alpha * e._alphaBR), e.tintFill, e.tilePositionX % e.displayFrame.width / e.displayFrame.width, e.tilePositionY % e.displayFrame.height / e.displayFrame.height, i, n, !1, o), t.pipelines.postBatch(e));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                e.updateCanvas(), i.addToRenderList(e), t.batchSprite(e, e.frame, i, n);
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1089), s = i(1090);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                e.videoTexture && (i.addToRenderList(e), e.pipeline.batchSprite(e, i, n));
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                e.videoTexture && (i.addToRenderList(e), t.batchSprite(e, e.frame, i, n));
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1092), s = i(1093);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var u = i(19), c = i(111), d = i(81);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = u(e, i, n), o = s.calcMatrix.copyFrom(r.calc), a = e._displayOriginX, h = e._displayOriginY, l = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && c(s, o, e, l, a, h), e.isStroked && d(s, e, l, a, h), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var o = i(35), a = i(46), h = i(58), l = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r = t.currentContext;
                l(t, r, e, i, n) && (s = e.radius, r.beginPath(), r.arc(s - e.originX * (2 * s), s - e.originY * (2 * s), s, o(e._startAngle), o(e._endAngle), e.anticlockwise), e.closePath && r.closePath(), e.isFilled && (a(r, e), r.fill()), e.isStroked && (h(r, e), r.stroke()), r.restore());
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1095), s = i(1096);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var u = i(111), c = i(19), d = i(81);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = c(e, i, n), o = s.calcMatrix.copyFrom(r.calc), a = e._displayOriginX + e._curveBounds.x, h = e._displayOriginY + e._curveBounds.y, l = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && u(s, o, e, l, a, h), e.isStroked && d(s, e, l, a, h), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var p = i(46), g = i(58), v = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.currentContext;
                if (v(t, s, e, i, n)) {
                    var r = e._displayOriginX + e._curveBounds.x, o = e._displayOriginY + e._curveBounds.y, a = e.pathData, h = a.length - 1, l = a[0] - r, u = a[1] - o;
                    s.beginPath(), s.moveTo(l, u), e.closePath || (h -= 2);
                    for(var c = 2; c < h; c += 2){
                        var d = a[c] - r, f = a[c + 1] - o;
                        s.lineTo(d, f);
                    }
                    e.closePath && s.closePath(), e.isFilled && (p(s, e), s.fill()), e.isStroked && (g(s, e), s.stroke()), s.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1098), s = i(1099);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var u = i(111), c = i(19), d = i(81);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = c(e, i, n), o = s.calcMatrix.copyFrom(r.calc), a = e._displayOriginX, h = e._displayOriginY, l = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && u(s, o, e, l, a, h), e.isStroked && d(s, e, l, a, h), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var p = i(46), g = i(58), v = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.currentContext;
                if (v(t, s, e, i, n)) {
                    var r = e._displayOriginX, o = e._displayOriginY, a = e.pathData, h = a.length - 1, l = a[0] - r, u = a[1] - o;
                    s.beginPath(), s.moveTo(l, u), e.closePath || (h -= 2);
                    for(var c = 2; c < h; c += 2){
                        var d = a[c] - r, f = a[c + 1] - o;
                        s.lineTo(d, f);
                    }
                    s.closePath(), e.isFilled && (p(s, e), s.fill()), e.isStroked && (g(s, e), s.stroke()), s.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1101), s = i(1102);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var O = i(19), L = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = O(e, i, n);
                s.calcMatrix.copyFrom(r.calc).translate(-e._displayOriginX, -e._displayOriginY);
                var o, a, h = i.alpha * e.alpha, l = e.width, u = e.height, c = e.cellWidth, d = e.cellHeight, f = Math.ceil(l / c), p = Math.ceil(u / d), g = c, v = d, m = c - (f * c - l), y = d - (p * d - u), x = e.showCells, T = e.showAltCells, w = e.showOutline, b = 0, E = 0, S = 0, A = 0, _ = 0;
                if (w && (g--, v--, m === c && m--, y === d && y--), t.pipelines.preBatch(e), x && 0 < e.fillAlpha) for(o = s.fillTint, a = L.getTintAppendFloatAlpha(e.fillColor, e.fillAlpha * h), o.TL = a, o.TR = a, o.BL = a, o.BR = a, E = 0; E < p; E++)for(T && (S = E % 2), b = 0; b < f; b++)T && S ? S = 0 : (S++, A = b < f - 1 ? g : m, _ = E < p - 1 ? v : y, s.batchFillRect(b * c, E * d, A, _));
                if (T && 0 < e.altFillAlpha) for(o = s.fillTint, a = L.getTintAppendFloatAlpha(e.altFillColor, e.altFillAlpha * h), o.TL = a, o.TR = a, o.BL = a, o.BR = a, E = 0; E < p; E++)for(T && (S = E % 2), b = 0; b < f; b++)!T || S ? (S = 0, A = b < f - 1 ? g : m, _ = E < p - 1 ? v : y, s.batchFillRect(b * c, E * d, A, _)) : S = 1;
                if (w && 0 < e.outlineFillAlpha) {
                    var C = s.strokeTint, M = L.getTintAppendFloatAlpha(e.outlineFillColor, e.outlineFillAlpha * h);
                    for(C.TL = M, C.TR = M, C.BL = M, C.BR = M, b = 1; b < f; b++){
                        var R = b * c;
                        s.batchLine(R, 0, R, u, 1, 1, 1, 0, !1);
                    }
                    for(E = 1; E < p; E++){
                        var P = E * d;
                        s.batchLine(0, P, l, P, 1, 1, 1, 0, !1);
                    }
                }
                t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var M = i(46), R = i(58), P = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.currentContext;
                if (P(t, s, e, i, n)) {
                    var r = -e._displayOriginX, o = -e._displayOriginY, a = i.alpha * e.alpha, h = e.width, l = e.height, u = e.cellWidth, c = e.cellHeight, d = Math.ceil(h / u), f = Math.ceil(l / c), p = u, g = c, v = u - (d * u - h), m = c - (f * c - l), y = e.showCells, x = e.showAltCells, T = e.showOutline, w = 0, b = 0, E = 0, S = 0, A = 0;
                    if (T && (p--, g--, v === u && v--, m === c && m--), y && 0 < e.fillAlpha) for(M(s, e), b = 0; b < f; b++)for(x && (E = b % 2), w = 0; w < d; w++)x && E ? E = 0 : (E++, S = w < d - 1 ? p : v, A = b < f - 1 ? g : m, s.fillRect(r + w * u, o + b * c, S, A));
                    if (x && 0 < e.altFillAlpha) for(M(s, e, e.altFillColor, e.altFillAlpha * a), b = 0; b < f; b++)for(x && (E = b % 2), w = 0; w < d; w++)!x || E ? (E = 0, S = w < d - 1 ? p : v, A = b < f - 1 ? g : m, s.fillRect(r + w * u, o + b * c, S, A)) : E = 1;
                    if (T && 0 < e.outlineFillAlpha) {
                        for(R(s, e, e.outlineFillColor, e.outlineFillAlpha * a), w = 1; w < d; w++){
                            var _ = w * u;
                            s.beginPath(), s.moveTo(_ + r, o), s.lineTo(_ + r, l + o), s.stroke();
                        }
                        for(b = 1; b < f; b++){
                            var C = b * c;
                            s.beginPath(), s.moveTo(r, C + o), s.lineTo(r + h, C + o), s.stroke();
                        }
                    }
                    s.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1104), s = i(1105);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var w = i(19), b = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o, a, h, l, u, c, d, f = t.pipelines.set(e.pipeline), p = w(e, i, n), g = f.calcMatrix.copyFrom(p.calc), v = e.width, m = e.height, y = v / 2, x = v / e.projection, T = i.alpha * e.alpha;
                e.isFilled && (t.pipelines.preBatch(e), e.showTop && (s = b.getTintAppendFloatAlpha(e.fillTop, T), r = g.getX(-y, -m), o = g.getY(-y, -m), a = g.getX(0, -x - m), h = g.getY(0, -x - m), l = g.getX(y, -m), u = g.getY(y, -m), c = g.getX(0, x - m), d = g.getY(0, x - m), f.batchQuad(r, o, a, h, l, u, c, d, s, s, s, s)), e.showLeft && (s = b.getTintAppendFloatAlpha(e.fillLeft, T), r = g.getX(-y, 0), o = g.getY(-y, 0), a = g.getX(0, x), h = g.getY(0, x), l = g.getX(0, x - m), u = g.getY(0, x - m), c = g.getX(-y, -m), d = g.getY(-y, -m), f.batchQuad(r, o, a, h, l, u, c, d, s, s, s, s)), e.showRight && (s = b.getTintAppendFloatAlpha(e.fillRight, T), r = g.getX(y, 0), o = g.getY(y, 0), a = g.getX(0, x), h = g.getY(0, x), l = g.getX(0, x - m), u = g.getY(0, x - m), c = g.getX(y, -m), d = g.getY(y, -m), f.batchQuad(r, o, a, h, l, u, c, d, s, s, s, s)), t.pipelines.postBatch(e));
            };
        },
        function(t, e, i) {
            var l = i(46), u = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o, a, h = t.currentContext;
                u(t, h, e, i, n) && e.isFilled && (s = e.width, r = e.height, o = s / 2, a = s / e.projection, e.showTop && (l(h, e, e.fillTop), h.beginPath(), h.moveTo(-o, -r), h.lineTo(0, -a - r), h.lineTo(o, -r), h.lineTo(o, -1), h.lineTo(0, a - 1), h.lineTo(-o, -1), h.lineTo(-o, -r), h.fill()), e.showLeft && (l(h, e, e.fillLeft), h.beginPath(), h.moveTo(-o, 0), h.lineTo(0, a), h.lineTo(0, a - r), h.lineTo(-o, -r), h.lineTo(-o, 0), h.fill()), e.showRight && (l(h, e, e.fillRight), h.beginPath(), h.moveTo(o, 0), h.lineTo(0, a), h.lineTo(0, a - r), h.lineTo(o, -r), h.lineTo(o, 0), h.fill()), h.restore());
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1107), s = i(1108);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var b = i(19), E = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o, a, h, l, u, c, d, f = t.pipelines.set(e.pipeline), p = b(e, i, n), g = f.calcMatrix.copyFrom(p.calc), v = e.width, m = e.height, y = v / 2, x = v / e.projection, T = e.isReversed, w = i.alpha * e.alpha;
                e.isFilled && (t.pipelines.preBatch(e), e.showTop && T && (s = E.getTintAppendFloatAlpha(e.fillTop, w), r = g.getX(-y, -m), o = g.getY(-y, -m), a = g.getX(0, -x - m), h = g.getY(0, -x - m), l = g.getX(y, -m), u = g.getY(y, -m), c = g.getX(0, x - m), d = g.getY(0, x - m), f.batchQuad(r, o, a, h, l, u, c, d, s, s, s, s)), e.showLeft && (s = E.getTintAppendFloatAlpha(e.fillLeft, w), u = (l = (h = (a = (o = T ? (r = g.getX(-y, -m), g.getY(-y, -m)) : (r = g.getX(-y, 0), g.getY(-y, 0)), g.getX(0, x)), g.getY(0, x)), g.getX(0, x - m)), g.getY(0, x - m)), f.batchTri(r, o, a, h, l, u, s, s, s)), e.showRight && (s = E.getTintAppendFloatAlpha(e.fillRight, w), u = (l = (h = (a = (o = T ? (r = g.getX(y, -m), g.getY(y, -m)) : (r = g.getX(y, 0), g.getY(y, 0)), g.getX(0, x)), g.getY(0, x)), g.getX(0, x - m)), g.getY(0, x - m)), f.batchTri(r, o, a, h, l, u, s, s, s)), t.pipelines.postBatch(e));
            };
        },
        function(t, e, i) {
            var u = i(46), c = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o, a, h, l = t.currentContext;
                c(t, l, e, i, n) && e.isFilled && (s = e.width, r = e.height, o = s / 2, a = s / e.projection, h = e.isReversed, e.showTop && h && (u(l, e, e.fillTop), l.beginPath(), l.moveTo(-o, -r), l.lineTo(0, -a - r), l.lineTo(o, -r), l.lineTo(0, a - r), l.fill()), e.showLeft && (u(l, e, e.fillLeft), l.beginPath(), h ? l.moveTo(-o, -r) : l.moveTo(-o, 0), l.lineTo(0, a), l.lineTo(0, a - r), l.fill()), e.showRight && (u(l, e, e.fillRight), l.beginPath(), h ? l.moveTo(o, -r) : l.moveTo(o, 0), l.lineTo(0, a), l.lineTo(0, a - r), l.fill()), l.restore());
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1110), s = i(1111);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var f = i(19), p = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = f(e, i, n);
                s.calcMatrix.copyFrom(r.calc);
                var o, a, h, l, u = e._displayOriginX, c = e._displayOriginY, d = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isStroked && (o = s.strokeTint, a = p.getTintAppendFloatAlpha(e.strokeColor, e.strokeAlpha * d), o.TL = a, o.TR = a, o.BL = a, o.BR = a, h = e._startWidth, l = e._endWidth, s.batchLine(e.geom.x1 - u, e.geom.y1 - c, e.geom.x2 - u, e.geom.y2 - c, h, l, 1, 0, !1, r.sprite, r.camera)), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var a = i(58), h = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o = t.currentContext;
                h(t, o, e, i, n) && (s = e._displayOriginX, r = e._displayOriginY, e.isStroked && (a(o, e), o.beginPath(), o.moveTo(e.geom.x1 - s, e.geom.y1 - r), o.lineTo(e.geom.x2 - s, e.geom.y2 - r), o.stroke()), o.restore());
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1113), s = i(1114);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var u = i(111), c = i(19), d = i(81);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = c(e, i, n), o = s.calcMatrix.copyFrom(r.calc), a = e._displayOriginX, h = e._displayOriginY, l = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && u(s, o, e, l, a, h), e.isStroked && d(s, e, l, a, h), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var p = i(46), g = i(58), v = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.currentContext;
                if (v(t, s, e, i, n)) {
                    var r = e._displayOriginX, o = e._displayOriginY, a = e.pathData, h = a.length - 1, l = a[0] - r, u = a[1] - o;
                    s.beginPath(), s.moveTo(l, u), e.closePath || (h -= 2);
                    for(var c = 2; c < h; c += 2){
                        var d = a[c] - r, f = a[c + 1] - o;
                        s.lineTo(d, f);
                    }
                    s.closePath(), e.isFilled && (p(s, e), s.fill()), e.isStroked && (g(s, e), s.stroke()), s.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1116), s = i(1117);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var c = i(19), d = i(81), f = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = c(e, i, n);
                s.calcMatrix.copyFrom(r.calc);
                var o, a, h = e._displayOriginX, l = e._displayOriginY, u = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && (o = s.fillTint, a = f.getTintAppendFloatAlpha(e.fillColor, e.fillAlpha * u), o.TL = a, o.TR = a, o.BL = a, o.BR = a, s.batchFillRect(-h, -l, e.width, e.height)), e.isStroked && d(s, e, u, h, l), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var a = i(46), h = i(58), l = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o = t.currentContext;
                l(t, o, e, i, n) && (s = e._displayOriginX, r = e._displayOriginY, e.isFilled && (a(o, e), o.fillRect(-s, -r, e.width, e.height)), e.isStroked && (h(o, e), o.beginPath(), o.rect(-s, -r, e.width, e.height), o.stroke()), o.restore());
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1119), s = i(1120);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var u = i(111), c = i(19), d = i(81);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = c(e, i, n), o = s.calcMatrix.copyFrom(r.calc), a = e._displayOriginX, h = e._displayOriginY, l = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && u(s, o, e, l, a, h), e.isStroked && d(s, e, l, a, h), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var p = i(46), g = i(58), v = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.currentContext;
                if (v(t, s, e, i, n)) {
                    var r = e._displayOriginX, o = e._displayOriginY, a = e.pathData, h = a.length - 1, l = a[0] - r, u = a[1] - o;
                    s.beginPath(), s.moveTo(l, u), e.closePath || (h -= 2);
                    for(var c = 2; c < h; c += 2){
                        var d = a[c] - r, f = a[c + 1] - o;
                        s.lineTo(d, f);
                    }
                    s.closePath(), e.isFilled && (p(s, e), s.fill()), e.isStroked && (g(s, e), s.stroke()), s.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1122), s = i(1123);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var m = i(19), y = i(81), x = i(12);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = m(e, i, n);
                s.calcMatrix.copyFrom(r.calc);
                var o, a, h, l, u, c, d, f, p = e._displayOriginX, g = e._displayOriginY, v = i.alpha * e.alpha;
                t.pipelines.preBatch(e), e.isFilled && (o = s.fillTint, a = x.getTintAppendFloatAlpha(e.fillColor, e.fillAlpha * v), o.TL = a, o.TR = a, o.BL = a, o.BR = a, h = e.geom.x1 - p, l = e.geom.y1 - g, u = e.geom.x2 - p, c = e.geom.y2 - g, d = e.geom.x3 - p, f = e.geom.y3 - g, s.batchFillTriangle(h, l, u, c, d, f, r.sprite, r.camera)), e.isStroked && y(s, e, v, p, g), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var f = i(46), p = i(58), g = i(30);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s, r, o, a, h, l, u, c, d = t.currentContext;
                g(t, d, e, i, n) && (s = e._displayOriginX, r = e._displayOriginY, o = e.geom.x1 - s, a = e.geom.y1 - r, h = e.geom.x2 - s, l = e.geom.y2 - r, u = e.geom.x3 - s, c = e.geom.y3 - r, d.beginPath(), d.moveTo(o, a), d.lineTo(h, l), d.lineTo(u, c), d.closePath(), e.isFilled && (f(d, e), d.fill()), e.isStroked && (p(d, e), d.stroke()), d.restore());
            };
        },
        function(t, e, i) {
            var s = i(210);
            i(5).register("blitter", function(t, e, i, n) {
                return this.displayList.add(new s(this.scene, t, e, i, n));
            });
        },
        function(t, e, i) {
            var n = i(211);
            i(5).register("container", function(t, e, i) {
                return this.displayList.add(new n(this.scene, t, e, i));
            });
        },
        function(t, e, i) {
            var o = i(436);
            i(5).register("dom", function(t, e, i, n, s) {
                var r = new o(this.scene, t, e, i, n, s);
                return this.displayList.add(r), r;
            });
        },
        function(t, e, i) {
            var r = i(212);
            i(5).register("dynamicBitmapText", function(t, e, i, n, s) {
                return this.displayList.add(new r(this.scene, t, e, i, n, s));
            });
        },
        function(t, e, i) {
            var n = i(438);
            i(5).register("extern", function() {
                var t = new n(this.scene);
                return this.displayList.add(t), t;
            });
        },
        function(t, e, i) {
            var n = i(213);
            i(5).register("graphics", function(t) {
                return this.displayList.add(new n(this.scene, t));
            });
        },
        function(t, e, i) {
            var n = i(110);
            i(5).register("group", function(t, e) {
                return this.updateList.add(new n(this.scene, t, e));
            });
        },
        function(t, e, i) {
            var s = i(124);
            i(5).register("image", function(t, e, i, n) {
                return this.displayList.add(new s(this.scene, t, e, i, n));
            });
        },
        function(t, e, i) {
            var n = i(216);
            i(5).register("layer", function(t) {
                return this.displayList.add(new n(this.scene, t));
            });
        },
        function(t, e, i) {
            var n = i(5), s = i(217);
            n.register("particles", function(t, e, i) {
                return this.displayList.add(new s(this.scene, t, e, i));
            });
        },
        function(t, e, i) {
            var n = i(5), o = i(451);
            n.register("follower", function(t, e, i, n, s) {
                var r = new o(this.scene, t, e, i, n, s);
                return this.displayList.add(r), this.updateList.add(r), r;
            });
        },
        function(t, e, i) {
            var n = i(5), o = i(218);
            n.register("renderTexture", function(t, e, i, n, s, r) {
                return this.displayList.add(new o(this.scene, t, e, i, n, s, r));
            });
        },
        function(t, e, i) {
            var h = i(220);
            i(5).register("rope", function(t, e, i, n, s, r, o, a) {
                return this.displayList.add(new h(this.scene, t, e, i, n, s, r, o, a));
            });
        },
        function(t, e, i) {
            var n = i(5), r = i(73);
            n.register("sprite", function(t, e, i, n) {
                var s = new r(this.scene, t, e, i, n);
                return this.displayList.add(s), s;
            });
        },
        function(t, e, i) {
            var o = i(147);
            i(5).register("bitmapText", function(t, e, i, n, s, r) {
                return this.displayList.add(new o(this.scene, t, e, i, n, s, r));
            });
        },
        function(t, e, i) {
            var s = i(221);
            i(5).register("text", function(t, e, i, n) {
                return this.displayList.add(new s(this.scene, t, e, i, n));
            });
        },
        function(t, e, i) {
            var o = i(222);
            i(5).register("tileSprite", function(t, e, i, n, s, r) {
                return this.displayList.add(new o(this.scene, t, e, i, n, s, r));
            });
        },
        function(t, e, i) {
            var s = i(127);
            i(5).register("zone", function(t, e, i, n) {
                return this.displayList.add(new s(this.scene, t, e, i, n));
            });
        },
        function(t, e, i) {
            var n = i(223);
            i(5).register("video", function(t, e, i) {
                return this.displayList.add(new n(this.scene, t, e, i));
            });
        },
        function(t, e, i) {
            var h = i(455), n = i(5);
            n.register("arc", function(t, e, i, n, s, r, o, a) {
                return this.displayList.add(new h(this.scene, t, e, i, n, s, r, o, a));
            }), n.register("circle", function(t, e, i, n, s) {
                return this.displayList.add(new h(this.scene, t, e, i, 0, 360, !1, n, s));
            });
        },
        function(t, e, i) {
            var n = i(5), r = i(456);
            n.register("curve", function(t, e, i, n, s) {
                return this.displayList.add(new r(this.scene, t, e, i, n, s));
            });
        },
        function(t, e, i) {
            var o = i(457);
            i(5).register("ellipse", function(t, e, i, n, s, r) {
                return this.displayList.add(new o(this.scene, t, e, i, n, s, r));
            });
        },
        function(t, e, i) {
            var n = i(5), u = i(458);
            n.register("grid", function(t, e, i, n, s, r, o, a, h, l) {
                return this.displayList.add(new u(this.scene, t, e, i, n, s, r, o, a, h, l));
            });
        },
        function(t, e, i) {
            var n = i(5), a = i(459);
            n.register("isobox", function(t, e, i, n, s, r, o) {
                return this.displayList.add(new a(this.scene, t, e, i, n, s, r, o));
            });
        },
        function(t, e, i) {
            var n = i(5), h = i(460);
            n.register("isotriangle", function(t, e, i, n, s, r, o, a) {
                return this.displayList.add(new h(this.scene, t, e, i, n, s, r, o, a));
            });
        },
        function(t, e, i) {
            var n = i(5), h = i(461);
            n.register("line", function(t, e, i, n, s, r, o, a) {
                return this.displayList.add(new h(this.scene, t, e, i, n, s, r, o, a));
            });
        },
        function(t, e, i) {
            var n = i(5), r = i(462);
            n.register("polygon", function(t, e, i, n, s) {
                return this.displayList.add(new r(this.scene, t, e, i, n, s));
            });
        },
        function(t, e, i) {
            var n = i(5), o = i(467);
            n.register("rectangle", function(t, e, i, n, s, r) {
                return this.displayList.add(new o(this.scene, t, e, i, n, s, r));
            });
        },
        function(t, e, i) {
            var a = i(468);
            i(5).register("star", function(t, e, i, n, s, r, o) {
                return this.displayList.add(new a(this.scene, t, e, i, n, s, r, o));
            });
        },
        function(t, e, i) {
            var n = i(5), u = i(469);
            n.register("triangle", function(t, e, i, n, s, r, o, a, h, l) {
                return this.displayList.add(new u(this.scene, t, e, i, n, s, r, o, a, h, l));
            });
        },
        function(t, e, i) {
            var r = i(210), o = i(28), n = i(16), a = i(13);
            n.register("blitter", function(t, e) {
                void 0 === t && (t = {});
                var i = a(t, "key", null), n = a(t, "frame", null), s = new r(this.scene, 0, 0, i, n);
                return void 0 !== e && (t.add = e), o(this.scene, s, t), s;
            });
        },
        function(t, e, i) {
            var o = i(28), a = i(211), n = i(16), h = i(13);
            n.register("container", function(t, e) {
                void 0 === t && (t = {});
                var i = h(t, "x", 0), n = h(t, "y", 0), s = h(t, "children", null), r = new a(this.scene, i, n, s);
                return void 0 !== e && (t.add = e), o(this.scene, r, t), r;
            });
        },
        function(t, e, i) {
            var o = i(212), a = i(28), n = i(16), h = i(13);
            n.register("dynamicBitmapText", function(t, e) {
                void 0 === t && (t = {});
                var i = h(t, "font", ""), n = h(t, "text", ""), s = h(t, "size", !1), r = new o(this.scene, 0, 0, i, n, s);
                return void 0 !== e && (t.add = e), a(this.scene, r, t), r;
            });
        },
        function(t, e, i) {
            var n = i(16), s = i(213);
            n.register("graphics", function(t, e) {
                void 0 === t && (t = {}), void 0 !== e && (t.add = e);
                var i = new s(this.scene, t);
                return t.add && this.scene.sys.displayList.add(i), i;
            });
        },
        function(t, e, i) {
            var n = i(16), s = i(110);
            n.register("group", function(t) {
                return new s(this.scene, null, t);
            });
        },
        function(t, e, i) {
            var r = i(28), n = i(16), o = i(13), a = i(124);
            n.register("image", function(t, e) {
                void 0 === t && (t = {});
                var i = o(t, "key", null), n = o(t, "frame", null), s = new a(this.scene, 0, 0, i, n);
                return void 0 !== e && (t.add = e), r(this.scene, s, t), s;
            });
        },
        function(t, e, i) {
            var s = i(28), r = i(216), n = i(16), o = i(13);
            n.register("layer", function(t, e) {
                void 0 === t && (t = {});
                var i = o(t, "children", null), n = new r(this.scene, i);
                return void 0 !== e && (t.add = e), s(this.scene, n, t), n;
            });
        },
        function(t, e, i) {
            var n = i(16), o = i(13), a = i(2), h = i(217);
            n.register("particles", function(t, e) {
                void 0 === t && (t = {});
                var i = o(t, "key", null), n = o(t, "frame", null), s = a(t, "emitters", null), r = new h(this.scene, i, n, s);
                return void 0 !== e && (t.add = e), a(t, "add", !1) ? this.displayList.add(r) : this.updateList.add(r), r;
            });
        },
        function(t, e, i) {
            var l = i(28), n = i(16), u = i(13), c = i(218);
            n.register("renderTexture", function(t, e) {
                void 0 === t && (t = {});
                var i = u(t, "x", 0), n = u(t, "y", 0), s = u(t, "width", 32), r = u(t, "height", 32), o = u(t, "key", void 0), a = u(t, "frame", void 0), h = new c(this.scene, i, n, s, r, o, a);
                return void 0 !== e && (t.add = e), l(this.scene, h, t), h;
            });
        },
        function(t, e, i) {
            var l = i(28), n = i(16), u = i(13), c = i(6), d = i(220);
            n.register("rope", function(t, e) {
                void 0 === t && (t = {});
                var i = u(t, "key", null), n = u(t, "frame", null), s = u(t, "horizontal", !0), r = c(t, "points", void 0), o = c(t, "colors", void 0), a = c(t, "alphas", void 0), h = new d(this.scene, 0, 0, i, n, r, s, o, a);
                return void 0 !== e && (t.add = e), l(this.scene, h, t), t.add || this.updateList.add(h), h;
            });
        },
        function(t, e, i) {
            var r = i(28), o = i(433), n = i(16), a = i(13), h = i(73);
            n.register("sprite", function(t, e) {
                void 0 === t && (t = {});
                var i = a(t, "key", null), n = a(t, "frame", null), s = new h(this.scene, 0, 0, i, n);
                return void 0 !== e && (t.add = e), r(this.scene, s, t), o(s, t), s;
            });
        },
        function(t, e, i) {
            var a = i(147), h = i(28), n = i(16), l = i(13), u = i(6);
            n.register("bitmapText", function(t, e) {
                void 0 === t && (t = {});
                var i = u(t, "font", ""), n = l(t, "text", ""), s = l(t, "size", !1), r = u(t, "align", 0), o = new a(this.scene, 0, 0, i, n, s, r);
                return void 0 !== e && (t.add = e), h(this.scene, o, t), o;
            });
        },
        function(t, e, i) {
            var o = i(28), n = i(16), a = i(13), h = i(221);
            n.register("text", function(t, e) {
                void 0 === t && (t = {});
                var i = a(t, "text", ""), n = a(t, "style", null), s = a(t, "padding", null);
                null !== s && (n.padding = s);
                var r = new h(this.scene, 0, 0, i, n);
                return void 0 !== e && (t.add = e), o(this.scene, r, t), r.autoRound = a(t, "autoRound", !0), r.resolution = a(t, "resolution", 1), r;
            });
        },
        function(t, e, i) {
            var l = i(28), n = i(16), u = i(13), c = i(222);
            n.register("tileSprite", function(t, e) {
                void 0 === t && (t = {});
                var i = u(t, "x", 0), n = u(t, "y", 0), s = u(t, "width", 512), r = u(t, "height", 512), o = u(t, "key", ""), a = u(t, "frame", ""), h = new c(this.scene, i, n, s, r, o, a);
                return void 0 !== e && (t.add = e), l(this.scene, h, t), h;
            });
        },
        function(t, e, i) {
            var n = i(16), r = i(13), o = i(127);
            n.register("zone", function(t) {
                var e = r(t, "x", 0), i = r(t, "y", 0), n = r(t, "width", 1), s = r(t, "height", n);
                return new o(this.scene, e, i, n, s);
            });
        },
        function(t, e, i) {
            var s = i(28), n = i(16), r = i(13), o = i(223);
            n.register("video", function(t, e) {
                void 0 === t && (t = {});
                var i = r(t, "key", null), n = new o(this.scene, 0, 0, i);
                return void 0 !== e && (t.add = e), s(this.scene, n, t), t.add || this.updateList.add(n), n;
            });
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1171), s = i(1172);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var r = i(19);
            t.exports = function(t, e, i, n) {
                var s;
                e.shader && (i.addToRenderList(e), t.pipelines.clear(), e.renderToTexture ? e.load() : (s = r(e, i, n).calc, t.width === e._rendererWidth && t.height === e._rendererHeight || e.projOrtho(0, t.width, t.height, 0), e.load(s.matrix)), e.flush(), t.pipelines.rebind());
            };
        },
        function(t, e) {
            t.exports = function() {};
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1174), s = i(1175);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var M = i(19);
            t.exports = function(t, e, i, n) {
                var s = e.faces, r = s.length;
                if (0 !== r) {
                    i.addToRenderList(e);
                    var o = t.pipelines.set(e.pipeline, e), a = M(e, i, n).calc, h = o.setGameObject(e), l = o.vertexViewF32, u = o.vertexViewU32, c = o.vertexCount * o.currentShader.vertexComponentCount - 1, d = e.tintFill, f = [], p = e.debugCallback, g = a.a, v = a.b, m = a.c, y = a.d, x = a.e, T = a.f, w = e.viewPosition.z, b = e.hideCCW, E = i.roundPixels, S = i.alpha * e.alpha, A = 0;
                    t.pipelines.preBatch(e);
                    for(var _ = 0; _ < r; _++){
                        var C = s[_];
                        C.isInView(i, b, w, S, g, v, m, y, x, T, E) && (o.shouldFlush(3) && (o.flush(), c = 0), c = C.load(l, u, c, h, d), A++, o.vertexCount += 3, p && f.push(C));
                    }
                    e.totalFrame += A, p && p.call(e, e, f), t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e) {
            t.exports = function() {};
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1177);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var b = i(19);
            t.exports = function(t, e, i, n) {
                i.addToRenderList(e);
                var s = t.pipelines.set(e.pipeline), r = b(e, i, n).calc, o = e.width, a = e.height, h = -e._radius, l = -e._radius, u = h + o, c = l + a, d = r.getX(0, 0), f = r.getY(0, 0), p = r.getX(h, l), g = r.getY(h, l), v = r.getX(h, c), m = r.getY(h, c), y = r.getX(u, c), x = r.getY(u, c), T = r.getX(u, l), w = r.getY(u, l);
                t.pipelines.preBatch(e), s.batchPointLight(e, i, p, g, v, m, y, x, T, w, d, f), t.pipelines.postBatch(e);
            };
        },
        function(t, e, i) {
            var a = i(226);
            i(5).register("shader", function(t, e, i, n, s, r, o) {
                return this.displayList.add(new a(this.scene, t, e, i, n, s, r, o));
            });
        },
        function(t, e, i) {
            var c = i(227);
            i(5).register("mesh", function(t, e, i, n, s, r, o, a, h, l, u) {
                return this.displayList.add(new c(this.scene, t, e, i, n, s, r, o, a, h, l, u));
            });
        },
        function(t, e, i) {
            var n = i(5), o = i(149);
            n.register("pointlight", function(t, e, i, n, s, r) {
                return this.displayList.add(new o(this.scene, t, e, i, n, s, r));
            });
        },
        function(t, e, i) {
            var h = i(28), n = i(16), l = i(13), u = i(226);
            n.register("shader", function(t, e) {
                void 0 === t && (t = {});
                var i = l(t, "key", null), n = l(t, "x", 0), s = l(t, "y", 0), r = l(t, "width", 128), o = l(t, "height", 128), a = new u(this.scene, i, n, s, r, o);
                return void 0 !== e && (t.add = e), h(this.scene, a, t), a;
            });
        },
        function(t, e, i) {
            var d = i(28), n = i(16), f = i(13), p = i(6), g = i(227);
            n.register("mesh", function(t, e) {
                void 0 === t && (t = {});
                var i = f(t, "key", null), n = f(t, "frame", null), s = p(t, "vertices", []), r = p(t, "uvs", []), o = p(t, "indicies", []), a = p(t, "containsZ", !1), h = p(t, "normals", []), l = p(t, "colors", 16777215), u = p(t, "alphas", 1), c = new g(this.scene, 0, 0, i, n, s, r, o, a, h, l, u);
                return void 0 !== e && (t.add = e), d(this.scene, c, t), c;
            });
        },
        function(t, e, i) {
            var a = i(28), n = i(16), h = i(13), l = i(149);
            n.register("pointlight", function(t, e) {
                void 0 === t && (t = {});
                var i = h(t, "color", 16777215), n = h(t, "radius", 128), s = h(t, "intensity", 1), r = h(t, "attenuation", .1), o = new l(this.scene, 0, 0, i, n, s, r);
                return void 0 !== e && (t.add = e), a(this.scene, o, t), o;
            });
        },
        function(t, e, i) {
            var n = i(0), s = i(476), r = i(24), o = i(21), a = new n({
                Extends: s,
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, t.sys.settings.isBooted || t.sys.events.once(o.BOOT, this.boot, this), s.call(this);
                },
                boot: function() {
                    var t = this.systems.events;
                    t.on(o.SHUTDOWN, this.shutdown, this), t.on(o.DESTROY, this.destroy, this);
                },
                destroy: function() {
                    this.shutdown(), this.scene = void 0, this.systems = void 0;
                }
            });
            r.register("LightsPlugin", a, "lights"), t.exports = a;
        },
        function(t, e, i) {
            var n = i(62);
            n.Area = i(1186), n.Circumference = i(296), n.CircumferencePoint = i(165), n.Clone = i(1187), n.Contains = i(63), n.ContainsPoint = i(1188), n.ContainsRect = i(1189), n.CopyFrom = i(1190), n.Equals = i(1191), n.GetBounds = i(1192), n.GetPoint = i(294), n.GetPoints = i(295), n.Offset = i(1193), n.OffsetPoint = i(1194), n.Random = i(166), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                return 0 < t.radius ? Math.PI * t.radius * t.radius : 0;
            };
        },
        function(t, e, i) {
            var n = i(62);
            t.exports = function(t) {
                return new n(t.x, t.y, t.radius);
            };
        },
        function(t, e, i) {
            var n = i(63);
            t.exports = function(t, e) {
                return n(t, e.x, e.y);
            };
        },
        function(t, e, i) {
            var n = i(63);
            t.exports = function(t, e) {
                return n(t, e.x, e.y) && n(t, e.right, e.y) && n(t, e.x, e.bottom) && n(t, e.right, e.bottom);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.setTo(t.x, t.y, t.radius);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x === e.x && t.y === e.y && t.radius === e.radius;
            };
        },
        function(t, e, i) {
            var n = i(10);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = t.left, e.y = t.top, e.width = t.diameter, e.height = t.diameter, e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t.x += e, t.y += i, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x += e.x, t.y += e.y, t;
            };
        },
        function(t, e, i) {
            var n = i(108);
            n.Area = i(1196), n.Circumference = i(441), n.CircumferencePoint = i(215), n.Clone = i(1197), n.Contains = i(109), n.ContainsPoint = i(1198), n.ContainsRect = i(1199), n.CopyFrom = i(1200), n.Equals = i(1201), n.GetBounds = i(1202), n.GetPoint = i(439), n.GetPoints = i(440), n.Offset = i(1203), n.OffsetPoint = i(1204), n.Random = i(177), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                return t.isEmpty() ? 0 : t.getMajorRadius() * t.getMinorRadius() * Math.PI;
            };
        },
        function(t, e, i) {
            var n = i(108);
            t.exports = function(t) {
                return new n(t.x, t.y, t.width, t.height);
            };
        },
        function(t, e, i) {
            var n = i(109);
            t.exports = function(t, e) {
                return n(t, e.x, e.y);
            };
        },
        function(t, e, i) {
            var n = i(109);
            t.exports = function(t, e) {
                return n(t, e.x, e.y) && n(t, e.right, e.y) && n(t, e.x, e.bottom) && n(t, e.right, e.bottom);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.setTo(t.x, t.y, t.width, t.height);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
            };
        },
        function(t, e, i) {
            var n = i(10);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = t.left, e.y = t.top, e.width = t.width, e.height = t.height, e;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t.x += e, t.y += i, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x += e.x, t.y += e.y, t;
            };
        },
        function(t, e, i) {
            var g = i(4), v = i(228);
            t.exports = function(t, e, i) {
                var n, s, r, o, a, h, l, u, c, d, f, p;
                return void 0 === i && (i = []), v(t, e) && (n = t.x, s = t.y, r = t.radius, o = e.x, a = e.y, h = e.radius, s === a ? 0 === (p = (f = -2 * a) * f - 4 * (d = 1) * (o * o + (l = (h * h - r * r - o * o + n * n) / (2 * (n - o))) * l - 2 * o * l + a * a - h * h)) ? i.push(new g(l, -f / (2 * d))) : 0 < p && (i.push(new g(l, (-f + Math.sqrt(p)) / (2 * d))), i.push(new g(l, (-f - Math.sqrt(p)) / (2 * d)))) : 0 === (p = (f = 2 * s * (u = (n - o) / (s - a)) - 2 * (c = (h * h - r * r - o * o + n * n - a * a + s * s) / (2 * (s - a))) * u - 2 * n) * f - 4 * (d = u * u + 1) * (n * n + s * s + c * c - r * r - 2 * s * c)) ? (l = -f / (2 * d), i.push(new g(l, c - l * u))) : 0 < p && (l = (-f + Math.sqrt(p)) / (2 * d), i.push(new g(l, c - l * u)), l = (-f - Math.sqrt(p)) / (2 * d), i.push(new g(l, c - l * u)))), i;
            };
        },
        function(t, e, i) {
            var a = i(229), h = i(150);
            t.exports = function(t, e, i) {
                var n, s, r, o;
                return void 0 === i && (i = []), h(t, e) && (n = e.getLineA(), s = e.getLineB(), r = e.getLineC(), o = e.getLineD(), a(n, t, i), a(s, t, i), a(r, t, i), a(o, t, i)), i;
            };
        },
        function(t, e, i) {
            var h = i(138), l = i(481), u = new (i(45));
            function c(t, e, i, n, s) {
                var r = Math.cos(t), o = Math.sin(t);
                u.setTo(e, i, e + r, i + o);
                var a = l(u, n);
                a && s.push(new h(a.x, a.y, t, a.w));
            }
            function d(t, e) {
                return t.z - e.z;
            }
            t.exports = function(t, e, i) {
                Array.isArray(i) || (i = [
                    i
                ]);
                for(var n = [], s = [], r = 0; r < i.length; r++)for(var o = i[r].points, a = 0; a < o.length; a++){
                    var h = Math.atan2(o[a].y - e, o[a].x - t);
                    -1 === s.indexOf(h) && (c(h, t, e, i, n), c(h - 1e-5, t, e, i, n), c(h + 1e-5, t, e, i, n), s.push(h));
                }
                return n.sort(d);
            };
        },
        function(t, e, i) {
            var n = i(10), s = i(114);
            t.exports = function(t, e, i) {
                return void 0 === i && (i = new n), s(t, e) && (i.x = Math.max(t.x, e.x), i.y = Math.max(t.y, e.y), i.width = Math.min(t.right, e.right) - i.x, i.height = Math.min(t.bottom, e.bottom) - i.y), i;
            };
        },
        function(t, e, i) {
            var a = i(231), h = i(114);
            t.exports = function(t, e, i) {
                var n, s, r, o;
                return void 0 === i && (i = []), h(t, e) && (n = t.getLineA(), s = t.getLineB(), r = t.getLineC(), o = t.getLineD(), a(n, e, i), a(s, e, i), a(r, e, i), a(o, e, i)), i;
            };
        },
        function(t, e, i) {
            var o = i(483), a = i(231);
            t.exports = function(t, e, i) {
                var n, s, r;
                return void 0 === i && (i = []), o(t, e) && (n = e.getLineA(), s = e.getLineB(), r = e.getLineC(), a(n, t, i), a(s, t, i), a(r, t, i)), i;
            };
        },
        function(t, e, i) {
            var o = i(229), a = i(485);
            t.exports = function(t, e, i) {
                var n, s, r;
                return void 0 === i && (i = []), a(t, e) && (n = t.getLineA(), s = t.getLineB(), r = t.getLineC(), o(n, e, i), o(s, e, i), o(r, e, i)), i;
            };
        },
        function(t, e, i) {
            var o = i(488), a = i(486);
            t.exports = function(t, e, i) {
                var n, s, r;
                return void 0 === i && (i = []), o(t, e) && (n = e.getLineA(), s = e.getLineB(), r = e.getLineC(), a(t, n, i), a(t, s, i), a(t, r, i)), i;
            };
        },
        function(t, e, i) {
            var o = i(490);
            t.exports = function(t, e) {
                if (!o(t, e)) return !1;
                var i = Math.min(e.x1, e.x2), n = Math.max(e.x1, e.x2), s = Math.min(e.y1, e.y2), r = Math.max(e.y1, e.y2);
                return t.x >= i && t.x <= n && t.y >= s && t.y <= r;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s, r) {
                return void 0 === r && (r = 0), !(e > t.right + r || i < t.left - r || n > t.bottom + r || s < t.top - r);
            };
        },
        function(t, e, i) {
            var n = i(45);
            n.Angle = i(93), n.BresenhamPoints = i(311), n.CenterOn = i(1216), n.Clone = i(1217), n.CopyFrom = i(1218), n.Equals = i(1219), n.Extend = i(1220), n.GetEasedPoints = i(1221), n.GetMidPoint = i(1222), n.GetNearestPoint = i(1223), n.GetNormal = i(1224), n.GetPoint = i(301), n.GetPoints = i(168), n.GetShortestDistance = i(1225), n.Height = i(1226), n.Length = i(64), n.NormalAngle = i(491), n.NormalX = i(1227), n.NormalY = i(1228), n.Offset = i(1229), n.PerpSlope = i(1230), n.Random = i(169), n.ReflectAngle = i(1231), n.Rotate = i(1232), n.RotateAroundPoint = i(1233), n.RotateAroundXY = i(233), n.SetToAngle = i(1234), n.Slope = i(1235), n.Width = i(1236), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = e - (t.x1 + t.x2) / 2, s = i - (t.y1 + t.y2) / 2;
                return t.x1 += n, t.y1 += s, t.x2 += n, t.y2 += s, t;
            };
        },
        function(t, e, i) {
            var n = i(45);
            t.exports = function(t) {
                return new n(t.x1, t.y1, t.x2, t.y2);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.setTo(t.x1, t.y1, t.x2, t.y2);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x1 === e.x1 && t.y1 === e.y1 && t.x2 === e.x2 && t.y2 === e.y2;
            };
        },
        function(t, e, i) {
            var o = i(64);
            t.exports = function(t, e, i) {
                void 0 === i && (i = e);
                var n = o(t), s = t.x2 - t.x1, r = t.y2 - t.y1;
                return e && (t.x1 = t.x1 - s / n * e, t.y1 = t.y1 - r / n * e), i && (t.x2 = t.x2 + s / n * i, t.y2 = t.y2 + r / n * i), t;
            };
        },
        function(t, e, i) {
            var y = i(346), x = i(80), T = i(4);
            t.exports = function(t, e, i, n, s) {
                void 0 === n && (n = 0), void 0 === s && (s = []);
                var r, o = [], a = t.x1, h = t.y1, l = t.x2 - a, u = t.y2 - h, c = x(e, s), d = i - 1;
                for(g = 0; g < d; g++)r = c(g / d), o.push(new T(a + l * r, h + u * r));
                if (r = c(1), o.push(new T(a + l * r, h + u * r)), 0 < n) {
                    for(var f = o[0], p = [
                        f
                    ], g = 1; g < o.length - 1; g++){
                        var v = o[g];
                        y(f, v) >= n && (p.push(v), f = v);
                    }
                    var m = o[o.length - 1];
                    return y(f, m) < n && p.pop(), p.push(m), p;
                }
                return o;
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = (t.x1 + t.x2) / 2, e.y = (t.y1 + t.y2) / 2, e;
            };
        },
        function(t, e, i) {
            var l = i(4);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new l);
                var n = t.x1, s = t.y1, r = t.x2, o = t.y2, a = (r - n) * (r - n) + (o - s) * (o - s);
                if (0 == a) return i;
                var h = ((e.x - n) * (r - n) + (e.y - s) * (o - s)) / a;
                return i.x = n + h * (r - n), i.y = s + h * (o - s), i;
            };
        },
        function(t, e, i) {
            var n = i(14), s = i(93), r = i(4);
            t.exports = function(t, e) {
                void 0 === e && (e = new r);
                var i = s(t) - n.TAU;
                return e.x = Math.cos(i), e.y = Math.sin(i), e;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = t.x1, n = t.y1, s = t.x2, r = t.y2, o = (s - i) * (s - i) + (r - n) * (r - n);
                if (0 == o) return !1;
                var a = ((n - e.y) * (s - i) - (i - e.x) * (r - n)) / o;
                return Math.abs(a) * Math.sqrt(o);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.abs(t.y1 - t.y2);
            };
        },
        function(t, e, i) {
            var n = i(14), s = i(93);
            t.exports = function(t) {
                return Math.cos(s(t) - n.TAU);
            };
        },
        function(t, e, i) {
            var n = i(14), s = i(93);
            t.exports = function(t) {
                return Math.sin(s(t) - n.TAU);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t.x1 += e, t.y1 += i, t.x2 += e, t.y2 += i, t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return -((t.x2 - t.x1) / (t.y2 - t.y1));
            };
        },
        function(t, e, i) {
            var n = i(93), s = i(491);
            t.exports = function(t, e) {
                return 2 * s(e) - Math.PI - n(t);
            };
        },
        function(t, e, i) {
            var s = i(233);
            t.exports = function(t, e) {
                var i = (t.x1 + t.x2) / 2, n = (t.y1 + t.y2) / 2;
                return s(t, i, n, e);
            };
        },
        function(t, e, i) {
            var n = i(233);
            t.exports = function(t, e, i) {
                return n(t, e.x, e.y, i);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n, s) {
                return t.x1 = e, t.y1 = i, t.x2 = e + Math.cos(n) * s, t.y2 = i + Math.sin(n) * s, t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return (t.y2 - t.y1) / (t.x2 - t.x1);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return Math.abs(t.x1 - t.x2);
            };
        },
        function(t, e, i) {
            var n = {
                Face: i(113),
                GenerateGridVerts: i(1238),
                GenerateObjVerts: i(474),
                GenerateVerts: i(473),
                ParseObj: i(492),
                ParseObjMaterial: i(493),
                RotateFace: i(1239),
                Vertex: i(115)
            };
            t.exports = n;
        },
        function(t, e, i) {
            var rt = i(113), ot = i(2), n = i(67), s = i(38), at = i(115), ht = new s, lt = new s, ut = new n;
            t.exports = function(t) {
                var e = ot(t, "mesh"), i = ot(t, "texture", null), n = ot(t, "frame"), s = ot(t, "width", 1), r = ot(t, "height", s), o = ot(t, "widthSegments", 1), a = ot(t, "heightSegments", o), h = ot(t, "x", 0), l = ot(t, "y", 0), u = ot(t, "z", 0), c = ot(t, "rotateX", 0), d = ot(t, "rotateY", 0), f = ot(t, "rotateZ", 0), p = ot(t, "zIsUp", !0), g = ot(t, "isOrtho", !!e && e.dirtyCache[11]), v = ot(t, "colors", [
                    16777215
                ]), m = ot(t, "alphas", [
                    1
                ]), y = ot(t, "tile", !1), x = ot(t, "flipY", !1), T = ot(t, "width", null), w = {
                    faces: [],
                    verts: []
                };
                if (ht.set(h, l, u), lt.set(c, d, f), ut.fromRotationXYTranslation(lt, ht, p), !i && e) i = e.texture;
                else {
                    if (!e || "string" != typeof i) return w;
                    i = e.scene.sys.textures.get(i);
                }
                var b = i.get(n);
                !T && g && i && e && (s = b.width / e.height, r = b.height / e.height);
                var E = s / 2, S = r / 2, A = Math.floor(o), _ = Math.floor(a), C = A + 1, M = _ + 1, R = s / A, P = r / _, O = [], L = [], D = 0, F = 1, k = 0, I = 1;
                b && (D = b.u0, F = b.u1, I = x ? (k = b.v1, b.v0) : (k = b.v0, b.v1));
                for(var B = F - D, N = I - k, Y = 0; Y < M; Y++)for(var U = Y * P - S, X = 0; X < C; X++){
                    var z = X * R - E;
                    L.push(z, -U);
                    var G = D + X / A * B, W = k + Y / _ * N;
                    O.push(G, W);
                }
                Array.isArray(v) || (v = [
                    v
                ]), Array.isArray(m) || (m = [
                    m
                ]);
                var V = 0, H = 0;
                for(Y = 0; Y < _; Y++)for(X = 0; X < A; X++){
                    var j = 2 * (X + C * Y), q = 2 * (X + C * (Y + 1)), K = 2 * (X + 1 + C * (Y + 1)), Z = 2 * (X + 1 + C * Y), J = v[H], Q = m[V], $ = new at(L[j], L[1 + j], 0, O[j], O[1 + j], J, Q).transformMat4(ut), tt = new at(L[q], L[1 + q], 0, O[q], O[1 + q], J, Q).transformMat4(ut), et = new at(L[Z], L[1 + Z], 0, O[Z], O[1 + Z], J, Q).transformMat4(ut), it = new at(L[q], L[1 + q], 0, O[q], O[1 + q], J, Q).transformMat4(ut), nt = new at(L[K], L[1 + K], 0, O[K], O[1 + K], J, Q).transformMat4(ut), st = new at(L[Z], L[1 + Z], 0, O[Z], O[1 + Z], J, Q).transformMat4(ut);
                    y && ($.setUVs(D, I), tt.setUVs(D, k), et.setUVs(F, I), it.setUVs(D, k), nt.setUVs(F, k), st.setUVs(F, I)), ++H === v.length && (H = 0), ++V === m.length && (V = 0), w.verts.push($, tt, et, it, nt, st), w.faces.push(new rt($, tt, et), new rt(it, nt, st));
                }
                return e && (e.faces = e.faces.concat(w.faces), e.vertices = e.vertices.concat(w.verts)), w;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                var s, r, o;
                void 0 === i && void 0 === n && (r = (s = t.getInCenter()).x, o = s.y);
                var a = Math.cos(e), h = Math.sin(e), l = t.vertex1, u = t.vertex2, c = t.vertex3, d = l.x - r, f = l.y - o;
                l.set(d * a - f * h + r, d * h + f * a + o), d = u.x - r, f = u.y - o, u.set(d * a - f * h + r, d * h + f * a + o), d = c.x - r, f = c.y - o, c.set(d * a - f * h + r, d * h + f * a + o);
            };
        },
        function(t, e, i) {
            var n = i(4);
            n.Ceil = i(1241), n.Clone = i(1242), n.CopyFrom = i(1243), n.Equals = i(1244), n.Floor = i(1245), n.GetCentroid = i(1246), n.GetMagnitude = i(494), n.GetMagnitudeSq = i(495), n.GetRectangleFromPoints = i(1247), n.Interpolate = i(1248), n.Invert = i(1249), n.Negative = i(1250), n.Project = i(1251), n.ProjectUnit = i(1252), n.SetMagnitude = i(1253), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                return t.setTo(Math.ceil(t.x), Math.ceil(t.y));
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t) {
                return new n(t.x, t.y);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.setTo(t.x, t.y);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x === e.x && t.y === e.y;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.setTo(Math.floor(t.x), Math.floor(t.y));
            };
        },
        function(t, e, i) {
            var s = i(4);
            t.exports = function(t, e) {
                if (void 0 === e && (e = new s), !Array.isArray(t)) throw new Error("GetCentroid points argument must be an array");
                var i = t.length;
                if (i < 1) throw new Error("GetCentroid points array must not be empty");
                if (1 === i) e.x = t[0].x, e.y = t[0].y;
                else {
                    for(var n = 0; n < i; n++)e.x += t[n].x, e.y += t[n].y;
                    e.x /= i, e.y /= i;
                }
                return e;
            };
        },
        function(t, e, i) {
            var h = i(10);
            t.exports = function(t, e) {
                void 0 === e && (e = new h);
                for(var i = Number.NEGATIVE_INFINITY, n = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY, r = Number.POSITIVE_INFINITY, o = 0; o < t.length; o++){
                    var a = t[o];
                    a.x > i && (i = a.x), a.x < n && (n = a.x), a.y > s && (s = a.y), a.y < r && (r = a.y);
                }
                return e.x = n, e.y = r, e.width = i - n, e.height = s - r, e;
            };
        },
        function(t, e, i) {
            var s = i(4);
            t.exports = function(t, e, i, n) {
                return void 0 === i && (i = 0), void 0 === n && (n = new s), n.x = t.x + (e.x - t.x) * i, n.y = t.y + (e.y - t.y) * i, n;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.setTo(t.y, t.x);
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.setTo(-t.x, -t.y);
            };
        },
        function(t, e, i) {
            var s = i(4), r = i(495);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new s);
                var n = (t.x * e.x + t.y * e.y) / r(e);
                return 0 != n && (i.x = n * e.x, i.y = n * e.y), i;
            };
        },
        function(t, e, i) {
            var s = i(4);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new s);
                var n = t.x * e.x + t.y * e.y;
                return 0 != n && (i.x = n * e.x, i.y = n * e.y), i;
            };
        },
        function(t, e, i) {
            var n = i(494);
            t.exports = function(t, e) {
                var i;
                return 0 === t.x && 0 === t.y || (i = n(t), t.x /= i, t.y /= i), t.x *= e, t.y *= e, t;
            };
        },
        function(t, e, i) {
            var n = i(224);
            n.Clone = i(1255), n.Contains = i(225), n.ContainsPoint = i(1256), n.Earcut = i(68), n.GetAABB = i(463), n.GetNumberArray = i(1257), n.GetPoints = i(464), n.Perimeter = i(465), n.Reverse = i(1258), n.Simplify = i(1259), n.Smooth = i(466), n.Translate = i(1260), t.exports = n;
        },
        function(t, e, i) {
            var n = i(224);
            t.exports = function(t) {
                return new n(t.points);
            };
        },
        function(t, e, i) {
            var n = i(225);
            t.exports = function(t, e) {
                return n(t, e.x, e.y);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = []);
                for(var i = 0; i < t.points.length; i++)e.push(t.points[i].x), e.push(t.points[i].y);
                return e;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.points.reverse(), t;
            };
        },
        function(t, e) {
            function r(t, e) {
                var i = t.length - 1, n = [
                    t[0]
                ];
                return function t(e, i, n, s, r) {
                    for(var o, a, h, l, u, c, d, f, p, g = s, v = i + 1; v < n; v++){
                        var m = (a = e[v], h = e[i], l = e[n], p = f = d = c = u = void 0, c = h.x, d = h.y, f = l.x - c, p = l.y - d, 0 === f && 0 === p || (1 < (u = ((a.x - c) * f + (a.y - d) * p) / (f * f + p * p)) ? (c = l.x, d = l.y) : 0 < u && (c += f * u, d += p * u)), (f = a.x - c) * f + (p = a.y - d) * p);
                        g < m && (o = v, g = m);
                    }
                    s < g && (1 < o - i && t(e, i, o, s, r), r.push(e[o]), 1 < n - o && t(e, o, n, s, r));
                }(t, 0, i, e, n), n.push(t[i]), n;
            }
            t.exports = function(t, e, i) {
                void 0 === e && (e = 1), void 0 === i && (i = !1);
                var n, s = t.points;
                return 2 < s.length && (n = e * e, i || (s = function(t, e) {
                    for(var i, n, s, r, o, a = t[0], h = [
                        a
                    ], l = 1, u = t.length; l < u; l++)i = t[l], s = a, o = r = void 0, r = (n = i).x - s.x, o = n.y - s.y, e < r * r + o * o && (h.push(i), a = i);
                    return a !== i && h.push(i), h;
                }(s, n)), t.setTo(r(s, n))), t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                for(var n = t.points, s = 0; s < n.length; s++)n[s].x += e, n[s].y += i;
                return t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.width * t.height;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x = Math.ceil(t.x), t.y = Math.ceil(t.y), t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x = Math.ceil(t.x), t.y = Math.ceil(t.y), t.width = Math.ceil(t.width), t.height = Math.ceil(t.height), t;
            };
        },
        function(t, e, i) {
            var n = i(10);
            t.exports = function(t) {
                return new n(t.x, t.y, t.width, t.height);
            };
        },
        function(t, e, i) {
            var n = i(56);
            t.exports = function(t, e) {
                return n(t, e.x, e.y);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.setTo(t.x, t.y, t.width, t.height);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
            };
        },
        function(t, e, i) {
            var n = i(234);
            t.exports = function(t, e) {
                var i = n(t);
                return i < n(e) ? t.setSize(e.height * i, e.height) : t.setSize(e.width, e.width / i), t.setPosition(e.centerX - t.width / 2, e.centerY - t.height / 2);
            };
        },
        function(t, e, i) {
            var n = i(234);
            t.exports = function(t, e) {
                var i = n(t);
                return i > n(e) ? t.setSize(e.height * i, e.height) : t.setSize(e.width, e.width / i), t.setPosition(e.centerX - t.width / 2, e.centerY - t.height / 2);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x = Math.floor(t.x), t.y = Math.floor(t.y), t;
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.x = Math.floor(t.x), t.y = Math.floor(t.y), t.width = Math.floor(t.width), t.height = Math.floor(t.height), t;
            };
        },
        function(t, e, i) {
            var r = i(10);
            t.exports = function(t, e, i, n, s) {
                return void 0 === s && (s = new r), s.setTo(Math.min(t, i), Math.min(e, n), Math.abs(t - i), Math.abs(e - n));
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = t.centerX, e.y = t.centerY, e;
            };
        },
        function(t, e, i) {
            var n = i(4);
            t.exports = function(t, e) {
                return void 0 === e && (e = new n), e.x = t.width, e.y = t.height, e;
            };
        },
        function(t, e, i) {
            var r = i(187);
            t.exports = function(t, e, i) {
                var n = t.centerX, s = t.centerY;
                return t.setSize(t.width + 2 * e, t.height + 2 * i), r(t, n, s);
            };
        },
        function(t, e, i) {
            var n = i(10), s = i(114);
            t.exports = function(t, e, i) {
                return void 0 === i && (i = new n), s(t, e) ? (i.x = Math.max(t.x, e.x), i.y = Math.max(t.y, e.y), i.width = Math.min(t.right, e.right) - i.x, i.height = Math.min(t.bottom, e.bottom) - i.y) : i.setEmpty(), i;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var i = t.x, n = t.right, s = t.y, r = t.bottom, o = 0; o < e.length; o++)i = Math.min(i, e[o].x), n = Math.max(n, e[o].x), s = Math.min(s, e[o].y), r = Math.max(r, e[o].y);
                return t.x = i, t.y = s, t.width = n - i, t.height = r - s, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                var i = Math.min(t.x, e.x), n = Math.max(t.right, e.right);
                t.x = i, t.width = n - i;
                var s = Math.min(t.y, e.y), r = Math.max(t.bottom, e.bottom);
                return t.y = s, t.height = r - s, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                var n = Math.min(t.x, e), s = Math.max(t.right, e);
                t.x = n, t.width = s - n;
                var r = Math.min(t.y, i), o = Math.max(t.bottom, i);
                return t.y = r, t.height = o - r, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return t.x += e, t.y += i, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x += e.x, t.y += e.y, t;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x < e.right && t.right > e.x && t.y < e.bottom && t.bottom > e.y;
            };
        },
        function(t, e, i) {
            var a = i(4), h = i(35);
            t.exports = function(t, e, i) {
                void 0 === i && (i = new a), e = h(e);
                var n = Math.sin(e), s = Math.cos(e), r = 0 < s ? t.width / 2 : t.width / -2, o = 0 < n ? t.height / 2 : t.height / -2;
                return Math.abs(r * n) < Math.abs(o * s) ? o = r * n / s : r = o * s / n, i.x = r + t.centerX, i.y = o + t.centerY, i;
            };
        },
        function(t, e, i) {
            var n = i(192), s = i(497), r = i(4);
            t.exports = function(t, e, i) {
                if (void 0 === i && (i = new r), s(t, e)) switch(n(0, 3)){
                    case 0:
                        i.x = t.x + Math.random() * (e.right - t.x), i.y = t.y + Math.random() * (e.top - t.y);
                        break;
                    case 1:
                        i.x = e.x + Math.random() * (t.right - e.x), i.y = e.bottom + Math.random() * (t.bottom - e.bottom);
                        break;
                    case 2:
                        i.x = t.x + Math.random() * (e.x - t.x), i.y = e.y + Math.random() * (t.bottom - e.y);
                        break;
                    case 3:
                        i.x = e.right + Math.random() * (t.right - e.right), i.y = t.y + Math.random() * (e.bottom - t.y);
                }
                return i;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.width === e.width && t.height === e.height;
            };
        },
        function(t, e) {
            t.exports = function(t, e, i) {
                return void 0 === i && (i = e), t.width *= e, t.height *= i, t;
            };
        },
        function(t, e, i) {
            var n = i(82);
            n.Area = i(1288), n.BuildEquilateral = i(1289), n.BuildFromPolygon = i(1290), n.BuildRight = i(1291), n.CenterOn = i(1292), n.Centroid = i(498), n.CircumCenter = i(1293), n.CircumCircle = i(1294), n.Clone = i(1295), n.Contains = i(112), n.ContainsArray = i(232), n.ContainsPoint = i(1296), n.CopyFrom = i(1297), n.Decompose = i(489), n.Equals = i(1298), n.GetPoint = i(470), n.GetPoints = i(471), n.InCenter = i(500), n.Perimeter = i(1299), n.Offset = i(499), n.Random = i(178), n.Rotate = i(1300), n.RotateAroundPoint = i(1301), n.RotateAroundXY = i(235), t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                var e = t.x1, i = t.y1, n = t.x2, s = t.y2, r = t.x3, o = t.y3;
                return Math.abs(((r - e) * (s - i) - (n - e) * (o - i)) / 2);
            };
        },
        function(t, e, i) {
            var s = i(82);
            t.exports = function(t, e, i) {
                var n = i * (Math.sqrt(3) / 2);
                return new s(t, e, t + i / 2, e + n, t - i / 2, e + n);
            };
        },
        function(t, e, i) {
            var v = i(68), m = i(82);
            t.exports = function(t, e, i, n, s) {
                void 0 === e && (e = null), void 0 === i && (i = 1), void 0 === n && (n = 1), void 0 === s && (s = []);
                for(var r, o, a, h, l, u, c, d, f, p = v(t, e), g = 0; g < p.length; g += 3)r = p[g], o = p[g + 1], a = p[g + 2], h = t[2 * r] * i, l = t[2 * r + 1] * n, u = t[2 * o] * i, c = t[2 * o + 1] * n, d = t[2 * a] * i, f = t[2 * a + 1] * n, s.push(new m(h, l, u, c, d, f));
                return s;
            };
        },
        function(t, e, i) {
            var s = i(82);
            t.exports = function(t, e, i, n) {
                return void 0 === n && (n = i), new s(t, e, t, e - n, t + i, e);
            };
        },
        function(t, e, i) {
            var a = i(498), h = i(499);
            t.exports = function(t, e, i, n) {
                void 0 === n && (n = a);
                var s = n(t), r = e - s.x, o = i - s.y;
                return h(t, r, o);
            };
        },
        function(t, e, i) {
            var c = i(3);
            t.exports = function(t, e) {
                void 0 === e && (e = new c);
                var i = t.x3, n = t.y3, s = t.x1 - i, r = t.y1 - n, o = t.x2 - i, a = t.y2 - n, h = 2 * (s * a - r * o), l = r * (o * o + a * a) - (s * s + r * r) * a, u = s * (o * o + a * a) - (s * s + r * r) * o;
                return e.x = i - l / h, e.y = n + u / h, e;
            };
        },
        function(t, e, i) {
            var x = i(62);
            t.exports = function(t, e) {
                void 0 === e && (e = new x);
                var i, n, s, r, o = t.x1, a = t.y1, h = t.x2, l = t.y2, u = t.x3, c = t.y3, d = h - o, f = l - a, p = u - o, g = c - a, v = d * (o + h) + f * (a + l), m = p * (o + u) + g * (a + c), y = 2 * (d * (c - l) - f * (u - h));
                return Math.abs(y) < 1e-6 ? (i = Math.min(o, h, u), n = Math.min(a, l, c), s = .5 * (Math.max(o, h, u) - i), r = .5 * (Math.max(a, l, c) - n), e.x = i + s, e.y = n + r) : (e.x = (g * v - f * m) / y, e.y = (d * m - p * v) / y, s = e.x - o, r = e.y - a), e.radius = Math.sqrt(s * s + r * r), e;
            };
        },
        function(t, e, i) {
            var n = i(82);
            t.exports = function(t) {
                return new n(t.x1, t.y1, t.x2, t.y2, t.x3, t.y3);
            };
        },
        function(t, e, i) {
            var n = i(112);
            t.exports = function(t, e) {
                return n(t, e.x, e.y);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return e.setTo(t.x1, t.y1, t.x2, t.y2, t.x3, t.y3);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return t.x1 === e.x1 && t.y1 === e.y1 && t.x2 === e.x2 && t.y2 === e.y2 && t.x3 === e.x3 && t.y3 === e.y3;
            };
        },
        function(t, e, i) {
            var s = i(64);
            t.exports = function(t) {
                var e = t.getLineA(), i = t.getLineB(), n = t.getLineC();
                return s(e) + s(i) + s(n);
            };
        },
        function(t, e, i) {
            var n = i(235), s = i(500);
            t.exports = function(t, e) {
                var i = s(t);
                return n(t, i.x, i.y, e);
            };
        },
        function(t, e, i) {
            var n = i(235);
            t.exports = function(t, e, i) {
                return n(t, e.x, e.y, i);
            };
        },
        function(t, e, i) {
            var n = i(200), s = i(17)(!1, s = {
                CreatePixelPerfectHandler: i(501),
                CreateInteractiveObject: i(502),
                Events: i(49),
                Gamepad: i(1303),
                InputManager: i(403),
                InputPlugin: i(1315),
                InputPluginCache: i(151),
                Keyboard: i(1316),
                Mouse: i(1330),
                Pointer: i(406),
                Touch: i(1331)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            t.exports = {
                Axis: i(503),
                Button: i(504),
                Events: i(236),
                Gamepad: i(505),
                GamepadPlugin: i(1310),
                Configs: i(1311)
            };
        },
        function(t, e) {
            t.exports = "down";
        },
        function(t, e) {
            t.exports = "up";
        },
        function(t, e) {
            t.exports = "connected";
        },
        function(t, e) {
            t.exports = "disconnected";
        },
        function(t, e) {
            t.exports = "down";
        },
        function(t, e) {
            t.exports = "up";
        },
        function(t, e, i) {
            var n = i(0), s = i(9), r = i(236), h = i(505), o = i(6), a = i(151), l = i(49), u = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.scene = t.scene, this.settings = this.scene.sys.settings, this.sceneInputPlugin = t, this.enabled = !0, this.target, this.gamepads = [], this.queue = [], this.onGamepadHandler, this._pad1, this._pad2, this._pad3, this._pad4, t.pluginEvents.once(l.BOOT, this.boot, this), t.pluginEvents.on(l.START, this.start, this);
                },
                boot: function() {
                    var t = this.scene.sys.game, e = this.settings.input, i = t.config;
                    this.enabled = o(e, "gamepad", i.inputGamepad) && t.device.input.gamepads, this.target = o(e, "gamepad.target", i.inputGamepadEventTarget), this.sceneInputPlugin.pluginEvents.once(l.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.enabled && (this.startListeners(), this.refreshPads()), this.sceneInputPlugin.pluginEvents.once(l.SHUTDOWN, this.shutdown, this);
                },
                isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                startListeners: function() {
                    function t(t) {
                        !t.defaultPrevented && e.isActive() && (e.refreshPads(), e.queue.push(t));
                    }
                    var e = this, i = this.target;
                    this.onGamepadHandler = t, i.addEventListener("gamepadconnected", t, !1), i.addEventListener("gamepaddisconnected", t, !1), this.sceneInputPlugin.pluginEvents.on(l.UPDATE, this.update, this);
                },
                stopListeners: function() {
                    this.target.removeEventListener("gamepadconnected", this.onGamepadHandler), this.target.removeEventListener("gamepaddisconnected", this.onGamepadHandler), this.sceneInputPlugin.pluginEvents.off(l.UPDATE, this.update);
                    for(var t = 0; t < this.gamepads.length; t++)this.gamepads[t].removeAllListeners();
                },
                disconnectAll: function() {
                    for(var t = 0; t < this.gamepads.length; t++)this.gamepads[t].pad.connected = !1;
                },
                refreshPads: function() {
                    var t = navigator.getGamepads();
                    if (t) for(var e = this.gamepads, i = 0; i < t.length; i++){
                        var n, s, r, o, a = t[i];
                        a && (n = a.id, (r = e[s = a.index]) ? r.id !== n ? (r.destroy(), e[s] = new h(this, a)) : r.update(a) : (o = new h(this, a), e[s] = o, this._pad1 ? this._pad2 ? this._pad3 ? this._pad4 || (this._pad4 = o) : this._pad3 = o : this._pad2 = o : this._pad1 = o));
                    }
                    else this.disconnectAll();
                },
                getAll: function() {
                    for(var t = [], e = this.gamepads, i = 0; i < e.length; i++)e[i] && t.push(e[i]);
                    return t;
                },
                getPad: function(t) {
                    for(var e = this.gamepads, i = 0; i < e.length; i++)if (e[i] && e[i].index === t) return e[i];
                },
                update: function() {
                    if (this.enabled) {
                        this.refreshPads();
                        var t = this.queue.length;
                        if (0 !== t) for(var e = this.queue.splice(0, t), i = 0; i < t; i++){
                            var n = e[i], s = this.getPad(n.gamepad.index);
                            "gamepadconnected" === n.type ? this.emit(r.CONNECTED, s, n) : "gamepaddisconnected" === n.type && this.emit(r.DISCONNECTED, s, n);
                        }
                    }
                },
                shutdown: function() {
                    this.stopListeners(), this.removeAllListeners();
                },
                destroy: function() {
                    this.shutdown();
                    for(var t = 0; t < this.gamepads.length; t++)this.gamepads[t] && this.gamepads[t].destroy();
                    this.gamepads = [], this.scene = null, this.settings = null, this.sceneInputPlugin = null, this.target = null;
                },
                total: {
                    get: function() {
                        return this.gamepads.length;
                    }
                },
                pad1: {
                    get: function() {
                        return this._pad1;
                    }
                },
                pad2: {
                    get: function() {
                        return this._pad2;
                    }
                },
                pad3: {
                    get: function() {
                        return this._pad3;
                    }
                },
                pad4: {
                    get: function() {
                        return this._pad4;
                    }
                }
            });
            a.register("GamepadPlugin", u, "gamepad", "gamepad", "inputGamepad"), t.exports = u;
        },
        function(t, e, i) {
            t.exports = {
                DUALSHOCK_4: i(1312),
                SNES_USB: i(1313),
                XBOX_360: i(1314)
            };
        },
        function(t, e) {
            t.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                SHARE: 8,
                OPTIONS: 9,
                PS: 16,
                TOUCHBAR: 17,
                X: 0,
                CIRCLE: 1,
                SQUARE: 2,
                TRIANGLE: 3,
                L1: 4,
                R1: 5,
                L2: 6,
                R2: 7,
                L3: 10,
                R3: 11,
                LEFT_STICK_H: 0,
                LEFT_STICK_V: 1,
                RIGHT_STICK_H: 2,
                RIGHT_STICK_V: 3
            };
        },
        function(t, e) {
            t.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                SELECT: 8,
                START: 9,
                B: 0,
                A: 1,
                Y: 2,
                X: 3,
                LEFT_SHOULDER: 4,
                RIGHT_SHOULDER: 5
            };
        },
        function(t, e) {
            t.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                MENU: 16,
                A: 0,
                B: 1,
                X: 2,
                Y: 3,
                LB: 4,
                RB: 5,
                LT: 6,
                RT: 7,
                BACK: 8,
                START: 9,
                LS: 10,
                RS: 11,
                LEFT_STICK_H: 0,
                LEFT_STICK_V: 1,
                RIGHT_STICK_H: 2,
                RIGHT_STICK_V: 3
            };
        },
        function(t, e, i) {
            var o = i(62), a = i(63), n = i(0), h = i(200), p = i(502), s = i(501), r = i(48), l = i(108), u = i(109), g = i(49), c = i(9), v = i(2), d = i(55), f = i(151), m = i(7), y = i(24), x = i(10), T = i(56), w = i(21), b = i(82), E = i(112), S = new n({
                Extends: c,
                initialize: function(t) {
                    c.call(this), this.scene = t, this.systems = t.sys, this.settings = t.sys.settings, this.manager = t.sys.game.input, this.pluginEvents = new c, this.enabled = !0, this.displayList, this.cameras, f.install(this), this.mouse = this.manager.mouse, this.topOnly = !0, this.pollRate = -1, this._pollTimer = 0;
                    var e = {
                        cancelled: !1
                    };
                    this._eventContainer = {
                        stopPropagation: function() {
                            e.cancelled = !0;
                        }
                    }, this._eventData = e, this.dragDistanceThreshold = 0, this.dragTimeThreshold = 0, this._temp = [], this._tempZones = [], this._list = [], this._pendingInsertion = [], this._pendingRemoval = [], this._draggable = [], this._drag = {
                        0: [],
                        1: [],
                        2: [],
                        3: [],
                        4: [],
                        5: [],
                        6: [],
                        7: [],
                        8: [],
                        9: [],
                        10: []
                    }, this._dragState = [], this._over = {
                        0: [],
                        1: [],
                        2: [],
                        3: [],
                        4: [],
                        5: [],
                        6: [],
                        7: [],
                        8: [],
                        9: [],
                        10: []
                    }, this._validTypes = [
                        "onDown",
                        "onUp",
                        "onOver",
                        "onOut",
                        "onMove",
                        "onDragStart",
                        "onDrag",
                        "onDragEnd",
                        "onDragEnter",
                        "onDragLeave",
                        "onDragOver",
                        "onDrop"
                    ], this._updatedThisFrame = !1, t.sys.events.once(w.BOOT, this.boot, this), t.sys.events.on(w.START, this.start, this);
                },
                boot: function() {
                    this.cameras = this.systems.cameras, this.displayList = this.systems.displayList, this.systems.events.once(w.DESTROY, this.destroy, this), this.pluginEvents.emit(g.BOOT);
                },
                start: function() {
                    var t = this.systems.events;
                    t.on(w.TRANSITION_START, this.transitionIn, this), t.on(w.TRANSITION_OUT, this.transitionOut, this), t.on(w.TRANSITION_COMPLETE, this.transitionComplete, this), t.on(w.PRE_UPDATE, this.preUpdate, this), t.once(w.SHUTDOWN, this.shutdown, this), this.manager.events.on(g.GAME_OUT, this.onGameOut, this), this.manager.events.on(g.GAME_OVER, this.onGameOver, this), this.enabled = !0, this._dragState = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.pluginEvents.emit(g.START);
                },
                onGameOver: function(t) {
                    this.isActive() && this.emit(g.GAME_OVER, t.timeStamp, t);
                },
                onGameOut: function(t) {
                    this.isActive() && this.emit(g.GAME_OUT, t.timeStamp, t);
                },
                preUpdate: function() {
                    this.pluginEvents.emit(g.PRE_UPDATE);
                    var t = this._pendingRemoval, e = this._pendingInsertion, i = t.length, n = e.length;
                    if (0 !== i || 0 !== n) {
                        for(var s = this._list, r = 0; r < i; r++){
                            var o = t[r], a = s.indexOf(o);
                            -1 < a && (s.splice(a, 1), this.clear(o, !0));
                        }
                        t.length = 0, this._pendingRemoval.length = 0, this._list = s.concat(e.splice(0));
                    }
                },
                isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                updatePoll: function(t, e) {
                    if (!this.isActive()) return !1;
                    if (this.pluginEvents.emit(g.UPDATE, t, e), this._updatedThisFrame) return this._updatedThisFrame = !1;
                    for(var i = this.manager, n = i.pointers, s = i.pointersTotal, r = 0; r < s; r++)n[r].updateMotion();
                    if (0 === this._list.length) return !1;
                    var o = this.pollRate;
                    if (-1 === o) return !1;
                    if (0 < o) {
                        if (this._pollTimer -= e, !(this._pollTimer < 0)) return !1;
                        this._pollTimer = this.pollRate;
                    }
                    var a = !1;
                    for(r = 0; r < s; r++){
                        var h = 0, l = n[r];
                        this._tempZones = [], this._temp = this.hitTestPointer(l), this.sortGameObjects(this._temp, l), this.sortDropZones(this._tempZones), this.topOnly && (this._temp.length && this._temp.splice(1), this._tempZones.length && this._tempZones.splice(1)), h += this.processOverOutEvents(l), 2 === this.getDragState(l) && this.processDragThresholdEvent(l, t), 0 < h && (a = !0);
                    }
                    return a;
                },
                update: function(t, e) {
                    if (!this.isActive()) return !1;
                    for(var i = e.length, n = !1, s = 0; s < i; s++){
                        var r = 0, o = e[s];
                        switch(this._tempZones = [], this._temp = this.hitTestPointer(o), this.sortGameObjects(this._temp, o), this.sortDropZones(this._tempZones), this.topOnly && (this._temp.length && this._temp.splice(1), this._tempZones.length && this._tempZones.splice(1)), t){
                            case h.MOUSE_DOWN:
                                r += this.processDragDownEvent(o), r += this.processDownEvents(o), r += this.processOverOutEvents(o);
                                break;
                            case h.MOUSE_UP:
                                r += this.processDragUpEvent(o), r += this.processUpEvents(o), r += this.processOverOutEvents(o);
                                break;
                            case h.TOUCH_START:
                                r += this.processDragDownEvent(o), r += this.processDownEvents(o), r += this.processOverEvents(o);
                                break;
                            case h.TOUCH_END:
                            case h.TOUCH_CANCEL:
                                r += this.processDragUpEvent(o), r += this.processUpEvents(o), r += this.processOutEvents(o);
                                break;
                            case h.MOUSE_MOVE:
                            case h.TOUCH_MOVE:
                                r += this.processDragMoveEvent(o), r += this.processMoveEvents(o), r += this.processOverOutEvents(o);
                                break;
                            case h.MOUSE_WHEEL:
                                r += this.processWheelEvent(o);
                        }
                        0 < r && (n = !0);
                    }
                    return this._updatedThisFrame = !0, n;
                },
                clear: function(t, e) {
                    void 0 === e && (e = !1);
                    var i = t.input;
                    if (i) {
                        e || this.queueForRemoval(t), i.gameObject = void 0, i.target = void 0, i.hitArea = void 0, i.hitAreaCallback = void 0, i.callbackContext = void 0, t.input = null;
                        var n = this._draggable.indexOf(t);
                        return -1 < n && this._draggable.splice(n, 1), -1 < (n = this._drag[0].indexOf(t)) && this._drag[0].splice(n, 1), -1 < (n = this._over[0].indexOf(t)) && (this._over[0].splice(n, 1), this.manager.resetCursor(i)), t;
                    }
                },
                disable: function(t) {
                    t.input.enabled = !1;
                },
                enable: function(t, e, i, n) {
                    return void 0 === n && (n = !1), t.input ? t.input.enabled = !0 : this.setHitArea(t, e, i), t.input && n && !t.input.dropZone && (t.input.dropZone = n), this;
                },
                hitTestPointer: function(t) {
                    for(var e = this.cameras.getCamerasBelowPointer(t), i = 0; i < e.length; i++){
                        for(var n = e[i], s = this.manager.hitTest(t, this._list, n), r = 0; r < s.length; r++){
                            var o = s[r];
                            o.input.dropZone && this._tempZones.push(o);
                        }
                        if (0 < s.length) return t.camera = n, s;
                    }
                    return t.camera = e[0], [];
                },
                processDownEvents: function(t) {
                    for(var e = 0, i = this._temp, n = this._eventData, s = this._eventContainer, r = n.cancelled = !1, o = 0; o < i.length; o++){
                        var a = i[o];
                        if (a.input) {
                            if (e++, a.emit(g.GAMEOBJECT_POINTER_DOWN, t, a.input.localX, a.input.localY, s), n.cancelled || !a.input) {
                                r = !0;
                                break;
                            }
                            if (this.emit(g.GAMEOBJECT_DOWN, t, a, s), n.cancelled || !a.input) {
                                r = !0;
                                break;
                            }
                        }
                    }
                    return !r && this.manager && (t.downElement === this.manager.game.canvas ? this.emit(g.POINTER_DOWN, t, i) : this.emit(g.POINTER_DOWN_OUTSIDE, t)), e;
                },
                getDragState: function(t) {
                    return this._dragState[t.id];
                },
                setDragState: function(t, e) {
                    this._dragState[t.id] = e;
                },
                processDragThresholdEvent: function(t, e) {
                    var i = !1, n = this.dragTimeThreshold, s = this.dragDistanceThreshold;
                    if ((0 < s && r(t.x, t.y, t.downX, t.downY) >= s || 0 < n && e >= t.downTime + n) && (i = !0), i) return this.setDragState(t, 3), this.processDragStartList(t);
                },
                processDragStartList: function(t) {
                    if (3 !== this.getDragState(t)) return 0;
                    for(var e = this._drag[t.id], i = 0; i < e.length; i++){
                        var n = e[i], s = n.input;
                        s.dragState = 2, s.dragStartX = n.x, s.dragStartY = n.y, s.dragStartXGlobal = t.worldX, s.dragStartYGlobal = t.worldY, s.dragX = s.dragStartXGlobal - s.dragStartX, s.dragY = s.dragStartYGlobal - s.dragStartY, n.emit(g.GAMEOBJECT_DRAG_START, t, s.dragX, s.dragY), this.emit(g.DRAG_START, t, n);
                    }
                    return this.setDragState(t, 4), e.length;
                },
                processDragDownEvent: function(t) {
                    var e = this._temp;
                    if (0 === this._draggable.length || 0 === e.length || !t.primaryDown || 0 !== this.getDragState(t)) return 0;
                    this.setDragState(t, 1);
                    for(var i = [], n = 0; n < e.length; n++){
                        var s = e[n];
                        s.input.draggable && 0 === s.input.dragState && i.push(s);
                    }
                    return 0 === i.length ? (this.setDragState(t, 0), 0) : (1 < i.length && (this.sortGameObjects(i, t), this.topOnly && i.splice(1)), this._drag[t.id] = i, 0 === this.dragDistanceThreshold && 0 === this.dragTimeThreshold ? (this.setDragState(t, 3), this.processDragStartList(t)) : (this.setDragState(t, 2), 0));
                },
                processDragMoveEvent: function(t) {
                    if (2 === this.getDragState(t) && this.processDragThresholdEvent(t, this.manager.game.loop.now), 4 !== this.getDragState(t)) return 0;
                    for(var e = this._tempZones, i = this._drag[t.id], n = 0; n < i.length; n++){
                        var s, r, o, a, h, l, u, c, d = i[n], f = d.input, p = f.target;
                        p ? 0 === (s = e.indexOf(p)) ? (d.emit(g.GAMEOBJECT_DRAG_OVER, t, p), this.emit(g.DRAG_OVER, t, d, p)) : 0 < s ? (d.emit(g.GAMEOBJECT_DRAG_LEAVE, t, p), this.emit(g.DRAG_LEAVE, t, d, p), f.target = e[0], p = f.target, d.emit(g.GAMEOBJECT_DRAG_ENTER, t, p), this.emit(g.DRAG_ENTER, t, d, p)) : (d.emit(g.GAMEOBJECT_DRAG_LEAVE, t, p), this.emit(g.DRAG_LEAVE, t, d, p), e[0] ? (f.target = e[0], p = f.target, d.emit(g.GAMEOBJECT_DRAG_ENTER, t, p), this.emit(g.DRAG_ENTER, t, d, p)) : f.target = null) : !p && e[0] && (f.target = e[0], p = f.target, d.emit(g.GAMEOBJECT_DRAG_ENTER, t, p), this.emit(g.DRAG_ENTER, t, d, p)), o = d.parentContainer ? (a = t.worldX - f.dragStartXGlobal, h = t.worldY - f.dragStartYGlobal, l = d.getParentRotation(), u = a * Math.cos(l) + h * Math.sin(l), c = h * Math.cos(l) - a * Math.sin(l), u *= 1 / d.parentContainer.scaleX, c *= 1 / d.parentContainer.scaleY, r = u + f.dragStartX, c + f.dragStartY) : (r = t.worldX - f.dragX, t.worldY - f.dragY), d.emit(g.GAMEOBJECT_DRAG, t, r, o), this.emit(g.DRAG, t, d, r, o);
                    }
                    return i.length;
                },
                processDragUpEvent: function(t) {
                    for(var e = this._drag[t.id], i = 0; i < e.length; i++){
                        var n, s, r = e[i], o = r.input;
                        o && 2 === o.dragState && (o.dragState = 0, o.dragX = o.localX - r.displayOriginX, o.dragY = o.localY - r.displayOriginY, n = !1, (s = o.target) && (r.emit(g.GAMEOBJECT_DROP, t, s), this.emit(g.DROP, t, r, s), n = (o.target = null, true)), r.input && (r.emit(g.GAMEOBJECT_DRAG_END, t, o.dragX, o.dragY, n), this.emit(g.DRAG_END, t, r, n)));
                    }
                    return this.setDragState(t, 0), e.splice(0), 0;
                },
                processMoveEvents: function(t) {
                    for(var e = 0, i = this._temp, n = this._eventData, s = this._eventContainer, r = n.cancelled = !1, o = 0; o < i.length; o++){
                        var a = i[o];
                        if (a.input) {
                            if (e++, a.emit(g.GAMEOBJECT_POINTER_MOVE, t, a.input.localX, a.input.localY, s), n.cancelled || !a.input) {
                                r = !0;
                                break;
                            }
                            if (this.emit(g.GAMEOBJECT_MOVE, t, a, s), n.cancelled || !a.input) {
                                r = !0;
                                break;
                            }
                            if (this.topOnly) break;
                        }
                    }
                    return r || this.emit(g.POINTER_MOVE, t, i), e;
                },
                processWheelEvent: function(t) {
                    for(var e = 0, i = this._temp, n = this._eventData, s = this._eventContainer, r = n.cancelled = !1, o = t.deltaX, a = t.deltaY, h = t.deltaZ, l = 0; l < i.length; l++){
                        var u = i[l];
                        if (u.input) {
                            if (e++, u.emit(g.GAMEOBJECT_POINTER_WHEEL, t, o, a, h, s), n.cancelled || !u.input) {
                                r = !0;
                                break;
                            }
                            if (this.emit(g.GAMEOBJECT_WHEEL, t, u, o, a, h, s), n.cancelled || !u.input) {
                                r = !0;
                                break;
                            }
                        }
                    }
                    return r || this.emit(g.POINTER_WHEEL, t, i, o, a, h), e;
                },
                processOverEvents: function(t) {
                    var e = this._temp, i = 0, n = e.length, s = [];
                    if (0 < n) {
                        for(var r = this.manager, o = this._eventData, a = this._eventContainer, h = o.cancelled = !1, l = 0; l < n; l++){
                            var u = e[l];
                            if (u.input) {
                                if (s.push(u), r.setCursor(u.input), u.emit(g.GAMEOBJECT_POINTER_OVER, t, u.input.localX, u.input.localY, a), i++, o.cancelled || !u.input) {
                                    h = !0;
                                    break;
                                }
                                if (this.emit(g.GAMEOBJECT_OVER, t, u, a), o.cancelled || !u.input) {
                                    h = !0;
                                    break;
                                }
                            }
                        }
                        h || this.emit(g.POINTER_OVER, t, s);
                    }
                    return this._over[t.id] = s, i;
                },
                processOutEvents: function(t) {
                    var e = this._over[t.id], i = 0, n = e.length;
                    if (0 < n) {
                        var s = this.manager, r = this._eventData, o = this._eventContainer, a = r.cancelled = !1;
                        this.sortGameObjects(e, t);
                        for(var h = 0; h < n; h++){
                            var l = e[h];
                            if ((l = e[h]).input) {
                                if (s.resetCursor(l.input), l.emit(g.GAMEOBJECT_POINTER_OUT, t, o), i++, r.cancelled || !l.input) {
                                    a = !0;
                                    break;
                                }
                                if (this.emit(g.GAMEOBJECT_OUT, t, l, o), r.cancelled || !l.input) {
                                    a = !0;
                                    break;
                                }
                                a || this.emit(g.POINTER_OUT, t, e);
                            }
                        }
                        this._over[t.id] = [];
                    }
                    return i;
                },
                processOverOutEvents: function(t) {
                    for(var e, i = this._temp, n = [], s = [], r = [], o = this._over[t.id], a = this._drag[t.id], h = this.manager, l = 0; l < o.length; l++)e = o[l], -1 === i.indexOf(e) && -1 === a.indexOf(e) ? n.push(e) : r.push(e);
                    for(l = 0; l < i.length; l++)e = i[l], -1 === o.indexOf(e) && s.push(e);
                    var u = n.length, c = 0, d = this._eventData, f = this._eventContainer, p = d.cancelled = !1;
                    if (0 < u) {
                        for(this.sortGameObjects(n, t), l = 0; l < u; l++)if ((e = n[l]).input) {
                            if (h.resetCursor(e.input), e.emit(g.GAMEOBJECT_POINTER_OUT, t, f), c++, d.cancelled || !e.input) {
                                p = !0;
                                break;
                            }
                            if (this.emit(g.GAMEOBJECT_OUT, t, e, f), d.cancelled || !e.input) {
                                p = !0;
                                break;
                            }
                        }
                        p || this.emit(g.POINTER_OUT, t, n);
                    }
                    if (u = s.length, p = d.cancelled = !1, 0 < u) {
                        for(this.sortGameObjects(s, t), l = 0; l < u; l++)if ((e = s[l]).input) {
                            if (h.setCursor(e.input), e.emit(g.GAMEOBJECT_POINTER_OVER, t, e.input.localX, e.input.localY, f), c++, d.cancelled || !e.input) {
                                p = !0;
                                break;
                            }
                            if (this.emit(g.GAMEOBJECT_OVER, t, e, f), d.cancelled || !e.input) {
                                p = !0;
                                break;
                            }
                        }
                        p || this.emit(g.POINTER_OVER, t, s);
                    }
                    return o = r.concat(s), this._over[t.id] = this.sortGameObjects(o, t), c;
                },
                processUpEvents: function(t) {
                    for(var e = this._temp, i = this._eventData, n = this._eventContainer, s = i.cancelled = !1, r = 0; r < e.length; r++){
                        var o = e[r];
                        if (o.input) {
                            if (o.emit(g.GAMEOBJECT_POINTER_UP, t, o.input.localX, o.input.localY, n), i.cancelled || !o.input) {
                                s = !0;
                                break;
                            }
                            if (this.emit(g.GAMEOBJECT_UP, t, o, n), i.cancelled || !o.input) {
                                s = !0;
                                break;
                            }
                        }
                    }
                    return !s && this.manager && (t.upElement === this.manager.game.canvas ? this.emit(g.POINTER_UP, t, e) : this.emit(g.POINTER_UP_OUTSIDE, t)), e.length;
                },
                queueForInsertion: function(t) {
                    return -1 === this._pendingInsertion.indexOf(t) && -1 === this._list.indexOf(t) && this._pendingInsertion.push(t), this;
                },
                queueForRemoval: function(t) {
                    return this._pendingRemoval.push(t), this;
                },
                setDraggable: function(t, e) {
                    void 0 === e && (e = !0), Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        n.input.draggable = e;
                        var s = this._draggable.indexOf(n);
                        e && -1 === s ? this._draggable.push(n) : !e && -1 < s && this._draggable.splice(s, 1);
                    }
                    return this;
                },
                makePixelPerfect: function(t) {
                    void 0 === t && (t = 1);
                    var e = this.systems.textures;
                    return s(e, t);
                },
                setHitArea: function(t, e, i) {
                    if (void 0 === e) return this.setHitAreaFromTexture(t);
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    var n, s, r = !1, o = !1, a = !1, h = !1, l = !1, u = !0;
                    m(e) ? (e = v(n = e, "hitArea", null), i = v(n, "hitAreaCallback", null), r = v(n, "draggable", !1), o = v(n, "dropZone", !1), a = v(n, "cursor", !1), h = v(n, "useHandCursor", !1), l = v(n, "pixelPerfect", !1), s = v(n, "alphaTolerance", 1), l && (e = {}, i = this.makePixelPerfect(s)), e && i || (this.setHitAreaFromTexture(t), u = !1)) : "function" != typeof e || i || (i = e, e = {});
                    for(var c = 0; c < t.length; c++){
                        var d, f = t[c];
                        l && "Container" === f.type ? console.warn("Cannot pixelPerfect test a Container. Use a custom callback.") : ((d = f.input ? f.input : p(f, e, i)).customHitArea = u, d.dropZone = o, d.cursor = h ? "pointer" : a, f.input = d, r && this.setDraggable(f), this.queueForInsertion(f));
                    }
                    return this;
                },
                setHitAreaCircle: function(t, e, i, n, s) {
                    void 0 === s && (s = a);
                    var r = new o(e, i, n);
                    return this.setHitArea(t, r, s);
                },
                setHitAreaEllipse: function(t, e, i, n, s, r) {
                    void 0 === r && (r = u);
                    var o = new l(e, i, n, s);
                    return this.setHitArea(t, o, r);
                },
                setHitAreaFromTexture: function(t, e) {
                    void 0 === e && (e = T), Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i], s = n.frame, r = 0, o = 0;
                        n.width ? (r = n.width, o = n.height) : s && (r = s.realWidth, o = s.realHeight), "Container" !== n.type || 0 !== r && 0 !== o ? 0 !== r && 0 !== o && (n.input = p(n, new x(0, 0, r, o), e), this.queueForInsertion(n)) : console.warn("Container.setInteractive must specify a Shape or call setSize() first");
                    }
                    return this;
                },
                setHitAreaRectangle: function(t, e, i, n, s, r) {
                    void 0 === r && (r = T);
                    var o = new x(e, i, n, s);
                    return this.setHitArea(t, o, r);
                },
                setHitAreaTriangle: function(t, e, i, n, s, r, o, a) {
                    void 0 === a && (a = E);
                    var h = new b(e, i, n, s, r, o);
                    return this.setHitArea(t, h, a);
                },
                enableDebug: function(o, a) {
                    void 0 === a && (a = 65280);
                    var t = o.input;
                    if (!t || !t.hitArea) return this;
                    var e = t.hitArea, i = e.type, h = t.hitAreaDebug, n = this.systems.add, s = this.systems.updateList;
                    h && (s.remove(h), h.destroy(), h = null);
                    var l = 0, u = 0;
                    switch(i){
                        case d.CIRCLE:
                            h = n.arc(0, 0, e.radius), l = e.x - e.radius, u = e.y - e.radius;
                            break;
                        case d.ELLIPSE:
                            h = n.ellipse(0, 0, e.width, e.height), l = e.x - e.width / 2, u = e.y - e.height / 2;
                            break;
                        case d.LINE:
                            h = n.line(0, 0, e.x1, e.y1, e.x2, e.y2);
                            break;
                        case d.POLYGON:
                            h = n.polygon(0, 0, e.points);
                            break;
                        case d.RECTANGLE:
                            h = n.rectangle(0, 0, e.width, e.height), l = e.x, u = e.y;
                            break;
                        case d.TRIANGLE:
                            h = n.triangle(0, 0, e.x1, e.y1, e.x2, e.y2, e.x3, e.y3);
                    }
                    return h && (h.isFilled = !1, h.preUpdate = function() {
                        h.setStrokeStyle(1 / o.scale, a), h.setDisplayOrigin(o.displayOriginX, o.displayOriginY);
                        var t, e = o.x, i = o.y, n = o.rotation, s = o.scaleX, r = o.scaleY;
                        o.parentContainer && (e = (t = o.getWorldTransformMatrix()).tx, i = t.ty, n = t.rotation, s = t.scaleX, r = t.scaleY), h.setRotation(n), h.setScale(s, r), h.setPosition(e + l, i + u), h.setScrollFactor(o.scrollFactorX, o.scrollFactorY), h.setDepth(o.depth);
                    }, s.add(h), t.hitAreaDebug = h), this;
                },
                removeDebug: function(t) {
                    var e, i = t.input;
                    return i && i.hitAreaDebug && (e = i.hitAreaDebug, this.systems.updateList.remove(e), e.destroy(), i.hitAreaDebug = null), this;
                },
                setPollAlways: function() {
                    return this.setPollRate(0);
                },
                setPollOnMove: function() {
                    return this.setPollRate(-1);
                },
                setPollRate: function(t) {
                    return this.pollRate = t, this._pollTimer = 0, this;
                },
                setGlobalTopOnly: function(t) {
                    return this.manager.globalTopOnly = t, this;
                },
                setTopOnly: function(t) {
                    return this.topOnly = t, this;
                },
                sortGameObjects: function(t, e) {
                    if (t.length < 2) return t;
                    var i = e.camera.renderList;
                    return t.sort(function(t, e) {
                        return i.indexOf(e) - i.indexOf(t);
                    });
                },
                sortDropZones: function(t) {
                    return t.length < 2 ? t : (this.scene.sys.depthSort(), t.sort(this.sortDropZoneHandler.bind(this)));
                },
                sortDropZoneHandler: function(t, e) {
                    if (t.parentContainer || e.parentContainer) {
                        if (t.parentContainer === e.parentContainer) return e.parentContainer.getIndex(e) - t.parentContainer.getIndex(t);
                        if (t.parentContainer === e) return -1;
                        if (e.parentContainer === t) return 1;
                        for(var i = t.getIndexList(), n = e.getIndexList(), s = Math.min(i.length, n.length), r = 0; r < s; r++){
                            var o = i[r], a = n[r];
                            if (o !== a) return a - o;
                        }
                        return n.length - i.length;
                    }
                    return this.displayList.getIndex(e) - this.displayList.getIndex(t);
                },
                stopPropagation: function() {
                    return this.manager._tempSkip = !0, this;
                },
                addPointer: function(t) {
                    return this.manager.addPointer(t);
                },
                setDefaultCursor: function(t) {
                    return this.manager.setDefaultCursor(t), this;
                },
                transitionIn: function() {
                    this.enabled = this.settings.transitionAllowInput;
                },
                transitionComplete: function() {
                    this.settings.transitionAllowInput || (this.enabled = !0);
                },
                transitionOut: function() {
                    this.enabled = this.settings.transitionAllowInput;
                },
                shutdown: function() {
                    this.pluginEvents.emit(g.SHUTDOWN), this._temp.length = 0, this._list.length = 0, this._draggable.length = 0, this._pendingRemoval.length = 0, this._pendingInsertion.length = 0;
                    for(var t = this._dragState.length = 0; t < 10; t++)this._drag[t] = [], this._over[t] = [];
                    this.removeAllListeners();
                    var e = this.manager;
                    e.canvas.style.cursor = e.defaultCursor;
                    var i = this.systems.events;
                    i.off(w.TRANSITION_START, this.transitionIn, this), i.off(w.TRANSITION_OUT, this.transitionOut, this), i.off(w.TRANSITION_COMPLETE, this.transitionComplete, this), i.off(w.PRE_UPDATE, this.preUpdate, this), e.events.off(g.GAME_OUT, this.onGameOut, this), e.events.off(g.GAME_OVER, this.onGameOver, this), i.off(w.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.pluginEvents.emit(g.DESTROY), this.pluginEvents.removeAllListeners(), this.scene.sys.events.off(w.START, this.start, this), this.scene = null, this.cameras = null, this.manager = null, this.events = null, this.mouse = null;
                },
                x: {
                    get: function() {
                        return this.manager.activePointer.x;
                    }
                },
                y: {
                    get: function() {
                        return this.manager.activePointer.y;
                    }
                },
                isOver: {
                    get: function() {
                        return this.manager.isOver;
                    }
                },
                mousePointer: {
                    get: function() {
                        return this.manager.mousePointer;
                    }
                },
                activePointer: {
                    get: function() {
                        return this.manager.activePointer;
                    }
                },
                pointer1: {
                    get: function() {
                        return this.manager.pointers[1];
                    }
                },
                pointer2: {
                    get: function() {
                        return this.manager.pointers[2];
                    }
                },
                pointer3: {
                    get: function() {
                        return this.manager.pointers[3];
                    }
                },
                pointer4: {
                    get: function() {
                        return this.manager.pointers[4];
                    }
                },
                pointer5: {
                    get: function() {
                        return this.manager.pointers[5];
                    }
                },
                pointer6: {
                    get: function() {
                        return this.manager.pointers[6];
                    }
                },
                pointer7: {
                    get: function() {
                        return this.manager.pointers[7];
                    }
                },
                pointer8: {
                    get: function() {
                        return this.manager.pointers[8];
                    }
                },
                pointer9: {
                    get: function() {
                        return this.manager.pointers[9];
                    }
                },
                pointer10: {
                    get: function() {
                        return this.manager.pointers[10];
                    }
                }
            });
            y.register("InputPlugin", S, "input"), t.exports = S;
        },
        function(t, e, i) {
            t.exports = {
                Events: i(152),
                KeyboardManager: i(404),
                KeyboardPlugin: i(1324),
                Key: i(506),
                KeyCodes: i(141),
                KeyCombo: i(507),
                AdvanceKeyCombo: i(509),
                ProcessKeyCombo: i(508),
                ResetKeyCombo: i(510),
                JustDown: i(1326),
                JustUp: i(1327),
                DownDuration: i(1328),
                UpDuration: i(1329)
            };
        },
        function(t, e) {
            t.exports = "keydown";
        },
        function(t, e) {
            t.exports = "keyup";
        },
        function(t, e) {
            t.exports = "keycombomatch";
        },
        function(t, e) {
            t.exports = "down";
        },
        function(t, e) {
            t.exports = "keydown-";
        },
        function(t, e) {
            t.exports = "keyup-";
        },
        function(t, e) {
            t.exports = "up";
        },
        function(t, e, i) {
            var n = i(0), s = i(9), h = i(152), r = i(22), o = i(6), a = i(49), l = i(151), u = i(506), c = i(141), d = i(507), f = i(1325), p = i(21), g = i(76), v = new n({
                Extends: s,
                initialize: function(t) {
                    s.call(this), this.game = t.systems.game, this.scene = t.scene, this.settings = this.scene.sys.settings, this.sceneInputPlugin = t, this.manager = t.manager.keyboard, this.enabled = !0, this.keys = [], this.combos = [], this.prevCode = null, this.prevTime = 0, this.prevType = null, t.pluginEvents.once(a.BOOT, this.boot, this), t.pluginEvents.on(a.START, this.start, this);
                },
                boot: function() {
                    var t = this.settings.input;
                    this.enabled = o(t, "keyboard", !0);
                    var e = o(t, "keyboard.capture", null);
                    e && this.addCaptures(e), this.sceneInputPlugin.pluginEvents.once(a.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.sceneInputPlugin.manager.events.on(a.MANAGER_PROCESS, this.update, this), this.sceneInputPlugin.pluginEvents.once(a.SHUTDOWN, this.shutdown, this), this.game.events.on(r.BLUR, this.resetKeys, this), this.scene.sys.events.on(p.PAUSE, this.resetKeys, this), this.scene.sys.events.on(p.SLEEP, this.resetKeys, this);
                },
                isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                addCapture: function(t) {
                    return this.manager.addCapture(t), this;
                },
                removeCapture: function(t) {
                    return this.manager.removeCapture(t), this;
                },
                getCaptures: function() {
                    return this.manager.captures;
                },
                enableGlobalCapture: function() {
                    return this.manager.preventDefault = !0, this;
                },
                disableGlobalCapture: function() {
                    return this.manager.preventDefault = !1, this;
                },
                clearCaptures: function() {
                    return this.manager.clearCaptures(), this;
                },
                createCursorKeys: function() {
                    return this.addKeys({
                        up: c.UP,
                        down: c.DOWN,
                        left: c.LEFT,
                        right: c.RIGHT,
                        space: c.SPACE,
                        shift: c.SHIFT
                    });
                },
                addKeys: function(t, e, i) {
                    void 0 === e && (e = !0), void 0 === i && (i = !1);
                    var n = {};
                    if ("string" == typeof t) {
                        t = t.split(",");
                        for(var s = 0; s < t.length; s++){
                            var r = t[s].trim();
                            r && (n[r] = this.addKey(r, e, i));
                        }
                    } else for(var o in t)n[o] = this.addKey(t[o], e, i);
                    return n;
                },
                addKey: function(t, e, i) {
                    void 0 === e && (e = !0), void 0 === i && (i = !1);
                    var n = this.keys;
                    if (t instanceof u) {
                        var s = n.indexOf(t);
                        return -1 < s ? n[s] = t : n[t.keyCode] = t, e && this.addCapture(t.keyCode), t.setEmitOnRepeat(i), t;
                    }
                    return "string" == typeof t && (t = c[t.toUpperCase()]), n[t] || (n[t] = new u(this, t), e && this.addCapture(t), n[t].setEmitOnRepeat(i)), n[t];
                },
                removeKey: function(t, e) {
                    void 0 === e && (e = !1);
                    var i, n, s = this.keys;
                    return t instanceof u ? -1 < (n = s.indexOf(t)) && (i = this.keys[n], this.keys[n] = void 0) : "string" == typeof t && (t = c[t.toUpperCase()]), s[t] && (i = s[t], s[t] = void 0), i && (i.plugin = null, e && i.destroy()), this;
                },
                removeAllKeys: function(t) {
                    for(var e = this.keys, i = 0; i < e.length; i++){
                        var n = e[i];
                        n && (e[i] = void 0, t && n.destroy());
                    }
                    return this;
                },
                createCombo: function(t, e) {
                    return new d(this, t, e);
                },
                checkDown: function(t, e) {
                    if (void 0 === e && (e = 0), this.enabled && t.isDown) {
                        var i = g(this.time - t.timeDown, e);
                        if (i > t._tick) return t._tick = i, !0;
                    }
                    return !1;
                },
                update: function() {
                    var t = this.manager.queue, e = t.length;
                    if (this.isActive() && 0 !== e) for(var i = this.keys, n = 0; n < e; n++){
                        var s = t[n], r = s.keyCode, o = i[r], a = !1;
                        void 0 === s.cancelled && (s.cancelled = 0, s.stopImmediatePropagation = function() {
                            s.cancelled = 1;
                        }, s.stopPropagation = function() {
                            s.cancelled = -1;
                        }), -1 !== s.cancelled && (r === this.prevCode && s.timeStamp === this.prevTime && s.type === this.prevType || (this.prevCode = r, this.prevTime = s.timeStamp, this.prevType = s.type, "keydown" === s.type ? (o && (a = o.isDown, o.onDown(s)), s.cancelled || o && a || (f[r] && this.emit(h.KEY_DOWN + f[r], s), s.cancelled || this.emit(h.ANY_KEY_DOWN, s))) : (o && o.onUp(s), s.cancelled || (f[r] && this.emit(h.KEY_UP + f[r], s), s.cancelled || this.emit(h.ANY_KEY_UP, s))), 1 === s.cancelled && (s.cancelled = 0)));
                    }
                },
                resetKeys: function() {
                    for(var t = this.keys, e = 0; e < t.length; e++)t[e] && t[e].reset();
                    return this;
                },
                shutdown: function() {
                    this.resetKeys(), this.sceneInputPlugin.manager.events.off(a.MANAGER_PROCESS, this.update, this), this.game.events.off(r.BLUR, this.resetKeys), this.scene.sys.events.off(p.PAUSE, this.resetKeys, this), this.scene.sys.events.off(p.SLEEP, this.resetKeys, this), this.removeAllListeners(), this.queue = [];
                },
                destroy: function() {
                    this.shutdown();
                    for(var t = this.keys, e = 0; e < t.length; e++)t[e] && t[e].destroy();
                    this.keys = [], this.combos = [], this.queue = [], this.scene = null, this.settings = null, this.sceneInputPlugin = null, this.manager = null;
                },
                time: {
                    get: function() {
                        return this.sceneInputPlugin.manager.time;
                    }
                }
            });
            l.register("KeyboardPlugin", v, "keyboard", "keyboard", "inputKeyboard"), t.exports = v;
        },
        function(t, e, i) {
            var n = i(141), s = {};
            for(var r in n)s[n[r]] = r;
            t.exports = s;
        },
        function(t, e) {
            t.exports = function(t) {
                return !!t._justDown && (t._justDown = !1, true);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return !!t._justUp && (t._justUp = !1, true);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 50);
                var i = t.plugin.game.loop.time - t.timeDown;
                return t.isDown && i < e;
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                void 0 === e && (e = 50);
                var i = t.plugin.game.loop.time - t.timeUp;
                return t.isUp && i < e;
            };
        },
        function(t, e, i) {
            t.exports = {
                MouseManager: i(405)
            };
        },
        function(t, e, i) {
            t.exports = {
                TouchManager: i(407)
            };
        },
        function(t, e, i) {
            var n = i(20), s = i(17)(!1, s = {
                Events: i(91),
                FileTypes: i(1333),
                File: i(23),
                FileTypesManager: i(8),
                GetURL: i(153),
                LoaderPlugin: i(1359),
                MergeXHRSettings: i(237),
                MultiFile: i(47),
                XHRLoader: i(511),
                XHRSettings: i(154)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            t.exports = {
                AnimationJSONFile: i(1334),
                AsepriteFile: i(1335),
                AtlasJSONFile: i(1336),
                AtlasXMLFile: i(1337),
                AudioFile: i(512),
                AudioSpriteFile: i(1338),
                BinaryFile: i(1339),
                BitmapFontFile: i(1340),
                CSSFile: i(1341),
                GLSLFile: i(1342),
                HTML5AudioFile: i(513),
                HTMLFile: i(1343),
                HTMLTextureFile: i(1344),
                ImageFile: i(70),
                JSONFile: i(59),
                MultiAtlasFile: i(1345),
                MultiScriptFile: i(1346),
                OBJFile: i(1347),
                PackFile: i(1348),
                PluginFile: i(1349),
                SceneFile: i(1350),
                ScenePluginFile: i(1351),
                ScriptFile: i(514),
                SpriteSheetFile: i(1352),
                SVGFile: i(1353),
                TextFile: i(239),
                TilemapCSVFile: i(1354),
                TilemapImpactFile: i(1355),
                TilemapJSONFile: i(1356),
                UnityAtlasFile: i(1357),
                VideoFile: i(1358),
                XMLFile: i(238)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(8), r = i(59), o = i(91), a = new n({
                Extends: r,
                initialize: function(t, e, i, n, s) {
                    r.call(this, t, e, i, n, s), this.type = "animationJSON";
                },
                onProcess: function() {
                    this.loader.once(o.POST_PROCESS, this.onLoadComplete, this), r.prototype.onProcess.call(this);
                },
                onLoadComplete: function() {
                    this.loader.systems.anims.fromJSON(this.data);
                }
            });
            s.register("animation", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new a(this, t[s]));
                else this.addFile(new a(this, t, e, n, i));
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), l = i(2), u = i(70), c = i(7), d = i(59), f = i(47), a = new n({
                Extends: f,
                initialize: function(t, e, i, n, s, r) {
                    var o, a, h = c(e) ? (e = l(a = e, "key"), o = new u(t, {
                        key: e,
                        url: l(a, "textureURL"),
                        extension: l(a, "textureExtension", "png"),
                        normalMap: l(a, "normalMap"),
                        xhrSettings: l(a, "textureXhrSettings")
                    }), new d(t, {
                        key: e,
                        url: l(a, "atlasURL"),
                        extension: l(a, "atlasExtension", "json"),
                        xhrSettings: l(a, "atlasXhrSettings")
                    })) : (o = new u(t, e, i, s), new d(t, e, n, r));
                    o.linkFile ? f.call(this, t, "atlasjson", e, [
                        o,
                        h,
                        o.linkFile
                    ]) : f.call(this, t, "atlasjson", e, [
                        o,
                        h
                    ]);
                },
                addToCache: function() {
                    var t, e, i;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], i = this.files[2] ? this.files[2].data : null, this.loader.textureManager.addAtlas(t.key, t.data, e.data, i), e.addToCache(), this.complete = !0);
                }
            });
            s.register("aseprite", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), l = i(2), u = i(70), c = i(7), d = i(59), f = i(47), a = new n({
                Extends: f,
                initialize: function(t, e, i, n, s, r) {
                    var o, a, h = c(e) ? (e = l(a = e, "key"), o = new u(t, {
                        key: e,
                        url: l(a, "textureURL"),
                        extension: l(a, "textureExtension", "png"),
                        normalMap: l(a, "normalMap"),
                        xhrSettings: l(a, "textureXhrSettings")
                    }), new d(t, {
                        key: e,
                        url: l(a, "atlasURL"),
                        extension: l(a, "atlasExtension", "json"),
                        xhrSettings: l(a, "atlasXhrSettings")
                    })) : (o = new u(t, e, i, s), new d(t, e, n, r));
                    o.linkFile ? f.call(this, t, "atlasjson", e, [
                        o,
                        h,
                        o.linkFile
                    ]) : f.call(this, t, "atlasjson", e, [
                        o,
                        h
                    ]);
                },
                addToCache: function() {
                    var t, e, i;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], i = this.files[2] ? this.files[2].data : null, this.loader.textureManager.addAtlas(t.key, t.data, e.data, i), e.pendingDestroy(), this.complete = !0);
                }
            });
            s.register("atlas", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), l = i(2), u = i(70), c = i(7), d = i(47), f = i(238), a = new n({
                Extends: d,
                initialize: function(t, e, i, n, s, r) {
                    var o, a, h = c(e) ? (e = l(a = e, "key"), o = new u(t, {
                        key: e,
                        url: l(a, "textureURL"),
                        extension: l(a, "textureExtension", "png"),
                        normalMap: l(a, "normalMap"),
                        xhrSettings: l(a, "textureXhrSettings")
                    }), new f(t, {
                        key: e,
                        url: l(a, "atlasURL"),
                        extension: l(a, "atlasExtension", "xml"),
                        xhrSettings: l(a, "atlasXhrSettings")
                    })) : (o = new u(t, e, i, s), new f(t, e, n, r));
                    o.linkFile ? d.call(this, t, "atlasxml", e, [
                        o,
                        h,
                        o.linkFile
                    ]) : d.call(this, t, "atlasxml", e, [
                        o,
                        h
                    ]);
                },
                addToCache: function() {
                    var t, e, i;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], i = this.files[2] ? this.files[2].data : null, this.loader.textureManager.addAtlasXML(t.key, t.data, e.data, i), e.pendingDestroy(), this.complete = !0);
                }
            });
            s.register("atlasXML", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var u = i(512), n = i(0), s = i(8), c = i(2), d = i(7), f = i(59), p = i(47), g = new n({
                Extends: p,
                initialize: function(t, e, i, n, s, r, o) {
                    var a, h, l;
                    d(e) && (e = c(a = e, "key"), i = c(a, "jsonURL"), n = c(a, "audioURL"), s = c(a, "audioConfig"), r = c(a, "audioXhrSettings"), o = c(a, "jsonXhrSettings")), n ? (l = u.create(t, e, n, s, r)) && (h = new f(t, e, i, o), p.call(this, t, "audiosprite", e, [
                        l,
                        h
                    ]), this.config.resourceLoad = !1) : (h = new f(t, e, i, o), p.call(this, t, "audiosprite", e, [
                        h
                    ]), this.config.resourceLoad = !0, this.config.audioConfig = s, this.config.audioXhrSettings = r);
                },
                onFileComplete: function(t) {
                    var e, i, n, s;
                    -1 !== this.files.indexOf(t) && (this.pending--, this.config.resourceLoad && "json" === t.type && t.data.hasOwnProperty("resources") && (e = t.data.resources, i = c(this.config, "audioConfig"), n = c(this.config, "audioXhrSettings"), (s = u.create(this.loader, t.key, e, i, n)) && (this.addToMultiFile(s), this.loader.addFile(s))));
                },
                addToCache: function() {
                    var t, e;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], t.addToCache(), e.addToCache(), this.complete = !0);
                }
            });
            s.register("audioSprite", function(t, e, i, n, s, r) {
                var o, a = this.systems.game, h = a.config.audio, l = a.device.audio;
                if (h && h.noAudio || !l.webAudio && !l.audioData) return this;
                if (Array.isArray(t)) for(var u = 0; u < t.length; u++)(o = new g(this, t[u])).files && this.addFile(o.files);
                else (o = new g(this, t, e, i, n, s, r)).files && this.addFile(o.files);
                return this;
            });
        },
        function(t, e, i) {
            var n = i(0), s = i(20), h = i(23), r = i(8), l = i(2), u = i(7), o = new n({
                Extends: h,
                initialize: function(t, e, i, n, s) {
                    var r, o = "bin";
                    u(e) && (e = l(r = e, "key"), i = l(r, "url"), n = l(r, "xhrSettings"), o = l(r, "extension", o), s = l(r, "dataType", s));
                    var a = {
                        type: "binary",
                        cache: t.cacheManager.binary,
                        extension: o,
                        responseType: "arraybuffer",
                        key: e,
                        url: i,
                        xhrSettings: n,
                        config: {
                            dataType: s
                        }
                    };
                    h.call(this, t, a);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING;
                    var t = this.config.dataType;
                    this.data = t ? new t(this.xhrLoader.response) : this.xhrLoader.response, this.onProcessComplete();
                }
            });
            r.register("binary", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new o(this, t[s]));
                else this.addFile(new o(this, t, e, n, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), l = i(2), u = i(70), c = i(7), d = i(47), r = i(209), f = i(238), a = new n({
                Extends: d,
                initialize: function(t, e, i, n, s, r) {
                    var o, a, h = c(e) ? (e = l(a = e, "key"), o = new u(t, {
                        key: e,
                        url: l(a, "textureURL"),
                        extension: l(a, "textureExtension", "png"),
                        normalMap: l(a, "normalMap"),
                        xhrSettings: l(a, "textureXhrSettings")
                    }), new f(t, {
                        key: e,
                        url: l(a, "fontDataURL"),
                        extension: l(a, "fontDataExtension", "xml"),
                        xhrSettings: l(a, "fontDataXhrSettings")
                    })) : (o = new u(t, e, i, s), new f(t, e, n, r));
                    o.linkFile ? d.call(this, t, "bitmapfont", e, [
                        o,
                        h,
                        o.linkFile
                    ]) : d.call(this, t, "bitmapfont", e, [
                        o,
                        h
                    ]);
                },
                addToCache: function() {
                    var t, e, i, n;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], t.addToCache(), e.pendingDestroy(), i = t.cache.get(t.key), n = r(e.data, t.cache.getFrame(t.key), 0, 0, i), this.loader.cacheManager.bitmapFont.add(t.key, {
                        data: n,
                        texture: t.key,
                        frame: null
                    }), this.complete = !0);
                }
            });
            s.register("bitmapFont", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), h = i(2), l = i(7), o = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    var s, r = "css";
                    l(e) && (e = h(s = e, "key"), i = h(s, "url"), n = h(s, "xhrSettings"), r = h(s, "extension", r));
                    var o = {
                        type: "script",
                        cache: !1,
                        extension: r,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    a.call(this, t, o);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = document.createElement("style"), this.data.defer = !1, this.data.innerHTML = this.xhrLoader.responseText, document.head.appendChild(this.data), this.onProcessComplete();
                }
            });
            r.register("css", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), h = i(23), r = i(8), l = i(2), u = i(7), a = i(390), o = new n({
                Extends: h,
                initialize: function(t, e, i, n, s) {
                    var r, o = "glsl";
                    u(e) ? (e = l(r = e, "key"), i = l(r, "url"), n = l(r, "shaderType", "fragment"), s = l(r, "xhrSettings"), o = l(r, "extension", o)) : void 0 === n && (n = "fragment");
                    var a = {
                        type: "glsl",
                        cache: t.cacheManager.shader,
                        extension: o,
                        responseType: "text",
                        key: e,
                        url: i,
                        config: {
                            shaderType: n
                        },
                        xhrSettings: s
                    };
                    h.call(this, t, a);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = this.xhrLoader.responseText, this.onProcessComplete();
                },
                addToCache: function() {
                    var t = this.data.split("\n"), e = this.extractBlock(t, 0);
                    if (e) for(; e;){
                        var i, n = this.getShaderName(e.header), s = this.getShaderType(e.header), r = this.getShaderUniforms(e.header), o = e.shader;
                        this.cache.has(n) ? (i = this.cache.get(n), "fragment" === s ? i.fragmentSrc = o : i.vertexSrc = o, i.uniforms || (i.uniforms = r)) : "fragment" === s ? this.cache.add(n, new a(n, o, "", r)) : this.cache.add(n, new a(n, "", o, r)), e = this.extractBlock(t, e.offset);
                    }
                    else "fragment" === this.config.shaderType ? this.cache.add(this.key, new a(this.key, this.data)) : this.cache.add(this.key, new a(this.key, "", this.data));
                    this.pendingDestroy();
                },
                getShaderName: function(t) {
                    for(var e = 0; e < t.length; e++){
                        var i = t[e].trim();
                        if ("name:" === i.substring(0, 5)) return i.substring(5).trim();
                    }
                    return this.key;
                },
                getShaderType: function(t) {
                    for(var e = 0; e < t.length; e++){
                        var i = t[e].trim();
                        if ("type:" === i.substring(0, 5)) return i.substring(5).trim();
                    }
                    return this.config.shaderType;
                },
                getShaderUniforms: function(t) {
                    for(var e = {}, i = 0; i < t.length; i++){
                        var n = t[i].trim();
                        if ("uniform." === n.substring(0, 8)) {
                            var s = n.indexOf(":");
                            if (s) {
                                var r = n.substring(8, s);
                                try {
                                    e[r] = JSON.parse(n.substring(s + 1));
                                } catch (t) {
                                    console.warn("Invalid uniform JSON: " + r);
                                }
                            }
                        }
                    }
                    return e;
                },
                extractBlock: function(t, e) {
                    for(var i = -1, n = -1, s = -1, r = !1, o = !1, a = [], h = [], l = e; l < t.length; l++){
                        var u = t[l].trim();
                        if ("---" === u) {
                            if (-1 === i) i = l, r = !0;
                            else {
                                if (!r) {
                                    o = !1;
                                    break;
                                }
                                n = l, o = (r = !1, true);
                            }
                        } else r ? a.push(u) : o && (h.push(u), s = l);
                    }
                    return r || -1 === n ? null : {
                        header: a,
                        shader: h.join("\n"),
                        offset: s
                    };
                }
            });
            r.register("glsl", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new o(this, t[s]));
                else this.addFile(new o(this, t, e, i, n));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), h = i(2), l = i(7), o = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    var s, r = "html";
                    l(e) && (e = h(s = e, "key"), i = h(s, "url"), n = h(s, "xhrSettings"), r = h(s, "extension", r));
                    var o = {
                        type: "text",
                        cache: t.cacheManager.html,
                        extension: r,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    a.call(this, t, o);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = this.xhrLoader.responseText, this.onProcessComplete();
                }
            });
            r.register("html", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), o = i(20), l = i(23), s = i(8), u = i(2), c = i(7), a = new n({
                Extends: l,
                initialize: function(t, e, i, n, s, r) {
                    void 0 === n && (n = 512), void 0 === s && (s = 512);
                    var o, a = "html";
                    c(e) && (e = u(o = e, "key"), i = u(o, "url"), r = u(o, "xhrSettings"), a = u(o, "extension", a), n = u(o, "width", n), s = u(o, "height", s));
                    var h = {
                        type: "html",
                        cache: t.textureManager,
                        extension: a,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: r,
                        config: {
                            width: n,
                            height: s
                        }
                    };
                    l.call(this, t, h);
                },
                onProcess: function() {
                    this.state = o.FILE_PROCESSING;
                    var t = this.config.width, e = this.config.height, i = [];
                    i.push('<svg width="' + t + 'px" height="' + e + 'px" viewBox="0 0 ' + t + " " + e + '" xmlns="http://www.w3.org/2000/svg">'), i.push('<foreignObject width="100%" height="100%">'), i.push('<body xmlns="http://www.w3.org/1999/xhtml">'), i.push(this.xhrLoader.responseText), i.push("</body>"), i.push("</foreignObject>"), i.push("</svg>");
                    var n = [
                        i.join("\n")
                    ], s = this;
                    try {
                        var r = new window.Blob(n, {
                            type: "image/svg+xml;charset=utf-8"
                        });
                    } catch (t) {
                        return s.state = o.FILE_ERRORED, void s.onProcessComplete();
                    }
                    this.data = new Image, this.data.crossOrigin = this.crossOrigin, this.data.onload = function() {
                        l.revokeObjectURL(s.data), s.onProcessComplete();
                    }, this.data.onerror = function() {
                        l.revokeObjectURL(s.data), s.onProcessError();
                    }, l.createObjectURL(this.data, r, "image/svg+xml");
                },
                addToCache: function() {
                    var t = this.cache.addImage(this.key, this.data);
                    this.pendingDestroy(t);
                }
            });
            s.register("htmlTexture", function(t, e, i, n, s) {
                if (Array.isArray(t)) for(var r = 0; r < t.length; r++)this.addFile(new a(this, t[r]));
                else this.addFile(new a(this, t, e, i, n, s));
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), v = i(2), m = i(70), l = i(7), u = i(59), c = i(47), a = new n({
                Extends: c,
                initialize: function(t, e, i, n, s, r, o) {
                    var a;
                    l(e) && (e = v(a = e, "key"), i = v(a, "url", !1) ? v(a, "url") : v(a, "atlasURL"), r = v(a, "xhrSettings"), n = v(a, "path"), s = v(a, "baseURL"), o = v(a, "textureXhrSettings"));
                    var h = new u(t, e, i, r);
                    c.call(this, t, "multiatlas", e, [
                        h
                    ]), this.config.path = n, this.config.baseURL = s, this.config.textureXhrSettings = o;
                },
                onFileComplete: function(t) {
                    if (-1 !== this.files.indexOf(t) && (this.pending--, "json" === t.type && t.data.hasOwnProperty("textures"))) {
                        var e = t.data.textures, i = this.config, n = this.loader, s = n.baseURL, r = n.path, o = n.prefix, a = v(i, "baseURL", this.baseURL), h = v(i, "path", this.path), l = v(i, "prefix", this.prefix), u = v(i, "textureXhrSettings");
                        n.setBaseURL(a), n.setPath(h), n.setPrefix(l);
                        for(var c = 0; c < e.length; c++){
                            var d, f = e[c].image, p = "MA" + this.multiKeyIndex + "_" + f, g = new m(n, p, f, u);
                            this.addToMultiFile(g), n.addFile(g), e[c].normalMap && ((d = new m(n, p, e[c].normalMap, u)).type = "normalMap", g.setLink(d), this.addToMultiFile(d), n.addFile(d));
                        }
                        n.setBaseURL(s), n.setPath(r), n.setPrefix(o);
                    }
                },
                addToCache: function() {
                    if (this.isReadyToProcess()) {
                        for(var t = this.files[0], e = [], i = [], n = [], s = 1; s < this.files.length; s++){
                            var r = this.files[s];
                            if ("normalMap" !== r.type) for(var o = r.key.indexOf("_"), a = r.key.substr(o + 1), h = r.data, l = 0; l < t.data.textures.length; l++){
                                var u = t.data.textures[l];
                                if (u.image === a) {
                                    i.push(h), e.push(u), r.linkFile && n.push(r.linkFile.data);
                                    break;
                                }
                            }
                        }
                        for(0 === n.length && (n = void 0), this.loader.textureManager.addAtlasJSONArray(this.key, i, e, n), this.complete = !0, s = 0; s < this.files.length; s++)this.files[s].pendingDestroy();
                    }
                }
            });
            s.register("multiatlas", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), l = i(2), u = i(7), c = i(47), d = i(514), r = new n({
                Extends: c,
                initialize: function(t, e, i, n) {
                    var s, r = "js", o = [];
                    u(e) && (e = l(s = e, "key"), i = l(s, "url"), n = l(s, "xhrSettings"), r = l(s, "extension", r)), Array.isArray(i) || (i = [
                        i
                    ]);
                    for(var a = 0; a < i.length; a++){
                        var h = new d(t, {
                            key: e + "_" + a.toString(),
                            url: i[a],
                            extension: r,
                            xhrSettings: n
                        });
                        h.onProcess = function() {
                            this.onProcessComplete();
                        }, o.push(h);
                    }
                    c.call(this, t, "scripts", e, o);
                },
                addToCache: function() {
                    if (this.isReadyToProcess()) {
                        for(var t = 0; t < this.files.length; t++){
                            var e = this.files[t];
                            e.data = document.createElement("script"), e.data.language = "javascript", e.data.type = "text/javascript", e.data.defer = !1, e.data.text = e.xhrLoader.responseText, document.head.appendChild(e.data);
                        }
                        this.complete = !0;
                    }
                }
            });
            s.register("scripts", function(t, e, i) {
                var n;
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)n = new r(this, t[s]), this.addFile(n.files);
                else n = new r(this, t, e, i), this.addFile(n.files);
                return this;
            }), t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), u = i(2), c = i(7), d = i(47), r = i(492), o = i(493), f = i(239), a = new n({
                Extends: d,
                initialize: function(t, e, i, n, s, r) {
                    var o, a, h, l = t.cacheManager.obj;
                    c(e) ? (e = u(h = e, "key"), o = new f(t, {
                        key: e,
                        type: "obj",
                        cache: l,
                        url: u(h, "url"),
                        extension: u(h, "extension", "obj"),
                        xhrSettings: u(h, "xhrSettings"),
                        config: {
                            flipUV: u(h, "flipUV", s)
                        }
                    }), (n = u(h, "matURL")) && (a = new f(t, {
                        key: e,
                        type: "mat",
                        cache: l,
                        url: n,
                        extension: u(h, "matExtension", "mat"),
                        xhrSettings: u(h, "xhrSettings")
                    }))) : (o = new f(t, {
                        key: e,
                        url: i,
                        type: "obj",
                        cache: l,
                        extension: "obj",
                        xhrSettings: r,
                        config: {
                            flipUV: s
                        }
                    }), n && (a = new f(t, {
                        key: e,
                        url: n,
                        type: "mat",
                        cache: l,
                        extension: "mat",
                        xhrSettings: r
                    }))), d.call(this, t, "obj", e, [
                        o,
                        a
                    ]);
                },
                addToCache: function() {
                    var t, e, i;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], i = r(t.data, t.config.flipUV), e && (i.materials = o(e.data)), t.cache.add(t.key, i), this.complete = !0);
                }
            });
            s.register("obj", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), r = i(8), o = i(59), a = new n({
                Extends: o,
                initialize: function(t, e, i, n, s) {
                    o.call(this, t, e, i, n, s), this.type = "packfile";
                },
                onProcess: function() {
                    this.state !== s.FILE_POPULATED && (this.state = s.FILE_PROCESSING, this.data = JSON.parse(this.xhrLoader.responseText)), this.loader.addPack(this.data, this.config), this.onProcessComplete();
                }
            });
            r.register("pack", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new a(this, t[s]));
                else this.addFile(new a(this, t, e, n, i));
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), l = i(20), u = i(23), s = i(8), c = i(2), d = i(7), o = new n({
                Extends: u,
                initialize: function(t, e, i, n, s, r) {
                    var o, a = "js";
                    d(e) && (e = c(o = e, "key"), i = c(o, "url"), r = c(o, "xhrSettings"), a = c(o, "extension", a), n = c(o, "start"), s = c(o, "mapping"));
                    var h = {
                        type: "plugin",
                        cache: !1,
                        extension: a,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: r,
                        config: {
                            start: n,
                            mapping: s
                        }
                    };
                    u.call(this, t, h), "function" == typeof i && (this.data = i, this.state = l.FILE_POPULATED);
                },
                onProcess: function() {
                    var t, e = this.loader.systems.plugins, i = this.config, n = c(i, "start", !1), s = c(i, "mapping", null);
                    this.state === l.FILE_POPULATED ? e.install(this.key, this.data, n, s) : (this.state = l.FILE_PROCESSING, this.data = document.createElement("script"), this.data.language = "javascript", this.data.type = "text/javascript", this.data.defer = !1, this.data.text = this.xhrLoader.responseText, document.head.appendChild(this.data), t = e.install(this.key, window[this.key], n, s), (n || s) && (this.loader.systems[s] = t, this.loader.scene[s] = t)), this.onProcessComplete();
                }
            });
            s.register("plugin", function(t, e, i, n, s) {
                if (Array.isArray(t)) for(var r = 0; r < t.length; r++)this.addFile(new o(this, t[r]));
                else this.addFile(new o(this, t, e, i, n, s));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), h = i(2), l = i(7), o = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    var s, r = "js";
                    l(e) && (e = h(s = e, "key"), i = h(s, "url"), n = h(s, "xhrSettings"), r = h(s, "extension", r));
                    var o = {
                        type: "text",
                        extension: r,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    a.call(this, t, o);
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = this.xhrLoader.responseText, this.onProcessComplete();
                },
                addToCache: function() {
                    var t = this.data.concat("(function(){\nreturn new " + this.key + "();\n}).call(this);"), e = eval;
                    this.loader.sceneManager.add(this.key, e(t)), this.complete = !0;
                }
            });
            r.register("sceneFile", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), l = i(20), u = i(23), s = i(8), c = i(2), d = i(7), o = new n({
                Extends: u,
                initialize: function(t, e, i, n, s, r) {
                    var o, a = "js";
                    d(e) && (e = c(o = e, "key"), i = c(o, "url"), r = c(o, "xhrSettings"), a = c(o, "extension", a), n = c(o, "systemKey"), s = c(o, "sceneKey"));
                    var h = {
                        type: "scenePlugin",
                        cache: !1,
                        extension: a,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: r,
                        config: {
                            systemKey: n,
                            sceneKey: s
                        }
                    };
                    u.call(this, t, h), "function" == typeof i && (this.data = i, this.state = l.FILE_POPULATED);
                },
                onProcess: function() {
                    var t = this.loader.systems.plugins, e = this.config, i = this.key, n = c(e, "systemKey", i), s = c(e, "sceneKey", i);
                    this.state === l.FILE_POPULATED ? t.installScenePlugin(n, this.data, s, this.loader.scene, !0) : (this.state = l.FILE_PROCESSING, this.data = document.createElement("script"), this.data.language = "javascript", this.data.type = "text/javascript", this.data.defer = !1, this.data.text = this.xhrLoader.responseText, document.head.appendChild(this.data), t.installScenePlugin(n, window[this.key], s, this.loader.scene, !0)), this.onProcessComplete();
                }
            });
            s.register("scenePlugin", function(t, e, i, n, s) {
                if (Array.isArray(t)) for(var r = 0; r < t.length; r++)this.addFile(new o(this, t[r]));
                else this.addFile(new o(this, t, e, i, n, s));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), r = i(70), o = new n({
                Extends: r,
                initialize: function(t, e, i, n, s) {
                    r.call(this, t, e, i, s, n), this.type = "spritesheet";
                },
                addToCache: function() {
                    var t = this.cache.addSpriteSheet(this.key, this.data, this.config);
                    this.pendingDestroy(t);
                }
            });
            s.register("spritesheet", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new o(this, t[s]));
                else this.addFile(new o(this, t, e, i, n));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), f = i(20), p = i(23), s = i(8), h = i(2), l = i(7), r = new n({
                Extends: p,
                initialize: function(t, e, i, n, s) {
                    var r, o = "svg";
                    l(e) && (e = h(r = e, "key"), i = h(r, "url"), n = h(r, "svgConfig", {}), s = h(r, "xhrSettings"), o = h(r, "extension", o));
                    var a = {
                        type: "svg",
                        cache: t.textureManager,
                        extension: o,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: s,
                        config: {
                            width: h(n, "width"),
                            height: h(n, "height"),
                            scale: h(n, "scale")
                        }
                    };
                    p.call(this, t, a);
                },
                onProcess: function() {
                    this.state = f.FILE_PROCESSING;
                    var t = this.xhrLoader.responseText, e = [
                        t
                    ], i = this.config.width, n = this.config.height, s = this.config.scale;
                    t: if (i && n || s) {
                        var r, o = (new DOMParser).parseFromString(t, "text/xml").getElementsByTagName("svg")[0], a = o.hasAttribute("viewBox"), h = parseFloat(o.getAttribute("width")), l = parseFloat(o.getAttribute("height"));
                        if (!a && h && l ? o.setAttribute("viewBox", "0  0 " + h + " " + l) : !a || h || l || (h = (r = o.getAttribute("viewBox").split(/\s+|,/))[2], l = r[3]), s) {
                            if (!h || !l) break t;
                            i = h * s, n = l * s;
                        }
                        o.setAttribute("width", i.toString() + "px"), o.setAttribute("height", n.toString() + "px"), e = [
                            (new XMLSerializer).serializeToString(o)
                        ];
                    }
                    try {
                        var u = new window.Blob(e, {
                            type: "image/svg+xml;charset=utf-8"
                        });
                    } catch (t) {
                        return void this.onProcessError();
                    }
                    this.data = new Image, this.data.crossOrigin = this.crossOrigin;
                    var c = this, d = !1;
                    this.data.onload = function() {
                        d || p.revokeObjectURL(c.data), c.onProcessComplete();
                    }, this.data.onerror = function() {
                        d ? c.onProcessError() : (d = !0, p.revokeObjectURL(c.data), c.data.src = "data:image/svg+xml," + encodeURIComponent(e.join("")));
                    }, p.createObjectURL(this.data, u, "image/svg+xml");
                },
                addToCache: function() {
                    var t = this.cache.addImage(this.key, this.data);
                    this.pendingDestroy(t);
                }
            });
            s.register("svg", function(t, e, i, n) {
                if (Array.isArray(t)) for(var s = 0; s < t.length; s++)this.addFile(new r(this, t[s]));
                else this.addFile(new r(this, t, e, i, n));
                return this;
            }), t.exports = r;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), a = i(23), r = i(8), h = i(2), l = i(7), u = i(39), o = new n({
                Extends: a,
                initialize: function(t, e, i, n) {
                    var s, r = "csv";
                    l(e) && (e = h(s = e, "key"), i = h(s, "url"), n = h(s, "xhrSettings"), r = h(s, "extension", r));
                    var o = {
                        type: "tilemapCSV",
                        cache: t.cacheManager.tilemap,
                        extension: r,
                        responseType: "text",
                        key: e,
                        url: i,
                        xhrSettings: n
                    };
                    a.call(this, t, o), this.tilemapFormat = u.CSV;
                },
                onProcess: function() {
                    this.state = s.FILE_PROCESSING, this.data = this.xhrLoader.responseText, this.onProcessComplete();
                },
                addToCache: function() {
                    var t = {
                        format: this.tilemapFormat,
                        data: this.data
                    };
                    this.cache.add(this.key, t), this.pendingDestroy(t);
                }
            });
            r.register("tilemapCSV", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new o(this, t[n]));
                else this.addFile(new o(this, t, e, i));
                return this;
            }), t.exports = o;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), r = i(59), o = i(39), a = new n({
                Extends: r,
                initialize: function(t, e, i, n) {
                    r.call(this, t, e, i, n), this.type = "tilemapJSON", this.cache = t.cacheManager.tilemap;
                },
                addToCache: function() {
                    var t = {
                        format: o.WELTMEISTER,
                        data: this.data
                    };
                    this.cache.add(this.key, t), this.pendingDestroy(t);
                }
            });
            s.register("tilemapImpact", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new a(this, t[n]));
                else this.addFile(new a(this, t, e, i));
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), r = i(59), o = i(39), a = new n({
                Extends: r,
                initialize: function(t, e, i, n) {
                    r.call(this, t, e, i, n), this.type = "tilemapJSON", this.cache = t.cacheManager.tilemap;
                },
                addToCache: function() {
                    var t = {
                        format: o.TILED_JSON,
                        data: this.data
                    };
                    this.cache.add(this.key, t), this.pendingDestroy(t);
                }
            });
            s.register("tilemapTiledJSON", function(t, e, i) {
                if (Array.isArray(t)) for(var n = 0; n < t.length; n++)this.addFile(new a(this, t[n]));
                else this.addFile(new a(this, t, e, i));
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(8), l = i(2), u = i(70), c = i(7), d = i(47), f = i(239), a = new n({
                Extends: d,
                initialize: function(t, e, i, n, s, r) {
                    var o, a, h = c(e) ? (e = l(a = e, "key"), o = new u(t, {
                        key: e,
                        url: l(a, "textureURL"),
                        extension: l(a, "textureExtension", "png"),
                        normalMap: l(a, "normalMap"),
                        xhrSettings: l(a, "textureXhrSettings")
                    }), new f(t, {
                        key: e,
                        url: l(a, "atlasURL"),
                        extension: l(a, "atlasExtension", "txt"),
                        xhrSettings: l(a, "atlasXhrSettings")
                    })) : (o = new u(t, e, i, s), new f(t, e, n, r));
                    o.linkFile ? d.call(this, t, "unityatlas", e, [
                        o,
                        h,
                        o.linkFile
                    ]) : d.call(this, t, "unityatlas", e, [
                        o,
                        h
                    ]);
                },
                addToCache: function() {
                    var t, e, i;
                    this.isReadyToProcess() && (t = this.files[0], e = this.files[1], i = this.files[2] ? this.files[2].data : null, this.loader.textureManager.addUnityAtlas(t.key, t.data, e.data, i), e.pendingDestroy(), this.complete = !0);
                }
            });
            s.register("unityAtlas", function(t, e, i, n, s) {
                var r;
                if (Array.isArray(t)) for(var o = 0; o < t.length; o++)r = new a(this, t[o]), this.addFile(r.files);
                else r = new a(this, t, e, i, n, s), this.addFile(r.files);
                return this;
            }), t.exports = a;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), h = i(23), r = i(8), o = i(153), l = i(2), u = i(7), c = new n({
                Extends: h,
                initialize: function(t, e, i, n, s, r, o) {
                    void 0 === n && (n = "loadeddata"), void 0 === s && (s = !1), void 0 === r && (r = !1), "loadeddata" !== n && "canplay" !== n && "canplaythrough" !== n && (n = "loadeddata");
                    var a = {
                        type: "video",
                        cache: t.cacheManager.video,
                        extension: i.type,
                        responseType: "blob",
                        key: e,
                        url: i.url,
                        xhrSettings: o,
                        config: {
                            loadEvent: n,
                            asBlob: s,
                            noAudio: r
                        }
                    };
                    this.onLoadCallback = this.onVideoLoadHandler.bind(this), this.onErrorCallback = this.onVideoErrorHandler.bind(this), h.call(this, t, a);
                },
                onProcess: function() {
                    var t, e;
                    this.state = s.FILE_PROCESSING, this.config.asBlob ? (t = this.createVideoElement(), this.data = t, (e = this).data.onloadeddata = function() {
                        e.onProcessComplete();
                    }, this.data.onerror = function() {
                        h.revokeObjectURL(e.data), e.onProcessError();
                    }, h.createObjectURL(t, this.xhrLoader.response, ""), t.load()) : this.onProcessComplete();
                },
                createVideoElement: function() {
                    var t = document.createElement("video");
                    return t.controls = !1, t.crossOrigin = this.loader.crossOrigin, this.config.noAudio && (t.muted = !0, t.defaultMuted = !0, t.setAttribute("autoplay", "autoplay")), t.setAttribute("playsinline", "playsinline"), t.setAttribute("preload", "auto"), t;
                },
                onVideoLoadHandler: function(t) {
                    var e = t.target;
                    e.removeEventListener(this.config.loadEvent, this.onLoadCallback, !0), e.removeEventListener("error", this.onErrorCallback, !0), this.data = e, this.resetXHR(), this.loader.nextFile(this, !0);
                },
                onVideoErrorHandler: function(t) {
                    var e = t.target;
                    e && (e.removeEventListener(this.config.loadEvent, this.onLoadCallback, !0), e.removeEventListener("error", this.onErrorCallback, !0)), this.resetXHR(), this.loader.nextFile(this, !1);
                },
                load: function() {
                    var t, e = this.config.loadEvent;
                    this.config.asBlob ? h.prototype.load.call(this) : (this.percentComplete = 0, (t = this.createVideoElement()).addEventListener(e, this.onLoadCallback, !0), t.addEventListener("error", this.onErrorCallback, !0), t.src = o(this, this.loader.baseURL), t.load());
                }
            });
            c.create = function(t, e, i, n, s, r, o) {
                var a = t.systems.game;
                u(e) && (i = l(e, "url", []), n = l(e, "loadEvent", "loadeddata"), s = l(e, "asBlob", !1), r = l(e, "noAudio", !1), o = l(e, "xhrSettings"));
                var h = c.getVideoURL(a, i);
                if (h) return new c(t, e, h, n, s, r, o);
            }, c.getVideoURL = function(t, e) {
                Array.isArray(e) || (e = [
                    e
                ]);
                for(var i = 0; i < e.length; i++){
                    var n, s = l(e[i], "url", e[i]);
                    if (0 === s.indexOf("blob:")) return {
                        url: s,
                        type: ""
                    };
                    if (n = 0 === s.indexOf("data:") ? s.split(",")[0].match(/\/(.*?);/) : s.match(/\.([a-zA-Z0-9]+)($|\?)/), n = l(e[i], "type", n ? n[1] : "").toLowerCase(), t.device.video[n]) return {
                        url: s,
                        type: n
                    };
                }
                return null;
            }, r.register("video", function(t, e, i, n, s, r) {
                var o;
                if (Array.isArray(t)) for(var a = 0; a < t.length; a++)(o = c.create(this, t[a])) && this.addFile(o);
                else (o = c.create(this, t, e, i, n, s, r)) && this.addFile(o);
                return this;
            }), t.exports = c;
        },
        function(t, e, i) {
            var n = i(0), s = i(20), r = i(148), o = i(9), a = i(91), h = i(8), v = i(2), l = i(24), u = i(21), c = i(154), d = new n({
                Extends: o,
                initialize: function(t) {
                    o.call(this);
                    var e = t.sys.game.config, i = t.sys.settings.loader;
                    this.scene = t, this.systems = t.sys, this.cacheManager = t.sys.cache, this.textureManager = t.sys.textures, this.sceneManager = t.sys.game.scene, h.install(this), this.prefix = "", this.path = "", this.baseURL = "", this.setBaseURL(v(i, "baseURL", e.loaderBaseURL)), this.setPath(v(i, "path", e.loaderPath)), this.setPrefix(v(i, "prefix", e.loaderPrefix)), this.maxParallelDownloads = v(i, "maxParallelDownloads", e.loaderMaxParallelDownloads), this.xhr = c(v(i, "responseType", e.loaderResponseType), v(i, "async", e.loaderAsync), v(i, "user", e.loaderUser), v(i, "password", e.loaderPassword), v(i, "timeout", e.loaderTimeout), v(i, "withCredentials", e.loaderWithCredentials)), this.crossOrigin = v(i, "crossOrigin", e.loaderCrossOrigin), this.totalToLoad = 0, this.progress = 0, this.list = new r, this.inflight = new r, this.queue = new r, this._deleteQueue = new r, this.totalFailed = 0, this.totalComplete = 0, this.state = s.LOADER_IDLE, this.multiKeyIndex = 0, t.sys.events.once(u.BOOT, this.boot, this), t.sys.events.on(u.START, this.pluginStart, this);
                },
                boot: function() {
                    this.systems.events.once(u.DESTROY, this.destroy, this);
                },
                pluginStart: function() {
                    this.systems.events.once(u.SHUTDOWN, this.shutdown, this);
                },
                setBaseURL: function(t) {
                    return void 0 === t && (t = ""), "" !== t && "/" !== t.substr(-1) && (t = t.concat("/")), this.baseURL = t, this;
                },
                setPath: function(t) {
                    return void 0 === t && (t = ""), "" !== t && "/" !== t.substr(-1) && (t = t.concat("/")), this.path = t, this;
                },
                setPrefix: function(t) {
                    return void 0 === t && (t = ""), this.prefix = t, this;
                },
                setCORS: function(t) {
                    return this.crossOrigin = t, this;
                },
                addFile: function(t) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = 0; e < t.length; e++){
                        var i = t[e];
                        this.keyExists(i) || (this.list.set(i), this.emit(a.ADD, i.key, i.type, this, i), this.isLoading() && (this.totalToLoad++, this.updateProgress()));
                    }
                },
                keyExists: function(e) {
                    var i = e.hasCacheConflict();
                    return i || this.list.iterate(function(t) {
                        if (t.type === e.type && t.key === e.key) return i = !0, false;
                    }), !i && this.isLoading() && (this.inflight.iterate(function(t) {
                        if (t.type === e.type && t.key === e.key) return i = !0, false;
                    }), this.queue.iterate(function(t) {
                        if (t.type === e.type && t.key === e.key) return i = !0, false;
                    })), i;
                },
                addPack: function(t, e) {
                    e && t.hasOwnProperty(e) && (t = {
                        packKey: t[e]
                    });
                    var i = 0, n = this.baseURL, s = this.path, r = this.prefix;
                    for(var o in t)if (Object.prototype.hasOwnProperty.call(t, o)) {
                        var a = t[o], h = v(a, "baseURL", n), l = v(a, "path", s), u = v(a, "prefix", r), c = v(a, "files", null), d = v(a, "defaultType", "void");
                        if (Array.isArray(c)) {
                            this.setBaseURL(h), this.setPath(l), this.setPrefix(u);
                            for(var f = 0; f < c.length; f++){
                                var p = c[f], g = p.hasOwnProperty("type") ? p.type : d;
                                this[g] && (this[g](p), i++);
                            }
                        }
                    }
                    return this.setBaseURL(n), this.setPath(s), this.setPrefix(r), 0 < i;
                },
                isLoading: function() {
                    return this.state === s.LOADER_LOADING || this.state === s.LOADER_PROCESSING;
                },
                isReady: function() {
                    return this.state === s.LOADER_IDLE || this.state === s.LOADER_COMPLETE;
                },
                start: function() {
                    this.isReady() && (this.progress = 0, this.totalFailed = 0, this.totalComplete = 0, this.totalToLoad = this.list.size, this.emit(a.START, this), 0 === this.list.size ? this.loadComplete() : (this.state = s.LOADER_LOADING, this.inflight.clear(), this.queue.clear(), this.updateProgress(), this.checkLoadQueue(), this.systems.events.on(u.UPDATE, this.update, this)));
                },
                updateProgress: function() {
                    this.progress = 1 - (this.list.size + this.inflight.size) / this.totalToLoad, this.emit(a.PROGRESS, this.progress);
                },
                update: function() {
                    this.state === s.LOADER_LOADING && 0 < this.list.size && this.inflight.size < this.maxParallelDownloads && this.checkLoadQueue();
                },
                checkLoadQueue: function() {
                    this.list.each(function(t) {
                        if ((t.state === s.FILE_POPULATED || t.state === s.FILE_PENDING && this.inflight.size < this.maxParallelDownloads) && (this.inflight.set(t), this.list.delete(t), t.crossOrigin || (t.crossOrigin = this.crossOrigin), t.load()), this.inflight.size === this.maxParallelDownloads) return !1;
                    }, this);
                },
                nextFile: function(t, e) {
                    this.inflight && (this.inflight.delete(t), this.updateProgress(), e ? (this.totalComplete++, this.queue.set(t), this.emit(a.FILE_LOAD, t), t.onProcess()) : (this.totalFailed++, this._deleteQueue.set(t), this.emit(a.FILE_LOAD_ERROR, t), this.fileProcessComplete(t)));
                },
                fileProcessComplete: function(t) {
                    this.scene && this.systems && this.systems.game && !this.systems.game.pendingDestroy && (t.state === s.FILE_ERRORED ? t.multiFile && t.multiFile.onFileFailed(t) : t.state === s.FILE_COMPLETE && (t.multiFile ? t.multiFile.isReadyToProcess() && t.multiFile.addToCache() : t.addToCache()), this.queue.delete(t), 0 === this.list.size && 0 === this.inflight.size && 0 === this.queue.size && this.loadComplete());
                },
                loadComplete: function() {
                    this.emit(a.POST_PROCESS, this), this.list.clear(), this.inflight.clear(), this.queue.clear(), this.progress = 1, this.state = s.LOADER_COMPLETE, this.systems.events.off(u.UPDATE, this.update, this), this._deleteQueue.iterateLocal("destroy"), this._deleteQueue.clear(), this.emit(a.COMPLETE, this, this.totalComplete, this.totalFailed);
                },
                flagForRemoval: function(t) {
                    this._deleteQueue.set(t);
                },
                saveJSON: function(t, e) {
                    return this.save(JSON.stringify(t), e);
                },
                save: function(t, e, i) {
                    void 0 === e && (e = "file.json"), void 0 === i && (i = "application/json");
                    var n = new Blob([
                        t
                    ], {
                        type: i
                    }), s = URL.createObjectURL(n), r = document.createElement("a");
                    return r.download = e, r.textContent = "Download " + e, r.href = s, r.click(), this;
                },
                reset: function() {
                    this.list.clear(), this.inflight.clear(), this.queue.clear();
                    var t = this.systems.game.config, e = this.systems.settings.loader;
                    this.setBaseURL(v(e, "baseURL", t.loaderBaseURL)), this.setPath(v(e, "path", t.loaderPath)), this.setPrefix(v(e, "prefix", t.loaderPrefix)), this.state = s.LOADER_IDLE;
                },
                shutdown: function() {
                    this.reset(), this.state = s.LOADER_SHUTDOWN, this.systems.events.off(u.UPDATE, this.update, this), this.systems.events.off(u.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.state = s.LOADER_DESTROYED, this.systems.events.off(u.UPDATE, this.update, this), this.systems.events.off(u.START, this.pluginStart, this), this.list = null, this.inflight = null, this.queue = null, this.scene = null, this.systems = null, this.textureManager = null, this.cacheManager = null, this.sceneManager = null;
                }
            });
            l.register("Loader", d, "load"), t.exports = d;
        },
        function(t, e, i) {
            var n = i(60), s = i(17)(!1, s = {
                ArcadePhysics: i(1361),
                Body: i(521),
                Collider: i(522),
                Components: i(240),
                Events: i(242),
                Factory: i(515),
                GetOverlapX: i(243),
                GetOverlapY: i(244),
                SeparateX: i(531),
                SeparateY: i(532),
                Group: i(518),
                Image: i(516),
                Sprite: i(155),
                StaticBody: i(533),
                StaticGroup: i(519),
                Tilemap: i(1385),
                World: i(520)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(0), s = i(35), o = i(48), c = i(347), r = i(515), a = i(2), h = i(143), l = i(517), u = i(241), d = i(24), f = i(21), p = i(3), g = i(520), v = new n({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.config = this.getConfig(), this.world, this.add, t.sys.events.once(f.BOOT, this.boot, this), t.sys.events.on(f.START, this.start, this);
                },
                boot: function() {
                    this.world = new g(this.scene, this.config), this.add = new r(this.world), this.systems.events.once(f.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.world || (this.world = new g(this.scene, this.config), this.add = new r(this.world));
                    var t = this.systems.events;
                    a(this.config, "customUpdate", !1) || t.on(f.UPDATE, this.world.update, this.world), t.on(f.POST_UPDATE, this.world.postUpdate, this.world), t.once(f.SHUTDOWN, this.shutdown, this);
                },
                enableUpdate: function() {
                    this.systems.events.on(f.UPDATE, this.world.update, this.world);
                },
                disableUpdate: function() {
                    this.systems.events.off(f.UPDATE, this.world.update, this.world);
                },
                getConfig: function() {
                    var t = this.systems.game.config.physics, e = this.systems.settings.physics;
                    return h(a(e, "arcade", {}), a(t, "arcade", {}));
                },
                overlap: function(t, e, i, n, s) {
                    return void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i), this.world.collideObjects(t, e, i, n, s, !0);
                },
                collide: function(t, e, i, n, s) {
                    return void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i), this.world.collideObjects(t, e, i, n, s, !1);
                },
                collideTiles: function(t, e, i, n, s) {
                    return this.world.collideTiles(t, e, i, n, s);
                },
                overlapTiles: function(t, e, i, n, s) {
                    return this.world.overlapTiles(t, e, i, n, s);
                },
                pause: function() {
                    return this.world.pause();
                },
                resume: function() {
                    return this.world.resume();
                },
                accelerateTo: function(t, e, i, n, s, r) {
                    void 0 === n && (n = 60);
                    var o = Math.atan2(i - t.y, e - t.x);
                    return t.body.acceleration.setToPolar(o, n), void 0 !== s && void 0 !== r && t.body.maxVelocity.set(s, r), o;
                },
                accelerateToObject: function(t, e, i, n, s) {
                    return this.accelerateTo(t, e.x, e.y, i, n, s);
                },
                closest: function(t, e) {
                    e = e || this.world.bodies.entries;
                    for(var i = Number.MAX_VALUE, n = null, s = t.x, r = t.y, o = e.length, a = 0; a < o; a++){
                        var h, l = e[a], u = l.body || l;
                        t !== l && t !== u && t !== u.gameObject && t !== u.center && (h = c(s, r, u.center.x, u.center.y)) < i && (n = l, i = h);
                    }
                    return n;
                },
                furthest: function(t, e) {
                    e = e || this.world.bodies.entries;
                    for(var i = -1, n = null, s = t.x, r = t.y, o = e.length, a = 0; a < o; a++){
                        var h, l = e[a], u = l.body || l;
                        t !== l && t !== u && t !== u.gameObject && t !== u.center && i < (h = c(s, r, u.center.x, u.center.y)) && (n = l, i = h);
                    }
                    return n;
                },
                moveTo: function(t, e, i, n, s) {
                    void 0 === n && (n = 60), void 0 === s && (s = 0);
                    var r = Math.atan2(i - t.y, e - t.x);
                    return 0 < s && (n = o(t.x, t.y, e, i) / (s / 1e3)), t.body.velocity.setToPolar(r, n), r;
                },
                moveToObject: function(t, e, i, n) {
                    return this.moveTo(t, e.x, e.y, i, n);
                },
                velocityFromAngle: function(t, e, i) {
                    return void 0 === e && (e = 60), void 0 === i && (i = new p), i.setToPolar(s(t), e);
                },
                velocityFromRotation: function(t, e, i) {
                    return void 0 === e && (e = 60), void 0 === i && (i = new p), i.setToPolar(t, e);
                },
                overlapRect: function(t, e, i, n, s, r) {
                    return u(this.world, t, e, i, n, s, r);
                },
                overlapCirc: function(t, e, i, n, s) {
                    return l(this.world, t, e, i, n, s);
                },
                shutdown: function() {
                    var t;
                    this.world && ((t = this.systems.events).off(f.UPDATE, this.world.update, this.world), t.off(f.POST_UPDATE, this.world.postUpdate, this.world), t.off(f.SHUTDOWN, this.shutdown, this), this.add.destroy(), this.world.destroy(), this.add = null, this.world = null);
                },
                destroy: function() {
                    this.shutdown(), this.scene.sys.events.off(f.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            d.register("ArcadePhysics", v, "arcadePhysics"), t.exports = v;
        },
        function(t, e) {
            t.exports = {
                setAcceleration: function(t, e) {
                    return this.body.acceleration.set(t, e), this;
                },
                setAccelerationX: function(t) {
                    return this.body.acceleration.x = t, this;
                },
                setAccelerationY: function(t) {
                    return this.body.acceleration.y = t, this;
                }
            };
        },
        function(t, e) {
            t.exports = {
                setAngularVelocity: function(t) {
                    return this.body.angularVelocity = t, this;
                },
                setAngularAcceleration: function(t) {
                    return this.body.angularAcceleration = t, this;
                },
                setAngularDrag: function(t) {
                    return this.body.angularDrag = t, this;
                }
            };
        },
        function(t, e) {
            t.exports = {
                setBounce: function(t, e) {
                    return this.body.bounce.set(t, e), this;
                },
                setBounceX: function(t) {
                    return this.body.bounce.x = t, this;
                },
                setBounceY: function(t) {
                    return this.body.bounce.y = t, this;
                },
                setCollideWorldBounds: function(t, e, i) {
                    return this.body.setCollideWorldBounds(t, e, i), this;
                }
            };
        },
        function(t, e) {
            t.exports = {
                setDebug: function(t, e, i) {
                    return this.debugShowBody = t, this.debugShowVelocity = e, this.debugBodyColor = i, this;
                },
                setDebugBodyColor: function(t) {
                    return this.body.debugBodyColor = t, this;
                },
                debugShowBody: {
                    get: function() {
                        return this.body.debugShowBody;
                    },
                    set: function(t) {
                        this.body.debugShowBody = t;
                    }
                },
                debugShowVelocity: {
                    get: function() {
                        return this.body.debugShowVelocity;
                    },
                    set: function(t) {
                        this.body.debugShowVelocity = t;
                    }
                },
                debugBodyColor: {
                    get: function() {
                        return this.body.debugBodyColor;
                    },
                    set: function(t) {
                        this.body.debugBodyColor = t;
                    }
                }
            };
        },
        function(t, e) {
            t.exports = {
                setDrag: function(t, e) {
                    return this.body.drag.set(t, e), this;
                },
                setDragX: function(t) {
                    return this.body.drag.x = t, this;
                },
                setDragY: function(t) {
                    return this.body.drag.y = t, this;
                },
                setDamping: function(t) {
                    return this.body.useDamping = t, this;
                }
            };
        },
        function(t, e) {
            var i = {
                enableBody: function(t, e, i, n, s) {
                    return t && this.body.reset(e, i), n && (this.body.gameObject.active = !0), s && (this.body.gameObject.visible = !0), this.body.enable = !0, this;
                },
                disableBody: function(t, e) {
                    return void 0 === t && (t = !1), void 0 === e && (e = !1), this.body.stop(), this.body.enable = !1, t && (this.body.gameObject.active = !1), e && (this.body.gameObject.visible = !1), this;
                },
                refreshBody: function() {
                    return this.body.updateFromGameObject(), this;
                }
            };
            t.exports = i;
        },
        function(t, e) {
            t.exports = {
                setFriction: function(t, e) {
                    return this.body.friction.set(t, e), this;
                },
                setFrictionX: function(t) {
                    return this.body.friction.x = t, this;
                },
                setFrictionY: function(t) {
                    return this.body.friction.y = t, this;
                }
            };
        },
        function(t, e) {
            t.exports = {
                setGravity: function(t, e) {
                    return this.body.gravity.set(t, e), this;
                },
                setGravityX: function(t) {
                    return this.body.gravity.x = t, this;
                },
                setGravityY: function(t) {
                    return this.body.gravity.y = t, this;
                }
            };
        },
        function(t, e) {
            var i = {
                setImmovable: function(t) {
                    return void 0 === t && (t = !0), this.body.immovable = t, this;
                }
            };
            t.exports = i;
        },
        function(t, e) {
            t.exports = {
                setMass: function(t) {
                    return this.body.mass = t, this;
                }
            };
        },
        function(t, e) {
            var i = {
                setPushable: function(t) {
                    return void 0 === t && (t = !0), this.body.pushable = t, this;
                }
            };
            t.exports = i;
        },
        function(t, e) {
            t.exports = {
                setOffset: function(t, e) {
                    return this.body.setOffset(t, e), this;
                },
                setSize: function(t, e, i) {
                    return this.body.setSize(t, e, i), this;
                },
                setBodySize: function(t, e, i) {
                    return this.body.setSize(t, e, i), this;
                },
                setCircle: function(t, e, i) {
                    return this.body.setCircle(t, e, i), this;
                }
            };
        },
        function(t, e) {
            t.exports = {
                setVelocity: function(t, e) {
                    return this.body.setVelocity(t, e), this;
                },
                setVelocityX: function(t) {
                    return this.body.setVelocityX(t), this;
                },
                setVelocityY: function(t) {
                    return this.body.setVelocityY(t), this;
                },
                setMaxVelocity: function(t, e) {
                    return this.body.maxVelocity.set(t, e), this;
                }
            };
        },
        function(t, e) {
            t.exports = "collide";
        },
        function(t, e) {
            t.exports = "overlap";
        },
        function(t, e) {
            t.exports = "pause";
        },
        function(t, e) {
            t.exports = "resume";
        },
        function(t, e) {
            t.exports = "tilecollide";
        },
        function(t, e) {
            t.exports = "tileoverlap";
        },
        function(t, e) {
            t.exports = "worldbounds";
        },
        function(t, e) {
            t.exports = "worldstep";
        },
        function(t, e) {
            var r, o, a, h, l, u, c, d, f, p, g, v, m, y, x, T, w, b = function() {
                return p && x && o.blocked.right ? (r.processX(-w, c, !1, !0), 1) : f && T && o.blocked.left ? (r.processX(w, c, !0), 1) : m && T && r.blocked.right ? (o.processX(-w, d, !1, !0), 2) : v && x && r.blocked.left ? (o.processX(w, d, !0), 2) : 0;
            }, E = function(t) {
                var e;
                return a && h ? (w *= .5, 0 === t || 3 === t ? (r.processX(w, l), o.processX(-w, u)) : (r.processX(-w, l), o.processX(w, u))) : a && !h ? 0 === t || 3 === t ? r.processX(w, c, !0) : r.processX(-w, c, !1, !0) : !a && h ? 0 === t || 3 === t ? o.processX(-w, d, !1, !0) : o.processX(w, d, !0) : (e = .5 * w, 0 === t ? y ? (r.processX(w, 0, !0), o.processX(0, null, !1, !0)) : m ? (r.processX(e, 0, !0), o.processX(-e, 0, !1, !0)) : (r.processX(e, o.velocity.x, !0), o.processX(-e, null, !1, !0)) : 1 === t ? g ? (r.processX(0, null, !1, !0), o.processX(w, 0, !0)) : p ? (r.processX(-e, 0, !1, !0), o.processX(e, 0, !0)) : (r.processX(-e, null, !1, !0), o.processX(e, r.velocity.x, !0)) : 2 === t ? y ? (r.processX(-w, 0, !1, !0), o.processX(0, null, !0)) : v ? (r.processX(-e, 0, !1, !0), o.processX(e, 0, !0)) : (r.processX(-e, o.velocity.x, !1, !0), o.processX(e, null, !0)) : 3 === t && (g ? (r.processX(0, null, !0), o.processX(-w, 0, !1, !0)) : f ? (r.processX(e, 0, !0), o.processX(-e, 0, !1, !0)) : (r.processX(e, o.velocity.y, !0), o.processX(-e, null, !1, !0)))), !0;
            };
            t.exports = {
                BlockCheck: b,
                Check: function() {
                    var t = r.velocity.x, e = o.velocity.x, i = Math.sqrt(e * e * o.mass / r.mass) * (0 < e ? 1 : -1), n = Math.sqrt(t * t * r.mass / o.mass) * (0 < t ? 1 : -1), s = .5 * (i + n);
                    return n -= s, l = s + (i -= s) * r.bounce.x, u = s + n * o.bounce.x, f && T ? E(0) : v && x ? E(1) : p && x ? E(2) : !(!m || !T) && E(3);
                },
                Set: function(t, e, i) {
                    o = e;
                    var n = (r = t).velocity.x, s = o.velocity.x;
                    return a = r.pushable, f = r._dx < 0, p = 0 < r._dx, g = 0 === r._dx, x = Math.abs(r.right - o.x) <= Math.abs(o.right - r.x), c = s - n * r.bounce.x, h = o.pushable, v = o._dx < 0, m = 0 < o._dx, y = 0 === o._dx, T = !x, d = n - s * o.bounce.x, w = Math.abs(i), b();
                },
                Run: E,
                RunImmovableBody1: function(t) {
                    1 === t ? o.velocity.x = 0 : x ? o.processX(w, d, !0) : o.processX(-w, d, !1, !0), r.moves && (o.y += (r.y - r.prev.y) * r.friction.y, o._dy = o.y - o.prev.y);
                },
                RunImmovableBody2: function(t) {
                    2 === t && (r.velocity.x = 0), T ? r.processX(w, c, !0) : r.processX(-w, c, !1, !0), o.moves && (r.y += (o.y - o.prev.y) * o.friction.y, r._dy = r.y - r.prev.y);
                }
            };
        },
        function(t, e) {
            var r, o, a, h, l, u, c, d, f, p, g, v, m, y, x, T, w, b = function() {
                return p && x && o.blocked.down ? (r.processY(-w, c, !1, !0), 1) : f && T && o.blocked.up ? (r.processY(w, c, !0), 1) : m && T && r.blocked.down ? (o.processY(-w, d, !1, !0), 2) : v && x && r.blocked.up ? (o.processY(w, d, !0), 2) : 0;
            }, E = function(t) {
                var e;
                return a && h ? (w *= .5, 0 === t || 3 === t ? (r.processY(w, l), o.processY(-w, u)) : (r.processY(-w, l), o.processY(w, u))) : a && !h ? 0 === t || 3 === t ? r.processY(w, c, !0) : r.processY(-w, c, !1, !0) : !a && h ? 0 === t || 3 === t ? o.processY(-w, d, !1, !0) : o.processY(w, d, !0) : (e = .5 * w, 0 === t ? y ? (r.processY(w, 0, !0), o.processY(0, null, !1, !0)) : m ? (r.processY(e, 0, !0), o.processY(-e, 0, !1, !0)) : (r.processY(e, o.velocity.y, !0), o.processY(-e, null, !1, !0)) : 1 === t ? g ? (r.processY(0, null, !1, !0), o.processY(w, 0, !0)) : p ? (r.processY(-e, 0, !1, !0), o.processY(e, 0, !0)) : (r.processY(-e, null, !1, !0), o.processY(e, r.velocity.y, !0)) : 2 === t ? y ? (r.processY(-w, 0, !1, !0), o.processY(0, null, !0)) : v ? (r.processY(-e, 0, !1, !0), o.processY(e, 0, !0)) : (r.processY(-e, o.velocity.y, !1, !0), o.processY(e, null, !0)) : 3 === t && (g ? (r.processY(0, null, !0), o.processY(-w, 0, !1, !0)) : f ? (r.processY(e, 0, !0), o.processY(-e, 0, !1, !0)) : (r.processY(e, o.velocity.y, !0), o.processY(-e, null, !1, !0)))), !0;
            };
            t.exports = {
                BlockCheck: b,
                Check: function() {
                    var t = r.velocity.y, e = o.velocity.y, i = Math.sqrt(e * e * o.mass / r.mass) * (0 < e ? 1 : -1), n = Math.sqrt(t * t * r.mass / o.mass) * (0 < t ? 1 : -1), s = .5 * (i + n);
                    return n -= s, l = s + (i -= s) * r.bounce.y, u = s + n * o.bounce.y, f && T ? E(0) : v && x ? E(1) : p && x ? E(2) : !(!m || !T) && E(3);
                },
                Set: function(t, e, i) {
                    o = e;
                    var n = (r = t).velocity.y, s = o.velocity.y;
                    return a = r.pushable, f = r._dy < 0, p = 0 < r._dy, g = 0 === r._dy, x = Math.abs(r.bottom - o.y) <= Math.abs(o.bottom - r.y), c = s - n * r.bounce.y, h = o.pushable, v = o._dy < 0, m = 0 < o._dy, y = 0 === o._dy, T = !x, d = n - s * o.bounce.y, w = Math.abs(i), b();
                },
                Run: E,
                RunImmovableBody1: function(t) {
                    1 === t ? o.velocity.y = 0 : x ? o.processY(w, d, !0) : o.processY(-w, d, !1, !0), r.moves && (o.x += (r.x - r.prev.x) * r.friction.x, o._dx = o.x - o.prev.x);
                },
                RunImmovableBody2: function(t) {
                    2 === t ? r.velocity.y = 0 : T ? r.processY(w, c, !0) : r.processY(-w, c, !1, !0), o.moves && (r.x += (o.x - o.prev.x) * o.friction.x, r._dx = r.x - r.prev.x);
                }
            };
        },
        function(t, e, i) {
            var n = {
                ProcessTileCallbacks: i(524),
                ProcessTileSeparationX: i(528),
                ProcessTileSeparationY: i(530),
                SeparateTile: i(526),
                TileCheckX: i(527),
                TileCheckY: i(529),
                TileIntersectsBody: i(245)
            };
            t.exports = n;
        },
        function(t, e, i) {
            var o = i(126), c = i(71), d = i(50), f = i(2), s = i(94), n = {
                parseBody: function(t, e, i, n) {
                    void 0 === n && (n = {});
                    for(var s = f(i, "fixtures", []), r = [], o = 0; o < s.length; o++)for(var a = this.parseFixture(s[o]), h = 0; h < a.length; h++)r.push(a[h]);
                    var l = d.clone(i, !0);
                    d.extend(l, n, !0), delete l.fixtures, delete l.type;
                    var u = c.create(l);
                    return c.setParts(u, r), c.setPosition(u, {
                        x: t,
                        y: e
                    }), u;
                },
                parseFixture: function(t) {
                    var e, i, n, s, r = d.extend({}, !1, t);
                    return delete r.circle, delete r.vertices, t.circle ? (e = f(t.circle, "x"), i = f(t.circle, "y"), n = f(t.circle, "radius"), s = [
                        o.circle(e, i, n, r)
                    ]) : t.vertices && (s = this.parseVertices(t.vertices, r)), s;
                },
                parseVertices: function(t, e) {
                    void 0 === e && (e = {});
                    for(var i = [], n = 0; n < t.length; n++)s.clockwiseSort(t[n]), i.push(c.create(d.extend({
                        position: s.centre(t[n]),
                        vertices: t[n]
                    }, e)));
                    return o.flagCoincidentParts(i);
                }
            };
            t.exports = n;
        },
        function(t, e, i) {
            var l = i(126), u = i(71), n = {
                parseBody: function(t, e, i, n) {
                    var s;
                    void 0 === n && (n = {});
                    var r = i.vertices;
                    if (1 === r.length) n.vertices = r[0], s = u.create(n), l.flagCoincidentParts(s.parts);
                    else {
                        for(var o = [], a = 0; a < r.length; a++){
                            var h = u.create({
                                vertices: r[a]
                            });
                            o.push(h);
                        }
                        l.flagCoincidentParts(o), n.parts = o, s = u.create(n);
                    }
                    return s.label = i.label, u.setPosition(s, {
                        x: t,
                        y: e
                    }), s;
                }
            };
            t.exports = n;
        },
        function(t, e, i) {
            var f = {};
            t.exports = f;
            var y = i(163), g = i(246), v = i(50), x = i(71), p = i(126);
            f.stack = function(t, e, i, n, s, r, o) {
                for(var a, h = y.create({
                    label: "Stack"
                }), l = t, u = e, c = 0, d = 0; d < n; d++){
                    for(var f = 0, p = 0; p < i; p++){
                        var g, v, m = o(l, u, p, d, a, c);
                        m ? (g = m.bounds.max.y - m.bounds.min.y, v = m.bounds.max.x - m.bounds.min.x, f < g && (f = g), x.translate(m, {
                            x: .5 * v,
                            y: .5 * g
                        }), l = m.bounds.max.x + s, y.addBody(h, m), a = m, c += 1) : l += s;
                    }
                    u += f + r, l = t;
                }
                return h;
            }, f.chain = function(t, e, i, n, s, r) {
                for(var o = t.bodies, a = 1; a < o.length; a++){
                    var h = o[a - 1], l = o[a], u = h.bounds.max.y - h.bounds.min.y, c = h.bounds.max.x - h.bounds.min.x, d = l.bounds.max.y - l.bounds.min.y, f = {
                        bodyA: h,
                        pointA: {
                            x: c * e,
                            y: u * i
                        },
                        bodyB: l,
                        pointB: {
                            x: (l.bounds.max.x - l.bounds.min.x) * n,
                            y: d * s
                        }
                    }, p = v.extend(f, r);
                    y.addConstraint(t, g.create(p));
                }
                return t.label += " Chain", t;
            }, f.mesh = function(t, e, i, n, s) {
                for(var r, o, a, h, l = t.bodies, u = 0; u < i; u++){
                    for(r = 1; r < e; r++)o = l[r - 1 + u * e], a = l[r + u * e], y.addConstraint(t, g.create(v.extend({
                        bodyA: o,
                        bodyB: a
                    }, s)));
                    if (0 < u) for(r = 0; r < e; r++)o = l[r + (u - 1) * e], a = l[r + u * e], y.addConstraint(t, g.create(v.extend({
                        bodyA: o,
                        bodyB: a
                    }, s))), n && 0 < r && (h = l[r - 1 + (u - 1) * e], y.addConstraint(t, g.create(v.extend({
                        bodyA: h,
                        bodyB: a
                    }, s)))), n && r < e - 1 && (h = l[r + 1 + (u - 1) * e], y.addConstraint(t, g.create(v.extend({
                        bodyA: h,
                        bodyB: a
                    }, s))));
                }
                return t.label += " Mesh", t;
            }, f.pyramid = function(h, t, l, u, c, e, d) {
                return f.stack(h, t, l, u, c, e, function(t, e, i, n, s, r) {
                    var o = Math.min(u, Math.ceil(l / 2)), a = s ? s.bounds.max.x - s.bounds.min.x : 0;
                    if (!(o < n) && !(i < (n = o - n) || l - 1 - n < i)) return 1 === r && x.translate(s, {
                        x: (i + (l % 2 == 1 ? 1 : -1)) * a,
                        y: 0
                    }), d(h + (s ? i * a : 0) + i * c, e, i, n, s, r);
                });
            }, f.newtonsCradle = function(t, e, i, n, s) {
                for(var r = y.create({
                    label: "Newtons Cradle"
                }), o = 0; o < i; o++){
                    var a = p.circle(t + o * (1.9 * n), e + s, n, {
                        inertia: 1 / 0,
                        restitution: 1,
                        friction: 0,
                        frictionAir: 1e-4,
                        slop: 1
                    }), h = g.create({
                        pointA: {
                            x: t + o * (1.9 * n),
                            y: e
                        },
                        bodyB: a
                    });
                    y.addBody(r, a), y.addConstraint(r, h);
                }
                return r;
            }, f.car = function(t, e, i, n, s) {
                var r = x.nextGroup(!0), o = .5 * -i + 20, a = .5 * i - 20, h = y.create({
                    label: "Car"
                }), l = p.rectangle(t, e, i, n, {
                    collisionFilter: {
                        group: r
                    },
                    chamfer: {
                        radius: .5 * n
                    },
                    density: 2e-4
                }), u = p.circle(t + o, e + 0, s, {
                    collisionFilter: {
                        group: r
                    },
                    friction: .8
                }), c = p.circle(t + a, e + 0, s, {
                    collisionFilter: {
                        group: r
                    },
                    friction: .8
                }), d = g.create({
                    bodyB: l,
                    pointB: {
                        x: o,
                        y: 0
                    },
                    bodyA: u,
                    stiffness: 1,
                    length: 0
                }), f = g.create({
                    bodyB: l,
                    pointB: {
                        x: a,
                        y: 0
                    },
                    bodyA: c,
                    stiffness: 1,
                    length: 0
                });
                return y.addBody(h, l), y.addBody(h, u), y.addBody(h, c), y.addConstraint(h, d), y.addConstraint(h, f), h;
            }, f.softBody = function(t, e, i, n, s, r, o, a, h, l) {
                h = v.extend({
                    inertia: 1 / 0
                }, h), l = v.extend({
                    stiffness: .2,
                    render: {
                        type: "line",
                        anchors: !1
                    }
                }, l);
                var u = f.stack(t, e, i, n, s, r, function(t, e) {
                    return p.circle(t, e, a, h);
                });
                return f.mesh(u, i, n, o, l), u.label = "Soft Body", u;
            };
        },
        function(t, e, i) {
            var x = {};
            t.exports = x;
            i(117);
            var T = i(50);
            x.pathToVertices = function(t, e) {
                "undefined" == typeof window || "SVGPathSeg" in window || T.warn("Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.");
                var i, n, s, r, o, a, h, l, u, c, d, f = [], p = 0, g = 0, v = 0;
                e = e || 15;
                function m(t, e, i) {
                    var n, s = i % 2 == 1 && 1 < i;
                    u && t == u.x && e == u.y || (d = u && s ? (c = u.x, u.y) : c = 0, n = {
                        x: c + t,
                        y: d + e
                    }, !s && u || (u = n), f.push(n), g = c + t, v = d + e);
                }
                function y(t) {
                    var e = t.pathSegTypeAsLetter.toUpperCase();
                    if ("Z" !== e) {
                        switch(e){
                            case "M":
                            case "L":
                            case "T":
                            case "C":
                            case "S":
                            case "Q":
                                g = t.x, v = t.y;
                                break;
                            case "H":
                                g = t.x;
                                break;
                            case "V":
                                v = t.y;
                        }
                        m(g, v, t.pathSegType);
                    }
                }
                for(x._svgPathToAbsolute(t), s = t.getTotalLength(), a = [], i = 0; i < t.pathSegList.numberOfItems; i += 1)a.push(t.pathSegList.getItem(i));
                for(h = a.concat(); p < s;){
                    if ((o = a[t.getPathSegAtLength(p)]) != l) {
                        for(; h.length && h[0] != o;)y(h.shift());
                        l = o;
                    }
                    switch(o.pathSegTypeAsLetter.toUpperCase()){
                        case "C":
                        case "T":
                        case "S":
                        case "Q":
                        case "A":
                            r = t.getPointAtLength(p), m(r.x, r.y, 0);
                    }
                    p += e;
                }
                for(i = 0, n = h.length; i < n; ++i)y(h[i]);
                return f;
            }, x._svgPathToAbsolute = function(t) {
                for(var e, i, n, s, r, o, a = t.pathSegList, h = 0, l = 0, u = a.numberOfItems, c = 0; c < u; ++c){
                    var d = a.getItem(c), f = d.pathSegTypeAsLetter;
                    if (/[MLHVCSQTA]/.test(f)) "x" in d && (h = d.x), "y" in d && (l = d.y);
                    else switch("x1" in d && (n = h + d.x1), "x2" in d && (r = h + d.x2), "y1" in d && (s = l + d.y1), "y2" in d && (o = l + d.y2), "x" in d && (h += d.x), "y" in d && (l += d.y), f){
                        case "m":
                            a.replaceItem(t.createSVGPathSegMovetoAbs(h, l), c);
                            break;
                        case "l":
                            a.replaceItem(t.createSVGPathSegLinetoAbs(h, l), c);
                            break;
                        case "h":
                            a.replaceItem(t.createSVGPathSegLinetoHorizontalAbs(h), c);
                            break;
                        case "v":
                            a.replaceItem(t.createSVGPathSegLinetoVerticalAbs(l), c);
                            break;
                        case "c":
                            a.replaceItem(t.createSVGPathSegCurvetoCubicAbs(h, l, n, s, r, o), c);
                            break;
                        case "s":
                            a.replaceItem(t.createSVGPathSegCurvetoCubicSmoothAbs(h, l, r, o), c);
                            break;
                        case "q":
                            a.replaceItem(t.createSVGPathSegCurvetoQuadraticAbs(h, l, n, s), c);
                            break;
                        case "t":
                            a.replaceItem(t.createSVGPathSegCurvetoQuadraticSmoothAbs(h, l), c);
                            break;
                        case "a":
                            a.replaceItem(t.createSVGPathSegArcAbs(h, l, d.r1, d.r2, d.angle, d.largeArcFlag, d.sweepFlag), c);
                            break;
                        case "z":
                        case "Z":
                            h = e, l = i;
                    }
                    "M" != f && "m" != f || (e = h, i = l);
                }
            };
        },
        function(t, e, i) {
            var y = i(126), x = i(71), n = i(0), s = i(534), o = i(9), T = i(2), w = i(125), b = i(94), r = new n({
                Extends: o,
                Mixins: [
                    s.Bounce,
                    s.Collision,
                    s.Friction,
                    s.Gravity,
                    s.Mass,
                    s.Sensor,
                    s.Sleep,
                    s.Static
                ],
                initialize: function(t, e, i) {
                    o.call(this), this.tile = e, this.world = t, e.physics.matterBody && e.physics.matterBody.destroy(), e.physics.matterBody = this;
                    var n, s = T(i, "body", null), r = T(i, "addToWorld", !0);
                    s ? this.setBody(s, r) : (n = e.getCollisionGroup(), 0 < T(n, "objects", []).length ? this.setFromTileCollision(i) : this.setFromTileRectangle(i));
                },
                setFromTileRectangle: function(t) {
                    void 0 === t && (t = {}), w(t, "isStatic") || (t.isStatic = !0), w(t, "addToWorld") || (t.addToWorld = !0);
                    var e = this.tile.getBounds(), i = e.x + e.width / 2, n = e.y + e.height / 2, s = y.rectangle(i, n, e.width, e.height, t);
                    return this.setBody(s, t.addToWorld), this;
                },
                setFromTileCollision: function(t) {
                    void 0 === t && (t = {}), w(t, "isStatic") || (t.isStatic = !0), w(t, "addToWorld") || (t.addToWorld = !0);
                    for(var e = this.tile.tilemapLayer.scaleX, i = this.tile.tilemapLayer.scaleY, n = this.tile.getLeft(), s = this.tile.getTop(), r = this.tile.getCollisionGroup(), o = T(r, "objects", []), a = [], h = 0; h < o.length; h++){
                        var l, u, c, d = o[h], f = n + d.x * e, p = s + d.y * i, g = d.width * e, v = d.height * i, m = null;
                        d.rectangle ? m = y.rectangle(f + g / 2, p + v / 2, g, v, t) : d.ellipse ? m = y.circle(f + g / 2, p + v / 2, g / 2, t) : (d.polygon || d.polyline) && (l = (d.polygon ? d.polygon : d.polyline).map(function(t) {
                            return {
                                x: t.x * e,
                                y: t.y * i
                            };
                        }), u = b.create(l), f += (c = b.centre(u)).x, p += c.y, m = y.fromVertices(f, p, u, t)), m && a.push(m);
                    }
                    return 1 === a.length ? this.setBody(a[0], t.addToWorld) : 1 < a.length && (t.parts = a, this.setBody(x.create(t), t.addToWorld)), this;
                },
                setBody: function(t, e) {
                    return void 0 === e && (e = !0), this.body && this.removeBody(), this.body = t, this.body.gameObject = this, e && this.world.add(this.body), this;
                },
                removeBody: function() {
                    return this.body && (this.world.remove(this.body), this.body.gameObject = void 0, this.body = void 0), this;
                },
                destroy: function() {
                    this.removeBody(), this.tile.physics.matterBody = void 0, this.removeAllListeners();
                }
            });
            t.exports = r;
        },
        function(t, e, i) {
            var n = i(1493);
            n.Body = i(71), n.Composite = i(163), n.World = i(1393), n.Detector = i(587), n.Grid = i(1394), n.Pairs = i(1395), n.Pair = i(535), n.Query = i(1494), n.Resolver = i(1396), n.SAT = i(588), n.Constraint = i(246), n.Common = i(50), n.Engine = i(1495), n.Events = i(268), n.Sleeping = i(267), n.Plugin = i(1392), n.Bodies = i(126), n.Composites = i(1388), n.Axes = i(585), n.Bounds = i(117), n.Svg = i(1389), n.Vector = i(116), n.Vertices = i(94), n.World.add = n.Composite.add, n.World.remove = n.Composite.remove, n.World.addComposite = n.Composite.addComposite, n.World.addBody = n.Composite.addBody, n.World.addConstraint = n.Composite.addConstraint, n.World.clear = n.Composite.clear, t.exports = n;
        },
        function(t, e, i) {
            var a = {};
            t.exports = a;
            var h = i(50);
            a._registry = {}, a.register = function(t) {
                var e, i, n;
                return a.isPlugin(t) || h.warn("Plugin.register:", a.toString(t), "does not implement all required fields."), t.name in a._registry ? (e = a._registry[t.name], i = a.versionParse(t.version).number, (n = a.versionParse(e.version).number) < i ? (h.warn("Plugin.register:", a.toString(e), "was upgraded to", a.toString(t)), a._registry[t.name] = t) : i < n ? h.warn("Plugin.register:", a.toString(e), "can not be downgraded to", a.toString(t)) : t !== e && h.warn("Plugin.register:", a.toString(t), "is already registered to different plugin object")) : a._registry[t.name] = t, t;
            }, a.resolve = function(t) {
                return a._registry[a.dependencyParse(t).name];
            }, a.toString = function(t) {
                return "string" == typeof t ? t : (t.name || "anonymous") + "@" + (t.version || t.range || "0.0.0");
            }, a.isPlugin = function(t) {
                return t && t.name && t.version && t.install;
            }, a.isUsed = function(t, e) {
                return -1 < t.used.indexOf(e);
            }, a.isFor = function(t, e) {
                var i = t.for && a.dependencyParse(t.for);
                return !t.for || e.name === i.name && a.versionSatisfies(e.version, i.range);
            }, a.use = function(t, e) {
                if (t.uses = (t.uses || []).concat(e || []), 0 !== t.uses.length) {
                    for(var i, n = a.dependencies(t), s = h.topologicalSort(n), r = [], o = 0; o < s.length; o += 1)s[o] !== t.name && ((i = a.resolve(s[o])) ? a.isUsed(t, i.name) || (a.isFor(i, t) || (h.warn("Plugin.use:", a.toString(i), "is for", i.for, "but installed on", a.toString(t) + "."), i._warned = !0), i.install ? i.install(t) : (h.warn("Plugin.use:", a.toString(i), "does not specify an install function."), i._warned = !0), i._warned ? (r.push("\uD83D\uDD36 " + a.toString(i)), delete i._warned) : r.push("\u2705 " + a.toString(i)), t.used.push(i.name)) : r.push("\u274C " + s[o]));
                    0 < r.length && !i.silent && h.info(r.join("  "));
                } else h.warn("Plugin.use:", a.toString(t), "does not specify any dependencies to install.");
            }, a.dependencies = function(n, t) {
                var s = a.dependencyParse(n), e = s.name;
                if (!(e in (t = t || {}))) {
                    n = a.resolve(n) || n, t[e] = h.map(n.uses || [], function(t) {
                        a.isPlugin(t) && a.register(t);
                        var e = a.dependencyParse(t), i = a.resolve(t);
                        return i && !a.versionSatisfies(i.version, e.range) ? (h.warn("Plugin.dependencies:", a.toString(i), "does not satisfy", a.toString(e), "used by", a.toString(s) + "."), i._warned = !0, n._warned = !0) : i || (h.warn("Plugin.dependencies:", a.toString(t), "used by", a.toString(s), "could not be resolved."), n._warned = !0), e.name;
                    });
                    for(var i = 0; i < t[e].length; i += 1)a.dependencies(t[e][i], t);
                    return t;
                }
            }, a.dependencyParse = function(t) {
                if (h.isString(t)) return /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?))?$/.test(t) || h.warn("Plugin.dependencyParse:", t, "is not a valid dependency string."), {
                    name: t.split("@")[0],
                    range: t.split("@")[1] || "*"
                };
                return {
                    name: t.name,
                    range: t.range || t.version
                };
            }, a.versionParse = function(t) {
                /^\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?$/.test(t) || h.warn("Plugin.versionParse:", t, "is not a valid version or range.");
                var e = t.split("-");
                t = e[0];
                var i = isNaN(Number(t[0])), n = i ? t.substr(1) : t, s = h.map(n.split("."), function(t) {
                    return Number(t);
                });
                return {
                    isRange: i,
                    version: n,
                    range: t,
                    operator: i ? t[0] : "",
                    parts: s,
                    prerelease: e[1],
                    number: 1e8 * s[0] + 1e4 * s[1] + s[2]
                };
            }, a.versionSatisfies = function(t, e) {
                e = e || "*";
                var i = a.versionParse(e), n = i.parts, s = a.versionParse(t), r = s.parts;
                if (i.isRange) {
                    if ("*" === i.operator || "*" === t) return !0;
                    if ("~" === i.operator) return r[0] === n[0] && r[1] === n[1] && r[2] >= n[2];
                    if ("^" === i.operator) return 0 < n[0] ? r[0] === n[0] && s.number >= i.number : 0 < n[1] ? r[1] === n[1] && r[2] >= n[2] : r[2] === n[2];
                }
                return t === e || "*" === t;
            };
        },
        function(t, e, i) {
            var n = {};
            t.exports = n;
            var s = i(163), r = (i(246), i(50));
            n.create = function(t) {
                var e = s.create(), i = {
                    label: "World",
                    gravity: {
                        x: 0,
                        y: 1,
                        scale: .001
                    },
                    bounds: {
                        min: {
                            x: -1 / 0,
                            y: -1 / 0
                        },
                        max: {
                            x: 1 / 0,
                            y: 1 / 0
                        }
                    }
                };
                return r.extend(e, i, t);
            };
        },
        function(t, e, i) {
            var y = {};
            t.exports = y;
            var a = i(535), n = i(587), r = i(50);
            y.create = function(t) {
                var e = {
                    controller: y,
                    detector: n.collisions,
                    buckets: {},
                    pairs: {},
                    pairsList: [],
                    bucketWidth: 48,
                    bucketHeight: 48
                };
                return r.extend(e, t);
            }, y.update = function(t, e, i, n) {
                for(var s, r, o, a = i.world, h = t.buckets, l = !1, u = i.metrics, c = u.broadphaseTests = 0; c < e.length; c++){
                    var d = e[c];
                    if ((!d.isSleeping || n) && !(d.bounds.max.x < a.bounds.min.x || d.bounds.min.x > a.bounds.max.x || d.bounds.max.y < a.bounds.min.y || d.bounds.min.y > a.bounds.max.y)) {
                        var f = y._getRegion(t, d);
                        if (!d.region || f.id !== d.region.id || n) {
                            u.broadphaseTests += 1, d.region && !n || (d.region = f);
                            for(var p = y._regionUnion(f, d.region), g = p.startCol; g <= p.endCol; g++)for(s = p.startRow; s <= p.endRow; s++){
                                r = h[o = y._getBucketId(g, s)];
                                var v = g >= f.startCol && g <= f.endCol && s >= f.startRow && s <= f.endRow, m = g >= d.region.startCol && g <= d.region.endCol && s >= d.region.startRow && s <= d.region.endRow;
                                !v && m && m && r && y._bucketRemoveBody(t, r, d), (d.region === f || v && !m || n) && (r = r || y._createBucket(h, o), y._bucketAddBody(t, r, d));
                            }
                            d.region = f, l = !0;
                        }
                    }
                }
                l && (t.pairsList = y._createActivePairsList(t));
            }, y.clear = function(t) {
                t.buckets = {}, t.pairs = {}, t.pairsList = [];
            }, y._regionUnion = function(t, e) {
                var i = Math.min(t.startCol, e.startCol), n = Math.max(t.endCol, e.endCol), s = Math.min(t.startRow, e.startRow), r = Math.max(t.endRow, e.endRow);
                return y._createRegion(i, n, s, r);
            }, y._getRegion = function(t, e) {
                var i = e.bounds, n = Math.floor(i.min.x / t.bucketWidth), s = Math.floor(i.max.x / t.bucketWidth), r = Math.floor(i.min.y / t.bucketHeight), o = Math.floor(i.max.y / t.bucketHeight);
                return y._createRegion(n, s, r, o);
            }, y._createRegion = function(t, e, i, n) {
                return {
                    id: t + "," + e + "," + i + "," + n,
                    startCol: t,
                    endCol: e,
                    startRow: i,
                    endRow: n
                };
            }, y._getBucketId = function(t, e) {
                return "C" + t + "R" + e;
            }, y._createBucket = function(t, e) {
                return t[e] = [];
            }, y._bucketAddBody = function(t, e, i) {
                for(var n = 0; n < e.length; n++){
                    var s, r, o = e[n];
                    i.id === o.id || i.isStatic && o.isStatic || (s = a.id(i, o), (r = t.pairs[s]) ? r[2] += 1 : t.pairs[s] = [
                        i,
                        o,
                        1
                    ]);
                }
                e.push(i);
            }, y._bucketRemoveBody = function(t, e, i) {
                e.splice(e.indexOf(i), 1);
                for(var n = 0; n < e.length; n++){
                    var s = e[n], r = a.id(i, s), o = t.pairs[r];
                    o && --o[2];
                }
            }, y._createActivePairsList = function(t) {
                for(var e, i = [], n = r.keys(t.pairs), s = 0; s < n.length; s++)0 < (e = t.pairs[n[s]])[2] ? i.push(e) : delete t.pairs[n[s]];
                return i;
            };
        },
        function(t, e, i) {
            var l = {};
            t.exports = l;
            var d = i(535), n = i(50);
            l._pairMaxIdleLife = 1e3, l.create = function(t) {
                return n.extend({
                    table: {},
                    list: [],
                    collisionStart: [],
                    collisionActive: [],
                    collisionEnd: []
                }, t);
            }, l.update = function(t, e, i) {
                var n, s, r, o, a = t.list, h = t.table, l = t.collisionStart, u = t.collisionEnd, c = t.collisionActive;
                for(l.length = 0, u.length = 0, o = c.length = 0; o < a.length; o++)a[o].confirmedActive = !1;
                for(o = 0; o < e.length; o++)(n = e[o]).collided && ((r = h[s = d.id(n.bodyA, n.bodyB)]) ? (r.isActive ? c.push(r) : l.push(r), d.update(r, n, i), r.confirmedActive = !0) : (r = d.create(n, i), h[s] = r, l.push(r), a.push(r)));
                for(o = 0; o < a.length; o++)(r = a[o]).isActive && !r.confirmedActive && (d.setActive(r, !1, i), u.push(r));
            }, l.removeOld = function(t, e) {
                for(var i, n, s, r = t.list, o = t.table, a = [], h = 0; h < r.length; h++)(n = (i = r[h]).collision).bodyA.isSleeping || n.bodyB.isSleeping ? i.timeUpdated = e : e - i.timeUpdated > l._pairMaxIdleLife && a.push(h);
                for(h = 0; h < a.length; h++)delete o[(i = r[s = a[h] - h]).id], r.splice(s, 1);
            }, l.clear = function(t) {
                return t.table = {}, t.list.length = 0, t.collisionStart.length = 0, t.collisionActive.length = 0, t.collisionEnd.length = 0, t;
            };
        },
        function(t, e, i) {
            var Y = {};
            t.exports = Y;
            var r = i(94), U = i(116), X = i(50), o = i(117);
            Y._restingThresh = 4, Y._restingThreshTangent = 6, Y._positionDampen = .9, Y._positionWarming = .8, Y._frictionNormalMultiplier = 5, Y.preSolvePosition = function(t) {
                for(var e, i, n = 0; n < t.length; n++)(e = t[n]).isActive && (i = e.activeContacts.length, e.collision.parentA.totalContacts += i, e.collision.parentB.totalContacts += i);
            }, Y.solvePosition = function(t, e, i) {
                for(var n, s, r, o, a, h, l, u, c, d, f, p, g, v, m, y = i * Y._positionDampen, x = 0; x < e.length; x++){
                    var T = e[x];
                    T.previousPositionImpulse.x = T.positionImpulse.x, T.previousPositionImpulse.y = T.positionImpulse.y;
                }
                for(x = 0; x < t.length; x++)(r = t[x]).isActive && !r.isSensor && (a = (o = r.collision).parentA, h = o.parentB, l = o.normal, d = a.previousPositionImpulse, f = h.previousPositionImpulse, c = o.penetration, g = f.x - d.x + c.x, v = f.y - d.y + c.y, u = (n = l.x) * g + (s = l.y) * v, m = ((r.separation = u) - r.slop) * y, (a.isStatic || h.isStatic) && (m *= 2), a.isStatic || a.isSleeping || (p = m / a.totalContacts, a.positionImpulse.x += n * p, a.positionImpulse.y += s * p), h.isStatic || h.isSleeping || (p = m / h.totalContacts, h.positionImpulse.x -= n * p, h.positionImpulse.y -= s * p));
            }, Y.postSolvePosition = function(t) {
                for(var e = 0; e < t.length; e++){
                    var i = t[e];
                    if ((i.totalContacts = 0) !== i.positionImpulse.x || 0 !== i.positionImpulse.y) {
                        for(var n = 0; n < i.parts.length; n++){
                            var s = i.parts[n];
                            r.translate(s.vertices, i.positionImpulse), o.update(s.bounds, s.vertices, i.velocity), s.position.x += i.positionImpulse.x, s.position.y += i.positionImpulse.y;
                        }
                        i.positionPrev.x += i.positionImpulse.x, i.positionPrev.y += i.positionImpulse.y, U.dot(i.positionImpulse, i.velocity) < 0 ? (i.positionImpulse.x = 0, i.positionImpulse.y = 0) : (i.positionImpulse.x *= Y._positionWarming, i.positionImpulse.y *= Y._positionWarming);
                    }
                }
            }, Y.preSolveVelocity = function(t) {
                for(var e, i, n, s, r, o, a, h, l, u, c, d, f, p = U._temp[0], g = U._temp[1], v = 0; v < t.length; v++)if ((i = t[v]).isActive && !i.isSensor) for(n = i.activeContacts, r = (s = i.collision).parentA, o = s.parentB, a = s.normal, h = s.tangent, e = 0; e < n.length; e++)u = (l = n[e]).vertex, c = l.normalImpulse, d = l.tangentImpulse, 0 === c && 0 === d || (p.x = a.x * c + h.x * d, p.y = a.y * c + h.y * d, r.isStatic || r.isSleeping || (f = U.sub(u, r.position, g), r.positionPrev.x += p.x * r.inverseMass, r.positionPrev.y += p.y * r.inverseMass, r.anglePrev += U.cross(f, p) * r.inverseInertia), o.isStatic || o.isSleeping || (f = U.sub(u, o.position, g), o.positionPrev.x -= p.x * o.inverseMass, o.positionPrev.y -= p.y * o.inverseMass, o.anglePrev -= U.cross(f, p) * o.inverseInertia));
            }, Y.solveVelocity = function(t, e) {
                for(var i = e * e, n = U._temp[0], s = U._temp[1], r = U._temp[2], o = U._temp[3], a = U._temp[4], h = U._temp[5], l = 0; l < t.length; l++){
                    var u = t[l];
                    if (u.isActive && !u.isSensor) {
                        var c = u.collision, d = c.parentA, f = c.parentB, p = c.normal, g = c.tangent, v = u.activeContacts, m = 1 / v.length;
                        d.velocity.x = d.position.x - d.positionPrev.x, d.velocity.y = d.position.y - d.positionPrev.y, f.velocity.x = f.position.x - f.positionPrev.x, f.velocity.y = f.position.y - f.positionPrev.y, d.angularVelocity = d.angle - d.anglePrev, f.angularVelocity = f.angle - f.anglePrev;
                        for(var y = 0; y < v.length; y++){
                            var x = v[y], T = x.vertex, w = U.sub(T, d.position, s), b = U.sub(T, f.position, r), E = U.add(d.velocity, U.mult(U.perp(w), d.angularVelocity), o), S = U.add(f.velocity, U.mult(U.perp(b), f.angularVelocity), a), A = U.sub(E, S, h), _ = U.dot(p, A), C = U.dot(g, A), M = Math.abs(C), R = X.sign(C), P = (1 + u.restitution) * _, O = X.clamp(u.separation + _, 0, 1) * Y._frictionNormalMultiplier, L = C, D = 1 / 0;
                            M > u.friction * u.frictionStatic * O * i && (D = M, L = X.clamp(u.friction * R * i, -D, D));
                            var F, k, I = U.cross(w, p), B = U.cross(b, p), N = m / (d.inverseMass + f.inverseMass + d.inverseInertia * I * I + f.inverseInertia * B * B);
                            P *= N, L *= N, _ < 0 && _ * _ > Y._restingThresh * i ? x.normalImpulse = 0 : (F = x.normalImpulse, x.normalImpulse = Math.min(x.normalImpulse + P, 0), P = x.normalImpulse - F), C * C > Y._restingThreshTangent * i ? x.tangentImpulse = 0 : (k = x.tangentImpulse, x.tangentImpulse = X.clamp(x.tangentImpulse + L, -D, D), L = x.tangentImpulse - k), n.x = p.x * P + g.x * L, n.y = p.y * P + g.y * L, d.isStatic || d.isSleeping || (d.positionPrev.x += n.x * d.inverseMass, d.positionPrev.y += n.y * d.inverseMass, d.anglePrev += U.cross(w, n) * d.inverseInertia), f.isStatic || f.isSleeping || (f.positionPrev.x -= n.x * f.inverseMass, f.positionPrev.y -= n.y * f.inverseMass, f.anglePrev -= U.cross(b, n) * f.inverseInertia);
                        }
                    }
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                BasePlugin: i(536),
                DefaultPlugins: i(194),
                PluginCache: i(24),
                PluginManager: i(408),
                ScenePlugin: i(1398)
            };
        },
        function(t, e, i) {
            var n = i(536), s = i(0), r = i(21), o = new s({
                Extends: n,
                initialize: function(t, e) {
                    n.call(this, e), this.scene = t, this.systems = t.sys, t.sys.events.once(r.BOOT, this.boot, this);
                },
                boot: function() {},
                destroy: function() {
                    this.pluginManager = null, this.game = null, this.scene = null, this.systems = null;
                }
            });
            t.exports = o;
        },
        function(t, e, i) {
            t.exports = {
                Canvas: i(1400),
                Events: i(88),
                Snapshot: i(1401),
                WebGL: i(1402)
            };
        },
        function(t, e, i) {
            t.exports = {
                CanvasRenderer: i(362),
                GetBlendModes: i(364),
                SetTransform: i(30)
            };
        },
        function(t, e, i) {
            t.exports = {
                Canvas: i(363),
                WebGL: i(377)
            };
        },
        function(t, e, i) {
            var n = i(104), s = i(17)(!1, s = {
                PipelineManager: i(366),
                Pipelines: i(1403),
                RenderTarget: i(139),
                Utils: i(12),
                WebGLPipeline: i(57),
                WebGLRenderer: i(365),
                WebGLShader: i(369)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(65), s = i(17)(!1, s = {
                BitmapMaskPipeline: i(367),
                Events: i(368),
                GraphicsPipeline: i(370),
                LightPipeline: i(371),
                MultiPipeline: i(105),
                PointLightPipeline: i(372),
                PostFXPipeline: i(1404),
                RopePipeline: i(373),
                SinglePipeline: i(374),
                UtilityPipeline: i(375)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(0), s = i(195), r = i(2), o = i(1405), a = i(376), h = i(57), l = new n({
                Extends: h,
                initialize: function(t) {
                    t.renderTarget = r(t, "renderTarget", 1), t.fragShader = r(t, "fragShader", o), t.vertShader = r(t, "vertShader", a), t.attributes = r(t, "attributes", [
                        {
                            name: "inPosition",
                            size: 2
                        },
                        {
                            name: "inTexCoord",
                            size: 2
                        }
                    ]), t.batchSize = 1, t.vertices = [
                        -1,
                        -1,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        -1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        1,
                        0
                    ], h.call(this, t), this.isPostFX = !0, this.gameObject, this.colorMatrix = new s, this.fullFrame1, this.fullFrame2, this.halfFrame1, this.halfFrame2, this.renderer.isBooted && (this.manager = this.renderer.pipelines, this.boot());
                },
                boot: function() {
                    h.prototype.boot.call(this);
                    var t = this.manager.UTILITY_PIPELINE;
                    this.fullFrame1 = t.fullFrame1, this.fullFrame2 = t.fullFrame2, this.halfFrame1 = t.halfFrame1, this.halfFrame2 = t.halfFrame2, this.set1i("uMainSampler", 0);
                },
                onDraw: function(t) {
                    this.bindAndDraw(t);
                },
                copyFrame: function(t, e, i, n, s) {
                    this.manager.copyFrame(t, e, i, n, s);
                },
                copyToGame: function(t) {
                    this.manager.copyToGame(t);
                },
                drawFrame: function(t, e, i) {
                    this.manager.drawFrame(t, e, i, this.colorMatrix);
                },
                blendFrames: function(t, e, i, n, s) {
                    this.manager.blendFrames(t, e, i, n, s);
                },
                blendFramesAdditive: function(t, e, i, n, s) {
                    this.manager.blendFramesAdditive(t, e, i, n, s);
                },
                clearFrame: function(t, e) {
                    this.manager.clearFrame(t, e);
                },
                blitFrame: function(t, e, i, n, s, r) {
                    this.manager.blitFrame(t, e, i, n, s, r);
                },
                copyFrameRect: function(t, e, i, n, s, r, o, a) {
                    this.manager.copyFrameRect(t, e, i, n, s, r, o, a);
                },
                bindAndDraw: function(t, e, i, n, s) {
                    void 0 === i && (i = !0), void 0 === n && (n = !0);
                    var r = this.gl, o = this.renderer;
                    this.bind(s), this.set1i("uMainSampler", 0), e ? (r.viewport(0, 0, e.width, e.height), r.bindFramebuffer(r.FRAMEBUFFER, e.framebuffer), r.framebufferTexture2D(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, e.texture, 0), i && (n ? r.clearColor(0, 0, 0, 0) : r.clearColor(0, 0, 0, 1), r.clear(r.COLOR_BUFFER_BIT))) : (o.popFramebuffer(!1, !1, !1), o.currentFramebuffer || r.viewport(0, 0, o.width, o.height)), r.activeTexture(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, t.texture), r.bufferData(r.ARRAY_BUFFER, this.vertexData, r.STATIC_DRAW), r.drawArrays(r.TRIANGLES, 0, 6), e ? (r.bindTexture(r.TEXTURE_2D, null), r.bindFramebuffer(r.FRAMEBUFFER, null)) : o.resetTextures();
                }
            });
            t.exports = l;
        },
        function(t, e) {
            t.exports = [
                "#define SHADER_NAME PHASER_POSTFX_FS",
                "",
                "precision mediump float;",
                "",
                "uniform sampler2D uMainSampler;",
                "",
                "varying vec2 outTexCoord;",
                "",
                "void main ()",
                "{",
                "    gl_FragColor = texture2D(uMainSampler, outTexCoord);",
                "}",
                ""
            ].join("\n");
        },
        function(t, e, i) {
            var n = i(17), s = i(198), r = n(!1, r = {
                Center: i(397),
                Events: i(101),
                Orientation: i(398),
                ScaleManager: i(409),
                ScaleModes: i(399),
                Zoom: i(400)
            }, s.CENTER);
            r = n(!1, r, s.ORIENTATION), r = n(!1, r, s.SCALE_MODE), r = n(!1, r, s.ZOOM), t.exports = r;
        },
        function(t, e, i) {
            var n = i(142), s = i(17)(!1, s = {
                Events: i(21),
                GetPhysicsPlugins: i(413),
                GetScenePlugins: i(414),
                SceneManager: i(411),
                ScenePlugin: i(1408),
                Settings: i(415),
                Systems: i(201)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            var n = i(18), s = i(0), a = i(21), h = i(2), r = i(24), o = new s({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.settings = t.sys.settings, this.key = t.sys.settings.key, this.manager = t.sys.game.scene, this.transitionProgress = 0, this._elapsed = 0, this._target = null, this._duration = 0, this._onUpdate, this._onUpdateScope, this._willSleep = !1, this._willRemove = !1, t.sys.events.once(a.BOOT, this.boot, this), t.sys.events.on(a.START, this.pluginStart, this);
                },
                boot: function() {
                    this.systems.events.once(a.DESTROY, this.destroy, this);
                },
                pluginStart: function() {
                    this._target = null, this.systems.events.once(a.SHUTDOWN, this.shutdown, this);
                },
                start: function(t, e) {
                    return void 0 === t && (t = this.key), this.manager.queueOp("stop", this.key), this.manager.queueOp("start", t, e), this;
                },
                restart: function(t) {
                    var e = this.key;
                    return this.manager.queueOp("stop", e), this.manager.queueOp("start", e, t), this;
                },
                transition: function(t) {
                    void 0 === t && (t = {});
                    var e = h(t, "target", !1), i = this.manager.getScene(e);
                    if (!e || !this.checkValidTransition(i)) return !1;
                    var n = h(t, "duration", 1e3);
                    this._elapsed = 0, this._target = i, this._duration = n, this._willSleep = h(t, "sleep", !1), this._willRemove = h(t, "remove", !1);
                    var s = h(t, "onUpdate", null);
                    s && (this._onUpdate = s, this._onUpdateScope = h(t, "onUpdateScope", this.scene));
                    var r = h(t, "allowInput", !1);
                    this.settings.transitionAllowInput = r;
                    var o = i.sys.settings;
                    return o.isTransition = !0, o.transitionFrom = this.scene, o.transitionDuration = n, o.transitionAllowInput = r, h(t, "moveAbove", !1) ? this.manager.moveAbove(this.key, e) : h(t, "moveBelow", !1) && this.manager.moveBelow(this.key, e), i.sys.isSleeping() ? i.sys.wake(h(t, "data")) : this.manager.start(e, h(t, "data")), this.systems.events.emit(a.TRANSITION_OUT, i, n), this.systems.events.on(a.UPDATE, this.step, this), !0;
                },
                checkValidTransition: function(t) {
                    return !(!t || t.sys.isActive() || t.sys.isTransitioning() || t === this.scene || this.systems.isTransitioning());
                },
                step: function(t, e) {
                    this._elapsed += e, this.transitionProgress = n(this._elapsed / this._duration, 0, 1), this._onUpdate && this._onUpdate.call(this._onUpdateScope, this.transitionProgress), this._elapsed >= this._duration && this.transitionComplete();
                },
                transitionComplete: function() {
                    var t = this._target.sys, e = this._target.sys.settings;
                    this.systems.events.off(a.UPDATE, this.step, this), t.events.emit(a.TRANSITION_COMPLETE, this.scene), e.isTransition = !1, e.transitionFrom = null, this._duration = 0, this._target = null, this._onUpdate = null, this._onUpdateScope = null, this._willRemove ? this.manager.remove(this.key) : this._willSleep ? this.systems.sleep() : this.manager.stop(this.key);
                },
                add: function(t, e, i, n) {
                    return this.manager.add(t, e, i, n);
                },
                launch: function(t, e) {
                    return t && t !== this.key && this.manager.queueOp("start", t, e), this;
                },
                run: function(t, e) {
                    return t && t !== this.key && this.manager.queueOp("run", t, e), this;
                },
                pause: function(t, e) {
                    return void 0 === t && (t = this.key), this.manager.queueOp("pause", t, e), this;
                },
                resume: function(t, e) {
                    return void 0 === t && (t = this.key), this.manager.queueOp("resume", t, e), this;
                },
                sleep: function(t, e) {
                    return void 0 === t && (t = this.key), this.manager.queueOp("sleep", t, e), this;
                },
                wake: function(t, e) {
                    return void 0 === t && (t = this.key), this.manager.queueOp("wake", t, e), this;
                },
                switch: function(t) {
                    return t !== this.key && this.manager.queueOp("switch", this.key, t), this;
                },
                stop: function(t, e) {
                    return void 0 === t && (t = this.key), this.manager.queueOp("stop", t, e), this;
                },
                setActive: function(t, e, i) {
                    void 0 === e && (e = this.key);
                    var n = this.manager.getScene(e);
                    return n && n.sys.setActive(t, i), this;
                },
                setVisible: function(t, e) {
                    void 0 === e && (e = this.key);
                    var i = this.manager.getScene(e);
                    return i && i.sys.setVisible(t), this;
                },
                isSleeping: function(t) {
                    return void 0 === t && (t = this.key), this.manager.isSleeping(t);
                },
                isActive: function(t) {
                    return void 0 === t && (t = this.key), this.manager.isActive(t);
                },
                isPaused: function(t) {
                    return void 0 === t && (t = this.key), this.manager.isPaused(t);
                },
                isVisible: function(t) {
                    return void 0 === t && (t = this.key), this.manager.isVisible(t);
                },
                swapPosition: function(t, e) {
                    return void 0 === e && (e = this.key), t !== e && this.manager.swapPosition(t, e), this;
                },
                moveAbove: function(t, e) {
                    return void 0 === e && (e = this.key), t !== e && this.manager.moveAbove(t, e), this;
                },
                moveBelow: function(t, e) {
                    return void 0 === e && (e = this.key), t !== e && this.manager.moveBelow(t, e), this;
                },
                remove: function(t) {
                    return void 0 === t && (t = this.key), this.manager.remove(t), this;
                },
                moveUp: function(t) {
                    return void 0 === t && (t = this.key), this.manager.moveUp(t), this;
                },
                moveDown: function(t) {
                    return void 0 === t && (t = this.key), this.manager.moveDown(t), this;
                },
                bringToTop: function(t) {
                    return void 0 === t && (t = this.key), this.manager.bringToTop(t), this;
                },
                sendToBack: function(t) {
                    return void 0 === t && (t = this.key), this.manager.sendToBack(t), this;
                },
                get: function(t) {
                    return this.manager.getScene(t);
                },
                getIndex: function(t) {
                    return void 0 === t && (t = this.key), this.manager.getIndex(t);
                },
                shutdown: function() {
                    var t = this.systems.events;
                    t.off(a.SHUTDOWN, this.shutdown, this), t.off(a.POST_UPDATE, this.step, this), t.off(a.TRANSITION_OUT);
                },
                destroy: function() {
                    this.shutdown(), this.scene.sys.events.off(a.START, this.start, this), this.scene = null, this.systems = null, this.settings = null, this.manager = null;
                }
            });
            r.register("ScenePlugin", o, "scenePlugin"), t.exports = o;
        },
        function(t, e, i) {
            t.exports = {
                Events: i(432),
                List: i(107),
                Map: i(99),
                ProcessQueue: i(208),
                RTree: i(525),
                Set: i(148),
                Size: i(410)
            };
        },
        function(t, e, i) {
            var n = i(17), s = i(1411), r = n(!1, r = {
                CanvasTexture: i(417),
                Events: i(103),
                FilterMode: s,
                Frame: i(106),
                Parsers: i(419),
                Texture: i(203),
                TextureManager: i(416),
                TextureSource: i(418)
            }, s);
            t.exports = r;
        },
        function(t, e) {
            t.exports = {
                LINEAR: 0,
                NEAREST: 1
            };
        },
        function(t, e, i) {
            var n = i(17), s = i(1413), r = n(!1, r = {
                Components: i(247),
                Parsers: i(1446),
                Formats: i(39),
                ImageCollection: i(572),
                ParseToTilemap: i(258),
                Tile: i(83),
                Tilemap: i(576),
                TilemapCreator: i(1452),
                TilemapFactory: i(1453),
                Tileset: i(121),
                TilemapLayer: i(577),
                Orientation: i(29),
                LayerData: i(119),
                MapData: i(120),
                ObjectLayer: i(568)
            }, s.ORIENTATION);
            t.exports = r;
        },
        function(t, e, i) {
            var n = {
                ORIENTATION: i(29)
            };
            t.exports = n;
        },
        function(t, e, i) {
            var p = i(26), g = i(61);
            t.exports = function(t, e, i, n, s, r, o, a) {
                void 0 === o && (o = !0), t < 0 && (t = 0), e < 0 && (e = 0);
                for(var h = p(t, e, i, n, null, a), l = s - t, u = r - e, c = 0; c < h.length; c++){
                    var d = h[c].x + l, f = h[c].y + u;
                    0 <= d && d < a.width && 0 <= f && f < a.height && a.data[f][d] && a.data[f][d].copy(h[c]);
                }
                o && g(s - 1, r - 1, i + 2, n + 2, a);
            };
        },
        function(t, e, i) {
            var d = i(26), f = i(538);
            t.exports = function(t, e, i, n, s, r) {
                i = i || {}, Array.isArray(t) || (t = [
                    t
                ]);
                var o = r.tilemapLayer;
                n = n || o.scene, s = s || n.cameras.main;
                for(var a = d(0, 0, r.width, r.height, null, r), h = [], l = 0; l < a.length; l++){
                    var u, c = a[l];
                    -1 !== t.indexOf(c.index) && (u = o.tileToWorldXY(c.x, c.y, void 0, s, r), i.x = u.x, i.y = u.y, h.push(n.make.sprite(i)));
                }
                if ("number" == typeof e) for(l = 0; l < t.length; l++)f(t[l], e, 0, 0, r.width, r.height, r);
                else if (Array.isArray(e)) for(l = 0; l < t.length; l++)f(t[l], e[l], 0, 0, r.width, r.height, r);
                return h;
            };
        },
        function(t, e, i) {
            var u = i(26), c = i(61), d = i(72);
            t.exports = function(t, e, i, n, s, r, o) {
                for(var a = -1 !== o.collideIndexes.indexOf(t), h = u(e, i, n, s, null, o), l = 0; l < h.length; l++)h[l].index = t, d(h[l], a);
                r && c(e - 1, i - 1, n + 2, s + 2, o);
            };
        },
        function(t, e, i) {
            var h = i(26);
            t.exports = function(t, e, i, n, s, r, o, a) {
                return h(i, n, s, r, o, a).filter(t, e);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = 0), void 0 === i && (i = !1);
                var s, r, o, a = 0;
                if (i) {
                    for(r = n.height - 1; 0 <= r; r--)for(s = n.width - 1; 0 <= s; s--)if ((o = n.data[r][s]) && o.index === t) {
                        if (a === e) return o;
                        a += 1;
                    }
                } else for(r = 0; r < n.height; r++)for(s = 0; s < n.width; s++)if ((o = n.data[r][s]) && o.index === t) {
                    if (a === e) return o;
                    a += 1;
                }
                return null;
            };
        },
        function(t, e, i) {
            var h = i(26);
            t.exports = function(t, e, i, n, s, r, o, a) {
                return h(i, n, s, r, o, a).find(t, e) || null;
            };
        },
        function(t, e, i) {
            var h = i(26);
            t.exports = function(t, e, i, n, s, r, o, a) {
                h(i, n, s, r, o, a).forEach(t, e);
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(540), r = i(541), o = i(543), a = i(1), h = i(544);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? s : t === n.HEXAGONAL ? r : t === n.STAGGERED ? h : t === n.ISOMETRIC ? o : a;
            };
        },
        function(t, e, i) {
            var r = i(156), o = new (i(3));
            t.exports = function(t, e, i, n, s) {
                return s.tilemapLayer.worldToTileXY(t, e, !0, o, n), r(o.x, o.y, i, s);
            };
        },
        function(t, e, i) {
            function y(t, e) {
                return w.RectangleToTriangle(e, t);
            }
            var x = i(477), T = i(26), w = i(478), b = i(1), n = i(3), E = new n, S = new n, A = new n;
            t.exports = function(t, e, i, n) {
                if (void 0 === t) return [];
                var s = b;
                t instanceof x.Circle ? s = w.CircleToRectangle : t instanceof x.Rectangle ? s = w.RectangleToRectangle : t instanceof x.Triangle ? s = y : t instanceof x.Line && (s = w.LineToRectangle), n.tilemapLayer.worldToTileXY(t.left, t.top, !0, S, i);
                var r = S.x, o = S.y;
                n.tilemapLayer.worldToTileXY(t.right, t.bottom, !0, A, i);
                var a = Math.ceil(A.x), h = Math.ceil(A.y), l = Math.max(a - r, 1), u = Math.max(h - o, 1), c = T(r, o, l, u, e, n), d = n.tileWidth, f = n.tileHeight;
                n.tilemapLayer && (d *= n.tilemapLayer.scaleX, f *= n.tilemapLayer.scaleY);
                for(var p = [], g = new x.Rectangle(0, 0, d, f), v = 0; v < c.length; v++){
                    var m = c[v];
                    n.tilemapLayer.tileToWorldXY(m.x, m.y, E, i), g.x = E.x, g.y = E.y, s(t, g) && p.push(m);
                }
                return p;
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(1), r = i(249);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? r : s;
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(546), r = i(547), o = i(1), a = i(548), h = i(549);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? h : t === n.ISOMETRIC ? r : t === n.HEXAGONAL ? s : t === n.STAGGERED ? a : o;
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(550), r = i(1), o = i(551), a = i(250);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? a : t === n.HEXAGONAL ? s : t === n.STAGGERED ? o : r;
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(1), r = i(251);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? r : s;
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(552), r = i(553), o = i(1), a = i(554), h = i(555);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? h : t === n.ISOMETRIC ? r : t === n.HEXAGONAL ? s : t === n.STAGGERED ? a : o;
            };
        },
        function(t, e, i) {
            var n = i(29), s = i(556), r = i(1), o = i(557), a = i(252);
            t.exports = function(t) {
                return t === n.ORTHOGONAL ? a : t === n.HEXAGONAL ? s : t === n.STAGGERED ? o : r;
            };
        },
        function(t, e, i) {
            var o = i(558), a = new (i(3));
            t.exports = function(t, e, i, n) {
                n.tilemapLayer.worldToTileXY(t, e, !0, a, i);
                var s = a.x, r = a.y;
                return o(s, r, n);
            };
        },
        function(t, e, i) {
            var o = i(253), a = new (i(3));
            t.exports = function(t, e, i, n, s, r) {
                return r.tilemapLayer.worldToTileXY(e, i, !0, a, s, r), o(t, a.x, a.y, n, r);
            };
        },
        function(t, e, i) {
            var u = i(61), c = i(253);
            t.exports = function(t, e, i, n, s) {
                if (void 0 === n && (n = !0), !Array.isArray(t)) return null;
                Array.isArray(t[0]) || (t = [
                    t
                ]);
                for(var r = t.length, o = t[0].length, a = 0; a < r; a++)for(var h = 0; h < o; h++){
                    var l = t[a][h];
                    c(l, e + h, i + a, !1, s);
                }
                n && u(e - 1, i - 1, o + 2, r + 2, s);
            };
        },
        function(t, e, i) {
            var h = i(26), l = i(207);
            t.exports = function(t, e, i, n, s, r) {
                var o, a = h(t, e, i, n, {}, r);
                if (!s) for(s = [], o = 0; o < a.length; o++)-1 === s.indexOf(a[o].index) && s.push(a[o].index);
                for(o = 0; o < a.length; o++)a[o].index = l(s);
            };
        },
        function(t, e, i) {
            var o = i(559), a = new (i(3));
            t.exports = function(t, e, i, n, s, r) {
                return r.tilemapLayer.worldToTileXY(t, e, !0, a, s, r), o(a.x, a.y, i, n, r);
            };
        },
        function(t, e, i) {
            var p = i(26), n = i(391), g = new n(105, 210, 231, 150), v = new n(243, 134, 48, 200), m = new n(40, 39, 37, 150);
            t.exports = function(t, e, i) {
                void 0 === e && (e = {});
                var n = void 0 !== e.tileColor ? e.tileColor : g, s = void 0 !== e.collidingTileColor ? e.collidingTileColor : v, r = void 0 !== e.faceColor ? e.faceColor : m, o = p(0, 0, i.width, i.height, null, i);
                t.translateCanvas(i.tilemapLayer.x, i.tilemapLayer.y), t.scaleCanvas(i.tilemapLayer.scaleX, i.tilemapLayer.scaleY);
                for(var a = 0; a < o.length; a++){
                    var h = o[a], l = h.width, u = h.height, c = h.pixelX, d = h.pixelY, f = h.collides ? s : n;
                    null !== f && (t.fillStyle(f.color, f.alpha / 255), t.fillRect(c, d, l, u)), c += 1, d += 1, l -= 2, u -= 2, null !== r && (t.lineStyle(1, r.color, r.alpha / 255), h.faceTop && t.lineBetween(c, d, c + l, d), h.faceRight && t.lineBetween(c + l, d, c + l, d + u), h.faceBottom && t.lineBetween(c, d + u, c + l, d + u), h.faceLeft && t.lineBetween(c, d, c, d + u));
                }
            };
        },
        function(t, e, i) {
            var l = i(72), u = i(61), c = i(158);
            t.exports = function(t, e, i, n, s) {
                void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === s && (s = !0), Array.isArray(t) || (t = [
                    t
                ]);
                for(var r = 0; r < t.length; r++)c(t[r], e, n);
                if (s) for(var o = 0; o < n.height; o++)for(var a = 0; a < n.width; a++){
                    var h = n.data[o][a];
                    h && -1 !== t.indexOf(h.index) && l(h, e);
                }
                i && u(0, 0, n.width, n.height, n);
            };
        },
        function(t, e, i) {
            var u = i(72), c = i(61), d = i(158);
            t.exports = function(t, e, i, n, s, r) {
                if (void 0 === i && (i = !0), void 0 === n && (n = !0), void 0 === r && (r = !0), !(e < t)) {
                    for(var o = t; o <= e; o++)d(o, i, s);
                    if (r) for(var a = 0; a < s.height; a++)for(var h = 0; h < s.width; h++){
                        var l = s.data[a][h];
                        l && l.index >= t && l.index <= e && u(l, i);
                    }
                    n && c(0, 0, s.width, s.height, s);
                }
            };
        },
        function(t, e, i) {
            var a = i(72), h = i(61), l = i(158);
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = !0), void 0 === i && (i = !0), Array.isArray(t) || (t = [
                    t
                ]);
                for(var s = 0; s < n.height; s++)for(var r = 0; r < n.width; r++){
                    var o = n.data[s][r];
                    o && -1 === t.indexOf(o.index) && (a(o, e), l(o.index, e, n));
                }
                i && h(0, 0, n.width, n.height, n);
            };
        },
        function(t, e, i) {
            var u = i(72), c = i(61), d = i(125);
            t.exports = function(t, e, i, n) {
                void 0 === e && (e = !0), void 0 === i && (i = !0);
                for(var s = 0; s < n.height; s++)for(var r = 0; r < n.width; r++){
                    var o = n.data[s][r];
                    if (o) {
                        for(var a in t)if (d(o.properties, a)) {
                            var h = t[a];
                            Array.isArray(h) || (h = [
                                h
                            ]);
                            for(var l = 0; l < h.length; l++)o.properties[a] === h[l] && u(o, e);
                        }
                    }
                }
                i && c(0, 0, n.width, n.height, n);
            };
        },
        function(t, e, i) {
            var a = i(72), h = i(61);
            t.exports = function(t, e, i) {
                void 0 === t && (t = !0), void 0 === e && (e = !0);
                for(var n = 0; n < i.height; n++)for(var s = 0; s < i.width; s++){
                    var r, o = i.data[n][s];
                    o && (r = o.getCollisionGroup()) && r.objects && 0 < r.objects.length && a(o, t);
                }
                e && h(0, 0, i.width, i.height, i);
            };
        },
        function(t, e) {
            t.exports = function(t, e, i, n) {
                if ("number" == typeof t) n.callbacks[t] = null !== e ? {
                    callback: e,
                    callbackContext: i
                } : void 0;
                else for(var s = 0, r = t.length; s < r; s++)n.callbacks[t[s]] = null !== e ? {
                    callback: e,
                    callbackContext: i
                } : void 0;
            };
        },
        function(t, e, i) {
            var l = i(26);
            t.exports = function(t, e, i, n, s, r, o) {
                for(var a = l(t, e, i, n, null, o), h = 0; h < a.length; h++)a[h].setCollisionCallback(s, r);
            };
        },
        function(t, e, i) {
            var h = i(26), l = i(129);
            t.exports = function(t, e, i, n, s) {
                var r = h(t, e, i, n, null, s), o = r.map(function(t) {
                    return t.index;
                });
                l(o);
                for(var a = 0; a < r.length; a++)r[a].index = o[a];
            };
        },
        function(t, e, i) {
            var l = i(26);
            t.exports = function(t, e, i, n, s, r, o) {
                for(var a = l(i, n, s, r, null, o), h = 0; h < a.length; h++)a[h] && (a[h].index === t ? a[h].index = e : a[h].index === e && (a[h].index = t));
            };
        },
        function(t, e, i) {
            var p = i(26);
            t.exports = function(t, e, i, n, s, r) {
                if (s) {
                    for(var o = p(t, e, i, n, null, r), a = 0, h = 0; h < s.length; h++)a += s[h].weight;
                    if (!(a <= 0)) for(h = 0; h < o.length; h++){
                        for(var l = Math.random() * a, u = 0, c = -1, d = 0; d < s.length; d++)if (l <= (u += s[d].weight)) {
                            var f = s[d].index, c = Array.isArray(f) ? f[Math.floor(Math.random() * f.length)] : f;
                            break;
                        }
                        o[h].index = c;
                    }
                }
            };
        },
        function(t, e, i) {
            t.exports = {
                FromOrientationString: i(254),
                Parse: i(560),
                Parse2DArray: i(255),
                ParseCSV: i(561),
                Impact: i(1447),
                Tiled: i(1448)
            };
        },
        function(t, e, i) {
            t.exports = {
                ParseTileLayers: i(574),
                ParseTilesets: i(575),
                ParseWeltmeister: i(573)
            };
        },
        function(t, e, i) {
            t.exports = {
                AssignTileProperties: i(563),
                Base64Decode: i(570),
                BuildTilesetIndex: i(564),
                CreateGroupLayer: i(159),
                ParseGID: i(257),
                ParseImageLayers: i(565),
                ParseJSONTiled: i(562),
                ParseObject: i(256),
                ParseObjectLayers: i(566),
                ParseTileLayers: i(569),
                ParseTilesets: i(571)
            };
        },
        function(t, e, i) {
            var n = i(1), s = i(1), n = i(1450), s = i(1451);
            t.exports = {
                renderWebGL: n,
                renderCanvas: s
            };
        },
        function(t, e, i) {
            var M = i(12);
            t.exports = function(t, e, i) {
                var n = e.cull(i), s = n.length, r = i.alpha * e.alpha;
                if (!(0 === s || r <= 0)) {
                    var o = e.gidMap, a = t.pipelines.set(e.pipeline, e), h = M.getTintAppendFloatAlpha, l = e.scrollFactorX, u = e.scrollFactorY, c = e.x, d = e.y, f = e.scaleX, p = e.scaleY;
                    t.pipelines.preBatch(e);
                    for(var g = 0; g < s; g++){
                        var v, m, y, x, T, w, b, E, S, A, _ = n[g], C = o[_.index];
                        C && null !== (v = C.getTileTextureCoordinates(_.index)) && (m = C.glTexture, y = a.setTexture2D(m, e), x = C.tileWidth, T = C.tileHeight, w = v.x, b = v.y, E = .5 * C.tileWidth, S = .5 * C.tileHeight, A = h(_.tint, r * _.alpha), a.batchTexture(e, m, m.width, m.height, c + (E + _.pixelX) * f, d + (S + _.pixelY) * p, _.width, _.height, f, p, _.rotation, _.flipX, _.flipY, l, u, E, S, w, b, x, T, A, A, A, A, !1, 0, 0, i, null, !0, y));
                    }
                    t.pipelines.postBatch(e);
                }
            };
        },
        function(t, e, i) {
            var n = i(25), w = new n, b = new n, E = new n;
            t.exports = function(t, e, i, n) {
                var s = e.cull(i), r = s.length, o = i.alpha * e.alpha;
                if (!(0 === r || o <= 0)) {
                    var a = w, h = b, l = E;
                    h.applyITRS(e.x, e.y, e.rotation, e.scaleX, e.scaleY), a.copyFrom(i.matrix);
                    var u = t.currentContext, c = e.gidMap;
                    u.save(), n ? (a.multiplyWithOffset(n, -i.scrollX * e.scrollFactorX, -i.scrollY * e.scrollFactorY), h.e = e.x, h.f = e.y, a.multiply(h, l), l.copyToContext(u)) : (h.e -= i.scrollX * e.scrollFactorX, h.f -= i.scrollY * e.scrollFactorY, h.copyToContext(u)), (!t.antialias || 1 < e.scaleX || 1 < e.scaleY) && (u.imageSmoothingEnabled = !1);
                    for(var d = 0; d < r; d++){
                        var f, p, g, v, m, y, x = s[d], T = c[x.index];
                        T && (f = T.image.getSourceImage(), null !== (p = T.getTileTextureCoordinates(x.index)) && (m = .5 * (g = T.tileWidth), y = .5 * (v = T.tileHeight), u.save(), u.translate(x.pixelX + m, x.pixelY + y), 0 !== x.rotation && u.rotate(x.rotation), (x.flipX || x.flipY) && u.scale(x.flipX ? -1 : 1, x.flipY ? -1 : 1), u.globalAlpha = o * x.alpha, u.drawImage(f, p.x, p.y, g, v, -m, -y, g, v), u.restore()));
                    }
                    u.restore();
                }
            };
        },
        function(t, e, i) {
            var n = i(16), s = i(258);
            n.register("tilemap", function(t) {
                var e = void 0 !== t ? t : {};
                return s(this.scene, e.key, e.tileWidth, e.tileHeight, e.width, e.height, e.data, e.insertNull);
            });
        },
        function(t, e, i) {
            var n = i(5), a = i(258);
            n.register("tilemap", function(t, e, i, n, s, r, o) {
                return null === t && (t = void 0), null === e && (e = void 0), null === i && (i = void 0), null === n && (n = void 0), null === s && (s = void 0), a(this.scene, t, e, i, n, s, r, o);
            });
        },
        function(t, e, i) {
            t.exports = {
                Clock: i(1455),
                TimerEvent: i(578)
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(24), r = i(21), o = i(578), a = i(89), h = new n({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.now = 0, this.timeScale = 1, this.paused = !1, this._active = [], this._pendingInsertion = [], this._pendingRemoval = [], t.sys.events.once(r.BOOT, this.boot, this), t.sys.events.on(r.START, this.start, this);
                },
                boot: function() {
                    this.now = this.systems.game.loop.time, this.systems.events.once(r.DESTROY, this.destroy, this);
                },
                start: function() {
                    var t = this.systems.events;
                    t.on(r.PRE_UPDATE, this.preUpdate, this), t.on(r.UPDATE, this.update, this), t.once(r.SHUTDOWN, this.shutdown, this);
                },
                addEvent: function(t) {
                    var e;
                    return t instanceof o ? (e = t, this.removeEvent(e), e.elapsed = e.startAt, e.hasDispatched = !1, e.repeatCount = -1 === e.repeat || e.loop ? 999999999999 : e.repeat) : e = new o(t), this._pendingInsertion.push(e), e;
                },
                delayedCall: function(t, e, i, n) {
                    return this.addEvent({
                        delay: t,
                        callback: e,
                        args: i,
                        callbackScope: n
                    });
                },
                clearPendingEvents: function() {
                    return this._pendingInsertion = [], this;
                },
                removeEvent: function(t) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = 0; e < t.length; e++){
                        var i = t[e];
                        a(this._pendingRemoval, i), a(this._pendingInsertion, i), a(this._active, i);
                    }
                    return this;
                },
                removeAllEvents: function() {
                    return this._pendingRemoval = this._pendingRemoval.concat(this._active), this;
                },
                preUpdate: function() {
                    var t = this._pendingRemoval.length, e = this._pendingInsertion.length;
                    if (0 !== t || 0 !== e) {
                        for(var i, n = 0; n < t; n++){
                            i = this._pendingRemoval[n];
                            var s = this._active.indexOf(i);
                            -1 < s && this._active.splice(s, 1), i.destroy();
                        }
                        for(n = 0; n < e; n++)i = this._pendingInsertion[n], this._active.push(i);
                        this._pendingRemoval.length = 0, this._pendingInsertion.length = 0;
                    }
                },
                update: function(t, e) {
                    if (this.now = t, !this.paused) {
                        e *= this.timeScale;
                        for(var i = 0; i < this._active.length; i++){
                            var n, s = this._active[i];
                            s.paused || (s.elapsed += e * s.timeScale, s.elapsed >= s.delay && (n = s.elapsed - s.delay, s.elapsed = s.delay, !s.hasDispatched && s.callback && (s.hasDispatched = !0, s.callback.apply(s.callbackScope, s.args)), 0 < s.repeatCount ? (s.repeatCount--, s.elapsed = n, s.hasDispatched = !1) : this._pendingRemoval.push(s)));
                        }
                    }
                },
                shutdown: function() {
                    for(var t = 0; t < this._pendingInsertion.length; t++)this._pendingInsertion[t].destroy();
                    for(t = 0; t < this._active.length; t++)this._active[t].destroy();
                    for(t = 0; t < this._pendingRemoval.length; t++)this._pendingRemoval[t].destroy();
                    this._active.length = 0, this._pendingRemoval.length = 0, this._pendingInsertion.length = 0;
                    var e = this.systems.events;
                    e.off(r.PRE_UPDATE, this.preUpdate, this), e.off(r.UPDATE, this.update, this), e.off(r.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.scene.sys.events.off(r.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            s.register("Clock", h, "time"), t.exports = h;
        },
        function(t, e, i) {
            var n = i(97), s = i(17)(!1, s = {
                Builders: i(1457),
                Events: i(263),
                TweenManager: i(1473),
                Tween: i(262),
                TweenData: i(264),
                Timeline: i(584)
            }, n);
            t.exports = s;
        },
        function(t, e, i) {
            t.exports = {
                GetBoolean: i(96),
                GetEaseFunction: i(80),
                GetNewValue: i(160),
                GetProps: i(579),
                GetTargets: i(259),
                GetTweens: i(580),
                GetValueOp: i(260),
                NumberTweenBuilder: i(581),
                StaggerBuilder: i(582),
                TimelineBuilder: i(583),
                TweenBuilder: i(161)
            };
        },
        function(t, e) {
            t.exports = [
                "callbackScope",
                "completeDelay",
                "delay",
                "duration",
                "ease",
                "easeParams",
                "flipX",
                "flipY",
                "hold",
                "loop",
                "loopDelay",
                "offset",
                "onActive",
                "onActiveParams",
                "onActiveScope",
                "onComplete",
                "onCompleteParams",
                "onCompleteScope",
                "onLoop",
                "onLoopParams",
                "onLoopScope",
                "onRepeat",
                "onRepeatParams",
                "onRepeatScope",
                "onStart",
                "onStartParams",
                "onStartScope",
                "onStop",
                "onStopParams",
                "onStopScope",
                "onUpdate",
                "onUpdateParams",
                "onUpdateScope",
                "onYoyo",
                "onYoyoParams",
                "onYoyoScope",
                "paused",
                "props",
                "repeat",
                "repeatDelay",
                "targets",
                "useFrames",
                "yoyo"
            ];
        },
        function(t, e) {
            t.exports = "complete";
        },
        function(t, e) {
            t.exports = "loop";
        },
        function(t, e) {
            t.exports = "pause";
        },
        function(t, e) {
            t.exports = "resume";
        },
        function(t, e) {
            t.exports = "start";
        },
        function(t, e) {
            t.exports = "update";
        },
        function(t, e) {
            t.exports = "active";
        },
        function(t, e) {
            t.exports = "complete";
        },
        function(t, e) {
            t.exports = "loop";
        },
        function(t, e) {
            t.exports = "repeat";
        },
        function(t, e) {
            t.exports = "start";
        },
        function(t, e) {
            t.exports = "stop";
        },
        function(t, e) {
            t.exports = "update";
        },
        function(t, e) {
            t.exports = "yoyo";
        },
        function(t, e, i) {
            var n = i(89), s = i(0), r = i(581), o = i(24), a = i(21), h = i(582), l = i(583), u = i(97), c = i(161), d = new s({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.timeScale = 1, this._add = [], this._pending = [], this._active = [], this._destroy = [], this._toProcess = 0, t.sys.events.once(a.BOOT, this.boot, this), t.sys.events.on(a.START, this.start, this);
                },
                boot: function() {
                    this.systems.events.once(a.DESTROY, this.destroy, this);
                },
                start: function() {
                    var t = this.systems.events;
                    t.on(a.PRE_UPDATE, this.preUpdate, this), t.on(a.UPDATE, this.update, this), t.once(a.SHUTDOWN, this.shutdown, this), this.timeScale = 1;
                },
                createTimeline: function(t) {
                    return l(this, t);
                },
                timeline: function(t) {
                    var e = l(this, t);
                    return e.paused || (this._add.push(e), this._toProcess++), e;
                },
                create: function(t) {
                    return c(this, t);
                },
                add: function(t) {
                    var e = c(this, t);
                    return this._add.push(e), this._toProcess++, e;
                },
                existing: function(t) {
                    return this._add.push(t), this._toProcess++, this;
                },
                addCounter: function(t) {
                    var e = r(this, t);
                    return this._add.push(e), this._toProcess++, e;
                },
                stagger: function(t, e) {
                    return h(t, e);
                },
                preUpdate: function() {
                    if (0 !== this._toProcess) {
                        for(var t, e = this._destroy, i = this._active, n = this._pending, s = 0; s < e.length; s++){
                            t = e[s];
                            var r = i.indexOf(t);
                            -1 === r ? -1 < (r = n.indexOf(t)) && (t.state = u.REMOVED, n.splice(r, 1)) : (t.state = u.REMOVED, i.splice(r, 1));
                        }
                        for(e.length = 0, e = this._add, s = 0; s < e.length; s++)(t = e[s]).state === u.PENDING_ADD && (t.init() ? (t.play(), this._active.push(t)) : this._pending.push(t));
                        e.length = 0, this._toProcess = 0;
                    }
                },
                update: function(t, e) {
                    var i, n = this._active;
                    e *= this.timeScale;
                    for(var s = 0; s < n.length; s++)(i = n[s]).update(t, e) && (this._destroy.push(i), this._toProcess++);
                },
                remove: function(t) {
                    return n(this._add, t), n(this._pending, t), n(this._active, t), n(this._destroy, t), t.state = u.REMOVED, this;
                },
                makeActive: function(t) {
                    if (-1 !== this._add.indexOf(t) || -1 !== this._active.indexOf(t)) return this;
                    var e = this._pending.indexOf(t);
                    return -1 !== e && this._pending.splice(e, 1), this._add.push(t), t.state = u.PENDING_ADD, this._toProcess++, this;
                },
                each: function(t, e) {
                    for(var i = [
                        null
                    ], n = 1; n < arguments.length; n++)i.push(arguments[n]);
                    for(var s in this.list)i[0] = this.list[s], t.apply(e, i);
                },
                getAllTweens: function() {
                    for(var t = this._active, e = [], i = 0; i < t.length; i++)e.push(t[i]);
                    return e;
                },
                getGlobalTimeScale: function() {
                    return this.timeScale;
                },
                getTweensOf: function(t, e) {
                    void 0 === e && (e = !1);
                    var i, n, s, r = this._active, o = [];
                    for(Array.isArray(t) || (t = [
                        t
                    ]), n = 0; n < r.length; n++)for(i = r[n], s = 0; s < t.length; s++)i.hasTarget(t[s]) && o.push(i);
                    if (e) for(r = this._pending, n = 0; n < r.length; n++)for(i = r[n], s = 0; s < t.length; s++)i.hasTarget(t[s]) && o.push(i);
                    return o;
                },
                isTweening: function(t) {
                    for(var e, i = this._active, n = 0; n < i.length; n++)if ((e = i[n]).hasTarget(t) && e.isPlaying()) return !0;
                    return !1;
                },
                killAll: function() {
                    for(var t = this.getAllTweens(), e = 0; e < t.length; e++)t[e].stop();
                    return this;
                },
                killTweensOf: function(t) {
                    for(var e = this.getTweensOf(t), i = 0; i < e.length; i++)e[i].stop();
                    return this;
                },
                pauseAll: function() {
                    for(var t = this._active, e = 0; e < t.length; e++)t[e].pause();
                    return this;
                },
                resumeAll: function() {
                    for(var t = this._active, e = 0; e < t.length; e++)t[e].resume();
                    return this;
                },
                setGlobalTimeScale: function(t) {
                    return this.timeScale = t, this;
                },
                shutdown: function() {
                    this.killAll(), this._add = [], this._pending = [], this._active = [], this._destroy = [], this._toProcess = 0;
                    var t = this.systems.events;
                    t.off(a.PRE_UPDATE, this.preUpdate, this), t.off(a.UPDATE, this.update, this), t.off(a.SHUTDOWN, this.shutdown, this);
                },
                destroy: function() {
                    this.shutdown(), this.scene.sys.events.off(a.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            o.register("TweenManager", d, "tweens"), t.exports = d;
        },
        function(t, e, i) {
            t.exports = {
                Array: i(205),
                Base64: i(1475),
                Objects: i(1477),
                String: i(1481),
                NOOP: i(1)
            };
        },
        function(t, e, i) {
            t.exports = {
                ArrayBufferToBase64: i(1476),
                Base64ToArrayBuffer: i(427)
            };
        },
        function(t, e) {
            var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            t.exports = function(t, e) {
                for(var i = new Uint8Array(t), n = i.length, s = e ? "data:" + e + ";base64," : "", r = 0; r < n; r += 3)s += o[i[r] >> 2], s += o[(3 & i[r]) << 4 | i[r + 1] >> 4], s += o[(15 & i[r + 1]) << 2 | i[r + 2] >> 6], s += o[63 & i[r + 2]];
                return n % 3 == 2 ? s = s.substring(0, s.length - 1) + "=" : n % 3 == 1 && (s = s.substring(0, s.length - 2) + "=="), s;
            };
        },
        function(t, e, i) {
            t.exports = {
                Clone: i(77),
                DeepCopy: i(172),
                Extend: i(17),
                GetAdvancedValue: i(13),
                GetFastValue: i(2),
                GetMinMaxValue: i(1478),
                GetValue: i(6),
                HasAll: i(1479),
                HasAny: i(449),
                HasValue: i(125),
                IsPlainObject: i(7),
                Merge: i(143),
                MergeRight: i(1480),
                Pick: i(567),
                SetValue: i(472)
            };
        },
        function(t, e, i) {
            var o = i(6), a = i(18);
            t.exports = function(t, e, i, n, s) {
                void 0 === s && (s = i);
                var r = o(t, e, s);
                return a(r, i, n);
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                for(var i = 0; i < e.length; i++)if (!t.hasOwnProperty(e[i])) return !1;
                return !0;
            };
        },
        function(t, e, i) {
            var s = i(77);
            t.exports = function(t, e) {
                var i = s(t);
                for(var n in e)i.hasOwnProperty(n) && (i[n] = e[n]);
                return i;
            };
        },
        function(t, e, i) {
            t.exports = {
                Format: i(1482),
                Pad: i(183),
                RemoveAt: i(1483),
                Reverse: i(1484),
                UppercaseFirst: i(202),
                UUID: i(219)
            };
        },
        function(t, e) {
            t.exports = function(t, i) {
                return t.replace(/%([0-9]+)/g, function(t, e) {
                    return i[Number(e) - 1];
                });
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return 0 === e ? t.slice(1) : t.slice(0, e - 1) + t.slice(e);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return t.split("").reverse().join("");
            };
        },
        function(t, e, i) {
            t.exports = {
                SoundManagerCreator: i(420),
                Events: i(69),
                BaseSound: i(145),
                BaseSoundManager: i(144),
                WebAudioSound: i(428),
                WebAudioSoundManager: i(426),
                HTML5AudioSound: i(423),
                HTML5AudioSoundManager: i(421),
                NoAudioSound: i(425),
                NoAudioSoundManager: i(424)
            };
        },
        function(t, e, i) {
            var n = i(0), r = i(3), s = new n({
                initialize: function() {
                    this.boundsCenter = new r, this.centerDiff = new r;
                },
                parseBody: function(t) {
                    if (!(t = t.hasOwnProperty("body") ? t.body : t).hasOwnProperty("bounds") || !t.hasOwnProperty("centerOfMass")) return !1;
                    var e = this.boundsCenter, i = this.centerDiff, n = t.bounds.max.x - t.bounds.min.x, s = t.bounds.max.y - t.bounds.min.y, r = n * t.centerOfMass.x, o = s * t.centerOfMass.y;
                    return e.set(n / 2, s / 2), i.set(r - e.x, o - e.y), !0;
                },
                getTopLeft: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e + n.x + s.x, i + n.y + s.y);
                    }
                    return !1;
                },
                getTopCenter: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e + s.x, i + n.y + s.y);
                    }
                    return !1;
                },
                getTopRight: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e - (n.x - s.x), i + n.y + s.y);
                    }
                    return !1;
                },
                getLeftCenter: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e + n.x + s.x, i + s.y);
                    }
                    return !1;
                },
                getCenter: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.centerDiff;
                        return new r(e + n.x, i + n.y);
                    }
                    return !1;
                },
                getRightCenter: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e - (n.x - s.x), i + s.y);
                    }
                    return !1;
                },
                getBottomLeft: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e + n.x + s.x, i - (n.y - s.y));
                    }
                    return !1;
                },
                getBottomCenter: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e + s.x, i - (n.y - s.y));
                    }
                    return !1;
                },
                getBottomRight: function(t, e, i) {
                    if (void 0 === e && (e = 0), void 0 === i && (i = 0), this.parseBody(t)) {
                        var n = this.boundsCenter, s = this.centerDiff;
                        return new r(e - (n.x - s.x), i - (n.y - s.y));
                    }
                    return !1;
                }
            });
            t.exports = s;
        },
        function(t, e) {
            function s(t, e, i, n) {
                var s = e[0] - t[0], r = e[1] - t[1], o = n[0] - i[0], a = n[1] - i[1];
                if (o * r - a * s != 0) {
                    var h = (s * (i[1] - t[1]) + r * (t[0] - i[0])) / (o * r - a * s), l = (o * (t[1] - i[1]) + a * (i[0] - t[0])) / (a * s - o * r);
                    return 0 <= h && h <= 1 && 0 <= l && l <= 1;
                }
            }
            function l(t, e, i) {
                return (e[0] - t[0]) * (i[1] - t[1]) - (i[0] - t[0]) * (e[1] - t[1]);
            }
            function S(t, e, i) {
                return 0 < l(t, e, i);
            }
            function A(t, e, i) {
                return 0 <= l(t, e, i);
            }
            function _(t, e, i) {
                return l(t, e, i) < 0;
            }
            function C(t, e, i) {
                return l(t, e, i) <= 0;
            }
            t.exports = {
                decomp: function(t) {
                    var e = function t(e) {
                        var i = [], n = [], s = [], r = [];
                        var o = Number.MAX_VALUE;
                        for(var a = 0; a < e.length; ++a)if (O(e, a)) {
                            for(var h = 0; h < e.length; ++h)if (f(e, a, h)) {
                                n = t(p(e, a, h, r)), s = t(p(e, h, a, r));
                                for(var l = 0; l < s.length; l++)n.push(s[l]);
                                n.length < o && (o = (i = n).length, i.push([
                                    R(e, a),
                                    R(e, h)
                                ]));
                            }
                        }
                        return i;
                    }(t);
                    return 0 < e.length ? function t(e, i) {
                        if (0 === i.length) return [
                            e
                        ];
                        if (i instanceof Array && i.length && i[0] instanceof Array && 2 === i[0].length && i[0][0] instanceof Array) {
                            for(var n = [
                                e
                            ], s = 0; s < i.length; s++)for(var r = i[s], o = 0; o < n.length; o++){
                                var a = n[o], h = t(a, r);
                                if (h) {
                                    n.splice(o, 1), n.push(h[0], h[1]);
                                    break;
                                }
                            }
                            return n;
                        }
                        var r = i, s = e.indexOf(r[0]), o = e.indexOf(r[1]);
                        return -1 !== s && -1 !== o && [
                            p(e, s, o),
                            p(e, o, s)
                        ];
                    }(t, e) : [
                        t
                    ];
                },
                quickDecomp: function t(e, i, n, s, r, o, a) {
                    o = o || 100;
                    a = a || 0;
                    r = r || 25;
                    i = void 0 !== i ? i : [];
                    n = n || [];
                    s = s || [];
                    var h = [
                        0,
                        0
                    ], l = [
                        0,
                        0
                    ], u = [
                        0,
                        0
                    ];
                    var c = 0, d = 0, f = 0, p = 0;
                    var g = 0, v = 0, m = 0;
                    var y = [], x = [];
                    var T = e, w = e;
                    if (w.length < 3) return i;
                    a++;
                    if (o < a) return console.warn("quickDecomp: max level (" + o + ") reached."), i;
                    for(var b = 0; b < e.length; ++b)if (O(T, b)) {
                        n.push(T[b]), c = d = Number.MAX_VALUE;
                        for(var E = 0; E < e.length; ++E)S(R(T, b - 1), R(T, b), R(T, E)) && C(R(T, b - 1), R(T, b), R(T, E - 1)) && (u = D(R(T, b - 1), R(T, b), R(T, E), R(T, E - 1)), _(R(T, b + 1), R(T, b), u) && (f = M(T[b], u)) < d && (d = f, l = u, v = E)), S(R(T, b + 1), R(T, b), R(T, E + 1)) && C(R(T, b + 1), R(T, b), R(T, E)) && (u = D(R(T, b + 1), R(T, b), R(T, E), R(T, E + 1)), S(R(T, b - 1), R(T, b), u) && (f = M(T[b], u)) < c && (c = f, h = u, g = E));
                        if (v === (g + 1) % e.length) u[0] = (l[0] + h[0]) / 2, u[1] = (l[1] + h[1]) / 2, s.push(u), b < g ? (P(y, T, b, g + 1), y.push(u), x.push(u), 0 !== v && P(x, T, v, T.length), P(x, T, 0, b + 1)) : (0 !== b && P(y, T, b, T.length), P(y, T, 0, g + 1), y.push(u), x.push(u), P(x, T, v, b + 1));
                        else {
                            if (g < v && (g += e.length), p = Number.MAX_VALUE, g < v) return i;
                            for(var E = v; E <= g; ++E)A(R(T, b - 1), R(T, b), R(T, E)) && C(R(T, b + 1), R(T, b), R(T, E)) && (f = M(R(T, b), R(T, E))) < p && L(T, b, E) && (p = f, m = E % e.length);
                            b < m ? (P(y, T, b, m + 1), 0 !== m && P(x, T, m, w.length), P(x, T, 0, b + 1)) : (0 !== b && P(y, T, b, w.length), P(y, T, 0, m + 1), P(x, T, m, b + 1));
                        }
                        return y.length < x.length ? (t(y, i, n, s, r, o, a), t(x, i, n, s, r, o, a)) : (t(x, i, n, s, r, o, a), t(y, i, n, s, r, o, a)), i;
                    }
                    i.push(e);
                    return i;
                },
                isSimple: function(t) {
                    var e, i = t;
                    for(e = 0; e < i.length - 1; e++)for(var n = 0; n < e - 1; n++)if (s(i[e], i[e + 1], i[n], i[n + 1])) return !1;
                    for(e = 1; e < i.length - 2; e++)if (s(i[0], i[i.length - 1], i[e], i[e + 1])) return !1;
                    return !0;
                },
                removeCollinearPoints: function(t, e) {
                    for(var i = 0, n = t.length - 1; 3 < t.length && 0 <= n; --n)!function(t, e, i, n) {
                        if (n) {
                            var s = u, r = c;
                            s[0] = e[0] - t[0], s[1] = e[1] - t[1], r[0] = i[0] - e[0], r[1] = i[1] - e[1];
                            var o = s[0] * r[0] + s[1] * r[1], a = Math.sqrt(s[0] * s[0] + s[1] * s[1]), h = Math.sqrt(r[0] * r[0] + r[1] * r[1]);
                            return Math.acos(o / (a * h)) < n;
                        }
                        return 0 === l(t, e, i);
                    }(R(t, n - 1), R(t, n), R(t, n + 1), e) || (t.splice(n % t.length, 1), i++);
                    return i;
                },
                removeDuplicatePoints: function(t, e) {
                    for(var i = t.length - 1; 1 <= i; --i)for(var n = t[i], s = i - 1; 0 <= s; --s)!function(t, e, i) {
                        return g(t[0], e[0], i) && g(t[1], e[1], i);
                    }(n, t[s], e) || t.splice(i, 1);
                },
                makeCCW: function(t) {
                    for(var e = 0, i = t, n = 1; n < t.length; ++n)(i[n][1] < i[e][1] || i[n][1] === i[e][1] && i[n][0] > i[e][0]) && (e = n);
                    return !S(R(t, e - 1), R(t, e), R(t, e + 1)) && (function(t) {
                        for(var e = [], i = t.length, n = 0; n !== i; n++)e.push(t.pop());
                        for(n = 0; n !== i; n++)t[n] = e[n];
                    }(t), !0);
                }
            };
            var u = [], c = [];
            function M(t, e) {
                var i = e[0] - t[0], n = e[1] - t[1];
                return i * i + n * n;
            }
            function R(t, e) {
                var i = t.length;
                return t[e < 0 ? e % i + i : e % i];
            }
            function P(t, e, i, n) {
                for(var s = i; s < n; s++)t.push(e[s]);
            }
            function O(t, e) {
                return _(R(t, e - 1), R(t, e), R(t, e + 1));
            }
            var h = [], d = [];
            function f(t, e, i) {
                var n, s, r = h, o = d;
                if (!A(R(t, e + 1), R(t, e), R(t, i)) || !C(R(t, e - 1), R(t, e), R(t, i))) {
                    s = M(R(t, e), R(t, i));
                    for(var a = 0; a !== t.length; ++a)if ((a + 1) % t.length !== e && a !== e && A(R(t, e), R(t, i), R(t, a + 1)) && C(R(t, e), R(t, i), R(t, a)) && (r[0] = R(t, e), r[1] = R(t, i), o[0] = R(t, a), o[1] = R(t, a + 1), n = function(t, e, i) {
                        i = i || 0;
                        var n = [
                            0,
                            0
                        ], s = t[1][1] - t[0][1], r = t[0][0] - t[1][0], o = s * t[0][0] + r * t[0][1], a = e[1][1] - e[0][1], h = e[0][0] - e[1][0], l = a * e[0][0] + h * e[0][1], u = s * h - a * r;
                        return g(u, 0, i) || (n[0] = (h * o - r * l) / u, n[1] = (s * l - a * o) / u), n;
                    }(r, o), M(R(t, e), n) < s)) return;
                    return 1;
                }
            }
            function L(t, e, i) {
                for(var n = 0; n !== t.length; ++n)if (n !== e && n !== i && (n + 1) % t.length !== e && (n + 1) % t.length !== i && s(R(t, e), R(t, i), R(t, n), R(t, n + 1))) return;
                return 1;
            }
            function p(t, e, i, n) {
                var s = n || [];
                if (s.length = 0, e < i) for(var r = e; r <= i; r++)s.push(t[r]);
                else {
                    for(r = 0; r <= i; r++)s.push(t[r]);
                    for(r = e; r < t.length; r++)s.push(t[r]);
                }
                return s;
            }
            function D(t, e, i, n, s) {
                s = s || 0;
                var r = e[1] - t[1], o = t[0] - e[0], a = r * t[0] + o * t[1], h = n[1] - i[1], l = i[0] - n[0], u = h * i[0] + l * i[1], c = r * l - h * o;
                return g(c, 0, s) ? [
                    0,
                    0
                ] : [
                    (l * a - o * u) / c,
                    (r * u - h * a) / c
                ];
            }
            function g(t, e, i) {
                return i = i || 0, Math.abs(t - e) <= i;
            }
        },
        function(t, e, i) {
            var c = i(126), n = i(0), d = i(1388), o = i(246), f = i(1389), s = i(1489), p = i(1490), a = i(1491), r = i(1390), h = i(1386), l = i(1387), u = i(1492), g = i(94), v = new n({
                initialize: function(t) {
                    this.world = t, this.scene = t.scene, this.sys = t.scene.sys;
                },
                rectangle: function(t, e, i, n, s) {
                    var r = c.rectangle(t, e, i, n, s);
                    return this.world.add(r), r;
                },
                trapezoid: function(t, e, i, n, s, r) {
                    var o = c.trapezoid(t, e, i, n, s, r);
                    return this.world.add(o), o;
                },
                circle: function(t, e, i, n, s) {
                    var r = c.circle(t, e, i, n, s);
                    return this.world.add(r), r;
                },
                polygon: function(t, e, i, n, s) {
                    var r = c.polygon(t, e, i, n, s);
                    return this.world.add(r), r;
                },
                fromVertices: function(t, e, i, n, s, r, o) {
                    "string" == typeof i && (i = g.fromPath(i));
                    var a = c.fromVertices(t, e, i, n, s, r, o);
                    return this.world.add(a), a;
                },
                fromPhysicsEditor: function(t, e, i, n, s) {
                    void 0 === s && (s = !0);
                    var r = h.parseBody(t, e, i, n);
                    return s && !this.world.has(r) && this.world.add(r), r;
                },
                fromSVG: function(t, e, i, n, s, r) {
                    void 0 === n && (n = 1), void 0 === s && (s = {}), void 0 === r && (r = !0);
                    for(var o = i.getElementsByTagName("path"), a = [], h = 0; h < o.length; h++){
                        var l = f.pathToVertices(o[h], 30);
                        1 !== n && g.scale(l, n, n), a.push(l);
                    }
                    var u = c.fromVertices(t, e, a, s);
                    return r && this.world.add(u), u;
                },
                fromJSON: function(t, e, i, n, s) {
                    void 0 === n && (n = {}), void 0 === s && (s = !0);
                    var r = l.parseBody(t, e, i, n);
                    return r && s && this.world.add(r), r;
                },
                imageStack: function(n, s, t, e, i, r, o, a, h) {
                    void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === h && (h = {});
                    var l = this.world, u = this.sys.displayList;
                    h.addToWorld = !1;
                    var c = d.stack(t, e, i, r, o, a, function(t, e) {
                        var i = new p(l, t, e, n, s, h);
                        return u.add(i), i.body;
                    });
                    return l.add(c), c;
                },
                stack: function(t, e, i, n, s, r, o) {
                    var a = d.stack(t, e, i, n, s, r, o);
                    return this.world.add(a), a;
                },
                pyramid: function(t, e, i, n, s, r, o) {
                    var a = d.pyramid(t, e, i, n, s, r, o);
                    return this.world.add(a), a;
                },
                chain: function(t, e, i, n, s, r) {
                    return d.chain(t, e, i, n, s, r);
                },
                mesh: function(t, e, i, n, s) {
                    return d.mesh(t, e, i, n, s);
                },
                newtonsCradle: function(t, e, i, n, s) {
                    var r = d.newtonsCradle(t, e, i, n, s);
                    return this.world.add(r), r;
                },
                car: function(t, e, i, n, s) {
                    var r = d.car(t, e, i, n, s);
                    return this.world.add(r), r;
                },
                softBody: function(t, e, i, n, s, r, o, a, h, l) {
                    var u = d.softBody(t, e, i, n, s, r, o, a, h, l);
                    return this.world.add(u), u;
                },
                joint: function(t, e, i, n, s) {
                    return this.constraint(t, e, i, n, s);
                },
                spring: function(t, e, i, n, s) {
                    return this.constraint(t, e, i, n, s);
                },
                constraint: function(t, e, i, n, s) {
                    void 0 === n && (n = 1), void 0 === s && (s = {}), s.bodyA = "body" === t.type ? t : t.body, s.bodyB = "body" === e.type ? e : e.body, isNaN(i) || (s.length = i), s.stiffness = n;
                    var r = o.create(s);
                    return this.world.add(r), r;
                },
                worldConstraint: function(t, e, i, n) {
                    void 0 === i && (i = 1), void 0 === n && (n = {}), n.bodyB = "body" === t.type ? t : t.body, isNaN(e) || (n.length = e), n.stiffness = i;
                    var s = o.create(n);
                    return this.world.add(s), s;
                },
                mouseSpring: function(t) {
                    return this.pointerConstraint(t);
                },
                pointerConstraint: function(t) {
                    void 0 === t && (t = {}), t.hasOwnProperty("render") || (t.render = {
                        visible: !1
                    });
                    var e = new u(this.scene, this.world, t);
                    return this.world.add(e.constraint), e;
                },
                image: function(t, e, i, n, s) {
                    var r = new p(this.world, t, e, i, n, s);
                    return this.sys.displayList.add(r), r;
                },
                tileBody: function(t, e) {
                    return new r(this.world, t, e);
                },
                sprite: function(t, e, i, n, s) {
                    var r = new a(this.world, t, e, i, n, s);
                    return this.sys.displayList.add(r), this.sys.updateList.add(r), r;
                },
                gameObject: function(t, e, i) {
                    return s(this.world, t, e, i);
                },
                destroy: function() {
                    this.world = null, this.scene = null, this.sys = null;
                }
            });
            t.exports = v;
        },
        function(t, e, i) {
            var a = i(534), h = i(2), l = i(3);
            t.exports = function(t, n, e, i) {
                void 0 === e && (e = {}), void 0 === i && (i = !0);
                var s, r = n.x, o = n.y;
                return n.body = {
                    temp: !0,
                    position: {
                        x: r,
                        y: o
                    }
                }, [
                    a.Bounce,
                    a.Collision,
                    a.Force,
                    a.Friction,
                    a.Gravity,
                    a.Mass,
                    a.Sensor,
                    a.SetBody,
                    a.Sleep,
                    a.Static,
                    a.Transform,
                    a.Velocity
                ].forEach(function(t) {
                    for(var e in t)(i = t[e]).get && "function" == typeof i.get || i.set && "function" == typeof i.set ? Object.defineProperty(n, e, {
                        get: t[e].get,
                        set: t[e].set
                    }) : Object.defineProperty(n, e, {
                        value: t[e]
                    });
                    var i;
                }), n.world = t, n._tempVec2 = new l(r, o), e.hasOwnProperty("type") && "body" === e.type ? n.setExistingBody(e, i) : (s = (s = h(e, "shape", null)) || "rectangle", e.addToWorld = i, n.setBody(s, e)), n;
            };
        },
        function(t, e, i) {
            var n = i(0), s = i(534), a = i(15), h = i(2), r = i(124), o = i(171), l = i(3), u = new n({
                Extends: r,
                Mixins: [
                    s.Bounce,
                    s.Collision,
                    s.Force,
                    s.Friction,
                    s.Gravity,
                    s.Mass,
                    s.Sensor,
                    s.SetBody,
                    s.Sleep,
                    s.Static,
                    s.Transform,
                    s.Velocity,
                    o
                ],
                initialize: function(t, e, i, n, s, r) {
                    a.call(this, t.scene, "Image"), this._crop = this.resetCropObject(), this.setTexture(n, s), this.setSizeToFrame(), this.setOrigin(), this.world = t, this._tempVec2 = new l(e, i);
                    var o = h(r, "shape", null);
                    o ? this.setBody(o, r) : this.setRectangle(this.width, this.height, r), this.setPosition(e, i), this.initPipeline();
                }
            });
            t.exports = u;
        },
        function(t, e, i) {
            var a = i(162), n = i(0), s = i(534), h = i(15), l = i(2), r = i(171), o = i(73), u = i(3), c = new n({
                Extends: o,
                Mixins: [
                    s.Bounce,
                    s.Collision,
                    s.Force,
                    s.Friction,
                    s.Gravity,
                    s.Mass,
                    s.Sensor,
                    s.SetBody,
                    s.Sleep,
                    s.Static,
                    s.Transform,
                    s.Velocity,
                    r
                ],
                initialize: function(t, e, i, n, s, r) {
                    h.call(this, t.scene, "Sprite"), this._crop = this.resetCropObject(), this.anims = new a(this), this.setTexture(n, s), this.setSizeToFrame(), this.setOrigin(), this.world = t, this._tempVec2 = new u(e, i);
                    var o = l(r, "shape", null);
                    o ? this.setBody(o, r) : this.setRectangle(this.width, this.height, r), this.setPosition(e, i), this.initPipeline();
                }
            });
            t.exports = c;
        },
        function(t, e, i) {
            var o = i(117), n = i(0), a = i(163), s = i(246), h = i(587), l = i(586), r = i(49), u = i(143), c = i(267), d = i(3), f = i(94), p = new n({
                initialize: function(t, e, i) {
                    void 0 === i && (i = {});
                    this.scene = t, this.world = e, this.camera = null, this.pointer = null, this.active = !0, this.position = new d, this.body = null, this.part = null, this.constraint = s.create(u(i, {
                        label: "Pointer Constraint",
                        pointA: {
                            x: 0,
                            y: 0
                        },
                        pointB: {
                            x: 0,
                            y: 0
                        },
                        length: .01,
                        stiffness: .1,
                        angularStiffness: 1,
                        collisionFilter: {
                            category: 1,
                            mask: 4294967295,
                            group: 0
                        }
                    })), this.world.on(l.BEFORE_UPDATE, this.update, this), t.sys.input.on(r.POINTER_DOWN, this.onDown, this), t.sys.input.on(r.POINTER_UP, this.onUp, this);
                },
                onDown: function(t) {
                    this.pointer || (this.pointer = t, this.camera = t.camera);
                },
                onUp: function(t) {
                    t === this.pointer && (this.pointer = null);
                },
                getBody: function(t) {
                    var e = this.position, i = this.constraint;
                    this.camera.getWorldPoint(t.x, t.y, e);
                    for(var n = a.allBodies(this.world.localWorld), s = 0; s < n.length; s++){
                        var r = n[s];
                        if (!r.ignorePointer && o.contains(r.bounds, e) && h.canCollide(r.collisionFilter, i.collisionFilter) && this.hitTestBody(r, e)) return this.world.emit(l.DRAG_START, r, this.part, this), !0;
                    }
                    return !1;
                },
                hitTestBody: function(t, e) {
                    for(var i = this.constraint, n = t.parts.length, s = 1 < n ? 1 : 0; s < n; s++){
                        var r = t.parts[s];
                        if (f.contains(r.vertices, e)) return i.pointA = e, i.pointB = {
                            x: e.x - t.position.x,
                            y: e.y - t.position.y
                        }, i.bodyB = t, i.angleB = t.angle, c.set(t, !1), this.part = r, this.body = t, !0;
                    }
                    return !1;
                },
                update: function() {
                    var t = this.pointer, e = this.body;
                    if (this.active && t) {
                        if (t.isDown || !e) {
                            if (t.isDown) {
                                if (!e && !this.getBody(t)) return;
                                e = this.body;
                                var i = this.position, n = this.constraint;
                                this.camera.getWorldPoint(t.x, t.y, i), n.pointA.x = i.x, n.pointA.y = i.y, c.set(e, !1), this.world.emit(l.DRAG, e, this);
                            }
                        } else this.stopDrag();
                    } else e && this.stopDrag();
                },
                stopDrag: function() {
                    var t = this.body, e = this.constraint;
                    e.bodyB = null, e.pointB = null, this.pointer = null, this.body = null, this.part = null, t && this.world.emit(l.DRAG_END, t, this);
                },
                destroy: function() {
                    this.world.removeConstraint(this.constraint), this.pointer = null, this.constraint = null, this.body = null, this.part = null, this.world.off(l.BEFORE_UPDATE, this.update), this.scene.sys.input.off(r.POINTER_DOWN, this.onDown, this), this.scene.sys.input.off(r.POINTER_UP, this.onUp, this);
                }
            });
            t.exports = p;
        },
        function(t, e, i) {
            var n = {};
            t.exports = n;
            var s = i(1392), r = i(50);
            n.name = "matter-js", n.version = "0.14.2", n.uses = [], n.used = [], n.use = function() {
                s.use(n, Array.prototype.slice.call(arguments));
            }, n.before = function(t, e) {
                return t = t.replace(/^Matter./, ""), r.chainPathBefore(n, t, e);
            }, n.after = function(t, e) {
                return t = t.replace(/^Matter./, ""), r.chainPathAfter(n, t, e);
            };
        },
        function(t, e, i) {
            var d = {};
            t.exports = d;
            var f = i(116), h = i(588), l = i(117), p = i(126), a = i(94);
            d.collides = function(t, e) {
                for(var i = [], n = 0; n < e.length; n++){
                    var s = e[n];
                    if (t !== s && l.overlaps(s.bounds, t.bounds)) for(var r = 1 === s.parts.length ? 0 : 1; r < s.parts.length; r++){
                        var o = s.parts[r];
                        if (l.overlaps(o.bounds, t.bounds)) {
                            var a = h.collides(o, t);
                            if (a.collided) {
                                i.push(a);
                                break;
                            }
                        }
                    }
                }
                return i;
            }, d.ray = function(t, e, i, n) {
                n = n || 1e-100;
                for(var s = f.angle(e, i), r = f.magnitude(f.sub(e, i)), o = .5 * (i.x + e.x), a = .5 * (i.y + e.y), h = p.rectangle(o, a, r, n, {
                    angle: s
                }), l = d.collides(h, t), u = 0; u < l.length; u += 1){
                    var c = l[u];
                    c.body = c.bodyB = c.bodyA;
                }
                return l;
            }, d.region = function(t, e, i) {
                for(var n = [], s = 0; s < t.length; s++){
                    var r = t[s], o = l.overlaps(r.bounds, e);
                    (o && !i || !o && i) && n.push(r);
                }
                return n;
            }, d.point = function(t, e) {
                for(var i = [], n = 0; n < t.length; n++){
                    var s = t[n];
                    if (l.contains(s.bounds, e)) for(var r = 1 === s.parts.length ? 0 : 1; r < s.parts.length; r++){
                        var o = s.parts[r];
                        if (l.contains(o.bounds, e) && a.contains(o.vertices, e)) {
                            i.push(s);
                            break;
                        }
                    }
                }
                return i;
            };
        },
        function(t, e, i) {
            var p = {};
            t.exports = p;
            var s = i(1393), g = i(267), v = i(1396), m = i(1395), y = i(1528), r = i(1394), x = i(268), T = i(163), w = i(246), o = i(50), a = i(71);
            p.create = function(t, e) {
                e = (e = o.isElement(t) ? e : t) || {}, ((t = o.isElement(t) ? t : null) || e.render) && o.warn("Engine.create: engine.render is deprecated (see docs)");
                var i = {
                    positionIterations: 6,
                    velocityIterations: 4,
                    constraintIterations: 2,
                    enableSleeping: !1,
                    events: [],
                    plugin: {},
                    timing: {
                        timestamp: 0,
                        timeScale: 1
                    },
                    broadphase: {
                        controller: r
                    }
                }, n = o.extend(i, e);
                return n.world = e.world || s.create(n.world), n.pairs = m.create(), n.broadphase = n.broadphase.controller.create(n.broadphase), n.metrics = n.metrics || {
                    extended: !1
                }, n.metrics = y.create(n.metrics), n;
            }, p.update = function(t, e, i) {
                e = e || 1e3 / 60, i = i || 1;
                var n, s = t.world, r = t.timing, o = t.broadphase, a = [];
                r.timestamp += e * r.timeScale;
                var h = {
                    timestamp: r.timestamp
                };
                x.trigger(t, "beforeUpdate", h);
                var l = T.allBodies(s), u = T.allConstraints(s);
                for(y.reset(t.metrics), t.enableSleeping && g.update(l, r.timeScale), p._bodiesApplyGravity(l, s.gravity), p._bodiesUpdate(l, e, r.timeScale, i, s.bounds), w.preSolveAll(l), n = 0; n < t.constraintIterations; n++)w.solveAll(u, r.timeScale);
                w.postSolveAll(l), a = o.controller ? (s.isModified && o.controller.clear(o), o.controller.update(o, l, t, s.isModified), o.pairsList) : l, s.isModified && T.setModified(s, !1, !1, !0);
                var c = o.detector(a, t), d = t.pairs, f = r.timestamp;
                for(m.update(d, c, f), m.removeOld(d, f), t.enableSleeping && g.afterCollisions(d.list, r.timeScale), 0 < d.collisionStart.length && x.trigger(t, "collisionStart", {
                    pairs: d.collisionStart
                }), v.preSolvePosition(d.list), n = 0; n < t.positionIterations; n++)v.solvePosition(d.list, l, r.timeScale);
                for(v.postSolvePosition(l), w.preSolveAll(l), n = 0; n < t.constraintIterations; n++)w.solveAll(u, r.timeScale);
                for(w.postSolveAll(l), v.preSolveVelocity(d.list), n = 0; n < t.velocityIterations; n++)v.solveVelocity(d.list, r.timeScale);
                return 0 < d.collisionActive.length && x.trigger(t, "collisionActive", {
                    pairs: d.collisionActive
                }), 0 < d.collisionEnd.length && x.trigger(t, "collisionEnd", {
                    pairs: d.collisionEnd
                }), y.update(t.metrics, t), p._bodiesClearForces(l), x.trigger(t, "afterUpdate", h), t;
            }, p.merge = function(t, e) {
                if (o.extend(t, e), e.world) {
                    t.world = e.world, p.clear(t);
                    for(var i = T.allBodies(t.world), n = 0; n < i.length; n++){
                        var s = i[n];
                        g.set(s, !1), s.id = o.nextId();
                    }
                }
            }, p.clear = function(t) {
                var e = t.world;
                m.clear(t.pairs);
                var i, n = t.broadphase;
                n.controller && (i = T.allBodies(e), n.controller.clear(n), n.controller.update(n, i, t, !0));
            }, p._bodiesClearForces = function(t) {
                for(var e = 0; e < t.length; e++){
                    var i = t[e];
                    i.force.x = 0, i.force.y = 0, i.torque = 0;
                }
            }, p._bodiesApplyGravity = function(t, e) {
                var i = void 0 !== e.scale ? e.scale : .001;
                if ((0 !== e.x || 0 !== e.y) && 0 !== i) for(var n = 0; n < t.length; n++){
                    var s = t[n];
                    s.ignoreGravity || s.isStatic || s.isSleeping || (s.force.x += s.mass * e.x * i * s.gravityScale.x, s.force.y += s.mass * e.y * i * s.gravityScale.y);
                }
            }, p._bodiesUpdate = function(t, e, i, n, s) {
                for(var r = 0; r < t.length; r++){
                    var o = t[r];
                    o.isStatic || o.isSleeping || a.update(o, e, i, n);
                }
            };
        },
        function(t, e, i) {
            var o = i(126), n = i(71), s = i(0), y = i(50), u = i(163), T = i(1495), w = i(9), a = i(586), b = i(2), E = i(6), r = i(71), h = i(268), l = i(1390), c = i(1393), x = i(116), d = new s({
                Extends: w,
                initialize: function(t, e) {
                    w.call(this), this.scene = t, this.engine = T.create(e), this.localWorld = this.engine.world;
                    var i = E(e, "gravity", null);
                    i ? this.setGravity(i.x, i.y, i.scale) : !1 === i && this.setGravity(0, 0, 0), this.walls = {
                        left: null,
                        right: null,
                        top: null,
                        bottom: null
                    }, this.enabled = E(e, "enabled", !0), this.correction = E(e, "correction", 1), this.getDelta = E(e, "getDelta", this.update60Hz);
                    var n = b(e, "runner", {}), s = b(n, "fps", !1), r = b(n, "fps", 60), o = b(n, "delta", 1e3 / r), a = b(n, "deltaMin", 1e3 / r), h = b(n, "deltaMax", 1e3 / (.5 * r));
                    s || (r = 1e3 / o), this.runner = {
                        fps: r,
                        correction: b(n, "correction", 1),
                        deltaSampleSize: b(n, "deltaSampleSize", 60),
                        counterTimestamp: 0,
                        frameCounter: 0,
                        deltaHistory: [],
                        timePrev: null,
                        timeScalePrev: 1,
                        frameRequestId: null,
                        isFixed: b(n, "isFixed", !1),
                        delta: o,
                        deltaMin: a,
                        deltaMax: h
                    }, this.autoUpdate = E(e, "autoUpdate", !0);
                    var l, u, c, d, f, p, g, v, m, y, x = E(e, "debug", !1);
                    this.drawDebug = "object" == typeof x || x, this.debugGraphic, this.debugConfig = {
                        showAxes: b(x, "showAxes", !1),
                        showAngleIndicator: b(x, "showAngleIndicator", !1),
                        angleColor: b(x, "angleColor", 15208787),
                        showBroadphase: b(x, "showBroadphase", !1),
                        broadphaseColor: b(x, "broadphaseColor", 16757760),
                        showBounds: b(x, "showBounds", !1),
                        boundsColor: b(x, "boundsColor", 16777215),
                        showVelocity: b(x, "showVelocity", !1),
                        velocityColor: b(x, "velocityColor", 44783),
                        showCollisions: b(x, "showCollisions", !1),
                        collisionColor: b(x, "collisionColor", 16094476),
                        showSeparations: b(x, "showSeparations", !1),
                        separationColor: b(x, "separationColor", 16753920),
                        showBody: b(x, "showBody", !0),
                        showStaticBody: b(x, "showStaticBody", !0),
                        showInternalEdges: b(x, "showInternalEdges", !1),
                        renderFill: b(x, "renderFill", !1),
                        renderLine: b(x, "renderLine", !0),
                        fillColor: b(x, "fillColor", 1075465),
                        fillOpacity: b(x, "fillOpacity", 1),
                        lineColor: b(x, "lineColor", 2678297),
                        lineOpacity: b(x, "lineOpacity", 1),
                        lineThickness: b(x, "lineThickness", 1),
                        staticFillColor: b(x, "staticFillColor", 857979),
                        staticLineColor: b(x, "staticLineColor", 1255396),
                        showSleeping: b(x, "showSleeping", !1),
                        staticBodySleepOpacity: b(x, "staticBodySleepOpacity", .7),
                        sleepFillColor: b(x, "sleepFillColor", 4605510),
                        sleepLineColor: b(x, "sleepLineColor", 10066585),
                        showSensors: b(x, "showSensors", !0),
                        sensorFillColor: b(x, "sensorFillColor", 857979),
                        sensorLineColor: b(x, "sensorLineColor", 1255396),
                        showPositions: b(x, "showPositions", !0),
                        positionSize: b(x, "positionSize", 4),
                        positionColor: b(x, "positionColor", 14697178),
                        showJoint: b(x, "showJoint", !0),
                        jointColor: b(x, "jointColor", 14737474),
                        jointLineOpacity: b(x, "jointLineOpacity", 1),
                        jointLineThickness: b(x, "jointLineThickness", 2),
                        pinSize: b(x, "pinSize", 4),
                        pinColor: b(x, "pinColor", 4382944),
                        springColor: b(x, "springColor", 14697184),
                        anchorColor: b(x, "anchorColor", 15724527),
                        anchorSize: b(x, "anchorSize", 4),
                        showConvexHulls: b(x, "showConvexHulls", !1),
                        hullColor: b(x, "hullColor", 14091216)
                    }, this.drawDebug && this.createDebugGraphic(), this.setEventsProxy(), b(e, "setBounds", !1) && ("boolean" == typeof (l = e.setBounds) ? this.setBounds() : (u = b(l, "x", 0), c = b(l, "y", 0), d = b(l, "width", t.sys.scale.width), f = b(l, "height", t.sys.scale.height), p = b(l, "thickness", 64), g = b(l, "left", !0), v = b(l, "right", !0), m = b(l, "top", !0), y = b(l, "bottom", !0), this.setBounds(u, c, d, f, p, g, v, m, y)));
                },
                setCompositeRenderStyle: function(t) {
                    for(var e, i, n = t.bodies, s = t.constraints, r = t.composites, o = 0; o < n.length; o++)i = (e = n[o]).render, this.setBodyRenderStyle(e, i.lineColor, i.lineOpacity, i.lineThickness, i.fillColor, i.fillOpacity);
                    for(o = 0; o < s.length; o++)i = (e = s[o]).render, this.setConstraintRenderStyle(e, i.lineColor, i.lineOpacity, i.lineThickness, i.pinSize, i.anchorColor, i.anchorSize);
                    for(o = 0; o < r.length; o++)e = r[o], this.setCompositeRenderStyle(e);
                    return this;
                },
                setBodyRenderStyle: function(t, e, i, n, s, r) {
                    var o = t.render, a = this.debugConfig;
                    return o && (null == e && (e = t.isStatic ? a.staticLineColor : a.lineColor), null == i && (i = a.lineOpacity), null == n && (n = a.lineThickness), null == s && (s = t.isStatic ? a.staticFillColor : a.fillColor), null == r && (r = a.fillOpacity), !1 !== e && (o.lineColor = e), !1 !== i && (o.lineOpacity = i), !1 !== n && (o.lineThickness = n), !1 !== s && (o.fillColor = s), !1 !== r && (o.fillOpacity = r)), this;
                },
                setConstraintRenderStyle: function(t, e, i, n, s, r, o) {
                    var a, h = t.render, l = this.debugConfig;
                    return h && (null == e && ("line" === (a = h.type) ? e = l.jointColor : "pin" === a ? e = l.pinColor : "spring" === a && (e = l.springColor)), null == i && (i = l.jointLineOpacity), null == n && (n = l.jointLineThickness), null == s && (s = l.pinSize), null == r && (r = l.anchorColor), null == o && (o = l.anchorSize), !1 !== e && (h.lineColor = e), !1 !== i && (h.lineOpacity = i), !1 !== n && (h.lineThickness = n), !1 !== s && (h.pinSize = s), !1 !== r && (h.anchorColor = r), !1 !== o && (h.anchorSize = o)), this;
                },
                setEventsProxy: function() {
                    var r = this, t = this.engine, e = this.localWorld;
                    this.drawDebug && (h.on(e, "compositeModified", function(t) {
                        r.setCompositeRenderStyle(t);
                    }), h.on(e, "beforeAdd", function(t) {
                        for(var e = [].concat(t.object), i = 0; i < e.length; i++){
                            var n = e[i], s = n.render;
                            "body" === n.type ? r.setBodyRenderStyle(n, s.lineColor, s.lineOpacity, s.lineThickness, s.fillColor, s.fillOpacity) : "composite" === n.type ? r.setCompositeRenderStyle(n) : "constraint" === n.type && r.setConstraintRenderStyle(n, s.lineColor, s.lineOpacity, s.lineThickness, s.pinSize, s.anchorColor, s.anchorSize);
                        }
                    })), h.on(e, "beforeAdd", function(t) {
                        r.emit(a.BEFORE_ADD, t);
                    }), h.on(e, "afterAdd", function(t) {
                        r.emit(a.AFTER_ADD, t);
                    }), h.on(e, "beforeRemove", function(t) {
                        r.emit(a.BEFORE_REMOVE, t);
                    }), h.on(e, "afterRemove", function(t) {
                        r.emit(a.AFTER_REMOVE, t);
                    }), h.on(t, "beforeUpdate", function(t) {
                        r.emit(a.BEFORE_UPDATE, t);
                    }), h.on(t, "afterUpdate", function(t) {
                        r.emit(a.AFTER_UPDATE, t);
                    }), h.on(t, "collisionStart", function(t) {
                        var e, i, n = t.pairs;
                        0 < n.length && (e = n[0].bodyA, i = n[0].bodyB), r.emit(a.COLLISION_START, t, e, i);
                    }), h.on(t, "collisionActive", function(t) {
                        var e, i, n = t.pairs;
                        0 < n.length && (e = n[0].bodyA, i = n[0].bodyB), r.emit(a.COLLISION_ACTIVE, t, e, i);
                    }), h.on(t, "collisionEnd", function(t) {
                        var e, i, n = t.pairs;
                        0 < n.length && (e = n[0].bodyA, i = n[0].bodyB), r.emit(a.COLLISION_END, t, e, i);
                    });
                },
                setBounds: function(t, e, i, n, s, r, o, a, h) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.scene.sys.scale.width), void 0 === n && (n = this.scene.sys.scale.height), void 0 === s && (s = 64), void 0 === r && (r = !0), void 0 === o && (o = !0), void 0 === a && (a = !0), void 0 === h && (h = !0), this.updateWall(r, "left", t - s, e - s, s, n + 2 * s), this.updateWall(o, "right", t + i, e - s, s, n + 2 * s), this.updateWall(a, "top", t, e - s, i, s), this.updateWall(h, "bottom", t, e + n, i, s), this;
                },
                updateWall: function(t, e, i, n, s, r) {
                    var o = this.walls[e];
                    t ? (o && c.remove(this.localWorld, o), i += s / 2, n += r / 2, this.walls[e] = this.create(i, n, s, r, {
                        isStatic: !0,
                        friction: 0,
                        frictionStatic: 0
                    })) : (o && c.remove(this.localWorld, o), this.walls[e] = null);
                },
                createDebugGraphic: function() {
                    var t = this.scene.sys.add.graphics({
                        x: 0,
                        y: 0
                    });
                    return t.setDepth(Number.MAX_VALUE), this.debugGraphic = t, this.drawDebug = !0, t;
                },
                disableGravity: function() {
                    return this.localWorld.gravity.x = 0, this.localWorld.gravity.y = 0, this.localWorld.gravity.scale = 0, this;
                },
                setGravity: function(t, e, i) {
                    return void 0 === t && (t = 0), void 0 === e && (e = 1), this.localWorld.gravity.x = t, this.localWorld.gravity.y = e, void 0 !== i && (this.localWorld.gravity.scale = i), this;
                },
                create: function(t, e, i, n, s) {
                    var r = o.rectangle(t, e, i, n, s);
                    return c.add(this.localWorld, r), r;
                },
                add: function(t) {
                    return c.add(this.localWorld, t), this;
                },
                remove: function(t, e) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i], s = n.body ? n.body : n;
                        u.remove(this.localWorld, s, e);
                    }
                    return this;
                },
                removeConstraint: function(t, e) {
                    return u.remove(this.localWorld, t, e), this;
                },
                convertTilemapLayer: function(t, e) {
                    var i = t.layer, n = t.getTilesWithin(0, 0, i.width, i.height, {
                        isColliding: !0
                    });
                    return this.convertTiles(n, e), this;
                },
                convertTiles: function(t, e) {
                    if (0 === t.length) return this;
                    for(var i = 0; i < t.length; i++)new l(this, t[i], e);
                    return this;
                },
                nextGroup: function(t) {
                    return r.nextGroup(t);
                },
                nextCategory: function() {
                    return r.nextCategory();
                },
                pause: function() {
                    return this.enabled = !1, this.emit(a.PAUSE), this;
                },
                resume: function() {
                    return this.enabled = !0, this.emit(a.RESUME), this;
                },
                update: function(t, e) {
                    var i, n, s, r;
                    this.enabled && this.autoUpdate && (i = this.engine, n = this.runner, s = i.timing, r = this.correction, n.isFixed ? e = this.getDelta(t, e) : (e = t - n.timePrev || n.delta, n.timePrev = t, n.deltaHistory.push(e), n.deltaHistory = n.deltaHistory.slice(-n.deltaSampleSize), r = (e = (e = (e = Math.min.apply(null, n.deltaHistory)) < n.deltaMin ? n.deltaMin : e) > n.deltaMax ? n.deltaMax : e) / n.delta, n.delta = e), 0 !== n.timeScalePrev && (r *= s.timeScale / n.timeScalePrev), 0 === s.timeScale && (r = 0), n.timeScalePrev = s.timeScale, n.correction = r, n.frameCounter += 1, 1e3 <= t - n.counterTimestamp && (n.fps = n.frameCounter * ((t - n.counterTimestamp) / 1e3), n.counterTimestamp = t, n.frameCounter = 0), T.update(i, e, r));
                },
                step: function(t, e) {
                    T.update(this.engine, t, e);
                },
                update60Hz: function() {
                    return 1e3 / 60;
                },
                update30Hz: function() {
                    return 1e3 / 30;
                },
                has: function(t) {
                    var e = t.hasOwnProperty("body") ? t.body : t;
                    return null !== u.get(this.localWorld, e.id, e.type);
                },
                getAllBodies: function() {
                    return u.allBodies(this.localWorld);
                },
                getAllConstraints: function() {
                    return u.allConstraints(this.localWorld);
                },
                getAllComposites: function() {
                    return u.allComposites(this.localWorld);
                },
                postUpdate: function() {
                    var t, e, i, n;
                    this.drawDebug && (t = this.debugConfig, e = this.engine, i = this.debugGraphic, n = u.allBodies(this.localWorld), this.debugGraphic.clear(), t.showBroadphase && e.broadphase.controller && this.renderGrid(e.broadphase, i, t.broadphaseColor, .5), t.showBounds && this.renderBodyBounds(n, i, t.boundsColor, .5), (t.showBody || t.showStaticBody) && this.renderBodies(n), t.showJoint && this.renderJoints(), (t.showAxes || t.showAngleIndicator) && this.renderBodyAxes(n, i, t.showAxes, t.angleColor, .5), t.showVelocity && this.renderBodyVelocity(n, i, t.velocityColor, 1, 2), t.showSeparations && this.renderSeparations(e.pairs.list, i, t.separationColor), t.showCollisions && this.renderCollisions(e.pairs.list, i, t.collisionColor));
                },
                renderGrid: function(t, e, i, n) {
                    e.lineStyle(1, i, n);
                    for(var s = y.keys(t.buckets), r = 0; r < s.length; r++){
                        var o, a = s[r];
                        t.buckets[a].length < 2 || (o = a.split(/C|R/), e.strokeRect(parseInt(o[1], 10) * t.bucketWidth, parseInt(o[2], 10) * t.bucketHeight, t.bucketWidth, t.bucketHeight));
                    }
                    return this;
                },
                renderSeparations: function(t, e, i) {
                    e.lineStyle(1, i, 1);
                    for(var n = 0; n < t.length; n++){
                        var s, r, o, a, h, l, u, c = t[n];
                        c.isActive && (r = (s = c.collision).bodyA, o = s.bodyB, a = r.position, h = o.position, l = s.penetration, u = r.isStatic || o.isStatic ? 1 : 4, o.isStatic && (u = 0), e.lineBetween(h.x, h.y, h.x - l.x * u, h.y - l.y * u), u = r.isStatic || o.isStatic ? 1 : 4, r.isStatic && (u = 0), e.lineBetween(a.x, a.y, a.x - l.x * u, a.y - l.y * u));
                    }
                    return this;
                },
                renderCollisions: function(t, e, i) {
                    var n, s, r, o, a, h;
                    for(e.lineStyle(1, i, .5), e.fillStyle(i, 1), n = 0; n < t.length; n++)if ((s = t[n]).isActive) for(var l = 0; l < s.activeContacts.length; l++){
                        var u = s.activeContacts[l].vertex;
                        e.fillRect(u.x - 2, u.y - 2, 5, 5);
                    }
                    for(n = 0; n < t.length; n++)(s = t[n]).isActive && (r = s.collision, 0 < (o = s.activeContacts).length && (a = o[0].vertex.x, h = o[0].vertex.y, 2 === o.length && (a = (o[0].vertex.x + o[1].vertex.x) / 2, h = (o[0].vertex.y + o[1].vertex.y) / 2), r.bodyB === r.supports[0].body || r.bodyA.isStatic ? e.lineBetween(a - 8 * r.normal.x, h - 8 * r.normal.y, a, h) : e.lineBetween(a + 8 * r.normal.x, h + 8 * r.normal.y, a, h)));
                    return this;
                },
                renderBodyBounds: function(t, e, i, n) {
                    e.lineStyle(1, i, n);
                    for(var s = 0; s < t.length; s++){
                        var r = t[s];
                        if (r.render.visible) {
                            var o = r.bounds;
                            if (o) e.strokeRect(o.min.x, o.min.y, o.max.x - o.min.x, o.max.y - o.min.y);
                            else for(var a = r.parts, h = 1 < a.length ? 1 : 0; h < a.length; h++){
                                var l = a[h];
                                e.strokeRect(l.bounds.min.x, l.bounds.min.y, l.bounds.max.x - l.bounds.min.x, l.bounds.max.y - l.bounds.min.y);
                            }
                        }
                    }
                    return this;
                },
                renderBodyAxes: function(t, e, i, n, s) {
                    e.lineStyle(1, n, s);
                    for(var r = 0; r < t.length; r++){
                        var o, a, h, l = t[r], u = l.parts;
                        if (l.render.visible) {
                            if (i) for(a = 1 < u.length ? 1 : 0; a < u.length; a++)for(o = u[a], h = 0; h < o.axes.length; h++){
                                var c = o.axes[h];
                                e.lineBetween(o.position.x, o.position.y, o.position.x + 20 * c.x, o.position.y + 20 * c.y);
                            }
                            else for(a = 1 < u.length ? 1 : 0; a < u.length; a++)for(o = u[a], h = 0; h < o.axes.length; h++)e.lineBetween(o.position.x, o.position.y, (o.vertices[0].x + o.vertices[o.vertices.length - 1].x) / 2, (o.vertices[0].y + o.vertices[o.vertices.length - 1].y) / 2);
                        }
                    }
                    return this;
                },
                renderBodyVelocity: function(t, e, i, n, s) {
                    e.lineStyle(s, i, n);
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.render.visible && e.lineBetween(o.position.x, o.position.y, o.position.x + 2 * (o.position.x - o.positionPrev.x), o.position.y + 2 * (o.position.y - o.positionPrev.y));
                    }
                    return this;
                },
                renderBodies: function(t) {
                    for(var e = this.debugGraphic, i = this.debugConfig, n = i.showBody, s = i.showStaticBody, r = i.showSleeping, o = i.showInternalEdges, a = i.showConvexHulls, h = i.renderFill, l = i.renderLine, u = i.staticBodySleepOpacity, c = i.sleepFillColor, d = i.sleepLineColor, f = i.hullColor, p = 0; p < t.length; p++){
                        var g, v, m, y, x, T, w = t[p];
                        w.render.visible && (!s && w.isStatic || !n && !w.isStatic || (g = w.render.lineColor, v = w.render.lineOpacity, m = w.render.lineThickness, y = w.render.fillColor, x = w.render.fillOpacity, r && w.isSleeping && (w.isStatic ? (v *= u, x *= u) : (g = d, y = c)), h || (y = null), l || (g = null), this.renderBody(w, e, o, g, v, m, y, x), T = w.parts.length, a && 1 < T && this.renderConvexHull(w, e, f, m)));
                    }
                },
                renderBody: function(t, e, i, n, s, r, o, a) {
                    void 0 === n && (n = null), void 0 === s && (s = null), void 0 === r && (r = 1), void 0 === o && (o = null), void 0 === a && (a = null);
                    for(var h, l, u, c = this.debugConfig, d = c.sensorFillColor, f = c.sensorLineColor, p = t.parts, g = p.length, v = 1 < g ? 1 : 0; v < g; v++){
                        var m = p[v], y = m.render, x = y.opacity;
                        if (y.visible && 0 !== x && (!m.isSensor || c.showSensors)) {
                            var T = m.circleRadius;
                            if (e.beginPath(), m.isSensor ? (null !== o && e.fillStyle(d, a * x), null !== n && e.lineStyle(r, f, s * x)) : (null !== o && e.fillStyle(o, a * x), null !== n && e.lineStyle(r, n, s * x)), T) e.arc(m.position.x, m.position.y, T, 0, 2 * Math.PI);
                            else {
                                var w = m.vertices, b = w.length;
                                e.moveTo(w[0].x, w[0].y);
                                for(var E = 1; E < b; E++){
                                    var S, A = w[E];
                                    !w[E - 1].isInternal || i ? e.lineTo(A.x, A.y) : e.moveTo(A.x, A.y), E < b && A.isInternal && !i && (S = (E + 1) % b, e.moveTo(w[S].x, w[S].y));
                                }
                                e.closePath();
                            }
                            null !== o && e.fillPath(), null !== n && e.strokePath();
                        }
                    }
                    return c.showPositions && !t.isStatic && (h = t.position.x, l = t.position.y, u = Math.ceil(c.positionSize / 2), e.fillStyle(c.positionColor, 1), e.fillRect(h - u, l - u, c.positionSize, c.positionSize)), this;
                },
                renderConvexHull: function(t, e, i, n) {
                    if (void 0 === n && (n = 1), 1 < t.parts.length) {
                        var s = t.vertices;
                        e.lineStyle(n, i), e.beginPath(), e.moveTo(s[0].x, s[0].y);
                        for(var r = 1; r < s.length; r++)e.lineTo(s[r].x, s[r].y);
                        e.lineTo(s[0].x, s[0].y), e.strokePath();
                    }
                    return this;
                },
                renderJoints: function() {
                    for(var t = this.debugGraphic, e = u.allConstraints(this.localWorld), i = 0; i < e.length; i++){
                        var n = e[i].render, s = n.lineColor, r = n.lineOpacity, o = n.lineThickness, a = n.pinSize, h = n.anchorColor, l = n.anchorSize;
                        this.renderConstraint(e[i], t, s, r, o, a, h, l);
                    }
                },
                renderConstraint: function(t, e, i, n, s, r, o, a) {
                    var h = t.render;
                    if (!h.visible || !t.pointA || !t.pointB) return this;
                    e.lineStyle(s, i, n);
                    var l, u = t.bodyA, c = t.bodyB, d = u ? x.add(u.position, t.pointA) : t.pointA;
                    if ("pin" === h.type) e.strokeCircle(d.x, d.y, r);
                    else {
                        if (l = c ? x.add(c.position, t.pointB) : t.pointB, e.beginPath(), e.moveTo(d.x, d.y), "spring" === h.type) for(var f, p = x.sub(l, d), g = x.perp(x.normalise(p)), v = Math.ceil(y.clamp(t.length / 5, 12, 20)), m = 1; m < v; m += 1)f = m % 2 == 0 ? 1 : -1, e.lineTo(d.x + p.x * (m / v) + g.x * f * 4, d.y + p.y * (m / v) + g.y * f * 4);
                        e.lineTo(l.x, l.y);
                    }
                    return e.strokePath(), h.anchors && 0 < a && (e.fillStyle(o), e.fillCircle(d.x, d.y, a), e.fillCircle(l.x, l.y, a)), this;
                },
                resetCollisionIDs: function() {
                    return n._nextCollidingGroupId = 1, n._nextNonCollidingGroupId = -1, n._nextCategory = 1, this;
                },
                shutdown: function() {
                    h.off(this.engine), this.removeAllListeners(), c.clear(this.localWorld, !1), T.clear(this.engine), this.drawDebug && this.debugGraphic.destroy();
                },
                destroy: function() {
                    this.shutdown();
                }
            });
            t.exports = d;
        },
        function(s, t, r) {
            (function(t) {
                r(590);
                var e = r(32), i = r(17), n = {
                    Actions: r(269),
                    Animations: r(699),
                    BlendModes: r(34),
                    Cache: r(711),
                    Cameras: r(714),
                    Core: r(803),
                    Class: r(0),
                    Create: r(884),
                    Curves: r(890),
                    Data: r(892),
                    Display: r(894),
                    DOM: r(913),
                    Events: r(914),
                    Game: r(916),
                    GameObjects: r(1007),
                    Geom: r(477),
                    Input: r(1302),
                    Loader: r(1332),
                    Math: r(190),
                    Physics: r(1498),
                    Plugins: r(1397),
                    Renderer: r(1399),
                    Scale: r(1406),
                    ScaleModes: r(164),
                    Scene: r(412),
                    Scenes: r(1407),
                    Structs: r(1409),
                    Textures: r(1410),
                    Tilemaps: r(1412),
                    Time: r(1454),
                    Tweens: r(1456),
                    Utils: r(1474)
                };
                n.Sound = r(1485), n = i(!1, n, e), s.exports = n, t.Phaser = n;
            }).call(this, r(589));
        },
        function(t, e, i) {
            t.exports = {
                Arcade: i(1360),
                Matter: i(1499)
            };
        },
        function(t, e, i) {
            t.exports = {
                BodyBounds: i(1486),
                Components: i(534),
                Events: i(586),
                Factory: i(1488),
                MatterGameObject: i(1489),
                Image: i(1490),
                Matter: i(1391),
                MatterPhysics: i(1529),
                PolyDecomp: i(1487),
                Sprite: i(1491),
                TileBody: i(1390),
                PhysicsEditorParser: i(1386),
                PhysicsJSONParser: i(1387),
                PointerConstraint: i(1492),
                World: i(1496)
            };
        },
        function(t, e) {
            t.exports = {
                setBounce: function(t) {
                    return this.body.restitution = t, this;
                }
            };
        },
        function(t, e) {
            var i = {
                setCollisionCategory: function(t) {
                    return this.body.collisionFilter.category = t, this;
                },
                setCollisionGroup: function(t) {
                    return this.body.collisionFilter.group = t, this;
                },
                setCollidesWith: function(t) {
                    var e = 0;
                    if (Array.isArray(t)) for(var i = 0; i < t.length; i++)e |= t[i];
                    else e = t;
                    return this.body.collisionFilter.mask = e, this;
                },
                setOnCollide: function(t) {
                    return this.body.onCollideCallback = t, this;
                },
                setOnCollideEnd: function(t) {
                    return this.body.onCollideEndCallback = t, this;
                },
                setOnCollideActive: function(t) {
                    return this.body.onCollideActiveCallback = t, this;
                },
                setOnCollideWith: function(t, e) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var i = 0; i < t.length; i++){
                        var n = t[i].hasOwnProperty("body") ? t[i].body : t[i];
                        this.body.setOnCollideWith(n, e);
                    }
                    return this;
                }
            };
            t.exports = i;
        },
        function(t, e, i) {
            var n = i(71), s = {
                applyForce: function(t) {
                    return this._tempVec2.set(this.body.position.x, this.body.position.y), n.applyForce(this.body, this._tempVec2, t), this;
                },
                applyForceFrom: function(t, e) {
                    return n.applyForce(this.body, t, e), this;
                },
                thrust: function(t) {
                    var e = this.body.angle;
                    return this._tempVec2.set(t * Math.cos(e), t * Math.sin(e)), n.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2), this;
                },
                thrustLeft: function(t) {
                    var e = this.body.angle - Math.PI / 2;
                    return this._tempVec2.set(t * Math.cos(e), t * Math.sin(e)), n.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2), this;
                },
                thrustRight: function(t) {
                    var e = this.body.angle + Math.PI / 2;
                    return this._tempVec2.set(t * Math.cos(e), t * Math.sin(e)), n.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2), this;
                },
                thrustBack: function(t) {
                    var e = this.body.angle - Math.PI;
                    return this._tempVec2.set(t * Math.cos(e), t * Math.sin(e)), n.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2), this;
                }
            };
            t.exports = s;
        },
        function(t, e) {
            var i = {
                setFriction: function(t, e, i) {
                    return this.body.friction = t, void 0 !== e && (this.body.frictionAir = e), void 0 !== i && (this.body.frictionStatic = i), this;
                },
                setFrictionAir: function(t) {
                    return this.body.frictionAir = t, this;
                },
                setFrictionStatic: function(t) {
                    return this.body.frictionStatic = t, this;
                }
            };
            t.exports = i;
        },
        function(t, e) {
            t.exports = {
                setIgnoreGravity: function(t) {
                    return this.body.ignoreGravity = t, this;
                }
            };
        },
        function(t, e, i) {
            var n = i(71), s = i(3), r = {
                setMass: function(t) {
                    return n.setMass(this.body, t), this;
                },
                setDensity: function(t) {
                    return n.setDensity(this.body, t), this;
                },
                centerOfMass: {
                    get: function() {
                        return new s(this.body.centerOfMass.x, this.body.centerOfMass.y);
                    }
                }
            };
            t.exports = r;
        },
        function(t, e) {
            t.exports = {
                setSensor: function(t) {
                    return this.body.isSensor = t, this;
                },
                isSensor: function() {
                    return this.body.isSensor;
                }
            };
        },
        function(t, e, i) {
            var m = i(126), y = i(71), u = i(123), x = i(2), T = i(1386), w = i(1387), b = i(94), n = {
                setRectangle: function(t, e, i) {
                    return this.setBody({
                        type: "rectangle",
                        width: t,
                        height: e
                    }, i);
                },
                setCircle: function(t, e) {
                    return this.setBody({
                        type: "circle",
                        radius: t
                    }, e);
                },
                setPolygon: function(t, e, i) {
                    return this.setBody({
                        type: "polygon",
                        sides: e,
                        radius: t
                    }, i);
                },
                setTrapezoid: function(t, e, i, n) {
                    return this.setBody({
                        type: "trapezoid",
                        width: t,
                        height: e,
                        slope: i
                    }, n);
                },
                setExistingBody: function(t, e) {
                    void 0 === e && (e = !0), this.body && this.world.remove(this.body, !0), this.body = t;
                    for(var i = 0; i < t.parts.length; i++)t.parts[i].gameObject = this;
                    var n, s, r, o, a, h, l = this;
                    return t.destroy = function() {
                        l.world.remove(l.body, !0), l.body.gameObject = null;
                    }, e && (this.world.has(t) && this.world.remove(t, !0), this.world.add(t)), this._originComponent && (n = t.render.sprite.xOffset, s = t.render.sprite.yOffset, r = t.centerOfMass.x, o = t.centerOfMass.y, u(r, .5) && u(o, .5) ? this.setOrigin(n + .5, s + .5) : (a = t.centerOffset.x, h = t.centerOffset.y, this.setOrigin(n + a / this.displayWidth, s + h / this.displayHeight))), this;
                },
                setBody: function(t, e) {
                    if (!t) return this;
                    "string" == typeof t && (t = {
                        type: t
                    });
                    var i = x(t, "type", "rectangle"), n = x(t, "x", this._tempVec2.x), s = x(t, "y", this._tempVec2.y), r = x(t, "width", this.width), o = x(t, "height", this.height);
                    switch(i){
                        case "rectangle":
                            l = m.rectangle(n, s, r, o, e);
                            break;
                        case "circle":
                            var a = x(t, "radius", Math.max(r, o) / 2), h = x(t, "maxSides", 25), l = m.circle(n, s, a, e, h);
                            break;
                        case "trapezoid":
                            var u = x(t, "slope", .5);
                            l = m.trapezoid(n, s, r, o, u, e);
                            break;
                        case "polygon":
                            var c = x(t, "sides", 5), d = x(t, "radius", Math.max(r, o) / 2);
                            l = m.polygon(n, s, c, d, e);
                            break;
                        case "fromVertices":
                        case "fromVerts":
                            var f, p, g, v = x(t, "verts", null);
                            v && ("string" == typeof v && (v = b.fromPath(v)), l = this.body && !this.body.hasOwnProperty("temp") ? (y.setVertices(this.body, v), this.body) : (f = x(t, "flagInternal", !1), p = x(t, "removeCollinear", .01), g = x(t, "minimumArea", 10), m.fromVertices(n, s, v, e, f, p, g)));
                            break;
                        case "fromPhysicsEditor":
                            l = T.parseBody(n, s, t, e);
                            break;
                        case "fromPhysicsTracer":
                            l = w.parseBody(n, s, t, e);
                    }
                    return l && this.setExistingBody(l, t.addToWorld), this;
                }
            };
            t.exports = n;
        },
        function(t, e, i) {
            var n = i(586), s = i(267), r = i(268), o = {
                setToSleep: function() {
                    s.set(this.body, !0);
                },
                setAwake: function() {
                    s.set(this.body, !1);
                },
                setSleepThreshold: function(t) {
                    return void 0 === t && (t = 60), this.body.sleepThreshold = t, this;
                },
                setSleepEvents: function(t, e) {
                    return this.setSleepStartEvent(t), this.setSleepEndEvent(e), this;
                },
                setSleepStartEvent: function(t) {
                    var e;
                    return t ? (e = this.world, r.on(this.body, "sleepStart", function(t) {
                        e.emit(n.SLEEP_START, t, this);
                    })) : r.off(this.body, "sleepStart"), this;
                },
                setSleepEndEvent: function(t) {
                    var e;
                    return t ? (e = this.world, r.on(this.body, "sleepEnd", function(t) {
                        e.emit(n.SLEEP_END, t, this);
                    })) : r.off(this.body, "sleepEnd"), this;
                }
            };
            t.exports = o;
        },
        function(t, e) {
            t.exports = "afteradd";
        },
        function(t, e) {
            t.exports = "afterremove";
        },
        function(t, e) {
            t.exports = "afterupdate";
        },
        function(t, e) {
            t.exports = "beforeadd";
        },
        function(t, e) {
            t.exports = "beforeremove";
        },
        function(t, e) {
            t.exports = "beforeupdate";
        },
        function(t, e) {
            t.exports = "collisionactive";
        },
        function(t, e) {
            t.exports = "collisionend";
        },
        function(t, e) {
            t.exports = "collisionstart";
        },
        function(t, e) {
            t.exports = "dragend";
        },
        function(t, e) {
            t.exports = "drag";
        },
        function(t, e) {
            t.exports = "dragstart";
        },
        function(t, e) {
            t.exports = "pause";
        },
        function(t, e) {
            t.exports = "resume";
        },
        function(t, e) {
            t.exports = "sleepend";
        },
        function(t, e) {
            t.exports = "sleepstart";
        },
        function(t, e, i) {
            var n = i(71), s = {
                setStatic: function(t) {
                    return n.setStatic(this.body, t), this;
                },
                isStatic: function() {
                    return this.body.isStatic;
                }
            };
            t.exports = s;
        },
        function(t, e, i) {
            var r = i(71), n = i(14), s = i(265), o = i(266), a = {
                x: {
                    get: function() {
                        return this.body.position.x;
                    },
                    set: function(t) {
                        this._tempVec2.set(t, this.y), r.setPosition(this.body, this._tempVec2);
                    }
                },
                y: {
                    get: function() {
                        return this.body.position.y;
                    },
                    set: function(t) {
                        this._tempVec2.set(this.x, t), r.setPosition(this.body, this._tempVec2);
                    }
                },
                scaleX: {
                    get: function() {
                        return this._scaleX;
                    },
                    set: function(t) {
                        var e = 1 / this._scaleX, i = 1 / this._scaleY;
                        this._scaleX = t, 0 === this._scaleX ? this.renderFlags &= -5 : this.renderFlags |= 4, r.scale(this.body, e, i), r.scale(this.body, t, this._scaleY);
                    }
                },
                scaleY: {
                    get: function() {
                        return this._scaleY;
                    },
                    set: function(t) {
                        var e = 1 / this._scaleX, i = 1 / this._scaleY;
                        this._scaleY = t, 0 === this._scaleY ? this.renderFlags &= -5 : this.renderFlags |= 4, r.scale(this.body, e, i), r.scale(this.body, this._scaleX, t);
                    }
                },
                angle: {
                    get: function() {
                        return o(this.body.angle * n.RAD_TO_DEG);
                    },
                    set: function(t) {
                        this.rotation = o(t) * n.DEG_TO_RAD;
                    }
                },
                rotation: {
                    get: function() {
                        return this.body.angle;
                    },
                    set: function(t) {
                        this._rotation = s(t), r.setAngle(this.body, this._rotation);
                    }
                },
                setPosition: function(t, e) {
                    return void 0 === t && (t = 0), void 0 === e && (e = t), this._tempVec2.set(t, e), r.setPosition(this.body, this._tempVec2), this;
                },
                setRotation: function(t) {
                    return void 0 === t && (t = 0), this._rotation = s(t), r.setAngle(this.body, t), this;
                },
                setFixedRotation: function() {
                    return r.setInertia(this.body, 1 / 0), this;
                },
                setAngle: function(t) {
                    return void 0 === t && (t = 0), this.angle = t, r.setAngle(this.body, this.rotation), this;
                },
                setScale: function(t, e, i) {
                    void 0 === t && (t = 1), void 0 === e && (e = t);
                    var n = 1 / this._scaleX, s = 1 / this._scaleY;
                    return this._scaleX = t, this._scaleY = e, r.scale(this.body, n, s, i), r.scale(this.body, t, e, i), this;
                }
            };
            t.exports = a;
        },
        function(t, e, i) {
            var n = i(71), s = {
                setAngularVelocity: function(t) {
                    return n.setAngularVelocity(this.body, t), this;
                },
                setVelocityX: function(t) {
                    return this._tempVec2.set(t, this.body.velocity.y), n.setVelocity(this.body, this._tempVec2), this;
                },
                setVelocityY: function(t) {
                    return this._tempVec2.set(this.body.velocity.x, t), n.setVelocity(this.body, this._tempVec2), this;
                },
                setVelocity: function(t, e) {
                    return this._tempVec2.set(t, e), n.setVelocity(this.body, this._tempVec2), this;
                }
            };
            t.exports = s;
        },
        function(t, e, i) {
            var n = {};
            t.exports = n;
            var s = i(163), r = i(50);
            n.create = function(t) {
                return r.extend({
                    extended: !1,
                    narrowDetections: 0,
                    narrowphaseTests: 0,
                    narrowReuse: 0,
                    narrowReuseCount: 0,
                    midphaseTests: 0,
                    broadphaseTests: 0,
                    narrowEff: 1e-4,
                    midEff: 1e-4,
                    broadEff: 1e-4,
                    collisions: 0,
                    buckets: 0,
                    bodies: 0,
                    pairs: 0
                }, !1, t);
            }, n.reset = function(t) {
                t.extended && (t.narrowDetections = 0, t.narrowphaseTests = 0, t.narrowReuse = 0, t.narrowReuseCount = 0, t.midphaseTests = 0, t.broadphaseTests = 0, t.narrowEff = 0, t.midEff = 0, t.broadEff = 0, t.collisions = 0, t.buckets = 0, t.pairs = 0, t.bodies = 0);
            }, n.update = function(t, e) {
                var i, n;
                t.extended && (i = e.world, n = s.allBodies(i), t.collisions = t.narrowDetections, t.pairs = e.pairs.list.length, t.bodies = n.length, t.midEff = (t.narrowDetections / (t.midphaseTests || 1)).toFixed(2), t.narrowEff = (t.narrowDetections / (t.narrowphaseTests || 1)).toFixed(2), t.broadEff = (1 - t.broadphaseTests / (n.length || 1)).toFixed(2), t.narrowReuse = (t.narrowReuseCount / (t.narrowphaseTests || 1)).toFixed(2));
            };
        },
        function(t, e, i) {
            var r = i(122), n = i(585), s = i(126), o = i(71), a = i(1486), h = i(117), l = i(0), u = i(163), c = i(1388), d = i(246), f = i(587), p = i(48), g = i(1488), v = i(2), m = i(6), y = i(1394), x = i(1530), T = i(1531), w = i(1493), b = i(1532), E = i(143), S = i(535), A = i(1395), _ = i(1392), C = i(24), M = i(1494), R = i(1396), P = i(588), O = i(21), L = i(1389), D = i(116), F = i(94), k = i(1496), I = new l({
                initialize: function(t) {
                    this.scene = t, this.systems = t.sys, this.config = this.getConfig(), this.world, this.add, this.bodyBounds, this.body = o, this.composite = u, this.detector = f, this.grid = y, this.pair = S, this.pairs = A, this.query = M, this.resolver = R, this.sat = P, this.constraint = d, this.bodies = s, this.composites = c, this.axes = n, this.bounds = h, this.svg = L, this.vector = D, this.vertices = F, this.verts = F, this._tempVec2 = D.create(), m(this.config, "plugins.collisionevents", !0) && this.enableCollisionEventsPlugin(), m(this.config, "plugins.attractors", !1) && this.enableAttractorPlugin(), m(this.config, "plugins.wrap", !1) && this.enableWrapPlugin(), R._restingThresh = m(this.config, "restingThresh", 4), R._restingThreshTangent = m(this.config, "restingThreshTangent", 6), R._positionDampen = m(this.config, "positionDampen", .9), R._positionWarming = m(this.config, "positionWarming", .8), R._frictionNormalMultiplier = m(this.config, "frictionNormalMultiplier", 5), t.sys.events.once(O.BOOT, this.boot, this), t.sys.events.on(O.START, this.start, this);
                },
                boot: function() {
                    this.world = new k(this.scene, this.config), this.add = new g(this.world), this.bodyBounds = new a, this.systems.events.once(O.DESTROY, this.destroy, this);
                },
                start: function() {
                    this.world || (this.world = new k(this.scene, this.config), this.add = new g(this.world));
                    var t = this.systems.events;
                    t.on(O.UPDATE, this.world.update, this.world), t.on(O.POST_UPDATE, this.world.postUpdate, this.world), t.once(O.SHUTDOWN, this.shutdown, this);
                },
                getConfig: function() {
                    var t = this.systems.game.config.physics, e = this.systems.settings.physics;
                    return E(v(e, "matter", {}), v(t, "matter", {}));
                },
                enableAttractorPlugin: function() {
                    return _.register(x), _.use(w, x), this;
                },
                enableWrapPlugin: function() {
                    return _.register(b), _.use(w, b), this;
                },
                enableCollisionEventsPlugin: function() {
                    return _.register(T), _.use(w, T), this;
                },
                pause: function() {
                    return this.world.pause();
                },
                resume: function() {
                    return this.world.resume();
                },
                set60Hz: function() {
                    return this.world.getDelta = this.world.update60Hz, this.world.autoUpdate = !0, this;
                },
                set30Hz: function() {
                    return this.world.getDelta = this.world.update30Hz, this.world.autoUpdate = !0, this;
                },
                step: function(t, e) {
                    this.world.step(t, e);
                },
                containsPoint: function(t, e, i) {
                    t = this.getMatterBodies(t);
                    var n = D.create(e, i);
                    return 0 < M.point(t, n).length;
                },
                intersectPoint: function(t, e, i) {
                    i = this.getMatterBodies(i);
                    var n = D.create(t, e), s = [];
                    return M.point(i, n).forEach(function(t) {
                        -1 === s.indexOf(t) && s.push(t);
                    }), s;
                },
                intersectRect: function(t, e, i, n, s, r) {
                    void 0 === s && (s = !1), r = this.getMatterBodies(r);
                    var o = {
                        min: {
                            x: t,
                            y: e
                        },
                        max: {
                            x: t + i,
                            y: e + n
                        }
                    }, a = [];
                    return M.region(r, o, s).forEach(function(t) {
                        -1 === a.indexOf(t) && a.push(t);
                    }), a;
                },
                intersectRay: function(t, e, i, n, s, r) {
                    void 0 === s && (s = 1), r = this.getMatterBodies(r);
                    for(var o = [], a = M.ray(r, D.create(t, e), D.create(i, n), s), h = 0; h < a.length; h++)o.push(a[h].body);
                    return o;
                },
                intersectBody: function(t, e) {
                    e = this.getMatterBodies(e);
                    for(var i = [], n = M.collides(t, e), s = 0; s < n.length; s++){
                        var r = n[s];
                        r.bodyA === t ? i.push(r.bodyB) : i.push(r.bodyA);
                    }
                    return i;
                },
                overlap: function(t, e, i, n, s) {
                    void 0 === i && (i = null), void 0 === n && (n = null), void 0 === s && (s = i), Array.isArray(t) || (t = [
                        t
                    ]), t = this.getMatterBodies(t), e = this.getMatterBodies(e);
                    for(var r = !1, o = 0; o < t.length; o++)for(var a = t[o], h = M.collides(a, e), l = 0; l < h.length; l++){
                        var u = h[l], c = u.bodyA.id === a.id ? u.bodyB : u.bodyA;
                        if (!n || n.call(s, a, c, u)) {
                            if (r = !0, i) i.call(s, a, c, u);
                            else if (!n) return !0;
                        }
                    }
                    return r;
                },
                setCollisionCategory: function(t, e) {
                    return (t = this.getMatterBodies(t)).forEach(function(t) {
                        t.collisionFilter.category = e;
                    }), this;
                },
                setCollisionGroup: function(t, e) {
                    return (t = this.getMatterBodies(t)).forEach(function(t) {
                        t.collisionFilter.group = e;
                    }), this;
                },
                setCollidesWith: function(t, e) {
                    t = this.getMatterBodies(t);
                    var i = 0;
                    if (Array.isArray(e)) for(var n = 0; n < e.length; n++)i |= e[n];
                    else i = e;
                    return t.forEach(function(t) {
                        t.collisionFilter.mask = i;
                    }), this;
                },
                getMatterBodies: function(t) {
                    if (!t) return this.world.getAllBodies();
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    for(var e = [], i = 0; i < t.length; i++){
                        var n = t[i].hasOwnProperty("body") ? t[i].body : t[i];
                        e.push(n);
                    }
                    return e;
                },
                setVelocity: function(t, e, i) {
                    t = this.getMatterBodies(t);
                    var n = this._tempVec2;
                    return n.x = e, n.y = i, t.forEach(function(t) {
                        o.setVelocity(t, n);
                    }), this;
                },
                setVelocityX: function(t, e) {
                    t = this.getMatterBodies(t);
                    var i = this._tempVec2;
                    return i.x = e, t.forEach(function(t) {
                        i.y = t.velocity.y, o.setVelocity(t, i);
                    }), this;
                },
                setVelocityY: function(t, e) {
                    t = this.getMatterBodies(t);
                    var i = this._tempVec2;
                    return i.y = e, t.forEach(function(t) {
                        i.x = t.velocity.x, o.setVelocity(t, i);
                    }), this;
                },
                setAngularVelocity: function(t, e) {
                    return (t = this.getMatterBodies(t)).forEach(function(t) {
                        o.setAngularVelocity(t, e);
                    }), this;
                },
                applyForce: function(t, e) {
                    t = this.getMatterBodies(t);
                    var i = this._tempVec2;
                    return t.forEach(function(t) {
                        i.x = t.position.x, i.y = t.position.y, o.applyForce(t, i, e);
                    }), this;
                },
                applyForceFromPosition: function(t, e, i, n) {
                    t = this.getMatterBodies(t);
                    var s = this._tempVec2;
                    return t.forEach(function(t) {
                        void 0 === n && (n = t.angle), s.x = i * Math.cos(n), s.y = i * Math.sin(n), o.applyForce(t, e, s);
                    }), this;
                },
                applyForceFromAngle: function(t, e, i) {
                    t = this.getMatterBodies(t);
                    var n = this._tempVec2;
                    return t.forEach(function(t) {
                        void 0 === i && (i = t.angle), n.x = e * Math.cos(i), n.y = e * Math.sin(i), o.applyForce(t, {
                            x: t.position.x,
                            y: t.position.y
                        }, n);
                    }), this;
                },
                getConstraintLength: function(t) {
                    var e = t.pointA.x, i = t.pointA.y, n = t.pointB.x, s = t.pointB.y;
                    return t.bodyA && (e += t.bodyA.position.x, i += t.bodyA.position.y), t.bodyB && (n += t.bodyB.position.x, s += t.bodyB.position.y), p(e, i, n, s);
                },
                alignBody: function(t, e, i, n) {
                    var s;
                    switch(t = t.hasOwnProperty("body") ? t.body : t, n){
                        case r.TOP_LEFT:
                        case r.LEFT_TOP:
                            s = this.bodyBounds.getTopLeft(t, e, i);
                            break;
                        case r.TOP_CENTER:
                            s = this.bodyBounds.getTopCenter(t, e, i);
                            break;
                        case r.TOP_RIGHT:
                        case r.RIGHT_TOP:
                            s = this.bodyBounds.getTopRight(t, e, i);
                            break;
                        case r.LEFT_CENTER:
                            s = this.bodyBounds.getLeftCenter(t, e, i);
                            break;
                        case r.CENTER:
                            s = this.bodyBounds.getCenter(t, e, i);
                            break;
                        case r.RIGHT_CENTER:
                            s = this.bodyBounds.getRightCenter(t, e, i);
                            break;
                        case r.LEFT_BOTTOM:
                        case r.BOTTOM_LEFT:
                            s = this.bodyBounds.getBottomLeft(t, e, i);
                            break;
                        case r.BOTTOM_CENTER:
                            s = this.bodyBounds.getBottomCenter(t, e, i);
                            break;
                        case r.BOTTOM_RIGHT:
                        case r.RIGHT_BOTTOM:
                            s = this.bodyBounds.getBottomRight(t, e, i);
                    }
                    return s && o.setPosition(t, s), this;
                },
                shutdown: function() {
                    var t = this.systems.events;
                    this.world && (t.off(O.UPDATE, this.world.update, this.world), t.off(O.POST_UPDATE, this.world.postUpdate, this.world)), t.off(O.SHUTDOWN, this.shutdown, this), this.add && this.add.destroy(), this.world && this.world.destroy(), this.add = null, this.world = null;
                },
                destroy: function() {
                    this.shutdown(), this.scene.sys.events.off(O.START, this.start, this), this.scene = null, this.systems = null;
                }
            });
            C.register("MatterPhysics", I, "matterPhysics"), t.exports = I;
        },
        function(t, e, i) {
            var u = i(1391), a = {
                name: "matter-attractors",
                version: "0.1.7",
                for: "matter-js@^0.14.2",
                silent: !0,
                install: function(t) {
                    t.after("Body.create", function() {
                        a.Body.init(this);
                    }), t.before("Engine.update", function(t) {
                        a.Engine.update(t);
                    });
                },
                Body: {
                    init: function(t) {
                        t.plugin.attractors = t.plugin.attractors || [];
                    }
                },
                Engine: {
                    update: function(t) {
                        for(var e = u.Composite.allBodies(t.world), i = 0; i < e.length; i++){
                            var n = e[i], s = n.plugin.attractors;
                            if (s && 0 < s.length) for(var r = 0; r < e.length; r++){
                                var o = e[r];
                                if (i !== r) for(var a = 0; a < s.length; a++){
                                    var h = s[a], l = h;
                                    u.Common.isFunction(h) && (l = h(n, o)), l && u.Body.applyForce(o, o.position, l);
                                }
                            }
                        }
                    }
                },
                Attractors: {
                    gravityConstant: .001,
                    gravity: function(t, e) {
                        var i = u.Vector.sub(e.position, t.position), n = u.Vector.magnitudeSquared(i) || 1e-4, s = u.Vector.normalise(i), r = -a.Attractors.gravityConstant * (t.mass * e.mass / n), o = u.Vector.mult(s, r);
                        u.Body.applyForce(t, t.position, u.Vector.neg(o)), u.Body.applyForce(e, e.position, o);
                    }
                }
            };
            t.exports = a;
        },
        function(t, e) {
            t.exports = {
                name: "matter-collision-events",
                version: "0.1.6",
                for: "matter-js@^0.14.2",
                silent: !0,
                install: function(n) {
                    n.after("Engine.create", function() {
                        n.Events.on(this, "collisionStart", function(t) {
                            t.pairs.map(function(t) {
                                var e = t.bodyA, i = t.bodyB;
                                e.gameObject && e.gameObject.emit("collide", e, i, t), i.gameObject && i.gameObject.emit("collide", i, e, t), n.Events.trigger(e, "onCollide", {
                                    pair: t
                                }), n.Events.trigger(i, "onCollide", {
                                    pair: t
                                }), e.onCollideCallback && e.onCollideCallback(t), i.onCollideCallback && i.onCollideCallback(t), e.onCollideWith[i.id] && e.onCollideWith[i.id](i, t), i.onCollideWith[e.id] && i.onCollideWith[e.id](e, t);
                            });
                        }), n.Events.on(this, "collisionActive", function(t) {
                            t.pairs.map(function(t) {
                                var e = t.bodyA, i = t.bodyB;
                                e.gameObject && e.gameObject.emit("collideActive", e, i, t), i.gameObject && i.gameObject.emit("collideActive", i, e, t), n.Events.trigger(e, "onCollideActive", {
                                    pair: t
                                }), n.Events.trigger(i, "onCollideActive", {
                                    pair: t
                                }), e.onCollideActiveCallback && e.onCollideActiveCallback(t), i.onCollideActiveCallback && i.onCollideActiveCallback(t);
                            });
                        }), n.Events.on(this, "collisionEnd", function(t) {
                            t.pairs.map(function(t) {
                                var e = t.bodyA, i = t.bodyB;
                                e.gameObject && e.gameObject.emit("collideEnd", e, i, t), i.gameObject && i.gameObject.emit("collideEnd", i, e, t), n.Events.trigger(e, "onCollideEnd", {
                                    pair: t
                                }), n.Events.trigger(i, "onCollideEnd", {
                                    pair: t
                                }), e.onCollideEndCallback && e.onCollideEndCallback(t), i.onCollideEndCallback && i.onCollideEndCallback(t);
                            });
                        });
                    });
                }
            };
        },
        function(t, e, i) {
            var a = i(1391), h = {
                name: "matter-wrap",
                version: "0.1.4",
                for: "matter-js@^0.14.2",
                silent: !0,
                install: function(t) {
                    t.after("Engine.update", function() {
                        h.Engine.update(this);
                    });
                },
                Engine: {
                    update: function(t) {
                        for(var e = t.world, i = a.Composite.allBodies(e), n = a.Composite.allComposites(e), s = 0; s < i.length; s += 1){
                            var r = i[s];
                            r.plugin.wrap && h.Body.wrap(r, r.plugin.wrap);
                        }
                        for(s = 0; s < n.length; s += 1){
                            var o = n[s];
                            o.plugin.wrap && h.Composite.wrap(o, o.plugin.wrap);
                        }
                    }
                },
                Bounds: {
                    wrap: function(t, e) {
                        var i = null, n = null;
                        if (void 0 !== e.min.x && void 0 !== e.max.x && (t.min.x > e.max.x ? i = e.min.x - t.max.x : t.max.x < e.min.x && (i = e.max.x - t.min.x)), void 0 !== e.min.y && void 0 !== e.max.y && (t.min.y > e.max.y ? n = e.min.y - t.max.y : t.max.y < e.min.y && (n = e.max.y - t.min.y)), null !== i || null !== n) return {
                            x: i || 0,
                            y: n || 0
                        };
                    }
                },
                Body: {
                    wrap: function(t, e) {
                        var i = h.Bounds.wrap(t.bounds, e);
                        return i && a.Body.translate(t, i), i;
                    }
                },
                Composite: {
                    bounds: function(t) {
                        for(var e = a.Composite.allBodies(t), i = [], n = 0; n < e.length; n += 1){
                            var s = e[n];
                            i.push(s.bounds.min, s.bounds.max);
                        }
                        return a.Bounds.create(i);
                    },
                    wrap: function(t, e) {
                        var i = h.Bounds.wrap(h.Composite.bounds(t), e);
                        return i && a.Composite.translate(t, i), i;
                    }
                }
            };
            t.exports = h;
        }
    ], s.c = n, s.d = function(t, e, i) {
        s.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: i
        });
    }, s.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, s.t = function(e, t) {
        if (1 & t && (e = s(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (s.r(i), Object.defineProperty(i, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var n in e)s.d(i, n, (function(t) {
            return e[t];
        }).bind(null, n));
        return i;
    }, s.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return s.d(e, "a", e), e;
    }, s.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, s.p = "", s(s.s = 1497);
    function s(t) {
        if (n[t]) return n[t].exports;
        var e = n[t] = {
            i: t,
            l: !1,
            exports: {}
        };
        return i[t].call(e.exports, e, e.exports, s), e.l = !0, e.exports;
    }
});

//# sourceMappingURL=index.e7774ec5.js.map
